
        import * as monaco from "monaco-editor";

        monaco.languages.typescript.javascriptDefaults.addExtraLib(`declare type Maybe<T> = T;
declare type InputMaybe<T> = T;
declare type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
declare type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
declare type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
declare interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Any: any;
  /** The 'Byte' scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: any;
  /** The 'DateTime' scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** The built-in 'Decimal' scalar type. */
  Decimal: any;
  /**
   * The 'Long' scalar type represents non-fractional signed whole 64-bit numeric
   * values. Long can represent values between -(2^63) and 2^63 - 1.
   */
  Long: any;
  /** The 'TimeSpan' scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: any;
  UUID: any;
}

declare interface Account {
  code?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  type: AccountType;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
}

declare interface AccountDtoInput {
  code: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type: AccountType;
  userId?: InputMaybe<Scalars['String']>;
}

declare interface AccountFilterInput {
  and?: InputMaybe<Array<AccountFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AccountFilterInput>>;
  type?: InputMaybe<AccountTypeOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
}

declare interface AccountSortInput {
  code?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
}

declare type AccountType =
  | 'CUSTOMER'
  | 'MONEY'
  | 'SUPPLIER';

declare interface AccountTypeOperationFilterInput {
  eq?: InputMaybe<AccountType>;
  in?: InputMaybe<Array<AccountType>>;
  neq?: InputMaybe<AccountType>;
  nin?: InputMaybe<Array<AccountType>>;
}

/** A connection to a list of items. */
declare interface AccountsConnection {
  /** A list of edges. */
  edges?: Maybe<Array<AccountsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Account>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface AccountsEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Account>;
}

declare interface AddSubjectDtoInput {
  acAddress?: InputMaybe<Scalars['String']>;
  acBuyer?: InputMaybe<Scalars['String']>;
  acName2?: InputMaybe<Scalars['String']>;
  acPayMethod?: InputMaybe<Scalars['String']>;
  acPin?: InputMaybe<Scalars['String']>;
  acPost?: InputMaybe<Scalars['String']>;
  acSkis?: InputMaybe<Scalars['String']>;
  acSubject: Scalars['String'];
  acSupplier?: InputMaybe<Scalars['String']>;
  acWayOfSale?: InputMaybe<Scalars['String']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  docId?: InputMaybe<Scalars['Int']>;
}

declare interface AddTHeSetSubjContactAddressDtoInput {
  acNote?: InputMaybe<Scalars['String']>;
  acPhone?: InputMaybe<Scalars['String']>;
  acSubject?: InputMaybe<Scalars['String']>;
  acType?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
}

declare interface AddTHeSetSubjContactDtoInput {
  acActive?: InputMaybe<Scalars['String']>;
  acFunction?: InputMaybe<Scalars['String']>;
  acName?: InputMaybe<Scalars['String']>;
  acSubject?: InputMaybe<Scalars['String']>;
  acSurname?: InputMaybe<Scalars['String']>;
}

declare interface AddTMnDocumentDtoInput {
  acStatus?: InputMaybe<Scalars['String']>;
  anClassifIcationQid?: InputMaybe<Scalars['Int']>;
  anMailBoxQid?: InputMaybe<Scalars['Int']>;
  anStorageQid?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>;
  note?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
}

declare interface AddTMnFileDtoInput {
  fileContent?: InputMaybe<Array<Scalars['Byte']>>;
  fileName?: InputMaybe<Scalars['String']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  tMnDocumentId: Scalars['Int'];
}

declare type AiSupportRunBudgetMode =
  | 'BOUNDED'
  | 'RUN_UNTIL_TERMINAL';

declare interface AiSupportRunBudgetModeOperationFilterInput {
  eq?: InputMaybe<AiSupportRunBudgetMode>;
  in?: InputMaybe<Array<AiSupportRunBudgetMode>>;
  neq?: InputMaybe<AiSupportRunBudgetMode>;
  nin?: InputMaybe<Array<AiSupportRunBudgetMode>>;
}

declare interface AllActiveAccountsDto {
  customer?: Maybe<Array<Maybe<AllActiveAccountsDtoAccountDto>>>;
  money?: Maybe<Array<Maybe<AllActiveAccountsDtoAccountDto>>>;
  supplier?: Maybe<Array<Maybe<AllActiveAccountsDtoAccountDto>>>;
}

declare interface AllActiveAccountsDtoAccountDto {
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  type: AccountType;
}

declare interface AnalysisBalanceForCustomerDto {
  due: Scalars['Decimal'];
  period: Scalars['Decimal'];
}

declare interface AnalysisCurrencyTotal {
  credit: Scalars['Decimal'];
  creditInCurrency: Scalars['Decimal'];
  currency?: Maybe<Scalars['String']>;
  debit: Scalars['Decimal'];
  debitInCurrency: Scalars['Decimal'];
  totalCredit: Scalars['Decimal'];
  totalCreditInCurrency: Scalars['Decimal'];
  totalDebit: Scalars['Decimal'];
  totalDebitInCurrency: Scalars['Decimal'];
  value: Scalars['Decimal'];
  valueInCurrency: Scalars['Decimal'];
}

declare interface AnalysisDocumentPerCustomerDto {
  date: Scalars['DateTime'];
  document?: Maybe<Scalars['String']>;
  value: Scalars['Decimal'];
}

declare interface AnalysisTotalsDto {
  customer?: Maybe<Array<Maybe<AnalysisCurrencyTotal>>>;
  money?: Maybe<Array<Maybe<AnalysisCurrencyTotal>>>;
  supplier?: Maybe<Array<Maybe<AnalysisCurrencyTotal>>>;
}

declare interface AnalysisTotalsPerAccountDto {
  account?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Array<Maybe<AnalysisCurrencyTotal>>>;
}

declare interface AnalysisTotalsPerCustomerDto {
  customer?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  value?: Maybe<Array<Maybe<AnalysisCurrencyTotal>>>;
}

declare interface ApplicationPacket {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  from: Scalars['DateTime'];
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  packet: ApplicationPacketEnum;
  to: Scalars['DateTime'];
}

declare type ApplicationPacketEnum =
  | 'ACTIVITY_REPORTS'
  | 'BUSINESS_ANALYTICS'
  | 'DECLARATIONS'
  | 'DMS_NOTIFICATIONS'
  | 'DOCUMENTS'
  | 'DYN_DNS_HEALTHCHECK'
  | 'MARSERVIS_WORK_ORDERS'
  | 'ONIX_PHONE_DOCUMENTS_OVERVIEW'
  | 'PANTHEON_SUBJECTS_SYNC'
  | 'SETTINGS_SYNCHRONIZATION'
  | 'SUPPORT'
  | 'TRAVEL_WARRANTS'
  | 'TRAVEL_WARRANTS2'
  | 'USER_SYNCHRONIZATION'
  | 'WEB_DOCUMENTS'
  | 'WOO_COMMERCE'
  | 'WORK_RECORDS'
  | 'WORK_RECORDS2';

declare interface ApplicationPacketEnumOperationFilterInput {
  eq?: InputMaybe<ApplicationPacketEnum>;
  in?: InputMaybe<Array<ApplicationPacketEnum>>;
  neq?: InputMaybe<ApplicationPacketEnum>;
  nin?: InputMaybe<Array<ApplicationPacketEnum>>;
}

declare interface ApplicationPacketFilterInput {
  and?: InputMaybe<Array<ApplicationPacketFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  from?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationPacketFilterInput>>;
  packet?: InputMaybe<ApplicationPacketEnumOperationFilterInput>;
  to?: InputMaybe<ComparableDateTimeOperationFilterInput>;
}

declare interface ApplicationRole {
  concurrencyStamp?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['String']>;
  userRoles?: Maybe<Array<Maybe<ApplicationUserRole>>>;
}

declare interface ApplicationRoleFilterInput {
  and?: InputMaybe<Array<ApplicationRoleFilterInput>>;
  concurrencyStamp?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationRoleFilterInput>>;
  userRoles?: InputMaybe<ListFilterInputTypeOfApplicationUserRoleFilterInput>;
}

declare interface ApplicationRoleSortInput {
  concurrencyStamp?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
}

declare interface ApplicationUser {
  accessFailedCount: Scalars['Int'];
  accountingForUsers?: Maybe<Array<Maybe<ApplicationUser>>>;
  accountingUser?: Maybe<ApplicationUser>;
  accountingUserId?: Maybe<Scalars['String']>;
  alternativeUser?: Maybe<ApplicationUser>;
  alternativeUserId?: Maybe<Scalars['String']>;
  alternativeUsers?: Maybe<Array<Maybe<ApplicationUser>>>;
  assignedFiles?: Maybe<Array<Maybe<SavedFile>>>;
  automaticLogout: Scalars['TimeSpan'];
  bookStackTokenId?: Maybe<Scalars['String']>;
  bookStackTokenSecret?: Maybe<Scalars['String']>;
  ciscoPhoneAdminPath?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  concurrencyStamp?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  culture?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<Scalars['String']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  documentTypeLinks?: Maybe<Array<Maybe<DocumentTypeLink>>>;
  documentTypePairs?: Maybe<Array<Maybe<DocumentTypePair>>>;
  documentTypes?: Maybe<Array<Maybe<DocumentType>>>;
  email?: Maybe<Scalars['String']>;
  emailConfirmed: Scalars['Boolean'];
  externalAuthRequestStates?: Maybe<Array<Maybe<ExternalAuthRequestState>>>;
  externalIdentities?: Maybe<Array<Maybe<ApplicationUserExternalIdentity>>>;
  fCMTokens?: Maybe<Array<Maybe<FcmToken>>>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDMSReferenceUser: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  lastDevice?: Maybe<Scalars['String']>;
  lastLicenseTakeover: Scalars['DateTime'];
  lastLogin: Scalars['DateTime'];
  lastName?: Maybe<Scalars['String']>;
  lastPlatform?: Maybe<Scalars['String']>;
  lastRequestSource?: Maybe<Scalars['String']>;
  lastTokenRefresh: Scalars['DateTime'];
  lastVersion?: Maybe<Scalars['String']>;
  licenseTakeoverCount: Scalars['Int'];
  lockoutEnabled: Scalars['Boolean'];
  lockoutEnd?: Maybe<Scalars['DateTime']>;
  migratedToNewServer?: Maybe<Scalars['Boolean']>;
  mobileSettings?: Maybe<MobileSettings>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  normalizedEmail?: Maybe<Scalars['String']>;
  normalizedUserName?: Maybe<Scalars['String']>;
  notificationDeliveryReport?: Maybe<Array<Maybe<NotificationDeliveryReport>>>;
  notifiedSupportTicketMessages?: Maybe<Array<Maybe<SupportTicketMessage>>>;
  onixDesktopPantheonExePath?: Maybe<Scalars['String']>;
  onixDesktopPantheonExePathMac?: Maybe<Scalars['String']>;
  onixDesktopPantheonIniPath?: Maybe<Scalars['String']>;
  onixDesktopPantheonIniPathMac?: Maybe<Scalars['String']>;
  onixPhoneUserTasks?: Maybe<Array<Maybe<OnixPhoneUserTaskQueue>>>;
  pantheonUser?: Maybe<PantheonUser>;
  passwordHash?: Maybe<Scalars['String']>;
  permanentLoginToken?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberConfirmed: Scalars['Boolean'];
  pushedAppKey?: Maybe<Scalars['String']>;
  pushedAppSecret?: Maybe<Scalars['String']>;
  pushedTargetType?: Maybe<Scalars['String']>;
  responsibleAgentTicketMessages?: Maybe<Array<Maybe<SupportTicketMessage>>>;
  responsibleForUsers?: Maybe<Array<Maybe<ApplicationUser>>>;
  responsibleUser?: Maybe<ApplicationUser>;
  responsibleUserId?: Maybe<Scalars['String']>;
  restoredBy?: Maybe<Scalars['String']>;
  restoredById?: Maybe<Scalars['String']>;
  restoredOn?: Maybe<Scalars['DateTime']>;
  securityStamp?: Maybe<Scalars['String']>;
  sentAsSupportTicketMessages?: Maybe<Array<Maybe<SupportTicketMessage>>>;
  sentSupportTicketMessages?: Maybe<Array<Maybe<SupportTicketMessage>>>;
  settingsMigratedToMultiSettings: Scalars['Boolean'];
  supportEmailAddress?: Maybe<Scalars['String']>;
  supportEmailPassword?: Maybe<Scalars['String']>;
  supportGroupMembers?: Maybe<Array<Maybe<SupportGroupMember>>>;
  supportNotifyOfNewMessages: Scalars['Boolean'];
  supportOpenAIExecutions?: Maybe<Array<Maybe<SupportOpenAiExecution>>>;
  supportSignature?: Maybe<Scalars['String']>;
  supportTimeLogRoundingMinutes?: Maybe<Scalars['Int']>;
  supportTimeLogsAlwaysNonBillable: Scalars['Boolean'];
  supportTopBarCountersOpenTicketList?: Maybe<Scalars['Boolean']>;
  teamViewerID?: Maybe<Scalars['String']>;
  teamViewerSyncEnabled: Scalars['Boolean'];
  teamViewerToken?: Maybe<Scalars['String']>;
  temporaryOwnerSupportTickets?: Maybe<Array<Maybe<SupportTicket>>>;
  timeZone?: Maybe<Scalars['String']>;
  twoFactorEnabled: Scalars['Boolean'];
  unreadUserSupportTicketMessages?: Maybe<Array<Maybe<UnreadUserSupportTicketMessage>>>;
  useNewDocumentFlow: Scalars['Boolean'];
  userAccessHash?: Maybe<Scalars['String']>;
  userArbitrarySettings?: Maybe<Array<Maybe<UserArbitrarySetting>>>;
  userName?: Maybe<Scalars['String']>;
  userRoles?: Maybe<Array<Maybe<ApplicationUserRole>>>;
  userSupportTickets?: Maybe<Array<Maybe<SupportTicket>>>;
  visualAttributesOverview?: Maybe<Scalars['String']>;
  wakaApiBaseUrl?: Maybe<Scalars['String']>;
  wakaApiKey?: Maybe<Scalars['String']>;
  wakaAuthors?: Maybe<Array<Maybe<ApplicationUserWakaAuthor>>>;
  wakaLastSyncAt?: Maybe<Scalars['DateTime']>;
  wakaLastSyncError?: Maybe<Scalars['String']>;
  wakaMachines?: Maybe<Array<Maybe<ApplicationUserWakaMachine>>>;
  wakaProjectMaps?: Maybe<Array<Maybe<ApplicationUserWakaProjectMap>>>;
  wakaSyncEnabled: Scalars['Boolean'];
  wakaTimeCommits?: Maybe<Array<Maybe<WakaTimeCommit>>>;
  wakaTimeWorklogs?: Maybe<Array<Maybe<WakaTimeWorklog>>>;
  webAppRouting?: Maybe<WebAppRoutingDto>;
  workRecordPeriods?: Maybe<Array<Maybe<WorkRecordPeriod>>>;
}


declare interface ApplicationUserAccountingForUsersArgs {
  order?: InputMaybe<Array<ApplicationUserSortInput>>;
}


declare interface ApplicationUserAlternativeUsersArgs {
  order?: InputMaybe<Array<ApplicationUserSortInput>>;
}


declare interface ApplicationUserDocumentTypeLinksArgs {
  order?: InputMaybe<Array<DocumentTypeLinkSortInput>>;
  where?: InputMaybe<DocumentTypeLinkFilterInput>;
}


declare interface ApplicationUserDocumentTypePairsArgs {
  order?: InputMaybe<Array<DocumentTypePairSortInput>>;
  where?: InputMaybe<DocumentTypePairFilterInput>;
}


declare interface ApplicationUserDocumentTypesArgs {
  order?: InputMaybe<Array<DocumentTypeSortInput>>;
  where?: InputMaybe<DocumentTypeFilterInput>;
}


declare interface ApplicationUserOnixPhoneUserTasksArgs {
  order?: InputMaybe<Array<OnixPhoneUserTaskQueueSortInput>>;
  where?: InputMaybe<OnixPhoneUserTaskQueueFilterInput>;
}


declare interface ApplicationUserResponsibleAgentTicketMessagesArgs {
  order?: InputMaybe<Array<SupportTicketMessageSortInput>>;
}


declare interface ApplicationUserResponsibleForUsersArgs {
  order?: InputMaybe<Array<ApplicationUserSortInput>>;
}


declare interface ApplicationUserTemporaryOwnerSupportTicketsArgs {
  order?: InputMaybe<Array<SupportTicketSortInput>>;
}


declare interface ApplicationUserUserArbitrarySettingsArgs {
  order?: InputMaybe<Array<UserArbitrarySettingSortInput>>;
  where?: InputMaybe<UserArbitrarySettingFilterInput>;
}


declare interface ApplicationUserUserRolesArgs {
  order?: InputMaybe<Array<ApplicationUserRoleSortInput>>;
}


declare interface ApplicationUserUserSupportTicketsArgs {
  order?: InputMaybe<Array<SupportTicketSortInput>>;
}


declare interface ApplicationUserWorkRecordPeriodsArgs {
  order?: InputMaybe<Array<WorkRecordPeriodSortInput>>;
}

declare interface ApplicationUserExternalIdentity {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdByUser?: Maybe<ApplicationUser>;
  createdByUserId?: Maybe<Scalars['String']>;
  externalIdentity?: Maybe<ExternalIdentity>;
  externalIdentityId: Scalars['Int'];
  id: Scalars['Int'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
}

declare interface ApplicationUserExternalIdentityFilterInput {
  and?: InputMaybe<Array<ApplicationUserExternalIdentityFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  createdByUser?: InputMaybe<ApplicationUserFilterInput>;
  createdByUserId?: InputMaybe<StringOperationFilterInput>;
  externalIdentity?: InputMaybe<ExternalIdentityFilterInput>;
  externalIdentityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lastUsedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationUserExternalIdentityFilterInput>>;
}

declare interface ApplicationUserFilterInput {
  accessFailedCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  accountingForUsers?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  accountingUser?: InputMaybe<ApplicationUserFilterInput>;
  accountingUserId?: InputMaybe<StringOperationFilterInput>;
  alternativeUser?: InputMaybe<ApplicationUserFilterInput>;
  alternativeUserId?: InputMaybe<StringOperationFilterInput>;
  alternativeUsers?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  and?: InputMaybe<Array<ApplicationUserFilterInput>>;
  assignedFiles?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  automaticLogout?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  bookStackTokenId?: InputMaybe<StringOperationFilterInput>;
  bookStackTokenSecret?: InputMaybe<StringOperationFilterInput>;
  ciscoPhoneAdminPath?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  concurrencyStamp?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  culture?: InputMaybe<StringOperationFilterInput>;
  deletedBy?: InputMaybe<StringOperationFilterInput>;
  deletedById?: InputMaybe<StringOperationFilterInput>;
  deletedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  documentTypeLinks?: InputMaybe<ListFilterInputTypeOfDocumentTypeLinkFilterInput>;
  documentTypePairs?: InputMaybe<ListFilterInputTypeOfDocumentTypePairFilterInput>;
  documentTypes?: InputMaybe<ListFilterInputTypeOfDocumentTypeFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  emailConfirmed?: InputMaybe<BooleanOperationFilterInput>;
  externalAuthRequestStates?: InputMaybe<ListFilterInputTypeOfExternalAuthRequestStateFilterInput>;
  externalIdentities?: InputMaybe<ListFilterInputTypeOfApplicationUserExternalIdentityFilterInput>;
  fCMTokens?: InputMaybe<ListFilterInputTypeOfFcmTokenFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDMSReferenceUser?: InputMaybe<BooleanOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  language?: InputMaybe<StringOperationFilterInput>;
  lastDevice?: InputMaybe<StringOperationFilterInput>;
  lastLicenseTakeover?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  lastLogin?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  lastPlatform?: InputMaybe<StringOperationFilterInput>;
  lastRequestSource?: InputMaybe<StringOperationFilterInput>;
  lastTokenRefresh?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  lastVersion?: InputMaybe<StringOperationFilterInput>;
  licenseTakeoverCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  lockoutEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lockoutEnd?: InputMaybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  migratedToNewServer?: InputMaybe<BooleanOperationFilterInput>;
  mobileSettings?: InputMaybe<MobileSettingsFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  normalizedEmail?: InputMaybe<StringOperationFilterInput>;
  normalizedUserName?: InputMaybe<StringOperationFilterInput>;
  notificationDeliveryReport?: InputMaybe<ListFilterInputTypeOfNotificationDeliveryReportFilterInput>;
  notifiedSupportTicketMessages?: InputMaybe<ListFilterInputTypeOfSupportTicketMessageFilterInput>;
  onixDesktopPantheonExePath?: InputMaybe<StringOperationFilterInput>;
  onixDesktopPantheonExePathMac?: InputMaybe<StringOperationFilterInput>;
  onixDesktopPantheonIniPath?: InputMaybe<StringOperationFilterInput>;
  onixDesktopPantheonIniPathMac?: InputMaybe<StringOperationFilterInput>;
  onixPhoneUserTasks?: InputMaybe<ListFilterInputTypeOfOnixPhoneUserTaskQueueFilterInput>;
  or?: InputMaybe<Array<ApplicationUserFilterInput>>;
  pantheonUser?: InputMaybe<PantheonUserFilterInput>;
  passwordHash?: InputMaybe<StringOperationFilterInput>;
  permanentLoginToken?: InputMaybe<StringOperationFilterInput>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  phoneNumberConfirmed?: InputMaybe<BooleanOperationFilterInput>;
  pushedAppKey?: InputMaybe<StringOperationFilterInput>;
  pushedAppSecret?: InputMaybe<StringOperationFilterInput>;
  pushedTargetType?: InputMaybe<StringOperationFilterInput>;
  responsibleAgentTicketMessages?: InputMaybe<ListFilterInputTypeOfSupportTicketMessageFilterInput>;
  responsibleForUsers?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  responsibleUser?: InputMaybe<ApplicationUserFilterInput>;
  responsibleUserId?: InputMaybe<StringOperationFilterInput>;
  restoredBy?: InputMaybe<StringOperationFilterInput>;
  restoredById?: InputMaybe<StringOperationFilterInput>;
  restoredOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  securityStamp?: InputMaybe<StringOperationFilterInput>;
  sentAsSupportTicketMessages?: InputMaybe<ListFilterInputTypeOfSupportTicketMessageFilterInput>;
  sentSupportTicketMessages?: InputMaybe<ListFilterInputTypeOfSupportTicketMessageFilterInput>;
  settingsMigratedToMultiSettings?: InputMaybe<BooleanOperationFilterInput>;
  supportEmailAddress?: InputMaybe<StringOperationFilterInput>;
  supportEmailPassword?: InputMaybe<StringOperationFilterInput>;
  supportGroupMembers?: InputMaybe<ListFilterInputTypeOfSupportGroupMemberFilterInput>;
  supportNotifyOfNewMessages?: InputMaybe<BooleanOperationFilterInput>;
  supportOpenAIExecutions?: InputMaybe<ListFilterInputTypeOfSupportOpenAiExecutionFilterInput>;
  supportSignature?: InputMaybe<StringOperationFilterInput>;
  supportTimeLogRoundingMinutes?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportTimeLogsAlwaysNonBillable?: InputMaybe<BooleanOperationFilterInput>;
  supportTopBarCountersOpenTicketList?: InputMaybe<BooleanOperationFilterInput>;
  teamViewerID?: InputMaybe<StringOperationFilterInput>;
  teamViewerSyncEnabled?: InputMaybe<BooleanOperationFilterInput>;
  teamViewerToken?: InputMaybe<StringOperationFilterInput>;
  temporaryOwnerSupportTickets?: InputMaybe<ListFilterInputTypeOfSupportTicketFilterInput>;
  timeZone?: InputMaybe<StringOperationFilterInput>;
  twoFactorEnabled?: InputMaybe<BooleanOperationFilterInput>;
  unreadUserSupportTicketMessages?: InputMaybe<ListFilterInputTypeOfUnreadUserSupportTicketMessageFilterInput>;
  useNewDocumentFlow?: InputMaybe<BooleanOperationFilterInput>;
  userAccessHash?: InputMaybe<StringOperationFilterInput>;
  userArbitrarySettings?: InputMaybe<ListFilterInputTypeOfUserArbitrarySettingFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
  userRoles?: InputMaybe<ListFilterInputTypeOfApplicationUserRoleFilterInput>;
  userSupportTickets?: InputMaybe<ListFilterInputTypeOfSupportTicketFilterInput>;
  visualAttributesOverview?: InputMaybe<StringOperationFilterInput>;
  wakaApiBaseUrl?: InputMaybe<StringOperationFilterInput>;
  wakaApiKey?: InputMaybe<StringOperationFilterInput>;
  wakaAuthors?: InputMaybe<ListFilterInputTypeOfApplicationUserWakaAuthorFilterInput>;
  wakaLastSyncAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  wakaLastSyncError?: InputMaybe<StringOperationFilterInput>;
  wakaMachines?: InputMaybe<ListFilterInputTypeOfApplicationUserWakaMachineFilterInput>;
  wakaProjectMaps?: InputMaybe<ListFilterInputTypeOfApplicationUserWakaProjectMapFilterInput>;
  wakaSyncEnabled?: InputMaybe<BooleanOperationFilterInput>;
  wakaTimeCommits?: InputMaybe<ListFilterInputTypeOfWakaTimeCommitFilterInput>;
  wakaTimeWorklogs?: InputMaybe<ListFilterInputTypeOfWakaTimeWorklogFilterInput>;
  workRecordPeriods?: InputMaybe<ListFilterInputTypeOfWorkRecordPeriodFilterInput>;
}

declare interface ApplicationUserRole {
  role?: Maybe<ApplicationRole>;
  roleId: Scalars['String'];
  user?: Maybe<ApplicationUser>;
  userId: Scalars['String'];
}

declare interface ApplicationUserRoleFilterInput {
  and?: InputMaybe<Array<ApplicationUserRoleFilterInput>>;
  or?: InputMaybe<Array<ApplicationUserRoleFilterInput>>;
  role?: InputMaybe<ApplicationRoleFilterInput>;
  roleId?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
}

declare interface ApplicationUserRoleSortInput {
  role?: InputMaybe<ApplicationRoleSortInput>;
  roleId?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
}

declare interface ApplicationUserSortInput {
  accessFailedCount?: InputMaybe<SortEnumType>;
  accountingUser?: InputMaybe<ApplicationUserSortInput>;
  accountingUserId?: InputMaybe<SortEnumType>;
  alternativeUser?: InputMaybe<ApplicationUserSortInput>;
  alternativeUserId?: InputMaybe<SortEnumType>;
  automaticLogout?: InputMaybe<SortEnumType>;
  bookStackTokenId?: InputMaybe<SortEnumType>;
  bookStackTokenSecret?: InputMaybe<SortEnumType>;
  ciscoPhoneAdminPath?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  concurrencyStamp?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  culture?: InputMaybe<SortEnumType>;
  deletedBy?: InputMaybe<SortEnumType>;
  deletedById?: InputMaybe<SortEnumType>;
  deletedOn?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  emailConfirmed?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDMSReferenceUser?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  language?: InputMaybe<SortEnumType>;
  lastDevice?: InputMaybe<SortEnumType>;
  lastLicenseTakeover?: InputMaybe<SortEnumType>;
  lastLogin?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  lastPlatform?: InputMaybe<SortEnumType>;
  lastRequestSource?: InputMaybe<SortEnumType>;
  lastTokenRefresh?: InputMaybe<SortEnumType>;
  lastVersion?: InputMaybe<SortEnumType>;
  licenseTakeoverCount?: InputMaybe<SortEnumType>;
  lockoutEnabled?: InputMaybe<SortEnumType>;
  lockoutEnd?: InputMaybe<SortEnumType>;
  migratedToNewServer?: InputMaybe<SortEnumType>;
  mobileSettings?: InputMaybe<MobileSettingsSortInput>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  normalizedEmail?: InputMaybe<SortEnumType>;
  normalizedUserName?: InputMaybe<SortEnumType>;
  onixDesktopPantheonExePath?: InputMaybe<SortEnumType>;
  onixDesktopPantheonExePathMac?: InputMaybe<SortEnumType>;
  onixDesktopPantheonIniPath?: InputMaybe<SortEnumType>;
  onixDesktopPantheonIniPathMac?: InputMaybe<SortEnumType>;
  pantheonUser?: InputMaybe<PantheonUserSortInput>;
  passwordHash?: InputMaybe<SortEnumType>;
  permanentLoginToken?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  phoneNumberConfirmed?: InputMaybe<SortEnumType>;
  pushedAppKey?: InputMaybe<SortEnumType>;
  pushedAppSecret?: InputMaybe<SortEnumType>;
  pushedTargetType?: InputMaybe<SortEnumType>;
  responsibleUser?: InputMaybe<ApplicationUserSortInput>;
  responsibleUserId?: InputMaybe<SortEnumType>;
  restoredBy?: InputMaybe<SortEnumType>;
  restoredById?: InputMaybe<SortEnumType>;
  restoredOn?: InputMaybe<SortEnumType>;
  securityStamp?: InputMaybe<SortEnumType>;
  settingsMigratedToMultiSettings?: InputMaybe<SortEnumType>;
  supportEmailAddress?: InputMaybe<SortEnumType>;
  supportEmailPassword?: InputMaybe<SortEnumType>;
  supportNotifyOfNewMessages?: InputMaybe<SortEnumType>;
  supportSignature?: InputMaybe<SortEnumType>;
  supportTimeLogRoundingMinutes?: InputMaybe<SortEnumType>;
  supportTimeLogsAlwaysNonBillable?: InputMaybe<SortEnumType>;
  supportTopBarCountersOpenTicketList?: InputMaybe<SortEnumType>;
  teamViewerID?: InputMaybe<SortEnumType>;
  teamViewerSyncEnabled?: InputMaybe<SortEnumType>;
  teamViewerToken?: InputMaybe<SortEnumType>;
  timeZone?: InputMaybe<SortEnumType>;
  twoFactorEnabled?: InputMaybe<SortEnumType>;
  useNewDocumentFlow?: InputMaybe<SortEnumType>;
  userAccessHash?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
  visualAttributesOverview?: InputMaybe<SortEnumType>;
  wakaApiBaseUrl?: InputMaybe<SortEnumType>;
  wakaApiKey?: InputMaybe<SortEnumType>;
  wakaLastSyncAt?: InputMaybe<SortEnumType>;
  wakaLastSyncError?: InputMaybe<SortEnumType>;
  wakaSyncEnabled?: InputMaybe<SortEnumType>;
}

declare interface ApplicationUserWakaAuthor {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  kind: WakaTimeAuthorKind;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
}

declare interface ApplicationUserWakaAuthorFilterInput {
  and?: InputMaybe<Array<ApplicationUserWakaAuthorFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  kind?: InputMaybe<WakaTimeAuthorKindOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationUserWakaAuthorFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
}

declare interface ApplicationUserWakaMachine {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  hostName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  machineId?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
}

declare interface ApplicationUserWakaMachineFilterInput {
  and?: InputMaybe<Array<ApplicationUserWakaMachineFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  hostName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  machineId?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationUserWakaMachineFilterInput>>;
}

declare interface ApplicationUserWakaProjectMap {
  active: Scalars['Boolean'];
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  externalProjectName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  internalProject?: Maybe<Project>;
  internalProjectId?: Maybe<Scalars['Int']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
}

declare interface ApplicationUserWakaProjectMapFilterInput {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ApplicationUserWakaProjectMapFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  externalProjectName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  internalProject?: InputMaybe<ProjectFilterInput>;
  internalProjectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationUserWakaProjectMapFilterInput>>;
}

declare type ApplyPolicy =
  | 'AFTER_RESOLVER'
  | 'BEFORE_RESOLVER';

declare type ArbitraryFieldEntryType =
  | 'FT_BOOLEAN'
  | 'FT_CURRENCY'
  | 'FT_DATE'
  | 'FT_INTEGER'
  | 'FT_STRING';

declare type ArbitraryFieldLocationEnum =
  | 'ADDITIONAL_DOCUMENT_ENTRY_FIELD'
  | 'ADDITIONAL_PDF_HEADER_FIELD'
  | 'AFTER_HEADER_CUSTOMER_ANALYSIS'
  | 'AFTER_HEADER_DOCUMENT_ANALYSIS'
  | 'ARTICLE_PICKER_ITEM_LIST_ITEM_AFTER_PRICE'
  | 'FILTER_EXISTING_MOVE_DOCUMENTS_BASED_ON_SCANNED_MODIFIER_CHARACTER'
  | 'FILTER_EXISTING_ORDER_DOCUMENTS_BASED_ON_SCANNED_MODIFIER_CHARACTER'
  | 'NEW_DOCUMENT_CUSTOMER_ERROR'
  | 'NEW_DOCUMENT_ITEM_ITEM_LIST_AFTER_PRICE'
  | 'NEW_DOCUMENT_ITEM_LIST_AFTER_PRICE'
  | 'NEW_DOCUMENT_ITEM_LIST_AFTER_QUANTITY'
  | 'NEW_DOCUMENT_ITEM_PACKAGE_QUANTITY'
  | 'NEW_DOCUMENT_ITEM_REPLACEMENT'
  | 'ON_ADD_NEW_DOCUMENT_ITEM_SHOW_ERROR'
  | 'ON_ADD_NEW_DOCUMENT_ITEM_SHOW_WARNING'
  | 'ON_SUBMIT_DOCUMENT_SHOW_ERROR'
  | 'ON_SUBMIT_DOCUMENT_SHOW_WARNING'
  | 'PDF_AN_CLERK'
  | 'T_HE_MOVE_LIST_ITEM_AFTER_PRICE'
  | 'T_HE_MOVE_LIST_ITEM_REPLACEMENT'
  | 'T_HE_ORDER_LIST_ITEM_AFTER_PRICE'
  | 'T_HE_ORDER_LIST_ITEM_REPLACEMENT';

declare interface AresDeploymentAres {
  aresAcKey?: Maybe<Scalars['String']>;
  aresAcName?: Maybe<Scalars['String']>;
  aresDeploymentAresCompanyCurrentVersions?: Maybe<Array<Maybe<AresDeploymentAresCompanyCurrentVersion>>>;
  aresDeploymentGroup?: Maybe<AresDeploymentGroup>;
  aresDeploymentGroupId: Scalars['Int'];
  aresVersion: Scalars['Decimal'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  executeSteps: Scalars['Boolean'];
  executionPhase?: Maybe<AresDeploymentExecutionPhase>;
  executionPhaseOrder?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isBoostrapExecutionAres: Scalars['Boolean'];
  isSQLExecutionAres: Scalars['Boolean'];
  isTestSuiteAres: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
}

declare interface AresDeploymentAresCompanyCurrentVersion {
  aresAcKey?: Maybe<Scalars['String']>;
  aresDeploymentAres?: Maybe<AresDeploymentAres>;
  aresDeploymentAresId: Scalars['Int'];
  aresVersion?: Maybe<Scalars['Decimal']>;
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  forPantheonVersion?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
}

declare interface AresDeploymentAresCompanyCurrentVersionFilterInput {
  and?: InputMaybe<Array<AresDeploymentAresCompanyCurrentVersionFilterInput>>;
  aresAcKey?: InputMaybe<StringOperationFilterInput>;
  aresDeploymentAres?: InputMaybe<AresDeploymentAresFilterInput>;
  aresDeploymentAresId?: InputMaybe<ComparableInt32OperationFilterInput>;
  aresVersion?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  forPantheonVersion?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentAresCompanyCurrentVersionFilterInput>>;
}

declare interface AresDeploymentAresFilterInput {
  and?: InputMaybe<Array<AresDeploymentAresFilterInput>>;
  aresAcKey?: InputMaybe<StringOperationFilterInput>;
  aresAcName?: InputMaybe<StringOperationFilterInput>;
  aresDeploymentAresCompanyCurrentVersions?: InputMaybe<ListFilterInputTypeOfAresDeploymentAresCompanyCurrentVersionFilterInput>;
  aresDeploymentGroup?: InputMaybe<AresDeploymentGroupFilterInput>;
  aresDeploymentGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  aresVersion?: InputMaybe<ComparableDecimalOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  executeSteps?: InputMaybe<BooleanOperationFilterInput>;
  executionPhase?: InputMaybe<NullableOfAresDeploymentExecutionPhaseOperationFilterInput>;
  executionPhaseOrder?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isBoostrapExecutionAres?: InputMaybe<BooleanOperationFilterInput>;
  isSQLExecutionAres?: InputMaybe<BooleanOperationFilterInput>;
  isTestSuiteAres?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentAresFilterInput>>;
}

declare type AresDeploymentEnvironment =
  | 'PRODUCTION'
  | 'STAGING'
  | 'TESTING';

declare interface AresDeploymentEnvironmentOperationFilterInput {
  eq?: InputMaybe<AresDeploymentEnvironment>;
  in?: InputMaybe<Array<AresDeploymentEnvironment>>;
  neq?: InputMaybe<AresDeploymentEnvironment>;
  nin?: InputMaybe<Array<AresDeploymentEnvironment>>;
}

declare type AresDeploymentExecutionPhase =
  | 'BOOTSTRAP'
  | 'SQL_EXECUTION'
  | 'STANDARD'
  | 'TEST_REFRESH_SETUP'
  | 'TEST_SUITE'
  | 'TEST_TEARDOWN';

declare interface AresDeploymentGroup {
  activityCheckSql?: Maybe<Scalars['String']>;
  areses?: Maybe<Array<Maybe<AresDeploymentAres>>>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  installationSteps?: Maybe<Array<Maybe<AresDeploymentGroupInstallationStep>>>;
  isBackgroundInstallable: Scalars['Boolean'];
  isInvoicedToAccounting: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  lastAresTestCompanySettingsId?: Maybe<Scalars['Int']>;
  lastAresTestRunAt?: Maybe<Scalars['DateTime']>;
  lastAresTestRunHash?: Maybe<Scalars['String']>;
  lastAresTestRunMessage?: Maybe<Scalars['String']>;
  lastAresTestRunPassed?: Maybe<Scalars['Boolean']>;
  lastSuccessfulAresTestHash?: Maybe<Scalars['String']>;
  lastSuccessfulAresTestRunAt?: Maybe<Scalars['DateTime']>;
  maxPantheonBuildNo?: Maybe<Scalars['Int']>;
  minPantheonBuildNo?: Maybe<Scalars['Int']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  onixPhoneSettings?: Maybe<Array<Maybe<AresDeploymentOnixPhoneSettings>>>;
  snapshots?: Maybe<Array<Maybe<AresDeploymentGroupSnapshot>>>;
  workflowDefinitions?: Maybe<Array<Maybe<AresDeploymentWorkflowDefinition>>>;
}

declare interface AresDeploymentGroupCompanyMapping {
  aresDeploymentGroup?: Maybe<AresDeploymentGroup>;
  aresDeploymentGroupId: Scalars['Int'];
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deploymentEnvironment: AresDeploymentEnvironment;
  id: Scalars['Int'];
  installationStepPoints?: Maybe<Array<Maybe<AresDeploymentInstallationStepPoint>>>;
  isAresActive?: Maybe<Scalars['Boolean']>;
  lastAresActivityCheckAt?: Maybe<Scalars['DateTime']>;
  lastAresActivityCheckResult?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
}

declare interface AresDeploymentGroupCompanyMappingFilterInput {
  and?: InputMaybe<Array<AresDeploymentGroupCompanyMappingFilterInput>>;
  aresDeploymentGroup?: InputMaybe<AresDeploymentGroupFilterInput>;
  aresDeploymentGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deploymentEnvironment?: InputMaybe<AresDeploymentEnvironmentOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  installationStepPoints?: InputMaybe<ListFilterInputTypeOfAresDeploymentInstallationStepPointFilterInput>;
  isAresActive?: InputMaybe<BooleanOperationFilterInput>;
  lastAresActivityCheckAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastAresActivityCheckResult?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentGroupCompanyMappingFilterInput>>;
}

declare interface AresDeploymentGroupFilterInput {
  activityCheckSql?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AresDeploymentGroupFilterInput>>;
  areses?: InputMaybe<ListFilterInputTypeOfAresDeploymentAresFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  installationSteps?: InputMaybe<ListFilterInputTypeOfAresDeploymentGroupInstallationStepFilterInput>;
  isBackgroundInstallable?: InputMaybe<BooleanOperationFilterInput>;
  isInvoicedToAccounting?: InputMaybe<BooleanOperationFilterInput>;
  isPublic?: InputMaybe<BooleanOperationFilterInput>;
  lastAresTestCompanySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lastAresTestRunAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastAresTestRunHash?: InputMaybe<StringOperationFilterInput>;
  lastAresTestRunMessage?: InputMaybe<StringOperationFilterInput>;
  lastAresTestRunPassed?: InputMaybe<BooleanOperationFilterInput>;
  lastSuccessfulAresTestHash?: InputMaybe<StringOperationFilterInput>;
  lastSuccessfulAresTestRunAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  maxPantheonBuildNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  minPantheonBuildNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  onixPhoneSettings?: InputMaybe<ListFilterInputTypeOfAresDeploymentOnixPhoneSettingsFilterInput>;
  or?: InputMaybe<Array<AresDeploymentGroupFilterInput>>;
  snapshots?: InputMaybe<ListFilterInputTypeOfAresDeploymentGroupSnapshotFilterInput>;
  workflowDefinitions?: InputMaybe<ListFilterInputTypeOfAresDeploymentWorkflowDefinitionFilterInput>;
}

declare interface AresDeploymentGroupInstallationStep {
  aresDeploymentGroup?: Maybe<AresDeploymentGroup>;
  aresDeploymentGroupId: Scalars['Int'];
  aresDeploymentInstallationStepPoints?: Maybe<Array<Maybe<AresDeploymentInstallationStepPoint>>>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['TimeSpan']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  order?: Maybe<Scalars['Int']>;
  resetsOnInvoicing: Scalars['Boolean'];
  sumType?: Maybe<InvoiceSumType>;
  triggerType?: Maybe<DeploymentGroupStepTriggerType>;
  variableName?: Maybe<Scalars['String']>;
  variableType: InstallationVariableType;
}

declare interface AresDeploymentGroupInstallationStepFilterInput {
  and?: InputMaybe<Array<AresDeploymentGroupInstallationStepFilterInput>>;
  aresDeploymentGroup?: InputMaybe<AresDeploymentGroupFilterInput>;
  aresDeploymentGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  aresDeploymentInstallationStepPoints?: InputMaybe<ListFilterInputTypeOfAresDeploymentInstallationStepPointFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  duration?: InputMaybe<ComparableNullableOfTimeSpanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentGroupInstallationStepFilterInput>>;
  order?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  resetsOnInvoicing?: InputMaybe<BooleanOperationFilterInput>;
  sumType?: InputMaybe<NullableOfInvoiceSumTypeOperationFilterInput>;
  triggerType?: InputMaybe<NullableOfDeploymentGroupStepTriggerTypeOperationFilterInput>;
  variableName?: InputMaybe<StringOperationFilterInput>;
  variableType?: InputMaybe<InstallationVariableTypeOperationFilterInput>;
}

declare interface AresDeploymentGroupSnapshot {
  aresDeploymentGroup?: Maybe<AresDeploymentGroup>;
  aresDeploymentGroupId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  installCount: Scalars['Int'];
  isProduction: Scalars['Boolean'];
  isStaging: Scalars['Boolean'];
  isTesting: Scalars['Boolean'];
  lastInstalledAt?: Maybe<Scalars['DateTime']>;
  lastPulledAt?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  payloadJson?: Maybe<Scalars['String']>;
  pullCount: Scalars['Int'];
  snapshotTakenAt: Scalars['DateTime'];
  sourceHash?: Maybe<Scalars['String']>;
  versionNo: Scalars['Int'];
}

declare interface AresDeploymentGroupSnapshotFilterInput {
  and?: InputMaybe<Array<AresDeploymentGroupSnapshotFilterInput>>;
  aresDeploymentGroup?: InputMaybe<AresDeploymentGroupFilterInput>;
  aresDeploymentGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  installCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  isProduction?: InputMaybe<BooleanOperationFilterInput>;
  isStaging?: InputMaybe<BooleanOperationFilterInput>;
  isTesting?: InputMaybe<BooleanOperationFilterInput>;
  lastInstalledAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastPulledAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentGroupSnapshotFilterInput>>;
  payloadJson?: InputMaybe<StringOperationFilterInput>;
  pullCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  snapshotTakenAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  sourceHash?: InputMaybe<StringOperationFilterInput>;
  versionNo?: InputMaybe<ComparableInt32OperationFilterInput>;
}

declare interface AresDeploymentInstallationStepPoint {
  aresDeploymentGroupCompanyMapping?: Maybe<AresDeploymentGroupCompanyMapping>;
  aresDeploymentGroupCompanyMappingId?: Maybe<Scalars['Int']>;
  aresDeploymentGroupInstallationStep?: Maybe<AresDeploymentGroupInstallationStep>;
  aresDeploymentGroupInstallationStepId?: Maybe<Scalars['Int']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  supportTicketTimeLog?: Maybe<SupportTicketTimeLog>;
  supportTicketTimeLogId?: Maybe<Scalars['Int']>;
  variableValue: Scalars['String'];
}

declare interface AresDeploymentInstallationStepPointFilterInput {
  and?: InputMaybe<Array<AresDeploymentInstallationStepPointFilterInput>>;
  aresDeploymentGroupCompanyMapping?: InputMaybe<AresDeploymentGroupCompanyMappingFilterInput>;
  aresDeploymentGroupCompanyMappingId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  aresDeploymentGroupInstallationStep?: InputMaybe<AresDeploymentGroupInstallationStepFilterInput>;
  aresDeploymentGroupInstallationStepId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentInstallationStepPointFilterInput>>;
  supportTicketTimeLog?: InputMaybe<SupportTicketTimeLogFilterInput>;
  supportTicketTimeLogId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  variableValue?: InputMaybe<StringOperationFilterInput>;
}

declare interface AresDeploymentOnixPhoneSettings {
  aresDeploymentGroup?: Maybe<AresDeploymentGroup>;
  aresDeploymentGroupId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
}

declare interface AresDeploymentOnixPhoneSettingsFilterInput {
  and?: InputMaybe<Array<AresDeploymentOnixPhoneSettingsFilterInput>>;
  aresDeploymentGroup?: InputMaybe<AresDeploymentGroupFilterInput>;
  aresDeploymentGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentOnixPhoneSettingsFilterInput>>;
}

declare interface AresDeploymentWorkflowDefinition {
  acIdentify?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  aresDeploymentGroup?: Maybe<AresDeploymentGroup>;
  aresDeploymentGroupId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
}

declare interface AresDeploymentWorkflowDefinitionFilterInput {
  acIdentify?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AresDeploymentWorkflowDefinitionFilterInput>>;
  aresDeploymentGroup?: InputMaybe<AresDeploymentGroupFilterInput>;
  aresDeploymentGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentWorkflowDefinitionFilterInput>>;
}

declare interface BaseMutation {
  addSingleTHeOrderItem?: Maybe<THeOrderItem>;
  addSubject?: Maybe<THeSetSubj>;
  addTHeDoc?: Maybe<TrimWorkOrderTHeDocs>;
  addTHeMove?: Maybe<Scalars['String']>;
  addTHeMoveWithFixedRebates?: Maybe<Scalars['String']>;
  addTHeOrder?: Maybe<Scalars['String']>;
  addTHeOrderWithFixedRebates?: Maybe<Scalars['String']>;
  addTHeSetSubjContact?: Maybe<THeSetSubjContact>;
  addTHeSetSubjContactAddress?: Maybe<THeSetSubjContactAddress>;
  addTHfWoex?: Maybe<Scalars['String']>;
  addTHfWoexWithFixedRebates?: Maybe<Scalars['String']>;
  addTMnDocument?: Maybe<TMnDocument>;
  addTMnFile?: Maybe<TMnFile>;
  addWorkOrderImage?: Maybe<OkWorkOrderAnKeyResult>;
  addWorkOrderMaterial?: Maybe<OkWorkOrderAnNoResult>;
  addWorkOrderReception?: Maybe<OkWorkOrderAnNoResult>;
  addWorkOrderReclamation?: Maybe<OkWorkOrderAnNoResult>;
  addWorkOrderService?: Maybe<OkWorkOrderAnNoResult>;
  addWorkOrderSpec?: Maybe<OkWorkOrderAnNoResult>;
  attachBarcodeToIdent: Scalars['Boolean'];
  checkIfDocumentIsReserved: Scalars['Boolean'];
  classifyTMnDocument: Scalars['Boolean'];
  completePortalRegistration?: Maybe<PortalSignInResultDto>;
  confirmTMnDocuments: Scalars['Boolean'];
  createAccount: Scalars['Boolean'];
  createDraftFromDocument?: Maybe<WebDraftDto>;
  createMarservisWorkOrderItemWork: Scalars['Boolean'];
  createMcpApiKey?: Maybe<CreatedMcpApiKeyDto>;
  createMoveFromAnotherDocument?: Maybe<THeMove>;
  createMoveFromGenericDocument?: Maybe<THeMove>;
  createOrderFromAnotherDocument?: Maybe<THeOrder>;
  createOrderFromGenericDocument?: Maybe<THeOrder>;
  createPortalServiceKey?: Maybe<CreatedPortalServiceKeyDto>;
  createSavedFile?: Maybe<SavedFile>;
  createWoexFromAnotherDocument?: Maybe<THeMove>;
  createWoexFromGenericDocument?: Maybe<THeMove>;
  deleteAccount: Scalars['Boolean'];
  deleteAllCloudBackedUpKeyValueStorageEntries: Scalars['Boolean'];
  deleteFirebaseNotificationTokenForUser: Scalars['Boolean'];
  deleteMarservisWorkOrderItemWork: Scalars['Boolean'];
  deleteMyPortalAccount: Scalars['Boolean'];
  deleteSavedFile: Scalars['Int'];
  deleteTHeDoc?: Maybe<TrimWorkOrderTHeDocs>;
  deleteTHeSetSubjContact: Scalars['Boolean'];
  deleteTHeSetSubjContactAddress: Scalars['Boolean'];
  deleteTMnDocument: Scalars['Boolean'];
  deleteTMnFile: Scalars['Boolean'];
  deleteWorkOrderImage?: Maybe<OkWorkOrderAnKeyResult>;
  deleteWorkOrderMaterial?: Maybe<OkWorkOrderAnNoResult>;
  deleteWorkOrderReception?: Maybe<OkWorkOrderAnNoResult>;
  deleteWorkOrderReclamation?: Maybe<OkWorkOrderAnNoResult>;
  deleteWorkOrderService?: Maybe<OkWorkOrderAnNoResult>;
  deleteWorkOrderSpec?: Maybe<OkWorkOrderAnNoResult>;
  demoLogin?: Maybe<Scalars['String']>;
  discardWebDraft: Scalars['Boolean'];
  duplicateWorkOrder?: Maybe<THeMove>;
  endWorkOrder?: Maybe<OkWorkOrderAcKeyResult>;
  exchangeExternalAuthTicket?: Maybe<ExternalAuthExchangeResultDto>;
  fISBarcodeScanned: Scalars['Boolean'];
  finalizeDailyIncome: Scalars['Boolean'];
  finishDeliveryNotesControl: Scalars['Boolean'];
  finishDeliveryNotesControlPartial: Scalars['Boolean'];
  issueWebDraft?: Maybe<WebIssueResult>;
  licenseTakeOver?: Maybe<Scalars['String']>;
  login?: Maybe<Scalars['String']>;
  loginWithPermanentToken?: Maybe<Scalars['String']>;
  markMarservisWorkOrderItemAsFinished: MarservisWorkOrderItemStatusEnum;
  markOnixPhoneUserTaskQueue: Scalars['Boolean'];
  portalCreateTicket?: Maybe<PortalWriteResultDto>;
  portalMarkSeen: Scalars['Boolean'];
  portalReply?: Maybe<PortalWriteResultDto>;
  portalSetEmailCopies?: Maybe<PortalEmailPreferencesDto>;
  refreshToken?: Maybe<Scalars['String']>;
  registerFirebaseNotificationTokenForUser: Scalars['Boolean'];
  registerNewVersion?: Maybe<NewVersionDto>;
  rejectTMnDocuments: Scalars['Boolean'];
  removeTHeMoveItem: Scalars['Boolean'];
  removeTHeOrderItem: Scalars['Boolean'];
  removeTHfWoexItem: Scalars['Boolean'];
  resendWebDocumentEmail?: Maybe<WebDocumentEmailDto>;
  restartWebDraft?: Maybe<WebDraftDto>;
  retryWebDocumentFiscalization?: Maybe<WebFiscalRetryResult>;
  revokeMcpApiKey: Scalars['Boolean'];
  revokePortalServiceKey: Scalars['Boolean'];
  saveEInvoicePdfArtifact?: Maybe<EInvoicePdfArtifactAck>;
  saveSignedDocument: Scalars['Boolean'];
  saveSignedDocumentPagesOnly: Scalars['Boolean'];
  saveSignedDocumentWithPages: Scalars['Boolean'];
  saveWebDraft?: Maybe<WebDraftSaveResult>;
  saveWebListPreference?: Maybe<WebListPreferenceDto>;
  saveWebPreferences?: Maybe<WebPreferencesDto>;
  sendWebDocumentEmail?: Maybe<WebDocumentEmailDto>;
  setPassword: Scalars['Boolean'];
  setTHeMoveItemFieldValue: Scalars['Boolean'];
  setTHfWoexItemFieldValue: Scalars['Boolean'];
  startExternalLink?: Maybe<ExternalAuthStartResultDto>;
  startExternalLogin?: Maybe<ExternalAuthStartResultDto>;
  startMerDownload: Scalars['Boolean'];
  startPortalEmailSignIn?: Maybe<PortalSignInStartDto>;
  startWorkOrder?: Maybe<OkWorkOrderAcKeyResult>;
  submitKeyValueStorageChangeLog: Scalars['Boolean'];
  submitLURInvoice?: Maybe<Scalars['String']>;
  toggleMarservisWorkOrderItemItemFinished?: Maybe<MarservisWorkOrderItemItem>;
  unlinkExternalIdentity: Scalars['Boolean'];
  unlockWorkOrder: Scalars['Boolean'];
  unreserveDocument: Scalars['Boolean'];
  updateAccount: Scalars['Boolean'];
  updateDocumentType?: Maybe<DocumentType>;
  updateDocumentTypeV2: Scalars['Boolean'];
  updateMarservisWorkOrderItemWork: Scalars['Boolean'];
  updateMobileSettings?: Maybe<MobileSettings>;
  updateOxDmsxmlitem?: Maybe<Array<Maybe<OxDmsxmlitem>>>;
  updateSubject?: Maybe<THeSetSubj>;
  updateSubjectGeolocation: Scalars['Boolean'];
  updateTHeDoc?: Maybe<TrimWorkOrderTHeDocs>;
  updateTHeSetItem?: Maybe<THeSetItem>;
  updateTHeSetSubjContact?: Maybe<THeSetSubjContact>;
  updateTHeSetSubjContactAddress?: Maybe<THeSetSubjContactAddress>;
  updateTMnDocument?: Maybe<TMnDocument>;
  updateTMnFile?: Maybe<TMnFile>;
  updateWorkOrder?: Maybe<TrimWorkOrderQuery>;
  verifyDocument: Scalars['Boolean'];
  verifyPortalEmailCode?: Maybe<PortalSignInResultDto>;
}


declare interface BaseMutationAddSingleTHeOrderItemArgs {
  acKey?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  item?: InputMaybe<CreateGenericDocumentItemDtoInput>;
}


declare interface BaseMutationAddSubjectArgs {
  add?: InputMaybe<AddSubjectDtoInput>;
}


declare interface BaseMutationAddTHeDocArgs {
  acPhoneUID?: InputMaybe<Scalars['String']>;
  acPicture?: InputMaybe<Array<Scalars['Byte']>>;
}


declare interface BaseMutationAddTHeMoveArgs {
  docType: Scalars['Int'];
  move?: InputMaybe<SubmittingMoveViewModelInput>;
}


declare interface BaseMutationAddTHeMoveWithFixedRebatesArgs {
  docType: Scalars['Int'];
  move?: InputMaybe<SubmittingMoveViewModelInput>;
}


declare interface BaseMutationAddTHeOrderArgs {
  docType: Scalars['Int'];
  order?: InputMaybe<SubmittingOrderViewModelInput>;
}


declare interface BaseMutationAddTHeOrderWithFixedRebatesArgs {
  docType: Scalars['Int'];
  order?: InputMaybe<SubmittingOrderViewModelInput>;
}


declare interface BaseMutationAddTHeSetSubjContactArgs {
  dto?: InputMaybe<AddTHeSetSubjContactDtoInput>;
}


declare interface BaseMutationAddTHeSetSubjContactAddressArgs {
  dto?: InputMaybe<AddTHeSetSubjContactAddressDtoInput>;
}


declare interface BaseMutationAddTHfWoexArgs {
  docType: Scalars['Int'];
  move?: InputMaybe<SubmittingWoexViewModelInput>;
}


declare interface BaseMutationAddTHfWoexWithFixedRebatesArgs {
  docType: Scalars['Int'];
  move?: InputMaybe<SubmittingWoexViewModelInput>;
}


declare interface BaseMutationAddTMnDocumentArgs {
  documentTypeId: Scalars['Int'];
  dto?: InputMaybe<AddTMnDocumentDtoInput>;
}


declare interface BaseMutationAddTMnFileArgs {
  documentTypeId?: InputMaybe<Scalars['Int']>;
  dto?: InputMaybe<AddTMnFileDtoInput>;
}


declare interface BaseMutationAddWorkOrderImageArgs {
  data?: InputMaybe<TrimWorkOrderImageQueryInput>;
}


declare interface BaseMutationAddWorkOrderMaterialArgs {
  data?: InputMaybe<SubmittingWorkOrderMaterialViewModelInput>;
}


declare interface BaseMutationAddWorkOrderReceptionArgs {
  data?: InputMaybe<TrimWorkOrderReceptionQueryInput>;
}


declare interface BaseMutationAddWorkOrderReclamationArgs {
  data?: InputMaybe<SubmittingWorkOrderMaterialViewModelInput>;
}


declare interface BaseMutationAddWorkOrderServiceArgs {
  data?: InputMaybe<SubmittingWorkOrderMaterialViewModelInput>;
}


declare interface BaseMutationAddWorkOrderSpecArgs {
  data?: InputMaybe<SubmittingWorkOrderWorkSpecViewModelInput>;
}


declare interface BaseMutationAttachBarcodeToIdentArgs {
  acIdent?: InputMaybe<Scalars['String']>;
  acSubject?: InputMaybe<Scalars['String']>;
  barcode?: InputMaybe<Scalars['String']>;
  packageQuantity?: InputMaybe<Scalars['Decimal']>;
}


declare interface BaseMutationCheckIfDocumentIsReservedArgs {
  acKey?: InputMaybe<Scalars['String']>;
  isMove: Scalars['Boolean'];
}


declare interface BaseMutationClassifyTMnDocumentArgs {
  anQId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
  dto?: InputMaybe<ClassifyTMnDocumentDtoInput>;
  targetClassificationQId: Scalars['Int'];
}


declare interface BaseMutationCompletePortalRegistrationArgs {
  acceptTerms: Scalars['Boolean'];
  registrationTicket?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationConfirmTMnDocumentsArgs {
  anQIds?: InputMaybe<Array<Scalars['Int']>>;
  documentTypeId?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationCreateAccountArgs {
  dto?: InputMaybe<AccountDtoInput>;
}


declare interface BaseMutationCreateDraftFromDocumentArgs {
  acKey?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  relation: DocumentRelationKind;
}


declare interface BaseMutationCreateMarservisWorkOrderItemWorkArgs {
  work?: InputMaybe<MarservisWorkOrderItemWorkDtoInput>;
}


declare interface BaseMutationCreateMcpApiKeyArgs {
  apiKey?: InputMaybe<CreateMcpApiKeyDtoInput>;
}


declare interface BaseMutationCreateMoveFromAnotherDocumentArgs {
  dto?: InputMaybe<CreateGenericDocumentFromAnotherDtoInput>;
}


declare interface BaseMutationCreateMoveFromGenericDocumentArgs {
  dto?: InputMaybe<CreateGenericDocumentDtoInput>;
}


declare interface BaseMutationCreateOrderFromAnotherDocumentArgs {
  dto?: InputMaybe<CreateGenericDocumentFromAnotherDtoInput>;
}


declare interface BaseMutationCreateOrderFromGenericDocumentArgs {
  dto?: InputMaybe<CreateGenericDocumentDtoInput>;
}


declare interface BaseMutationCreatePortalServiceKeyArgs {
  serviceKey?: InputMaybe<CreatePortalServiceKeyDtoInput>;
}


declare interface BaseMutationCreateSavedFileArgs {
  file?: InputMaybe<SavedFileDtoInput>;
}


declare interface BaseMutationCreateWoexFromAnotherDocumentArgs {
  dto?: InputMaybe<CreateGenericDocumentFromAnotherDtoInput>;
}


declare interface BaseMutationCreateWoexFromGenericDocumentArgs {
  dto?: InputMaybe<CreateGenericDocumentDtoInput>;
}


declare interface BaseMutationDeleteAccountArgs {
  dto?: InputMaybe<AccountDtoInput>;
}


declare interface BaseMutationDeleteFirebaseNotificationTokenForUserArgs {
  firebaseToken?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationDeleteMarservisWorkOrderItemWorkArgs {
  work?: InputMaybe<MarservisWorkOrderItemWorkWithoutFilesReturnDtoInput>;
}


declare interface BaseMutationDeleteMyPortalAccountArgs {
  confirmation?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationDeleteSavedFileArgs {
  fileId: Scalars['Int'];
}


declare interface BaseMutationDeleteTHeDocArgs {
  anQId: Scalars['Int'];
}


declare interface BaseMutationDeleteTHeSetSubjContactArgs {
  anQId: Scalars['Int'];
}


declare interface BaseMutationDeleteTHeSetSubjContactAddressArgs {
  anQId: Scalars['Int'];
}


declare interface BaseMutationDeleteTMnDocumentArgs {
  anQId: Scalars['Int'];
  documentTypeId?: InputMaybe<Scalars['Int']>;
}


declare interface BaseMutationDeleteTMnFileArgs {
  anQId: Scalars['Int'];
  documentTypeId?: InputMaybe<Scalars['Int']>;
}


declare interface BaseMutationDeleteWorkOrderImageArgs {
  acKey?: InputMaybe<Scalars['String']>;
  anKey: Scalars['Int'];
}


declare interface BaseMutationDeleteWorkOrderMaterialArgs {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
}


declare interface BaseMutationDeleteWorkOrderReceptionArgs {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
}


declare interface BaseMutationDeleteWorkOrderReclamationArgs {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
}


declare interface BaseMutationDeleteWorkOrderServiceArgs {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
}


declare interface BaseMutationDeleteWorkOrderSpecArgs {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
}


declare interface BaseMutationDiscardWebDraftArgs {
  id: Scalars['UUID'];
}


declare interface BaseMutationDuplicateWorkOrderArgs {
  acKey?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationEndWorkOrderArgs {
  data?: InputMaybe<SubmittingWorkOrderEndViewModelInput>;
}


declare interface BaseMutationExchangeExternalAuthTicketArgs {
  selectedUserId?: InputMaybe<Scalars['String']>;
  takeLicense: Scalars['Boolean'];
  ticket?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationFIsBarcodeScannedArgs {
  barcode?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationFinalizeDailyIncomeArgs {
  acDocType?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationFinishDeliveryNotesControlArgs {
  acKey?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationFinishDeliveryNotesControlPartialArgs {
  acKey?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<PartialFinishDeliveryNotesItemDtoInput>>>;
}


declare interface BaseMutationIssueWebDraftArgs {
  expectedTotal: Scalars['Decimal'];
  id: Scalars['UUID'];
}


declare interface BaseMutationLoginArgs {
  loginModel?: InputMaybe<LoginModelInput>;
}


declare interface BaseMutationLoginWithPermanentTokenArgs {
  permanentToken?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationMarkMarservisWorkOrderItemAsFinishedArgs {
  id: Scalars['Int'];
}


declare interface BaseMutationMarkOnixPhoneUserTaskQueueArgs {
  failed: Scalars['Boolean'];
  response?: InputMaybe<Scalars['String']>;
  taskId: Scalars['Int'];
}


declare interface BaseMutationPortalCreateTicketArgs {
  contactId?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  uploadIds?: InputMaybe<Array<Scalars['UUID']>>;
}


declare interface BaseMutationPortalMarkSeenArgs {
  messageId: Scalars['Int'];
  ticketId: Scalars['Int'];
}


declare interface BaseMutationPortalReplyArgs {
  text?: InputMaybe<Scalars['String']>;
  ticketId: Scalars['Int'];
  uploadIds?: InputMaybe<Array<Scalars['UUID']>>;
}


declare interface BaseMutationPortalSetEmailCopiesArgs {
  enabled: Scalars['Boolean'];
}


declare interface BaseMutationRegisterFirebaseNotificationTokenForUserArgs {
  newFirebaseToken?: InputMaybe<Scalars['String']>;
  oldFirebaseToken?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationRegisterNewVersionArgs {
  newVersionDto?: InputMaybe<NewVersionDtoInput>;
}


declare interface BaseMutationRejectTMnDocumentsArgs {
  anQIds?: InputMaybe<Array<Scalars['Int']>>;
  documentTypeId?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationRemoveTHeMoveItemArgs {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
  docType: Scalars['Int'];
}


declare interface BaseMutationRemoveTHeOrderItemArgs {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
  docType: Scalars['Int'];
}


declare interface BaseMutationRemoveTHfWoexItemArgs {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
  docType: Scalars['Int'];
}


declare interface BaseMutationResendWebDocumentEmailArgs {
  id: Scalars['UUID'];
}


declare interface BaseMutationRestartWebDraftArgs {
  id: Scalars['UUID'];
}


declare interface BaseMutationRetryWebDocumentFiscalizationArgs {
  acKey?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
}


declare interface BaseMutationRevokeMcpApiKeyArgs {
  id: Scalars['Int'];
}


declare interface BaseMutationRevokePortalServiceKeyArgs {
  id: Scalars['Int'];
}


declare interface BaseMutationSaveEInvoicePdfArtifactArgs {
  input?: InputMaybe<SaveEInvoicePdfArtifactInput>;
}


declare interface BaseMutationSaveSignedDocumentArgs {
  ackey?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Array<Scalars['Byte']>>;
  documentId?: InputMaybe<Scalars['Int']>;
  fileCategory?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  sendByCompanyOutboundEmail?: InputMaybe<Scalars['Boolean']>;
}


declare interface BaseMutationSaveSignedDocumentPagesOnlyArgs {
  ackey?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<Array<InputMaybe<Array<Scalars['Byte']>>>>;
}


declare interface BaseMutationSaveSignedDocumentWithPagesArgs {
  ackey?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Array<Scalars['Byte']>>;
  documentId?: InputMaybe<Scalars['Int']>;
  fileCategory?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<Array<InputMaybe<Array<Scalars['Byte']>>>>;
  sendByCompanyOutboundEmail?: InputMaybe<Scalars['Boolean']>;
}


declare interface BaseMutationSaveWebDraftArgs {
  expectedVersion?: InputMaybe<Scalars['Long']>;
  input?: InputMaybe<WebDraftInput>;
}


declare interface BaseMutationSaveWebListPreferenceArgs {
  input?: InputMaybe<SaveWebListPreferenceInput>;
}


declare interface BaseMutationSaveWebPreferencesArgs {
  input?: InputMaybe<SaveWebPreferencesInput>;
}


declare interface BaseMutationSendWebDocumentEmailArgs {
  input?: InputMaybe<WebDocumentEmailInput>;
}


declare interface BaseMutationSetPasswordArgs {
  password?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationSetTHeMoveItemFieldValueArgs {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
  fieldName?: InputMaybe<Scalars['String']>;
  fieldValue?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationSetTHfWoexItemFieldValueArgs {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
  fieldName?: InputMaybe<Scalars['String']>;
  fieldValue?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationStartExternalLinkArgs {
  appRedirectUri?: InputMaybe<Scalars['String']>;
  provider: ExternalAuthProvider;
}


declare interface BaseMutationStartExternalLoginArgs {
  appRedirectUri?: InputMaybe<Scalars['String']>;
  provider: ExternalAuthProvider;
}


declare interface BaseMutationStartMerDownloadArgs {
  documentTypeId?: InputMaybe<Scalars['Int']>;
}


declare interface BaseMutationStartPortalEmailSignInArgs {
  email?: InputMaybe<Scalars['String']>;
}


declare interface BaseMutationStartWorkOrderArgs {
  data?: InputMaybe<SubmittingWorkOrderViewModelInput>;
  docType: Scalars['Int'];
}


declare interface BaseMutationSubmitKeyValueStorageChangeLogArgs {
  dto?: InputMaybe<KeyValueStorageChangeLogInput>;
}


declare interface BaseMutationSubmitLurInvoiceArgs {
  docType: Scalars['Int'];
  invoice?: InputMaybe<SubmittingLurInvoiceViewModelInput>;
}


declare interface BaseMutationToggleMarservisWorkOrderItemItemFinishedArgs {
  id: Scalars['Int'];
}


declare interface BaseMutationUnlinkExternalIdentityArgs {
  externalIdentityId: Scalars['Int'];
}


declare interface BaseMutationUnlockWorkOrderArgs {
  acKey?: InputMaybe<Scalars['String']>;
  documentTypeId?: InputMaybe<Scalars['Int']>;
}


declare interface BaseMutationUnreserveDocumentArgs {
  acKey?: InputMaybe<Scalars['String']>;
  isMove: Scalars['Boolean'];
}


declare interface BaseMutationUpdateAccountArgs {
  dto?: InputMaybe<AccountDtoInput>;
}


declare interface BaseMutationUpdateDocumentTypeArgs {
  documentType?: InputMaybe<DocumentTypeUpdateDtoInput>;
  id: Scalars['Int'];
}


declare interface BaseMutationUpdateDocumentTypeV2Args {
  documentType?: InputMaybe<DocumentTypeUpdateDtoV2Input>;
  id: Scalars['Int'];
}


declare interface BaseMutationUpdateMarservisWorkOrderItemWorkArgs {
  work?: InputMaybe<MarservisWorkOrderItemWorkWithoutFilesReturnDtoInput>;
}


declare interface BaseMutationUpdateMobileSettingsArgs {
  mobileSettings?: InputMaybe<MobileSettingsUpdateDtoInput>;
}


declare interface BaseMutationUpdateOxDmsxmlitemArgs {
  documentTypeId?: InputMaybe<Scalars['Int']>;
  dto?: InputMaybe<UpdateOxDmsxmlitemDtoInput>;
}


declare interface BaseMutationUpdateSubjectArgs {
  update?: InputMaybe<UpdateSubjectDtoInput>;
}


declare interface BaseMutationUpdateSubjectGeolocationArgs {
  acSubject?: InputMaybe<Scalars['String']>;
  anLatitude?: InputMaybe<Scalars['Decimal']>;
  anLongitude?: InputMaybe<Scalars['Decimal']>;
}


declare interface BaseMutationUpdateTHeDocArgs {
  acPicture?: InputMaybe<Array<Scalars['Byte']>>;
  anQId: Scalars['Int'];
}


declare interface BaseMutationUpdateTHeSetItemArgs {
  acIdent?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<Scalars['Any']>;
}


declare interface BaseMutationUpdateTHeSetSubjContactArgs {
  anQId: Scalars['Int'];
  dto?: InputMaybe<UpdateTHeSetSubjContactDtoInput>;
}


declare interface BaseMutationUpdateTHeSetSubjContactAddressArgs {
  anQId: Scalars['Int'];
  dto?: InputMaybe<UpdateTHeSetSubjContactAddressDtoInput>;
}


declare interface BaseMutationUpdateTMnDocumentArgs {
  anQId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
  dto?: InputMaybe<UpdateTMnDocumentDtoInput>;
}


declare interface BaseMutationUpdateTMnFileArgs {
  anQId: Scalars['Int'];
  documentTypeId?: InputMaybe<Scalars['Int']>;
  dto?: InputMaybe<UpdateTMnFileDtoInput>;
}


declare interface BaseMutationUpdateWorkOrderArgs {
  update?: InputMaybe<UpdateWorkOrderDtoInput>;
}


declare interface BaseMutationVerifyDocumentArgs {
  acKey?: InputMaybe<Scalars['String']>;
  documentId: Scalars['Int'];
}


declare interface BaseMutationVerifyPortalEmailCodeArgs {
  challengeId: Scalars['UUID'];
  code?: InputMaybe<Scalars['String']>;
}

declare interface BaseQuery {
  accounts?: Maybe<AccountsConnection>;
  adminFilterableDocumentTypes?: Maybe<Array<Maybe<DocumentType>>>;
  allActiveAccounts?: Maybe<AllActiveAccountsDto>;
  allTMnDocumentFiles?: Maybe<Array<Maybe<TMnFile>>>;
  analysisBalanceForCustomer?: Maybe<AnalysisBalanceForCustomerDto>;
  analysisDocumentsForCustomer?: Maybe<Array<Maybe<AnalysisDocumentPerCustomerDto>>>;
  analysisPerAccountForType?: Maybe<Array<Maybe<AnalysisTotalsPerAccountDto>>>;
  analysisPerCustomerForAccount?: Maybe<Array<Maybe<AnalysisTotalsPerCustomerDto>>>;
  analysisTotals?: Maybe<AnalysisTotalsDto>;
  analysisTotalsForType?: Maybe<Array<Maybe<AnalysisCurrencyTotal>>>;
  cloudBackedUpKeyValueStorageCount: Scalars['Int'];
  cloudBackedUpKeyValueStorageEntries?: Maybe<Array<Maybe<OnixPhoneKeyValueStorage>>>;
  dailyRecap: DailyRecapDto;
  dbFile?: Maybe<DbFile>;
  dmsXmlItemsForDocument?: Maybe<Array<Maybe<OxDmsxmlitem>>>;
  documentTypes?: Maybe<Array<Maybe<DocumentType>>>;
  eInvoiceDispatchByDocumentUid?: Maybe<EInvoiceDispatchDto>;
  eInvoicePreflight?: Maybe<EInvoicePreflightDto>;
  executeSingleResultQuery?: Maybe<SingleQueryResult>;
  executeTableQuery?: Maybe<QueryTableResult>;
  existingInventoryIdents?: Maybe<Array<Maybe<Scalars['String']>>>;
  externalAuthProviders?: Maybe<Array<ExternalAuthProvider>>;
  fiscalizationCertificateGateInfo?: Maybe<FiscalizationCertificateValidationResult>;
  healthCheck?: Maybe<Scalars['String']>;
  hostName?: Maybe<Scalars['String']>;
  itemsOffsetted?: Maybe<ItemCollectionSegment>;
  lURInvoiceListItems?: Maybe<LurInvoiceListItemsConnection>;
  lURInvoicePDF?: Maybe<THeMove>;
  loginAsAccountingUser?: Maybe<Scalars['String']>;
  loginAsAlternativeUser?: Maybe<Scalars['String']>;
  loginAsUser?: Maybe<Scalars['String']>;
  marservisMaterialsForItemGroup?: Maybe<Array<Maybe<MarservisMaterialReturnDto>>>;
  marservisUserWorkOrderAllItems?: Maybe<MarservisUserWorkOrderAllItemsConnection>;
  marservisUserWorkOrderItems?: Maybe<MarservisUserWorkOrderItemsConnection>;
  marservisUserWorkOrders?: Maybe<MarservisUserWorkOrdersConnection>;
  marservisWorkOrderItemItems?: Maybe<Array<Maybe<MarservisWorkOrderItemItem>>>;
  marservisWorkOrderItemStatus: MarservisWorkOrderItemStatusEnum;
  marservisWorkOrderItemWorks?: Maybe<Array<Maybe<MarservisWorkOrderItemWorkWithoutFilesReturnDto>>>;
  marservisWorkOrderSavedFiles?: Maybe<Array<Maybe<MarservisSavedFile>>>;
  myExternalIdentities?: Maybe<Array<Maybe<ApplicationUserExternalIdentity>>>;
  myMcpApiKeyEntitlements?: Maybe<McpApiKeyEntitlementsDto>;
  myMcpApiKeys?: Maybe<Array<Maybe<McpApiKeyDto>>>;
  onixPhoneUserTaskQueue?: Maybe<Array<Maybe<OnixPhoneUserTaskQueue>>>;
  oxIOSPerSubject?: Maybe<Array<Maybe<OxIosPerSubject>>>;
  oxMerdownloadReports?: Maybe<Array<Maybe<OxMerdownloadReport>>>;
  oxScansPaged?: Maybe<OxScansPagedConnection>;
  paymentRecord?: Maybe<Array<Maybe<THeMovePaymentRecord>>>;
  pickersData?: Maybe<Array<KeyValuePairOfStringAndDictionaryOfStringAndString>>;
  plainTHeSetCustTariff?: Maybe<Array<Maybe<THeSetCustTariff>>>;
  plainTHeSetDelMet?: Maybe<Array<Maybe<THeSetDelMet>>>;
  plainTHeSetDocText?: Maybe<Array<Maybe<THeSetDocText>>>;
  plainTHeSetDuty?: Maybe<Array<Maybe<THeSetDuty>>>;
  plainTHeSetItem?: Maybe<Array<Maybe<THeSetItem>>>;
  plainTHeSetItemCateg?: Maybe<Array<Maybe<THeSetItemCateg>>>;
  plainTHeSetItemExtItemSubj?: Maybe<Array<Maybe<THeSetItemExtItemSubj>>>;
  plainTHeSetItemPriceForWrh?: Maybe<Array<Maybe<THeSetItemPriceForWrh>>>;
  plainTHeSetItemSnt?: Maybe<Array<Maybe<THeSetItemSnt>>>;
  plainTHeSetItemSntitem?: Maybe<Array<Maybe<THeSetItemSntitem>>>;
  plainTHeSetItemSntserialNo?: Maybe<Array<Maybe<THeSetItemSntserialNo>>>;
  plainTHeSetPayMet?: Maybe<Array<Maybe<THeSetPayMet>>>;
  plainTHeSetPostCode?: Maybe<Array<Maybe<THeSetPostCode>>>;
  plainTHeSetSubj?: Maybe<Array<Maybe<THeSetSubj>>>;
  plainTHeSetSubjContact?: Maybe<Array<Maybe<THeSetSubjContact>>>;
  plainTHeSetSubjContactAddress?: Maybe<Array<Maybe<THeSetSubjContactAddress>>>;
  plainTHeSetSubjPriceCateg?: Maybe<Array<Maybe<THeSetSubjPriceCateg>>>;
  plainTHeSetSubjPriceItem?: Maybe<Array<Maybe<THeSetSubjPriceItem>>>;
  plainTHeSetTax?: Maybe<Array<Maybe<THeSetTax>>>;
  plainTHeStock?: Maybe<Array<Maybe<THeStock>>>;
  plainTHeStockSerialNo?: Maybe<Array<Maybe<THeStockSerialNo>>>;
  portalConfig?: Maybe<PortalConfigDto>;
  portalEmailPreferences?: Maybe<PortalEmailPreferencesDto>;
  portalMe?: Maybe<PortalMeDto>;
  portalMessageOriginal?: Maybe<PortalMessageOriginalDto>;
  portalServiceKeys?: Maybe<Array<Maybe<PortalServiceKeyDto>>>;
  portalTicket?: Maybe<PortalTicketThreadDto>;
  portalTickets?: Maybe<PortalTicketsResponse>;
  ready: Scalars['Boolean'];
  savedFile?: Maybe<SavedFile>;
  savedFiles?: Maybe<Array<Maybe<SavedFile>>>;
  savedFilesPaged?: Maybe<SavedFilesPagedConnection>;
  signedDocument?: Maybe<Array<Scalars['Byte']>>;
  singleTHeDoc?: Maybe<TrimWorkOrderTHeDocs>;
  singleTHeFa?: Maybe<THeFa>;
  singleTHeMove?: Maybe<THeMove>;
  singleTHeMoveSortable?: Maybe<THeMove>;
  singleTHeOrder?: Maybe<THeOrder>;
  singleTHeSetItem?: Maybe<THeSetItem>;
  singleTHeSetItemExtItemSubj?: Maybe<THeSetItemExtItemSubj>;
  singleTHeSetItemParametrized?: Maybe<THeSetItem>;
  singleTHeSetSubj?: Maybe<THeSetSubj>;
  singleTHfWoex?: Maybe<THfWoex>;
  singleTHfWoexSortable?: Maybe<THfWoex>;
  singleTMnDocumentsWithStatus?: Maybe<TMnDocumentWithStatus>;
  singleVHeMove?: Maybe<VHeMove>;
  singleVHeMoveFiscalisation?: Maybe<VHeMoveFiscalisation>;
  singleVHeMoveOut?: Maybe<VHeMoveOut>;
  softPOS7PayToken?: Maybe<SoftPos7PayTokenState>;
  subjektski?: Maybe<Array<Maybe<Subjektski>>>;
  tDeSetAccountPaged?: Maybe<TDeSetAccountPagedConnection>;
  tHeAcctTransItem?: Maybe<THeAcctTransItemConnection>;
  tHeCashRegItems?: Maybe<Array<Maybe<THeCashRegItem>>>;
  tHeCashRegPaged?: Maybe<THeCashRegPagedConnection>;
  tHeCostDrvPaged?: Maybe<THeCostDrvPagedConnection>;
  tHeDocs?: Maybe<Array<Maybe<TrimWorkOrderTHeDocs>>>;
  tHeFaPaged?: Maybe<THeFaPagedConnection>;
  tHeMove?: Maybe<Array<Maybe<THeMove>>>;
  tHeMoveDailyIncomeSummary?: Maybe<THeMoveDailyIncomeSummaryDto>;
  tHeMoveItem?: Maybe<Array<Maybe<THeMoveItem>>>;
  tHeMoveItemExciseOuts?: Maybe<Array<Maybe<THeMoveItemExciseOut>>>;
  tHeMoveItemFieldValue?: Maybe<Scalars['String']>;
  tHeMovePaged?: Maybe<THeMovePagedConnection>;
  tHeMovePagedParametrized?: Maybe<THeMovePagedParametrizedConnection>;
  tHeMovePagedParametrizedDto?: Maybe<THeMovePagedParametrizedDtoConnection>;
  tHeMoveSignature?: Maybe<Array<Scalars['Byte']>>;
  tHeOrder?: Maybe<Array<Maybe<THeOrder>>>;
  tHeOrderItem?: Maybe<Array<Maybe<THeOrderItem>>>;
  tHeOrderPaged?: Maybe<THeOrderPagedConnection>;
  tHeOrderPagedParametrized?: Maybe<THeOrderPagedParametrizedConnection>;
  tHeOrderPagedParametrizedDto?: Maybe<THeOrderPagedParametrizedDtoConnection>;
  tHeSetDelMet?: Maybe<Array<Maybe<THeSetDelMet>>>;
  tHeSetItem?: Maybe<Array<Maybe<THeSetItem>>>;
  tHeSetItemCategPaged?: Maybe<THeSetItemCategPagedConnection>;
  tHeSetItemCategPagedParametrized?: Maybe<THeSetItemCategPagedParametrizedConnection>;
  tHeSetItemPaged?: Maybe<THeSetItemPagedConnection>;
  tHeSetItemPagedParametrized?: Maybe<THeSetItemPagedParametrizedConnection>;
  tHeSetItemPagedParametrizedDto?: Maybe<THeSetItemPagedParametrizedDtoConnection>;
  tHeSetItemPagedParametrizedV2?: Maybe<THeSetItemPagedParametrizedV2Connection>;
  tHeSetItemPicture?: Maybe<Array<Scalars['Byte']>>;
  tHeSetPayMets?: Maybe<Array<Maybe<THeSetPayMet>>>;
  tHeSetPostCode?: Maybe<Array<Maybe<THeSetPostCode>>>;
  tHeSetPostCodePaged?: Maybe<THeSetPostCodePagedConnection>;
  tHeSetSubj?: Maybe<Array<Maybe<THeSetSubj>>>;
  tHeSetSubjContact?: Maybe<Array<Maybe<THeSetSubjContact>>>;
  tHeSetSubjContactAddress?: Maybe<Array<Maybe<THeSetSubjContactAddress>>>;
  tHeSetSubjContactPaged?: Maybe<THeSetSubjContactPagedConnection>;
  tHeSetSubjPaged?: Maybe<THeSetSubjPagedConnection>;
  tHeSetSubjPagedParametrized?: Maybe<THeSetSubjPagedParametrizedConnection>;
  tHeSetSubjPagedParametrizedDto?: Maybe<THeSetSubjPagedParametrizedDtoConnection>;
  tHeStock?: Maybe<Array<Maybe<THeStock>>>;
  tHeStockPaged?: Maybe<THeStockPagedConnection>;
  tHeStockSerialNos?: Maybe<Array<Maybe<THeStockSerialNo>>>;
  tHeStockSerialNosPaged?: Maybe<THeStockSerialNosPagedConnection>;
  tHeStockSerialNosPagedParametrized?: Maybe<THeStockSerialNosPagedParametrizedConnection>;
  tHfWoex?: Maybe<Array<Maybe<THfWoex>>>;
  tHfWoexItem?: Maybe<Array<Maybe<THfWoexItem>>>;
  tHfWoexItemFieldValue?: Maybe<Scalars['String']>;
  tHfWoexPaged?: Maybe<THfWoexPagedConnection>;
  tHfWoexPagedParametrized?: Maybe<THfWoexPagedParametrizedConnection>;
  tHfWoexSignature?: Maybe<Array<Scalars['Byte']>>;
  tHrPrsnPaged?: Maybe<THrPrsnPagedConnection>;
  tMnClassificationMetaData?: Maybe<Array<Maybe<TMnSetClassificationMetaDatum>>>;
  tMnDocumentChatLogs?: Maybe<TMnDocumentChatLogsConnection>;
  tMnDocumentMetaData?: Maybe<Array<Maybe<TMnDocumentMetaDatum>>>;
  tMnDocuments?: Maybe<TMnDocumentsConnection>;
  tMnDocumentsCount: Scalars['Int'];
  tMnDocumentsWithStatus?: Maybe<TMnDocumentsWithStatusConnection>;
  tMnFiles?: Maybe<TMnFilesConnection>;
  tMnSetClassifications?: Maybe<Array<Maybe<TMnSetClassification>>>;
  tPaSysParam?: Maybe<Array<Maybe<TPaSysParam>>>;
  tPaUserPaged?: Maybe<TPaUserPagedConnection>;
  unfiscalizedDocumentCount: Scalars['Int'];
  unlinkedDocumentCountFromDocumentTypePair: Scalars['Int'];
  user?: Maybe<ApplicationUser>;
  userInfoVersionHash?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<ApplicationUser>>>;
  vOPSetDepts?: Maybe<Array<Maybe<VopSetDept>>>;
  vOPSetItemCategs?: Maybe<Array<Maybe<VopSetItemCateg>>>;
  vOPSetItemCategsPaged?: Maybe<VopSetItemCategsPagedConnection>;
  vOPSetItems?: Maybe<Array<Maybe<VopSetItem>>>;
  vOPSetItemsPaged?: Maybe<VopSetItemsPagedConnection>;
  vOpCashReg?: Maybe<VOpCashRegConnection>;
  vOpMoveBank?: Maybe<VOpMoveBank>;
  vOpSetBoatNamePaged?: Maybe<VOpSetBoatNamePagedConnection>;
  vOpSetBoatNames?: Maybe<Array<Maybe<VOpSetBoatName>>>;
  webAppSession?: Maybe<WebAppRoutingDto>;
  webCustomerBalance?: Maybe<WebCustomerBalanceDto>;
  webDailyIncome?: Maybe<WebDailyIncomeDto>;
  webDmsStatusCounts?: Maybe<Array<Maybe<WebDmsStatusCountDto>>>;
  webDocumentDetail?: Maybe<WebDocumentDetailDto>;
  webDocumentRoutePreview?: Maybe<EInvoicePreflightDto>;
  webDocumentStatuses?: Maybe<Array<Maybe<WebDocumentStatusDto>>>;
  webDraft?: Maybe<WebDraftDto>;
  webDrafts?: Maybe<Array<Maybe<WebDraftSummaryDto>>>;
  webEmailSettings?: Maybe<WebEmailSettingsDto>;
  webItemClassifications?: Maybe<Array<Maybe<WebItemClassificationDto>>>;
  webItemPrices?: Maybe<Array<Maybe<WebItemPrice>>>;
  webItemSearch?: Maybe<WebItemSearchConnection>;
  webMoveList?: Maybe<WebMoveListConnection>;
  webOrderList?: Maybe<WebOrderListConnection>;
  webPreferences?: Maybe<WebPreferencesDto>;
  webSubjectHistory?: Maybe<WebSubjectHistoryConnection>;
  webSubjectSearch?: Maybe<WebSubjectSearchConnection>;
  workOrder?: Maybe<WorkOrderStateViewModel>;
  workOrderPDF?: Maybe<ByteArrayDto>;
  workflowTasks?: Maybe<WorkflowTasksConnection>;
  workflowTasksCount: Scalars['Int'];
  zippedPlainTHeSetCustTariff?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetDelMet?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetDuty?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetItem?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetItemCateg?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetItemExtItemSubj?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetItemPriceForWrh?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetPayMet?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetPostCode?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetSubj?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetSubjPriceCateg?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetSubjPriceItem?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetTax?: Maybe<ByteArrayDto>;
  zippedPlainTHeStock?: Maybe<ByteArrayDto>;
}


declare interface BaseQueryAccountsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<AccountSortInput>>;
  where?: InputMaybe<AccountFilterInput>;
}


declare interface BaseQueryAdminFilterableDocumentTypesArgs {
  order?: InputMaybe<Array<DocumentTypeSortInput>>;
  userId?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<DocumentTypeFilterInput>;
}


declare interface BaseQueryAllTMnDocumentFilesArgs {
  anQId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
  order?: InputMaybe<Array<TMnFileSortInput>>;
  where?: InputMaybe<TMnFileFilterInput>;
}


declare interface BaseQueryAnalysisBalanceForCustomerArgs {
  customer?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryAnalysisDocumentsForCustomerArgs {
  accountId: Scalars['Int'];
  customer?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryAnalysisPerAccountForTypeArgs {
  type: AccountType;
}


declare interface BaseQueryAnalysisPerCustomerForAccountArgs {
  accountId: Scalars['Int'];
}


declare interface BaseQueryAnalysisTotalsForTypeArgs {
  type: AccountType;
}


declare interface BaseQueryCloudBackedUpKeyValueStorageCountArgs {
  localIds?: InputMaybe<Array<KeyValuePairOfStringAndDateTimeInput>>;
}


declare interface BaseQueryDailyRecapArgs {
  acDelivery?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acDeptOut?: InputMaybe<Scalars['String']>;
  acIssuer?: InputMaybe<Scalars['String']>;
  acPrsn3?: InputMaybe<Scalars['String']>;
  acReceiver?: InputMaybe<Scalars['String']>;
  docType: Scalars['String'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}


declare interface BaseQueryDbFileArgs {
  fileId: Scalars['Int'];
}


declare interface BaseQueryDmsXmlItemsForDocumentArgs {
  anDocumentQId: Scalars['Int'];
  documentTypeId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OxDmsxmlitemSortInput>>;
  where?: InputMaybe<OxDmsxmlitemFilterInput>;
}


declare interface BaseQueryEInvoiceDispatchByDocumentUidArgs {
  documentUid?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryEInvoicePreflightArgs {
  input?: InputMaybe<EInvoicePreflightInput>;
}


declare interface BaseQueryExecuteSingleResultQueryArgs {
  query?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryExecuteTableQueryArgs {
  query?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryExistingInventoryIdentsArgs {
  documentId: Scalars['Int'];
}


declare interface BaseQueryItemsOffsettedArgs {
  order?: InputMaybe<Array<ItemSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ItemFilterInput>;
}


declare interface BaseQueryLUrInvoiceListItemsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<LurInvoiceListItemDtoSortInput>>;
  where?: InputMaybe<LurInvoiceListItemDtoFilterInput>;
}


declare interface BaseQueryLUrInvoicePdfArgs {
  acKey?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryLoginAsAccountingUserArgs {
  userId?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryLoginAsUserArgs {
  userId?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryMarservisMaterialsForItemGroupArgs {
  itemGroupId: Scalars['Int'];
}


declare interface BaseQueryMarservisUserWorkOrderAllItemsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MarservisUserMobileWorkOrderItemDtoSortInput>>;
  where?: InputMaybe<MarservisUserMobileWorkOrderItemDtoFilterInput>;
}


declare interface BaseQueryMarservisUserWorkOrderItemsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MarservisUserMobileWorkOrderItemDtoSortInput>>;
  where?: InputMaybe<MarservisUserMobileWorkOrderItemDtoFilterInput>;
}


declare interface BaseQueryMarservisUserWorkOrdersArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MarservisLocalWorkOrderReturnDtoSortInput>>;
  where?: InputMaybe<MarservisLocalWorkOrderReturnDtoFilterInput>;
}


declare interface BaseQueryMarservisWorkOrderItemItemsArgs {
  order?: InputMaybe<Array<MarservisWorkOrderItemItemSortInput>>;
  where?: InputMaybe<MarservisWorkOrderItemItemFilterInput>;
}


declare interface BaseQueryMarservisWorkOrderItemStatusArgs {
  id: Scalars['Int'];
}


declare interface BaseQueryMarservisWorkOrderItemWorksArgs {
  order?: InputMaybe<Array<MarservisWorkOrderItemWorkWithoutFilesReturnDtoSortInput>>;
  where?: InputMaybe<MarservisWorkOrderItemWorkWithoutFilesReturnDtoFilterInput>;
}


declare interface BaseQueryMarservisWorkOrderSavedFilesArgs {
  order?: InputMaybe<Array<MarservisSavedFileSortInput>>;
  where?: InputMaybe<MarservisSavedFileFilterInput>;
}


declare interface BaseQueryOnixPhoneUserTaskQueueArgs {
  order?: InputMaybe<Array<OnixPhoneUserTaskQueueSortInput>>;
  where?: InputMaybe<OnixPhoneUserTaskQueueFilterInput>;
}


declare interface BaseQueryOxIosPerSubjectArgs {
  order?: InputMaybe<Array<OxIosPerSubjectSortInput>>;
  where?: InputMaybe<OxIosPerSubjectFilterInput>;
}


declare interface BaseQueryOxMerdownloadReportsArgs {
  documentTypeId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OxMerdownloadReportSortInput>>;
  where?: InputMaybe<OxMerdownloadReportFilterInput>;
}


declare interface BaseQueryOxScansPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onlyActive: Scalars['Boolean'];
  order?: InputMaybe<Array<OxPalletsViewSortInput>>;
  where?: InputMaybe<OxPalletsViewFilterInput>;
}


declare interface BaseQueryPaymentRecordArgs {
  acKey?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryPickersDataArgs {
  pickers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}


declare interface BaseQueryPlainTHeSetCustTariffArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetCustTariffFilterInput>;
}


declare interface BaseQueryPlainTHeSetDelMetArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetDelMetFilterInput>;
}


declare interface BaseQueryPlainTHeSetDocTextArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetDocTextFilterInput>;
}


declare interface BaseQueryPlainTHeSetDutyArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetDutyFilterInput>;
}


declare interface BaseQueryPlainTHeSetItemArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetItemFilterInput>;
}


declare interface BaseQueryPlainTHeSetItemCategArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetItemCategFilterInput>;
}


declare interface BaseQueryPlainTHeSetItemExtItemSubjArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetItemExtItemSubjFilterInput>;
}


declare interface BaseQueryPlainTHeSetItemPriceForWrhArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetItemPriceForWrhFilterInput>;
}


declare interface BaseQueryPlainTHeSetItemSntArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetItemSntFilterInput>;
}


declare interface BaseQueryPlainTHeSetItemSntitemArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetItemSntitemFilterInput>;
}


declare interface BaseQueryPlainTHeSetItemSntserialNoArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetItemSntserialNoFilterInput>;
}


declare interface BaseQueryPlainTHeSetPayMetArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetPayMetFilterInput>;
}


declare interface BaseQueryPlainTHeSetPostCodeArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetPostCodeFilterInput>;
}


declare interface BaseQueryPlainTHeSetSubjArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetSubjFilterInput>;
}


declare interface BaseQueryPlainTHeSetSubjContactArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetSubjContactFilterInput>;
}


declare interface BaseQueryPlainTHeSetSubjContactAddressArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetSubjContactAddressFilterInput>;
}


declare interface BaseQueryPlainTHeSetSubjPriceCategArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetSubjPriceCategFilterInput>;
}


declare interface BaseQueryPlainTHeSetSubjPriceItemArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetSubjPriceItemFilterInput>;
}


declare interface BaseQueryPlainTHeSetTaxArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetTaxFilterInput>;
}


declare interface BaseQueryPlainTHeStockArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeStockFilterInput>;
}


declare interface BaseQueryPlainTHeStockSerialNoArgs {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeStockSerialNoFilterInput>;
}


declare interface BaseQueryPortalMessageOriginalArgs {
  messageId: Scalars['Int'];
  ticketId: Scalars['Int'];
}


declare interface BaseQueryPortalTicketArgs {
  id: Scalars['Int'];
}


declare interface BaseQueryPortalTicketsArgs {
  skip?: Scalars['Int'];
  status?: PortalTicketStatusFilter;
  take?: Scalars['Int'];
}


declare interface BaseQuerySavedFileArgs {
  order?: InputMaybe<Array<SavedFileSortInput>>;
  where?: InputMaybe<SavedFileFilterInput>;
}


declare interface BaseQuerySavedFilesArgs {
  order?: InputMaybe<Array<SavedFileSortInput>>;
  where?: InputMaybe<SavedFileFilterInput>;
}


declare interface BaseQuerySavedFilesPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<SavedFileSortInput>>;
  where?: InputMaybe<SavedFileFilterInput>;
}


declare interface BaseQuerySignedDocumentArgs {
  acKey?: InputMaybe<Scalars['String']>;
  fileCategory?: InputMaybe<Scalars['String']>;
}


declare interface BaseQuerySingleTHeDocArgs {
  order?: InputMaybe<Array<TrimWorkOrderTHeDocsSortInput>>;
  where?: InputMaybe<TrimWorkOrderTHeDocsFilterInput>;
}


declare interface BaseQuerySingleTHeFaArgs {
  where?: InputMaybe<THeFaFilterInput>;
}


declare interface BaseQuerySingleTHeMoveArgs {
  where?: InputMaybe<THeMoveFilterInput>;
}


declare interface BaseQuerySingleTHeMoveSortableArgs {
  order?: InputMaybe<Array<THeMoveSortInput>>;
  where?: InputMaybe<THeMoveFilterInput>;
}


declare interface BaseQuerySingleTHeOrderArgs {
  where?: InputMaybe<THeOrderFilterInput>;
}


declare interface BaseQuerySingleTHeSetItemArgs {
  where?: InputMaybe<THeSetItemFilterInput>;
}


declare interface BaseQuerySingleTHeSetItemExtItemSubjArgs {
  where?: InputMaybe<THeSetItemExtItemSubjFilterInput>;
}


declare interface BaseQuerySingleTHeSetItemParametrizedArgs {
  acWarehouse?: InputMaybe<Scalars['String']>;
  barcode?: InputMaybe<Scalars['String']>;
  ignoreWarehouse?: InputMaybe<Scalars['Boolean']>;
  showOnlyInStock?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<THeSetItemFilterInput>;
}


declare interface BaseQuerySingleTHeSetSubjArgs {
  where?: InputMaybe<THeSetSubjFilterInput>;
}


declare interface BaseQuerySingleTHfWoexArgs {
  where?: InputMaybe<THfWoexFilterInput>;
}


declare interface BaseQuerySingleTHfWoexSortableArgs {
  order?: InputMaybe<Array<THfWoexSortInput>>;
  where?: InputMaybe<THfWoexFilterInput>;
}


declare interface BaseQuerySingleTMnDocumentsWithStatusArgs {
  anQId: Scalars['Int'];
  documentTypeId?: InputMaybe<Scalars['Int']>;
}


declare interface BaseQuerySingleVHeMoveArgs {
  where?: InputMaybe<VHeMoveFilterInput>;
}


declare interface BaseQuerySingleVHeMoveFiscalisationArgs {
  where?: InputMaybe<VHeMoveFiscalisationFilterInput>;
}


declare interface BaseQuerySingleVHeMoveOutArgs {
  where?: InputMaybe<VHeMoveOutFilterInput>;
}


declare interface BaseQuerySubjektskiArgs {
  order?: InputMaybe<Array<SubjektskiSortInput>>;
  where?: InputMaybe<SubjektskiFilterInput>;
}


declare interface BaseQueryTDeSetAccountPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TDeSetAccountSortInput>>;
  where?: InputMaybe<TDeSetAccountFilterInput>;
}


declare interface BaseQueryTHeAcctTransItemArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeAcctTransItemSortInput>>;
  where?: InputMaybe<THeAcctTransItemFilterInput>;
}


declare interface BaseQueryTHeCashRegItemsArgs {
  order?: InputMaybe<Array<THeCashRegItemSortInput>>;
  where?: InputMaybe<THeCashRegItemFilterInput>;
}


declare interface BaseQueryTHeCashRegPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeCashRegSortInput>>;
  where?: InputMaybe<THeCashRegFilterInput>;
}


declare interface BaseQueryTHeCostDrvPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeCostDrvSortInput>>;
  where?: InputMaybe<THeCostDrvFilterInput>;
}


declare interface BaseQueryTHeDocsArgs {
  order?: InputMaybe<Array<TrimWorkOrderTHeDocsSortInput>>;
  where?: InputMaybe<TrimWorkOrderTHeDocsFilterInput>;
}


declare interface BaseQueryTHeFaPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeFaSortInput>>;
  where?: InputMaybe<THeFaFilterInput>;
}


declare interface BaseQueryTHeMoveArgs {
  order?: InputMaybe<Array<THeMoveSortInput>>;
  where?: InputMaybe<THeMoveFilterInput>;
}


declare interface BaseQueryTHeMoveDailyIncomeSummaryArgs {
  acDocType?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryTHeMoveItemArgs {
  order?: InputMaybe<Array<THeMoveItemSortInput>>;
  scannedModifierChar?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<THeMoveItemFilterInput>;
}


declare interface BaseQueryTHeMoveItemExciseOutsArgs {
  order?: InputMaybe<Array<THeMoveItemExciseOutSortInput>>;
  where?: InputMaybe<THeMoveItemExciseOutFilterInput>;
}


declare interface BaseQueryTHeMoveItemFieldValueArgs {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
  fieldName?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryTHeMovePagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeMoveSortInput>>;
  where?: InputMaybe<THeMoveFilterInput>;
}


declare interface BaseQueryTHeMovePagedParametrizedArgs {
  acDelivery?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acDeptOut?: InputMaybe<Scalars['String']>;
  acDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acIssuer?: InputMaybe<Scalars['String']>;
  acKeys?: InputMaybe<Array<Scalars['String']>>;
  acPrsn3?: InputMaybe<Scalars['String']>;
  acReceiver?: InputMaybe<Scalars['String']>;
  acVerifiedPrices?: InputMaybe<Scalars['String']>;
  acVerifyStatus?: InputMaybe<Scalars['String']>;
  adFieldDAIsNotNull?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  anUserIns?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['DateTime']>;
  fromAcKey?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeMoveSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  sortDescending?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<THeMovePagedSortField>;
  to?: InputMaybe<Scalars['DateTime']>;
  toAcKey?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<THeMoveFilterInput>;
}


declare interface BaseQueryTHeMovePagedParametrizedDtoArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dto?: InputMaybe<THeMovePagedParametrizedDtoInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeMoveSortInput>>;
  where?: InputMaybe<THeMoveFilterInput>;
}


declare interface BaseQueryTHeMoveSignatureArgs {
  acKey?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryTHeOrderArgs {
  order?: InputMaybe<Array<THeOrderSortInput>>;
  where?: InputMaybe<THeOrderFilterInput>;
}


declare interface BaseQueryTHeOrderItemArgs {
  order?: InputMaybe<Array<THeOrderItemSortInput>>;
  scannedModifierChar?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<THeOrderItemFilterInput>;
}


declare interface BaseQueryTHeOrderPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeOrderSortInput>>;
  where?: InputMaybe<THeOrderFilterInput>;
}


declare interface BaseQueryTHeOrderPagedParametrizedArgs {
  acConsignee?: InputMaybe<Scalars['String']>;
  acDelivery?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acReceiver?: InputMaybe<Scalars['String']>;
  acStatus?: InputMaybe<Scalars['String']>;
  acStatusIn?: InputMaybe<Array<Scalars['String']>>;
  acStatusNotIn?: InputMaybe<Array<Scalars['String']>>;
  after?: InputMaybe<Scalars['String']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['DateTime']>;
  fromAcKey?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeOrderSortInput>>;
  sortDescending?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<THeOrderPagedSortField>;
  to?: InputMaybe<Scalars['DateTime']>;
  toAcKey?: InputMaybe<Scalars['String']>;
  useDeliveryDeadline?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<THeOrderFilterInput>;
}


declare interface BaseQueryTHeOrderPagedParametrizedDtoArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dto?: InputMaybe<THeOrderPagedParametrizedDtoInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeOrderSortInput>>;
  where?: InputMaybe<THeOrderFilterInput>;
}


declare interface BaseQueryTHeSetDelMetArgs {
  order?: InputMaybe<Array<THeSetDelMetSortInput>>;
  where?: InputMaybe<THeSetDelMetFilterInput>;
}


declare interface BaseQueryTHeSetItemArgs {
  order?: InputMaybe<Array<THeSetItemSortInput>>;
  where?: InputMaybe<THeSetItemFilterInput>;
}


declare interface BaseQueryTHeSetItemCategPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetItemCategSortInput>>;
  where?: InputMaybe<THeSetItemCategFilterInput>;
}


declare interface BaseQueryTHeSetItemCategPagedParametrizedArgs {
  acFieldsA?: InputMaybe<Scalars['String']>;
  acSetOfItem?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetItemCategSortInput>>;
  where?: InputMaybe<THeSetItemCategFilterInput>;
}


declare interface BaseQueryTHeSetItemPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetItemSortInput>>;
  where?: InputMaybe<THeSetItemFilterInput>;
}


declare interface BaseQueryTHeSetItemPagedParametrizedArgs {
  acClassif?: InputMaybe<Scalars['String']>;
  acFieldsA?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetItemSortInput>>;
  where?: InputMaybe<THeSetItemFilterInput>;
}


declare interface BaseQueryTHeSetItemPagedParametrizedDtoArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dto?: InputMaybe<THeSetItemPagedDtoInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetItemSortInput>>;
  where?: InputMaybe<THeSetItemFilterInput>;
}


declare interface BaseQueryTHeSetItemPagedParametrizedV2Args {
  acClassif?: InputMaybe<Scalars['String']>;
  acFieldsA?: InputMaybe<Scalars['String']>;
  acSetOfItem?: InputMaybe<Scalars['String']>;
  acWarehouse?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  docTypeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ignoreWarehouse?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  minStock?: InputMaybe<Scalars['Decimal']>;
  onlyWithCustomerContractPrices?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  showOnlyInStock?: InputMaybe<Scalars['Boolean']>;
  sortDescending?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<THeSetItemPagedSortField>;
  where?: InputMaybe<THeSetItemFilterInput>;
}


declare interface BaseQueryTHeSetItemPictureArgs {
  acIdent?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryTHeSetPayMetsArgs {
  order?: InputMaybe<Array<THeSetPayMetSortInput>>;
  where?: InputMaybe<THeSetPayMetFilterInput>;
}


declare interface BaseQueryTHeSetPostCodeArgs {
  order?: InputMaybe<Array<THeSetPostCodeSortInput>>;
  where?: InputMaybe<THeSetPostCodeFilterInput>;
}


declare interface BaseQueryTHeSetPostCodePagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetPostCodeSortInput>>;
  where?: InputMaybe<THeSetPostCodeFilterInput>;
}


declare interface BaseQueryTHeSetSubjArgs {
  order?: InputMaybe<Array<THeSetSubjSortInput>>;
  where?: InputMaybe<THeSetSubjFilterInput>;
}


declare interface BaseQueryTHeSetSubjContactArgs {
  order?: InputMaybe<Array<THeSetSubjContactSortInput>>;
  where?: InputMaybe<THeSetSubjContactFilterInput>;
}


declare interface BaseQueryTHeSetSubjContactAddressArgs {
  order?: InputMaybe<Array<THeSetSubjContactAddressSortInput>>;
  where?: InputMaybe<THeSetSubjContactAddressFilterInput>;
}


declare interface BaseQueryTHeSetSubjContactPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetSubjContactSortInput>>;
  where?: InputMaybe<THeSetSubjContactFilterInput>;
}


declare interface BaseQueryTHeSetSubjPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetSubjSortInput>>;
  where?: InputMaybe<THeSetSubjFilterInput>;
}


declare interface BaseQueryTHeSetSubjPagedParametrizedArgs {
  acBuyer?: InputMaybe<Scalars['String']>;
  acConsigneeInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acDeptInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acDeptOutInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acFieldSa?: InputMaybe<Scalars['String']>;
  acIssuerInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acPrsn3InDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acReceiverInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acSubject?: InputMaybe<Scalars['String']>;
  acSupplier?: InputMaybe<Scalars['String']>;
  acWarehouse?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  anClerks?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  byAcSkis?: InputMaybe<Scalars['String']>;
  byPrefix?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetSubjSortInput>>;
  where?: InputMaybe<THeSetSubjFilterInput>;
}


declare interface BaseQueryTHeSetSubjPagedParametrizedDtoArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dto?: InputMaybe<THeSetSubjPagedParametrizedDtoInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetSubjSortInput>>;
  where?: InputMaybe<THeSetSubjFilterInput>;
}


declare interface BaseQueryTHeStockArgs {
  order?: InputMaybe<Array<THeStockSortInput>>;
  where?: InputMaybe<THeStockFilterInput>;
}


declare interface BaseQueryTHeStockPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeStockSortInput>>;
  where?: InputMaybe<THeStockFilterInput>;
}


declare interface BaseQueryTHeStockSerialNosArgs {
  order?: InputMaybe<Array<THeStockSerialNoSortInput>>;
  where?: InputMaybe<THeStockSerialNoFilterInput>;
}


declare interface BaseQueryTHeStockSerialNosPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeStockSerialNoSortInput>>;
  where?: InputMaybe<THeStockSerialNoFilterInput>;
}


declare interface BaseQueryTHeStockSerialNosPagedParametrizedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeStockSerialNoSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<THeStockSerialNoFilterInput>;
}


declare interface BaseQueryTHfWoexArgs {
  order?: InputMaybe<Array<THfWoexSortInput>>;
  where?: InputMaybe<THfWoexFilterInput>;
}


declare interface BaseQueryTHfWoexItemArgs {
  order?: InputMaybe<Array<THfWoexItemSortInput>>;
  scannedModifierChar?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<THfWoexItemFilterInput>;
}


declare interface BaseQueryTHfWoexItemFieldValueArgs {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
  fieldName?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryTHfWoexPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THfWoexSortInput>>;
  where?: InputMaybe<THfWoexFilterInput>;
}


declare interface BaseQueryTHfWoexPagedParametrizedArgs {
  acConsignee?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acKeys?: InputMaybe<Array<Scalars['String']>>;
  acReceiver?: InputMaybe<Scalars['String']>;
  acStatus?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  anUserIns?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['DateTime']>;
  fromAcKey?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THfWoexSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  sortDescending?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<THfWoexPagedSortField>;
  to?: InputMaybe<Scalars['DateTime']>;
  toAcKey?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<THfWoexFilterInput>;
}


declare interface BaseQueryTHfWoexSignatureArgs {
  acKey?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryTHrPrsnPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THrPrsnSortInput>>;
  tHrPrsnForOnlyOnixPhoneUsers?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<THrPrsnFilterInput>;
}


declare interface BaseQueryTMnClassificationMetaDataArgs {
  order?: InputMaybe<Array<TMnSetClassificationMetaDatumSortInput>>;
  where?: InputMaybe<TMnSetClassificationMetaDatumFilterInput>;
}


declare interface BaseQueryTMnDocumentChatLogsArgs {
  after?: InputMaybe<Scalars['String']>;
  anDocumentQId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  documentTypeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TMnDocumentChatLogSortInput>>;
  where?: InputMaybe<TMnDocumentChatLogFilterInput>;
}


declare interface BaseQueryTMnDocumentMetaDataArgs {
  anDocumentQId?: InputMaybe<Scalars['Int']>;
  documentTypeId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TMnDocumentMetaDatumSortInput>>;
  where?: InputMaybe<TMnDocumentMetaDatumFilterInput>;
}


declare interface BaseQueryTMnDocumentsArgs {
  acSubject?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  anClassificationQId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  byAnQid?: InputMaybe<Scalars['Int']>;
  dmsAcStatusIn?: InputMaybe<Array<Scalars['String']>>;
  documentTypeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TMnDocumentSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<Scalars['Boolean']>;
  showOnlyUnconfirmedDMSDocuments?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TMnDocumentFilterInput>;
}


declare interface BaseQueryTMnDocumentsCountArgs {
  acSubject?: InputMaybe<Scalars['String']>;
  anClassificationQId?: InputMaybe<Scalars['Int']>;
  byAnQid?: InputMaybe<Scalars['Int']>;
  dmsAcStatusIn?: InputMaybe<Array<Scalars['String']>>;
  documentTypeId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<Scalars['Boolean']>;
  showOnlyUnconfirmedDMSDocuments?: InputMaybe<Scalars['Boolean']>;
}


declare interface BaseQueryTMnDocumentsWithStatusArgs {
  acSubject?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  anClassificationQId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  byAnQid?: InputMaybe<Scalars['Int']>;
  dmsAcStatusIn?: InputMaybe<Array<Scalars['String']>>;
  documentTypeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TMnDocumentWithStatusSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<Scalars['Boolean']>;
  showOnlyUnconfirmedDMSDocuments?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TMnDocumentWithStatusFilterInput>;
}


declare interface BaseQueryTMnFilesArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byAnDocumentQId?: InputMaybe<Scalars['Int']>;
  byAnQId?: InputMaybe<Scalars['Int']>;
  byAnUserIns?: InputMaybe<Scalars['Int']>;
  documentTypeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TMnFileSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<TMnFileFilterInput>;
}


declare interface BaseQueryTMnSetClassificationsArgs {
  order?: InputMaybe<Array<TMnSetClassificationSortInput>>;
  where?: InputMaybe<TMnSetClassificationFilterInput>;
}


declare interface BaseQueryTPaSysParamArgs {
  order?: InputMaybe<Array<TPaSysParamSortInput>>;
  where?: InputMaybe<TPaSysParamFilterInput>;
}


declare interface BaseQueryTPaUserPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TPaUserSortInput>>;
  where?: InputMaybe<TPaUserFilterInput>;
}


declare interface BaseQueryUnfiscalizedDocumentCountArgs {
  docId: Scalars['Int'];
}


declare interface BaseQueryUnlinkedDocumentCountFromDocumentTypePairArgs {
  documentTypePairId: Scalars['Int'];
}


declare interface BaseQueryUsersArgs {
  order?: InputMaybe<Array<ApplicationUserSortInput>>;
  where?: InputMaybe<ApplicationUserFilterInput>;
}


declare interface BaseQueryVOpSetDeptsArgs {
  order?: InputMaybe<Array<VopSetDeptSortInput>>;
  where?: InputMaybe<VopSetDeptFilterInput>;
}


declare interface BaseQueryVOpSetItemCategsArgs {
  order?: InputMaybe<Array<VopSetItemCategSortInput>>;
  where?: InputMaybe<VopSetItemCategFilterInput>;
}


declare interface BaseQueryVOpSetItemCategsPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<VopSetItemCategSortInput>>;
  where?: InputMaybe<VopSetItemCategFilterInput>;
}


declare interface BaseQueryVOpSetItemsArgs {
  order?: InputMaybe<Array<VopSetItemSortInput>>;
  where?: InputMaybe<VopSetItemFilterInput>;
}


declare interface BaseQueryVOpSetItemsPagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<VopSetItemSortInput>>;
  where?: InputMaybe<VopSetItemFilterInput>;
}


declare interface BaseQueryVOpCashRegArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<VOpCashRegSortInput>>;
  where?: InputMaybe<VOpCashRegFilterInput>;
}


declare interface BaseQueryVOpMoveBankArgs {
  acKey?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryVOpSetBoatNamePagedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<VOpSetBoatNameSortInput>>;
  where?: InputMaybe<VOpSetBoatNameFilterInput>;
}


declare interface BaseQueryVOpSetBoatNamesArgs {
  order?: InputMaybe<Array<VOpSetBoatNameSortInput>>;
  where?: InputMaybe<VOpSetBoatNameFilterInput>;
}


declare interface BaseQueryWebCustomerBalanceArgs {
  acSubject?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
}


declare interface BaseQueryWebDailyIncomeArgs {
  documentTypeId: Scalars['Int'];
}


declare interface BaseQueryWebDmsStatusCountsArgs {
  anClassificationQId?: InputMaybe<Scalars['Int']>;
  documentTypeId: Scalars['Int'];
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<Scalars['Boolean']>;
}


declare interface BaseQueryWebDocumentDetailArgs {
  acKey?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
}


declare interface BaseQueryWebDocumentRoutePreviewArgs {
  acPayMethod?: InputMaybe<Scalars['String']>;
  acReceiver?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
}


declare interface BaseQueryWebDocumentStatusesArgs {
  acKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  documentTypeId: Scalars['Int'];
}


declare interface BaseQueryWebDraftArgs {
  id: Scalars['UUID'];
}


declare interface BaseQueryWebDraftsArgs {
  documentTypeId: Scalars['Int'];
}


declare interface BaseQueryWebItemClassificationsArgs {
  documentTypeId: Scalars['Int'];
}


declare interface BaseQueryWebItemPricesArgs {
  customerAcSubject?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  documentTypeId: Scalars['Int'];
  idents?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  warehouseAcSubject?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryWebItemSearchArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<WebItemSearchInput>;
  last?: InputMaybe<Scalars['Int']>;
}


declare interface BaseQueryWebMoveListArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  filter?: InputMaybe<WebDocumentListFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  historyView: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeMoveSortInput>>;
  where?: InputMaybe<THeMoveFilterInput>;
}


declare interface BaseQueryWebOrderListArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  filter?: InputMaybe<WebDocumentListFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  historyView: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeOrderSortInput>>;
  where?: InputMaybe<THeOrderFilterInput>;
}


declare interface BaseQueryWebSubjectHistoryArgs {
  acSubject?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dmsDocumentTypeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeMoveSortInput>>;
}


declare interface BaseQueryWebSubjectSearchArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<WebSubjectSearchInput>;
  last?: InputMaybe<Scalars['Int']>;
}


declare interface BaseQueryWorkOrderArgs {
  acKey?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryWorkOrderPdfArgs {
  acKey?: InputMaybe<Scalars['String']>;
}


declare interface BaseQueryWorkflowTasksArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TPaWorkflowTaskInstanceSortInput>>;
  where?: InputMaybe<TPaWorkflowTaskInstanceFilterInput>;
}


declare interface BaseQueryZippedPlainTHeSetCustTariffArgs {
  adTimeChg: Scalars['DateTime'];
}


declare interface BaseQueryZippedPlainTHeSetDelMetArgs {
  adTimeChg: Scalars['DateTime'];
}


declare interface BaseQueryZippedPlainTHeSetDutyArgs {
  adTimeChg: Scalars['DateTime'];
}


declare interface BaseQueryZippedPlainTHeSetItemArgs {
  adTimeChg: Scalars['DateTime'];
}


declare interface BaseQueryZippedPlainTHeSetItemCategArgs {
  adTimeChg: Scalars['DateTime'];
}


declare interface BaseQueryZippedPlainTHeSetItemExtItemSubjArgs {
  adTimeChg: Scalars['DateTime'];
}


declare interface BaseQueryZippedPlainTHeSetItemPriceForWrhArgs {
  adTimeChg: Scalars['DateTime'];
}


declare interface BaseQueryZippedPlainTHeSetPayMetArgs {
  adTimeChg: Scalars['DateTime'];
}


declare interface BaseQueryZippedPlainTHeSetPostCodeArgs {
  adTimeChg: Scalars['DateTime'];
}


declare interface BaseQueryZippedPlainTHeSetSubjArgs {
  adTimeChg: Scalars['DateTime'];
}


declare interface BaseQueryZippedPlainTHeSetSubjPriceCategArgs {
  adTimeChg: Scalars['DateTime'];
}


declare interface BaseQueryZippedPlainTHeSetSubjPriceItemArgs {
  adTimeChg: Scalars['DateTime'];
}


declare interface BaseQueryZippedPlainTHeSetTaxArgs {
  adTimeChg: Scalars['DateTime'];
}


declare interface BaseQueryZippedPlainTHeStockArgs {
  adTimeChg: Scalars['DateTime'];
}

declare interface BooleanOperationFilterInput {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
}

declare interface ByteArrayDto {
  data?: Maybe<Array<Scalars['Byte']>>;
}

declare type CardPaymentProvider =
  | 'NONE'
  | 'SOFT_POS7_PAY_ERSTE';

declare interface ClassifyTMnDocumentDtoInput {
  metadata?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>;
  note?: InputMaybe<Scalars['String']>;
  reclassifySubjectDocuments?: InputMaybe<Scalars['Boolean']>;
  rememberSubjectClassificationMapping?: InputMaybe<Scalars['Boolean']>;
  subjectClassificationAcSubject?: InputMaybe<Scalars['String']>;
}

declare type ClientEnum =
  | 'ADRIANA_NAUTICA'
  | 'CORTINA'
  | 'DIMEGLIO'
  | 'DONAR'
  | 'MUSHROOMS'
  | 'ONIX'
  | 'PROTECH'
  | 'TRIM';

/** Information about the offset pagination. */
declare interface CollectionSegmentInfo {
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
}

declare interface Company {
  accountingCompany?: Maybe<Company>;
  accountingCompanyId?: Maybe<Scalars['Int']>;
  alternateMainServerPrefix?: Maybe<Scalars['String']>;
  aresDeploymentAresCompanyCurrentVersions?: Maybe<Array<Maybe<AresDeploymentAresCompanyCurrentVersion>>>;
  aresDeploymentGroupCompanyMappings?: Maybe<Array<Maybe<AresDeploymentGroupCompanyMapping>>>;
  companyDatalabReferenceLinks?: Maybe<Array<Maybe<CompanyDatalabReferenceLink>>>;
  companyMachineUids?: Maybe<Array<Maybe<CompanyMachineUid>>>;
  companyMeshCentralGroupMappings?: Maybe<Array<Maybe<CompanyMeshCentralGroupMapping>>>;
  companyRunbookNotes?: Maybe<Array<Maybe<CompanyRunbookNote>>>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  companyTeamViewerContacts?: Maybe<Array<Maybe<CompanyTeamViewerContact>>>;
  companyTeamViewerDevices?: Maybe<Array<Maybe<CompanyTeamViewerDevice>>>;
  connectionSettings?: Maybe<Scalars['String']>;
  contactCompanies?: Maybe<Array<Maybe<ContactCompany>>>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  datalabReleaseLockdownRuns?: Maybe<Array<Maybe<DatalabReleaseLockdownRun>>>;
  description?: Maybe<Scalars['String']>;
  grunfAresSyncToken?: Maybe<Scalars['String']>;
  iBackupEventLogComputers?: Maybe<Array<Maybe<IBackupEventLogComputer>>>;
  id: Scalars['Int'];
  linkedCompanySettings?: Maybe<CompanySettings>;
  linkedCompanySettingsId?: Maybe<Scalars['Int']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  myEInvoiceSettings?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notOurCustomer: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  pantheonAcSubject?: Maybe<Scalars['String']>;
  pantheonBuyerType?: Maybe<Scalars['String']>;
  pantheonBuyerTypeName?: Maybe<Scalars['String']>;
  pantheonConnectionString?: Maybe<Scalars['String']>;
  pantheonId?: Maybe<Scalars['String']>;
  pantheonStatus?: Maybe<Scalars['String']>;
  pantheonSubscriber: Scalars['Boolean'];
  shouldHaveIBackup: Scalars['Boolean'];
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
}

declare interface CompanyDatalabReferenceLink {
  company: Company;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  datalabReferenceCompany?: Maybe<DatalabReferenceCompany>;
  datalabReferenceCompanyId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isManual: Scalars['Boolean'];
  lastSuggestedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  reviewedAt?: Maybe<Scalars['DateTime']>;
  reviewedById?: Maybe<Scalars['String']>;
  status: CompanyDatalabReferenceLinkStatusEnum;
  suggestedReason?: Maybe<Scalars['String']>;
  suggestedScore?: Maybe<Scalars['Decimal']>;
}

declare interface CompanyDatalabReferenceLinkFilterInput {
  and?: InputMaybe<Array<CompanyDatalabReferenceLinkFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  datalabReferenceCompany?: InputMaybe<DatalabReferenceCompanyFilterInput>;
  datalabReferenceCompanyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isManual?: InputMaybe<BooleanOperationFilterInput>;
  lastSuggestedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CompanyDatalabReferenceLinkFilterInput>>;
  reviewedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  reviewedById?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<CompanyDatalabReferenceLinkStatusEnumOperationFilterInput>;
  suggestedReason?: InputMaybe<StringOperationFilterInput>;
  suggestedScore?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
}

declare type CompanyDatalabReferenceLinkStatusEnum =
  | 'APPROVED'
  | 'PENDING'
  | 'REJECTED';

declare interface CompanyDatalabReferenceLinkStatusEnumOperationFilterInput {
  eq?: InputMaybe<CompanyDatalabReferenceLinkStatusEnum>;
  in?: InputMaybe<Array<CompanyDatalabReferenceLinkStatusEnum>>;
  neq?: InputMaybe<CompanyDatalabReferenceLinkStatusEnum>;
  nin?: InputMaybe<Array<CompanyDatalabReferenceLinkStatusEnum>>;
}

declare interface CompanyEmailForward {
  bCC?: Maybe<Scalars['String']>;
  bodyFormat?: Maybe<Scalars['String']>;
  bodyParams?: Maybe<Scalars['String']>;
  cC?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  context: CompanyEmailForwardContextEnum;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  documentFilterSQL?: Maybe<Scalars['String']>;
  documentItemsFilterSQL?: Maybe<Scalars['String']>;
  documentType?: Maybe<DocumentType>;
  documentTypeId?: Maybe<Scalars['Int']>;
  documentTypeParams?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isBodyHtml: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  receivingEmail?: Maybe<Scalars['String']>;
  titleFormat?: Maybe<Scalars['String']>;
  titleParams?: Maybe<Scalars['String']>;
}

declare type CompanyEmailForwardContextEnum =
  | 'AFTER_SAVING_DOCUMENT'
  | 'AFTER_SAVING_SIGNED_PDF';

declare interface CompanyEmailForwardContextEnumOperationFilterInput {
  eq?: InputMaybe<CompanyEmailForwardContextEnum>;
  in?: InputMaybe<Array<CompanyEmailForwardContextEnum>>;
  neq?: InputMaybe<CompanyEmailForwardContextEnum>;
  nin?: InputMaybe<Array<CompanyEmailForwardContextEnum>>;
}

declare interface CompanyEmailForwardFilterInput {
  and?: InputMaybe<Array<CompanyEmailForwardFilterInput>>;
  bCC?: InputMaybe<StringOperationFilterInput>;
  bodyFormat?: InputMaybe<StringOperationFilterInput>;
  bodyParams?: InputMaybe<StringOperationFilterInput>;
  cC?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  context?: InputMaybe<CompanyEmailForwardContextEnumOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  documentFilterSQL?: InputMaybe<StringOperationFilterInput>;
  documentItemsFilterSQL?: InputMaybe<StringOperationFilterInput>;
  documentType?: InputMaybe<DocumentTypeFilterInput>;
  documentTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  documentTypeParams?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isBodyHtml?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CompanyEmailForwardFilterInput>>;
  receivingEmail?: InputMaybe<StringOperationFilterInput>;
  titleFormat?: InputMaybe<StringOperationFilterInput>;
  titleParams?: InputMaybe<StringOperationFilterInput>;
}

declare interface CompanyFilterInput {
  accountingCompany?: InputMaybe<CompanyFilterInput>;
  accountingCompanyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  alternateMainServerPrefix?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CompanyFilterInput>>;
  aresDeploymentAresCompanyCurrentVersions?: InputMaybe<ListFilterInputTypeOfAresDeploymentAresCompanyCurrentVersionFilterInput>;
  aresDeploymentGroupCompanyMappings?: InputMaybe<ListFilterInputTypeOfAresDeploymentGroupCompanyMappingFilterInput>;
  companyDatalabReferenceLinks?: InputMaybe<ListFilterInputTypeOfCompanyDatalabReferenceLinkFilterInput>;
  companyMachineUids?: InputMaybe<ListFilterInputTypeOfCompanyMachineUidFilterInput>;
  companyMeshCentralGroupMappings?: InputMaybe<ListFilterInputTypeOfCompanyMeshCentralGroupMappingFilterInput>;
  companyRunbookNotes?: InputMaybe<ListFilterInputTypeOfCompanyRunbookNoteFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companyTeamViewerContacts?: InputMaybe<ListFilterInputTypeOfCompanyTeamViewerContactFilterInput>;
  companyTeamViewerDevices?: InputMaybe<ListFilterInputTypeOfCompanyTeamViewerDeviceFilterInput>;
  connectionSettings?: InputMaybe<StringOperationFilterInput>;
  contactCompanies?: InputMaybe<ListFilterInputTypeOfContactCompanyFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  datalabReleaseLockdownRuns?: InputMaybe<ListFilterInputTypeOfDatalabReleaseLockdownRunFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  grunfAresSyncToken?: InputMaybe<StringOperationFilterInput>;
  iBackupEventLogComputers?: InputMaybe<ListFilterInputTypeOfIBackupEventLogComputerFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  linkedCompanySettings?: InputMaybe<CompanySettingsFilterInput>;
  linkedCompanySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  myEInvoiceSettings?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notOurCustomer?: InputMaybe<BooleanOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CompanyFilterInput>>;
  pantheonAcSubject?: InputMaybe<StringOperationFilterInput>;
  pantheonBuyerType?: InputMaybe<StringOperationFilterInput>;
  pantheonBuyerTypeName?: InputMaybe<StringOperationFilterInput>;
  pantheonConnectionString?: InputMaybe<StringOperationFilterInput>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  pantheonStatus?: InputMaybe<StringOperationFilterInput>;
  pantheonSubscriber?: InputMaybe<BooleanOperationFilterInput>;
  shouldHaveIBackup?: InputMaybe<BooleanOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
}

declare interface CompanyMachineUid {
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  database?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  machineUID?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
}

declare interface CompanyMachineUidFilterInput {
  and?: InputMaybe<Array<CompanyMachineUidFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  database?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  machineUID?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CompanyMachineUidFilterInput>>;
}

declare interface CompanyMeshCentralGroupMapping {
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  meshCentralGroupId?: Maybe<Scalars['String']>;
  meshCentralGroupName?: Maybe<Scalars['String']>;
  meshCentralServerDeviceId?: Maybe<Scalars['String']>;
  meshCentralServerDeviceName?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  mssqlPort?: Maybe<Scalars['Int']>;
}

declare interface CompanyMeshCentralGroupMappingFilterInput {
  and?: InputMaybe<Array<CompanyMeshCentralGroupMappingFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lastSeenAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  meshCentralGroupId?: InputMaybe<StringOperationFilterInput>;
  meshCentralGroupName?: InputMaybe<StringOperationFilterInput>;
  meshCentralServerDeviceId?: InputMaybe<StringOperationFilterInput>;
  meshCentralServerDeviceName?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  mssqlPort?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<CompanyMeshCentralGroupMappingFilterInput>>;
}

declare interface CompanyRunbookNote {
  attachments?: Maybe<Array<Maybe<SavedFile>>>;
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uniqueClientId?: Maybe<Scalars['String']>;
}

declare interface CompanyRunbookNoteFilterInput {
  and?: InputMaybe<Array<CompanyRunbookNoteFilterInput>>;
  attachments?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  content?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CompanyRunbookNoteFilterInput>>;
  tags?: InputMaybe<StringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  uniqueClientId?: InputMaybe<StringOperationFilterInput>;
}

declare interface CompanyRunbookNoteSortInput {
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  content?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  tags?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  uniqueClientId?: InputMaybe<SortEnumType>;
}

declare interface CompanySettings {
  additionalBottomTextOnPrint?: Maybe<Scalars['String']>;
  aiSupportApiKey?: Maybe<Scalars['String']>;
  aiSupportDefaultTimeoutMinutes?: Maybe<Scalars['Int']>;
  aiSupportInvestigationModel?: Maybe<Scalars['String']>;
  aiSupportMaxInputTokensPerTurn?: Maybe<Scalars['Int']>;
  aiSupportMaxOutputTokensPerTurn?: Maybe<Scalars['Int']>;
  aiSupportMaxToolRounds?: Maybe<Scalars['Int']>;
  aiSupportReasoningEffort?: Maybe<Scalars['String']>;
  aiSupportRunBudgetMode: AiSupportRunBudgetMode;
  aiSupportTriageModel?: Maybe<Scalars['String']>;
  aiSupportVerbosity?: Maybe<Scalars['String']>;
  alternateMainServerPrefix?: Maybe<Scalars['String']>;
  applicationPackets?: Maybe<Array<Maybe<ApplicationPacket>>>;
  bookStackUrl?: Maybe<Scalars['String']>;
  client?: Maybe<ClientEnum>;
  companyDatalabReferenceLinks?: Maybe<Array<Maybe<CompanyDatalabReferenceLink>>>;
  companyDocumentsEmail?: Maybe<Scalars['String']>;
  companyEmailForwards?: Maybe<Array<Maybe<CompanyEmailForward>>>;
  companyGS1Prefix?: Maybe<Scalars['String']>;
  companyOutboundEmail?: Maybe<Scalars['String']>;
  companyOutboundEmailDisplayName?: Maybe<Scalars['String']>;
  companyOutboundEmailHost?: Maybe<Scalars['String']>;
  companyOutboundEmailPassword?: Maybe<Scalars['String']>;
  companyOutboundEmailPort: Scalars['Int'];
  companyOutboundEmailUseSSL: Scalars['Boolean'];
  companyOutboundEmailUseTLS: Scalars['Boolean'];
  companyOutboundEmailUser?: Maybe<Scalars['String']>;
  companySQLConnectionString?: Maybe<Scalars['String']>;
  companyStamp?: Maybe<Array<Scalars['Byte']>>;
  connectionName?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  culture?: Maybe<Scalars['String']>;
  datalabBaseUrl?: Maybe<Scalars['String']>;
  datalabPassword?: Maybe<Scalars['String']>;
  datalabReferenceCompanies?: Maybe<Array<Maybe<DatalabReferenceCompany>>>;
  datalabReferencePartnerQuery?: Maybe<Scalars['String']>;
  datalabReleaseLockdownRuns?: Maybe<Array<Maybe<DatalabReleaseLockdownRun>>>;
  datalabSyncEnabled: Scalars['Boolean'];
  datalabUsername?: Maybe<Scalars['String']>;
  eInvoiceIssuerVatRegistered?: Maybe<Scalars['Boolean']>;
  expenseBearers?: Maybe<Array<Maybe<ExpenseBearer>>>;
  externalId?: Maybe<Scalars['String']>;
  fiscCertContent?: Maybe<Array<Scalars['Byte']>>;
  fiscCertIssuer?: Maybe<Scalars['String']>;
  fiscCertPassword?: Maybe<Scalars['String']>;
  fiscCertPrivateKey?: Maybe<Array<Scalars['Byte']>>;
  fiscCertSerialNumber?: Maybe<Scalars['String']>;
  grunfCompanyId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isMainAresDeploymentDatabase?: Maybe<Scalars['Boolean']>;
  isMainAresTestingDatabase?: Maybe<Scalars['Boolean']>;
  meshCentralPassword?: Maybe<Scalars['String']>;
  meshCentralServerUrl?: Maybe<Scalars['String']>;
  meshCentralUsername?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  onixPhoneEInvoiceEnabled?: Maybe<Scalars['Boolean']>;
  onixPhoneProxyDBCreated: Scalars['Boolean'];
  pantheonAcCompanyPrtTextA?: Maybe<Scalars['String']>;
  pantheonAcCompanyPrtTextB?: Maybe<Scalars['String']>;
  pantheonAcQtyInCodeCont?: Maybe<Scalars['String']>;
  pantheonAlsoUseNDigitBarcodes?: Maybe<Scalars['Int']>;
  pantheonAnDocKeyLenDocType: Scalars['Int'];
  pantheonAnDocKeyLenNumber: Scalars['Int'];
  pantheonAnGenerSubjNoFieldLen?: Maybe<Scalars['Int']>;
  pantheonAnGenerSubjNoLen?: Maybe<Scalars['Int']>;
  pantheonAnPrStNo: Scalars['Int'];
  pantheonAnQtyInCodeLen: Scalars['Int'];
  pantheonCompanyAddress?: Maybe<Scalars['String']>;
  pantheonCompanyImage?: Maybe<Array<Scalars['Byte']>>;
  pantheonCompanyName?: Maybe<Scalars['String']>;
  pantheonCompanyOnixPhoneSmallImage?: Maybe<Array<Scalars['Byte']>>;
  pantheonCompanyPIN?: Maybe<Scalars['String']>;
  primaryCurrency?: Maybe<Scalars['String']>;
  supportAutoReplyOnNewTicket: Scalars['Boolean'];
  supportAutoReplyOnNewTicketBody?: Maybe<Scalars['String']>;
  supportAutoReplyOnNewTicketSubject?: Maybe<Scalars['String']>;
  supportEmailAddress?: Maybe<Scalars['String']>;
  supportEmailPassword?: Maybe<Scalars['String']>;
  supportIBackupEmailAddress?: Maybe<Scalars['String']>;
  supportIBackupEmailPassword?: Maybe<Scalars['String']>;
  supportRedirectAllToSender: Scalars['Boolean'];
  supportTickets?: Maybe<Array<Maybe<SupportTicket>>>;
  synchronizations?: Maybe<Array<Maybe<Synchronization>>>;
  teamViewerClientId?: Maybe<Scalars['String']>;
  teamViewerClientSecret?: Maybe<Scalars['String']>;
  teamViewerGroupId?: Maybe<Scalars['String']>;
  teamViewerRefreshToken?: Maybe<Scalars['String']>;
  teamViewerScriptKey?: Maybe<Scalars['String']>;
  teamViewerToken?: Maybe<Scalars['String']>;
  tenant?: Maybe<OnixTenant>;
  testingFiscalisation?: Maybe<Scalars['Boolean']>;
  timeZone?: Maybe<Scalars['String']>;
  travelKilometers?: Maybe<Array<Maybe<TravelKilometers>>>;
  useSecondaryCurrency: Scalars['Boolean'];
  users?: Maybe<Array<Maybe<ApplicationUser>>>;
  wooCommerceKey?: Maybe<Scalars['String']>;
  wooCommerceLocation?: Maybe<Scalars['String']>;
  wooCommerceSecret?: Maybe<Scalars['String']>;
  workHours?: Maybe<Array<Maybe<CompanySettingsWorkHours>>>;
  workOrderItemsAdditionalReportData?: Maybe<OnixPhoneAdditionalReportData>;
  workOrderWorkerPickerIncludesInactiveWorkers: Scalars['Boolean'];
  workRecordCostTypes?: Maybe<Array<Maybe<WorkRecordCostType>>>;
  workRecordPeriods?: Maybe<Array<Maybe<WorkRecordPeriod>>>;
}

declare interface CompanySettingsFilterInput {
  additionalBottomTextOnPrint?: InputMaybe<StringOperationFilterInput>;
  aiSupportApiKey?: InputMaybe<StringOperationFilterInput>;
  aiSupportDefaultTimeoutMinutes?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  aiSupportInvestigationModel?: InputMaybe<StringOperationFilterInput>;
  aiSupportMaxInputTokensPerTurn?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  aiSupportMaxOutputTokensPerTurn?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  aiSupportMaxToolRounds?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  aiSupportReasoningEffort?: InputMaybe<StringOperationFilterInput>;
  aiSupportRunBudgetMode?: InputMaybe<AiSupportRunBudgetModeOperationFilterInput>;
  aiSupportTriageModel?: InputMaybe<StringOperationFilterInput>;
  aiSupportVerbosity?: InputMaybe<StringOperationFilterInput>;
  alternateMainServerPrefix?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CompanySettingsFilterInput>>;
  applicationPackets?: InputMaybe<ListFilterInputTypeOfApplicationPacketFilterInput>;
  bookStackUrl?: InputMaybe<StringOperationFilterInput>;
  client?: InputMaybe<NullableOfClientEnumOperationFilterInput>;
  companyDatalabReferenceLinks?: InputMaybe<ListFilterInputTypeOfCompanyDatalabReferenceLinkFilterInput>;
  companyDocumentsEmail?: InputMaybe<StringOperationFilterInput>;
  companyEmailForwards?: InputMaybe<ListFilterInputTypeOfCompanyEmailForwardFilterInput>;
  companyGS1Prefix?: InputMaybe<StringOperationFilterInput>;
  companyOutboundEmail?: InputMaybe<StringOperationFilterInput>;
  companyOutboundEmailDisplayName?: InputMaybe<StringOperationFilterInput>;
  companyOutboundEmailHost?: InputMaybe<StringOperationFilterInput>;
  companyOutboundEmailPassword?: InputMaybe<StringOperationFilterInput>;
  companyOutboundEmailPort?: InputMaybe<ComparableInt32OperationFilterInput>;
  companyOutboundEmailUseSSL?: InputMaybe<BooleanOperationFilterInput>;
  companyOutboundEmailUseTLS?: InputMaybe<BooleanOperationFilterInput>;
  companyOutboundEmailUser?: InputMaybe<StringOperationFilterInput>;
  companySQLConnectionString?: InputMaybe<StringOperationFilterInput>;
  companyStamp?: InputMaybe<ListComparableByteOperationFilterInput>;
  connectionName?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  culture?: InputMaybe<StringOperationFilterInput>;
  datalabBaseUrl?: InputMaybe<StringOperationFilterInput>;
  datalabPassword?: InputMaybe<StringOperationFilterInput>;
  datalabReferenceCompanies?: InputMaybe<ListFilterInputTypeOfDatalabReferenceCompanyFilterInput>;
  datalabReferencePartnerQuery?: InputMaybe<StringOperationFilterInput>;
  datalabReleaseLockdownRuns?: InputMaybe<ListFilterInputTypeOfDatalabReleaseLockdownRunFilterInput>;
  datalabSyncEnabled?: InputMaybe<BooleanOperationFilterInput>;
  datalabUsername?: InputMaybe<StringOperationFilterInput>;
  eInvoiceIssuerVatRegistered?: InputMaybe<BooleanOperationFilterInput>;
  expenseBearers?: InputMaybe<ListFilterInputTypeOfExpenseBearerFilterInput>;
  externalId?: InputMaybe<StringOperationFilterInput>;
  fiscCertContent?: InputMaybe<ListComparableByteOperationFilterInput>;
  fiscCertIssuer?: InputMaybe<StringOperationFilterInput>;
  fiscCertPassword?: InputMaybe<StringOperationFilterInput>;
  fiscCertPrivateKey?: InputMaybe<ListComparableByteOperationFilterInput>;
  fiscCertSerialNumber?: InputMaybe<StringOperationFilterInput>;
  grunfCompanyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isMainAresDeploymentDatabase?: InputMaybe<BooleanOperationFilterInput>;
  isMainAresTestingDatabase?: InputMaybe<BooleanOperationFilterInput>;
  meshCentralPassword?: InputMaybe<StringOperationFilterInput>;
  meshCentralServerUrl?: InputMaybe<StringOperationFilterInput>;
  meshCentralUsername?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  onixPhoneEInvoiceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  onixPhoneProxyDBCreated?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<CompanySettingsFilterInput>>;
  pantheonAcCompanyPrtTextA?: InputMaybe<StringOperationFilterInput>;
  pantheonAcCompanyPrtTextB?: InputMaybe<StringOperationFilterInput>;
  pantheonAcQtyInCodeCont?: InputMaybe<StringOperationFilterInput>;
  pantheonAlsoUseNDigitBarcodes?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  pantheonAnDocKeyLenDocType?: InputMaybe<ComparableInt32OperationFilterInput>;
  pantheonAnDocKeyLenNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  pantheonAnGenerSubjNoFieldLen?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  pantheonAnGenerSubjNoLen?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  pantheonAnPrStNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  pantheonAnQtyInCodeLen?: InputMaybe<ComparableInt32OperationFilterInput>;
  pantheonCompanyAddress?: InputMaybe<StringOperationFilterInput>;
  pantheonCompanyImage?: InputMaybe<ListComparableByteOperationFilterInput>;
  pantheonCompanyName?: InputMaybe<StringOperationFilterInput>;
  pantheonCompanyOnixPhoneSmallImage?: InputMaybe<ListComparableByteOperationFilterInput>;
  pantheonCompanyPIN?: InputMaybe<StringOperationFilterInput>;
  primaryCurrency?: InputMaybe<StringOperationFilterInput>;
  supportAutoReplyOnNewTicket?: InputMaybe<BooleanOperationFilterInput>;
  supportAutoReplyOnNewTicketBody?: InputMaybe<StringOperationFilterInput>;
  supportAutoReplyOnNewTicketSubject?: InputMaybe<StringOperationFilterInput>;
  supportEmailAddress?: InputMaybe<StringOperationFilterInput>;
  supportEmailPassword?: InputMaybe<StringOperationFilterInput>;
  supportIBackupEmailAddress?: InputMaybe<StringOperationFilterInput>;
  supportIBackupEmailPassword?: InputMaybe<StringOperationFilterInput>;
  supportRedirectAllToSender?: InputMaybe<BooleanOperationFilterInput>;
  supportTickets?: InputMaybe<ListFilterInputTypeOfSupportTicketFilterInput>;
  synchronizations?: InputMaybe<ListFilterInputTypeOfSynchronizationFilterInput>;
  teamViewerClientId?: InputMaybe<StringOperationFilterInput>;
  teamViewerClientSecret?: InputMaybe<StringOperationFilterInput>;
  teamViewerGroupId?: InputMaybe<StringOperationFilterInput>;
  teamViewerRefreshToken?: InputMaybe<StringOperationFilterInput>;
  teamViewerScriptKey?: InputMaybe<StringOperationFilterInput>;
  teamViewerToken?: InputMaybe<StringOperationFilterInput>;
  tenant?: InputMaybe<NullableOfOnixTenantOperationFilterInput>;
  testingFiscalisation?: InputMaybe<BooleanOperationFilterInput>;
  timeZone?: InputMaybe<StringOperationFilterInput>;
  travelKilometers?: InputMaybe<ListFilterInputTypeOfTravelKilometersFilterInput>;
  useSecondaryCurrency?: InputMaybe<BooleanOperationFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  wooCommerceKey?: InputMaybe<StringOperationFilterInput>;
  wooCommerceLocation?: InputMaybe<StringOperationFilterInput>;
  wooCommerceSecret?: InputMaybe<StringOperationFilterInput>;
  workHours?: InputMaybe<ListFilterInputTypeOfCompanySettingsWorkHoursFilterInput>;
  workOrderItemsAdditionalReportData?: InputMaybe<OnixPhoneAdditionalReportDataFilterInput>;
  workOrderWorkerPickerIncludesInactiveWorkers?: InputMaybe<BooleanOperationFilterInput>;
  workRecordCostTypes?: InputMaybe<ListFilterInputTypeOfWorkRecordCostTypeFilterInput>;
  workRecordPeriods?: InputMaybe<ListFilterInputTypeOfWorkRecordPeriodFilterInput>;
}

declare interface CompanySettingsSortInput {
  additionalBottomTextOnPrint?: InputMaybe<SortEnumType>;
  aiSupportApiKey?: InputMaybe<SortEnumType>;
  aiSupportDefaultTimeoutMinutes?: InputMaybe<SortEnumType>;
  aiSupportInvestigationModel?: InputMaybe<SortEnumType>;
  aiSupportMaxInputTokensPerTurn?: InputMaybe<SortEnumType>;
  aiSupportMaxOutputTokensPerTurn?: InputMaybe<SortEnumType>;
  aiSupportMaxToolRounds?: InputMaybe<SortEnumType>;
  aiSupportReasoningEffort?: InputMaybe<SortEnumType>;
  aiSupportRunBudgetMode?: InputMaybe<SortEnumType>;
  aiSupportTriageModel?: InputMaybe<SortEnumType>;
  aiSupportVerbosity?: InputMaybe<SortEnumType>;
  alternateMainServerPrefix?: InputMaybe<SortEnumType>;
  bookStackUrl?: InputMaybe<SortEnumType>;
  client?: InputMaybe<SortEnumType>;
  companyDocumentsEmail?: InputMaybe<SortEnumType>;
  companyGS1Prefix?: InputMaybe<SortEnumType>;
  companyOutboundEmail?: InputMaybe<SortEnumType>;
  companyOutboundEmailDisplayName?: InputMaybe<SortEnumType>;
  companyOutboundEmailHost?: InputMaybe<SortEnumType>;
  companyOutboundEmailPassword?: InputMaybe<SortEnumType>;
  companyOutboundEmailPort?: InputMaybe<SortEnumType>;
  companyOutboundEmailUseSSL?: InputMaybe<SortEnumType>;
  companyOutboundEmailUseTLS?: InputMaybe<SortEnumType>;
  companyOutboundEmailUser?: InputMaybe<SortEnumType>;
  companySQLConnectionString?: InputMaybe<SortEnumType>;
  connectionName?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  culture?: InputMaybe<SortEnumType>;
  datalabBaseUrl?: InputMaybe<SortEnumType>;
  datalabPassword?: InputMaybe<SortEnumType>;
  datalabReferencePartnerQuery?: InputMaybe<SortEnumType>;
  datalabSyncEnabled?: InputMaybe<SortEnumType>;
  datalabUsername?: InputMaybe<SortEnumType>;
  eInvoiceIssuerVatRegistered?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  fiscCertIssuer?: InputMaybe<SortEnumType>;
  fiscCertPassword?: InputMaybe<SortEnumType>;
  fiscCertSerialNumber?: InputMaybe<SortEnumType>;
  grunfCompanyId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isMainAresDeploymentDatabase?: InputMaybe<SortEnumType>;
  isMainAresTestingDatabase?: InputMaybe<SortEnumType>;
  meshCentralPassword?: InputMaybe<SortEnumType>;
  meshCentralServerUrl?: InputMaybe<SortEnumType>;
  meshCentralUsername?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  onixPhoneEInvoiceEnabled?: InputMaybe<SortEnumType>;
  onixPhoneProxyDBCreated?: InputMaybe<SortEnumType>;
  pantheonAcCompanyPrtTextA?: InputMaybe<SortEnumType>;
  pantheonAcCompanyPrtTextB?: InputMaybe<SortEnumType>;
  pantheonAcQtyInCodeCont?: InputMaybe<SortEnumType>;
  pantheonAlsoUseNDigitBarcodes?: InputMaybe<SortEnumType>;
  pantheonAnDocKeyLenDocType?: InputMaybe<SortEnumType>;
  pantheonAnDocKeyLenNumber?: InputMaybe<SortEnumType>;
  pantheonAnGenerSubjNoFieldLen?: InputMaybe<SortEnumType>;
  pantheonAnGenerSubjNoLen?: InputMaybe<SortEnumType>;
  pantheonAnPrStNo?: InputMaybe<SortEnumType>;
  pantheonAnQtyInCodeLen?: InputMaybe<SortEnumType>;
  pantheonCompanyAddress?: InputMaybe<SortEnumType>;
  pantheonCompanyName?: InputMaybe<SortEnumType>;
  pantheonCompanyPIN?: InputMaybe<SortEnumType>;
  primaryCurrency?: InputMaybe<SortEnumType>;
  supportAutoReplyOnNewTicket?: InputMaybe<SortEnumType>;
  supportAutoReplyOnNewTicketBody?: InputMaybe<SortEnumType>;
  supportAutoReplyOnNewTicketSubject?: InputMaybe<SortEnumType>;
  supportEmailAddress?: InputMaybe<SortEnumType>;
  supportEmailPassword?: InputMaybe<SortEnumType>;
  supportIBackupEmailAddress?: InputMaybe<SortEnumType>;
  supportIBackupEmailPassword?: InputMaybe<SortEnumType>;
  supportRedirectAllToSender?: InputMaybe<SortEnumType>;
  teamViewerClientId?: InputMaybe<SortEnumType>;
  teamViewerClientSecret?: InputMaybe<SortEnumType>;
  teamViewerGroupId?: InputMaybe<SortEnumType>;
  teamViewerRefreshToken?: InputMaybe<SortEnumType>;
  teamViewerScriptKey?: InputMaybe<SortEnumType>;
  teamViewerToken?: InputMaybe<SortEnumType>;
  tenant?: InputMaybe<SortEnumType>;
  testingFiscalisation?: InputMaybe<SortEnumType>;
  timeZone?: InputMaybe<SortEnumType>;
  useSecondaryCurrency?: InputMaybe<SortEnumType>;
  wooCommerceKey?: InputMaybe<SortEnumType>;
  wooCommerceLocation?: InputMaybe<SortEnumType>;
  wooCommerceSecret?: InputMaybe<SortEnumType>;
  workOrderItemsAdditionalReportData?: InputMaybe<OnixPhoneAdditionalReportDataSortInput>;
  workOrderWorkerPickerIncludesInactiveWorkers?: InputMaybe<SortEnumType>;
}

declare interface CompanySettingsWorkHours {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  day: DayOfWeek;
  endTime: Scalars['TimeSpan'];
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  startTime: Scalars['TimeSpan'];
}

declare interface CompanySettingsWorkHoursFilterInput {
  and?: InputMaybe<Array<CompanySettingsWorkHoursFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  day?: InputMaybe<DayOfWeekOperationFilterInput>;
  endTime?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CompanySettingsWorkHoursFilterInput>>;
  startTime?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
}

declare interface CompanySortInput {
  accountingCompany?: InputMaybe<CompanySortInput>;
  accountingCompanyId?: InputMaybe<SortEnumType>;
  alternateMainServerPrefix?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  connectionSettings?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  grunfAresSyncToken?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  linkedCompanySettings?: InputMaybe<CompanySettingsSortInput>;
  linkedCompanySettingsId?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  myEInvoiceSettings?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notOurCustomer?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  pantheonAcSubject?: InputMaybe<SortEnumType>;
  pantheonBuyerType?: InputMaybe<SortEnumType>;
  pantheonBuyerTypeName?: InputMaybe<SortEnumType>;
  pantheonConnectionString?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  pantheonStatus?: InputMaybe<SortEnumType>;
  pantheonSubscriber?: InputMaybe<SortEnumType>;
  shouldHaveIBackup?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
}

declare interface CompanyTeamViewerContact {
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  teamViewerContactDescription?: Maybe<Scalars['String']>;
  teamViewerContactID?: Maybe<Scalars['String']>;
  teamViewerContactName?: Maybe<Scalars['String']>;
}

declare interface CompanyTeamViewerContactFilterInput {
  and?: InputMaybe<Array<CompanyTeamViewerContactFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CompanyTeamViewerContactFilterInput>>;
  teamViewerContactDescription?: InputMaybe<StringOperationFilterInput>;
  teamViewerContactID?: InputMaybe<StringOperationFilterInput>;
  teamViewerContactName?: InputMaybe<StringOperationFilterInput>;
}

declare interface CompanyTeamViewerDevice {
  alias?: Maybe<Scalars['String']>;
  assignedTo: Scalars['Boolean'];
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deviceId?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  onlineState?: Maybe<Scalars['String']>;
  remoteControlId?: Maybe<Scalars['String']>;
  teamviewerId: Scalars['Int'];
}

declare interface CompanyTeamViewerDeviceFilterInput {
  alias?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CompanyTeamViewerDeviceFilterInput>>;
  assignedTo?: InputMaybe<BooleanOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deviceId?: InputMaybe<StringOperationFilterInput>;
  groupId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  onlineState?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CompanyTeamViewerDeviceFilterInput>>;
  remoteControlId?: InputMaybe<StringOperationFilterInput>;
  teamviewerId?: InputMaybe<ComparableInt32OperationFilterInput>;
}

declare interface ComparableByteOperationFilterInput {
  eq?: InputMaybe<Scalars['Byte']>;
  gt?: InputMaybe<Scalars['Byte']>;
  gte?: InputMaybe<Scalars['Byte']>;
  in?: InputMaybe<Array<Scalars['Byte']>>;
  lt?: InputMaybe<Scalars['Byte']>;
  lte?: InputMaybe<Scalars['Byte']>;
  neq?: InputMaybe<Scalars['Byte']>;
  ngt?: InputMaybe<Scalars['Byte']>;
  ngte?: InputMaybe<Scalars['Byte']>;
  nin?: InputMaybe<Array<Scalars['Byte']>>;
  nlt?: InputMaybe<Scalars['Byte']>;
  nlte?: InputMaybe<Scalars['Byte']>;
}

declare interface ComparableDateTimeOperationFilterInput {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<Scalars['DateTime']>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
}

declare interface ComparableDecimalOperationFilterInput {
  eq?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  neq?: InputMaybe<Scalars['Decimal']>;
  ngt?: InputMaybe<Scalars['Decimal']>;
  ngte?: InputMaybe<Scalars['Decimal']>;
  nin?: InputMaybe<Array<Scalars['Decimal']>>;
  nlt?: InputMaybe<Scalars['Decimal']>;
  nlte?: InputMaybe<Scalars['Decimal']>;
}

declare interface ComparableDoubleOperationFilterInput {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  ngt?: InputMaybe<Scalars['Float']>;
  ngte?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<Scalars['Float']>>;
  nlt?: InputMaybe<Scalars['Float']>;
  nlte?: InputMaybe<Scalars['Float']>;
}

declare interface ComparableGuidOperationFilterInput {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<Scalars['UUID']>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<Scalars['UUID']>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
}

declare interface ComparableInt32OperationFilterInput {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<Scalars['Int']>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
}

declare interface ComparableInt64OperationFilterInput {
  eq?: InputMaybe<Scalars['Long']>;
  gt?: InputMaybe<Scalars['Long']>;
  gte?: InputMaybe<Scalars['Long']>;
  in?: InputMaybe<Array<Scalars['Long']>>;
  lt?: InputMaybe<Scalars['Long']>;
  lte?: InputMaybe<Scalars['Long']>;
  neq?: InputMaybe<Scalars['Long']>;
  ngt?: InputMaybe<Scalars['Long']>;
  ngte?: InputMaybe<Scalars['Long']>;
  nin?: InputMaybe<Array<Scalars['Long']>>;
  nlt?: InputMaybe<Scalars['Long']>;
  nlte?: InputMaybe<Scalars['Long']>;
}

declare interface ComparableNullableOfByteOperationFilterInput {
  eq?: InputMaybe<Scalars['Byte']>;
  gt?: InputMaybe<Scalars['Byte']>;
  gte?: InputMaybe<Scalars['Byte']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Byte']>>>;
  lt?: InputMaybe<Scalars['Byte']>;
  lte?: InputMaybe<Scalars['Byte']>;
  neq?: InputMaybe<Scalars['Byte']>;
  ngt?: InputMaybe<Scalars['Byte']>;
  ngte?: InputMaybe<Scalars['Byte']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Byte']>>>;
  nlt?: InputMaybe<Scalars['Byte']>;
  nlte?: InputMaybe<Scalars['Byte']>;
}

declare interface ComparableNullableOfDateTimeOffsetOperationFilterInput {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
}

declare interface ComparableNullableOfDateTimeOperationFilterInput {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
}

declare interface ComparableNullableOfDecimalOperationFilterInput {
  eq?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  neq?: InputMaybe<Scalars['Decimal']>;
  ngt?: InputMaybe<Scalars['Decimal']>;
  ngte?: InputMaybe<Scalars['Decimal']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  nlt?: InputMaybe<Scalars['Decimal']>;
  nlte?: InputMaybe<Scalars['Decimal']>;
}

declare interface ComparableNullableOfDoubleOperationFilterInput {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  ngt?: InputMaybe<Scalars['Float']>;
  ngte?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  nlt?: InputMaybe<Scalars['Float']>;
  nlte?: InputMaybe<Scalars['Float']>;
}

declare interface ComparableNullableOfGuidOperationFilterInput {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
}

declare interface ComparableNullableOfInt32OperationFilterInput {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
}

declare interface ComparableNullableOfInt64OperationFilterInput {
  eq?: InputMaybe<Scalars['Long']>;
  gt?: InputMaybe<Scalars['Long']>;
  gte?: InputMaybe<Scalars['Long']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  lt?: InputMaybe<Scalars['Long']>;
  lte?: InputMaybe<Scalars['Long']>;
  neq?: InputMaybe<Scalars['Long']>;
  ngt?: InputMaybe<Scalars['Long']>;
  ngte?: InputMaybe<Scalars['Long']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  nlt?: InputMaybe<Scalars['Long']>;
  nlte?: InputMaybe<Scalars['Long']>;
}

declare interface ComparableNullableOfSingleOperationFilterInput {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  ngt?: InputMaybe<Scalars['Float']>;
  ngte?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  nlt?: InputMaybe<Scalars['Float']>;
  nlte?: InputMaybe<Scalars['Float']>;
}

declare interface ComparableNullableOfTimeSpanOperationFilterInput {
  eq?: InputMaybe<Scalars['TimeSpan']>;
  gt?: InputMaybe<Scalars['TimeSpan']>;
  gte?: InputMaybe<Scalars['TimeSpan']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']>>>;
  lt?: InputMaybe<Scalars['TimeSpan']>;
  lte?: InputMaybe<Scalars['TimeSpan']>;
  neq?: InputMaybe<Scalars['TimeSpan']>;
  ngt?: InputMaybe<Scalars['TimeSpan']>;
  ngte?: InputMaybe<Scalars['TimeSpan']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']>>>;
  nlt?: InputMaybe<Scalars['TimeSpan']>;
  nlte?: InputMaybe<Scalars['TimeSpan']>;
}

declare interface ComparableTimeSpanOperationFilterInput {
  eq?: InputMaybe<Scalars['TimeSpan']>;
  gt?: InputMaybe<Scalars['TimeSpan']>;
  gte?: InputMaybe<Scalars['TimeSpan']>;
  in?: InputMaybe<Array<Scalars['TimeSpan']>>;
  lt?: InputMaybe<Scalars['TimeSpan']>;
  lte?: InputMaybe<Scalars['TimeSpan']>;
  neq?: InputMaybe<Scalars['TimeSpan']>;
  ngt?: InputMaybe<Scalars['TimeSpan']>;
  ngte?: InputMaybe<Scalars['TimeSpan']>;
  nin?: InputMaybe<Array<Scalars['TimeSpan']>>;
  nlt?: InputMaybe<Scalars['TimeSpan']>;
  nlte?: InputMaybe<Scalars['TimeSpan']>;
}

declare interface Contact {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contactCompanies?: Maybe<Array<Maybe<ContactCompany>>>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deactivated: Scalars['Boolean'];
  emails?: Maybe<Array<Maybe<ContactEmail>>>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isIBackup: Scalars['Boolean'];
  isMaintenance: Scalars['Boolean'];
  isPromotionalEmailRecipient: Scalars['Boolean'];
  isSpam: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<ContactPhone>>>;
  tickets?: Maybe<Array<Maybe<SupportTicket>>>;
}

declare interface ContactCompany {
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isPrimary: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
}

declare interface ContactCompanyFilterInput {
  and?: InputMaybe<Array<ContactCompanyFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contact?: InputMaybe<ContactFilterInput>;
  contactId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isPrimary?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ContactCompanyFilterInput>>;
}

declare interface ContactEmail {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contact?: Maybe<Contact>;
  contactId: Scalars['Int'];
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isPrimary: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  suppressNotificationEmails: Scalars['Boolean'];
}

declare interface ContactEmailFilterInput {
  and?: InputMaybe<Array<ContactEmailFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contact?: InputMaybe<ContactFilterInput>;
  contactId?: InputMaybe<ComparableInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isPrimary?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ContactEmailFilterInput>>;
  suppressNotificationEmails?: InputMaybe<BooleanOperationFilterInput>;
}

declare interface ContactEmailSortInput {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  contact?: InputMaybe<ContactSortInput>;
  contactId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isPrimary?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  suppressNotificationEmails?: InputMaybe<SortEnumType>;
}

declare interface ContactFilterInput {
  and?: InputMaybe<Array<ContactFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contactCompanies?: InputMaybe<ListFilterInputTypeOfContactCompanyFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deactivated?: InputMaybe<BooleanOperationFilterInput>;
  emails?: InputMaybe<ListFilterInputTypeOfContactEmailFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isIBackup?: InputMaybe<BooleanOperationFilterInput>;
  isMaintenance?: InputMaybe<BooleanOperationFilterInput>;
  isPromotionalEmailRecipient?: InputMaybe<BooleanOperationFilterInput>;
  isSpam?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContactFilterInput>>;
  phoneNumbers?: InputMaybe<ListFilterInputTypeOfContactPhoneFilterInput>;
  tickets?: InputMaybe<ListFilterInputTypeOfSupportTicketFilterInput>;
}

declare interface ContactPhone {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  phoneNumber?: Maybe<Scalars['String']>;
}

declare interface ContactPhoneFilterInput {
  and?: InputMaybe<Array<ContactPhoneFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contact?: InputMaybe<ContactFilterInput>;
  contactId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ContactPhoneFilterInput>>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
}

declare interface ContactSortInput {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  deactivated?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isIBackup?: InputMaybe<SortEnumType>;
  isMaintenance?: InputMaybe<SortEnumType>;
  isPromotionalEmailRecipient?: InputMaybe<SortEnumType>;
  isSpam?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
}

declare interface Country {
  code?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  pantheonId?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
}

declare interface CountryFilterInput {
  and?: InputMaybe<Array<CountryFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CountryFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
}

declare interface CountrySortInput {
  code?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
}

declare interface CreateGenericDocumentDtoInput {
  adDate?: InputMaybe<Scalars['DateTime']>;
  adDateDue?: InputMaybe<Scalars['DateTime']>;
  additionalEntryFields?: InputMaybe<Scalars['String']>;
  additionalFields?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  deliveryDeadlineDays?: InputMaybe<Scalars['Int']>;
  documentDate?: InputMaybe<Scalars['DateTime']>;
  documentPair?: InputMaybe<Scalars['Int']>;
  documentType: Scalars['Int'];
  eInvoiceContractVersion?: InputMaybe<Scalars['Int']>;
  expectedEInvoiceRoute?: InputMaybe<EInvoiceRoute>;
  fiscalBaseAmount?: InputMaybe<Scalars['Decimal']>;
  fiscalInternalNumber?: InputMaybe<Scalars['String']>;
  fiscalSequenceNumber?: InputMaybe<Scalars['Int']>;
  fiscalTotal?: InputMaybe<Scalars['Decimal']>;
  fiscalYear?: InputMaybe<Scalars['Int']>;
  items?: InputMaybe<Array<InputMaybe<CreateGenericDocumentItemDtoInput>>>;
  note?: InputMaybe<Scalars['String']>;
  originApplicationUserId?: InputMaybe<Scalars['String']>;
  originCompanySettingsId?: InputMaybe<Scalars['Int']>;
  originalDocument2Date?: InputMaybe<Scalars['DateTime']>;
  originalDocument2Number?: InputMaybe<Scalars['String']>;
  originalDocumentDate?: InputMaybe<Scalars['DateTime']>;
  originalDocumentNumber?: InputMaybe<Scalars['String']>;
  pantheonAcDelivery?: InputMaybe<Scalars['String']>;
  pantheonAcPayMethod?: InputMaybe<Scalars['String']>;
  pantheonAcWarehouse?: InputMaybe<Scalars['String']>;
  pantheonPayerAcSubject?: InputMaybe<Scalars['String']>;
  pantheonReceiverAcSubject?: InputMaybe<Scalars['String']>;
  pantheonReceivingAcWarehouse?: InputMaybe<Scalars['String']>;
  paymentProviderResponse?: InputMaybe<Scalars['String']>;
  printTime?: InputMaybe<Scalars['DateTime']>;
  signature?: InputMaybe<Array<Scalars['Byte']>>;
  uID?: InputMaybe<Scalars['String']>;
  zKI?: InputMaybe<Scalars['String']>;
}

declare interface CreateGenericDocumentFromAnotherDtoInput {
  adDate?: InputMaybe<Scalars['DateTime']>;
  adDateDue?: InputMaybe<Scalars['DateTime']>;
  additionalEntryFields?: InputMaybe<Scalars['String']>;
  additionalFields?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  deliveryDeadlineDays?: InputMaybe<Scalars['Int']>;
  documentDate?: InputMaybe<Scalars['DateTime']>;
  documentPair?: InputMaybe<Scalars['Int']>;
  documentType: Scalars['Int'];
  eInvoiceContractVersion?: InputMaybe<Scalars['Int']>;
  expectedEInvoiceRoute?: InputMaybe<EInvoiceRoute>;
  fiscalBaseAmount?: InputMaybe<Scalars['Decimal']>;
  fiscalInternalNumber?: InputMaybe<Scalars['String']>;
  fiscalSequenceNumber?: InputMaybe<Scalars['Int']>;
  fiscalTotal?: InputMaybe<Scalars['Decimal']>;
  fiscalYear?: InputMaybe<Scalars['Int']>;
  items?: InputMaybe<Array<InputMaybe<CreateGenericDocumentFromAnotherItemDtoInput>>>;
  note?: InputMaybe<Scalars['String']>;
  originApplicationUserId?: InputMaybe<Scalars['String']>;
  originCompanySettingsId?: InputMaybe<Scalars['Int']>;
  originPantheonAcKey?: InputMaybe<Scalars['String']>;
  originPantheonAcKeyList?: InputMaybe<Array<Scalars['String']>>;
  originalDocument2Date?: InputMaybe<Scalars['DateTime']>;
  originalDocument2Number?: InputMaybe<Scalars['String']>;
  originalDocumentDate?: InputMaybe<Scalars['DateTime']>;
  originalDocumentNumber?: InputMaybe<Scalars['String']>;
  pantheonAcDelivery?: InputMaybe<Scalars['String']>;
  pantheonAcPayMethod?: InputMaybe<Scalars['String']>;
  pantheonAcWarehouse?: InputMaybe<Scalars['String']>;
  pantheonPayerAcSubject?: InputMaybe<Scalars['String']>;
  pantheonReceiverAcSubject?: InputMaybe<Scalars['String']>;
  pantheonReceivingAcWarehouse?: InputMaybe<Scalars['String']>;
  paymentProviderResponse?: InputMaybe<Scalars['String']>;
  printTime?: InputMaybe<Scalars['DateTime']>;
  signature?: InputMaybe<Array<Scalars['Byte']>>;
  uID?: InputMaybe<Scalars['String']>;
  updateExisting?: InputMaybe<Scalars['Boolean']>;
  zKI?: InputMaybe<Scalars['String']>;
}

declare interface CreateGenericDocumentFromAnotherItemDtoInput {
  note?: InputMaybe<Scalars['String']>;
  originPantheonAnNo: Scalars['Int'];
  originPantheonDetails?: InputMaybe<Array<OriginPantheonItemDetailsInput>>;
  packQuantity: Scalars['Float'];
  pantheonAcIdent?: InputMaybe<Scalars['String']>;
  price: Scalars['Decimal'];
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
  scans?: InputMaybe<Array<CreateGenericDocumentItemDtoScanDtoInput>>;
  serialNumber?: InputMaybe<Scalars['String']>;
  serialNumbers?: InputMaybe<Array<InputMaybe<CreateGenericDocumentItemDtoSerialDtoInput>>>;
}

declare interface CreateGenericDocumentItemDtoInput {
  note?: InputMaybe<Scalars['String']>;
  packQuantity: Scalars['Float'];
  pantheonAcIdent?: InputMaybe<Scalars['String']>;
  price: Scalars['Decimal'];
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
  scans?: InputMaybe<Array<CreateGenericDocumentItemDtoScanDtoInput>>;
  serialNumber?: InputMaybe<Scalars['String']>;
  serialNumbers?: InputMaybe<Array<InputMaybe<CreateGenericDocumentItemDtoSerialDtoInput>>>;
}

declare interface CreateGenericDocumentItemDtoScanDtoInput {
  fullScanContent?: InputMaybe<Scalars['String']>;
  scanContent: Scalars['String'];
  scanDate: Scalars['DateTime'];
}

declare interface CreateGenericDocumentItemDtoSerialDtoInput {
  dateDue: Scalars['DateTime'];
  pallet?: InputMaybe<CreateGenericDocumentItemDtoSerialDtoPalletDtoInput>;
  quantity: Scalars['Decimal'];
  relatedSSCC?: InputMaybe<Scalars['String']>;
  serialNumber: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
}

declare interface CreateGenericDocumentItemDtoSerialDtoPalletDtoInput {
  acRegion?: InputMaybe<Scalars['String']>;
  acSubject?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  sSCCCode?: InputMaybe<Scalars['String']>;
  shortCode: Scalars['String'];
  userId?: InputMaybe<Scalars['Int']>;
}

declare interface CreateMcpApiKeyDtoInput {
  expiresInDays?: InputMaybe<Scalars['Int']>;
  kind: McpApiKeyKind;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

declare interface CreatePortalServiceKeyDtoInput {
  companySettingsId?: InputMaybe<Scalars['Int']>;
  expiresInDays?: InputMaybe<Scalars['Int']>;
  kind: PortalServiceKeyKind;
  name?: InputMaybe<Scalars['String']>;
}

declare interface CreatedMcpApiKeyDto {
  apiKey?: Maybe<McpApiKeyDto>;
  key?: Maybe<Scalars['String']>;
}

declare interface CreatedPortalServiceKeyDto {
  key?: Maybe<Scalars['String']>;
  serviceKey?: Maybe<PortalServiceKeyDto>;
}

declare interface Currency {
  code?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  longName?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  pantheonId?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
  unit: Scalars['Int'];
}

declare interface CurrencyFilterInput {
  and?: InputMaybe<Array<CurrencyFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  longName?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CurrencyFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  unit?: InputMaybe<ComparableInt32OperationFilterInput>;
}

declare interface CurrencySortInput {
  code?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  longName?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
  unit?: InputMaybe<SortEnumType>;
}

declare interface DailyRecapDto {
  acKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  fromDate?: Maybe<Scalars['DateTime']>;
  fromDoc?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<DailyRecapDtoItemDto>>>;
  toDate?: Maybe<Scalars['DateTime']>;
  toDoc?: Maybe<Scalars['String']>;
}

declare interface DailyRecapDtoItemDto {
  paid: Scalars['Decimal'];
  paymentType?: Maybe<Scalars['String']>;
}

declare interface DatalabReferenceCompany {
  companyDatalabReferenceLinks?: Maybe<Array<Maybe<CompanyDatalabReferenceLink>>>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  detailUrl?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  firstSyncedAt: Scalars['DateTime'];
  id: Scalars['Int'];
  lastSyncedAt: Scalars['DateTime'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  normalizedName?: Maybe<Scalars['String']>;
  remoteKey?: Maybe<Scalars['String']>;
}

declare interface DatalabReferenceCompanyFilterInput {
  and?: InputMaybe<Array<DatalabReferenceCompanyFilterInput>>;
  companyDatalabReferenceLinks?: InputMaybe<ListFilterInputTypeOfCompanyDatalabReferenceLinkFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  detailUrl?: InputMaybe<StringOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  firstSyncedAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lastSyncedAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DatalabReferenceCompanyFilterInput>>;
  remoteKey?: InputMaybe<StringOperationFilterInput>;
}

declare interface DatalabReleaseLockdownRun {
  company: Company;
  companyDatalabReferenceLink?: Maybe<CompanyDatalabReferenceLink>;
  companyDatalabReferenceLinkId?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  completedOn?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deletedEntryCount: Scalars['Int'];
  errorText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  jobId?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  processedPopupCount: Scalars['Int'];
  saveTriggered: Scalars['Boolean'];
  startedOn?: Maybe<Scalars['DateTime']>;
  status: DatalabReleaseLockdownRunStatusEnum;
  summaryLog?: Maybe<Scalars['String']>;
  triggeredById?: Maybe<Scalars['String']>;
}

declare interface DatalabReleaseLockdownRunFilterInput {
  and?: InputMaybe<Array<DatalabReleaseLockdownRunFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyDatalabReferenceLink?: InputMaybe<CompanyDatalabReferenceLinkFilterInput>;
  companyDatalabReferenceLinkId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  completedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deletedEntryCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  errorText?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  jobId?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<DatalabReleaseLockdownRunFilterInput>>;
  processedPopupCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  saveTriggered?: InputMaybe<BooleanOperationFilterInput>;
  startedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  status?: InputMaybe<DatalabReleaseLockdownRunStatusEnumOperationFilterInput>;
  summaryLog?: InputMaybe<StringOperationFilterInput>;
  triggeredById?: InputMaybe<StringOperationFilterInput>;
}

declare type DatalabReleaseLockdownRunStatusEnum =
  | 'FAILED'
  | 'QUEUED'
  | 'RUNNING'
  | 'SUCCEEDED';

declare interface DatalabReleaseLockdownRunStatusEnumOperationFilterInput {
  eq?: InputMaybe<DatalabReleaseLockdownRunStatusEnum>;
  in?: InputMaybe<Array<DatalabReleaseLockdownRunStatusEnum>>;
  neq?: InputMaybe<DatalabReleaseLockdownRunStatusEnum>;
  nin?: InputMaybe<Array<DatalabReleaseLockdownRunStatusEnum>>;
}

declare type DateFilterType =
  | 'CUSTOM_RANGE'
  | 'LAST_MONTH'
  | 'THIS_MONTH'
  | 'THIS_WEEK'
  | 'TODAY'
  | 'UNTIL_TODAY'
  | 'YESTERDAY';

declare type DayOfWeek =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

declare interface DayOfWeekOperationFilterInput {
  eq?: InputMaybe<DayOfWeek>;
  in?: InputMaybe<Array<DayOfWeek>>;
  neq?: InputMaybe<DayOfWeek>;
  nin?: InputMaybe<Array<DayOfWeek>>;
}

declare interface DbFile {
  acKey?: Maybe<Scalars['String']>;
  content?: Maybe<Array<Scalars['Byte']>>;
  fileCategory?: Maybe<Scalars['String']>;
  fileId: Scalars['Int'];
  fileName?: Maybe<Scalars['String']>;
}

declare interface Department {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  items?: Maybe<Array<Maybe<Item>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
}

declare interface DepartmentFilterInput {
  and?: InputMaybe<Array<DepartmentFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfItemFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DepartmentFilterInput>>;
}

declare interface DepartmentSortInput {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
}

declare type DeploymentGroupStepTriggerType =
  | 'ON_INSTALL';

declare interface DictionaryOfStringAndStringFilterInput {
  and?: InputMaybe<Array<DictionaryOfStringAndStringFilterInput>>;
  capacity?: InputMaybe<ComparableInt32OperationFilterInput>;
  comparer?: InputMaybe<IEqualityComparerOfStringFilterInput>;
  count?: InputMaybe<ComparableInt32OperationFilterInput>;
  keys?: InputMaybe<ListStringOperationFilterInput>;
  or?: InputMaybe<Array<DictionaryOfStringAndStringFilterInput>>;
  values?: InputMaybe<ListStringOperationFilterInput>;
}

declare interface DmsRights {
  classify: Scalars['Boolean'];
  confirm: Scalars['Boolean'];
  createDocument: Scalars['Boolean'];
  deleteDocument: Scalars['Boolean'];
  editMetadata: Scalars['Boolean'];
  editNote: Scalars['Boolean'];
  mapXmlItems: Scalars['Boolean'];
  ownFilesOnly: Scalars['Boolean'];
  pullEInvoices: Scalars['Boolean'];
  read: Scalars['Boolean'];
  removeFile: Scalars['Boolean'];
  replaceFile: Scalars['Boolean'];
  uploadFile: Scalars['Boolean'];
}

declare type DocumentDraftKind =
  | 'MOVE'
  | 'ORDER';

declare type DocumentDraftOrigin =
  | 'ONIX_PHONE'
  | 'WEB';

declare type DocumentDraftPriceSource =
  | 'CONTRACT'
  | 'MANUAL'
  | 'PANTHEON';

declare type DocumentDraftStatus =
  | 'DISCARDED'
  | 'ISSUED'
  | 'ISSUING'
  | 'NOT_ISSUED'
  | 'OPEN';

declare type DocumentEmailDispatchStatus =
  | 'FAILED'
  | 'QUEUED'
  | 'SENDING'
  | 'SENT'
  | 'UNCERTAIN';

declare type DocumentFunctionalityEnum =
  | 'APPROVALS'
  | 'BASE_WORK_ORDERS'
  | 'DELIVERY_NOTES'
  | 'DELIVERY_NOTES_CONTROL'
  | 'DELIVERY_NOTES_FROM_ORDER'
  | 'DETACHED_OFFLINE_DOCUMENTS'
  | 'FIS_BARCODE_SCANNING'
  | 'FIXED_ASSETS'
  | 'INVENTORY'
  | 'INVOICES'
  | 'INVOICE_DELIVERY_NOTES'
  | 'LUR_INVOICE'
  | 'MARSERVIS_USER_WORK_ORDERS'
  | 'ORDERS'
  | 'PRICE_CHANGE_RECORDS'
  | 'TMN_DOCUMENTS_CLASSIFICATION_QUEUE'
  | 'TMN_DOCUMENTS_DIRECT'
  | 'TMN_DOCUMENTS_WEB'
  | 'TRANSFER'
  | 'WAREHOUSE_RECEIPT'
  | 'WOEX'
  | 'WORK_FLOW_TASKS'
  | 'WORK_ORDERS_OPERATIVE'
  | 'WORK_ORDERS_RECEPTION';

declare interface DocumentFunctionalityEnumOperationFilterInput {
  eq?: InputMaybe<DocumentFunctionalityEnum>;
  in?: InputMaybe<Array<DocumentFunctionalityEnum>>;
  neq?: InputMaybe<DocumentFunctionalityEnum>;
  nin?: InputMaybe<Array<DocumentFunctionalityEnum>>;
}

declare type DocumentPairFunctionalityEnum =
  | 'COPY'
  | 'PICKING';

declare interface DocumentPairFunctionalityEnumOperationFilterInput {
  eq?: InputMaybe<DocumentPairFunctionalityEnum>;
  in?: InputMaybe<Array<DocumentPairFunctionalityEnum>>;
  neq?: InputMaybe<DocumentPairFunctionalityEnum>;
  nin?: InputMaybe<Array<DocumentPairFunctionalityEnum>>;
}

declare type DocumentRelationKind =
  | 'MODIFY'
  | 'NONE'
  | 'REPEAT'
  | 'STORNO';

declare interface DocumentType {
  acDocsOrderingOnPDF?: Maybe<Scalars['String']>;
  acFieldSFLabel?: Maybe<Scalars['String']>;
  acFiscalDevice?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerName?: Maybe<Scalars['String']>;
  acLinkDocName1?: Maybe<Scalars['String']>;
  acLinkDocName2?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acName3?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverName?: Maybe<Scalars['String']>;
  acSetOfsWhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  acStatusIn?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acWorkPlace?: Maybe<Scalars['String']>;
  acceptedByFieldOnPrint?: Maybe<Scalars['String']>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: Maybe<Scalars['Boolean']>;
  adDateDoc1EntryIsTimeOnly?: Maybe<Scalars['Boolean']>;
  adDateDoc1PDFLabel?: Maybe<Scalars['String']>;
  adDateDoc2EntryIsTimeOnly?: Maybe<Scalars['Boolean']>;
  adDateDoc2PDFLabel?: Maybe<Scalars['String']>;
  addingItemWarnIfQuantityMoreThanAvailable: Scalars['Boolean'];
  adminAllowChangingItemPrice: Scalars['Boolean'];
  adminCanEditDocumentAfterSaving: Scalars['Boolean'];
  adminDefaultAcPriceRate?: Maybe<Scalars['String']>;
  adminDeleteItemsAfterDocumentIsSaved: Scalars['Boolean'];
  adminDocumentOnCreateMakeWarehouseReservation: Scalars['Boolean'];
  adminEmphasizeInStock: Scalars['Boolean'];
  adminForceAcPriceRate?: Maybe<Scalars['String']>;
  adminIgnoreRebate1: Scalars['Boolean'];
  adminIgnoreRebate2: Scalars['Boolean'];
  adminIgnoreRebate3: Scalars['Boolean'];
  adminItemQuantityMustBeInStock: Scalars['Boolean'];
  adminSavedRebatesForFinalRebate: Scalars['Boolean'];
  adminSendDocumentToCompanyDocumentEmail: Scalars['Boolean'];
  adminSerialNumbersAreNotAutomated?: Maybe<Scalars['Boolean']>;
  adminShowDailyIncome: Scalars['Boolean'];
  adminShowSubjectAdd: Scalars['Boolean'];
  adminUseAnWsPrice: Scalars['Boolean'];
  adminUseGenericDocumentsForMoveAndOrder: Scalars['Boolean'];
  adminUseSerialNumberForItems: Scalars['Boolean'];
  allowChangingWarehouse?: Maybe<Scalars['Boolean']>;
  allowDMSCRUDOnlyForUsersFiles?: Maybe<Scalars['Boolean']>;
  allowDMSConfirmation?: Maybe<Scalars['Boolean']>;
  allowDMSReclassification?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemArticlePicking?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemCostBearerPicking?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemDepartmentPicking?: Maybe<Scalars['Boolean']>;
  allowGenericDocumentTypeImageAttachments?: Maybe<Scalars['Boolean']>;
  allowManualVerifyFromDocumentOverview?: Maybe<Scalars['Boolean']>;
  allowModifyExistingDocuments: Scalars['Boolean'];
  allowPullingDMSEInvoicesFromService?: Maybe<Scalars['Boolean']>;
  allowSavingGeodecodedLocation?: Maybe<Scalars['Boolean']>;
  allowSelectingMultipleDocumentsToCreateFrom?: Maybe<Scalars['Boolean']>;
  allowSigningAfterDocumentIsSaved?: Maybe<Scalars['Boolean']>;
  alwaysShowTheseAcSetOfItem?: Maybe<Scalars['String']>;
  alwaysUpdatePriceAndRebateFromClient?: Maybe<Scalars['Boolean']>;
  appendToItemIfExists?: Maybe<Scalars['Boolean']>;
  arbitraryField1Label?: Maybe<Scalars['String']>;
  arbitraryField1Location?: Maybe<Scalars['String']>;
  arbitraryField1Value?: Maybe<Scalars['String']>;
  arbitraryFields: Array<DocumentTypeArbitraryField>;
  articleDontShowPriceAnyWhere: Scalars['Boolean'];
  articleDontShowStockAnyWhere: Scalars['Boolean'];
  articleSearchAllowSearchingByClassification: Scalars['Boolean'];
  articleSearchInitiallyLoadAll: Scalars['Boolean'];
  articleSearchRepeatLastSearch: Scalars['Boolean'];
  articleSearchShowOnlyInStock: Scalars['Boolean'];
  articleSearchShowOnlyWhereAcClassifIsIn?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsAIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsBIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsCIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsDIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsEIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsFIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsGIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsHIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsIIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsJIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAdFielddAIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddBIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddCIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddDIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAnFieldnAIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnBIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnCIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnDIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnEIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnFIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnGIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnHIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnIIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnJIs?: Maybe<Scalars['Decimal']>;
  bluetoothPrintCopiesNumber: Scalars['Int'];
  cacheDuration: Scalars['Int'];
  cacheUseCacheForAnyResource: Scalars['Boolean'];
  cacheUseForArticleSearch: Scalars['Boolean'];
  cacheUseForCustomerSearch: Scalars['Boolean'];
  cacheUseForWarehouseSearch: Scalars['Boolean'];
  cardPaymentProvider?: Maybe<CardPaymentProvider>;
  changeDocumentStatusAfterCreated?: Maybe<Scalars['String']>;
  changeSourceDocumentStatusTo?: Maybe<Scalars['String']>;
  classifs2WhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  classifsWhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  clerkFieldOnPrint?: Maybe<Scalars['String']>;
  companyEmailDefaultEmail?: Maybe<Scalars['String']>;
  companyEmailForwards?: Maybe<Array<Maybe<CompanyEmailForward>>>;
  companyEmailPDFBCC?: Maybe<Scalars['String']>;
  companyEmailPDFCC?: Maybe<Scalars['String']>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: Maybe<Scalars['Boolean']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  completeDeliveryStatus?: Maybe<Scalars['String']>;
  copyOnlyLeftOverQuantity?: Maybe<Scalars['Boolean']>;
  copyOnlyThoseWithLeftOverQuantity0?: Maybe<Scalars['Boolean']>;
  copyingFromAnotherIsAShadowCopy?: Maybe<Scalars['Boolean']>;
  create: Scalars['Boolean'];
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  customContractPriceFilter?: Maybe<Scalars['Boolean']>;
  customerCodeAllowedKeys?: Maybe<Scalars['String']>;
  customerCodeFromAcSkis?: Maybe<Scalars['Boolean']>;
  customerCodeIsGenerated?: Maybe<Scalars['Boolean']>;
  dMSListFilterOnDefaultClassification?: Maybe<Scalars['Boolean']>;
  dateFilterType?: Maybe<DateFilterType>;
  defaultCustomerType?: Maybe<Scalars['String']>;
  defaultCustomerTypeFilter?: Maybe<Scalars['String']>;
  defaultMoveDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultMoveDocumentSortField?: Maybe<THeMovePagedSortField>;
  defaultOrderDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultOrderDocumentSortField?: Maybe<THeOrderPagedSortField>;
  defaultPaymentMethod?: Maybe<Scalars['String']>;
  defaultQuantity?: Maybe<Scalars['Decimal']>;
  defaultSubjectDaysForPaymentOnAdd?: Maybe<Scalars['Int']>;
  defaultSubjectPaymentMethodOnAdd?: Maybe<Scalars['String']>;
  defaultToThisCustomer?: Maybe<Scalars['String']>;
  defaultWoexDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultWoexDocumentSortField?: Maybe<THfWoexPagedSortField>;
  delete: Scalars['Boolean'];
  deliveryIsRequired?: Maybe<Scalars['Boolean']>;
  disableUsingShadowItemAsItemBase?: Maybe<Scalars['Boolean']>;
  disallowChangingCustomer: Scalars['Boolean'];
  disallowChangingItemQuantityOnSerialInput?: Maybe<Scalars['Boolean']>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: Maybe<Scalars['Boolean']>;
  disallowManualWarehouseSearch?: Maybe<Scalars['Boolean']>;
  disallowPickingCustomer: Scalars['Boolean'];
  dmsAcStatusIn?: Maybe<Scalars['String']>;
  doNotFilterDailyRecapByUserId?: Maybe<Scalars['Boolean']>;
  documentLinkType?: Maybe<Scalars['String']>;
  documentLinkTypeA?: Maybe<Scalars['String']>;
  documentLinkTypeB?: Maybe<Scalars['String']>;
  documentNote?: Maybe<Scalars['String']>;
  documentOnCreateMakeA4Print?: Maybe<Scalars['Boolean']>;
  documentOnCreateMakeBluetoothPrint: Scalars['Boolean'];
  documentOnCreateMakePDF: Scalars['Boolean'];
  documentTopAdditionalText?: Maybe<Scalars['String']>;
  dontSaveIndividualPDFPages?: Maybe<Scalars['Boolean']>;
  existingInventoryCheckDays?: Maybe<Scalars['Int']>;
  fillReferentLineWithUserOnPrint?: Maybe<Scalars['Boolean']>;
  filterByAcDelivery: Scalars['Boolean'];
  filterByAcDept?: Maybe<Scalars['String']>;
  filterByAcDeptOut?: Maybe<Scalars['String']>;
  filterByAcType?: Maybe<Scalars['String']>;
  filterByAcVerifiedPrices?: Maybe<Scalars['String']>;
  filterByAcVerifyStatus?: Maybe<Scalars['String']>;
  filterByCurrentUserIdIsAnSigner1?: Maybe<Scalars['Boolean']>;
  filterMovesByThisAcIssuer?: Maybe<Scalars['String']>;
  filterMovesByThisAcReceiver?: Maybe<Scalars['String']>;
  filterOrdersByThisAcWarehouse?: Maybe<Scalars['String']>;
  filterReceiversByAcFieldSa?: Maybe<Scalars['String']>;
  fiscalizationQueueEntry?: Maybe<Array<Maybe<FiscalizationQueueEntry>>>;
  forceShowAvailableOnStock: Scalars['Boolean'];
  fromPairs?: Maybe<Array<Maybe<DocumentTypePair>>>;
  functionality: DocumentFunctionalityEnum;
  generatePrintTimeOnCreate: Scalars['Boolean'];
  groupAllCreatingDocumentTypesAtThisPoint: Scalars['Boolean'];
  groupAllDocumentTypesAtThisPoint: Scalars['Boolean'];
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated: Scalars['Boolean'];
  headerClerkPDFLabel?: Maybe<Scalars['String']>;
  hideAcceptedByFieldOnPrint?: Maybe<Scalars['Boolean']>;
  hideClerkFieldOnPrint?: Maybe<Scalars['Boolean']>;
  hideCurrencyDateOnPrint?: Maybe<Scalars['Boolean']>;
  hideDMSMetadataEntryFields?: Maybe<Scalars['Boolean']>;
  hideDataForPaymentOnPrint?: Maybe<Scalars['Boolean']>;
  hideDocumentElements?: Maybe<Scalars['String']>;
  hideDocumentItemElements?: Maybe<Scalars['String']>;
  hideLeftOverQuantityOnPicking?: Maybe<Scalars['Boolean']>;
  hideNoteInNonHistoricalView?: Maybe<Scalars['Boolean']>;
  hidePayMethodOnPrint?: Maybe<Scalars['Boolean']>;
  hideQuantityEntry?: Maybe<Scalars['Boolean']>;
  hideVATRecapitulationOnPrint?: Maybe<Scalars['Boolean']>;
  hideWarehouseItemActions?: Maybe<Scalars['Boolean']>;
  hideWarehouseOverview?: Maybe<Scalars['Boolean']>;
  hideWarehouseSupplier?: Maybe<Scalars['Boolean']>;
  hideWorkOrderImages?: Maybe<Scalars['Boolean']>;
  hideWorkOrderMaterials?: Maybe<Scalars['Boolean']>;
  hideWorkOrderPlaceFromTo?: Maybe<Scalars['Boolean']>;
  hideWorkOrderReception?: Maybe<Scalars['Boolean']>;
  hideWorkOrderReclamations?: Maybe<Scalars['Boolean']>;
  hideWorkOrderServices?: Maybe<Scalars['Boolean']>;
  hideWorkOrderSpecications?: Maybe<Scalars['Boolean']>;
  highlightArticlePickerTextOnNextOpen?: Maybe<Scalars['Boolean']>;
  historyViewIgnoredFilters?: Maybe<Scalars['String']>;
  horizontalDoc12AndDates?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  ifAcPayMethodChooseThisDocumentType?: Maybe<Scalars['String']>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: Maybe<Scalars['Boolean']>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: Maybe<Scalars['Boolean']>;
  ignoreQuantityInWholeDocument?: Maybe<Scalars['Boolean']>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: Maybe<Scalars['Boolean']>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: Maybe<Scalars['Boolean']>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isRetail?: Maybe<Scalars['Boolean']>;
  itemListShowDetailed: Scalars['Boolean'];
  jumpToEditAfterScanningItemWithBarcode: Scalars['Boolean'];
  keepAdDateDoc1And2Unrounded?: Maybe<Scalars['Boolean']>;
  labelDefinitionLocations: Array<LabelDefinitionLocation>;
  linkFrom?: Maybe<Array<Maybe<DocumentTypeLink>>>;
  linkTo?: Maybe<Array<Maybe<DocumentTypeLink>>>;
  makeDocumentLinks?: Maybe<Scalars['Boolean']>;
  makeSerialStockCheck?: Maybe<Scalars['Boolean']>;
  manualWorkOrderMaterial?: Maybe<Scalars['String']>;
  middleSignatureTextOnPrint?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  modifierCharacterLabel?: Maybe<Scalars['String']>;
  multipleEndDocumentsCaseToPickEndDocument?: Maybe<Scalars['String']>;
  mustFiscalize?: Maybe<Scalars['Boolean']>;
  newNewDocumentInputType?: Maybe<Scalars['Boolean']>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: Maybe<Scalars['Boolean']>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: Maybe<Scalars['Boolean']>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: Maybe<Scalars['Boolean']>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: Maybe<Scalars['Boolean']>;
  palletEntry?: Maybe<Scalars['Boolean']>;
  pantheonDirection: PantheonDocumentDirectionEnum;
  pantheonTable: PantheonDocumentTable;
  partialDeliveryStatus?: Maybe<Scalars['String']>;
  pdfSignWithoutGeneration?: Maybe<Scalars['Boolean']>;
  pickingShowConfirmationOnPick: Scalars['Boolean'];
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: Maybe<Scalars['Boolean']>;
  printDocumentTitleOverride?: Maybe<Scalars['String']>;
  printTicketNameOverride?: Maybe<Scalars['String']>;
  prioritisePackageQuantityEntryField?: Maybe<Scalars['Boolean']>;
  quantityDecimalPlaces: Scalars['Int'];
  read: Scalars['Boolean'];
  recommendToMakeCodebooksOffline?: Maybe<Scalars['Boolean']>;
  requireASignature: Scalars['Boolean'];
  reverseItemsList?: Maybe<Scalars['Boolean']>;
  saveUnsignedAsSignedPDF?: Maybe<Scalars['Boolean']>;
  sendB2BAsEInvoice?: Maybe<Scalars['Boolean']>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: Maybe<Scalars['Boolean']>;
  sendLeftoverShadowsWithZero?: Maybe<Scalars['Boolean']>;
  serialNumberDirectionIsInput?: Maybe<Scalars['Boolean']>;
  showAcDeliveryMobileFilterOnDocumentList: Scalars['Boolean'];
  showAcDeliveryOnDocumentList: Scalars['Boolean'];
  showAcDeptMobileFilterOnDocumentList: Scalars['Boolean'];
  showAcDescrOnPDFs?: Maybe<Scalars['Boolean']>;
  showAcDoc1?: Maybe<Scalars['Boolean']>;
  showAcDoc1OnPrint?: Maybe<Scalars['Boolean']>;
  showAcDoc2?: Maybe<Scalars['Boolean']>;
  showAcDoc2OnPrint?: Maybe<Scalars['Boolean']>;
  showAcIdentOnPrint?: Maybe<Scalars['Boolean']>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: Maybe<Scalars['String']>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: Maybe<Scalars['String']>;
  showAdDate?: Maybe<Scalars['Boolean']>;
  showAdDateDoc1?: Maybe<Scalars['Boolean']>;
  showAdDateDoc1OnPrint?: Maybe<Scalars['Boolean']>;
  showAdDateDoc2?: Maybe<Scalars['Boolean']>;
  showAdDateDoc2OnPrint?: Maybe<Scalars['Boolean']>;
  showAllDMSDocumentsForURAClassifications?: Maybe<Scalars['Boolean']>;
  showAllDocumentsNotOnlyAnUserIns?: Maybe<Scalars['Boolean']>;
  showAllItemsIgnoringWarehouse?: Maybe<Scalars['Boolean']>;
  showAnClerkAndAnNoteClerkIsOROperation?: Maybe<Scalars['Boolean']>;
  showArticlesGroupedByCodeButSeparate?: Maybe<Scalars['Boolean']>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: Maybe<Scalars['Boolean']>;
  showAttachSSCCButton?: Maybe<Scalars['Boolean']>;
  showBuyerOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showContactEmailEntry?: Maybe<Scalars['Boolean']>;
  showContactEntry?: Maybe<Scalars['Boolean']>;
  showCostBearerOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showCustomerName2AsPrimaryOnHeader?: Maybe<Scalars['Boolean']>;
  showCustomerOverview?: Maybe<Scalars['Boolean']>;
  showCustomersAcName2OnThermalPrint?: Maybe<Scalars['Boolean']>;
  showDMSXMLItems?: Maybe<Scalars['Boolean']>;
  showDeliveryDeadlineDays: Scalars['Boolean'];
  showDeliveryMethod: Scalars['Boolean'];
  showDepartmentAsReceiver: Scalars['Boolean'];
  showDepartmentOutAsReceiver: Scalars['Boolean'];
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: Maybe<Scalars['String']>;
  showDoc12AndTheirDatesOnDocumentList?: Maybe<Scalars['Boolean']>;
  showInventoryNumberOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showItalianLabelsOnPrint?: Maybe<Scalars['Boolean']>;
  showItemAcCustomsTariffOnPrint?: Maybe<Scalars['Boolean']>;
  showItemAnNetWeightOnPrint?: Maybe<Scalars['Boolean']>;
  showItemPicturesOnPrint?: Maybe<Scalars['Boolean']>;
  showLastNOrdersForCustomer?: Maybe<Scalars['Int']>;
  showLineNoteOnPrint: Scalars['Boolean'];
  showModifierCharacterPicker: Scalars['Boolean'];
  showNumberOfUnlinkedDocuments?: Maybe<Scalars['Boolean']>;
  showOnlyArticlesWithCustomerContractPrice: Scalars['Boolean'];
  showOnlyDMSDocumentsAssignedToMe?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: Maybe<Scalars['Boolean']>;
  showOnlyWOWhereCurrentUserSpecExists?: Maybe<Scalars['Boolean']>;
  showPackageQuantityEntryField?: Maybe<Scalars['Boolean']>;
  showPaymentMethod: Scalars['Boolean'];
  showQuantityPerUnitOfMeasureOnPrint?: Maybe<Scalars['Boolean']>;
  showQuantityTotalOnPrint?: Maybe<Scalars['Boolean']>;
  showReceiverOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showSerialNumberSearchForWorkOrders?: Maybe<Scalars['Boolean']>;
  showWOWorkersEntry?: Maybe<Scalars['Boolean']>;
  skipConfirmationOnShortcuts: Scalars['Boolean'];
  skipGS1BarcodeCheck: Scalars['Boolean'];
  stockViewLoadAllOnOpen: Scalars['Boolean'];
  stockViewShowOnlyInStock: Scalars['Boolean'];
  storeContactEmailArbitraryInField?: Maybe<Scalars['String']>;
  subjectDocumentListDocumentType?: Maybe<Scalars['String']>;
  subjectFieldForSSCCRequirementCheck?: Maybe<Scalars['String']>;
  subjectFieldValueForSSCCRequirementCheck?: Maybe<Scalars['String']>;
  syncPackagingWhenAddingNewItem: Scalars['Boolean'];
  tHrPrsnForOnlyOnixPhoneUsers?: Maybe<Scalars['Boolean']>;
  tMNAcDefaultStatus?: Maybe<Scalars['String']>;
  tMNAcDefaultSubject?: Maybe<Scalars['String']>;
  tMNAnClassifIcationQid?: Maybe<Scalars['Int']>;
  tMNAnMailBoxQid?: Maybe<Scalars['Int']>;
  tMNAnStorageQid?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSize?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSizeHeight?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSizeWidth?: Maybe<Scalars['Int']>;
  thermalPrintShowCompanyImage: Scalars['Boolean'];
  toPairs?: Maybe<Array<Maybe<DocumentTypePair>>>;
  transferAcDoc1WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAcDoc2WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAdDateDoc1WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAdDateDoc2WhenCopying?: Maybe<Scalars['Boolean']>;
  transferEnteredItemQuantityToSerialNumber?: Maybe<Scalars['Boolean']>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: Maybe<Scalars['Boolean']>;
  treatIdentAsBarcode?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  update: Scalars['Boolean'];
  updateHeadAndDeleteAllItemsOnCopy?: Maybe<Scalars['Boolean']>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: Maybe<Scalars['Boolean']>;
  useDeadlineDateOnOverview: Scalars['Boolean'];
  useSquareArticlePicker?: Maybe<Scalars['Boolean']>;
  useVerySmallMobileInterface?: Maybe<Scalars['Boolean']>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
  visualAttributes?: Maybe<Scalars['String']>;
  visualAttributesOverview?: Maybe<Scalars['String']>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: Maybe<Scalars['Boolean']>;
  warehouseName?: Maybe<Scalars['String']>;
  warehouseOverviewShowOnlyInStock: Scalars['Boolean'];
  warehousePositionTHeSetItemFieldName?: Maybe<Scalars['String']>;
  warehouseShowPrices?: Maybe<Scalars['Boolean']>;
  warehouseViewFixedAcSubject?: Maybe<Scalars['String']>;
  webDmsRights?: Maybe<DmsRights>;
  whenAddingSubjectSetAnClerkToCurrentUser?: Maybe<Scalars['Boolean']>;
  workOrderCanBeUnlocked?: Maybe<Scalars['Boolean']>;
  workOrderPrintSpecificationDuration: Scalars['Boolean'];
  workOrderSpecificationPrefillTime?: Maybe<Scalars['Boolean']>;
  workOrderSpecificationTimeNotRequired?: Maybe<Scalars['Boolean']>;
  workOrderUnlockableStatus?: Maybe<Scalars['String']>;
}


declare interface DocumentTypeArbitraryFieldsArgs {
  order?: InputMaybe<Array<DocumentTypeArbitraryFieldSortInput>>;
}


declare interface DocumentTypeFiscalizationQueueEntryArgs {
  order?: InputMaybe<Array<FiscalizationQueueEntrySortInput>>;
  where?: InputMaybe<FiscalizationQueueEntryFilterInput>;
}

declare interface DocumentTypeArbitraryField {
  arbitraryFieldLocation?: Maybe<ArbitraryFieldLocationEnum>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  documentType?: Maybe<DocumentType>;
  documentTypeId: Scalars['Int'];
  fieldBaseValue?: Maybe<Scalars['String']>;
  fieldReference?: Maybe<Scalars['String']>;
  fieldRequired: Scalars['Boolean'];
  fieldType?: Maybe<ArbitraryFieldEntryType>;
  id: Scalars['Int'];
  jSValue?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  prefillFromField?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}

declare interface DocumentTypeArbitraryFieldFilterInput {
  and?: InputMaybe<Array<DocumentTypeArbitraryFieldFilterInput>>;
  arbitraryFieldLocation?: InputMaybe<NullableOfArbitraryFieldLocationEnumOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  documentType?: InputMaybe<DocumentTypeFilterInput>;
  documentTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  fieldBaseValue?: InputMaybe<StringOperationFilterInput>;
  fieldReference?: InputMaybe<StringOperationFilterInput>;
  fieldRequired?: InputMaybe<BooleanOperationFilterInput>;
  fieldType?: InputMaybe<NullableOfArbitraryFieldEntryTypeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  jSValue?: InputMaybe<StringOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DocumentTypeArbitraryFieldFilterInput>>;
  order?: InputMaybe<ComparableInt32OperationFilterInput>;
  prefillFromField?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
}

declare interface DocumentTypeArbitraryFieldSortInput {
  arbitraryFieldLocation?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  documentType?: InputMaybe<DocumentTypeSortInput>;
  documentTypeId?: InputMaybe<SortEnumType>;
  fieldBaseValue?: InputMaybe<SortEnumType>;
  fieldReference?: InputMaybe<SortEnumType>;
  fieldRequired?: InputMaybe<SortEnumType>;
  fieldType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jSValue?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
  prefillFromField?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
}

declare type DocumentTypeEnum =
  | 'MOVE'
  | 'ORDER'
  | 'WORK_ORDER';

declare interface DocumentTypeEnumOperationFilterInput {
  eq?: InputMaybe<DocumentTypeEnum>;
  in?: InputMaybe<Array<DocumentTypeEnum>>;
  neq?: InputMaybe<DocumentTypeEnum>;
  nin?: InputMaybe<Array<DocumentTypeEnum>>;
}

declare interface DocumentTypeFilterInput {
  acDocsOrderingOnPDF?: InputMaybe<StringOperationFilterInput>;
  acFieldSFLabel?: InputMaybe<StringOperationFilterInput>;
  acFiscalDevice?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerName?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName1?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName2?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acName3?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverName?: InputMaybe<StringOperationFilterInput>;
  acSetOfsWhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  acStatusIn?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acWorkPlace?: InputMaybe<StringOperationFilterInput>;
  acceptedByFieldOnPrint?: InputMaybe<StringOperationFilterInput>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc1EntryIsTimeOnly?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc1PDFLabel?: InputMaybe<StringOperationFilterInput>;
  adDateDoc2EntryIsTimeOnly?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc2PDFLabel?: InputMaybe<StringOperationFilterInput>;
  addingItemWarnIfQuantityMoreThanAvailable?: InputMaybe<BooleanOperationFilterInput>;
  adminAllowChangingItemPrice?: InputMaybe<BooleanOperationFilterInput>;
  adminCanEditDocumentAfterSaving?: InputMaybe<BooleanOperationFilterInput>;
  adminDefaultAcPriceRate?: InputMaybe<StringOperationFilterInput>;
  adminDeleteItemsAfterDocumentIsSaved?: InputMaybe<BooleanOperationFilterInput>;
  adminDocumentOnCreateMakeWarehouseReservation?: InputMaybe<BooleanOperationFilterInput>;
  adminEmphasizeInStock?: InputMaybe<BooleanOperationFilterInput>;
  adminForceAcPriceRate?: InputMaybe<StringOperationFilterInput>;
  adminIgnoreRebate1?: InputMaybe<BooleanOperationFilterInput>;
  adminIgnoreRebate2?: InputMaybe<BooleanOperationFilterInput>;
  adminIgnoreRebate3?: InputMaybe<BooleanOperationFilterInput>;
  adminItemQuantityMustBeInStock?: InputMaybe<BooleanOperationFilterInput>;
  adminSavedRebatesForFinalRebate?: InputMaybe<BooleanOperationFilterInput>;
  adminSendDocumentToCompanyDocumentEmail?: InputMaybe<BooleanOperationFilterInput>;
  adminSerialNumbersAreNotAutomated?: InputMaybe<BooleanOperationFilterInput>;
  adminShowDailyIncome?: InputMaybe<BooleanOperationFilterInput>;
  adminShowSubjectAdd?: InputMaybe<BooleanOperationFilterInput>;
  adminUseAnWsPrice?: InputMaybe<BooleanOperationFilterInput>;
  adminUseGenericDocumentsForMoveAndOrder?: InputMaybe<BooleanOperationFilterInput>;
  adminUseSerialNumberForItems?: InputMaybe<BooleanOperationFilterInput>;
  allowChangingWarehouse?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSCRUDOnlyForUsersFiles?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSConfirmation?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSReclassification?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemArticlePicking?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemCostBearerPicking?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemDepartmentPicking?: InputMaybe<BooleanOperationFilterInput>;
  allowGenericDocumentTypeImageAttachments?: InputMaybe<BooleanOperationFilterInput>;
  allowManualVerifyFromDocumentOverview?: InputMaybe<BooleanOperationFilterInput>;
  allowModifyExistingDocuments?: InputMaybe<BooleanOperationFilterInput>;
  allowPullingDMSEInvoicesFromService?: InputMaybe<BooleanOperationFilterInput>;
  allowSavingGeodecodedLocation?: InputMaybe<BooleanOperationFilterInput>;
  allowSelectingMultipleDocumentsToCreateFrom?: InputMaybe<BooleanOperationFilterInput>;
  allowSigningAfterDocumentIsSaved?: InputMaybe<BooleanOperationFilterInput>;
  alwaysShowTheseAcSetOfItem?: InputMaybe<StringOperationFilterInput>;
  alwaysUpdatePriceAndRebateFromClient?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<DocumentTypeFilterInput>>;
  appendToItemIfExists?: InputMaybe<BooleanOperationFilterInput>;
  arbitraryField1Label?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Location?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Value?: InputMaybe<StringOperationFilterInput>;
  arbitraryFields?: InputMaybe<ListFilterInputTypeOfDocumentTypeArbitraryFieldFilterInput>;
  articleDontShowPriceAnyWhere?: InputMaybe<BooleanOperationFilterInput>;
  articleDontShowStockAnyWhere?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchAllowSearchingByClassification?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchInitiallyLoadAll?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchRepeatLastSearch?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsAIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsBIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsCIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsDIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsEIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsFIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsGIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsHIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsIIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsJIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddAIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddBIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddCIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddDIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnAIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnBIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnCIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnDIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnEIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnFIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnGIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnHIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnIIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnJIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  bluetoothPrintCopiesNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  cacheDuration?: InputMaybe<ComparableInt32OperationFilterInput>;
  cacheUseCacheForAnyResource?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForArticleSearch?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForCustomerSearch?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForWarehouseSearch?: InputMaybe<BooleanOperationFilterInput>;
  cardPaymentProvider?: InputMaybe<NullableOfCardPaymentProviderOperationFilterInput>;
  changeDocumentStatusAfterCreated?: InputMaybe<StringOperationFilterInput>;
  changeSourceDocumentStatusTo?: InputMaybe<StringOperationFilterInput>;
  classifs2WhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  classifsWhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  clerkFieldOnPrint?: InputMaybe<StringOperationFilterInput>;
  companyEmailDefaultEmail?: InputMaybe<StringOperationFilterInput>;
  companyEmailForwards?: InputMaybe<ListFilterInputTypeOfCompanyEmailForwardFilterInput>;
  companyEmailPDFBCC?: InputMaybe<StringOperationFilterInput>;
  companyEmailPDFCC?: InputMaybe<StringOperationFilterInput>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: InputMaybe<BooleanOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  completeDeliveryStatus?: InputMaybe<StringOperationFilterInput>;
  copyOnlyLeftOverQuantity?: InputMaybe<BooleanOperationFilterInput>;
  copyOnlyThoseWithLeftOverQuantity0?: InputMaybe<BooleanOperationFilterInput>;
  copyingFromAnotherIsAShadowCopy?: InputMaybe<BooleanOperationFilterInput>;
  create?: InputMaybe<BooleanOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  customContractPriceFilter?: InputMaybe<BooleanOperationFilterInput>;
  customerCodeAllowedKeys?: InputMaybe<StringOperationFilterInput>;
  customerCodeFromAcSkis?: InputMaybe<BooleanOperationFilterInput>;
  customerCodeIsGenerated?: InputMaybe<BooleanOperationFilterInput>;
  dMSListFilterOnDefaultClassification?: InputMaybe<BooleanOperationFilterInput>;
  dateFilterType?: InputMaybe<NullableOfDateFilterTypeOperationFilterInput>;
  defaultCustomerType?: InputMaybe<StringOperationFilterInput>;
  defaultCustomerTypeFilter?: InputMaybe<StringOperationFilterInput>;
  defaultMoveDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultMoveDocumentSortField?: InputMaybe<NullableOfTHeMovePagedSortFieldOperationFilterInput>;
  defaultOrderDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultOrderDocumentSortField?: InputMaybe<NullableOfTHeOrderPagedSortFieldOperationFilterInput>;
  defaultPaymentMethod?: InputMaybe<StringOperationFilterInput>;
  defaultQuantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  defaultSubjectDaysForPaymentOnAdd?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultSubjectPaymentMethodOnAdd?: InputMaybe<StringOperationFilterInput>;
  defaultToThisCustomer?: InputMaybe<StringOperationFilterInput>;
  defaultWoexDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultWoexDocumentSortField?: InputMaybe<NullableOfTHfWoexPagedSortFieldOperationFilterInput>;
  delete?: InputMaybe<BooleanOperationFilterInput>;
  deliveryIsRequired?: InputMaybe<BooleanOperationFilterInput>;
  disableUsingShadowItemAsItemBase?: InputMaybe<BooleanOperationFilterInput>;
  disallowChangingCustomer?: InputMaybe<BooleanOperationFilterInput>;
  disallowChangingItemQuantityOnSerialInput?: InputMaybe<BooleanOperationFilterInput>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: InputMaybe<BooleanOperationFilterInput>;
  disallowManualWarehouseSearch?: InputMaybe<BooleanOperationFilterInput>;
  disallowPickingCustomer?: InputMaybe<BooleanOperationFilterInput>;
  dmsAcStatusIn?: InputMaybe<StringOperationFilterInput>;
  doNotFilterDailyRecapByUserId?: InputMaybe<BooleanOperationFilterInput>;
  documentLinkType?: InputMaybe<StringOperationFilterInput>;
  documentLinkTypeA?: InputMaybe<StringOperationFilterInput>;
  documentLinkTypeB?: InputMaybe<StringOperationFilterInput>;
  documentNote?: InputMaybe<StringOperationFilterInput>;
  documentOnCreateMakeA4Print?: InputMaybe<BooleanOperationFilterInput>;
  documentOnCreateMakeBluetoothPrint?: InputMaybe<BooleanOperationFilterInput>;
  documentOnCreateMakePDF?: InputMaybe<BooleanOperationFilterInput>;
  documentTopAdditionalText?: InputMaybe<StringOperationFilterInput>;
  dontSaveIndividualPDFPages?: InputMaybe<BooleanOperationFilterInput>;
  existingInventoryCheckDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  fillReferentLineWithUserOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  filterByAcDelivery?: InputMaybe<BooleanOperationFilterInput>;
  filterByAcDept?: InputMaybe<StringOperationFilterInput>;
  filterByAcDeptOut?: InputMaybe<StringOperationFilterInput>;
  filterByAcType?: InputMaybe<StringOperationFilterInput>;
  filterByAcVerifiedPrices?: InputMaybe<StringOperationFilterInput>;
  filterByAcVerifyStatus?: InputMaybe<StringOperationFilterInput>;
  filterByCurrentUserIdIsAnSigner1?: InputMaybe<BooleanOperationFilterInput>;
  filterMovesByThisAcIssuer?: InputMaybe<StringOperationFilterInput>;
  filterMovesByThisAcReceiver?: InputMaybe<StringOperationFilterInput>;
  filterOrdersByThisAcWarehouse?: InputMaybe<StringOperationFilterInput>;
  filterReceiversByAcFieldSa?: InputMaybe<StringOperationFilterInput>;
  fiscalizationQueueEntry?: InputMaybe<ListFilterInputTypeOfFiscalizationQueueEntryFilterInput>;
  forceShowAvailableOnStock?: InputMaybe<BooleanOperationFilterInput>;
  fromPairs?: InputMaybe<ListFilterInputTypeOfDocumentTypePairFilterInput>;
  functionality?: InputMaybe<DocumentFunctionalityEnumOperationFilterInput>;
  generatePrintTimeOnCreate?: InputMaybe<BooleanOperationFilterInput>;
  groupAllCreatingDocumentTypesAtThisPoint?: InputMaybe<BooleanOperationFilterInput>;
  groupAllDocumentTypesAtThisPoint?: InputMaybe<BooleanOperationFilterInput>;
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated?: InputMaybe<BooleanOperationFilterInput>;
  headerClerkPDFLabel?: InputMaybe<StringOperationFilterInput>;
  hideAcceptedByFieldOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideClerkFieldOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideCurrencyDateOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideDMSMetadataEntryFields?: InputMaybe<BooleanOperationFilterInput>;
  hideDataForPaymentOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideDocumentElements?: InputMaybe<StringOperationFilterInput>;
  hideDocumentItemElements?: InputMaybe<StringOperationFilterInput>;
  hideLeftOverQuantityOnPicking?: InputMaybe<BooleanOperationFilterInput>;
  hideNoteInNonHistoricalView?: InputMaybe<BooleanOperationFilterInput>;
  hidePayMethodOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideQuantityEntry?: InputMaybe<BooleanOperationFilterInput>;
  hideVATRecapitulationOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseItemActions?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseOverview?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseSupplier?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderImages?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderMaterials?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderPlaceFromTo?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderReception?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderReclamations?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderServices?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderSpecications?: InputMaybe<BooleanOperationFilterInput>;
  highlightArticlePickerTextOnNextOpen?: InputMaybe<BooleanOperationFilterInput>;
  historyViewIgnoredFilters?: InputMaybe<StringOperationFilterInput>;
  horizontalDoc12AndDates?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  ifAcPayMethodChooseThisDocumentType?: InputMaybe<StringOperationFilterInput>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: InputMaybe<BooleanOperationFilterInput>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: InputMaybe<BooleanOperationFilterInput>;
  ignoreQuantityInWholeDocument?: InputMaybe<BooleanOperationFilterInput>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: InputMaybe<BooleanOperationFilterInput>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  isDisabled?: InputMaybe<BooleanOperationFilterInput>;
  isRetail?: InputMaybe<BooleanOperationFilterInput>;
  itemListShowDetailed?: InputMaybe<BooleanOperationFilterInput>;
  jumpToEditAfterScanningItemWithBarcode?: InputMaybe<BooleanOperationFilterInput>;
  keepAdDateDoc1And2Unrounded?: InputMaybe<BooleanOperationFilterInput>;
  labelDefinitionLocations?: InputMaybe<ListFilterInputTypeOfLabelDefinitionLocationFilterInput>;
  linkFrom?: InputMaybe<ListFilterInputTypeOfDocumentTypeLinkFilterInput>;
  linkTo?: InputMaybe<ListFilterInputTypeOfDocumentTypeLinkFilterInput>;
  makeDocumentLinks?: InputMaybe<BooleanOperationFilterInput>;
  makeSerialStockCheck?: InputMaybe<BooleanOperationFilterInput>;
  manualWorkOrderMaterial?: InputMaybe<StringOperationFilterInput>;
  middleSignatureTextOnPrint?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifierCharacterLabel?: InputMaybe<StringOperationFilterInput>;
  multipleEndDocumentsCaseToPickEndDocument?: InputMaybe<StringOperationFilterInput>;
  mustFiscalize?: InputMaybe<BooleanOperationFilterInput>;
  newNewDocumentInputType?: InputMaybe<BooleanOperationFilterInput>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: InputMaybe<BooleanOperationFilterInput>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DocumentTypeFilterInput>>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: InputMaybe<BooleanOperationFilterInput>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: InputMaybe<BooleanOperationFilterInput>;
  palletEntry?: InputMaybe<BooleanOperationFilterInput>;
  pantheonDirection?: InputMaybe<PantheonDocumentDirectionEnumOperationFilterInput>;
  pantheonTable?: InputMaybe<PantheonDocumentTableOperationFilterInput>;
  partialDeliveryStatus?: InputMaybe<StringOperationFilterInput>;
  pdfSignWithoutGeneration?: InputMaybe<BooleanOperationFilterInput>;
  pickingShowConfirmationOnPick?: InputMaybe<BooleanOperationFilterInput>;
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: InputMaybe<BooleanOperationFilterInput>;
  printDocumentTitleOverride?: InputMaybe<StringOperationFilterInput>;
  printTicketNameOverride?: InputMaybe<StringOperationFilterInput>;
  prioritisePackageQuantityEntryField?: InputMaybe<BooleanOperationFilterInput>;
  quantityDecimalPlaces?: InputMaybe<ComparableInt32OperationFilterInput>;
  read?: InputMaybe<BooleanOperationFilterInput>;
  recommendToMakeCodebooksOffline?: InputMaybe<BooleanOperationFilterInput>;
  requireASignature?: InputMaybe<BooleanOperationFilterInput>;
  reverseItemsList?: InputMaybe<BooleanOperationFilterInput>;
  saveUnsignedAsSignedPDF?: InputMaybe<BooleanOperationFilterInput>;
  sendB2BAsEInvoice?: InputMaybe<BooleanOperationFilterInput>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: InputMaybe<BooleanOperationFilterInput>;
  sendLeftoverShadowsWithZero?: InputMaybe<BooleanOperationFilterInput>;
  serialNumberDirectionIsInput?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeliveryMobileFilterOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeliveryOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeptMobileFilterOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDescrOnPDFs?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc1?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc1OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc2?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc2OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcIdentOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: InputMaybe<StringOperationFilterInput>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: InputMaybe<StringOperationFilterInput>;
  showAdDate?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc1?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc1OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc2?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc2OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAllDMSDocumentsForURAClassifications?: InputMaybe<BooleanOperationFilterInput>;
  showAllDocumentsNotOnlyAnUserIns?: InputMaybe<BooleanOperationFilterInput>;
  showAllItemsIgnoringWarehouse?: InputMaybe<BooleanOperationFilterInput>;
  showAnClerkAndAnNoteClerkIsOROperation?: InputMaybe<BooleanOperationFilterInput>;
  showArticlesGroupedByCodeButSeparate?: InputMaybe<BooleanOperationFilterInput>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: InputMaybe<BooleanOperationFilterInput>;
  showAttachSSCCButton?: InputMaybe<BooleanOperationFilterInput>;
  showBuyerOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showContactEmailEntry?: InputMaybe<BooleanOperationFilterInput>;
  showContactEntry?: InputMaybe<BooleanOperationFilterInput>;
  showCostBearerOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerName2AsPrimaryOnHeader?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerOverview?: InputMaybe<BooleanOperationFilterInput>;
  showCustomersAcName2OnThermalPrint?: InputMaybe<BooleanOperationFilterInput>;
  showDMSXMLItems?: InputMaybe<BooleanOperationFilterInput>;
  showDeliveryDeadlineDays?: InputMaybe<BooleanOperationFilterInput>;
  showDeliveryMethod?: InputMaybe<BooleanOperationFilterInput>;
  showDepartmentAsReceiver?: InputMaybe<BooleanOperationFilterInput>;
  showDepartmentOutAsReceiver?: InputMaybe<BooleanOperationFilterInput>;
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: InputMaybe<StringOperationFilterInput>;
  showDoc12AndTheirDatesOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showInventoryNumberOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showItalianLabelsOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemAcCustomsTariffOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemAnNetWeightOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemPicturesOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showLastNOrdersForCustomer?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  showLineNoteOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showModifierCharacterPicker?: InputMaybe<BooleanOperationFilterInput>;
  showNumberOfUnlinkedDocuments?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyArticlesWithCustomerContractPrice?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyWOWhereCurrentUserSpecExists?: InputMaybe<BooleanOperationFilterInput>;
  showPackageQuantityEntryField?: InputMaybe<BooleanOperationFilterInput>;
  showPaymentMethod?: InputMaybe<BooleanOperationFilterInput>;
  showQuantityPerUnitOfMeasureOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showQuantityTotalOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showReceiverOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showSerialNumberSearchForWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showWOWorkersEntry?: InputMaybe<BooleanOperationFilterInput>;
  skipConfirmationOnShortcuts?: InputMaybe<BooleanOperationFilterInput>;
  skipGS1BarcodeCheck?: InputMaybe<BooleanOperationFilterInput>;
  stockViewLoadAllOnOpen?: InputMaybe<BooleanOperationFilterInput>;
  stockViewShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  storeContactEmailArbitraryInField?: InputMaybe<StringOperationFilterInput>;
  subjectDocumentListDocumentType?: InputMaybe<StringOperationFilterInput>;
  subjectFieldForSSCCRequirementCheck?: InputMaybe<StringOperationFilterInput>;
  subjectFieldValueForSSCCRequirementCheck?: InputMaybe<StringOperationFilterInput>;
  syncPackagingWhenAddingNewItem?: InputMaybe<BooleanOperationFilterInput>;
  tHrPrsnForOnlyOnixPhoneUsers?: InputMaybe<BooleanOperationFilterInput>;
  tMNAcDefaultStatus?: InputMaybe<StringOperationFilterInput>;
  tMNAcDefaultSubject?: InputMaybe<StringOperationFilterInput>;
  tMNAnClassifIcationQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tMNAnMailBoxQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tMNAnStorageQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSize?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSizeHeight?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSizeWidth?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintShowCompanyImage?: InputMaybe<BooleanOperationFilterInput>;
  toPairs?: InputMaybe<ListFilterInputTypeOfDocumentTypePairFilterInput>;
  transferAcDoc1WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAcDoc2WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAdDateDoc1WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAdDateDoc2WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferEnteredItemQuantityToSerialNumber?: InputMaybe<BooleanOperationFilterInput>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: InputMaybe<BooleanOperationFilterInput>;
  treatIdentAsBarcode?: InputMaybe<BooleanOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  update?: InputMaybe<BooleanOperationFilterInput>;
  updateHeadAndDeleteAllItemsOnCopy?: InputMaybe<BooleanOperationFilterInput>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: InputMaybe<BooleanOperationFilterInput>;
  useDeadlineDateOnOverview?: InputMaybe<BooleanOperationFilterInput>;
  useSquareArticlePicker?: InputMaybe<BooleanOperationFilterInput>;
  useVerySmallMobileInterface?: InputMaybe<BooleanOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  visualAttributes?: InputMaybe<StringOperationFilterInput>;
  visualAttributesOverview?: InputMaybe<StringOperationFilterInput>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<BooleanOperationFilterInput>;
  warehouseName?: InputMaybe<StringOperationFilterInput>;
  warehouseOverviewShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  warehousePositionTHeSetItemFieldName?: InputMaybe<StringOperationFilterInput>;
  warehouseShowPrices?: InputMaybe<BooleanOperationFilterInput>;
  warehouseViewFixedAcSubject?: InputMaybe<StringOperationFilterInput>;
  whenAddingSubjectSetAnClerkToCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  workOrderCanBeUnlocked?: InputMaybe<BooleanOperationFilterInput>;
  workOrderPrintSpecificationDuration?: InputMaybe<BooleanOperationFilterInput>;
  workOrderSpecificationPrefillTime?: InputMaybe<BooleanOperationFilterInput>;
  workOrderSpecificationTimeNotRequired?: InputMaybe<BooleanOperationFilterInput>;
  workOrderUnlockableStatus?: InputMaybe<StringOperationFilterInput>;
}

declare interface DocumentTypeLink {
  acDocsOrderingOnPDF?: Maybe<Scalars['String']>;
  acFieldSFLabel?: Maybe<Scalars['String']>;
  acFiscalDevice?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerName?: Maybe<Scalars['String']>;
  acLinkDocName1?: Maybe<Scalars['String']>;
  acLinkDocName2?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acName3?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverName?: Maybe<Scalars['String']>;
  acSetOfsWhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  acStatusIn?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acWorkPlace?: Maybe<Scalars['String']>;
  acceptedByFieldOnPrint?: Maybe<Scalars['String']>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: Maybe<Scalars['Boolean']>;
  adDateDoc1EntryIsTimeOnly?: Maybe<Scalars['Boolean']>;
  adDateDoc1PDFLabel?: Maybe<Scalars['String']>;
  adDateDoc2EntryIsTimeOnly?: Maybe<Scalars['Boolean']>;
  adDateDoc2PDFLabel?: Maybe<Scalars['String']>;
  addingItemWarnIfQuantityMoreThanAvailable: Scalars['Boolean'];
  adminAllowChangingItemPrice: Scalars['Boolean'];
  adminCanEditDocumentAfterSaving: Scalars['Boolean'];
  adminDefaultAcPriceRate?: Maybe<Scalars['String']>;
  adminDeleteItemsAfterDocumentIsSaved: Scalars['Boolean'];
  adminDocumentOnCreateMakeWarehouseReservation: Scalars['Boolean'];
  adminEmphasizeInStock: Scalars['Boolean'];
  adminForceAcPriceRate?: Maybe<Scalars['String']>;
  adminIgnoreRebate1: Scalars['Boolean'];
  adminIgnoreRebate2: Scalars['Boolean'];
  adminIgnoreRebate3: Scalars['Boolean'];
  adminItemQuantityMustBeInStock: Scalars['Boolean'];
  adminSavedRebatesForFinalRebate: Scalars['Boolean'];
  adminSendDocumentToCompanyDocumentEmail: Scalars['Boolean'];
  adminSerialNumbersAreNotAutomated?: Maybe<Scalars['Boolean']>;
  adminShowDailyIncome: Scalars['Boolean'];
  adminShowSubjectAdd: Scalars['Boolean'];
  adminUseAnWsPrice: Scalars['Boolean'];
  adminUseGenericDocumentsForMoveAndOrder: Scalars['Boolean'];
  adminUseSerialNumberForItems: Scalars['Boolean'];
  allowChangingWarehouse?: Maybe<Scalars['Boolean']>;
  allowDMSCRUDOnlyForUsersFiles?: Maybe<Scalars['Boolean']>;
  allowDMSConfirmation?: Maybe<Scalars['Boolean']>;
  allowDMSReclassification?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemArticlePicking?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemCostBearerPicking?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemDepartmentPicking?: Maybe<Scalars['Boolean']>;
  allowGenericDocumentTypeImageAttachments?: Maybe<Scalars['Boolean']>;
  allowManualVerifyFromDocumentOverview?: Maybe<Scalars['Boolean']>;
  allowModifyExistingDocuments: Scalars['Boolean'];
  allowPullingDMSEInvoicesFromService?: Maybe<Scalars['Boolean']>;
  allowSavingGeodecodedLocation?: Maybe<Scalars['Boolean']>;
  allowSelectingMultipleDocumentsToCreateFrom?: Maybe<Scalars['Boolean']>;
  allowSigningAfterDocumentIsSaved?: Maybe<Scalars['Boolean']>;
  alwaysShowTheseAcSetOfItem?: Maybe<Scalars['String']>;
  alwaysUpdatePriceAndRebateFromClient?: Maybe<Scalars['Boolean']>;
  appendToItemIfExists?: Maybe<Scalars['Boolean']>;
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  arbitraryField1Label?: Maybe<Scalars['String']>;
  arbitraryField1Location?: Maybe<Scalars['String']>;
  arbitraryField1Value?: Maybe<Scalars['String']>;
  arbitraryFields: Array<DocumentTypeArbitraryField>;
  articleDontShowPriceAnyWhere: Scalars['Boolean'];
  articleDontShowStockAnyWhere: Scalars['Boolean'];
  articleSearchAllowSearchingByClassification: Scalars['Boolean'];
  articleSearchInitiallyLoadAll: Scalars['Boolean'];
  articleSearchRepeatLastSearch: Scalars['Boolean'];
  articleSearchShowOnlyInStock: Scalars['Boolean'];
  articleSearchShowOnlyWhereAcClassifIsIn?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsAIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsBIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsCIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsDIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsEIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsFIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsGIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsHIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsIIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsJIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAdFielddAIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddBIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddCIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddDIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAnFieldnAIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnBIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnCIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnDIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnEIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnFIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnGIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnHIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnIIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnJIs?: Maybe<Scalars['Decimal']>;
  bluetoothPrintCopiesNumber: Scalars['Int'];
  cacheDuration: Scalars['Int'];
  cacheUseCacheForAnyResource: Scalars['Boolean'];
  cacheUseForArticleSearch: Scalars['Boolean'];
  cacheUseForCustomerSearch: Scalars['Boolean'];
  cacheUseForWarehouseSearch: Scalars['Boolean'];
  cardPaymentProvider?: Maybe<CardPaymentProvider>;
  changeDocumentStatusAfterCreated?: Maybe<Scalars['String']>;
  changeSourceDocumentStatusTo?: Maybe<Scalars['String']>;
  classifs2WhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  classifsWhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  clerkFieldOnPrint?: Maybe<Scalars['String']>;
  companyEmailDefaultEmail?: Maybe<Scalars['String']>;
  companyEmailPDFBCC?: Maybe<Scalars['String']>;
  companyEmailPDFCC?: Maybe<Scalars['String']>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: Maybe<Scalars['Boolean']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  completeDeliveryStatus?: Maybe<Scalars['String']>;
  copyOnlyLeftOverQuantity?: Maybe<Scalars['Boolean']>;
  copyOnlyThoseWithLeftOverQuantity0?: Maybe<Scalars['Boolean']>;
  copyingFromAnotherIsAShadowCopy?: Maybe<Scalars['Boolean']>;
  create: Scalars['Boolean'];
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  customContractPriceFilter?: Maybe<Scalars['Boolean']>;
  customerCodeAllowedKeys?: Maybe<Scalars['String']>;
  customerCodeFromAcSkis?: Maybe<Scalars['Boolean']>;
  customerCodeIsGenerated?: Maybe<Scalars['Boolean']>;
  dMSListFilterOnDefaultClassification?: Maybe<Scalars['Boolean']>;
  dateFilterType?: Maybe<DateFilterType>;
  defaultCustomerType?: Maybe<Scalars['String']>;
  defaultCustomerTypeFilter?: Maybe<Scalars['String']>;
  defaultMoveDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultMoveDocumentSortField?: Maybe<THeMovePagedSortField>;
  defaultOrderDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultOrderDocumentSortField?: Maybe<THeOrderPagedSortField>;
  defaultPaymentMethod?: Maybe<Scalars['String']>;
  defaultQuantity?: Maybe<Scalars['Decimal']>;
  defaultSubjectDaysForPaymentOnAdd?: Maybe<Scalars['Int']>;
  defaultSubjectPaymentMethodOnAdd?: Maybe<Scalars['String']>;
  defaultToThisCustomer?: Maybe<Scalars['String']>;
  defaultWoexDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultWoexDocumentSortField?: Maybe<THfWoexPagedSortField>;
  delete: Scalars['Boolean'];
  deliveryIsRequired?: Maybe<Scalars['Boolean']>;
  disableUsingShadowItemAsItemBase?: Maybe<Scalars['Boolean']>;
  disallowChangingCustomer: Scalars['Boolean'];
  disallowChangingItemQuantityOnSerialInput?: Maybe<Scalars['Boolean']>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: Maybe<Scalars['Boolean']>;
  disallowManualWarehouseSearch?: Maybe<Scalars['Boolean']>;
  disallowPickingCustomer: Scalars['Boolean'];
  dmsAcStatusIn?: Maybe<Scalars['String']>;
  doNotFilterDailyRecapByUserId?: Maybe<Scalars['Boolean']>;
  documentLinkType?: Maybe<Scalars['String']>;
  documentLinkTypeA?: Maybe<Scalars['String']>;
  documentLinkTypeB?: Maybe<Scalars['String']>;
  documentNote?: Maybe<Scalars['String']>;
  documentOnCreateMakeA4Print?: Maybe<Scalars['Boolean']>;
  documentOnCreateMakeBluetoothPrint: Scalars['Boolean'];
  documentOnCreateMakePDF: Scalars['Boolean'];
  documentTopAdditionalText?: Maybe<Scalars['String']>;
  dontSaveIndividualPDFPages?: Maybe<Scalars['Boolean']>;
  existingInventoryCheckDays?: Maybe<Scalars['Int']>;
  fillReferentLineWithUserOnPrint?: Maybe<Scalars['Boolean']>;
  filterByAcDelivery: Scalars['Boolean'];
  filterByAcDept?: Maybe<Scalars['String']>;
  filterByAcDeptOut?: Maybe<Scalars['String']>;
  filterByAcType?: Maybe<Scalars['String']>;
  filterByAcVerifiedPrices?: Maybe<Scalars['String']>;
  filterByAcVerifyStatus?: Maybe<Scalars['String']>;
  filterByCurrentUserIdIsAnSigner1?: Maybe<Scalars['Boolean']>;
  filterMovesByThisAcIssuer?: Maybe<Scalars['String']>;
  filterMovesByThisAcReceiver?: Maybe<Scalars['String']>;
  filterOrdersByThisAcWarehouse?: Maybe<Scalars['String']>;
  filterReceiversByAcFieldSa?: Maybe<Scalars['String']>;
  forceShowAvailableOnStock: Scalars['Boolean'];
  functionality: DocumentPairFunctionalityEnum;
  generatePrintTimeOnCreate: Scalars['Boolean'];
  groupAllCreatingDocumentTypesAtThisPoint: Scalars['Boolean'];
  groupAllDocumentTypesAtThisPoint: Scalars['Boolean'];
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated: Scalars['Boolean'];
  headerClerkPDFLabel?: Maybe<Scalars['String']>;
  hideAcceptedByFieldOnPrint?: Maybe<Scalars['Boolean']>;
  hideClerkFieldOnPrint?: Maybe<Scalars['Boolean']>;
  hideCurrencyDateOnPrint?: Maybe<Scalars['Boolean']>;
  hideDMSMetadataEntryFields?: Maybe<Scalars['Boolean']>;
  hideDataForPaymentOnPrint?: Maybe<Scalars['Boolean']>;
  hideDocumentElements?: Maybe<Scalars['String']>;
  hideDocumentItemElements?: Maybe<Scalars['String']>;
  hideLeftOverQuantityOnPicking?: Maybe<Scalars['Boolean']>;
  hideNoteInNonHistoricalView?: Maybe<Scalars['Boolean']>;
  hidePayMethodOnPrint?: Maybe<Scalars['Boolean']>;
  hideQuantityEntry?: Maybe<Scalars['Boolean']>;
  hideVATRecapitulationOnPrint?: Maybe<Scalars['Boolean']>;
  hideWarehouseItemActions?: Maybe<Scalars['Boolean']>;
  hideWarehouseOverview?: Maybe<Scalars['Boolean']>;
  hideWarehouseSupplier?: Maybe<Scalars['Boolean']>;
  hideWorkOrderImages?: Maybe<Scalars['Boolean']>;
  hideWorkOrderMaterials?: Maybe<Scalars['Boolean']>;
  hideWorkOrderPlaceFromTo?: Maybe<Scalars['Boolean']>;
  hideWorkOrderReception?: Maybe<Scalars['Boolean']>;
  hideWorkOrderReclamations?: Maybe<Scalars['Boolean']>;
  hideWorkOrderServices?: Maybe<Scalars['Boolean']>;
  hideWorkOrderSpecications?: Maybe<Scalars['Boolean']>;
  highlightArticlePickerTextOnNextOpen?: Maybe<Scalars['Boolean']>;
  historyViewIgnoredFilters?: Maybe<Scalars['String']>;
  horizontalDoc12AndDates?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  ifAcPayMethodChooseThisDocumentType?: Maybe<Scalars['String']>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: Maybe<Scalars['Boolean']>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: Maybe<Scalars['Boolean']>;
  ignoreQuantityInWholeDocument?: Maybe<Scalars['Boolean']>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: Maybe<Scalars['Boolean']>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: Maybe<Scalars['Boolean']>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isRetail?: Maybe<Scalars['Boolean']>;
  itemListShowDetailed: Scalars['Boolean'];
  jumpToEditAfterScanningItemWithBarcode: Scalars['Boolean'];
  keepAdDateDoc1And2Unrounded?: Maybe<Scalars['Boolean']>;
  labelDefinitionLocations: Array<LabelDefinitionLocation>;
  linkFrom?: Maybe<Array<Maybe<DocumentType>>>;
  linkTo?: Maybe<Array<Maybe<DocumentType>>>;
  makeDocumentLinks?: Maybe<Scalars['Boolean']>;
  makeSerialStockCheck?: Maybe<Scalars['Boolean']>;
  manualWorkOrderMaterial?: Maybe<Scalars['String']>;
  middleSignatureTextOnPrint?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  modifierCharacterLabel?: Maybe<Scalars['String']>;
  multipleEndDocumentsCaseToPickEndDocument?: Maybe<Scalars['String']>;
  mustFiscalize?: Maybe<Scalars['Boolean']>;
  newNewDocumentInputType?: Maybe<Scalars['Boolean']>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: Maybe<Scalars['Boolean']>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: Maybe<Scalars['Boolean']>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: Maybe<Scalars['Boolean']>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: Maybe<Scalars['Boolean']>;
  palletEntry?: Maybe<Scalars['Boolean']>;
  partialDeliveryStatus?: Maybe<Scalars['String']>;
  pdfSignWithoutGeneration?: Maybe<Scalars['Boolean']>;
  pickingShowConfirmationOnPick: Scalars['Boolean'];
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: Maybe<Scalars['Boolean']>;
  printDocumentTitleOverride?: Maybe<Scalars['String']>;
  printTicketNameOverride?: Maybe<Scalars['String']>;
  prioritisePackageQuantityEntryField?: Maybe<Scalars['Boolean']>;
  quantityDecimalPlaces: Scalars['Int'];
  read: Scalars['Boolean'];
  recommendToMakeCodebooksOffline?: Maybe<Scalars['Boolean']>;
  requireASignature: Scalars['Boolean'];
  reverseItemsList?: Maybe<Scalars['Boolean']>;
  saveUnsignedAsSignedPDF?: Maybe<Scalars['Boolean']>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: Maybe<Scalars['Boolean']>;
  sendLeftoverShadowsWithZero?: Maybe<Scalars['Boolean']>;
  serialNumberDirectionIsInput?: Maybe<Scalars['Boolean']>;
  showAcDeliveryMobileFilterOnDocumentList: Scalars['Boolean'];
  showAcDeliveryOnDocumentList: Scalars['Boolean'];
  showAcDeptMobileFilterOnDocumentList: Scalars['Boolean'];
  showAcDescrOnPDFs?: Maybe<Scalars['Boolean']>;
  showAcDoc1?: Maybe<Scalars['Boolean']>;
  showAcDoc1OnPrint?: Maybe<Scalars['Boolean']>;
  showAcDoc2?: Maybe<Scalars['Boolean']>;
  showAcDoc2OnPrint?: Maybe<Scalars['Boolean']>;
  showAcIdentOnPrint?: Maybe<Scalars['Boolean']>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: Maybe<Scalars['String']>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: Maybe<Scalars['String']>;
  showAdDate?: Maybe<Scalars['Boolean']>;
  showAdDateDoc1?: Maybe<Scalars['Boolean']>;
  showAdDateDoc1OnPrint?: Maybe<Scalars['Boolean']>;
  showAdDateDoc2?: Maybe<Scalars['Boolean']>;
  showAdDateDoc2OnPrint?: Maybe<Scalars['Boolean']>;
  showAllDMSDocumentsForURAClassifications?: Maybe<Scalars['Boolean']>;
  showAllDocumentsNotOnlyAnUserIns?: Maybe<Scalars['Boolean']>;
  showAllItemsIgnoringWarehouse?: Maybe<Scalars['Boolean']>;
  showAnClerkAndAnNoteClerkIsOROperation?: Maybe<Scalars['Boolean']>;
  showArticlesGroupedByCodeButSeparate?: Maybe<Scalars['Boolean']>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: Maybe<Scalars['Boolean']>;
  showAttachSSCCButton?: Maybe<Scalars['Boolean']>;
  showBuyerOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showContactEmailEntry?: Maybe<Scalars['Boolean']>;
  showContactEntry?: Maybe<Scalars['Boolean']>;
  showCostBearerOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showCustomerName2AsPrimaryOnHeader?: Maybe<Scalars['Boolean']>;
  showCustomerOverview?: Maybe<Scalars['Boolean']>;
  showCustomersAcName2OnThermalPrint?: Maybe<Scalars['Boolean']>;
  showDMSXMLItems?: Maybe<Scalars['Boolean']>;
  showDeliveryDeadlineDays: Scalars['Boolean'];
  showDeliveryMethod: Scalars['Boolean'];
  showDepartmentAsReceiver: Scalars['Boolean'];
  showDepartmentOutAsReceiver: Scalars['Boolean'];
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: Maybe<Scalars['String']>;
  showDoc12AndTheirDatesOnDocumentList?: Maybe<Scalars['Boolean']>;
  showInventoryNumberOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showItalianLabelsOnPrint?: Maybe<Scalars['Boolean']>;
  showItemAcCustomsTariffOnPrint?: Maybe<Scalars['Boolean']>;
  showItemAnNetWeightOnPrint?: Maybe<Scalars['Boolean']>;
  showItemPicturesOnPrint?: Maybe<Scalars['Boolean']>;
  showLastNOrdersForCustomer?: Maybe<Scalars['Int']>;
  showLineNoteOnPrint: Scalars['Boolean'];
  showModifierCharacterPicker: Scalars['Boolean'];
  showNumberOfUnlinkedDocuments?: Maybe<Scalars['Boolean']>;
  showOnlyArticlesWithCustomerContractPrice: Scalars['Boolean'];
  showOnlyDMSDocumentsAssignedToMe?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: Maybe<Scalars['Boolean']>;
  showOnlyWOWhereCurrentUserSpecExists?: Maybe<Scalars['Boolean']>;
  showPackageQuantityEntryField?: Maybe<Scalars['Boolean']>;
  showPaymentMethod: Scalars['Boolean'];
  showQuantityPerUnitOfMeasureOnPrint?: Maybe<Scalars['Boolean']>;
  showQuantityTotalOnPrint?: Maybe<Scalars['Boolean']>;
  showReceiverOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showSerialNumberSearchForWorkOrders?: Maybe<Scalars['Boolean']>;
  showWOWorkersEntry?: Maybe<Scalars['Boolean']>;
  skipConfirmationOnShortcuts: Scalars['Boolean'];
  skipGS1BarcodeCheck: Scalars['Boolean'];
  stockViewLoadAllOnOpen: Scalars['Boolean'];
  stockViewShowOnlyInStock: Scalars['Boolean'];
  storeContactEmailArbitraryInField?: Maybe<Scalars['String']>;
  subjectDocumentListDocumentType?: Maybe<Scalars['String']>;
  subjectFieldForSSCCRequirementCheck?: Maybe<Scalars['String']>;
  subjectFieldValueForSSCCRequirementCheck?: Maybe<Scalars['String']>;
  syncPackagingWhenAddingNewItem: Scalars['Boolean'];
  tHrPrsnForOnlyOnixPhoneUsers?: Maybe<Scalars['Boolean']>;
  tMNAcDefaultStatus?: Maybe<Scalars['String']>;
  tMNAcDefaultSubject?: Maybe<Scalars['String']>;
  tMNAnClassifIcationQid?: Maybe<Scalars['Int']>;
  tMNAnMailBoxQid?: Maybe<Scalars['Int']>;
  tMNAnStorageQid?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSize?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSizeHeight?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSizeWidth?: Maybe<Scalars['Int']>;
  thermalPrintShowCompanyImage: Scalars['Boolean'];
  transferAcDoc1WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAcDoc2WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAdDateDoc1WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAdDateDoc2WhenCopying?: Maybe<Scalars['Boolean']>;
  transferEnteredItemQuantityToSerialNumber?: Maybe<Scalars['Boolean']>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: Maybe<Scalars['Boolean']>;
  treatIdentAsBarcode?: Maybe<Scalars['Boolean']>;
  update: Scalars['Boolean'];
  updateHeadAndDeleteAllItemsOnCopy?: Maybe<Scalars['Boolean']>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: Maybe<Scalars['Boolean']>;
  useDeadlineDateOnOverview: Scalars['Boolean'];
  useLinkSettings: Scalars['Boolean'];
  useSquareArticlePicker?: Maybe<Scalars['Boolean']>;
  useVerySmallMobileInterface?: Maybe<Scalars['Boolean']>;
  visualAttributes?: Maybe<Scalars['String']>;
  visualAttributesOverview?: Maybe<Scalars['String']>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: Maybe<Scalars['Boolean']>;
  warehouseName?: Maybe<Scalars['String']>;
  warehouseOverviewShowOnlyInStock: Scalars['Boolean'];
  warehousePositionTHeSetItemFieldName?: Maybe<Scalars['String']>;
  warehouseShowPrices?: Maybe<Scalars['Boolean']>;
  warehouseViewFixedAcSubject?: Maybe<Scalars['String']>;
  whenAddingSubjectSetAnClerkToCurrentUser?: Maybe<Scalars['Boolean']>;
  workOrderCanBeUnlocked?: Maybe<Scalars['Boolean']>;
  workOrderPrintSpecificationDuration: Scalars['Boolean'];
  workOrderSpecificationPrefillTime?: Maybe<Scalars['Boolean']>;
  workOrderSpecificationTimeNotRequired?: Maybe<Scalars['Boolean']>;
  workOrderUnlockableStatus?: Maybe<Scalars['String']>;
}


declare interface DocumentTypeLinkArbitraryFieldsArgs {
  order?: InputMaybe<Array<DocumentTypeArbitraryFieldSortInput>>;
}

declare interface DocumentTypeLinkFilterInput {
  acDocsOrderingOnPDF?: InputMaybe<StringOperationFilterInput>;
  acFieldSFLabel?: InputMaybe<StringOperationFilterInput>;
  acFiscalDevice?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerName?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName1?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName2?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acName3?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverName?: InputMaybe<StringOperationFilterInput>;
  acSetOfsWhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  acStatusIn?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acWorkPlace?: InputMaybe<StringOperationFilterInput>;
  acceptedByFieldOnPrint?: InputMaybe<StringOperationFilterInput>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc1EntryIsTimeOnly?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc1PDFLabel?: InputMaybe<StringOperationFilterInput>;
  adDateDoc2EntryIsTimeOnly?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc2PDFLabel?: InputMaybe<StringOperationFilterInput>;
  addingItemWarnIfQuantityMoreThanAvailable?: InputMaybe<BooleanOperationFilterInput>;
  adminAllowChangingItemPrice?: InputMaybe<BooleanOperationFilterInput>;
  adminCanEditDocumentAfterSaving?: InputMaybe<BooleanOperationFilterInput>;
  adminDefaultAcPriceRate?: InputMaybe<StringOperationFilterInput>;
  adminDeleteItemsAfterDocumentIsSaved?: InputMaybe<BooleanOperationFilterInput>;
  adminDocumentOnCreateMakeWarehouseReservation?: InputMaybe<BooleanOperationFilterInput>;
  adminEmphasizeInStock?: InputMaybe<BooleanOperationFilterInput>;
  adminForceAcPriceRate?: InputMaybe<StringOperationFilterInput>;
  adminIgnoreRebate1?: InputMaybe<BooleanOperationFilterInput>;
  adminIgnoreRebate2?: InputMaybe<BooleanOperationFilterInput>;
  adminIgnoreRebate3?: InputMaybe<BooleanOperationFilterInput>;
  adminItemQuantityMustBeInStock?: InputMaybe<BooleanOperationFilterInput>;
  adminSavedRebatesForFinalRebate?: InputMaybe<BooleanOperationFilterInput>;
  adminSendDocumentToCompanyDocumentEmail?: InputMaybe<BooleanOperationFilterInput>;
  adminSerialNumbersAreNotAutomated?: InputMaybe<BooleanOperationFilterInput>;
  adminShowDailyIncome?: InputMaybe<BooleanOperationFilterInput>;
  adminShowSubjectAdd?: InputMaybe<BooleanOperationFilterInput>;
  adminUseAnWsPrice?: InputMaybe<BooleanOperationFilterInput>;
  adminUseGenericDocumentsForMoveAndOrder?: InputMaybe<BooleanOperationFilterInput>;
  adminUseSerialNumberForItems?: InputMaybe<BooleanOperationFilterInput>;
  allowChangingWarehouse?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSCRUDOnlyForUsersFiles?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSConfirmation?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSReclassification?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemArticlePicking?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemCostBearerPicking?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemDepartmentPicking?: InputMaybe<BooleanOperationFilterInput>;
  allowGenericDocumentTypeImageAttachments?: InputMaybe<BooleanOperationFilterInput>;
  allowManualVerifyFromDocumentOverview?: InputMaybe<BooleanOperationFilterInput>;
  allowModifyExistingDocuments?: InputMaybe<BooleanOperationFilterInput>;
  allowPullingDMSEInvoicesFromService?: InputMaybe<BooleanOperationFilterInput>;
  allowSavingGeodecodedLocation?: InputMaybe<BooleanOperationFilterInput>;
  allowSelectingMultipleDocumentsToCreateFrom?: InputMaybe<BooleanOperationFilterInput>;
  allowSigningAfterDocumentIsSaved?: InputMaybe<BooleanOperationFilterInput>;
  alwaysShowTheseAcSetOfItem?: InputMaybe<StringOperationFilterInput>;
  alwaysUpdatePriceAndRebateFromClient?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<DocumentTypeLinkFilterInput>>;
  appendToItemIfExists?: InputMaybe<BooleanOperationFilterInput>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Label?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Location?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Value?: InputMaybe<StringOperationFilterInput>;
  arbitraryFields?: InputMaybe<ListFilterInputTypeOfDocumentTypeArbitraryFieldFilterInput>;
  articleDontShowPriceAnyWhere?: InputMaybe<BooleanOperationFilterInput>;
  articleDontShowStockAnyWhere?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchAllowSearchingByClassification?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchInitiallyLoadAll?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchRepeatLastSearch?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsAIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsBIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsCIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsDIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsEIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsFIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsGIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsHIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsIIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsJIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddAIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddBIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddCIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddDIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnAIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnBIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnCIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnDIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnEIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnFIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnGIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnHIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnIIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnJIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  bluetoothPrintCopiesNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  cacheDuration?: InputMaybe<ComparableInt32OperationFilterInput>;
  cacheUseCacheForAnyResource?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForArticleSearch?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForCustomerSearch?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForWarehouseSearch?: InputMaybe<BooleanOperationFilterInput>;
  cardPaymentProvider?: InputMaybe<NullableOfCardPaymentProviderOperationFilterInput>;
  changeDocumentStatusAfterCreated?: InputMaybe<StringOperationFilterInput>;
  changeSourceDocumentStatusTo?: InputMaybe<StringOperationFilterInput>;
  classifs2WhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  classifsWhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  clerkFieldOnPrint?: InputMaybe<StringOperationFilterInput>;
  companyEmailDefaultEmail?: InputMaybe<StringOperationFilterInput>;
  companyEmailPDFBCC?: InputMaybe<StringOperationFilterInput>;
  companyEmailPDFCC?: InputMaybe<StringOperationFilterInput>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: InputMaybe<BooleanOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  completeDeliveryStatus?: InputMaybe<StringOperationFilterInput>;
  copyOnlyLeftOverQuantity?: InputMaybe<BooleanOperationFilterInput>;
  copyOnlyThoseWithLeftOverQuantity0?: InputMaybe<BooleanOperationFilterInput>;
  copyingFromAnotherIsAShadowCopy?: InputMaybe<BooleanOperationFilterInput>;
  create?: InputMaybe<BooleanOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  customContractPriceFilter?: InputMaybe<BooleanOperationFilterInput>;
  customerCodeAllowedKeys?: InputMaybe<StringOperationFilterInput>;
  customerCodeFromAcSkis?: InputMaybe<BooleanOperationFilterInput>;
  customerCodeIsGenerated?: InputMaybe<BooleanOperationFilterInput>;
  dMSListFilterOnDefaultClassification?: InputMaybe<BooleanOperationFilterInput>;
  dateFilterType?: InputMaybe<NullableOfDateFilterTypeOperationFilterInput>;
  defaultCustomerType?: InputMaybe<StringOperationFilterInput>;
  defaultCustomerTypeFilter?: InputMaybe<StringOperationFilterInput>;
  defaultMoveDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultMoveDocumentSortField?: InputMaybe<NullableOfTHeMovePagedSortFieldOperationFilterInput>;
  defaultOrderDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultOrderDocumentSortField?: InputMaybe<NullableOfTHeOrderPagedSortFieldOperationFilterInput>;
  defaultPaymentMethod?: InputMaybe<StringOperationFilterInput>;
  defaultQuantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  defaultSubjectDaysForPaymentOnAdd?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultSubjectPaymentMethodOnAdd?: InputMaybe<StringOperationFilterInput>;
  defaultToThisCustomer?: InputMaybe<StringOperationFilterInput>;
  defaultWoexDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultWoexDocumentSortField?: InputMaybe<NullableOfTHfWoexPagedSortFieldOperationFilterInput>;
  delete?: InputMaybe<BooleanOperationFilterInput>;
  deliveryIsRequired?: InputMaybe<BooleanOperationFilterInput>;
  disableUsingShadowItemAsItemBase?: InputMaybe<BooleanOperationFilterInput>;
  disallowChangingCustomer?: InputMaybe<BooleanOperationFilterInput>;
  disallowChangingItemQuantityOnSerialInput?: InputMaybe<BooleanOperationFilterInput>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: InputMaybe<BooleanOperationFilterInput>;
  disallowManualWarehouseSearch?: InputMaybe<BooleanOperationFilterInput>;
  disallowPickingCustomer?: InputMaybe<BooleanOperationFilterInput>;
  dmsAcStatusIn?: InputMaybe<StringOperationFilterInput>;
  doNotFilterDailyRecapByUserId?: InputMaybe<BooleanOperationFilterInput>;
  documentLinkType?: InputMaybe<StringOperationFilterInput>;
  documentLinkTypeA?: InputMaybe<StringOperationFilterInput>;
  documentLinkTypeB?: InputMaybe<StringOperationFilterInput>;
  documentNote?: InputMaybe<StringOperationFilterInput>;
  documentOnCreateMakeA4Print?: InputMaybe<BooleanOperationFilterInput>;
  documentOnCreateMakeBluetoothPrint?: InputMaybe<BooleanOperationFilterInput>;
  documentOnCreateMakePDF?: InputMaybe<BooleanOperationFilterInput>;
  documentTopAdditionalText?: InputMaybe<StringOperationFilterInput>;
  dontSaveIndividualPDFPages?: InputMaybe<BooleanOperationFilterInput>;
  existingInventoryCheckDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  fillReferentLineWithUserOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  filterByAcDelivery?: InputMaybe<BooleanOperationFilterInput>;
  filterByAcDept?: InputMaybe<StringOperationFilterInput>;
  filterByAcDeptOut?: InputMaybe<StringOperationFilterInput>;
  filterByAcType?: InputMaybe<StringOperationFilterInput>;
  filterByAcVerifiedPrices?: InputMaybe<StringOperationFilterInput>;
  filterByAcVerifyStatus?: InputMaybe<StringOperationFilterInput>;
  filterByCurrentUserIdIsAnSigner1?: InputMaybe<BooleanOperationFilterInput>;
  filterMovesByThisAcIssuer?: InputMaybe<StringOperationFilterInput>;
  filterMovesByThisAcReceiver?: InputMaybe<StringOperationFilterInput>;
  filterOrdersByThisAcWarehouse?: InputMaybe<StringOperationFilterInput>;
  filterReceiversByAcFieldSa?: InputMaybe<StringOperationFilterInput>;
  forceShowAvailableOnStock?: InputMaybe<BooleanOperationFilterInput>;
  functionality?: InputMaybe<DocumentPairFunctionalityEnumOperationFilterInput>;
  generatePrintTimeOnCreate?: InputMaybe<BooleanOperationFilterInput>;
  groupAllCreatingDocumentTypesAtThisPoint?: InputMaybe<BooleanOperationFilterInput>;
  groupAllDocumentTypesAtThisPoint?: InputMaybe<BooleanOperationFilterInput>;
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated?: InputMaybe<BooleanOperationFilterInput>;
  headerClerkPDFLabel?: InputMaybe<StringOperationFilterInput>;
  hideAcceptedByFieldOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideClerkFieldOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideCurrencyDateOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideDMSMetadataEntryFields?: InputMaybe<BooleanOperationFilterInput>;
  hideDataForPaymentOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideDocumentElements?: InputMaybe<StringOperationFilterInput>;
  hideDocumentItemElements?: InputMaybe<StringOperationFilterInput>;
  hideLeftOverQuantityOnPicking?: InputMaybe<BooleanOperationFilterInput>;
  hideNoteInNonHistoricalView?: InputMaybe<BooleanOperationFilterInput>;
  hidePayMethodOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideQuantityEntry?: InputMaybe<BooleanOperationFilterInput>;
  hideVATRecapitulationOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseItemActions?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseOverview?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseSupplier?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderImages?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderMaterials?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderPlaceFromTo?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderReception?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderReclamations?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderServices?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderSpecications?: InputMaybe<BooleanOperationFilterInput>;
  highlightArticlePickerTextOnNextOpen?: InputMaybe<BooleanOperationFilterInput>;
  historyViewIgnoredFilters?: InputMaybe<StringOperationFilterInput>;
  horizontalDoc12AndDates?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  ifAcPayMethodChooseThisDocumentType?: InputMaybe<StringOperationFilterInput>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: InputMaybe<BooleanOperationFilterInput>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: InputMaybe<BooleanOperationFilterInput>;
  ignoreQuantityInWholeDocument?: InputMaybe<BooleanOperationFilterInput>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: InputMaybe<BooleanOperationFilterInput>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  isDisabled?: InputMaybe<BooleanOperationFilterInput>;
  isRetail?: InputMaybe<BooleanOperationFilterInput>;
  itemListShowDetailed?: InputMaybe<BooleanOperationFilterInput>;
  jumpToEditAfterScanningItemWithBarcode?: InputMaybe<BooleanOperationFilterInput>;
  keepAdDateDoc1And2Unrounded?: InputMaybe<BooleanOperationFilterInput>;
  labelDefinitionLocations?: InputMaybe<ListFilterInputTypeOfLabelDefinitionLocationFilterInput>;
  linkFrom?: InputMaybe<ListFilterInputTypeOfDocumentTypeFilterInput>;
  linkTo?: InputMaybe<ListFilterInputTypeOfDocumentTypeFilterInput>;
  makeDocumentLinks?: InputMaybe<BooleanOperationFilterInput>;
  makeSerialStockCheck?: InputMaybe<BooleanOperationFilterInput>;
  manualWorkOrderMaterial?: InputMaybe<StringOperationFilterInput>;
  middleSignatureTextOnPrint?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifierCharacterLabel?: InputMaybe<StringOperationFilterInput>;
  multipleEndDocumentsCaseToPickEndDocument?: InputMaybe<StringOperationFilterInput>;
  mustFiscalize?: InputMaybe<BooleanOperationFilterInput>;
  newNewDocumentInputType?: InputMaybe<BooleanOperationFilterInput>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: InputMaybe<BooleanOperationFilterInput>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DocumentTypeLinkFilterInput>>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: InputMaybe<BooleanOperationFilterInput>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: InputMaybe<BooleanOperationFilterInput>;
  palletEntry?: InputMaybe<BooleanOperationFilterInput>;
  partialDeliveryStatus?: InputMaybe<StringOperationFilterInput>;
  pdfSignWithoutGeneration?: InputMaybe<BooleanOperationFilterInput>;
  pickingShowConfirmationOnPick?: InputMaybe<BooleanOperationFilterInput>;
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: InputMaybe<BooleanOperationFilterInput>;
  printDocumentTitleOverride?: InputMaybe<StringOperationFilterInput>;
  printTicketNameOverride?: InputMaybe<StringOperationFilterInput>;
  prioritisePackageQuantityEntryField?: InputMaybe<BooleanOperationFilterInput>;
  quantityDecimalPlaces?: InputMaybe<ComparableInt32OperationFilterInput>;
  read?: InputMaybe<BooleanOperationFilterInput>;
  recommendToMakeCodebooksOffline?: InputMaybe<BooleanOperationFilterInput>;
  requireASignature?: InputMaybe<BooleanOperationFilterInput>;
  reverseItemsList?: InputMaybe<BooleanOperationFilterInput>;
  saveUnsignedAsSignedPDF?: InputMaybe<BooleanOperationFilterInput>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: InputMaybe<BooleanOperationFilterInput>;
  sendLeftoverShadowsWithZero?: InputMaybe<BooleanOperationFilterInput>;
  serialNumberDirectionIsInput?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeliveryMobileFilterOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeliveryOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeptMobileFilterOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDescrOnPDFs?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc1?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc1OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc2?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc2OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcIdentOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: InputMaybe<StringOperationFilterInput>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: InputMaybe<StringOperationFilterInput>;
  showAdDate?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc1?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc1OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc2?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc2OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAllDMSDocumentsForURAClassifications?: InputMaybe<BooleanOperationFilterInput>;
  showAllDocumentsNotOnlyAnUserIns?: InputMaybe<BooleanOperationFilterInput>;
  showAllItemsIgnoringWarehouse?: InputMaybe<BooleanOperationFilterInput>;
  showAnClerkAndAnNoteClerkIsOROperation?: InputMaybe<BooleanOperationFilterInput>;
  showArticlesGroupedByCodeButSeparate?: InputMaybe<BooleanOperationFilterInput>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: InputMaybe<BooleanOperationFilterInput>;
  showAttachSSCCButton?: InputMaybe<BooleanOperationFilterInput>;
  showBuyerOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showContactEmailEntry?: InputMaybe<BooleanOperationFilterInput>;
  showContactEntry?: InputMaybe<BooleanOperationFilterInput>;
  showCostBearerOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerName2AsPrimaryOnHeader?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerOverview?: InputMaybe<BooleanOperationFilterInput>;
  showCustomersAcName2OnThermalPrint?: InputMaybe<BooleanOperationFilterInput>;
  showDMSXMLItems?: InputMaybe<BooleanOperationFilterInput>;
  showDeliveryDeadlineDays?: InputMaybe<BooleanOperationFilterInput>;
  showDeliveryMethod?: InputMaybe<BooleanOperationFilterInput>;
  showDepartmentAsReceiver?: InputMaybe<BooleanOperationFilterInput>;
  showDepartmentOutAsReceiver?: InputMaybe<BooleanOperationFilterInput>;
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: InputMaybe<StringOperationFilterInput>;
  showDoc12AndTheirDatesOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showInventoryNumberOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showItalianLabelsOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemAcCustomsTariffOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemAnNetWeightOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemPicturesOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showLastNOrdersForCustomer?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  showLineNoteOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showModifierCharacterPicker?: InputMaybe<BooleanOperationFilterInput>;
  showNumberOfUnlinkedDocuments?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyArticlesWithCustomerContractPrice?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyWOWhereCurrentUserSpecExists?: InputMaybe<BooleanOperationFilterInput>;
  showPackageQuantityEntryField?: InputMaybe<BooleanOperationFilterInput>;
  showPaymentMethod?: InputMaybe<BooleanOperationFilterInput>;
  showQuantityPerUnitOfMeasureOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showQuantityTotalOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showReceiverOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showSerialNumberSearchForWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showWOWorkersEntry?: InputMaybe<BooleanOperationFilterInput>;
  skipConfirmationOnShortcuts?: InputMaybe<BooleanOperationFilterInput>;
  skipGS1BarcodeCheck?: InputMaybe<BooleanOperationFilterInput>;
  stockViewLoadAllOnOpen?: InputMaybe<BooleanOperationFilterInput>;
  stockViewShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  storeContactEmailArbitraryInField?: InputMaybe<StringOperationFilterInput>;
  subjectDocumentListDocumentType?: InputMaybe<StringOperationFilterInput>;
  subjectFieldForSSCCRequirementCheck?: InputMaybe<StringOperationFilterInput>;
  subjectFieldValueForSSCCRequirementCheck?: InputMaybe<StringOperationFilterInput>;
  syncPackagingWhenAddingNewItem?: InputMaybe<BooleanOperationFilterInput>;
  tHrPrsnForOnlyOnixPhoneUsers?: InputMaybe<BooleanOperationFilterInput>;
  tMNAcDefaultStatus?: InputMaybe<StringOperationFilterInput>;
  tMNAcDefaultSubject?: InputMaybe<StringOperationFilterInput>;
  tMNAnClassifIcationQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tMNAnMailBoxQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tMNAnStorageQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSize?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSizeHeight?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSizeWidth?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintShowCompanyImage?: InputMaybe<BooleanOperationFilterInput>;
  transferAcDoc1WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAcDoc2WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAdDateDoc1WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAdDateDoc2WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferEnteredItemQuantityToSerialNumber?: InputMaybe<BooleanOperationFilterInput>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: InputMaybe<BooleanOperationFilterInput>;
  treatIdentAsBarcode?: InputMaybe<BooleanOperationFilterInput>;
  update?: InputMaybe<BooleanOperationFilterInput>;
  updateHeadAndDeleteAllItemsOnCopy?: InputMaybe<BooleanOperationFilterInput>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: InputMaybe<BooleanOperationFilterInput>;
  useDeadlineDateOnOverview?: InputMaybe<BooleanOperationFilterInput>;
  useLinkSettings?: InputMaybe<BooleanOperationFilterInput>;
  useSquareArticlePicker?: InputMaybe<BooleanOperationFilterInput>;
  useVerySmallMobileInterface?: InputMaybe<BooleanOperationFilterInput>;
  visualAttributes?: InputMaybe<StringOperationFilterInput>;
  visualAttributesOverview?: InputMaybe<StringOperationFilterInput>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<BooleanOperationFilterInput>;
  warehouseName?: InputMaybe<StringOperationFilterInput>;
  warehouseOverviewShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  warehousePositionTHeSetItemFieldName?: InputMaybe<StringOperationFilterInput>;
  warehouseShowPrices?: InputMaybe<BooleanOperationFilterInput>;
  warehouseViewFixedAcSubject?: InputMaybe<StringOperationFilterInput>;
  whenAddingSubjectSetAnClerkToCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  workOrderCanBeUnlocked?: InputMaybe<BooleanOperationFilterInput>;
  workOrderPrintSpecificationDuration?: InputMaybe<BooleanOperationFilterInput>;
  workOrderSpecificationPrefillTime?: InputMaybe<BooleanOperationFilterInput>;
  workOrderSpecificationTimeNotRequired?: InputMaybe<BooleanOperationFilterInput>;
  workOrderUnlockableStatus?: InputMaybe<StringOperationFilterInput>;
}

declare interface DocumentTypeLinkSortInput {
  acDocsOrderingOnPDF?: InputMaybe<SortEnumType>;
  acFieldSFLabel?: InputMaybe<SortEnumType>;
  acFiscalDevice?: InputMaybe<SortEnumType>;
  acIssuer?: InputMaybe<SortEnumType>;
  acIssuerName?: InputMaybe<SortEnumType>;
  acLinkDocName1?: InputMaybe<SortEnumType>;
  acLinkDocName2?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acName3?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverName?: InputMaybe<SortEnumType>;
  acSetOfsWhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  acStatusIn?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acWorkPlace?: InputMaybe<SortEnumType>;
  acceptedByFieldOnPrint?: InputMaybe<SortEnumType>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<SortEnumType>;
  adDateDoc1EntryIsTimeOnly?: InputMaybe<SortEnumType>;
  adDateDoc1PDFLabel?: InputMaybe<SortEnumType>;
  adDateDoc2EntryIsTimeOnly?: InputMaybe<SortEnumType>;
  adDateDoc2PDFLabel?: InputMaybe<SortEnumType>;
  addingItemWarnIfQuantityMoreThanAvailable?: InputMaybe<SortEnumType>;
  adminAllowChangingItemPrice?: InputMaybe<SortEnumType>;
  adminCanEditDocumentAfterSaving?: InputMaybe<SortEnumType>;
  adminDefaultAcPriceRate?: InputMaybe<SortEnumType>;
  adminDeleteItemsAfterDocumentIsSaved?: InputMaybe<SortEnumType>;
  adminDocumentOnCreateMakeWarehouseReservation?: InputMaybe<SortEnumType>;
  adminEmphasizeInStock?: InputMaybe<SortEnumType>;
  adminForceAcPriceRate?: InputMaybe<SortEnumType>;
  adminIgnoreRebate1?: InputMaybe<SortEnumType>;
  adminIgnoreRebate2?: InputMaybe<SortEnumType>;
  adminIgnoreRebate3?: InputMaybe<SortEnumType>;
  adminItemQuantityMustBeInStock?: InputMaybe<SortEnumType>;
  adminSavedRebatesForFinalRebate?: InputMaybe<SortEnumType>;
  adminSendDocumentToCompanyDocumentEmail?: InputMaybe<SortEnumType>;
  adminSerialNumbersAreNotAutomated?: InputMaybe<SortEnumType>;
  adminShowDailyIncome?: InputMaybe<SortEnumType>;
  adminShowSubjectAdd?: InputMaybe<SortEnumType>;
  adminUseAnWsPrice?: InputMaybe<SortEnumType>;
  adminUseGenericDocumentsForMoveAndOrder?: InputMaybe<SortEnumType>;
  adminUseSerialNumberForItems?: InputMaybe<SortEnumType>;
  allowChangingWarehouse?: InputMaybe<SortEnumType>;
  allowDMSCRUDOnlyForUsersFiles?: InputMaybe<SortEnumType>;
  allowDMSConfirmation?: InputMaybe<SortEnumType>;
  allowDMSReclassification?: InputMaybe<SortEnumType>;
  allowDMSXMLItemArticlePicking?: InputMaybe<SortEnumType>;
  allowDMSXMLItemCostBearerPicking?: InputMaybe<SortEnumType>;
  allowDMSXMLItemDepartmentPicking?: InputMaybe<SortEnumType>;
  allowGenericDocumentTypeImageAttachments?: InputMaybe<SortEnumType>;
  allowManualVerifyFromDocumentOverview?: InputMaybe<SortEnumType>;
  allowModifyExistingDocuments?: InputMaybe<SortEnumType>;
  allowPullingDMSEInvoicesFromService?: InputMaybe<SortEnumType>;
  allowSavingGeodecodedLocation?: InputMaybe<SortEnumType>;
  allowSelectingMultipleDocumentsToCreateFrom?: InputMaybe<SortEnumType>;
  allowSigningAfterDocumentIsSaved?: InputMaybe<SortEnumType>;
  alwaysShowTheseAcSetOfItem?: InputMaybe<SortEnumType>;
  alwaysUpdatePriceAndRebateFromClient?: InputMaybe<SortEnumType>;
  appendToItemIfExists?: InputMaybe<SortEnumType>;
  applicationUser?: InputMaybe<ApplicationUserSortInput>;
  applicationUserId?: InputMaybe<SortEnumType>;
  arbitraryField1Label?: InputMaybe<SortEnumType>;
  arbitraryField1Location?: InputMaybe<SortEnumType>;
  arbitraryField1Value?: InputMaybe<SortEnumType>;
  articleDontShowPriceAnyWhere?: InputMaybe<SortEnumType>;
  articleDontShowStockAnyWhere?: InputMaybe<SortEnumType>;
  articleSearchAllowSearchingByClassification?: InputMaybe<SortEnumType>;
  articleSearchInitiallyLoadAll?: InputMaybe<SortEnumType>;
  articleSearchRepeatLastSearch?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyInStock?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsEIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsFIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsGIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsHIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsIIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsJIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnEIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnFIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnGIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnHIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnIIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnJIs?: InputMaybe<SortEnumType>;
  bluetoothPrintCopiesNumber?: InputMaybe<SortEnumType>;
  cacheDuration?: InputMaybe<SortEnumType>;
  cacheUseCacheForAnyResource?: InputMaybe<SortEnumType>;
  cacheUseForArticleSearch?: InputMaybe<SortEnumType>;
  cacheUseForCustomerSearch?: InputMaybe<SortEnumType>;
  cacheUseForWarehouseSearch?: InputMaybe<SortEnumType>;
  cardPaymentProvider?: InputMaybe<SortEnumType>;
  changeDocumentStatusAfterCreated?: InputMaybe<SortEnumType>;
  changeSourceDocumentStatusTo?: InputMaybe<SortEnumType>;
  classifs2WhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  classifsWhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  clerkFieldOnPrint?: InputMaybe<SortEnumType>;
  companyEmailDefaultEmail?: InputMaybe<SortEnumType>;
  companyEmailPDFBCC?: InputMaybe<SortEnumType>;
  companyEmailPDFCC?: InputMaybe<SortEnumType>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  completeDeliveryStatus?: InputMaybe<SortEnumType>;
  copyOnlyLeftOverQuantity?: InputMaybe<SortEnumType>;
  copyOnlyThoseWithLeftOverQuantity0?: InputMaybe<SortEnumType>;
  copyingFromAnotherIsAShadowCopy?: InputMaybe<SortEnumType>;
  create?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  customContractPriceFilter?: InputMaybe<SortEnumType>;
  customerCodeAllowedKeys?: InputMaybe<SortEnumType>;
  customerCodeFromAcSkis?: InputMaybe<SortEnumType>;
  customerCodeIsGenerated?: InputMaybe<SortEnumType>;
  dMSListFilterOnDefaultClassification?: InputMaybe<SortEnumType>;
  dateFilterType?: InputMaybe<SortEnumType>;
  defaultCustomerType?: InputMaybe<SortEnumType>;
  defaultCustomerTypeFilter?: InputMaybe<SortEnumType>;
  defaultMoveDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultMoveDocumentSortField?: InputMaybe<SortEnumType>;
  defaultOrderDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultOrderDocumentSortField?: InputMaybe<SortEnumType>;
  defaultPaymentMethod?: InputMaybe<SortEnumType>;
  defaultQuantity?: InputMaybe<SortEnumType>;
  defaultSubjectDaysForPaymentOnAdd?: InputMaybe<SortEnumType>;
  defaultSubjectPaymentMethodOnAdd?: InputMaybe<SortEnumType>;
  defaultToThisCustomer?: InputMaybe<SortEnumType>;
  defaultWoexDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultWoexDocumentSortField?: InputMaybe<SortEnumType>;
  delete?: InputMaybe<SortEnumType>;
  deliveryIsRequired?: InputMaybe<SortEnumType>;
  disableUsingShadowItemAsItemBase?: InputMaybe<SortEnumType>;
  disallowChangingCustomer?: InputMaybe<SortEnumType>;
  disallowChangingItemQuantityOnSerialInput?: InputMaybe<SortEnumType>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: InputMaybe<SortEnumType>;
  disallowManualWarehouseSearch?: InputMaybe<SortEnumType>;
  disallowPickingCustomer?: InputMaybe<SortEnumType>;
  dmsAcStatusIn?: InputMaybe<SortEnumType>;
  doNotFilterDailyRecapByUserId?: InputMaybe<SortEnumType>;
  documentLinkType?: InputMaybe<SortEnumType>;
  documentLinkTypeA?: InputMaybe<SortEnumType>;
  documentLinkTypeB?: InputMaybe<SortEnumType>;
  documentNote?: InputMaybe<SortEnumType>;
  documentOnCreateMakeA4Print?: InputMaybe<SortEnumType>;
  documentOnCreateMakeBluetoothPrint?: InputMaybe<SortEnumType>;
  documentOnCreateMakePDF?: InputMaybe<SortEnumType>;
  documentTopAdditionalText?: InputMaybe<SortEnumType>;
  dontSaveIndividualPDFPages?: InputMaybe<SortEnumType>;
  existingInventoryCheckDays?: InputMaybe<SortEnumType>;
  fillReferentLineWithUserOnPrint?: InputMaybe<SortEnumType>;
  filterByAcDelivery?: InputMaybe<SortEnumType>;
  filterByAcDept?: InputMaybe<SortEnumType>;
  filterByAcDeptOut?: InputMaybe<SortEnumType>;
  filterByAcType?: InputMaybe<SortEnumType>;
  filterByAcVerifiedPrices?: InputMaybe<SortEnumType>;
  filterByAcVerifyStatus?: InputMaybe<SortEnumType>;
  filterByCurrentUserIdIsAnSigner1?: InputMaybe<SortEnumType>;
  filterMovesByThisAcIssuer?: InputMaybe<SortEnumType>;
  filterMovesByThisAcReceiver?: InputMaybe<SortEnumType>;
  filterOrdersByThisAcWarehouse?: InputMaybe<SortEnumType>;
  filterReceiversByAcFieldSa?: InputMaybe<SortEnumType>;
  forceShowAvailableOnStock?: InputMaybe<SortEnumType>;
  functionality?: InputMaybe<SortEnumType>;
  generatePrintTimeOnCreate?: InputMaybe<SortEnumType>;
  groupAllCreatingDocumentTypesAtThisPoint?: InputMaybe<SortEnumType>;
  groupAllDocumentTypesAtThisPoint?: InputMaybe<SortEnumType>;
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated?: InputMaybe<SortEnumType>;
  headerClerkPDFLabel?: InputMaybe<SortEnumType>;
  hideAcceptedByFieldOnPrint?: InputMaybe<SortEnumType>;
  hideClerkFieldOnPrint?: InputMaybe<SortEnumType>;
  hideCurrencyDateOnPrint?: InputMaybe<SortEnumType>;
  hideDMSMetadataEntryFields?: InputMaybe<SortEnumType>;
  hideDataForPaymentOnPrint?: InputMaybe<SortEnumType>;
  hideDocumentElements?: InputMaybe<SortEnumType>;
  hideDocumentItemElements?: InputMaybe<SortEnumType>;
  hideLeftOverQuantityOnPicking?: InputMaybe<SortEnumType>;
  hideNoteInNonHistoricalView?: InputMaybe<SortEnumType>;
  hidePayMethodOnPrint?: InputMaybe<SortEnumType>;
  hideQuantityEntry?: InputMaybe<SortEnumType>;
  hideVATRecapitulationOnPrint?: InputMaybe<SortEnumType>;
  hideWarehouseItemActions?: InputMaybe<SortEnumType>;
  hideWarehouseOverview?: InputMaybe<SortEnumType>;
  hideWarehouseSupplier?: InputMaybe<SortEnumType>;
  hideWorkOrderImages?: InputMaybe<SortEnumType>;
  hideWorkOrderMaterials?: InputMaybe<SortEnumType>;
  hideWorkOrderPlaceFromTo?: InputMaybe<SortEnumType>;
  hideWorkOrderReception?: InputMaybe<SortEnumType>;
  hideWorkOrderReclamations?: InputMaybe<SortEnumType>;
  hideWorkOrderServices?: InputMaybe<SortEnumType>;
  hideWorkOrderSpecications?: InputMaybe<SortEnumType>;
  highlightArticlePickerTextOnNextOpen?: InputMaybe<SortEnumType>;
  historyViewIgnoredFilters?: InputMaybe<SortEnumType>;
  horizontalDoc12AndDates?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  ifAcPayMethodChooseThisDocumentType?: InputMaybe<SortEnumType>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: InputMaybe<SortEnumType>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: InputMaybe<SortEnumType>;
  ignoreQuantityInWholeDocument?: InputMaybe<SortEnumType>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: InputMaybe<SortEnumType>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: InputMaybe<SortEnumType>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: InputMaybe<SortEnumType>;
  isDisabled?: InputMaybe<SortEnumType>;
  isRetail?: InputMaybe<SortEnumType>;
  itemListShowDetailed?: InputMaybe<SortEnumType>;
  jumpToEditAfterScanningItemWithBarcode?: InputMaybe<SortEnumType>;
  keepAdDateDoc1And2Unrounded?: InputMaybe<SortEnumType>;
  makeDocumentLinks?: InputMaybe<SortEnumType>;
  makeSerialStockCheck?: InputMaybe<SortEnumType>;
  manualWorkOrderMaterial?: InputMaybe<SortEnumType>;
  middleSignatureTextOnPrint?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifierCharacterLabel?: InputMaybe<SortEnumType>;
  multipleEndDocumentsCaseToPickEndDocument?: InputMaybe<SortEnumType>;
  mustFiscalize?: InputMaybe<SortEnumType>;
  newNewDocumentInputType?: InputMaybe<SortEnumType>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: InputMaybe<SortEnumType>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: InputMaybe<SortEnumType>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: InputMaybe<SortEnumType>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: InputMaybe<SortEnumType>;
  palletEntry?: InputMaybe<SortEnumType>;
  partialDeliveryStatus?: InputMaybe<SortEnumType>;
  pdfSignWithoutGeneration?: InputMaybe<SortEnumType>;
  pickingShowConfirmationOnPick?: InputMaybe<SortEnumType>;
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: InputMaybe<SortEnumType>;
  printDocumentTitleOverride?: InputMaybe<SortEnumType>;
  printTicketNameOverride?: InputMaybe<SortEnumType>;
  prioritisePackageQuantityEntryField?: InputMaybe<SortEnumType>;
  quantityDecimalPlaces?: InputMaybe<SortEnumType>;
  read?: InputMaybe<SortEnumType>;
  recommendToMakeCodebooksOffline?: InputMaybe<SortEnumType>;
  requireASignature?: InputMaybe<SortEnumType>;
  reverseItemsList?: InputMaybe<SortEnumType>;
  saveUnsignedAsSignedPDF?: InputMaybe<SortEnumType>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: InputMaybe<SortEnumType>;
  sendLeftoverShadowsWithZero?: InputMaybe<SortEnumType>;
  serialNumberDirectionIsInput?: InputMaybe<SortEnumType>;
  showAcDeliveryMobileFilterOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDeliveryOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDeptMobileFilterOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDescrOnPDFs?: InputMaybe<SortEnumType>;
  showAcDoc1?: InputMaybe<SortEnumType>;
  showAcDoc1OnPrint?: InputMaybe<SortEnumType>;
  showAcDoc2?: InputMaybe<SortEnumType>;
  showAcDoc2OnPrint?: InputMaybe<SortEnumType>;
  showAcIdentOnPrint?: InputMaybe<SortEnumType>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: InputMaybe<SortEnumType>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: InputMaybe<SortEnumType>;
  showAdDate?: InputMaybe<SortEnumType>;
  showAdDateDoc1?: InputMaybe<SortEnumType>;
  showAdDateDoc1OnPrint?: InputMaybe<SortEnumType>;
  showAdDateDoc2?: InputMaybe<SortEnumType>;
  showAdDateDoc2OnPrint?: InputMaybe<SortEnumType>;
  showAllDMSDocumentsForURAClassifications?: InputMaybe<SortEnumType>;
  showAllDocumentsNotOnlyAnUserIns?: InputMaybe<SortEnumType>;
  showAllItemsIgnoringWarehouse?: InputMaybe<SortEnumType>;
  showAnClerkAndAnNoteClerkIsOROperation?: InputMaybe<SortEnumType>;
  showArticlesGroupedByCodeButSeparate?: InputMaybe<SortEnumType>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: InputMaybe<SortEnumType>;
  showAttachSSCCButton?: InputMaybe<SortEnumType>;
  showBuyerOnWorkOrders?: InputMaybe<SortEnumType>;
  showContactEmailEntry?: InputMaybe<SortEnumType>;
  showContactEntry?: InputMaybe<SortEnumType>;
  showCostBearerOnWorkOrders?: InputMaybe<SortEnumType>;
  showCustomerName2AsPrimaryOnHeader?: InputMaybe<SortEnumType>;
  showCustomerOverview?: InputMaybe<SortEnumType>;
  showCustomersAcName2OnThermalPrint?: InputMaybe<SortEnumType>;
  showDMSXMLItems?: InputMaybe<SortEnumType>;
  showDeliveryDeadlineDays?: InputMaybe<SortEnumType>;
  showDeliveryMethod?: InputMaybe<SortEnumType>;
  showDepartmentAsReceiver?: InputMaybe<SortEnumType>;
  showDepartmentOutAsReceiver?: InputMaybe<SortEnumType>;
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: InputMaybe<SortEnumType>;
  showDoc12AndTheirDatesOnDocumentList?: InputMaybe<SortEnumType>;
  showInventoryNumberOnWorkOrders?: InputMaybe<SortEnumType>;
  showItalianLabelsOnPrint?: InputMaybe<SortEnumType>;
  showItemAcCustomsTariffOnPrint?: InputMaybe<SortEnumType>;
  showItemAnNetWeightOnPrint?: InputMaybe<SortEnumType>;
  showItemPicturesOnPrint?: InputMaybe<SortEnumType>;
  showLastNOrdersForCustomer?: InputMaybe<SortEnumType>;
  showLineNoteOnPrint?: InputMaybe<SortEnumType>;
  showModifierCharacterPicker?: InputMaybe<SortEnumType>;
  showNumberOfUnlinkedDocuments?: InputMaybe<SortEnumType>;
  showOnlyArticlesWithCustomerContractPrice?: InputMaybe<SortEnumType>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: InputMaybe<SortEnumType>;
  showOnlyWOWhereCurrentUserSpecExists?: InputMaybe<SortEnumType>;
  showPackageQuantityEntryField?: InputMaybe<SortEnumType>;
  showPaymentMethod?: InputMaybe<SortEnumType>;
  showQuantityPerUnitOfMeasureOnPrint?: InputMaybe<SortEnumType>;
  showQuantityTotalOnPrint?: InputMaybe<SortEnumType>;
  showReceiverOnWorkOrders?: InputMaybe<SortEnumType>;
  showSerialNumberSearchForWorkOrders?: InputMaybe<SortEnumType>;
  showWOWorkersEntry?: InputMaybe<SortEnumType>;
  skipConfirmationOnShortcuts?: InputMaybe<SortEnumType>;
  skipGS1BarcodeCheck?: InputMaybe<SortEnumType>;
  stockViewLoadAllOnOpen?: InputMaybe<SortEnumType>;
  stockViewShowOnlyInStock?: InputMaybe<SortEnumType>;
  storeContactEmailArbitraryInField?: InputMaybe<SortEnumType>;
  subjectDocumentListDocumentType?: InputMaybe<SortEnumType>;
  subjectFieldForSSCCRequirementCheck?: InputMaybe<SortEnumType>;
  subjectFieldValueForSSCCRequirementCheck?: InputMaybe<SortEnumType>;
  syncPackagingWhenAddingNewItem?: InputMaybe<SortEnumType>;
  tHrPrsnForOnlyOnixPhoneUsers?: InputMaybe<SortEnumType>;
  tMNAcDefaultStatus?: InputMaybe<SortEnumType>;
  tMNAcDefaultSubject?: InputMaybe<SortEnumType>;
  tMNAnClassifIcationQid?: InputMaybe<SortEnumType>;
  tMNAnMailBoxQid?: InputMaybe<SortEnumType>;
  tMNAnStorageQid?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSize?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSizeHeight?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSizeWidth?: InputMaybe<SortEnumType>;
  thermalPrintShowCompanyImage?: InputMaybe<SortEnumType>;
  transferAcDoc1WhenCopying?: InputMaybe<SortEnumType>;
  transferAcDoc2WhenCopying?: InputMaybe<SortEnumType>;
  transferAdDateDoc1WhenCopying?: InputMaybe<SortEnumType>;
  transferAdDateDoc2WhenCopying?: InputMaybe<SortEnumType>;
  transferEnteredItemQuantityToSerialNumber?: InputMaybe<SortEnumType>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: InputMaybe<SortEnumType>;
  treatIdentAsBarcode?: InputMaybe<SortEnumType>;
  update?: InputMaybe<SortEnumType>;
  updateHeadAndDeleteAllItemsOnCopy?: InputMaybe<SortEnumType>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: InputMaybe<SortEnumType>;
  useDeadlineDateOnOverview?: InputMaybe<SortEnumType>;
  useLinkSettings?: InputMaybe<SortEnumType>;
  useSquareArticlePicker?: InputMaybe<SortEnumType>;
  useVerySmallMobileInterface?: InputMaybe<SortEnumType>;
  visualAttributes?: InputMaybe<SortEnumType>;
  visualAttributesOverview?: InputMaybe<SortEnumType>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<SortEnumType>;
  warehouseName?: InputMaybe<SortEnumType>;
  warehouseOverviewShowOnlyInStock?: InputMaybe<SortEnumType>;
  warehousePositionTHeSetItemFieldName?: InputMaybe<SortEnumType>;
  warehouseShowPrices?: InputMaybe<SortEnumType>;
  warehouseViewFixedAcSubject?: InputMaybe<SortEnumType>;
  whenAddingSubjectSetAnClerkToCurrentUser?: InputMaybe<SortEnumType>;
  workOrderCanBeUnlocked?: InputMaybe<SortEnumType>;
  workOrderPrintSpecificationDuration?: InputMaybe<SortEnumType>;
  workOrderSpecificationPrefillTime?: InputMaybe<SortEnumType>;
  workOrderSpecificationTimeNotRequired?: InputMaybe<SortEnumType>;
  workOrderUnlockableStatus?: InputMaybe<SortEnumType>;
}

declare interface DocumentTypePair {
  acDocsOrderingOnPDF?: Maybe<Scalars['String']>;
  acFieldSFLabel?: Maybe<Scalars['String']>;
  acFiscalDevice?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerName?: Maybe<Scalars['String']>;
  acLinkDocName1?: Maybe<Scalars['String']>;
  acLinkDocName2?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acName3?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverName?: Maybe<Scalars['String']>;
  acSetOfsWhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  acStatusIn?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acWorkPlace?: Maybe<Scalars['String']>;
  acceptedByFieldOnPrint?: Maybe<Scalars['String']>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: Maybe<Scalars['Boolean']>;
  adDateDoc1EntryIsTimeOnly?: Maybe<Scalars['Boolean']>;
  adDateDoc1PDFLabel?: Maybe<Scalars['String']>;
  adDateDoc2EntryIsTimeOnly?: Maybe<Scalars['Boolean']>;
  adDateDoc2PDFLabel?: Maybe<Scalars['String']>;
  addingItemWarnIfQuantityMoreThanAvailable: Scalars['Boolean'];
  adminAllowChangingItemPrice: Scalars['Boolean'];
  adminCanEditDocumentAfterSaving: Scalars['Boolean'];
  adminDefaultAcPriceRate?: Maybe<Scalars['String']>;
  adminDeleteItemsAfterDocumentIsSaved: Scalars['Boolean'];
  adminDocumentOnCreateMakeWarehouseReservation: Scalars['Boolean'];
  adminEmphasizeInStock: Scalars['Boolean'];
  adminForceAcPriceRate?: Maybe<Scalars['String']>;
  adminIgnoreRebate1: Scalars['Boolean'];
  adminIgnoreRebate2: Scalars['Boolean'];
  adminIgnoreRebate3: Scalars['Boolean'];
  adminItemQuantityMustBeInStock: Scalars['Boolean'];
  adminSavedRebatesForFinalRebate: Scalars['Boolean'];
  adminSendDocumentToCompanyDocumentEmail: Scalars['Boolean'];
  adminSerialNumbersAreNotAutomated?: Maybe<Scalars['Boolean']>;
  adminShowDailyIncome: Scalars['Boolean'];
  adminShowSubjectAdd: Scalars['Boolean'];
  adminUseAnWsPrice: Scalars['Boolean'];
  adminUseGenericDocumentsForMoveAndOrder: Scalars['Boolean'];
  adminUseSerialNumberForItems: Scalars['Boolean'];
  allowChangingWarehouse?: Maybe<Scalars['Boolean']>;
  allowDMSCRUDOnlyForUsersFiles?: Maybe<Scalars['Boolean']>;
  allowDMSConfirmation?: Maybe<Scalars['Boolean']>;
  allowDMSReclassification?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemArticlePicking?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemCostBearerPicking?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemDepartmentPicking?: Maybe<Scalars['Boolean']>;
  allowGenericDocumentTypeImageAttachments?: Maybe<Scalars['Boolean']>;
  allowManualVerifyFromDocumentOverview?: Maybe<Scalars['Boolean']>;
  allowModifyExistingDocuments: Scalars['Boolean'];
  allowPullingDMSEInvoicesFromService?: Maybe<Scalars['Boolean']>;
  allowSavingGeodecodedLocation?: Maybe<Scalars['Boolean']>;
  allowSelectingMultipleDocumentsToCreateFrom?: Maybe<Scalars['Boolean']>;
  allowSigningAfterDocumentIsSaved?: Maybe<Scalars['Boolean']>;
  alwaysShowTheseAcSetOfItem?: Maybe<Scalars['String']>;
  alwaysUpdatePriceAndRebateFromClient?: Maybe<Scalars['Boolean']>;
  appendToItemIfExists?: Maybe<Scalars['Boolean']>;
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  arbitraryField1Label?: Maybe<Scalars['String']>;
  arbitraryField1Location?: Maybe<Scalars['String']>;
  arbitraryField1Value?: Maybe<Scalars['String']>;
  arbitraryFields: Array<DocumentTypeArbitraryField>;
  articleDontShowPriceAnyWhere: Scalars['Boolean'];
  articleDontShowStockAnyWhere: Scalars['Boolean'];
  articleSearchAllowSearchingByClassification: Scalars['Boolean'];
  articleSearchInitiallyLoadAll: Scalars['Boolean'];
  articleSearchRepeatLastSearch: Scalars['Boolean'];
  articleSearchShowOnlyInStock: Scalars['Boolean'];
  articleSearchShowOnlyWhereAcClassifIsIn?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsAIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsBIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsCIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsDIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsEIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsFIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsGIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsHIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsIIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsJIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAdFielddAIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddBIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddCIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddDIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAnFieldnAIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnBIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnCIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnDIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnEIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnFIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnGIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnHIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnIIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnJIs?: Maybe<Scalars['Decimal']>;
  bluetoothPrintCopiesNumber: Scalars['Int'];
  cacheDuration: Scalars['Int'];
  cacheUseCacheForAnyResource: Scalars['Boolean'];
  cacheUseForArticleSearch: Scalars['Boolean'];
  cacheUseForCustomerSearch: Scalars['Boolean'];
  cacheUseForWarehouseSearch: Scalars['Boolean'];
  cardPaymentProvider?: Maybe<CardPaymentProvider>;
  changeDocumentStatusAfterCreated?: Maybe<Scalars['String']>;
  changeSourceDocumentStatusTo?: Maybe<Scalars['String']>;
  classifs2WhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  classifsWhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  clerkFieldOnPrint?: Maybe<Scalars['String']>;
  companyEmailDefaultEmail?: Maybe<Scalars['String']>;
  companyEmailPDFBCC?: Maybe<Scalars['String']>;
  companyEmailPDFCC?: Maybe<Scalars['String']>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: Maybe<Scalars['Boolean']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  completeDeliveryStatus?: Maybe<Scalars['String']>;
  copyOnlyLeftOverQuantity?: Maybe<Scalars['Boolean']>;
  copyOnlyThoseWithLeftOverQuantity0?: Maybe<Scalars['Boolean']>;
  copyingFromAnotherIsAShadowCopy?: Maybe<Scalars['Boolean']>;
  create: Scalars['Boolean'];
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  customContractPriceFilter?: Maybe<Scalars['Boolean']>;
  customerCodeAllowedKeys?: Maybe<Scalars['String']>;
  customerCodeFromAcSkis?: Maybe<Scalars['Boolean']>;
  customerCodeIsGenerated?: Maybe<Scalars['Boolean']>;
  dMSListFilterOnDefaultClassification?: Maybe<Scalars['Boolean']>;
  dateFilterType?: Maybe<DateFilterType>;
  defaultCustomerType?: Maybe<Scalars['String']>;
  defaultCustomerTypeFilter?: Maybe<Scalars['String']>;
  defaultMoveDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultMoveDocumentSortField?: Maybe<THeMovePagedSortField>;
  defaultOrderDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultOrderDocumentSortField?: Maybe<THeOrderPagedSortField>;
  defaultPaymentMethod?: Maybe<Scalars['String']>;
  defaultQuantity?: Maybe<Scalars['Decimal']>;
  defaultSubjectDaysForPaymentOnAdd?: Maybe<Scalars['Int']>;
  defaultSubjectPaymentMethodOnAdd?: Maybe<Scalars['String']>;
  defaultToThisCustomer?: Maybe<Scalars['String']>;
  defaultWoexDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultWoexDocumentSortField?: Maybe<THfWoexPagedSortField>;
  delete: Scalars['Boolean'];
  deliveryIsRequired?: Maybe<Scalars['Boolean']>;
  disableUsingShadowItemAsItemBase?: Maybe<Scalars['Boolean']>;
  disallowChangingCustomer: Scalars['Boolean'];
  disallowChangingItemQuantityOnSerialInput?: Maybe<Scalars['Boolean']>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: Maybe<Scalars['Boolean']>;
  disallowManualWarehouseSearch?: Maybe<Scalars['Boolean']>;
  disallowPickingCustomer: Scalars['Boolean'];
  dmsAcStatusIn?: Maybe<Scalars['String']>;
  doNotFilterDailyRecapByUserId?: Maybe<Scalars['Boolean']>;
  documentLinkType?: Maybe<Scalars['String']>;
  documentLinkTypeA?: Maybe<Scalars['String']>;
  documentLinkTypeB?: Maybe<Scalars['String']>;
  documentNote?: Maybe<Scalars['String']>;
  documentOnCreateMakeA4Print?: Maybe<Scalars['Boolean']>;
  documentOnCreateMakeBluetoothPrint: Scalars['Boolean'];
  documentOnCreateMakePDF: Scalars['Boolean'];
  documentTopAdditionalText?: Maybe<Scalars['String']>;
  dontSaveIndividualPDFPages?: Maybe<Scalars['Boolean']>;
  existingInventoryCheckDays?: Maybe<Scalars['Int']>;
  fillReferentLineWithUserOnPrint?: Maybe<Scalars['Boolean']>;
  filterByAcDelivery: Scalars['Boolean'];
  filterByAcDept?: Maybe<Scalars['String']>;
  filterByAcDeptOut?: Maybe<Scalars['String']>;
  filterByAcType?: Maybe<Scalars['String']>;
  filterByAcVerifiedPrices?: Maybe<Scalars['String']>;
  filterByAcVerifyStatus?: Maybe<Scalars['String']>;
  filterByCurrentUserIdIsAnSigner1?: Maybe<Scalars['Boolean']>;
  filterByUserOnAcIssuer: Scalars['Boolean'];
  filterByUserOnAcReceiver: Scalars['Boolean'];
  filterMovesByThisAcIssuer?: Maybe<Scalars['String']>;
  filterMovesByThisAcReceiver?: Maybe<Scalars['String']>;
  filterOrdersByThisAcWarehouse?: Maybe<Scalars['String']>;
  filterReceiversByAcFieldSa?: Maybe<Scalars['String']>;
  forceShowAvailableOnStock: Scalars['Boolean'];
  from?: Maybe<DocumentType>;
  fromId: Scalars['Int'];
  functionality: DocumentPairFunctionalityEnum;
  generatePrintTimeOnCreate: Scalars['Boolean'];
  groupAllCreatingDocumentTypesAtThisPoint: Scalars['Boolean'];
  groupAllDocumentTypesAtThisPoint: Scalars['Boolean'];
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated: Scalars['Boolean'];
  headerClerkPDFLabel?: Maybe<Scalars['String']>;
  hideAcceptedByFieldOnPrint?: Maybe<Scalars['Boolean']>;
  hideClerkFieldOnPrint?: Maybe<Scalars['Boolean']>;
  hideCurrencyDateOnPrint?: Maybe<Scalars['Boolean']>;
  hideDMSMetadataEntryFields?: Maybe<Scalars['Boolean']>;
  hideDataForPaymentOnPrint?: Maybe<Scalars['Boolean']>;
  hideDocumentElements?: Maybe<Scalars['String']>;
  hideDocumentItemElements?: Maybe<Scalars['String']>;
  hideLeftOverQuantityOnPicking?: Maybe<Scalars['Boolean']>;
  hideNoteInNonHistoricalView?: Maybe<Scalars['Boolean']>;
  hidePayMethodOnPrint?: Maybe<Scalars['Boolean']>;
  hideQuantityEntry?: Maybe<Scalars['Boolean']>;
  hideVATRecapitulationOnPrint?: Maybe<Scalars['Boolean']>;
  hideWarehouseItemActions?: Maybe<Scalars['Boolean']>;
  hideWarehouseOverview?: Maybe<Scalars['Boolean']>;
  hideWarehouseSupplier?: Maybe<Scalars['Boolean']>;
  hideWorkOrderImages?: Maybe<Scalars['Boolean']>;
  hideWorkOrderMaterials?: Maybe<Scalars['Boolean']>;
  hideWorkOrderPlaceFromTo?: Maybe<Scalars['Boolean']>;
  hideWorkOrderReception?: Maybe<Scalars['Boolean']>;
  hideWorkOrderReclamations?: Maybe<Scalars['Boolean']>;
  hideWorkOrderServices?: Maybe<Scalars['Boolean']>;
  hideWorkOrderSpecications?: Maybe<Scalars['Boolean']>;
  highlightArticlePickerTextOnNextOpen?: Maybe<Scalars['Boolean']>;
  historyViewIgnoredFilters?: Maybe<Scalars['String']>;
  horizontalDoc12AndDates?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  ifAcPayMethodChooseThisDocumentType?: Maybe<Scalars['String']>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: Maybe<Scalars['Boolean']>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: Maybe<Scalars['Boolean']>;
  ignoreQuantityInWholeDocument?: Maybe<Scalars['Boolean']>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: Maybe<Scalars['Boolean']>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: Maybe<Scalars['Boolean']>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isRetail?: Maybe<Scalars['Boolean']>;
  itemListShowDetailed: Scalars['Boolean'];
  jumpToEditAfterScanningItemWithBarcode: Scalars['Boolean'];
  keepAdDateDoc1And2Unrounded?: Maybe<Scalars['Boolean']>;
  labelDefinitionLocations: Array<LabelDefinitionLocation>;
  makeDocumentLinks?: Maybe<Scalars['Boolean']>;
  makeSerialStockCheck?: Maybe<Scalars['Boolean']>;
  manualWorkOrderMaterial?: Maybe<Scalars['String']>;
  middleSignatureTextOnPrint?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  modifierCharacterLabel?: Maybe<Scalars['String']>;
  multipleEndDocumentsCaseToPickEndDocument?: Maybe<Scalars['String']>;
  mustFiscalize?: Maybe<Scalars['Boolean']>;
  newNewDocumentInputType?: Maybe<Scalars['Boolean']>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: Maybe<Scalars['Boolean']>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: Maybe<Scalars['Boolean']>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: Maybe<Scalars['Boolean']>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: Maybe<Scalars['Boolean']>;
  palletEntry?: Maybe<Scalars['Boolean']>;
  partialDeliveryStatus?: Maybe<Scalars['String']>;
  pdfSignWithoutGeneration?: Maybe<Scalars['Boolean']>;
  pickingShowConfirmationOnPick: Scalars['Boolean'];
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: Maybe<Scalars['Boolean']>;
  printDocumentTitleOverride?: Maybe<Scalars['String']>;
  printTicketNameOverride?: Maybe<Scalars['String']>;
  prioritisePackageQuantityEntryField?: Maybe<Scalars['Boolean']>;
  quantityDecimalPlaces: Scalars['Int'];
  read: Scalars['Boolean'];
  recommendToMakeCodebooksOffline?: Maybe<Scalars['Boolean']>;
  requireASignature: Scalars['Boolean'];
  reverseItemsList?: Maybe<Scalars['Boolean']>;
  saveUnsignedAsSignedPDF?: Maybe<Scalars['Boolean']>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: Maybe<Scalars['Boolean']>;
  sendLeftoverShadowsWithZero?: Maybe<Scalars['Boolean']>;
  serialNumberDirectionIsInput?: Maybe<Scalars['Boolean']>;
  showAcDeliveryMobileFilterOnDocumentList: Scalars['Boolean'];
  showAcDeliveryOnDocumentList: Scalars['Boolean'];
  showAcDeptMobileFilterOnDocumentList: Scalars['Boolean'];
  showAcDescrOnPDFs?: Maybe<Scalars['Boolean']>;
  showAcDoc1?: Maybe<Scalars['Boolean']>;
  showAcDoc1OnPrint?: Maybe<Scalars['Boolean']>;
  showAcDoc2?: Maybe<Scalars['Boolean']>;
  showAcDoc2OnPrint?: Maybe<Scalars['Boolean']>;
  showAcIdentOnPrint?: Maybe<Scalars['Boolean']>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: Maybe<Scalars['String']>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: Maybe<Scalars['String']>;
  showAdDate?: Maybe<Scalars['Boolean']>;
  showAdDateDoc1?: Maybe<Scalars['Boolean']>;
  showAdDateDoc1OnPrint?: Maybe<Scalars['Boolean']>;
  showAdDateDoc2?: Maybe<Scalars['Boolean']>;
  showAdDateDoc2OnPrint?: Maybe<Scalars['Boolean']>;
  showAllDMSDocumentsForURAClassifications?: Maybe<Scalars['Boolean']>;
  showAllDocumentsNotOnlyAnUserIns?: Maybe<Scalars['Boolean']>;
  showAllItemsIgnoringWarehouse?: Maybe<Scalars['Boolean']>;
  showAnClerkAndAnNoteClerkIsOROperation?: Maybe<Scalars['Boolean']>;
  showArticlesGroupedByCodeButSeparate?: Maybe<Scalars['Boolean']>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: Maybe<Scalars['Boolean']>;
  showAttachSSCCButton?: Maybe<Scalars['Boolean']>;
  showBuyerOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showContactEmailEntry?: Maybe<Scalars['Boolean']>;
  showContactEntry?: Maybe<Scalars['Boolean']>;
  showCostBearerOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showCustomerName2AsPrimaryOnHeader?: Maybe<Scalars['Boolean']>;
  showCustomerOverview?: Maybe<Scalars['Boolean']>;
  showCustomersAcName2OnThermalPrint?: Maybe<Scalars['Boolean']>;
  showDMSXMLItems?: Maybe<Scalars['Boolean']>;
  showDeliveryDeadlineDays: Scalars['Boolean'];
  showDeliveryMethod: Scalars['Boolean'];
  showDepartmentAsReceiver: Scalars['Boolean'];
  showDepartmentOutAsReceiver: Scalars['Boolean'];
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: Maybe<Scalars['String']>;
  showDoc12AndTheirDatesOnDocumentList?: Maybe<Scalars['Boolean']>;
  showInventoryNumberOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showItalianLabelsOnPrint?: Maybe<Scalars['Boolean']>;
  showItemAcCustomsTariffOnPrint?: Maybe<Scalars['Boolean']>;
  showItemAnNetWeightOnPrint?: Maybe<Scalars['Boolean']>;
  showItemPicturesOnPrint?: Maybe<Scalars['Boolean']>;
  showLastNOrdersForCustomer?: Maybe<Scalars['Int']>;
  showLineNoteOnPrint: Scalars['Boolean'];
  showModifierCharacterPicker: Scalars['Boolean'];
  showNumberOfUnlinkedDocuments?: Maybe<Scalars['Boolean']>;
  showOnlyArticlesWithCustomerContractPrice: Scalars['Boolean'];
  showOnlyDMSDocumentsAssignedToMe?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: Maybe<Scalars['Boolean']>;
  showOnlyWOWhereCurrentUserSpecExists?: Maybe<Scalars['Boolean']>;
  showPackageQuantityEntryField?: Maybe<Scalars['Boolean']>;
  showPaymentMethod: Scalars['Boolean'];
  showQuantityPerUnitOfMeasureOnPrint?: Maybe<Scalars['Boolean']>;
  showQuantityTotalOnPrint?: Maybe<Scalars['Boolean']>;
  showReceiverOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showSerialNumberSearchForWorkOrders?: Maybe<Scalars['Boolean']>;
  showWOWorkersEntry?: Maybe<Scalars['Boolean']>;
  skipConfirmationOnShortcuts: Scalars['Boolean'];
  skipGS1BarcodeCheck: Scalars['Boolean'];
  stockViewLoadAllOnOpen: Scalars['Boolean'];
  stockViewShowOnlyInStock: Scalars['Boolean'];
  storeContactEmailArbitraryInField?: Maybe<Scalars['String']>;
  subjectDocumentListDocumentType?: Maybe<Scalars['String']>;
  subjectFieldForSSCCRequirementCheck?: Maybe<Scalars['String']>;
  subjectFieldValueForSSCCRequirementCheck?: Maybe<Scalars['String']>;
  syncPackagingWhenAddingNewItem: Scalars['Boolean'];
  tHrPrsnForOnlyOnixPhoneUsers?: Maybe<Scalars['Boolean']>;
  tMNAcDefaultStatus?: Maybe<Scalars['String']>;
  tMNAcDefaultSubject?: Maybe<Scalars['String']>;
  tMNAnClassifIcationQid?: Maybe<Scalars['Int']>;
  tMNAnMailBoxQid?: Maybe<Scalars['Int']>;
  tMNAnStorageQid?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSize?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSizeHeight?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSizeWidth?: Maybe<Scalars['Int']>;
  thermalPrintShowCompanyImage: Scalars['Boolean'];
  to?: Maybe<DocumentType>;
  toId: Scalars['Int'];
  transferAcDoc1WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAcDoc2WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAdDateDoc1WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAdDateDoc2WhenCopying?: Maybe<Scalars['Boolean']>;
  transferEnteredItemQuantityToSerialNumber?: Maybe<Scalars['Boolean']>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: Maybe<Scalars['Boolean']>;
  treatIdentAsBarcode?: Maybe<Scalars['Boolean']>;
  update: Scalars['Boolean'];
  updateHeadAndDeleteAllItemsOnCopy?: Maybe<Scalars['Boolean']>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: Maybe<Scalars['Boolean']>;
  useDeadlineDateOnOverview: Scalars['Boolean'];
  useSquareArticlePicker?: Maybe<Scalars['Boolean']>;
  useVerySmallMobileInterface?: Maybe<Scalars['Boolean']>;
  visualAttributes?: Maybe<Scalars['String']>;
  visualAttributesOverview?: Maybe<Scalars['String']>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: Maybe<Scalars['Boolean']>;
  warehouseName?: Maybe<Scalars['String']>;
  warehouseOverviewShowOnlyInStock: Scalars['Boolean'];
  warehousePositionTHeSetItemFieldName?: Maybe<Scalars['String']>;
  warehouseShowPrices?: Maybe<Scalars['Boolean']>;
  warehouseViewFixedAcSubject?: Maybe<Scalars['String']>;
  whenAddingSubjectSetAnClerkToCurrentUser?: Maybe<Scalars['Boolean']>;
  workOrderCanBeUnlocked?: Maybe<Scalars['Boolean']>;
  workOrderPrintSpecificationDuration: Scalars['Boolean'];
  workOrderSpecificationPrefillTime?: Maybe<Scalars['Boolean']>;
  workOrderSpecificationTimeNotRequired?: Maybe<Scalars['Boolean']>;
  workOrderUnlockableStatus?: Maybe<Scalars['String']>;
}


declare interface DocumentTypePairArbitraryFieldsArgs {
  order?: InputMaybe<Array<DocumentTypeArbitraryFieldSortInput>>;
}

declare interface DocumentTypePairFilterInput {
  acDocsOrderingOnPDF?: InputMaybe<StringOperationFilterInput>;
  acFieldSFLabel?: InputMaybe<StringOperationFilterInput>;
  acFiscalDevice?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerName?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName1?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName2?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acName3?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverName?: InputMaybe<StringOperationFilterInput>;
  acSetOfsWhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  acStatusIn?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acWorkPlace?: InputMaybe<StringOperationFilterInput>;
  acceptedByFieldOnPrint?: InputMaybe<StringOperationFilterInput>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc1EntryIsTimeOnly?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc1PDFLabel?: InputMaybe<StringOperationFilterInput>;
  adDateDoc2EntryIsTimeOnly?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc2PDFLabel?: InputMaybe<StringOperationFilterInput>;
  addingItemWarnIfQuantityMoreThanAvailable?: InputMaybe<BooleanOperationFilterInput>;
  adminAllowChangingItemPrice?: InputMaybe<BooleanOperationFilterInput>;
  adminCanEditDocumentAfterSaving?: InputMaybe<BooleanOperationFilterInput>;
  adminDefaultAcPriceRate?: InputMaybe<StringOperationFilterInput>;
  adminDeleteItemsAfterDocumentIsSaved?: InputMaybe<BooleanOperationFilterInput>;
  adminDocumentOnCreateMakeWarehouseReservation?: InputMaybe<BooleanOperationFilterInput>;
  adminEmphasizeInStock?: InputMaybe<BooleanOperationFilterInput>;
  adminForceAcPriceRate?: InputMaybe<StringOperationFilterInput>;
  adminIgnoreRebate1?: InputMaybe<BooleanOperationFilterInput>;
  adminIgnoreRebate2?: InputMaybe<BooleanOperationFilterInput>;
  adminIgnoreRebate3?: InputMaybe<BooleanOperationFilterInput>;
  adminItemQuantityMustBeInStock?: InputMaybe<BooleanOperationFilterInput>;
  adminSavedRebatesForFinalRebate?: InputMaybe<BooleanOperationFilterInput>;
  adminSendDocumentToCompanyDocumentEmail?: InputMaybe<BooleanOperationFilterInput>;
  adminSerialNumbersAreNotAutomated?: InputMaybe<BooleanOperationFilterInput>;
  adminShowDailyIncome?: InputMaybe<BooleanOperationFilterInput>;
  adminShowSubjectAdd?: InputMaybe<BooleanOperationFilterInput>;
  adminUseAnWsPrice?: InputMaybe<BooleanOperationFilterInput>;
  adminUseGenericDocumentsForMoveAndOrder?: InputMaybe<BooleanOperationFilterInput>;
  adminUseSerialNumberForItems?: InputMaybe<BooleanOperationFilterInput>;
  allowChangingWarehouse?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSCRUDOnlyForUsersFiles?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSConfirmation?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSReclassification?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemArticlePicking?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemCostBearerPicking?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemDepartmentPicking?: InputMaybe<BooleanOperationFilterInput>;
  allowGenericDocumentTypeImageAttachments?: InputMaybe<BooleanOperationFilterInput>;
  allowManualVerifyFromDocumentOverview?: InputMaybe<BooleanOperationFilterInput>;
  allowModifyExistingDocuments?: InputMaybe<BooleanOperationFilterInput>;
  allowPullingDMSEInvoicesFromService?: InputMaybe<BooleanOperationFilterInput>;
  allowSavingGeodecodedLocation?: InputMaybe<BooleanOperationFilterInput>;
  allowSelectingMultipleDocumentsToCreateFrom?: InputMaybe<BooleanOperationFilterInput>;
  allowSigningAfterDocumentIsSaved?: InputMaybe<BooleanOperationFilterInput>;
  alwaysShowTheseAcSetOfItem?: InputMaybe<StringOperationFilterInput>;
  alwaysUpdatePriceAndRebateFromClient?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<DocumentTypePairFilterInput>>;
  appendToItemIfExists?: InputMaybe<BooleanOperationFilterInput>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Label?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Location?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Value?: InputMaybe<StringOperationFilterInput>;
  arbitraryFields?: InputMaybe<ListFilterInputTypeOfDocumentTypeArbitraryFieldFilterInput>;
  articleDontShowPriceAnyWhere?: InputMaybe<BooleanOperationFilterInput>;
  articleDontShowStockAnyWhere?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchAllowSearchingByClassification?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchInitiallyLoadAll?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchRepeatLastSearch?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsAIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsBIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsCIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsDIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsEIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsFIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsGIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsHIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsIIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsJIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddAIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddBIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddCIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddDIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnAIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnBIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnCIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnDIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnEIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnFIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnGIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnHIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnIIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnJIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  bluetoothPrintCopiesNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  cacheDuration?: InputMaybe<ComparableInt32OperationFilterInput>;
  cacheUseCacheForAnyResource?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForArticleSearch?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForCustomerSearch?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForWarehouseSearch?: InputMaybe<BooleanOperationFilterInput>;
  cardPaymentProvider?: InputMaybe<NullableOfCardPaymentProviderOperationFilterInput>;
  changeDocumentStatusAfterCreated?: InputMaybe<StringOperationFilterInput>;
  changeSourceDocumentStatusTo?: InputMaybe<StringOperationFilterInput>;
  classifs2WhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  classifsWhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  clerkFieldOnPrint?: InputMaybe<StringOperationFilterInput>;
  companyEmailDefaultEmail?: InputMaybe<StringOperationFilterInput>;
  companyEmailPDFBCC?: InputMaybe<StringOperationFilterInput>;
  companyEmailPDFCC?: InputMaybe<StringOperationFilterInput>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: InputMaybe<BooleanOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  completeDeliveryStatus?: InputMaybe<StringOperationFilterInput>;
  copyOnlyLeftOverQuantity?: InputMaybe<BooleanOperationFilterInput>;
  copyOnlyThoseWithLeftOverQuantity0?: InputMaybe<BooleanOperationFilterInput>;
  copyingFromAnotherIsAShadowCopy?: InputMaybe<BooleanOperationFilterInput>;
  create?: InputMaybe<BooleanOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  customContractPriceFilter?: InputMaybe<BooleanOperationFilterInput>;
  customerCodeAllowedKeys?: InputMaybe<StringOperationFilterInput>;
  customerCodeFromAcSkis?: InputMaybe<BooleanOperationFilterInput>;
  customerCodeIsGenerated?: InputMaybe<BooleanOperationFilterInput>;
  dMSListFilterOnDefaultClassification?: InputMaybe<BooleanOperationFilterInput>;
  dateFilterType?: InputMaybe<NullableOfDateFilterTypeOperationFilterInput>;
  defaultCustomerType?: InputMaybe<StringOperationFilterInput>;
  defaultCustomerTypeFilter?: InputMaybe<StringOperationFilterInput>;
  defaultMoveDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultMoveDocumentSortField?: InputMaybe<NullableOfTHeMovePagedSortFieldOperationFilterInput>;
  defaultOrderDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultOrderDocumentSortField?: InputMaybe<NullableOfTHeOrderPagedSortFieldOperationFilterInput>;
  defaultPaymentMethod?: InputMaybe<StringOperationFilterInput>;
  defaultQuantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  defaultSubjectDaysForPaymentOnAdd?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultSubjectPaymentMethodOnAdd?: InputMaybe<StringOperationFilterInput>;
  defaultToThisCustomer?: InputMaybe<StringOperationFilterInput>;
  defaultWoexDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultWoexDocumentSortField?: InputMaybe<NullableOfTHfWoexPagedSortFieldOperationFilterInput>;
  delete?: InputMaybe<BooleanOperationFilterInput>;
  deliveryIsRequired?: InputMaybe<BooleanOperationFilterInput>;
  disableUsingShadowItemAsItemBase?: InputMaybe<BooleanOperationFilterInput>;
  disallowChangingCustomer?: InputMaybe<BooleanOperationFilterInput>;
  disallowChangingItemQuantityOnSerialInput?: InputMaybe<BooleanOperationFilterInput>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: InputMaybe<BooleanOperationFilterInput>;
  disallowManualWarehouseSearch?: InputMaybe<BooleanOperationFilterInput>;
  disallowPickingCustomer?: InputMaybe<BooleanOperationFilterInput>;
  dmsAcStatusIn?: InputMaybe<StringOperationFilterInput>;
  doNotFilterDailyRecapByUserId?: InputMaybe<BooleanOperationFilterInput>;
  documentLinkType?: InputMaybe<StringOperationFilterInput>;
  documentLinkTypeA?: InputMaybe<StringOperationFilterInput>;
  documentLinkTypeB?: InputMaybe<StringOperationFilterInput>;
  documentNote?: InputMaybe<StringOperationFilterInput>;
  documentOnCreateMakeA4Print?: InputMaybe<BooleanOperationFilterInput>;
  documentOnCreateMakeBluetoothPrint?: InputMaybe<BooleanOperationFilterInput>;
  documentOnCreateMakePDF?: InputMaybe<BooleanOperationFilterInput>;
  documentTopAdditionalText?: InputMaybe<StringOperationFilterInput>;
  dontSaveIndividualPDFPages?: InputMaybe<BooleanOperationFilterInput>;
  existingInventoryCheckDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  fillReferentLineWithUserOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  filterByAcDelivery?: InputMaybe<BooleanOperationFilterInput>;
  filterByAcDept?: InputMaybe<StringOperationFilterInput>;
  filterByAcDeptOut?: InputMaybe<StringOperationFilterInput>;
  filterByAcType?: InputMaybe<StringOperationFilterInput>;
  filterByAcVerifiedPrices?: InputMaybe<StringOperationFilterInput>;
  filterByAcVerifyStatus?: InputMaybe<StringOperationFilterInput>;
  filterByCurrentUserIdIsAnSigner1?: InputMaybe<BooleanOperationFilterInput>;
  filterByUserOnAcIssuer?: InputMaybe<BooleanOperationFilterInput>;
  filterByUserOnAcReceiver?: InputMaybe<BooleanOperationFilterInput>;
  filterMovesByThisAcIssuer?: InputMaybe<StringOperationFilterInput>;
  filterMovesByThisAcReceiver?: InputMaybe<StringOperationFilterInput>;
  filterOrdersByThisAcWarehouse?: InputMaybe<StringOperationFilterInput>;
  filterReceiversByAcFieldSa?: InputMaybe<StringOperationFilterInput>;
  forceShowAvailableOnStock?: InputMaybe<BooleanOperationFilterInput>;
  from?: InputMaybe<DocumentTypeFilterInput>;
  fromId?: InputMaybe<ComparableInt32OperationFilterInput>;
  functionality?: InputMaybe<DocumentPairFunctionalityEnumOperationFilterInput>;
  generatePrintTimeOnCreate?: InputMaybe<BooleanOperationFilterInput>;
  groupAllCreatingDocumentTypesAtThisPoint?: InputMaybe<BooleanOperationFilterInput>;
  groupAllDocumentTypesAtThisPoint?: InputMaybe<BooleanOperationFilterInput>;
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated?: InputMaybe<BooleanOperationFilterInput>;
  headerClerkPDFLabel?: InputMaybe<StringOperationFilterInput>;
  hideAcceptedByFieldOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideClerkFieldOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideCurrencyDateOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideDMSMetadataEntryFields?: InputMaybe<BooleanOperationFilterInput>;
  hideDataForPaymentOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideDocumentElements?: InputMaybe<StringOperationFilterInput>;
  hideDocumentItemElements?: InputMaybe<StringOperationFilterInput>;
  hideLeftOverQuantityOnPicking?: InputMaybe<BooleanOperationFilterInput>;
  hideNoteInNonHistoricalView?: InputMaybe<BooleanOperationFilterInput>;
  hidePayMethodOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideQuantityEntry?: InputMaybe<BooleanOperationFilterInput>;
  hideVATRecapitulationOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseItemActions?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseOverview?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseSupplier?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderImages?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderMaterials?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderPlaceFromTo?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderReception?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderReclamations?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderServices?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderSpecications?: InputMaybe<BooleanOperationFilterInput>;
  highlightArticlePickerTextOnNextOpen?: InputMaybe<BooleanOperationFilterInput>;
  historyViewIgnoredFilters?: InputMaybe<StringOperationFilterInput>;
  horizontalDoc12AndDates?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  ifAcPayMethodChooseThisDocumentType?: InputMaybe<StringOperationFilterInput>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: InputMaybe<BooleanOperationFilterInput>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: InputMaybe<BooleanOperationFilterInput>;
  ignoreQuantityInWholeDocument?: InputMaybe<BooleanOperationFilterInput>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: InputMaybe<BooleanOperationFilterInput>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  isDisabled?: InputMaybe<BooleanOperationFilterInput>;
  isRetail?: InputMaybe<BooleanOperationFilterInput>;
  itemListShowDetailed?: InputMaybe<BooleanOperationFilterInput>;
  jumpToEditAfterScanningItemWithBarcode?: InputMaybe<BooleanOperationFilterInput>;
  keepAdDateDoc1And2Unrounded?: InputMaybe<BooleanOperationFilterInput>;
  labelDefinitionLocations?: InputMaybe<ListFilterInputTypeOfLabelDefinitionLocationFilterInput>;
  makeDocumentLinks?: InputMaybe<BooleanOperationFilterInput>;
  makeSerialStockCheck?: InputMaybe<BooleanOperationFilterInput>;
  manualWorkOrderMaterial?: InputMaybe<StringOperationFilterInput>;
  middleSignatureTextOnPrint?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifierCharacterLabel?: InputMaybe<StringOperationFilterInput>;
  multipleEndDocumentsCaseToPickEndDocument?: InputMaybe<StringOperationFilterInput>;
  mustFiscalize?: InputMaybe<BooleanOperationFilterInput>;
  newNewDocumentInputType?: InputMaybe<BooleanOperationFilterInput>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: InputMaybe<BooleanOperationFilterInput>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DocumentTypePairFilterInput>>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: InputMaybe<BooleanOperationFilterInput>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: InputMaybe<BooleanOperationFilterInput>;
  palletEntry?: InputMaybe<BooleanOperationFilterInput>;
  partialDeliveryStatus?: InputMaybe<StringOperationFilterInput>;
  pdfSignWithoutGeneration?: InputMaybe<BooleanOperationFilterInput>;
  pickingShowConfirmationOnPick?: InputMaybe<BooleanOperationFilterInput>;
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: InputMaybe<BooleanOperationFilterInput>;
  printDocumentTitleOverride?: InputMaybe<StringOperationFilterInput>;
  printTicketNameOverride?: InputMaybe<StringOperationFilterInput>;
  prioritisePackageQuantityEntryField?: InputMaybe<BooleanOperationFilterInput>;
  quantityDecimalPlaces?: InputMaybe<ComparableInt32OperationFilterInput>;
  read?: InputMaybe<BooleanOperationFilterInput>;
  recommendToMakeCodebooksOffline?: InputMaybe<BooleanOperationFilterInput>;
  requireASignature?: InputMaybe<BooleanOperationFilterInput>;
  reverseItemsList?: InputMaybe<BooleanOperationFilterInput>;
  saveUnsignedAsSignedPDF?: InputMaybe<BooleanOperationFilterInput>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: InputMaybe<BooleanOperationFilterInput>;
  sendLeftoverShadowsWithZero?: InputMaybe<BooleanOperationFilterInput>;
  serialNumberDirectionIsInput?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeliveryMobileFilterOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeliveryOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeptMobileFilterOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDescrOnPDFs?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc1?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc1OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc2?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc2OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcIdentOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: InputMaybe<StringOperationFilterInput>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: InputMaybe<StringOperationFilterInput>;
  showAdDate?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc1?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc1OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc2?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc2OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAllDMSDocumentsForURAClassifications?: InputMaybe<BooleanOperationFilterInput>;
  showAllDocumentsNotOnlyAnUserIns?: InputMaybe<BooleanOperationFilterInput>;
  showAllItemsIgnoringWarehouse?: InputMaybe<BooleanOperationFilterInput>;
  showAnClerkAndAnNoteClerkIsOROperation?: InputMaybe<BooleanOperationFilterInput>;
  showArticlesGroupedByCodeButSeparate?: InputMaybe<BooleanOperationFilterInput>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: InputMaybe<BooleanOperationFilterInput>;
  showAttachSSCCButton?: InputMaybe<BooleanOperationFilterInput>;
  showBuyerOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showContactEmailEntry?: InputMaybe<BooleanOperationFilterInput>;
  showContactEntry?: InputMaybe<BooleanOperationFilterInput>;
  showCostBearerOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerName2AsPrimaryOnHeader?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerOverview?: InputMaybe<BooleanOperationFilterInput>;
  showCustomersAcName2OnThermalPrint?: InputMaybe<BooleanOperationFilterInput>;
  showDMSXMLItems?: InputMaybe<BooleanOperationFilterInput>;
  showDeliveryDeadlineDays?: InputMaybe<BooleanOperationFilterInput>;
  showDeliveryMethod?: InputMaybe<BooleanOperationFilterInput>;
  showDepartmentAsReceiver?: InputMaybe<BooleanOperationFilterInput>;
  showDepartmentOutAsReceiver?: InputMaybe<BooleanOperationFilterInput>;
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: InputMaybe<StringOperationFilterInput>;
  showDoc12AndTheirDatesOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showInventoryNumberOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showItalianLabelsOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemAcCustomsTariffOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemAnNetWeightOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemPicturesOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showLastNOrdersForCustomer?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  showLineNoteOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showModifierCharacterPicker?: InputMaybe<BooleanOperationFilterInput>;
  showNumberOfUnlinkedDocuments?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyArticlesWithCustomerContractPrice?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyWOWhereCurrentUserSpecExists?: InputMaybe<BooleanOperationFilterInput>;
  showPackageQuantityEntryField?: InputMaybe<BooleanOperationFilterInput>;
  showPaymentMethod?: InputMaybe<BooleanOperationFilterInput>;
  showQuantityPerUnitOfMeasureOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showQuantityTotalOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showReceiverOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showSerialNumberSearchForWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showWOWorkersEntry?: InputMaybe<BooleanOperationFilterInput>;
  skipConfirmationOnShortcuts?: InputMaybe<BooleanOperationFilterInput>;
  skipGS1BarcodeCheck?: InputMaybe<BooleanOperationFilterInput>;
  stockViewLoadAllOnOpen?: InputMaybe<BooleanOperationFilterInput>;
  stockViewShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  storeContactEmailArbitraryInField?: InputMaybe<StringOperationFilterInput>;
  subjectDocumentListDocumentType?: InputMaybe<StringOperationFilterInput>;
  subjectFieldForSSCCRequirementCheck?: InputMaybe<StringOperationFilterInput>;
  subjectFieldValueForSSCCRequirementCheck?: InputMaybe<StringOperationFilterInput>;
  syncPackagingWhenAddingNewItem?: InputMaybe<BooleanOperationFilterInput>;
  tHrPrsnForOnlyOnixPhoneUsers?: InputMaybe<BooleanOperationFilterInput>;
  tMNAcDefaultStatus?: InputMaybe<StringOperationFilterInput>;
  tMNAcDefaultSubject?: InputMaybe<StringOperationFilterInput>;
  tMNAnClassifIcationQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tMNAnMailBoxQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tMNAnStorageQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSize?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSizeHeight?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSizeWidth?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintShowCompanyImage?: InputMaybe<BooleanOperationFilterInput>;
  to?: InputMaybe<DocumentTypeFilterInput>;
  toId?: InputMaybe<ComparableInt32OperationFilterInput>;
  transferAcDoc1WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAcDoc2WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAdDateDoc1WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAdDateDoc2WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferEnteredItemQuantityToSerialNumber?: InputMaybe<BooleanOperationFilterInput>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: InputMaybe<BooleanOperationFilterInput>;
  treatIdentAsBarcode?: InputMaybe<BooleanOperationFilterInput>;
  update?: InputMaybe<BooleanOperationFilterInput>;
  updateHeadAndDeleteAllItemsOnCopy?: InputMaybe<BooleanOperationFilterInput>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: InputMaybe<BooleanOperationFilterInput>;
  useDeadlineDateOnOverview?: InputMaybe<BooleanOperationFilterInput>;
  useSquareArticlePicker?: InputMaybe<BooleanOperationFilterInput>;
  useVerySmallMobileInterface?: InputMaybe<BooleanOperationFilterInput>;
  visualAttributes?: InputMaybe<StringOperationFilterInput>;
  visualAttributesOverview?: InputMaybe<StringOperationFilterInput>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<BooleanOperationFilterInput>;
  warehouseName?: InputMaybe<StringOperationFilterInput>;
  warehouseOverviewShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  warehousePositionTHeSetItemFieldName?: InputMaybe<StringOperationFilterInput>;
  warehouseShowPrices?: InputMaybe<BooleanOperationFilterInput>;
  warehouseViewFixedAcSubject?: InputMaybe<StringOperationFilterInput>;
  whenAddingSubjectSetAnClerkToCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  workOrderCanBeUnlocked?: InputMaybe<BooleanOperationFilterInput>;
  workOrderPrintSpecificationDuration?: InputMaybe<BooleanOperationFilterInput>;
  workOrderSpecificationPrefillTime?: InputMaybe<BooleanOperationFilterInput>;
  workOrderSpecificationTimeNotRequired?: InputMaybe<BooleanOperationFilterInput>;
  workOrderUnlockableStatus?: InputMaybe<StringOperationFilterInput>;
}

declare interface DocumentTypePairSortInput {
  acDocsOrderingOnPDF?: InputMaybe<SortEnumType>;
  acFieldSFLabel?: InputMaybe<SortEnumType>;
  acFiscalDevice?: InputMaybe<SortEnumType>;
  acIssuer?: InputMaybe<SortEnumType>;
  acIssuerName?: InputMaybe<SortEnumType>;
  acLinkDocName1?: InputMaybe<SortEnumType>;
  acLinkDocName2?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acName3?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverName?: InputMaybe<SortEnumType>;
  acSetOfsWhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  acStatusIn?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acWorkPlace?: InputMaybe<SortEnumType>;
  acceptedByFieldOnPrint?: InputMaybe<SortEnumType>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<SortEnumType>;
  adDateDoc1EntryIsTimeOnly?: InputMaybe<SortEnumType>;
  adDateDoc1PDFLabel?: InputMaybe<SortEnumType>;
  adDateDoc2EntryIsTimeOnly?: InputMaybe<SortEnumType>;
  adDateDoc2PDFLabel?: InputMaybe<SortEnumType>;
  addingItemWarnIfQuantityMoreThanAvailable?: InputMaybe<SortEnumType>;
  adminAllowChangingItemPrice?: InputMaybe<SortEnumType>;
  adminCanEditDocumentAfterSaving?: InputMaybe<SortEnumType>;
  adminDefaultAcPriceRate?: InputMaybe<SortEnumType>;
  adminDeleteItemsAfterDocumentIsSaved?: InputMaybe<SortEnumType>;
  adminDocumentOnCreateMakeWarehouseReservation?: InputMaybe<SortEnumType>;
  adminEmphasizeInStock?: InputMaybe<SortEnumType>;
  adminForceAcPriceRate?: InputMaybe<SortEnumType>;
  adminIgnoreRebate1?: InputMaybe<SortEnumType>;
  adminIgnoreRebate2?: InputMaybe<SortEnumType>;
  adminIgnoreRebate3?: InputMaybe<SortEnumType>;
  adminItemQuantityMustBeInStock?: InputMaybe<SortEnumType>;
  adminSavedRebatesForFinalRebate?: InputMaybe<SortEnumType>;
  adminSendDocumentToCompanyDocumentEmail?: InputMaybe<SortEnumType>;
  adminSerialNumbersAreNotAutomated?: InputMaybe<SortEnumType>;
  adminShowDailyIncome?: InputMaybe<SortEnumType>;
  adminShowSubjectAdd?: InputMaybe<SortEnumType>;
  adminUseAnWsPrice?: InputMaybe<SortEnumType>;
  adminUseGenericDocumentsForMoveAndOrder?: InputMaybe<SortEnumType>;
  adminUseSerialNumberForItems?: InputMaybe<SortEnumType>;
  allowChangingWarehouse?: InputMaybe<SortEnumType>;
  allowDMSCRUDOnlyForUsersFiles?: InputMaybe<SortEnumType>;
  allowDMSConfirmation?: InputMaybe<SortEnumType>;
  allowDMSReclassification?: InputMaybe<SortEnumType>;
  allowDMSXMLItemArticlePicking?: InputMaybe<SortEnumType>;
  allowDMSXMLItemCostBearerPicking?: InputMaybe<SortEnumType>;
  allowDMSXMLItemDepartmentPicking?: InputMaybe<SortEnumType>;
  allowGenericDocumentTypeImageAttachments?: InputMaybe<SortEnumType>;
  allowManualVerifyFromDocumentOverview?: InputMaybe<SortEnumType>;
  allowModifyExistingDocuments?: InputMaybe<SortEnumType>;
  allowPullingDMSEInvoicesFromService?: InputMaybe<SortEnumType>;
  allowSavingGeodecodedLocation?: InputMaybe<SortEnumType>;
  allowSelectingMultipleDocumentsToCreateFrom?: InputMaybe<SortEnumType>;
  allowSigningAfterDocumentIsSaved?: InputMaybe<SortEnumType>;
  alwaysShowTheseAcSetOfItem?: InputMaybe<SortEnumType>;
  alwaysUpdatePriceAndRebateFromClient?: InputMaybe<SortEnumType>;
  appendToItemIfExists?: InputMaybe<SortEnumType>;
  applicationUser?: InputMaybe<ApplicationUserSortInput>;
  applicationUserId?: InputMaybe<SortEnumType>;
  arbitraryField1Label?: InputMaybe<SortEnumType>;
  arbitraryField1Location?: InputMaybe<SortEnumType>;
  arbitraryField1Value?: InputMaybe<SortEnumType>;
  articleDontShowPriceAnyWhere?: InputMaybe<SortEnumType>;
  articleDontShowStockAnyWhere?: InputMaybe<SortEnumType>;
  articleSearchAllowSearchingByClassification?: InputMaybe<SortEnumType>;
  articleSearchInitiallyLoadAll?: InputMaybe<SortEnumType>;
  articleSearchRepeatLastSearch?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyInStock?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsEIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsFIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsGIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsHIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsIIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsJIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnEIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnFIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnGIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnHIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnIIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnJIs?: InputMaybe<SortEnumType>;
  bluetoothPrintCopiesNumber?: InputMaybe<SortEnumType>;
  cacheDuration?: InputMaybe<SortEnumType>;
  cacheUseCacheForAnyResource?: InputMaybe<SortEnumType>;
  cacheUseForArticleSearch?: InputMaybe<SortEnumType>;
  cacheUseForCustomerSearch?: InputMaybe<SortEnumType>;
  cacheUseForWarehouseSearch?: InputMaybe<SortEnumType>;
  cardPaymentProvider?: InputMaybe<SortEnumType>;
  changeDocumentStatusAfterCreated?: InputMaybe<SortEnumType>;
  changeSourceDocumentStatusTo?: InputMaybe<SortEnumType>;
  classifs2WhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  classifsWhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  clerkFieldOnPrint?: InputMaybe<SortEnumType>;
  companyEmailDefaultEmail?: InputMaybe<SortEnumType>;
  companyEmailPDFBCC?: InputMaybe<SortEnumType>;
  companyEmailPDFCC?: InputMaybe<SortEnumType>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  completeDeliveryStatus?: InputMaybe<SortEnumType>;
  copyOnlyLeftOverQuantity?: InputMaybe<SortEnumType>;
  copyOnlyThoseWithLeftOverQuantity0?: InputMaybe<SortEnumType>;
  copyingFromAnotherIsAShadowCopy?: InputMaybe<SortEnumType>;
  create?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  customContractPriceFilter?: InputMaybe<SortEnumType>;
  customerCodeAllowedKeys?: InputMaybe<SortEnumType>;
  customerCodeFromAcSkis?: InputMaybe<SortEnumType>;
  customerCodeIsGenerated?: InputMaybe<SortEnumType>;
  dMSListFilterOnDefaultClassification?: InputMaybe<SortEnumType>;
  dateFilterType?: InputMaybe<SortEnumType>;
  defaultCustomerType?: InputMaybe<SortEnumType>;
  defaultCustomerTypeFilter?: InputMaybe<SortEnumType>;
  defaultMoveDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultMoveDocumentSortField?: InputMaybe<SortEnumType>;
  defaultOrderDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultOrderDocumentSortField?: InputMaybe<SortEnumType>;
  defaultPaymentMethod?: InputMaybe<SortEnumType>;
  defaultQuantity?: InputMaybe<SortEnumType>;
  defaultSubjectDaysForPaymentOnAdd?: InputMaybe<SortEnumType>;
  defaultSubjectPaymentMethodOnAdd?: InputMaybe<SortEnumType>;
  defaultToThisCustomer?: InputMaybe<SortEnumType>;
  defaultWoexDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultWoexDocumentSortField?: InputMaybe<SortEnumType>;
  delete?: InputMaybe<SortEnumType>;
  deliveryIsRequired?: InputMaybe<SortEnumType>;
  disableUsingShadowItemAsItemBase?: InputMaybe<SortEnumType>;
  disallowChangingCustomer?: InputMaybe<SortEnumType>;
  disallowChangingItemQuantityOnSerialInput?: InputMaybe<SortEnumType>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: InputMaybe<SortEnumType>;
  disallowManualWarehouseSearch?: InputMaybe<SortEnumType>;
  disallowPickingCustomer?: InputMaybe<SortEnumType>;
  dmsAcStatusIn?: InputMaybe<SortEnumType>;
  doNotFilterDailyRecapByUserId?: InputMaybe<SortEnumType>;
  documentLinkType?: InputMaybe<SortEnumType>;
  documentLinkTypeA?: InputMaybe<SortEnumType>;
  documentLinkTypeB?: InputMaybe<SortEnumType>;
  documentNote?: InputMaybe<SortEnumType>;
  documentOnCreateMakeA4Print?: InputMaybe<SortEnumType>;
  documentOnCreateMakeBluetoothPrint?: InputMaybe<SortEnumType>;
  documentOnCreateMakePDF?: InputMaybe<SortEnumType>;
  documentTopAdditionalText?: InputMaybe<SortEnumType>;
  dontSaveIndividualPDFPages?: InputMaybe<SortEnumType>;
  existingInventoryCheckDays?: InputMaybe<SortEnumType>;
  fillReferentLineWithUserOnPrint?: InputMaybe<SortEnumType>;
  filterByAcDelivery?: InputMaybe<SortEnumType>;
  filterByAcDept?: InputMaybe<SortEnumType>;
  filterByAcDeptOut?: InputMaybe<SortEnumType>;
  filterByAcType?: InputMaybe<SortEnumType>;
  filterByAcVerifiedPrices?: InputMaybe<SortEnumType>;
  filterByAcVerifyStatus?: InputMaybe<SortEnumType>;
  filterByCurrentUserIdIsAnSigner1?: InputMaybe<SortEnumType>;
  filterByUserOnAcIssuer?: InputMaybe<SortEnumType>;
  filterByUserOnAcReceiver?: InputMaybe<SortEnumType>;
  filterMovesByThisAcIssuer?: InputMaybe<SortEnumType>;
  filterMovesByThisAcReceiver?: InputMaybe<SortEnumType>;
  filterOrdersByThisAcWarehouse?: InputMaybe<SortEnumType>;
  filterReceiversByAcFieldSa?: InputMaybe<SortEnumType>;
  forceShowAvailableOnStock?: InputMaybe<SortEnumType>;
  from?: InputMaybe<DocumentTypeSortInput>;
  fromId?: InputMaybe<SortEnumType>;
  functionality?: InputMaybe<SortEnumType>;
  generatePrintTimeOnCreate?: InputMaybe<SortEnumType>;
  groupAllCreatingDocumentTypesAtThisPoint?: InputMaybe<SortEnumType>;
  groupAllDocumentTypesAtThisPoint?: InputMaybe<SortEnumType>;
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated?: InputMaybe<SortEnumType>;
  headerClerkPDFLabel?: InputMaybe<SortEnumType>;
  hideAcceptedByFieldOnPrint?: InputMaybe<SortEnumType>;
  hideClerkFieldOnPrint?: InputMaybe<SortEnumType>;
  hideCurrencyDateOnPrint?: InputMaybe<SortEnumType>;
  hideDMSMetadataEntryFields?: InputMaybe<SortEnumType>;
  hideDataForPaymentOnPrint?: InputMaybe<SortEnumType>;
  hideDocumentElements?: InputMaybe<SortEnumType>;
  hideDocumentItemElements?: InputMaybe<SortEnumType>;
  hideLeftOverQuantityOnPicking?: InputMaybe<SortEnumType>;
  hideNoteInNonHistoricalView?: InputMaybe<SortEnumType>;
  hidePayMethodOnPrint?: InputMaybe<SortEnumType>;
  hideQuantityEntry?: InputMaybe<SortEnumType>;
  hideVATRecapitulationOnPrint?: InputMaybe<SortEnumType>;
  hideWarehouseItemActions?: InputMaybe<SortEnumType>;
  hideWarehouseOverview?: InputMaybe<SortEnumType>;
  hideWarehouseSupplier?: InputMaybe<SortEnumType>;
  hideWorkOrderImages?: InputMaybe<SortEnumType>;
  hideWorkOrderMaterials?: InputMaybe<SortEnumType>;
  hideWorkOrderPlaceFromTo?: InputMaybe<SortEnumType>;
  hideWorkOrderReception?: InputMaybe<SortEnumType>;
  hideWorkOrderReclamations?: InputMaybe<SortEnumType>;
  hideWorkOrderServices?: InputMaybe<SortEnumType>;
  hideWorkOrderSpecications?: InputMaybe<SortEnumType>;
  highlightArticlePickerTextOnNextOpen?: InputMaybe<SortEnumType>;
  historyViewIgnoredFilters?: InputMaybe<SortEnumType>;
  horizontalDoc12AndDates?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  ifAcPayMethodChooseThisDocumentType?: InputMaybe<SortEnumType>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: InputMaybe<SortEnumType>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: InputMaybe<SortEnumType>;
  ignoreQuantityInWholeDocument?: InputMaybe<SortEnumType>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: InputMaybe<SortEnumType>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: InputMaybe<SortEnumType>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: InputMaybe<SortEnumType>;
  isDisabled?: InputMaybe<SortEnumType>;
  isRetail?: InputMaybe<SortEnumType>;
  itemListShowDetailed?: InputMaybe<SortEnumType>;
  jumpToEditAfterScanningItemWithBarcode?: InputMaybe<SortEnumType>;
  keepAdDateDoc1And2Unrounded?: InputMaybe<SortEnumType>;
  makeDocumentLinks?: InputMaybe<SortEnumType>;
  makeSerialStockCheck?: InputMaybe<SortEnumType>;
  manualWorkOrderMaterial?: InputMaybe<SortEnumType>;
  middleSignatureTextOnPrint?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifierCharacterLabel?: InputMaybe<SortEnumType>;
  multipleEndDocumentsCaseToPickEndDocument?: InputMaybe<SortEnumType>;
  mustFiscalize?: InputMaybe<SortEnumType>;
  newNewDocumentInputType?: InputMaybe<SortEnumType>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: InputMaybe<SortEnumType>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: InputMaybe<SortEnumType>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: InputMaybe<SortEnumType>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: InputMaybe<SortEnumType>;
  palletEntry?: InputMaybe<SortEnumType>;
  partialDeliveryStatus?: InputMaybe<SortEnumType>;
  pdfSignWithoutGeneration?: InputMaybe<SortEnumType>;
  pickingShowConfirmationOnPick?: InputMaybe<SortEnumType>;
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: InputMaybe<SortEnumType>;
  printDocumentTitleOverride?: InputMaybe<SortEnumType>;
  printTicketNameOverride?: InputMaybe<SortEnumType>;
  prioritisePackageQuantityEntryField?: InputMaybe<SortEnumType>;
  quantityDecimalPlaces?: InputMaybe<SortEnumType>;
  read?: InputMaybe<SortEnumType>;
  recommendToMakeCodebooksOffline?: InputMaybe<SortEnumType>;
  requireASignature?: InputMaybe<SortEnumType>;
  reverseItemsList?: InputMaybe<SortEnumType>;
  saveUnsignedAsSignedPDF?: InputMaybe<SortEnumType>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: InputMaybe<SortEnumType>;
  sendLeftoverShadowsWithZero?: InputMaybe<SortEnumType>;
  serialNumberDirectionIsInput?: InputMaybe<SortEnumType>;
  showAcDeliveryMobileFilterOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDeliveryOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDeptMobileFilterOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDescrOnPDFs?: InputMaybe<SortEnumType>;
  showAcDoc1?: InputMaybe<SortEnumType>;
  showAcDoc1OnPrint?: InputMaybe<SortEnumType>;
  showAcDoc2?: InputMaybe<SortEnumType>;
  showAcDoc2OnPrint?: InputMaybe<SortEnumType>;
  showAcIdentOnPrint?: InputMaybe<SortEnumType>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: InputMaybe<SortEnumType>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: InputMaybe<SortEnumType>;
  showAdDate?: InputMaybe<SortEnumType>;
  showAdDateDoc1?: InputMaybe<SortEnumType>;
  showAdDateDoc1OnPrint?: InputMaybe<SortEnumType>;
  showAdDateDoc2?: InputMaybe<SortEnumType>;
  showAdDateDoc2OnPrint?: InputMaybe<SortEnumType>;
  showAllDMSDocumentsForURAClassifications?: InputMaybe<SortEnumType>;
  showAllDocumentsNotOnlyAnUserIns?: InputMaybe<SortEnumType>;
  showAllItemsIgnoringWarehouse?: InputMaybe<SortEnumType>;
  showAnClerkAndAnNoteClerkIsOROperation?: InputMaybe<SortEnumType>;
  showArticlesGroupedByCodeButSeparate?: InputMaybe<SortEnumType>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: InputMaybe<SortEnumType>;
  showAttachSSCCButton?: InputMaybe<SortEnumType>;
  showBuyerOnWorkOrders?: InputMaybe<SortEnumType>;
  showContactEmailEntry?: InputMaybe<SortEnumType>;
  showContactEntry?: InputMaybe<SortEnumType>;
  showCostBearerOnWorkOrders?: InputMaybe<SortEnumType>;
  showCustomerName2AsPrimaryOnHeader?: InputMaybe<SortEnumType>;
  showCustomerOverview?: InputMaybe<SortEnumType>;
  showCustomersAcName2OnThermalPrint?: InputMaybe<SortEnumType>;
  showDMSXMLItems?: InputMaybe<SortEnumType>;
  showDeliveryDeadlineDays?: InputMaybe<SortEnumType>;
  showDeliveryMethod?: InputMaybe<SortEnumType>;
  showDepartmentAsReceiver?: InputMaybe<SortEnumType>;
  showDepartmentOutAsReceiver?: InputMaybe<SortEnumType>;
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: InputMaybe<SortEnumType>;
  showDoc12AndTheirDatesOnDocumentList?: InputMaybe<SortEnumType>;
  showInventoryNumberOnWorkOrders?: InputMaybe<SortEnumType>;
  showItalianLabelsOnPrint?: InputMaybe<SortEnumType>;
  showItemAcCustomsTariffOnPrint?: InputMaybe<SortEnumType>;
  showItemAnNetWeightOnPrint?: InputMaybe<SortEnumType>;
  showItemPicturesOnPrint?: InputMaybe<SortEnumType>;
  showLastNOrdersForCustomer?: InputMaybe<SortEnumType>;
  showLineNoteOnPrint?: InputMaybe<SortEnumType>;
  showModifierCharacterPicker?: InputMaybe<SortEnumType>;
  showNumberOfUnlinkedDocuments?: InputMaybe<SortEnumType>;
  showOnlyArticlesWithCustomerContractPrice?: InputMaybe<SortEnumType>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: InputMaybe<SortEnumType>;
  showOnlyWOWhereCurrentUserSpecExists?: InputMaybe<SortEnumType>;
  showPackageQuantityEntryField?: InputMaybe<SortEnumType>;
  showPaymentMethod?: InputMaybe<SortEnumType>;
  showQuantityPerUnitOfMeasureOnPrint?: InputMaybe<SortEnumType>;
  showQuantityTotalOnPrint?: InputMaybe<SortEnumType>;
  showReceiverOnWorkOrders?: InputMaybe<SortEnumType>;
  showSerialNumberSearchForWorkOrders?: InputMaybe<SortEnumType>;
  showWOWorkersEntry?: InputMaybe<SortEnumType>;
  skipConfirmationOnShortcuts?: InputMaybe<SortEnumType>;
  skipGS1BarcodeCheck?: InputMaybe<SortEnumType>;
  stockViewLoadAllOnOpen?: InputMaybe<SortEnumType>;
  stockViewShowOnlyInStock?: InputMaybe<SortEnumType>;
  storeContactEmailArbitraryInField?: InputMaybe<SortEnumType>;
  subjectDocumentListDocumentType?: InputMaybe<SortEnumType>;
  subjectFieldForSSCCRequirementCheck?: InputMaybe<SortEnumType>;
  subjectFieldValueForSSCCRequirementCheck?: InputMaybe<SortEnumType>;
  syncPackagingWhenAddingNewItem?: InputMaybe<SortEnumType>;
  tHrPrsnForOnlyOnixPhoneUsers?: InputMaybe<SortEnumType>;
  tMNAcDefaultStatus?: InputMaybe<SortEnumType>;
  tMNAcDefaultSubject?: InputMaybe<SortEnumType>;
  tMNAnClassifIcationQid?: InputMaybe<SortEnumType>;
  tMNAnMailBoxQid?: InputMaybe<SortEnumType>;
  tMNAnStorageQid?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSize?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSizeHeight?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSizeWidth?: InputMaybe<SortEnumType>;
  thermalPrintShowCompanyImage?: InputMaybe<SortEnumType>;
  to?: InputMaybe<DocumentTypeSortInput>;
  toId?: InputMaybe<SortEnumType>;
  transferAcDoc1WhenCopying?: InputMaybe<SortEnumType>;
  transferAcDoc2WhenCopying?: InputMaybe<SortEnumType>;
  transferAdDateDoc1WhenCopying?: InputMaybe<SortEnumType>;
  transferAdDateDoc2WhenCopying?: InputMaybe<SortEnumType>;
  transferEnteredItemQuantityToSerialNumber?: InputMaybe<SortEnumType>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: InputMaybe<SortEnumType>;
  treatIdentAsBarcode?: InputMaybe<SortEnumType>;
  update?: InputMaybe<SortEnumType>;
  updateHeadAndDeleteAllItemsOnCopy?: InputMaybe<SortEnumType>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: InputMaybe<SortEnumType>;
  useDeadlineDateOnOverview?: InputMaybe<SortEnumType>;
  useSquareArticlePicker?: InputMaybe<SortEnumType>;
  useVerySmallMobileInterface?: InputMaybe<SortEnumType>;
  visualAttributes?: InputMaybe<SortEnumType>;
  visualAttributesOverview?: InputMaybe<SortEnumType>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<SortEnumType>;
  warehouseName?: InputMaybe<SortEnumType>;
  warehouseOverviewShowOnlyInStock?: InputMaybe<SortEnumType>;
  warehousePositionTHeSetItemFieldName?: InputMaybe<SortEnumType>;
  warehouseShowPrices?: InputMaybe<SortEnumType>;
  warehouseViewFixedAcSubject?: InputMaybe<SortEnumType>;
  whenAddingSubjectSetAnClerkToCurrentUser?: InputMaybe<SortEnumType>;
  workOrderCanBeUnlocked?: InputMaybe<SortEnumType>;
  workOrderPrintSpecificationDuration?: InputMaybe<SortEnumType>;
  workOrderSpecificationPrefillTime?: InputMaybe<SortEnumType>;
  workOrderSpecificationTimeNotRequired?: InputMaybe<SortEnumType>;
  workOrderUnlockableStatus?: InputMaybe<SortEnumType>;
}

declare interface DocumentTypeSortInput {
  acDocsOrderingOnPDF?: InputMaybe<SortEnumType>;
  acFieldSFLabel?: InputMaybe<SortEnumType>;
  acFiscalDevice?: InputMaybe<SortEnumType>;
  acIssuer?: InputMaybe<SortEnumType>;
  acIssuerName?: InputMaybe<SortEnumType>;
  acLinkDocName1?: InputMaybe<SortEnumType>;
  acLinkDocName2?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acName3?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverName?: InputMaybe<SortEnumType>;
  acSetOfsWhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  acStatusIn?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acWorkPlace?: InputMaybe<SortEnumType>;
  acceptedByFieldOnPrint?: InputMaybe<SortEnumType>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<SortEnumType>;
  adDateDoc1EntryIsTimeOnly?: InputMaybe<SortEnumType>;
  adDateDoc1PDFLabel?: InputMaybe<SortEnumType>;
  adDateDoc2EntryIsTimeOnly?: InputMaybe<SortEnumType>;
  adDateDoc2PDFLabel?: InputMaybe<SortEnumType>;
  addingItemWarnIfQuantityMoreThanAvailable?: InputMaybe<SortEnumType>;
  adminAllowChangingItemPrice?: InputMaybe<SortEnumType>;
  adminCanEditDocumentAfterSaving?: InputMaybe<SortEnumType>;
  adminDefaultAcPriceRate?: InputMaybe<SortEnumType>;
  adminDeleteItemsAfterDocumentIsSaved?: InputMaybe<SortEnumType>;
  adminDocumentOnCreateMakeWarehouseReservation?: InputMaybe<SortEnumType>;
  adminEmphasizeInStock?: InputMaybe<SortEnumType>;
  adminForceAcPriceRate?: InputMaybe<SortEnumType>;
  adminIgnoreRebate1?: InputMaybe<SortEnumType>;
  adminIgnoreRebate2?: InputMaybe<SortEnumType>;
  adminIgnoreRebate3?: InputMaybe<SortEnumType>;
  adminItemQuantityMustBeInStock?: InputMaybe<SortEnumType>;
  adminSavedRebatesForFinalRebate?: InputMaybe<SortEnumType>;
  adminSendDocumentToCompanyDocumentEmail?: InputMaybe<SortEnumType>;
  adminSerialNumbersAreNotAutomated?: InputMaybe<SortEnumType>;
  adminShowDailyIncome?: InputMaybe<SortEnumType>;
  adminShowSubjectAdd?: InputMaybe<SortEnumType>;
  adminUseAnWsPrice?: InputMaybe<SortEnumType>;
  adminUseGenericDocumentsForMoveAndOrder?: InputMaybe<SortEnumType>;
  adminUseSerialNumberForItems?: InputMaybe<SortEnumType>;
  allowChangingWarehouse?: InputMaybe<SortEnumType>;
  allowDMSCRUDOnlyForUsersFiles?: InputMaybe<SortEnumType>;
  allowDMSConfirmation?: InputMaybe<SortEnumType>;
  allowDMSReclassification?: InputMaybe<SortEnumType>;
  allowDMSXMLItemArticlePicking?: InputMaybe<SortEnumType>;
  allowDMSXMLItemCostBearerPicking?: InputMaybe<SortEnumType>;
  allowDMSXMLItemDepartmentPicking?: InputMaybe<SortEnumType>;
  allowGenericDocumentTypeImageAttachments?: InputMaybe<SortEnumType>;
  allowManualVerifyFromDocumentOverview?: InputMaybe<SortEnumType>;
  allowModifyExistingDocuments?: InputMaybe<SortEnumType>;
  allowPullingDMSEInvoicesFromService?: InputMaybe<SortEnumType>;
  allowSavingGeodecodedLocation?: InputMaybe<SortEnumType>;
  allowSelectingMultipleDocumentsToCreateFrom?: InputMaybe<SortEnumType>;
  allowSigningAfterDocumentIsSaved?: InputMaybe<SortEnumType>;
  alwaysShowTheseAcSetOfItem?: InputMaybe<SortEnumType>;
  alwaysUpdatePriceAndRebateFromClient?: InputMaybe<SortEnumType>;
  appendToItemIfExists?: InputMaybe<SortEnumType>;
  arbitraryField1Label?: InputMaybe<SortEnumType>;
  arbitraryField1Location?: InputMaybe<SortEnumType>;
  arbitraryField1Value?: InputMaybe<SortEnumType>;
  articleDontShowPriceAnyWhere?: InputMaybe<SortEnumType>;
  articleDontShowStockAnyWhere?: InputMaybe<SortEnumType>;
  articleSearchAllowSearchingByClassification?: InputMaybe<SortEnumType>;
  articleSearchInitiallyLoadAll?: InputMaybe<SortEnumType>;
  articleSearchRepeatLastSearch?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyInStock?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsEIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsFIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsGIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsHIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsIIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsJIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnEIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnFIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnGIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnHIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnIIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnJIs?: InputMaybe<SortEnumType>;
  bluetoothPrintCopiesNumber?: InputMaybe<SortEnumType>;
  cacheDuration?: InputMaybe<SortEnumType>;
  cacheUseCacheForAnyResource?: InputMaybe<SortEnumType>;
  cacheUseForArticleSearch?: InputMaybe<SortEnumType>;
  cacheUseForCustomerSearch?: InputMaybe<SortEnumType>;
  cacheUseForWarehouseSearch?: InputMaybe<SortEnumType>;
  cardPaymentProvider?: InputMaybe<SortEnumType>;
  changeDocumentStatusAfterCreated?: InputMaybe<SortEnumType>;
  changeSourceDocumentStatusTo?: InputMaybe<SortEnumType>;
  classifs2WhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  classifsWhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  clerkFieldOnPrint?: InputMaybe<SortEnumType>;
  companyEmailDefaultEmail?: InputMaybe<SortEnumType>;
  companyEmailPDFBCC?: InputMaybe<SortEnumType>;
  companyEmailPDFCC?: InputMaybe<SortEnumType>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  completeDeliveryStatus?: InputMaybe<SortEnumType>;
  copyOnlyLeftOverQuantity?: InputMaybe<SortEnumType>;
  copyOnlyThoseWithLeftOverQuantity0?: InputMaybe<SortEnumType>;
  copyingFromAnotherIsAShadowCopy?: InputMaybe<SortEnumType>;
  create?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  customContractPriceFilter?: InputMaybe<SortEnumType>;
  customerCodeAllowedKeys?: InputMaybe<SortEnumType>;
  customerCodeFromAcSkis?: InputMaybe<SortEnumType>;
  customerCodeIsGenerated?: InputMaybe<SortEnumType>;
  dMSListFilterOnDefaultClassification?: InputMaybe<SortEnumType>;
  dateFilterType?: InputMaybe<SortEnumType>;
  defaultCustomerType?: InputMaybe<SortEnumType>;
  defaultCustomerTypeFilter?: InputMaybe<SortEnumType>;
  defaultMoveDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultMoveDocumentSortField?: InputMaybe<SortEnumType>;
  defaultOrderDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultOrderDocumentSortField?: InputMaybe<SortEnumType>;
  defaultPaymentMethod?: InputMaybe<SortEnumType>;
  defaultQuantity?: InputMaybe<SortEnumType>;
  defaultSubjectDaysForPaymentOnAdd?: InputMaybe<SortEnumType>;
  defaultSubjectPaymentMethodOnAdd?: InputMaybe<SortEnumType>;
  defaultToThisCustomer?: InputMaybe<SortEnumType>;
  defaultWoexDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultWoexDocumentSortField?: InputMaybe<SortEnumType>;
  delete?: InputMaybe<SortEnumType>;
  deliveryIsRequired?: InputMaybe<SortEnumType>;
  disableUsingShadowItemAsItemBase?: InputMaybe<SortEnumType>;
  disallowChangingCustomer?: InputMaybe<SortEnumType>;
  disallowChangingItemQuantityOnSerialInput?: InputMaybe<SortEnumType>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: InputMaybe<SortEnumType>;
  disallowManualWarehouseSearch?: InputMaybe<SortEnumType>;
  disallowPickingCustomer?: InputMaybe<SortEnumType>;
  dmsAcStatusIn?: InputMaybe<SortEnumType>;
  doNotFilterDailyRecapByUserId?: InputMaybe<SortEnumType>;
  documentLinkType?: InputMaybe<SortEnumType>;
  documentLinkTypeA?: InputMaybe<SortEnumType>;
  documentLinkTypeB?: InputMaybe<SortEnumType>;
  documentNote?: InputMaybe<SortEnumType>;
  documentOnCreateMakeA4Print?: InputMaybe<SortEnumType>;
  documentOnCreateMakeBluetoothPrint?: InputMaybe<SortEnumType>;
  documentOnCreateMakePDF?: InputMaybe<SortEnumType>;
  documentTopAdditionalText?: InputMaybe<SortEnumType>;
  dontSaveIndividualPDFPages?: InputMaybe<SortEnumType>;
  existingInventoryCheckDays?: InputMaybe<SortEnumType>;
  fillReferentLineWithUserOnPrint?: InputMaybe<SortEnumType>;
  filterByAcDelivery?: InputMaybe<SortEnumType>;
  filterByAcDept?: InputMaybe<SortEnumType>;
  filterByAcDeptOut?: InputMaybe<SortEnumType>;
  filterByAcType?: InputMaybe<SortEnumType>;
  filterByAcVerifiedPrices?: InputMaybe<SortEnumType>;
  filterByAcVerifyStatus?: InputMaybe<SortEnumType>;
  filterByCurrentUserIdIsAnSigner1?: InputMaybe<SortEnumType>;
  filterMovesByThisAcIssuer?: InputMaybe<SortEnumType>;
  filterMovesByThisAcReceiver?: InputMaybe<SortEnumType>;
  filterOrdersByThisAcWarehouse?: InputMaybe<SortEnumType>;
  filterReceiversByAcFieldSa?: InputMaybe<SortEnumType>;
  forceShowAvailableOnStock?: InputMaybe<SortEnumType>;
  functionality?: InputMaybe<SortEnumType>;
  generatePrintTimeOnCreate?: InputMaybe<SortEnumType>;
  groupAllCreatingDocumentTypesAtThisPoint?: InputMaybe<SortEnumType>;
  groupAllDocumentTypesAtThisPoint?: InputMaybe<SortEnumType>;
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated?: InputMaybe<SortEnumType>;
  headerClerkPDFLabel?: InputMaybe<SortEnumType>;
  hideAcceptedByFieldOnPrint?: InputMaybe<SortEnumType>;
  hideClerkFieldOnPrint?: InputMaybe<SortEnumType>;
  hideCurrencyDateOnPrint?: InputMaybe<SortEnumType>;
  hideDMSMetadataEntryFields?: InputMaybe<SortEnumType>;
  hideDataForPaymentOnPrint?: InputMaybe<SortEnumType>;
  hideDocumentElements?: InputMaybe<SortEnumType>;
  hideDocumentItemElements?: InputMaybe<SortEnumType>;
  hideLeftOverQuantityOnPicking?: InputMaybe<SortEnumType>;
  hideNoteInNonHistoricalView?: InputMaybe<SortEnumType>;
  hidePayMethodOnPrint?: InputMaybe<SortEnumType>;
  hideQuantityEntry?: InputMaybe<SortEnumType>;
  hideVATRecapitulationOnPrint?: InputMaybe<SortEnumType>;
  hideWarehouseItemActions?: InputMaybe<SortEnumType>;
  hideWarehouseOverview?: InputMaybe<SortEnumType>;
  hideWarehouseSupplier?: InputMaybe<SortEnumType>;
  hideWorkOrderImages?: InputMaybe<SortEnumType>;
  hideWorkOrderMaterials?: InputMaybe<SortEnumType>;
  hideWorkOrderPlaceFromTo?: InputMaybe<SortEnumType>;
  hideWorkOrderReception?: InputMaybe<SortEnumType>;
  hideWorkOrderReclamations?: InputMaybe<SortEnumType>;
  hideWorkOrderServices?: InputMaybe<SortEnumType>;
  hideWorkOrderSpecications?: InputMaybe<SortEnumType>;
  highlightArticlePickerTextOnNextOpen?: InputMaybe<SortEnumType>;
  historyViewIgnoredFilters?: InputMaybe<SortEnumType>;
  horizontalDoc12AndDates?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  ifAcPayMethodChooseThisDocumentType?: InputMaybe<SortEnumType>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: InputMaybe<SortEnumType>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: InputMaybe<SortEnumType>;
  ignoreQuantityInWholeDocument?: InputMaybe<SortEnumType>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: InputMaybe<SortEnumType>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: InputMaybe<SortEnumType>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: InputMaybe<SortEnumType>;
  isDisabled?: InputMaybe<SortEnumType>;
  isRetail?: InputMaybe<SortEnumType>;
  itemListShowDetailed?: InputMaybe<SortEnumType>;
  jumpToEditAfterScanningItemWithBarcode?: InputMaybe<SortEnumType>;
  keepAdDateDoc1And2Unrounded?: InputMaybe<SortEnumType>;
  makeDocumentLinks?: InputMaybe<SortEnumType>;
  makeSerialStockCheck?: InputMaybe<SortEnumType>;
  manualWorkOrderMaterial?: InputMaybe<SortEnumType>;
  middleSignatureTextOnPrint?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifierCharacterLabel?: InputMaybe<SortEnumType>;
  multipleEndDocumentsCaseToPickEndDocument?: InputMaybe<SortEnumType>;
  mustFiscalize?: InputMaybe<SortEnumType>;
  newNewDocumentInputType?: InputMaybe<SortEnumType>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: InputMaybe<SortEnumType>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: InputMaybe<SortEnumType>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: InputMaybe<SortEnumType>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: InputMaybe<SortEnumType>;
  palletEntry?: InputMaybe<SortEnumType>;
  pantheonDirection?: InputMaybe<SortEnumType>;
  pantheonTable?: InputMaybe<SortEnumType>;
  partialDeliveryStatus?: InputMaybe<SortEnumType>;
  pdfSignWithoutGeneration?: InputMaybe<SortEnumType>;
  pickingShowConfirmationOnPick?: InputMaybe<SortEnumType>;
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: InputMaybe<SortEnumType>;
  printDocumentTitleOverride?: InputMaybe<SortEnumType>;
  printTicketNameOverride?: InputMaybe<SortEnumType>;
  prioritisePackageQuantityEntryField?: InputMaybe<SortEnumType>;
  quantityDecimalPlaces?: InputMaybe<SortEnumType>;
  read?: InputMaybe<SortEnumType>;
  recommendToMakeCodebooksOffline?: InputMaybe<SortEnumType>;
  requireASignature?: InputMaybe<SortEnumType>;
  reverseItemsList?: InputMaybe<SortEnumType>;
  saveUnsignedAsSignedPDF?: InputMaybe<SortEnumType>;
  sendB2BAsEInvoice?: InputMaybe<SortEnumType>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: InputMaybe<SortEnumType>;
  sendLeftoverShadowsWithZero?: InputMaybe<SortEnumType>;
  serialNumberDirectionIsInput?: InputMaybe<SortEnumType>;
  showAcDeliveryMobileFilterOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDeliveryOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDeptMobileFilterOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDescrOnPDFs?: InputMaybe<SortEnumType>;
  showAcDoc1?: InputMaybe<SortEnumType>;
  showAcDoc1OnPrint?: InputMaybe<SortEnumType>;
  showAcDoc2?: InputMaybe<SortEnumType>;
  showAcDoc2OnPrint?: InputMaybe<SortEnumType>;
  showAcIdentOnPrint?: InputMaybe<SortEnumType>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: InputMaybe<SortEnumType>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: InputMaybe<SortEnumType>;
  showAdDate?: InputMaybe<SortEnumType>;
  showAdDateDoc1?: InputMaybe<SortEnumType>;
  showAdDateDoc1OnPrint?: InputMaybe<SortEnumType>;
  showAdDateDoc2?: InputMaybe<SortEnumType>;
  showAdDateDoc2OnPrint?: InputMaybe<SortEnumType>;
  showAllDMSDocumentsForURAClassifications?: InputMaybe<SortEnumType>;
  showAllDocumentsNotOnlyAnUserIns?: InputMaybe<SortEnumType>;
  showAllItemsIgnoringWarehouse?: InputMaybe<SortEnumType>;
  showAnClerkAndAnNoteClerkIsOROperation?: InputMaybe<SortEnumType>;
  showArticlesGroupedByCodeButSeparate?: InputMaybe<SortEnumType>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: InputMaybe<SortEnumType>;
  showAttachSSCCButton?: InputMaybe<SortEnumType>;
  showBuyerOnWorkOrders?: InputMaybe<SortEnumType>;
  showContactEmailEntry?: InputMaybe<SortEnumType>;
  showContactEntry?: InputMaybe<SortEnumType>;
  showCostBearerOnWorkOrders?: InputMaybe<SortEnumType>;
  showCustomerName2AsPrimaryOnHeader?: InputMaybe<SortEnumType>;
  showCustomerOverview?: InputMaybe<SortEnumType>;
  showCustomersAcName2OnThermalPrint?: InputMaybe<SortEnumType>;
  showDMSXMLItems?: InputMaybe<SortEnumType>;
  showDeliveryDeadlineDays?: InputMaybe<SortEnumType>;
  showDeliveryMethod?: InputMaybe<SortEnumType>;
  showDepartmentAsReceiver?: InputMaybe<SortEnumType>;
  showDepartmentOutAsReceiver?: InputMaybe<SortEnumType>;
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: InputMaybe<SortEnumType>;
  showDoc12AndTheirDatesOnDocumentList?: InputMaybe<SortEnumType>;
  showInventoryNumberOnWorkOrders?: InputMaybe<SortEnumType>;
  showItalianLabelsOnPrint?: InputMaybe<SortEnumType>;
  showItemAcCustomsTariffOnPrint?: InputMaybe<SortEnumType>;
  showItemAnNetWeightOnPrint?: InputMaybe<SortEnumType>;
  showItemPicturesOnPrint?: InputMaybe<SortEnumType>;
  showLastNOrdersForCustomer?: InputMaybe<SortEnumType>;
  showLineNoteOnPrint?: InputMaybe<SortEnumType>;
  showModifierCharacterPicker?: InputMaybe<SortEnumType>;
  showNumberOfUnlinkedDocuments?: InputMaybe<SortEnumType>;
  showOnlyArticlesWithCustomerContractPrice?: InputMaybe<SortEnumType>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: InputMaybe<SortEnumType>;
  showOnlyWOWhereCurrentUserSpecExists?: InputMaybe<SortEnumType>;
  showPackageQuantityEntryField?: InputMaybe<SortEnumType>;
  showPaymentMethod?: InputMaybe<SortEnumType>;
  showQuantityPerUnitOfMeasureOnPrint?: InputMaybe<SortEnumType>;
  showQuantityTotalOnPrint?: InputMaybe<SortEnumType>;
  showReceiverOnWorkOrders?: InputMaybe<SortEnumType>;
  showSerialNumberSearchForWorkOrders?: InputMaybe<SortEnumType>;
  showWOWorkersEntry?: InputMaybe<SortEnumType>;
  skipConfirmationOnShortcuts?: InputMaybe<SortEnumType>;
  skipGS1BarcodeCheck?: InputMaybe<SortEnumType>;
  stockViewLoadAllOnOpen?: InputMaybe<SortEnumType>;
  stockViewShowOnlyInStock?: InputMaybe<SortEnumType>;
  storeContactEmailArbitraryInField?: InputMaybe<SortEnumType>;
  subjectDocumentListDocumentType?: InputMaybe<SortEnumType>;
  subjectFieldForSSCCRequirementCheck?: InputMaybe<SortEnumType>;
  subjectFieldValueForSSCCRequirementCheck?: InputMaybe<SortEnumType>;
  syncPackagingWhenAddingNewItem?: InputMaybe<SortEnumType>;
  tHrPrsnForOnlyOnixPhoneUsers?: InputMaybe<SortEnumType>;
  tMNAcDefaultStatus?: InputMaybe<SortEnumType>;
  tMNAcDefaultSubject?: InputMaybe<SortEnumType>;
  tMNAnClassifIcationQid?: InputMaybe<SortEnumType>;
  tMNAnMailBoxQid?: InputMaybe<SortEnumType>;
  tMNAnStorageQid?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSize?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSizeHeight?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSizeWidth?: InputMaybe<SortEnumType>;
  thermalPrintShowCompanyImage?: InputMaybe<SortEnumType>;
  transferAcDoc1WhenCopying?: InputMaybe<SortEnumType>;
  transferAcDoc2WhenCopying?: InputMaybe<SortEnumType>;
  transferAdDateDoc1WhenCopying?: InputMaybe<SortEnumType>;
  transferAdDateDoc2WhenCopying?: InputMaybe<SortEnumType>;
  transferEnteredItemQuantityToSerialNumber?: InputMaybe<SortEnumType>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: InputMaybe<SortEnumType>;
  treatIdentAsBarcode?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  update?: InputMaybe<SortEnumType>;
  updateHeadAndDeleteAllItemsOnCopy?: InputMaybe<SortEnumType>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: InputMaybe<SortEnumType>;
  useDeadlineDateOnOverview?: InputMaybe<SortEnumType>;
  useSquareArticlePicker?: InputMaybe<SortEnumType>;
  useVerySmallMobileInterface?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
  visualAttributes?: InputMaybe<SortEnumType>;
  visualAttributesOverview?: InputMaybe<SortEnumType>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<SortEnumType>;
  warehouseName?: InputMaybe<SortEnumType>;
  warehouseOverviewShowOnlyInStock?: InputMaybe<SortEnumType>;
  warehousePositionTHeSetItemFieldName?: InputMaybe<SortEnumType>;
  warehouseShowPrices?: InputMaybe<SortEnumType>;
  warehouseViewFixedAcSubject?: InputMaybe<SortEnumType>;
  whenAddingSubjectSetAnClerkToCurrentUser?: InputMaybe<SortEnumType>;
  workOrderCanBeUnlocked?: InputMaybe<SortEnumType>;
  workOrderPrintSpecificationDuration?: InputMaybe<SortEnumType>;
  workOrderSpecificationPrefillTime?: InputMaybe<SortEnumType>;
  workOrderSpecificationTimeNotRequired?: InputMaybe<SortEnumType>;
  workOrderUnlockableStatus?: InputMaybe<SortEnumType>;
}

declare interface DocumentTypeUpdateDtoInput {
  addingItemWarnIfQuantityMoreThanAvailable: Scalars['Boolean'];
  articleSearchAllowSearchingByClassification: Scalars['Boolean'];
  articleSearchInitiallyLoadAll: Scalars['Boolean'];
  articleSearchRepeatLastSearch: Scalars['Boolean'];
  articleSearchShowOnlyInStock: Scalars['Boolean'];
  articleSearchShowOnlyWhereAcFieldsAIs?: InputMaybe<Scalars['String']>;
  bluetoothPrintCopiesNumber: Scalars['Int'];
  cacheDuration: Scalars['Int'];
  cacheUseCacheForAnyResource: Scalars['Boolean'];
  cacheUseForArticleSearch: Scalars['Boolean'];
  cacheUseForCustomerSearch: Scalars['Boolean'];
  cacheUseForWarehouseSearch: Scalars['Boolean'];
  documentOnCreateMakeBluetoothPrint: Scalars['Boolean'];
  documentOnCreateMakePDF: Scalars['Boolean'];
  itemListShowDetailed: Scalars['Boolean'];
  pickingShowConfirmationOnPick: Scalars['Boolean'];
  quantityDecimalPlaces: Scalars['Int'];
  sendB2BAsEInvoice?: InputMaybe<Scalars['Boolean']>;
  skipConfirmationOnShortcuts: Scalars['Boolean'];
  stockViewLoadAllOnOpen: Scalars['Boolean'];
  stockViewShowOnlyInStock: Scalars['Boolean'];
  warehouseOverviewShowOnlyInStock: Scalars['Boolean'];
  workOrderPrintSpecificationDuration: Scalars['Boolean'];
}

declare interface DocumentTypeUpdateDtoV2Input {
  addingItemWarnIfQuantityMoreThanAvailable: Scalars['Boolean'];
  articleSearchAllowSearchingByClassification: Scalars['Boolean'];
  articleSearchShowOnlyInStock: Scalars['Boolean'];
  bluetoothPrintCopiesNumber: Scalars['Int'];
  documentOnCreateMakeBluetoothPrint: Scalars['Boolean'];
  documentOnCreateMakePDF: Scalars['Boolean'];
  itemListShowDetailed: Scalars['Boolean'];
  quantityDecimalPlaces: Scalars['Int'];
  sendB2BAsEInvoice?: InputMaybe<Scalars['Boolean']>;
  skipConfirmationOnShortcuts: Scalars['Boolean'];
  stockViewShowOnlyInStock: Scalars['Boolean'];
  warehouseOverviewShowOnlyInStock: Scalars['Boolean'];
  workOrderPrintSpecificationDuration: Scalars['Boolean'];
}

declare interface EInvoiceDispatchDto {
  acKey?: Maybe<Scalars['String']>;
  artifactId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['DateTime'];
  dispatchId: Scalars['UUID'];
  documentUid: Scalars['String'];
  exchange: EInvoiceExchangeOutcome;
  firstFailureAt?: Maybe<Scalars['DateTime']>;
  fiscalization: EInvoiceFiscalizationOutcome;
  fiscalizedAt?: Maybe<Scalars['DateTime']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  nextAttemptAt?: Maybe<Scalars['DateTime']>;
  pdfByteLength?: Maybe<Scalars['Int']>;
  pdfSha256?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  stage: EInvoiceStage;
  state: EInvoiceQueueState;
  updatedAt: Scalars['DateTime'];
}

declare interface EInvoiceDocumentStatusDto {
  exchange: EInvoiceExchangeOutcome;
  fiscalization: EInvoiceFiscalizationOutcome;
  hasFailure: Scalars['Boolean'];
  reasonCode?: Maybe<Scalars['String']>;
  stage: EInvoiceStage;
  state: EInvoiceQueueState;
}

declare type EInvoiceExchangeOutcome =
  | 'ACCEPTED'
  | 'DEFINITIVELY_NOT_ACCEPTED'
  | 'NOT_ATTEMPTED'
  | 'UNCERTAIN';

declare type EInvoiceFiscalizationOutcome =
  | 'CONFIRMED'
  | 'FAILED'
  | 'PENDING'
  | 'UNKNOWN';

declare interface EInvoicePdfArtifactAck {
  artifactId: Scalars['UUID'];
  byteLength: Scalars['Int'];
  dispatch?: Maybe<EInvoiceDispatchDto>;
  sha256?: Maybe<Scalars['String']>;
}

declare interface EInvoicePreflightDto {
  contractVersion: Scalars['Int'];
  errors: Array<Scalars['String']>;
  maxPdfBytes: Scalars['Int'];
  reasonCode?: Maybe<Scalars['String']>;
  requiresF1Signing: Scalars['Boolean'];
  route: EInvoiceRoute;
}

declare interface EInvoicePreflightInput {
  buyerCode?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  documentUid?: InputMaybe<Scalars['String']>;
  eInvoiceContractVersion?: InputMaybe<Scalars['Int']>;
  originApplicationUserId?: InputMaybe<Scalars['String']>;
  originCompanySettingsId: Scalars['Int'];
  pairId?: InputMaybe<Scalars['Int']>;
  paymentMethodCode?: InputMaybe<Scalars['String']>;
  sourceAcKey?: InputMaybe<Scalars['String']>;
  updateExisting: Scalars['Boolean'];
}

declare type EInvoiceQueueState =
  | 'AWAITING_COMMIT'
  | 'AWAITING_FISCALIZATION'
  | 'AWAITING_PDF'
  | 'COMPLETED'
  | 'NEEDS_ATTENTION'
  | 'NOT_ISSUED'
  | 'PROCESSING'
  | 'READY'
  | 'RECONCILE_REQUIRED'
  | 'RETRY_PENDING';

declare type EInvoiceRoute =
  | 'F1'
  | 'F2'
  | 'LEGACY_MANUAL'
  | 'NOT_APPLICABLE';

declare type EInvoiceStage =
  | 'COMMIT'
  | 'FISCALIZATION'
  | 'PDF'
  | 'PROVIDER_EXCHANGE'
  | 'XML';

declare interface ExpenseBearer {
  active: Scalars['Boolean'];
  allowance: Scalars['Float'];
  bearer?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  consignee?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  pantheonId?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  receiver?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
}

declare interface ExpenseBearerFilterInput {
  active?: InputMaybe<BooleanOperationFilterInput>;
  allowance?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<ExpenseBearerFilterInput>>;
  bearer?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  consignee?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExpenseBearerFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  place?: InputMaybe<StringOperationFilterInput>;
  receiver?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
}

declare interface ExpenseBearerSortInput {
  active?: InputMaybe<SortEnumType>;
  allowance?: InputMaybe<SortEnumType>;
  bearer?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  consignee?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  place?: InputMaybe<SortEnumType>;
  receiver?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
}

declare interface ExternalAuthAccountChoiceDto {
  companyName?: Maybe<Scalars['String']>;
  companySettingsId?: Maybe<Scalars['Int']>;
  userId: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
}

declare interface ExternalAuthExchangeResultDto {
  accountChoices: Array<ExternalAuthAccountChoiceDto>;
  portalRegistrationDisplayName?: Maybe<Scalars['String']>;
  portalRegistrationEmail?: Maybe<Scalars['String']>;
  portalRegistrationTicket?: Maybe<Scalars['String']>;
  requiresAccountSelection: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
}

declare type ExternalAuthFlowKind =
  | 'LINK'
  | 'LOGIN';

declare interface ExternalAuthFlowKindOperationFilterInput {
  eq?: InputMaybe<ExternalAuthFlowKind>;
  in?: InputMaybe<Array<ExternalAuthFlowKind>>;
  neq?: InputMaybe<ExternalAuthFlowKind>;
  nin?: InputMaybe<Array<ExternalAuthFlowKind>>;
}

declare type ExternalAuthProvider =
  | 'APPLE'
  | 'GOOGLE'
  | 'MICROSOFT';

declare interface ExternalAuthProviderOperationFilterInput {
  eq?: InputMaybe<ExternalAuthProvider>;
  in?: InputMaybe<Array<ExternalAuthProvider>>;
  neq?: InputMaybe<ExternalAuthProvider>;
  nin?: InputMaybe<Array<ExternalAuthProvider>>;
}

declare interface ExternalAuthRequestState {
  appRedirectUri?: Maybe<Scalars['String']>;
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  consumedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
  flowKind: ExternalAuthFlowKind;
  id: Scalars['Int'];
  provider: ExternalAuthProvider;
  stateHash: Scalars['String'];
}

declare interface ExternalAuthRequestStateFilterInput {
  and?: InputMaybe<Array<ExternalAuthRequestStateFilterInput>>;
  appRedirectUri?: InputMaybe<StringOperationFilterInput>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  consumedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  createdAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  expiresAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  flowKind?: InputMaybe<ExternalAuthFlowKindOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ExternalAuthRequestStateFilterInput>>;
  provider?: InputMaybe<ExternalAuthProviderOperationFilterInput>;
  stateHash?: InputMaybe<StringOperationFilterInput>;
}

declare interface ExternalAuthStartResultDto {
  url?: Maybe<Scalars['String']>;
}

declare interface ExternalAuthTicket {
  consumedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
  externalIdentity?: Maybe<ExternalIdentity>;
  externalIdentityId: Scalars['Int'];
  id: Scalars['Int'];
  ticketHash?: Maybe<Scalars['String']>;
}

declare interface ExternalAuthTicketFilterInput {
  and?: InputMaybe<Array<ExternalAuthTicketFilterInput>>;
  consumedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  createdAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  expiresAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  externalIdentity?: InputMaybe<ExternalIdentityFilterInput>;
  externalIdentityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ExternalAuthTicketFilterInput>>;
  ticketHash?: InputMaybe<StringOperationFilterInput>;
}

declare interface ExternalIdentity {
  applicationUsers?: Maybe<Array<Maybe<ApplicationUserExternalIdentity>>>;
  createdAt: Scalars['DateTime'];
  displayName?: Maybe<Scalars['String']>;
  externalAuthTickets?: Maybe<Array<Maybe<ExternalAuthTicket>>>;
  id: Scalars['Int'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  provider: ExternalAuthProvider;
  providerSubject?: Maybe<Scalars['String']>;
  providerTenantId?: Maybe<Scalars['String']>;
  verifiedEmail?: Maybe<Scalars['String']>;
}

declare interface ExternalIdentityFilterInput {
  and?: InputMaybe<Array<ExternalIdentityFilterInput>>;
  applicationUsers?: InputMaybe<ListFilterInputTypeOfApplicationUserExternalIdentityFilterInput>;
  createdAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  externalAuthTickets?: InputMaybe<ListFilterInputTypeOfExternalAuthTicketFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lastUsedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ExternalIdentityFilterInput>>;
  provider?: InputMaybe<ExternalAuthProviderOperationFilterInput>;
  providerSubject?: InputMaybe<StringOperationFilterInput>;
  providerTenantId?: InputMaybe<StringOperationFilterInput>;
  verifiedEmail?: InputMaybe<StringOperationFilterInput>;
}

declare interface FcmToken {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  notificationDeliveryReport?: Maybe<Array<Maybe<NotificationDeliveryReport>>>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
}

declare interface FcmTokenFilterInput {
  and?: InputMaybe<Array<FcmTokenFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  notificationDeliveryReport?: InputMaybe<ListFilterInputTypeOfNotificationDeliveryReportFilterInput>;
  or?: InputMaybe<Array<FcmTokenFilterInput>>;
  token?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
}

declare type FiscalDataSource =
  | 'CLIENT'
  | 'SERVER';

declare interface FiscalDataSourceOperationFilterInput {
  eq?: InputMaybe<FiscalDataSource>;
  in?: InputMaybe<Array<FiscalDataSource>>;
  neq?: InputMaybe<FiscalDataSource>;
  nin?: InputMaybe<Array<FiscalDataSource>>;
}

declare interface FiscalizationCertificateValidationResult {
  error?: Maybe<Scalars['String']>;
  notAfterUtc?: Maybe<Scalars['DateTime']>;
  notBeforeUtc?: Maybe<Scalars['DateTime']>;
}

declare interface FiscalizationQueueEntry {
  acKey?: Maybe<Scalars['String']>;
  alreadyTriedFiscalizing: Scalars['Boolean'];
  documentType?: Maybe<DocumentType>;
  documentTypeId: Scalars['Int'];
  fiscalBaseAmount?: Maybe<Scalars['Decimal']>;
  fiscalDataSource: FiscalDataSource;
  fiscalInternalNumber?: Maybe<Scalars['String']>;
  fiscalSequenceNumber?: Maybe<Scalars['Int']>;
  fiscalTotal?: Maybe<Scalars['Decimal']>;
  fiscalYear?: Maybe<Scalars['Int']>;
  fiscalizationError?: Maybe<Scalars['String']>;
  fiscalized: Scalars['Boolean'];
  id: Scalars['Int'];
  jir?: Maybe<Scalars['String']>;
  requestData?: Maybe<Scalars['String']>;
  systemError?: Maybe<Scalars['String']>;
  uID?: Maybe<Scalars['String']>;
  xML?: Maybe<Scalars['String']>;
  zKI?: Maybe<Scalars['String']>;
}

declare interface FiscalizationQueueEntryFilterInput {
  acKey?: InputMaybe<StringOperationFilterInput>;
  alreadyTriedFiscalizing?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<FiscalizationQueueEntryFilterInput>>;
  documentType?: InputMaybe<DocumentTypeFilterInput>;
  documentTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  fiscalBaseAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  fiscalDataSource?: InputMaybe<FiscalDataSourceOperationFilterInput>;
  fiscalInternalNumber?: InputMaybe<StringOperationFilterInput>;
  fiscalSequenceNumber?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  fiscalTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  fiscalYear?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  fiscalizationError?: InputMaybe<StringOperationFilterInput>;
  fiscalized?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  jir?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FiscalizationQueueEntryFilterInput>>;
  requestData?: InputMaybe<StringOperationFilterInput>;
  systemError?: InputMaybe<StringOperationFilterInput>;
  uID?: InputMaybe<StringOperationFilterInput>;
  xML?: InputMaybe<StringOperationFilterInput>;
  zKI?: InputMaybe<StringOperationFilterInput>;
}

declare interface FiscalizationQueueEntrySortInput {
  acKey?: InputMaybe<SortEnumType>;
  alreadyTriedFiscalizing?: InputMaybe<SortEnumType>;
  documentType?: InputMaybe<DocumentTypeSortInput>;
  documentTypeId?: InputMaybe<SortEnumType>;
  fiscalBaseAmount?: InputMaybe<SortEnumType>;
  fiscalDataSource?: InputMaybe<SortEnumType>;
  fiscalInternalNumber?: InputMaybe<SortEnumType>;
  fiscalSequenceNumber?: InputMaybe<SortEnumType>;
  fiscalTotal?: InputMaybe<SortEnumType>;
  fiscalYear?: InputMaybe<SortEnumType>;
  fiscalizationError?: InputMaybe<SortEnumType>;
  fiscalized?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jir?: InputMaybe<SortEnumType>;
  requestData?: InputMaybe<SortEnumType>;
  systemError?: InputMaybe<SortEnumType>;
  uID?: InputMaybe<SortEnumType>;
  xML?: InputMaybe<SortEnumType>;
  zKI?: InputMaybe<SortEnumType>;
}

declare interface IBackupEventLogComputer {
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
}

declare interface IBackupEventLogComputerFilterInput {
  and?: InputMaybe<Array<IBackupEventLogComputerFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IBackupEventLogComputerFilterInput>>;
}

declare interface IEqualityComparerOfStringFilterInput {
  and?: InputMaybe<Array<IEqualityComparerOfStringFilterInput>>;
  or?: InputMaybe<Array<IEqualityComparerOfStringFilterInput>>;
}

declare type InstallationVariableType =
  | 'BOOLEAN'
  | 'DATE_TIME'
  | 'FLOAT'
  | 'INTEGER'
  | 'STRING';

declare interface InstallationVariableTypeOperationFilterInput {
  eq?: InputMaybe<InstallationVariableType>;
  in?: InputMaybe<Array<InstallationVariableType>>;
  neq?: InputMaybe<InstallationVariableType>;
  nin?: InputMaybe<Array<InstallationVariableType>>;
}

declare type InvoiceSumType =
  | 'COUNT'
  | 'DURATION_SUM';

declare interface Item {
  code?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  itemGroupItems?: Maybe<Array<Maybe<ItemGroupItem>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  pantheonId?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
}

declare interface ItemCollectionSegment {
  items?: Maybe<Array<Maybe<Item>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
}

declare interface ItemFilterInput {
  and?: InputMaybe<Array<ItemFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  department?: InputMaybe<DepartmentFilterInput>;
  departmentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemGroupItems?: InputMaybe<ListFilterInputTypeOfItemGroupItemFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ItemFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
}

declare interface ItemGroup {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  itemGroupItems?: Maybe<Array<Maybe<ItemGroupItem>>>;
  itemGroupMaterials?: Maybe<Array<Maybe<MarservisItemGroupMaterial>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
}

declare interface ItemGroupFilterInput {
  and?: InputMaybe<Array<ItemGroupFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemGroupItems?: InputMaybe<ListFilterInputTypeOfItemGroupItemFilterInput>;
  itemGroupMaterials?: InputMaybe<ListFilterInputTypeOfMarservisItemGroupMaterialFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ItemGroupFilterInput>>;
}

declare interface ItemGroupItem {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  item?: Maybe<Item>;
  itemGroup?: Maybe<ItemGroup>;
  itemGroupId: Scalars['Int'];
  itemId: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
}

declare interface ItemGroupItemFilterInput {
  and?: InputMaybe<Array<ItemGroupItemFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  item?: InputMaybe<ItemFilterInput>;
  itemGroup?: InputMaybe<ItemGroupFilterInput>;
  itemGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ItemGroupItemFilterInput>>;
}

declare interface ItemGroupSortInput {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
}

declare interface ItemSortInput {
  code?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  department?: InputMaybe<DepartmentSortInput>;
  departmentId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
}

declare interface KeyValuePairOfStringAndDateTimeInput {
  key: Scalars['String'];
  value: Scalars['DateTime'];
}

declare interface KeyValuePairOfStringAndDictionaryOfStringAndString {
  key: Scalars['String'];
  value: Array<KeyValuePairOfStringAndString>;
}

declare interface KeyValuePairOfStringAndString {
  key: Scalars['String'];
  value: Scalars['String'];
}

declare interface KeyValuePairOfStringAndStringInput {
  key: Scalars['String'];
  value: Scalars['String'];
}

declare interface KeyValueStorageChangeLogInput {
  added?: InputMaybe<Array<InputMaybe<OnixPhoneKeyValueStorageInput>>>;
  deleted?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updated?: InputMaybe<Array<InputMaybe<OnixPhoneKeyValueStorageInput>>>;
}

declare interface LurInvoiceListItemDto {
  acCurrency?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acHrFiskalNumber?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPrsn3?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acVerifiedPrices?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClerk: Scalars['Int'];
  anForPay: Scalars['Decimal'];
}

declare interface LurInvoiceListItemDtoFilterInput {
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDoc1?: InputMaybe<StringOperationFilterInput>;
  acDoc2?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acHrFiskalNumber?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPrsn3?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acVerifiedPrices?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClerk?: InputMaybe<ComparableInt32OperationFilterInput>;
  anForPay?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<LurInvoiceListItemDtoFilterInput>>;
  or?: InputMaybe<Array<LurInvoiceListItemDtoFilterInput>>;
}

declare interface LurInvoiceListItemDtoSortInput {
  acCurrency?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acDoc1?: InputMaybe<SortEnumType>;
  acDoc2?: InputMaybe<SortEnumType>;
  acDocType?: InputMaybe<SortEnumType>;
  acHrFiskalNumber?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acPayMethod?: InputMaybe<SortEnumType>;
  acPrsn3?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acVerifiedPrices?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anForPay?: InputMaybe<SortEnumType>;
}

/** A connection to a list of items. */
declare interface LurInvoiceListItemsConnection {
  /** A list of edges. */
  edges?: Maybe<Array<LurInvoiceListItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<LurInvoiceListItemDto>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface LurInvoiceListItemsEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LurInvoiceListItemDto>;
}

declare interface LabelComposition {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  sVGTemplate?: Maybe<Scalars['String']>;
}

declare interface LabelCompositionFilterInput {
  and?: InputMaybe<Array<LabelCompositionFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LabelCompositionFilterInput>>;
  sVGTemplate?: InputMaybe<StringOperationFilterInput>;
}

declare type LabelContinuousOrSingleSheetEnum =
  | 'CONTINUOUS'
  | 'SINGLE_SHEET';

declare interface LabelContinuousOrSingleSheetEnumOperationFilterInput {
  eq?: InputMaybe<LabelContinuousOrSingleSheetEnum>;
  in?: InputMaybe<Array<LabelContinuousOrSingleSheetEnum>>;
  neq?: InputMaybe<LabelContinuousOrSingleSheetEnum>;
  nin?: InputMaybe<Array<LabelContinuousOrSingleSheetEnum>>;
}

declare interface LabelDefinition {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  continuousOrSingleSheet: LabelContinuousOrSingleSheetEnum;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lHDist: Scalars['Int'];
  lHeight: Scalars['Int'];
  lLeft: Scalars['Int'];
  lPHeight: Scalars['Int'];
  lPWidth: Scalars['Int'];
  lUpper: Scalars['Int'];
  lVDist: Scalars['Int'];
  lWidth: Scalars['Int'];
  manufacturer?: Maybe<Scalars['String']>;
  manufacturerId?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  nCols: Scalars['Int'];
  nRows: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
}

declare interface LabelDefinitionFilterInput {
  and?: InputMaybe<Array<LabelDefinitionFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  continuousOrSingleSheet?: InputMaybe<LabelContinuousOrSingleSheetEnumOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lHDist?: InputMaybe<ComparableInt32OperationFilterInput>;
  lHeight?: InputMaybe<ComparableInt32OperationFilterInput>;
  lLeft?: InputMaybe<ComparableInt32OperationFilterInput>;
  lPHeight?: InputMaybe<ComparableInt32OperationFilterInput>;
  lPWidth?: InputMaybe<ComparableInt32OperationFilterInput>;
  lUpper?: InputMaybe<ComparableInt32OperationFilterInput>;
  lVDist?: InputMaybe<ComparableInt32OperationFilterInput>;
  lWidth?: InputMaybe<ComparableInt32OperationFilterInput>;
  manufacturer?: InputMaybe<StringOperationFilterInput>;
  manufacturerId?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  nCols?: InputMaybe<ComparableInt32OperationFilterInput>;
  nRows?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LabelDefinitionFilterInput>>;
}

declare interface LabelDefinitionLocation {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  documentType?: Maybe<DocumentType>;
  documentTypeId: Scalars['Int'];
  id: Scalars['Int'];
  labelComposition?: Maybe<LabelComposition>;
  labelCompositionId?: Maybe<Scalars['Int']>;
  labelDefinition?: Maybe<LabelDefinition>;
  labelDefinitionId: Scalars['Int'];
  location: LabelDefinitionLocationEnum;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
}

declare type LabelDefinitionLocationEnum =
  | 'WAREHOUSE_OVERVIEW';

declare interface LabelDefinitionLocationEnumOperationFilterInput {
  eq?: InputMaybe<LabelDefinitionLocationEnum>;
  in?: InputMaybe<Array<LabelDefinitionLocationEnum>>;
  neq?: InputMaybe<LabelDefinitionLocationEnum>;
  nin?: InputMaybe<Array<LabelDefinitionLocationEnum>>;
}

declare interface LabelDefinitionLocationFilterInput {
  and?: InputMaybe<Array<LabelDefinitionLocationFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  documentType?: InputMaybe<DocumentTypeFilterInput>;
  documentTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  labelComposition?: InputMaybe<LabelCompositionFilterInput>;
  labelCompositionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  labelDefinition?: InputMaybe<LabelDefinitionFilterInput>;
  labelDefinitionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  location?: InputMaybe<LabelDefinitionLocationEnumOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<LabelDefinitionLocationFilterInput>>;
}

declare interface ListComparableByteOperationFilterInput {
  all?: InputMaybe<ComparableByteOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ComparableByteOperationFilterInput>;
  some?: InputMaybe<ComparableByteOperationFilterInput>;
}

declare interface ListFilterInputTypeOfApplicationPacketFilterInput {
  all?: InputMaybe<ApplicationPacketFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationPacketFilterInput>;
  some?: InputMaybe<ApplicationPacketFilterInput>;
}

declare interface ListFilterInputTypeOfApplicationUserExternalIdentityFilterInput {
  all?: InputMaybe<ApplicationUserExternalIdentityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationUserExternalIdentityFilterInput>;
  some?: InputMaybe<ApplicationUserExternalIdentityFilterInput>;
}

declare interface ListFilterInputTypeOfApplicationUserFilterInput {
  all?: InputMaybe<ApplicationUserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationUserFilterInput>;
  some?: InputMaybe<ApplicationUserFilterInput>;
}

declare interface ListFilterInputTypeOfApplicationUserRoleFilterInput {
  all?: InputMaybe<ApplicationUserRoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationUserRoleFilterInput>;
  some?: InputMaybe<ApplicationUserRoleFilterInput>;
}

declare interface ListFilterInputTypeOfApplicationUserWakaAuthorFilterInput {
  all?: InputMaybe<ApplicationUserWakaAuthorFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationUserWakaAuthorFilterInput>;
  some?: InputMaybe<ApplicationUserWakaAuthorFilterInput>;
}

declare interface ListFilterInputTypeOfApplicationUserWakaMachineFilterInput {
  all?: InputMaybe<ApplicationUserWakaMachineFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationUserWakaMachineFilterInput>;
  some?: InputMaybe<ApplicationUserWakaMachineFilterInput>;
}

declare interface ListFilterInputTypeOfApplicationUserWakaProjectMapFilterInput {
  all?: InputMaybe<ApplicationUserWakaProjectMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationUserWakaProjectMapFilterInput>;
  some?: InputMaybe<ApplicationUserWakaProjectMapFilterInput>;
}

declare interface ListFilterInputTypeOfAresDeploymentAresCompanyCurrentVersionFilterInput {
  all?: InputMaybe<AresDeploymentAresCompanyCurrentVersionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentAresCompanyCurrentVersionFilterInput>;
  some?: InputMaybe<AresDeploymentAresCompanyCurrentVersionFilterInput>;
}

declare interface ListFilterInputTypeOfAresDeploymentAresFilterInput {
  all?: InputMaybe<AresDeploymentAresFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentAresFilterInput>;
  some?: InputMaybe<AresDeploymentAresFilterInput>;
}

declare interface ListFilterInputTypeOfAresDeploymentGroupCompanyMappingFilterInput {
  all?: InputMaybe<AresDeploymentGroupCompanyMappingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentGroupCompanyMappingFilterInput>;
  some?: InputMaybe<AresDeploymentGroupCompanyMappingFilterInput>;
}

declare interface ListFilterInputTypeOfAresDeploymentGroupInstallationStepFilterInput {
  all?: InputMaybe<AresDeploymentGroupInstallationStepFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentGroupInstallationStepFilterInput>;
  some?: InputMaybe<AresDeploymentGroupInstallationStepFilterInput>;
}

declare interface ListFilterInputTypeOfAresDeploymentGroupSnapshotFilterInput {
  all?: InputMaybe<AresDeploymentGroupSnapshotFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentGroupSnapshotFilterInput>;
  some?: InputMaybe<AresDeploymentGroupSnapshotFilterInput>;
}

declare interface ListFilterInputTypeOfAresDeploymentInstallationStepPointFilterInput {
  all?: InputMaybe<AresDeploymentInstallationStepPointFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentInstallationStepPointFilterInput>;
  some?: InputMaybe<AresDeploymentInstallationStepPointFilterInput>;
}

declare interface ListFilterInputTypeOfAresDeploymentOnixPhoneSettingsFilterInput {
  all?: InputMaybe<AresDeploymentOnixPhoneSettingsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentOnixPhoneSettingsFilterInput>;
  some?: InputMaybe<AresDeploymentOnixPhoneSettingsFilterInput>;
}

declare interface ListFilterInputTypeOfAresDeploymentWorkflowDefinitionFilterInput {
  all?: InputMaybe<AresDeploymentWorkflowDefinitionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentWorkflowDefinitionFilterInput>;
  some?: InputMaybe<AresDeploymentWorkflowDefinitionFilterInput>;
}

declare interface ListFilterInputTypeOfCompanyDatalabReferenceLinkFilterInput {
  all?: InputMaybe<CompanyDatalabReferenceLinkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanyDatalabReferenceLinkFilterInput>;
  some?: InputMaybe<CompanyDatalabReferenceLinkFilterInput>;
}

declare interface ListFilterInputTypeOfCompanyEmailForwardFilterInput {
  all?: InputMaybe<CompanyEmailForwardFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanyEmailForwardFilterInput>;
  some?: InputMaybe<CompanyEmailForwardFilterInput>;
}

declare interface ListFilterInputTypeOfCompanyMachineUidFilterInput {
  all?: InputMaybe<CompanyMachineUidFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanyMachineUidFilterInput>;
  some?: InputMaybe<CompanyMachineUidFilterInput>;
}

declare interface ListFilterInputTypeOfCompanyMeshCentralGroupMappingFilterInput {
  all?: InputMaybe<CompanyMeshCentralGroupMappingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanyMeshCentralGroupMappingFilterInput>;
  some?: InputMaybe<CompanyMeshCentralGroupMappingFilterInput>;
}

declare interface ListFilterInputTypeOfCompanyRunbookNoteFilterInput {
  all?: InputMaybe<CompanyRunbookNoteFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanyRunbookNoteFilterInput>;
  some?: InputMaybe<CompanyRunbookNoteFilterInput>;
}

declare interface ListFilterInputTypeOfCompanySettingsWorkHoursFilterInput {
  all?: InputMaybe<CompanySettingsWorkHoursFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanySettingsWorkHoursFilterInput>;
  some?: InputMaybe<CompanySettingsWorkHoursFilterInput>;
}

declare interface ListFilterInputTypeOfCompanyTeamViewerContactFilterInput {
  all?: InputMaybe<CompanyTeamViewerContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanyTeamViewerContactFilterInput>;
  some?: InputMaybe<CompanyTeamViewerContactFilterInput>;
}

declare interface ListFilterInputTypeOfCompanyTeamViewerDeviceFilterInput {
  all?: InputMaybe<CompanyTeamViewerDeviceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanyTeamViewerDeviceFilterInput>;
  some?: InputMaybe<CompanyTeamViewerDeviceFilterInput>;
}

declare interface ListFilterInputTypeOfContactCompanyFilterInput {
  all?: InputMaybe<ContactCompanyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ContactCompanyFilterInput>;
  some?: InputMaybe<ContactCompanyFilterInput>;
}

declare interface ListFilterInputTypeOfContactEmailFilterInput {
  all?: InputMaybe<ContactEmailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ContactEmailFilterInput>;
  some?: InputMaybe<ContactEmailFilterInput>;
}

declare interface ListFilterInputTypeOfContactPhoneFilterInput {
  all?: InputMaybe<ContactPhoneFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ContactPhoneFilterInput>;
  some?: InputMaybe<ContactPhoneFilterInput>;
}

declare interface ListFilterInputTypeOfDatalabReferenceCompanyFilterInput {
  all?: InputMaybe<DatalabReferenceCompanyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DatalabReferenceCompanyFilterInput>;
  some?: InputMaybe<DatalabReferenceCompanyFilterInput>;
}

declare interface ListFilterInputTypeOfDatalabReleaseLockdownRunFilterInput {
  all?: InputMaybe<DatalabReleaseLockdownRunFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DatalabReleaseLockdownRunFilterInput>;
  some?: InputMaybe<DatalabReleaseLockdownRunFilterInput>;
}

declare interface ListFilterInputTypeOfDocumentTypeArbitraryFieldFilterInput {
  all?: InputMaybe<DocumentTypeArbitraryFieldFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentTypeArbitraryFieldFilterInput>;
  some?: InputMaybe<DocumentTypeArbitraryFieldFilterInput>;
}

declare interface ListFilterInputTypeOfDocumentTypeFilterInput {
  all?: InputMaybe<DocumentTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentTypeFilterInput>;
  some?: InputMaybe<DocumentTypeFilterInput>;
}

declare interface ListFilterInputTypeOfDocumentTypeLinkFilterInput {
  all?: InputMaybe<DocumentTypeLinkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentTypeLinkFilterInput>;
  some?: InputMaybe<DocumentTypeLinkFilterInput>;
}

declare interface ListFilterInputTypeOfDocumentTypePairFilterInput {
  all?: InputMaybe<DocumentTypePairFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentTypePairFilterInput>;
  some?: InputMaybe<DocumentTypePairFilterInput>;
}

declare interface ListFilterInputTypeOfExpenseBearerFilterInput {
  all?: InputMaybe<ExpenseBearerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ExpenseBearerFilterInput>;
  some?: InputMaybe<ExpenseBearerFilterInput>;
}

declare interface ListFilterInputTypeOfExternalAuthRequestStateFilterInput {
  all?: InputMaybe<ExternalAuthRequestStateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ExternalAuthRequestStateFilterInput>;
  some?: InputMaybe<ExternalAuthRequestStateFilterInput>;
}

declare interface ListFilterInputTypeOfExternalAuthTicketFilterInput {
  all?: InputMaybe<ExternalAuthTicketFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ExternalAuthTicketFilterInput>;
  some?: InputMaybe<ExternalAuthTicketFilterInput>;
}

declare interface ListFilterInputTypeOfFcmTokenFilterInput {
  all?: InputMaybe<FcmTokenFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FcmTokenFilterInput>;
  some?: InputMaybe<FcmTokenFilterInput>;
}

declare interface ListFilterInputTypeOfFiscalizationQueueEntryFilterInput {
  all?: InputMaybe<FiscalizationQueueEntryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FiscalizationQueueEntryFilterInput>;
  some?: InputMaybe<FiscalizationQueueEntryFilterInput>;
}

declare interface ListFilterInputTypeOfIBackupEventLogComputerFilterInput {
  all?: InputMaybe<IBackupEventLogComputerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<IBackupEventLogComputerFilterInput>;
  some?: InputMaybe<IBackupEventLogComputerFilterInput>;
}

declare interface ListFilterInputTypeOfItemFilterInput {
  all?: InputMaybe<ItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ItemFilterInput>;
  some?: InputMaybe<ItemFilterInput>;
}

declare interface ListFilterInputTypeOfItemGroupItemFilterInput {
  all?: InputMaybe<ItemGroupItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ItemGroupItemFilterInput>;
  some?: InputMaybe<ItemGroupItemFilterInput>;
}

declare interface ListFilterInputTypeOfLabelDefinitionLocationFilterInput {
  all?: InputMaybe<LabelDefinitionLocationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<LabelDefinitionLocationFilterInput>;
  some?: InputMaybe<LabelDefinitionLocationFilterInput>;
}

declare interface ListFilterInputTypeOfMarservisItemGroupMaterialFilterInput {
  all?: InputMaybe<MarservisItemGroupMaterialFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MarservisItemGroupMaterialFilterInput>;
  some?: InputMaybe<MarservisItemGroupMaterialFilterInput>;
}

declare interface ListFilterInputTypeOfMarservisWorkOrderItemFilterInput {
  all?: InputMaybe<MarservisWorkOrderItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MarservisWorkOrderItemFilterInput>;
  some?: InputMaybe<MarservisWorkOrderItemFilterInput>;
}

declare interface ListFilterInputTypeOfMarservisWorkOrderItemItemFilterInput {
  all?: InputMaybe<MarservisWorkOrderItemItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MarservisWorkOrderItemItemFilterInput>;
  some?: InputMaybe<MarservisWorkOrderItemItemFilterInput>;
}

declare interface ListFilterInputTypeOfMarservisWorkOrderItemWorkFilterInput {
  all?: InputMaybe<MarservisWorkOrderItemWorkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MarservisWorkOrderItemWorkFilterInput>;
  some?: InputMaybe<MarservisWorkOrderItemWorkFilterInput>;
}

declare interface ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialFilterInput {
  all?: InputMaybe<MarservisWorkOrderItemWorkMaterialFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MarservisWorkOrderItemWorkMaterialFilterInput>;
  some?: InputMaybe<MarservisWorkOrderItemWorkMaterialFilterInput>;
}

declare interface ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialInputDtoFilterInput {
  all?: InputMaybe<MarservisWorkOrderItemWorkMaterialInputDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MarservisWorkOrderItemWorkMaterialInputDtoFilterInput>;
  some?: InputMaybe<MarservisWorkOrderItemWorkMaterialInputDtoFilterInput>;
}

declare interface ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialReturnDtoFilterInput {
  all?: InputMaybe<MarservisWorkOrderItemWorkMaterialReturnDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MarservisWorkOrderItemWorkMaterialReturnDtoFilterInput>;
  some?: InputMaybe<MarservisWorkOrderItemWorkMaterialReturnDtoFilterInput>;
}

declare interface ListFilterInputTypeOfNotificationDeliveryReportFilterInput {
  all?: InputMaybe<NotificationDeliveryReportFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<NotificationDeliveryReportFilterInput>;
  some?: InputMaybe<NotificationDeliveryReportFilterInput>;
}

declare interface ListFilterInputTypeOfOnixPhoneUserTaskQueueFilterInput {
  all?: InputMaybe<OnixPhoneUserTaskQueueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OnixPhoneUserTaskQueueFilterInput>;
  some?: InputMaybe<OnixPhoneUserTaskQueueFilterInput>;
}

declare interface ListFilterInputTypeOfSavedFileFilterInput {
  all?: InputMaybe<SavedFileFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SavedFileFilterInput>;
  some?: InputMaybe<SavedFileFilterInput>;
}

declare interface ListFilterInputTypeOfSupportGroupMemberFilterInput {
  all?: InputMaybe<SupportGroupMemberFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SupportGroupMemberFilterInput>;
  some?: InputMaybe<SupportGroupMemberFilterInput>;
}

declare interface ListFilterInputTypeOfSupportOpenAiExecutionFilterInput {
  all?: InputMaybe<SupportOpenAiExecutionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SupportOpenAiExecutionFilterInput>;
  some?: InputMaybe<SupportOpenAiExecutionFilterInput>;
}

declare interface ListFilterInputTypeOfSupportTicketFilterInput {
  all?: InputMaybe<SupportTicketFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SupportTicketFilterInput>;
  some?: InputMaybe<SupportTicketFilterInput>;
}

declare interface ListFilterInputTypeOfSupportTicketMessageFilterInput {
  all?: InputMaybe<SupportTicketMessageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SupportTicketMessageFilterInput>;
  some?: InputMaybe<SupportTicketMessageFilterInput>;
}

declare interface ListFilterInputTypeOfSupportTicketTimeLogFilterInput {
  all?: InputMaybe<SupportTicketTimeLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SupportTicketTimeLogFilterInput>;
  some?: InputMaybe<SupportTicketTimeLogFilterInput>;
}

declare interface ListFilterInputTypeOfSupportTicketTodoFilterInput {
  all?: InputMaybe<SupportTicketTodoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SupportTicketTodoFilterInput>;
  some?: InputMaybe<SupportTicketTodoFilterInput>;
}

declare interface ListFilterInputTypeOfSynchronizationFilterInput {
  all?: InputMaybe<SynchronizationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SynchronizationFilterInput>;
  some?: InputMaybe<SynchronizationFilterInput>;
}

declare interface ListFilterInputTypeOfTHeCashRegItemFilterInput {
  all?: InputMaybe<THeCashRegItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeCashRegItemFilterInput>;
  some?: InputMaybe<THeCashRegItemFilterInput>;
}

declare interface ListFilterInputTypeOfTHeCostDrvFilterInput {
  all?: InputMaybe<THeCostDrvFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeCostDrvFilterInput>;
  some?: InputMaybe<THeCostDrvFilterInput>;
}

declare interface ListFilterInputTypeOfTHeLinkMoveItemMoveItemFilterInput {
  all?: InputMaybe<THeLinkMoveItemMoveItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeLinkMoveItemMoveItemFilterInput>;
  some?: InputMaybe<THeLinkMoveItemMoveItemFilterInput>;
}

declare interface ListFilterInputTypeOfTHeLinkMoveItemOrderItemFilterInput {
  all?: InputMaybe<THeLinkMoveItemOrderItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeLinkMoveItemOrderItemFilterInput>;
  some?: InputMaybe<THeLinkMoveItemOrderItemFilterInput>;
}

declare interface ListFilterInputTypeOfTHeLinkMoveMoveFilterInput {
  all?: InputMaybe<THeLinkMoveMoveFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeLinkMoveMoveFilterInput>;
  some?: InputMaybe<THeLinkMoveMoveFilterInput>;
}

declare interface ListFilterInputTypeOfTHeMoveFilterInput {
  all?: InputMaybe<THeMoveFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeMoveFilterInput>;
  some?: InputMaybe<THeMoveFilterInput>;
}

declare interface ListFilterInputTypeOfTHeMoveItemExciseFilterInput {
  all?: InputMaybe<THeMoveItemExciseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeMoveItemExciseFilterInput>;
  some?: InputMaybe<THeMoveItemExciseFilterInput>;
}

declare interface ListFilterInputTypeOfTHeMoveItemExciseOutFilterInput {
  all?: InputMaybe<THeMoveItemExciseOutFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeMoveItemExciseOutFilterInput>;
  some?: InputMaybe<THeMoveItemExciseOutFilterInput>;
}

declare interface ListFilterInputTypeOfTHeMoveItemFilterInput {
  all?: InputMaybe<THeMoveItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeMoveItemFilterInput>;
  some?: InputMaybe<THeMoveItemFilterInput>;
}

declare interface ListFilterInputTypeOfTHeMoveItemSerialNoFilterInput {
  all?: InputMaybe<THeMoveItemSerialNoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeMoveItemSerialNoFilterInput>;
  some?: InputMaybe<THeMoveItemSerialNoFilterInput>;
}

declare interface ListFilterInputTypeOfTHeMovePaymentRecordFilterInput {
  all?: InputMaybe<THeMovePaymentRecordFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeMovePaymentRecordFilterInput>;
  some?: InputMaybe<THeMovePaymentRecordFilterInput>;
}

declare interface ListFilterInputTypeOfTHeOrderFilterInput {
  all?: InputMaybe<THeOrderFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeOrderFilterInput>;
  some?: InputMaybe<THeOrderFilterInput>;
}

declare interface ListFilterInputTypeOfTHeOrderItemFilterInput {
  all?: InputMaybe<THeOrderItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeOrderItemFilterInput>;
  some?: InputMaybe<THeOrderItemFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSetCustTariffFilterInput {
  all?: InputMaybe<THeSetCustTariffFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetCustTariffFilterInput>;
  some?: InputMaybe<THeSetCustTariffFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSetCustTariffSaleExFilterInput {
  all?: InputMaybe<THeSetCustTariffSaleExFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetCustTariffSaleExFilterInput>;
  some?: InputMaybe<THeSetCustTariffSaleExFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSetItemExciseFilterInput {
  all?: InputMaybe<THeSetItemExciseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetItemExciseFilterInput>;
  some?: InputMaybe<THeSetItemExciseFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSetItemExtItemSubjFilterInput {
  all?: InputMaybe<THeSetItemExtItemSubjFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetItemExtItemSubjFilterInput>;
  some?: InputMaybe<THeSetItemExtItemSubjFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSetItemFilterInput {
  all?: InputMaybe<THeSetItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetItemFilterInput>;
  some?: InputMaybe<THeSetItemFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSetItemPriceForWrhFilterInput {
  all?: InputMaybe<THeSetItemPriceForWrhFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetItemPriceForWrhFilterInput>;
  some?: InputMaybe<THeSetItemPriceForWrhFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSetItemSntitemFilterInput {
  all?: InputMaybe<THeSetItemSntitemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetItemSntitemFilterInput>;
  some?: InputMaybe<THeSetItemSntitemFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSetItemSntserialNoFilterInput {
  all?: InputMaybe<THeSetItemSntserialNoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetItemSntserialNoFilterInput>;
  some?: InputMaybe<THeSetItemSntserialNoFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSetSubjContactAddressFilterInput {
  all?: InputMaybe<THeSetSubjContactAddressFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetSubjContactAddressFilterInput>;
  some?: InputMaybe<THeSetSubjContactAddressFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSetSubjContactFilterInput {
  all?: InputMaybe<THeSetSubjContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetSubjContactFilterInput>;
  some?: InputMaybe<THeSetSubjContactFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSetSubjFilterInput {
  all?: InputMaybe<THeSetSubjFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetSubjFilterInput>;
  some?: InputMaybe<THeSetSubjFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSetSubjPriceCategFilterInput {
  all?: InputMaybe<THeSetSubjPriceCategFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetSubjPriceCategFilterInput>;
  some?: InputMaybe<THeSetSubjPriceCategFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSetSubjPriceItemFilterInput {
  all?: InputMaybe<THeSetSubjPriceItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetSubjPriceItemFilterInput>;
  some?: InputMaybe<THeSetSubjPriceItemFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSetTaxFilterInput {
  all?: InputMaybe<THeSetTaxFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetTaxFilterInput>;
  some?: InputMaybe<THeSetTaxFilterInput>;
}

declare interface ListFilterInputTypeOfTHeStockFilterInput {
  all?: InputMaybe<THeStockFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeStockFilterInput>;
  some?: InputMaybe<THeStockFilterInput>;
}

declare interface ListFilterInputTypeOfTHeStockSerialNoFilterInput {
  all?: InputMaybe<THeStockSerialNoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeStockSerialNoFilterInput>;
  some?: InputMaybe<THeStockSerialNoFilterInput>;
}

declare interface ListFilterInputTypeOfTHeSubjTypeFilterInput {
  all?: InputMaybe<THeSubjTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSubjTypeFilterInput>;
  some?: InputMaybe<THeSubjTypeFilterInput>;
}

declare interface ListFilterInputTypeOfTHfPlanFilterInput {
  all?: InputMaybe<THfPlanFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THfPlanFilterInput>;
  some?: InputMaybe<THfPlanFilterInput>;
}

declare interface ListFilterInputTypeOfTHfWoexFilterInput {
  all?: InputMaybe<THfWoexFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THfWoexFilterInput>;
  some?: InputMaybe<THfWoexFilterInput>;
}

declare interface ListFilterInputTypeOfTHfWoexItemFilterInput {
  all?: InputMaybe<THfWoexItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THfWoexItemFilterInput>;
  some?: InputMaybe<THfWoexItemFilterInput>;
}

declare interface ListFilterInputTypeOfTHfWoexItemSerialNoFilterInput {
  all?: InputMaybe<THfWoexItemSerialNoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THfWoexItemSerialNoFilterInput>;
  some?: InputMaybe<THfWoexItemSerialNoFilterInput>;
}

declare interface ListFilterInputTypeOfTHrLinkTrvlTrvlFilterInput {
  all?: InputMaybe<THrLinkTrvlTrvlFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THrLinkTrvlTrvlFilterInput>;
  some?: InputMaybe<THrLinkTrvlTrvlFilterInput>;
}

declare interface ListFilterInputTypeOfTHrPrsnStatusFilterInput {
  all?: InputMaybe<THrPrsnStatusFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THrPrsnStatusFilterInput>;
  some?: InputMaybe<THrPrsnStatusFilterInput>;
}

declare interface ListFilterInputTypeOfTHrTrvlFilterInput {
  all?: InputMaybe<THrTrvlFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THrTrvlFilterInput>;
  some?: InputMaybe<THrTrvlFilterInput>;
}

declare interface ListFilterInputTypeOfTHrTrvlItemExpWithAttachmentFilterInput {
  all?: InputMaybe<THrTrvlItemExpWithAttachmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THrTrvlItemExpWithAttachmentFilterInput>;
  some?: InputMaybe<THrTrvlItemExpWithAttachmentFilterInput>;
}

declare interface ListFilterInputTypeOfTHrTrvlItemFilterInput {
  all?: InputMaybe<THrTrvlItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THrTrvlItemFilterInput>;
  some?: InputMaybe<THrTrvlItemFilterInput>;
}

declare interface ListFilterInputTypeOfTMnDocumentChatLogFilterInput {
  all?: InputMaybe<TMnDocumentChatLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnDocumentChatLogFilterInput>;
  some?: InputMaybe<TMnDocumentChatLogFilterInput>;
}

declare interface ListFilterInputTypeOfTMnDocumentFilterInput {
  all?: InputMaybe<TMnDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnDocumentFilterInput>;
  some?: InputMaybe<TMnDocumentFilterInput>;
}

declare interface ListFilterInputTypeOfTMnDocumentMetaDatumFilterInput {
  all?: InputMaybe<TMnDocumentMetaDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnDocumentMetaDatumFilterInput>;
  some?: InputMaybe<TMnDocumentMetaDatumFilterInput>;
}

declare interface ListFilterInputTypeOfTMnFileFilterInput {
  all?: InputMaybe<TMnFileFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnFileFilterInput>;
  some?: InputMaybe<TMnFileFilterInput>;
}

declare interface ListFilterInputTypeOfTMnLinkDocumentsWfFilterInput {
  all?: InputMaybe<TMnLinkDocumentsWfFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnLinkDocumentsWfFilterInput>;
  some?: InputMaybe<TMnLinkDocumentsWfFilterInput>;
}

declare interface ListFilterInputTypeOfTMnMailboxFilterInput {
  all?: InputMaybe<TMnMailboxFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnMailboxFilterInput>;
  some?: InputMaybe<TMnMailboxFilterInput>;
}

declare interface ListFilterInputTypeOfTMnSetClassificationFilterInput {
  all?: InputMaybe<TMnSetClassificationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnSetClassificationFilterInput>;
  some?: InputMaybe<TMnSetClassificationFilterInput>;
}

declare interface ListFilterInputTypeOfTMnSetClassificationMetaDatumFilterInput {
  all?: InputMaybe<TMnSetClassificationMetaDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnSetClassificationMetaDatumFilterInput>;
  some?: InputMaybe<TMnSetClassificationMetaDatumFilterInput>;
}

declare interface ListFilterInputTypeOfTPaSetDocTypeStatFilterInput {
  all?: InputMaybe<TPaSetDocTypeStatFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TPaSetDocTypeStatFilterInput>;
  some?: InputMaybe<TPaSetDocTypeStatFilterInput>;
}

declare interface ListFilterInputTypeOfTeamViewerSessionFilterInput {
  all?: InputMaybe<TeamViewerSessionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TeamViewerSessionFilterInput>;
  some?: InputMaybe<TeamViewerSessionFilterInput>;
}

declare interface ListFilterInputTypeOfTravelKilometersFilterInput {
  all?: InputMaybe<TravelKilometersFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TravelKilometersFilterInput>;
  some?: InputMaybe<TravelKilometersFilterInput>;
}

declare interface ListFilterInputTypeOfTravelWarrantItemFilterInput {
  all?: InputMaybe<TravelWarrantItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TravelWarrantItemFilterInput>;
  some?: InputMaybe<TravelWarrantItemFilterInput>;
}

declare interface ListFilterInputTypeOfTrimTHeMoveRmaworkSpecFilterInput {
  all?: InputMaybe<TrimTHeMoveRmaworkSpecFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TrimTHeMoveRmaworkSpecFilterInput>;
  some?: InputMaybe<TrimTHeMoveRmaworkSpecFilterInput>;
}

declare interface ListFilterInputTypeOfUnreadUserSupportTicketMessageFilterInput {
  all?: InputMaybe<UnreadUserSupportTicketMessageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UnreadUserSupportTicketMessageFilterInput>;
  some?: InputMaybe<UnreadUserSupportTicketMessageFilterInput>;
}

declare interface ListFilterInputTypeOfUserArbitrarySettingFilterInput {
  all?: InputMaybe<UserArbitrarySettingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserArbitrarySettingFilterInput>;
  some?: InputMaybe<UserArbitrarySettingFilterInput>;
}

declare interface ListFilterInputTypeOfWakaTimeCommitFilterInput {
  all?: InputMaybe<WakaTimeCommitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WakaTimeCommitFilterInput>;
  some?: InputMaybe<WakaTimeCommitFilterInput>;
}

declare interface ListFilterInputTypeOfWakaTimeWorklogFilterInput {
  all?: InputMaybe<WakaTimeWorklogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WakaTimeWorklogFilterInput>;
  some?: InputMaybe<WakaTimeWorklogFilterInput>;
}

declare interface ListFilterInputTypeOfWikiEntryCategoryFilterInput {
  all?: InputMaybe<WikiEntryCategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WikiEntryCategoryFilterInput>;
  some?: InputMaybe<WikiEntryCategoryFilterInput>;
}

declare interface ListFilterInputTypeOfWikiEntryFilterInput {
  all?: InputMaybe<WikiEntryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WikiEntryFilterInput>;
  some?: InputMaybe<WikiEntryFilterInput>;
}

declare interface ListFilterInputTypeOfWikiEntryTagFilterInput {
  all?: InputMaybe<WikiEntryTagFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WikiEntryTagFilterInput>;
  some?: InputMaybe<WikiEntryTagFilterInput>;
}

declare interface ListFilterInputTypeOfWorkRecordCostTypeFilterInput {
  all?: InputMaybe<WorkRecordCostTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkRecordCostTypeFilterInput>;
  some?: InputMaybe<WorkRecordCostTypeFilterInput>;
}

declare interface ListFilterInputTypeOfWorkRecordFilterInput {
  all?: InputMaybe<WorkRecordFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkRecordFilterInput>;
  some?: InputMaybe<WorkRecordFilterInput>;
}

declare interface ListFilterInputTypeOfWorkRecordPeriodFilterInput {
  all?: InputMaybe<WorkRecordPeriodFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkRecordPeriodFilterInput>;
  some?: InputMaybe<WorkRecordPeriodFilterInput>;
}

declare interface ListFilterInputTypeOfWorkRecordWorkHoursFilterInput {
  all?: InputMaybe<WorkRecordWorkHoursFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkRecordWorkHoursFilterInput>;
  some?: InputMaybe<WorkRecordWorkHoursFilterInput>;
}

declare interface ListStringOperationFilterInput {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
}

declare interface LocationStructureInput {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
}

declare interface LoginModelInput {
  password: Scalars['String'];
  takeLicense?: InputMaybe<Scalars['Boolean']>;
  userNameOrEmail: Scalars['String'];
}

declare interface MarservisItemGroupMaterial {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  itemGroup?: Maybe<ItemGroup>;
  itemGroupId: Scalars['Int'];
  material?: Maybe<MarservisMaterial>;
  materialId: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
}

declare interface MarservisItemGroupMaterialFilterInput {
  and?: InputMaybe<Array<MarservisItemGroupMaterialFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemGroup?: InputMaybe<ItemGroupFilterInput>;
  itemGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  material?: InputMaybe<MarservisMaterialFilterInput>;
  materialId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<MarservisItemGroupMaterialFilterInput>>;
}

declare interface MarservisLocalWorkOrderReturnDto {
  date: Scalars['DateTime'];
  dateEnd: Scalars['DateTime'];
  documentNumber: Scalars['Int'];
  hasFiles: Scalars['Boolean'];
  hasMaterials: Scalars['Boolean'];
  hasUserFiles: Scalars['Boolean'];
  hasUserNotes: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  project?: Maybe<MarservisLocalWorkOrderReturnProjectDto>;
  projectId: Scalars['Int'];
  status: MarservisWorkOrderStatusEnum;
  subject?: Maybe<MarservisLocalWorkOrderReturnSubjectDto>;
  subjectId?: Maybe<Scalars['Int']>;
}

declare interface MarservisLocalWorkOrderReturnDtoFilterInput {
  and?: InputMaybe<Array<MarservisLocalWorkOrderReturnDtoFilterInput>>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  dateEnd?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  documentNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  hasFiles?: InputMaybe<BooleanOperationFilterInput>;
  hasMaterials?: InputMaybe<BooleanOperationFilterInput>;
  hasUserFiles?: InputMaybe<BooleanOperationFilterInput>;
  hasUserNotes?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisLocalWorkOrderReturnDtoFilterInput>>;
  project?: InputMaybe<MarservisLocalWorkOrderReturnProjectDtoFilterInput>;
  projectId?: InputMaybe<ComparableInt32OperationFilterInput>;
  status?: InputMaybe<MarservisWorkOrderStatusEnumOperationFilterInput>;
  subject?: InputMaybe<MarservisLocalWorkOrderReturnSubjectDtoFilterInput>;
  subjectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
}

declare interface MarservisLocalWorkOrderReturnDtoSortInput {
  date?: InputMaybe<SortEnumType>;
  dateEnd?: InputMaybe<SortEnumType>;
  documentNumber?: InputMaybe<SortEnumType>;
  hasFiles?: InputMaybe<SortEnumType>;
  hasMaterials?: InputMaybe<SortEnumType>;
  hasUserFiles?: InputMaybe<SortEnumType>;
  hasUserNotes?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  project?: InputMaybe<MarservisLocalWorkOrderReturnProjectDtoSortInput>;
  projectId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  subject?: InputMaybe<MarservisLocalWorkOrderReturnSubjectDtoSortInput>;
  subjectId?: InputMaybe<SortEnumType>;
}

declare interface MarservisLocalWorkOrderReturnProjectDto {
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  subject?: Maybe<MarservisLocalWorkOrderReturnProjectDtoSubjectDto>;
}

declare interface MarservisLocalWorkOrderReturnProjectDtoFilterInput {
  and?: InputMaybe<Array<MarservisLocalWorkOrderReturnProjectDtoFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisLocalWorkOrderReturnProjectDtoFilterInput>>;
  subject?: InputMaybe<MarservisLocalWorkOrderReturnProjectDtoSubjectDtoFilterInput>;
}

declare interface MarservisLocalWorkOrderReturnProjectDtoSortInput {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  subject?: InputMaybe<MarservisLocalWorkOrderReturnProjectDtoSubjectDtoSortInput>;
}

declare interface MarservisLocalWorkOrderReturnProjectDtoSubjectDto {
  shortName?: Maybe<Scalars['String']>;
}

declare interface MarservisLocalWorkOrderReturnProjectDtoSubjectDtoFilterInput {
  and?: InputMaybe<Array<MarservisLocalWorkOrderReturnProjectDtoSubjectDtoFilterInput>>;
  or?: InputMaybe<Array<MarservisLocalWorkOrderReturnProjectDtoSubjectDtoFilterInput>>;
  shortName?: InputMaybe<StringOperationFilterInput>;
}

declare interface MarservisLocalWorkOrderReturnProjectDtoSubjectDtoSortInput {
  shortName?: InputMaybe<SortEnumType>;
}

declare interface MarservisLocalWorkOrderReturnSubjectDto {
  id: Scalars['Int'];
  longName?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
}

declare interface MarservisLocalWorkOrderReturnSubjectDtoFilterInput {
  and?: InputMaybe<Array<MarservisLocalWorkOrderReturnSubjectDtoFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  longName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisLocalWorkOrderReturnSubjectDtoFilterInput>>;
  shortName?: InputMaybe<StringOperationFilterInput>;
}

declare interface MarservisLocalWorkOrderReturnSubjectDtoSortInput {
  id?: InputMaybe<SortEnumType>;
  longName?: InputMaybe<SortEnumType>;
  shortName?: InputMaybe<SortEnumType>;
}

declare interface MarservisMaterial {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  itemGroupMaterials?: Maybe<Array<Maybe<MarservisItemGroupMaterial>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['String']>;
  normalizedUnitOfMeasure?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  workUsages?: Maybe<Array<Maybe<MarservisWorkOrderItemWorkMaterial>>>;
}

declare interface MarservisMaterialFilterInput {
  and?: InputMaybe<Array<MarservisMaterialFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemGroupMaterials?: InputMaybe<ListFilterInputTypeOfMarservisItemGroupMaterialFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  normalizedUnitOfMeasure?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisMaterialFilterInput>>;
  unitOfMeasure?: InputMaybe<StringOperationFilterInput>;
  workUsages?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialFilterInput>;
}

declare interface MarservisMaterialReturnDto {
  id: Scalars['Int'];
  name: Scalars['String'];
  unitOfMeasure: Scalars['String'];
}

declare interface MarservisSavedFile {
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  workOrderId?: Maybe<Scalars['String']>;
}

declare interface MarservisSavedFileFilterInput {
  and?: InputMaybe<Array<MarservisSavedFileFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisSavedFileFilterInput>>;
  workOrderId?: InputMaybe<StringOperationFilterInput>;
}

declare interface MarservisSavedFileSortInput {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  workOrderId?: InputMaybe<SortEnumType>;
}

declare interface MarservisUserMobileWorkOrderItemDto {
  deadlineDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  itemCode?: Maybe<Scalars['String']>;
  itemGroupId?: Maybe<Scalars['Int']>;
  itemGroupName?: Maybe<Scalars['String']>;
  itemId?: Maybe<Scalars['Int']>;
  itemName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['Int']>;
  projectName?: Maybe<Scalars['String']>;
  status: MarservisWorkOrderItemStatusEnum;
  subjectId?: Maybe<Scalars['Int']>;
  subjectLongName?: Maybe<Scalars['String']>;
  subjectShortName?: Maybe<Scalars['String']>;
  unfinishedItems?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
  workOrderDateEnd?: Maybe<Scalars['DateTime']>;
  workOrderId?: Maybe<Scalars['String']>;
  workOrderLocation?: Maybe<Scalars['String']>;
  workOrderStatus?: Maybe<MarservisWorkOrderStatusEnum>;
}

declare interface MarservisUserMobileWorkOrderItemDtoFilterInput {
  and?: InputMaybe<Array<MarservisUserMobileWorkOrderItemDtoFilterInput>>;
  deadlineDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemCode?: InputMaybe<StringOperationFilterInput>;
  itemGroupId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  itemGroupName?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisUserMobileWorkOrderItemDtoFilterInput>>;
  projectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  projectName?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<MarservisWorkOrderItemStatusEnumOperationFilterInput>;
  subjectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  subjectLongName?: InputMaybe<StringOperationFilterInput>;
  subjectShortName?: InputMaybe<StringOperationFilterInput>;
  unfinishedItems?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  workOrderDateEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  workOrderId?: InputMaybe<StringOperationFilterInput>;
  workOrderLocation?: InputMaybe<StringOperationFilterInput>;
  workOrderStatus?: InputMaybe<NullableOfMarservisWorkOrderStatusEnumOperationFilterInput>;
}

declare interface MarservisUserMobileWorkOrderItemDtoSortInput {
  deadlineDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemCode?: InputMaybe<SortEnumType>;
  itemGroupId?: InputMaybe<SortEnumType>;
  itemGroupName?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  projectId?: InputMaybe<SortEnumType>;
  projectName?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  subjectId?: InputMaybe<SortEnumType>;
  subjectLongName?: InputMaybe<SortEnumType>;
  subjectShortName?: InputMaybe<SortEnumType>;
  unfinishedItems?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  workOrderDateEnd?: InputMaybe<SortEnumType>;
  workOrderId?: InputMaybe<SortEnumType>;
  workOrderLocation?: InputMaybe<SortEnumType>;
  workOrderStatus?: InputMaybe<SortEnumType>;
}

/** A connection to a list of items. */
declare interface MarservisUserWorkOrderAllItemsConnection {
  /** A list of edges. */
  edges?: Maybe<Array<MarservisUserWorkOrderAllItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<MarservisUserMobileWorkOrderItemDto>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface MarservisUserWorkOrderAllItemsEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MarservisUserMobileWorkOrderItemDto>;
}

/** A connection to a list of items. */
declare interface MarservisUserWorkOrderItemsConnection {
  /** A list of edges. */
  edges?: Maybe<Array<MarservisUserWorkOrderItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<MarservisUserMobileWorkOrderItemDto>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface MarservisUserWorkOrderItemsEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MarservisUserMobileWorkOrderItemDto>;
}

/** A connection to a list of items. */
declare interface MarservisUserWorkOrdersConnection {
  /** A list of edges. */
  edges?: Maybe<Array<MarservisUserWorkOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<MarservisLocalWorkOrderReturnDto>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface MarservisUserWorkOrdersEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MarservisLocalWorkOrderReturnDto>;
}

declare interface MarservisWorkOrder {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  dateEnd: Scalars['DateTime'];
  documentNumber: Scalars['Int'];
  files?: Maybe<Array<Maybe<SavedFile>>>;
  id?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<MarservisWorkOrderItem>>>;
  location?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
  projectId: Scalars['Int'];
  status: MarservisWorkOrderStatusEnum;
}

declare interface MarservisWorkOrderFilterInput {
  and?: InputMaybe<Array<MarservisWorkOrderFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  dateEnd?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  documentNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  files?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderFilterInput>>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<ComparableInt32OperationFilterInput>;
  status?: InputMaybe<MarservisWorkOrderStatusEnumOperationFilterInput>;
}

declare interface MarservisWorkOrderItem {
  billableTime: Scalars['TimeSpan'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deadlineDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  item?: Maybe<Item>;
  itemGroup?: Maybe<ItemGroup>;
  itemGroupId?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<MarservisWorkOrderItemItem>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  status: MarservisWorkOrderItemStatusEnum;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
  workOrder?: Maybe<MarservisWorkOrder>;
  workOrderId?: Maybe<Scalars['String']>;
  works?: Maybe<Array<Maybe<MarservisWorkOrderItemWork>>>;
}

declare interface MarservisWorkOrderItemFilterInput {
  and?: InputMaybe<Array<MarservisWorkOrderItemFilterInput>>;
  billableTime?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deadlineDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  item?: InputMaybe<ItemFilterInput>;
  itemGroup?: InputMaybe<ItemGroupFilterInput>;
  itemGroupId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  itemId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemItemFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderItemFilterInput>>;
  status?: InputMaybe<MarservisWorkOrderItemStatusEnumOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  workOrder?: InputMaybe<MarservisWorkOrderFilterInput>;
  workOrderId?: InputMaybe<StringOperationFilterInput>;
  works?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemWorkFilterInput>;
}

declare interface MarservisWorkOrderItemItem {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  finished: Scalars['Boolean'];
  id: Scalars['Int'];
  item?: Maybe<Item>;
  itemId: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  workOrderItem?: Maybe<MarservisWorkOrderItem>;
  workOrderItemId: Scalars['Int'];
}

declare interface MarservisWorkOrderItemItemFilterInput {
  and?: InputMaybe<Array<MarservisWorkOrderItemItemFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  finished?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  item?: InputMaybe<ItemFilterInput>;
  itemId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderItemItemFilterInput>>;
  workOrderItem?: InputMaybe<MarservisWorkOrderItemFilterInput>;
  workOrderItemId?: InputMaybe<ComparableInt32OperationFilterInput>;
}

declare interface MarservisWorkOrderItemItemSortInput {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  finished?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  item?: InputMaybe<ItemSortInput>;
  itemId?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  workOrderItem?: InputMaybe<MarservisWorkOrderItemSortInput>;
  workOrderItemId?: InputMaybe<SortEnumType>;
}

declare interface MarservisWorkOrderItemSortInput {
  billableTime?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  deadlineDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  item?: InputMaybe<ItemSortInput>;
  itemGroup?: InputMaybe<ItemGroupSortInput>;
  itemGroupId?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
  workOrder?: InputMaybe<MarservisWorkOrderSortInput>;
  workOrderId?: InputMaybe<SortEnumType>;
}

declare type MarservisWorkOrderItemStatusEnum =
  | 'DONE'
  | 'IN_PROGRESS'
  | 'NOT_DONE';

declare interface MarservisWorkOrderItemStatusEnumOperationFilterInput {
  eq?: InputMaybe<MarservisWorkOrderItemStatusEnum>;
  in?: InputMaybe<Array<MarservisWorkOrderItemStatusEnum>>;
  neq?: InputMaybe<MarservisWorkOrderItemStatusEnum>;
  nin?: InputMaybe<Array<MarservisWorkOrderItemStatusEnum>>;
}

declare interface MarservisWorkOrderItemWork {
  cause?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  files?: Maybe<Array<Maybe<SavedFile>>>;
  id: Scalars['Int'];
  materialUsageDetails?: Maybe<Array<Maybe<MarservisWorkOrderItemWorkMaterialReturnDto>>>;
  materialUsages?: Maybe<Array<Maybe<MarservisWorkOrderItemWorkMaterial>>>;
  materials?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  remedy?: Maybe<Scalars['String']>;
  time: Scalars['TimeSpan'];
  workOrderItem?: Maybe<MarservisWorkOrderItem>;
  workOrderItemId: Scalars['Int'];
}

declare interface MarservisWorkOrderItemWorkDtoInput {
  cause?: InputMaybe<Scalars['String']>;
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['Int']>;
  materialUsages?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialInputDtoInput>>;
  materials?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  remedy?: InputMaybe<Scalars['String']>;
  time: Scalars['TimeSpan'];
  uniqueClientId?: InputMaybe<Scalars['String']>;
  workOrderItemId: Scalars['Int'];
}

declare interface MarservisWorkOrderItemWorkFilterInput {
  and?: InputMaybe<Array<MarservisWorkOrderItemWorkFilterInput>>;
  cause?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  files?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  materialUsageDetails?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialReturnDtoFilterInput>;
  materialUsages?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialFilterInput>;
  materials?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderItemWorkFilterInput>>;
  remedy?: InputMaybe<StringOperationFilterInput>;
  time?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  workOrderItem?: InputMaybe<MarservisWorkOrderItemFilterInput>;
  workOrderItemId?: InputMaybe<ComparableInt32OperationFilterInput>;
}

declare interface MarservisWorkOrderItemWorkMaterial {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  material?: Maybe<MarservisMaterial>;
  materialId: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  quantity: Scalars['Decimal'];
  workOrderItemWork?: Maybe<MarservisWorkOrderItemWork>;
  workOrderItemWorkId: Scalars['Int'];
}

declare interface MarservisWorkOrderItemWorkMaterialFilterInput {
  and?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  material?: InputMaybe<MarservisMaterialFilterInput>;
  materialId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialFilterInput>>;
  quantity?: InputMaybe<ComparableDecimalOperationFilterInput>;
  workOrderItemWork?: InputMaybe<MarservisWorkOrderItemWorkFilterInput>;
  workOrderItemWorkId?: InputMaybe<ComparableInt32OperationFilterInput>;
}

declare interface MarservisWorkOrderItemWorkMaterialInputDto {
  materialId: Scalars['Int'];
  quantity: Scalars['Decimal'];
}

declare interface MarservisWorkOrderItemWorkMaterialInputDtoFilterInput {
  and?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialInputDtoFilterInput>>;
  materialId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialInputDtoFilterInput>>;
  quantity?: InputMaybe<ComparableDecimalOperationFilterInput>;
}

declare interface MarservisWorkOrderItemWorkMaterialInputDtoInput {
  materialId: Scalars['Int'];
  quantity: Scalars['Decimal'];
}

declare interface MarservisWorkOrderItemWorkMaterialReturnDto {
  id: Scalars['Int'];
  materialId: Scalars['Int'];
  materialName?: Maybe<Scalars['String']>;
  quantity: Scalars['Decimal'];
  unitOfMeasure?: Maybe<Scalars['String']>;
}

declare interface MarservisWorkOrderItemWorkMaterialReturnDtoFilterInput {
  and?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialReturnDtoFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  materialId?: InputMaybe<ComparableInt32OperationFilterInput>;
  materialName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialReturnDtoFilterInput>>;
  quantity?: InputMaybe<ComparableDecimalOperationFilterInput>;
  unitOfMeasure?: InputMaybe<StringOperationFilterInput>;
}

declare interface MarservisWorkOrderItemWorkMaterialReturnDtoInput {
  id: Scalars['Int'];
  materialId: Scalars['Int'];
  materialName?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Decimal'];
  unitOfMeasure?: InputMaybe<Scalars['String']>;
}

declare interface MarservisWorkOrderItemWorkSortInput {
  cause?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  materials?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  remedy?: InputMaybe<SortEnumType>;
  time?: InputMaybe<SortEnumType>;
  workOrderItem?: InputMaybe<MarservisWorkOrderItemSortInput>;
  workOrderItemId?: InputMaybe<SortEnumType>;
}

declare interface MarservisWorkOrderItemWorkWithoutFilesReturnDto {
  cause?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  materialUsageDetails?: Maybe<Array<Maybe<MarservisWorkOrderItemWorkMaterialReturnDto>>>;
  materialUsages?: Maybe<Array<MarservisWorkOrderItemWorkMaterialInputDto>>;
  materials?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  remedy?: Maybe<Scalars['String']>;
  time: Scalars['TimeSpan'];
  workOrderItemId: Scalars['Int'];
}

declare interface MarservisWorkOrderItemWorkWithoutFilesReturnDtoFilterInput {
  and?: InputMaybe<Array<MarservisWorkOrderItemWorkWithoutFilesReturnDtoFilterInput>>;
  cause?: InputMaybe<StringOperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  materialUsageDetails?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialReturnDtoFilterInput>;
  materialUsages?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialInputDtoFilterInput>;
  materials?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderItemWorkWithoutFilesReturnDtoFilterInput>>;
  remedy?: InputMaybe<StringOperationFilterInput>;
  time?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  workOrderItemId?: InputMaybe<ComparableInt32OperationFilterInput>;
}

declare interface MarservisWorkOrderItemWorkWithoutFilesReturnDtoInput {
  cause?: InputMaybe<Scalars['String']>;
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  materialUsageDetails?: InputMaybe<Array<InputMaybe<MarservisWorkOrderItemWorkMaterialReturnDtoInput>>>;
  materialUsages?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialInputDtoInput>>;
  materials?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  remedy?: InputMaybe<Scalars['String']>;
  time: Scalars['TimeSpan'];
  workOrderItemId: Scalars['Int'];
}

declare interface MarservisWorkOrderItemWorkWithoutFilesReturnDtoSortInput {
  cause?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  materials?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  remedy?: InputMaybe<SortEnumType>;
  time?: InputMaybe<SortEnumType>;
  workOrderItemId?: InputMaybe<SortEnumType>;
}

declare interface MarservisWorkOrderSortInput {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  dateEnd?: InputMaybe<SortEnumType>;
  documentNumber?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  project?: InputMaybe<ProjectSortInput>;
  projectId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
}

declare type MarservisWorkOrderStatusEnum =
  | 'DONE'
  | 'INVOICED'
  | 'IN_PROGRESS'
  | 'NOT_DONE';

declare interface MarservisWorkOrderStatusEnumOperationFilterInput {
  eq?: InputMaybe<MarservisWorkOrderStatusEnum>;
  in?: InputMaybe<Array<MarservisWorkOrderStatusEnum>>;
  neq?: InputMaybe<MarservisWorkOrderStatusEnum>;
  nin?: InputMaybe<Array<MarservisWorkOrderStatusEnum>>;
}

declare interface McpApiKeyDto {
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  keyPrefix?: Maybe<Scalars['String']>;
  kind: McpApiKeyKind;
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  revokedAt?: Maybe<Scalars['DateTime']>;
}

declare interface McpApiKeyEntitlementsDto {
  canCreateOnixServerKey: Scalars['Boolean'];
  canCreateSupportKey: Scalars['Boolean'];
  onixServerPermissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  supportPermissions?: Maybe<Array<Maybe<Scalars['String']>>>;
}

declare type McpApiKeyKind =
  | 'ONIX_SERVER'
  | 'SUPPORT';

declare interface MobileSettings {
  a4PrinterURL?: Maybe<Scalars['String']>;
  bluetoothPrinterAddress?: Maybe<Scalars['String']>;
  bluetoothPrinterArbitrarySettings?: Maybe<Array<KeyValuePairOfStringAndString>>;
  bluetoothPrinterBoldMode?: Maybe<Scalars['Boolean']>;
  bluetoothPrinterName?: Maybe<Scalars['String']>;
  bluetoothPrinterPaperWidth?: Maybe<Scalars['Int']>;
  bluetoothPrinterPrintSpeed?: Maybe<Scalars['Int']>;
  bluetoothPrinterType?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  detailedLogging?: Maybe<Scalars['Boolean']>;
  featureFlag?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  mobileMenuV3?: Maybe<Scalars['Boolean']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  thermalPrinterPrintVerticalPDF417?: Maybe<Scalars['Boolean']>;
  useDarkTheme: Scalars['Boolean'];
  useDocumentTypeCodesInTitles?: Maybe<Scalars['Boolean']>;
  useFilteredOfflineCodebooks?: Maybe<Scalars['Boolean']>;
  useKeyboardBarcodeScanner?: Maybe<Scalars['Boolean']>;
  useListViewOnPickers: Scalars['Boolean'];
  useOnlyShortcuts: Scalars['Boolean'];
  useTabletMode?: Maybe<Scalars['Boolean']>;
  useWiderColumns?: Maybe<Scalars['Boolean']>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
  userMobileMenuV4?: Maybe<Scalars['Boolean']>;
}

declare interface MobileSettingsFilterInput {
  a4PrinterURL?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<MobileSettingsFilterInput>>;
  bluetoothPrinterAddress?: InputMaybe<StringOperationFilterInput>;
  bluetoothPrinterArbitrarySettings?: InputMaybe<DictionaryOfStringAndStringFilterInput>;
  bluetoothPrinterBoldMode?: InputMaybe<BooleanOperationFilterInput>;
  bluetoothPrinterName?: InputMaybe<StringOperationFilterInput>;
  bluetoothPrinterPaperWidth?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  bluetoothPrinterPrintSpeed?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  bluetoothPrinterType?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  detailedLogging?: InputMaybe<BooleanOperationFilterInput>;
  featureFlag?: InputMaybe<BooleanOperationFilterInput>;
  language?: InputMaybe<StringOperationFilterInput>;
  mobileMenuV3?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<MobileSettingsFilterInput>>;
  thermalPrinterPrintVerticalPDF417?: InputMaybe<BooleanOperationFilterInput>;
  useDarkTheme?: InputMaybe<BooleanOperationFilterInput>;
  useDocumentTypeCodesInTitles?: InputMaybe<BooleanOperationFilterInput>;
  useFilteredOfflineCodebooks?: InputMaybe<BooleanOperationFilterInput>;
  useKeyboardBarcodeScanner?: InputMaybe<BooleanOperationFilterInput>;
  useListViewOnPickers?: InputMaybe<BooleanOperationFilterInput>;
  useOnlyShortcuts?: InputMaybe<BooleanOperationFilterInput>;
  useTabletMode?: InputMaybe<BooleanOperationFilterInput>;
  useWiderColumns?: InputMaybe<BooleanOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  userMobileMenuV4?: InputMaybe<BooleanOperationFilterInput>;
}

declare interface MobileSettingsSortInput {
  a4PrinterURL?: InputMaybe<SortEnumType>;
  bluetoothPrinterAddress?: InputMaybe<SortEnumType>;
  bluetoothPrinterBoldMode?: InputMaybe<SortEnumType>;
  bluetoothPrinterName?: InputMaybe<SortEnumType>;
  bluetoothPrinterPaperWidth?: InputMaybe<SortEnumType>;
  bluetoothPrinterPrintSpeed?: InputMaybe<SortEnumType>;
  bluetoothPrinterType?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  detailedLogging?: InputMaybe<SortEnumType>;
  featureFlag?: InputMaybe<SortEnumType>;
  language?: InputMaybe<SortEnumType>;
  mobileMenuV3?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  thermalPrinterPrintVerticalPDF417?: InputMaybe<SortEnumType>;
  useDarkTheme?: InputMaybe<SortEnumType>;
  useDocumentTypeCodesInTitles?: InputMaybe<SortEnumType>;
  useFilteredOfflineCodebooks?: InputMaybe<SortEnumType>;
  useKeyboardBarcodeScanner?: InputMaybe<SortEnumType>;
  useListViewOnPickers?: InputMaybe<SortEnumType>;
  useOnlyShortcuts?: InputMaybe<SortEnumType>;
  useTabletMode?: InputMaybe<SortEnumType>;
  useWiderColumns?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
  userMobileMenuV4?: InputMaybe<SortEnumType>;
}

declare interface MobileSettingsUpdateDtoInput {
  a4PrinterURL?: InputMaybe<Scalars['String']>;
  bluetoothPrinterAddress?: InputMaybe<Scalars['String']>;
  bluetoothPrinterArbitrarySettings?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>;
  bluetoothPrinterBoldMode?: InputMaybe<Scalars['Boolean']>;
  bluetoothPrinterName?: InputMaybe<Scalars['String']>;
  bluetoothPrinterPaperWidth?: InputMaybe<Scalars['Int']>;
  bluetoothPrinterPrintSpeed?: InputMaybe<Scalars['Int']>;
  bluetoothPrinterType?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  thermalPrinterPrintVerticalPDF417?: InputMaybe<Scalars['Boolean']>;
  useDarkTheme: Scalars['Boolean'];
  useDocumentTypeCodesInTitles?: InputMaybe<Scalars['Boolean']>;
  useListViewOnPickers: Scalars['Boolean'];
  useOnlyShortcuts: Scalars['Boolean'];
  useTabletMode?: InputMaybe<Scalars['Boolean']>;
  useWiderColumns?: InputMaybe<Scalars['Boolean']>;
}

declare interface NewVersionDto {
  platform?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
}

declare interface NewVersionDtoInput {
  platform?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
}

declare interface NotificationDeliveryReport {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  fCMToken?: Maybe<FcmToken>;
  fCMTokenId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  notificationType?: Maybe<Scalars['String']>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
}

declare interface NotificationDeliveryReportFilterInput {
  and?: InputMaybe<Array<NotificationDeliveryReportFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  fCMToken?: InputMaybe<FcmTokenFilterInput>;
  fCMTokenId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  notificationType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NotificationDeliveryReportFilterInput>>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
}

declare type NotificationType =
  | 'AGENT_FINISHED_TASK_ON_TICKET'
  | 'AI_INVESTIGATION_UPDATE'
  | 'CHAT_GPT_TICKET_RECOMMENDATION'
  | 'CONTACT_RESPONDED'
  | 'NEW_SUPPORT_TICKET'
  | 'NEW_TASK'
  | 'USER_MENTIONED_YOU';

declare interface NotificationTypeOperationFilterInput {
  eq?: InputMaybe<NotificationType>;
  in?: InputMaybe<Array<NotificationType>>;
  neq?: InputMaybe<NotificationType>;
  nin?: InputMaybe<Array<NotificationType>>;
}

declare interface NullableOfArbitraryFieldEntryTypeOperationFilterInput {
  eq?: InputMaybe<ArbitraryFieldEntryType>;
  in?: InputMaybe<Array<InputMaybe<ArbitraryFieldEntryType>>>;
  neq?: InputMaybe<ArbitraryFieldEntryType>;
  nin?: InputMaybe<Array<InputMaybe<ArbitraryFieldEntryType>>>;
}

declare interface NullableOfArbitraryFieldLocationEnumOperationFilterInput {
  eq?: InputMaybe<ArbitraryFieldLocationEnum>;
  in?: InputMaybe<Array<InputMaybe<ArbitraryFieldLocationEnum>>>;
  neq?: InputMaybe<ArbitraryFieldLocationEnum>;
  nin?: InputMaybe<Array<InputMaybe<ArbitraryFieldLocationEnum>>>;
}

declare interface NullableOfAresDeploymentExecutionPhaseOperationFilterInput {
  eq?: InputMaybe<AresDeploymentExecutionPhase>;
  in?: InputMaybe<Array<InputMaybe<AresDeploymentExecutionPhase>>>;
  neq?: InputMaybe<AresDeploymentExecutionPhase>;
  nin?: InputMaybe<Array<InputMaybe<AresDeploymentExecutionPhase>>>;
}

declare interface NullableOfCardPaymentProviderOperationFilterInput {
  eq?: InputMaybe<CardPaymentProvider>;
  in?: InputMaybe<Array<InputMaybe<CardPaymentProvider>>>;
  neq?: InputMaybe<CardPaymentProvider>;
  nin?: InputMaybe<Array<InputMaybe<CardPaymentProvider>>>;
}

declare interface NullableOfClientEnumOperationFilterInput {
  eq?: InputMaybe<ClientEnum>;
  in?: InputMaybe<Array<InputMaybe<ClientEnum>>>;
  neq?: InputMaybe<ClientEnum>;
  nin?: InputMaybe<Array<InputMaybe<ClientEnum>>>;
}

declare interface NullableOfDateFilterTypeOperationFilterInput {
  eq?: InputMaybe<DateFilterType>;
  in?: InputMaybe<Array<InputMaybe<DateFilterType>>>;
  neq?: InputMaybe<DateFilterType>;
  nin?: InputMaybe<Array<InputMaybe<DateFilterType>>>;
}

declare interface NullableOfDeploymentGroupStepTriggerTypeOperationFilterInput {
  eq?: InputMaybe<DeploymentGroupStepTriggerType>;
  in?: InputMaybe<Array<InputMaybe<DeploymentGroupStepTriggerType>>>;
  neq?: InputMaybe<DeploymentGroupStepTriggerType>;
  nin?: InputMaybe<Array<InputMaybe<DeploymentGroupStepTriggerType>>>;
}

declare interface NullableOfInvoiceSumTypeOperationFilterInput {
  eq?: InputMaybe<InvoiceSumType>;
  in?: InputMaybe<Array<InputMaybe<InvoiceSumType>>>;
  neq?: InputMaybe<InvoiceSumType>;
  nin?: InputMaybe<Array<InputMaybe<InvoiceSumType>>>;
}

declare interface NullableOfMarservisWorkOrderStatusEnumOperationFilterInput {
  eq?: InputMaybe<MarservisWorkOrderStatusEnum>;
  in?: InputMaybe<Array<InputMaybe<MarservisWorkOrderStatusEnum>>>;
  neq?: InputMaybe<MarservisWorkOrderStatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<MarservisWorkOrderStatusEnum>>>;
}

declare interface NullableOfOnixTenantOperationFilterInput {
  eq?: InputMaybe<OnixTenant>;
  in?: InputMaybe<Array<InputMaybe<OnixTenant>>>;
  neq?: InputMaybe<OnixTenant>;
  nin?: InputMaybe<Array<InputMaybe<OnixTenant>>>;
}

declare interface NullableOfSupportAiThreadItemPhaseOperationFilterInput {
  eq?: InputMaybe<SupportAiThreadItemPhase>;
  in?: InputMaybe<Array<InputMaybe<SupportAiThreadItemPhase>>>;
  neq?: InputMaybe<SupportAiThreadItemPhase>;
  nin?: InputMaybe<Array<InputMaybe<SupportAiThreadItemPhase>>>;
}

declare interface NullableOfSupportAiThreadItemRoleOperationFilterInput {
  eq?: InputMaybe<SupportAiThreadItemRole>;
  in?: InputMaybe<Array<InputMaybe<SupportAiThreadItemRole>>>;
  neq?: InputMaybe<SupportAiThreadItemRole>;
  nin?: InputMaybe<Array<InputMaybe<SupportAiThreadItemRole>>>;
}

declare interface NullableOfTHeMovePagedSortFieldOperationFilterInput {
  eq?: InputMaybe<THeMovePagedSortField>;
  in?: InputMaybe<Array<InputMaybe<THeMovePagedSortField>>>;
  neq?: InputMaybe<THeMovePagedSortField>;
  nin?: InputMaybe<Array<InputMaybe<THeMovePagedSortField>>>;
}

declare interface NullableOfTHeOrderPagedSortFieldOperationFilterInput {
  eq?: InputMaybe<THeOrderPagedSortField>;
  in?: InputMaybe<Array<InputMaybe<THeOrderPagedSortField>>>;
  neq?: InputMaybe<THeOrderPagedSortField>;
  nin?: InputMaybe<Array<InputMaybe<THeOrderPagedSortField>>>;
}

declare interface NullableOfTHfWoexPagedSortFieldOperationFilterInput {
  eq?: InputMaybe<THfWoexPagedSortField>;
  in?: InputMaybe<Array<InputMaybe<THfWoexPagedSortField>>>;
  neq?: InputMaybe<THfWoexPagedSortField>;
  nin?: InputMaybe<Array<InputMaybe<THfWoexPagedSortField>>>;
}

declare interface OfficialVehicle {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isDeactivated: Scalars['Boolean'];
  makeAndModel?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  pantheonId?: Maybe<Scalars['String']>;
  registration?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
}

declare interface OfficialVehicleFilterInput {
  and?: InputMaybe<Array<OfficialVehicleFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeactivated?: InputMaybe<BooleanOperationFilterInput>;
  makeAndModel?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<OfficialVehicleFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  registration?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
}

declare interface OfficialVehicleSortInput {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeactivated?: InputMaybe<SortEnumType>;
  makeAndModel?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  registration?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
}

declare interface OkWorkOrderAcKeyResult {
  acKey?: Maybe<Scalars['String']>;
}

declare interface OkWorkOrderAnKeyResult {
  acKey?: Maybe<Scalars['String']>;
  anKey: Scalars['Long'];
}

declare interface OkWorkOrderAnNoResult {
  acKey?: Maybe<Scalars['String']>;
  anNo: Scalars['Int'];
}

declare interface OnixPhoneAdditionalReportData {
  jsonSchema?: Maybe<Scalars['String']>;
  reportAddCompanySignature: Scalars['Boolean'];
  reportBccAddress?: Maybe<Scalars['String']>;
  reportTitle?: Maybe<Scalars['String']>;
  reportUserSignatureText?: Maybe<Scalars['String']>;
  reportUserSignsTheDocument: Scalars['Boolean'];
  uISchema?: Maybe<Scalars['String']>;
}

declare interface OnixPhoneAdditionalReportDataFilterInput {
  and?: InputMaybe<Array<OnixPhoneAdditionalReportDataFilterInput>>;
  jsonSchema?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OnixPhoneAdditionalReportDataFilterInput>>;
  reportAddCompanySignature?: InputMaybe<BooleanOperationFilterInput>;
  reportBccAddress?: InputMaybe<StringOperationFilterInput>;
  reportTitle?: InputMaybe<StringOperationFilterInput>;
  reportUserSignatureText?: InputMaybe<StringOperationFilterInput>;
  reportUserSignsTheDocument?: InputMaybe<BooleanOperationFilterInput>;
  uISchema?: InputMaybe<StringOperationFilterInput>;
}

declare interface OnixPhoneAdditionalReportDataSortInput {
  jsonSchema?: InputMaybe<SortEnumType>;
  reportAddCompanySignature?: InputMaybe<SortEnumType>;
  reportBccAddress?: InputMaybe<SortEnumType>;
  reportTitle?: InputMaybe<SortEnumType>;
  reportUserSignatureText?: InputMaybe<SortEnumType>;
  reportUserSignsTheDocument?: InputMaybe<SortEnumType>;
  uISchema?: InputMaybe<SortEnumType>;
}

declare interface OnixPhoneKeyValueStorage {
  context?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeletable?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userDocId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
  value?: Maybe<Array<Scalars['Byte']>>;
  version?: Maybe<Scalars['String']>;
}

declare interface OnixPhoneKeyValueStorageInput {
  context?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDeletable?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userDocId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Array<Scalars['Byte']>>;
  version?: InputMaybe<Scalars['String']>;
}

declare type OnixPhoneUserTaskEnum =
  | 'EXECUTE_SQ_LITE_SQL'
  | 'SHOW_MESSAGE_TO_USER'
  | 'UPDATE_USER_SETTINGS'
  | 'UPLOAD_SQ_LITE_DATABASE';

declare interface OnixPhoneUserTaskEnumOperationFilterInput {
  eq?: InputMaybe<OnixPhoneUserTaskEnum>;
  in?: InputMaybe<Array<OnixPhoneUserTaskEnum>>;
  neq?: InputMaybe<OnixPhoneUserTaskEnum>;
  nin?: InputMaybe<Array<OnixPhoneUserTaskEnum>>;
}

declare interface OnixPhoneUserTaskQueue {
  campaignId?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  failed: Scalars['Boolean'];
  id: Scalars['Int'];
  isCompleted: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  nofityAdminOnCompletion: Scalars['Boolean'];
  response?: Maybe<Scalars['String']>;
  task: OnixPhoneUserTaskEnum;
  taskData?: Maybe<Scalars['String']>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
}

declare interface OnixPhoneUserTaskQueueFilterInput {
  and?: InputMaybe<Array<OnixPhoneUserTaskQueueFilterInput>>;
  campaignId?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  failed?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isCompleted?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  nofityAdminOnCompletion?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OnixPhoneUserTaskQueueFilterInput>>;
  response?: InputMaybe<StringOperationFilterInput>;
  task?: InputMaybe<OnixPhoneUserTaskEnumOperationFilterInput>;
  taskData?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  validFrom?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  validTo?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
}

declare interface OnixPhoneUserTaskQueueSortInput {
  campaignId?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  failed?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isCompleted?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  nofityAdminOnCompletion?: InputMaybe<SortEnumType>;
  response?: InputMaybe<SortEnumType>;
  task?: InputMaybe<SortEnumType>;
  taskData?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
  validFrom?: InputMaybe<SortEnumType>;
  validTo?: InputMaybe<SortEnumType>;
}

declare type OnixTenant =
  | 'CAK'
  | 'CORTINA'
  | 'DANIELI'
  | 'DIMEGLIO'
  | 'EIKONSTUDIO'
  | 'EURONEWPACK'
  | 'KASTAV_GRUPA'
  | 'KOMPAKT'
  | 'LINEA'
  | 'LUCKA_UPRAVA_ROVINJ'
  | 'MARSERVIS'
  | 'MONTRAKER'
  | 'MUSHROOMS'
  | 'NONE'
  | 'ONIX'
  | 'ORCUS'
  | 'OSO'
  | 'PROTECH'
  | 'RITOSA_TRGOVINE'
  | 'SISTEMA'
  | 'SKLAD'
  | 'SKLAD_PROFILI'
  | 'TAPESS'
  | 'TEHNOLINE_OBRT'
  | 'TEHNOLINE_TELEKOM'
  | 'TRIM';

declare interface OriginPantheonItemDetailsInput {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
}

declare interface OxDmsxmlitem {
  acCode?: Maybe<Scalars['String']>;
  acCostBearer?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDescription?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentName?: Maybe<Scalars['String']>;
  acJoinReason?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  anDocumentQid: Scalars['Int'];
  anForPay?: Maybe<Scalars['Decimal']>;
  anId?: Maybe<Scalars['Int']>;
  anPrice?: Maybe<Scalars['Decimal']>;
  anQty?: Maybe<Scalars['Decimal']>;
  anRebate?: Maybe<Scalars['Decimal']>;
  anRebate1?: Maybe<Scalars['Decimal']>;
  anVat?: Maybe<Scalars['Decimal']>;
  anVatamount?: Maybe<Scalars['Decimal']>;
  anVatbase?: Maybe<Scalars['Decimal']>;
}

declare interface OxDmsxmlitemFilterInput {
  acCode?: InputMaybe<StringOperationFilterInput>;
  acCostBearer?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDescription?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentName?: InputMaybe<StringOperationFilterInput>;
  acJoinReason?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  anDocumentQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anForPay?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anRebate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anRebate1?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anVat?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anVatamount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anVatbase?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  and?: InputMaybe<Array<OxDmsxmlitemFilterInput>>;
  or?: InputMaybe<Array<OxDmsxmlitemFilterInput>>;
}

declare interface OxDmsxmlitemSortInput {
  acCode?: InputMaybe<SortEnumType>;
  acCostBearer?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acDescription?: InputMaybe<SortEnumType>;
  acIdent?: InputMaybe<SortEnumType>;
  acIdentName?: InputMaybe<SortEnumType>;
  acJoinReason?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  anDocumentQid?: InputMaybe<SortEnumType>;
  anForPay?: InputMaybe<SortEnumType>;
  anId?: InputMaybe<SortEnumType>;
  anPrice?: InputMaybe<SortEnumType>;
  anQty?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anRebate1?: InputMaybe<SortEnumType>;
  anVat?: InputMaybe<SortEnumType>;
  anVatamount?: InputMaybe<SortEnumType>;
  anVatbase?: InputMaybe<SortEnumType>;
}

declare interface OxIosPerSubject {
  acCurrency?: Maybe<Scalars['String']>;
  acHrfiskalNumber?: Maybe<Scalars['String']>;
  acLinkDoc?: Maybe<Scalars['String']>;
  acName2?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  adDateDue: Scalars['DateTime'];
  adDateInv: Scalars['DateTime'];
  anCredit: Scalars['Decimal'];
  anDebit: Scalars['Decimal'];
  saldo: Scalars['Decimal'];
}

declare interface OxIosPerSubjectFilterInput {
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acHrfiskalNumber?: InputMaybe<StringOperationFilterInput>;
  acLinkDoc?: InputMaybe<StringOperationFilterInput>;
  acName2?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adDateInv?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  anCredit?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDebit?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<OxIosPerSubjectFilterInput>>;
  or?: InputMaybe<Array<OxIosPerSubjectFilterInput>>;
  saldo?: InputMaybe<ComparableDecimalOperationFilterInput>;
}

declare interface OxIosPerSubjectSortInput {
  acCurrency?: InputMaybe<SortEnumType>;
  acHrfiskalNumber?: InputMaybe<SortEnumType>;
  acLinkDoc?: InputMaybe<SortEnumType>;
  acName2?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  adDateDue?: InputMaybe<SortEnumType>;
  adDateInv?: InputMaybe<SortEnumType>;
  anCredit?: InputMaybe<SortEnumType>;
  anDebit?: InputMaybe<SortEnumType>;
  saldo?: InputMaybe<SortEnumType>;
}

declare interface OxMerdownloadReport {
  acReportStatus?: Maybe<Scalars['String']>;
  acReportType?: Maybe<Scalars['String']>;
  brojDokumenta?: Maybe<Scalars['String']>;
  dmsoznaka?: Maybe<Scalars['String']>;
  greska?: Maybe<Scalars['String']>;
  imeFirme?: Maybe<Scalars['String']>;
  oibfirme?: Maybe<Scalars['String']>;
  subjekt?: Maybe<Scalars['String']>;
  tipDokumenta?: Maybe<Scalars['String']>;
  vrijemeSlanja?: Maybe<Scalars['DateTime']>;
}

declare interface OxMerdownloadReportFilterInput {
  acReportStatus?: InputMaybe<StringOperationFilterInput>;
  acReportType?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<OxMerdownloadReportFilterInput>>;
  brojDokumenta?: InputMaybe<StringOperationFilterInput>;
  dmsoznaka?: InputMaybe<StringOperationFilterInput>;
  greska?: InputMaybe<StringOperationFilterInput>;
  imeFirme?: InputMaybe<StringOperationFilterInput>;
  oibfirme?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OxMerdownloadReportFilterInput>>;
  subjekt?: InputMaybe<StringOperationFilterInput>;
  tipDokumenta?: InputMaybe<StringOperationFilterInput>;
  vrijemeSlanja?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
}

declare interface OxMerdownloadReportSortInput {
  acReportStatus?: InputMaybe<SortEnumType>;
  acReportType?: InputMaybe<SortEnumType>;
  brojDokumenta?: InputMaybe<SortEnumType>;
  dmsoznaka?: InputMaybe<SortEnumType>;
  greska?: InputMaybe<SortEnumType>;
  imeFirme?: InputMaybe<SortEnumType>;
  oibfirme?: InputMaybe<SortEnumType>;
  subjekt?: InputMaybe<SortEnumType>;
  tipDokumenta?: InputMaybe<SortEnumType>;
  vrijemeSlanja?: InputMaybe<SortEnumType>;
}

declare interface OxPalletsView {
  acCode?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyView?: Maybe<Scalars['String']>;
  acPrsn3?: Maybe<Scalars['String']>;
  acPrsn3Name?: Maybe<Scalars['String']>;
  acPrsn3Region?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverName?: Maybe<Scalars['String']>;
  acReceiverRegion?: Maybe<Scalars['String']>;
  acSscc?: Maybe<Scalars['String']>;
  acSsccNormalized?: Maybe<Scalars['String']>;
  acUserName?: Maybe<Scalars['String']>;
  adDate: Scalars['DateTime'];
  adDateOnly?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserId: Scalars['Int'];
}

declare interface OxPalletsViewFilterInput {
  acCode?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyView?: InputMaybe<StringOperationFilterInput>;
  acPrsn3?: InputMaybe<StringOperationFilterInput>;
  acPrsn3Name?: InputMaybe<StringOperationFilterInput>;
  acPrsn3Region?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverName?: InputMaybe<StringOperationFilterInput>;
  acReceiverRegion?: InputMaybe<StringOperationFilterInput>;
  acSscc?: InputMaybe<StringOperationFilterInput>;
  acSsccNormalized?: InputMaybe<StringOperationFilterInput>;
  acUserName?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adDateOnly?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<OxPalletsViewFilterInput>>;
  or?: InputMaybe<Array<OxPalletsViewFilterInput>>;
}

declare interface OxPalletsViewSortInput {
  acCode?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyView?: InputMaybe<SortEnumType>;
  acPrsn3?: InputMaybe<SortEnumType>;
  acPrsn3Name?: InputMaybe<SortEnumType>;
  acPrsn3Region?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverName?: InputMaybe<SortEnumType>;
  acReceiverRegion?: InputMaybe<SortEnumType>;
  acSscc?: InputMaybe<SortEnumType>;
  acSsccNormalized?: InputMaybe<SortEnumType>;
  acUserName?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adDateOnly?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserId?: InputMaybe<SortEnumType>;
}

/** A connection to a list of items. */
declare interface OxScansPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<OxScansPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<OxPalletsView>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface OxScansPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<OxPalletsView>;
}

/** Information about pagination in a connection. */
declare interface PageInfo {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
}

declare type PantheonDocumentDirectionEnum =
  | 'IN'
  | 'OUT';

declare interface PantheonDocumentDirectionEnumOperationFilterInput {
  eq?: InputMaybe<PantheonDocumentDirectionEnum>;
  in?: InputMaybe<Array<PantheonDocumentDirectionEnum>>;
  neq?: InputMaybe<PantheonDocumentDirectionEnum>;
  nin?: InputMaybe<Array<PantheonDocumentDirectionEnum>>;
}

declare type PantheonDocumentTable =
  | 'T_HE_MOVE'
  | 'T_HE_ORDER';

declare interface PantheonDocumentTableOperationFilterInput {
  eq?: InputMaybe<PantheonDocumentTable>;
  in?: InputMaybe<Array<PantheonDocumentTable>>;
  neq?: InputMaybe<PantheonDocumentTable>;
  nin?: InputMaybe<Array<PantheonDocumentTable>>;
}

declare interface PantheonUser {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  encodedUserId?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  pantheonAcDelivery?: Maybe<Scalars['String']>;
  pantheonAcName?: Maybe<Scalars['String']>;
  pantheonAcRegNo?: Maybe<Scalars['String']>;
  pantheonAcUserId?: Maybe<Scalars['String']>;
  pantheonAcWorker?: Maybe<Scalars['String']>;
  pantheonAnUserId: Scalars['Int'];
  pantheonPIN?: Maybe<Scalars['String']>;
  pantheonPrsnStatus: Scalars['Boolean'];
  pantheonSignature?: Maybe<Array<Scalars['Byte']>>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
}

declare interface PantheonUserFilterInput {
  and?: InputMaybe<Array<PantheonUserFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  encodedUserId?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PantheonUserFilterInput>>;
  pantheonAcDelivery?: InputMaybe<StringOperationFilterInput>;
  pantheonAcName?: InputMaybe<StringOperationFilterInput>;
  pantheonAcRegNo?: InputMaybe<StringOperationFilterInput>;
  pantheonAcUserId?: InputMaybe<StringOperationFilterInput>;
  pantheonAcWorker?: InputMaybe<StringOperationFilterInput>;
  pantheonAnUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  pantheonPIN?: InputMaybe<StringOperationFilterInput>;
  pantheonPrsnStatus?: InputMaybe<BooleanOperationFilterInput>;
  pantheonSignature?: InputMaybe<ListComparableByteOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
}

declare interface PantheonUserSortInput {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  encodedUserId?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  pantheonAcDelivery?: InputMaybe<SortEnumType>;
  pantheonAcName?: InputMaybe<SortEnumType>;
  pantheonAcRegNo?: InputMaybe<SortEnumType>;
  pantheonAcUserId?: InputMaybe<SortEnumType>;
  pantheonAcWorker?: InputMaybe<SortEnumType>;
  pantheonAnUserId?: InputMaybe<SortEnumType>;
  pantheonPIN?: InputMaybe<SortEnumType>;
  pantheonPrsnStatus?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
}

declare interface PantheonVersion {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  downloadPath?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  versionFormatted?: Maybe<Scalars['String']>;
}

declare interface PantheonVersionFilterInput {
  and?: InputMaybe<Array<PantheonVersionFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  downloadPath?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PantheonVersionFilterInput>>;
  version?: InputMaybe<StringOperationFilterInput>;
  versionFormatted?: InputMaybe<StringOperationFilterInput>;
}

declare interface PantheonVersionSortInput {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  downloadPath?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
  versionFormatted?: InputMaybe<SortEnumType>;
}

declare interface PartialFinishDeliveryNotesItemDtoInput {
  acIdent?: InputMaybe<Scalars['String']>;
  anQty: Scalars['Decimal'];
}

declare interface PersonalVehicle {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  makeAndModel?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  registration?: Maybe<Scalars['String']>;
}

declare interface PersonalVehicleFilterInput {
  and?: InputMaybe<Array<PersonalVehicleFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  makeAndModel?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PersonalVehicleFilterInput>>;
  registration?: InputMaybe<StringOperationFilterInput>;
}

declare interface PersonalVehicleSortInput {
  applicationUser?: InputMaybe<ApplicationUserSortInput>;
  applicationUserId?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  makeAndModel?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  registration?: InputMaybe<SortEnumType>;
}

declare interface PortalAttachmentDto {
  contentType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
}

declare interface PortalConfigDto {
  enabled: Scalars['Boolean'];
  showEntryPoints: Scalars['Boolean'];
}

declare interface PortalEmailPreferencesDto {
  available: Scalars['Boolean'];
  emailCopiesEnabled: Scalars['Boolean'];
}

declare type PortalEmailStatus =
  | 'MISSING'
  | 'SHARED'
  | 'UNCONFIRMED'
  | 'VERIFIED';

declare interface PortalLinkedContactDto {
  contactId: Scalars['Int'];
  displayName?: Maybe<Scalars['String']>;
}

declare interface PortalMeDto {
  companyScope: Scalars['Boolean'];
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailStatus: PortalEmailStatus;
  linkedContacts?: Maybe<Array<Maybe<PortalLinkedContactDto>>>;
  portalOnly: Scalars['Boolean'];
  unreadCount?: Maybe<Scalars['Int']>;
}

declare type PortalMessageDirection =
  | 'INBOUND'
  | 'OUTBOUND';

declare interface PortalMessageDto {
  attachments?: Maybe<Array<Maybe<PortalAttachmentDto>>>;
  authorDisplayName?: Maybe<Scalars['String']>;
  direction: PortalMessageDirection;
  id: Scalars['Int'];
  plainText?: Maybe<Scalars['String']>;
  safeHtml?: Maybe<Scalars['String']>;
  sentOn?: Maybe<Scalars['DateTime']>;
}

declare interface PortalMessageOriginalDto {
  id: Scalars['Int'];
  plainText?: Maybe<Scalars['String']>;
  safeHtml?: Maybe<Scalars['String']>;
}

declare interface PortalServiceKeyDto {
  companySettingsId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  keyPrefix?: Maybe<Scalars['String']>;
  kind: PortalServiceKeyKind;
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  revokedAt?: Maybe<Scalars['DateTime']>;
}

declare type PortalServiceKeyKind =
  | 'CALLBACK'
  | 'SERVICE';

declare interface PortalSignInResultDto {
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  registrationTicket?: Maybe<Scalars['String']>;
  requiresRegistration: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
}

declare interface PortalSignInStartDto {
  challengeId: Scalars['UUID'];
}

declare type PortalTicketStatus =
  | 'IN_PROGRESS'
  | 'RESOLVED'
  | 'WAITING_FOR_CUSTOMER';

declare type PortalTicketStatusFilter =
  | 'ALL'
  | 'CLOSED'
  | 'OPEN';

declare interface PortalTicketSummaryDto {
  companyName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lastActivityOn?: Maybe<Scalars['DateTime']>;
  lastPublicMessageId?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['String']>;
  status: PortalTicketStatus;
  title: Scalars['String'];
  unread: Scalars['Boolean'];
}

declare interface PortalTicketThreadDto {
  messages?: Maybe<Array<Maybe<PortalMessageDto>>>;
  ticket?: Maybe<PortalTicketSummaryDto>;
}

declare interface PortalTicketsResponse {
  items?: Maybe<Array<Maybe<PortalTicketSummaryDto>>>;
  total: Scalars['Int'];
}

declare interface PortalWriteResultDto {
  messageId: Scalars['Int'];
  ticketId: Scalars['Int'];
}

declare interface Project {
  billable: Scalars['Boolean'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  engineModel?: Maybe<Scalars['String']>;
  engineSerialNumber?: Maybe<Scalars['String']>;
  finished: Scalars['Boolean'];
  hINNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invoice: Scalars['Boolean'];
  model?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  pantheonId?: Maybe<Scalars['String']>;
  subject?: Maybe<Subject>;
  subjectId?: Maybe<Scalars['Int']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
  tickets?: Maybe<Array<Maybe<SupportTicket>>>;
  transmissionModel?: Maybe<Scalars['String']>;
  transmissionSerialNumber?: Maybe<Scalars['String']>;
}

declare interface ProjectFilterInput {
  and?: InputMaybe<Array<ProjectFilterInput>>;
  billable?: InputMaybe<BooleanOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  dueDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  engineModel?: InputMaybe<StringOperationFilterInput>;
  engineSerialNumber?: InputMaybe<StringOperationFilterInput>;
  finished?: InputMaybe<BooleanOperationFilterInput>;
  hINNumber?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  invoice?: InputMaybe<BooleanOperationFilterInput>;
  model?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProjectFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  tickets?: InputMaybe<ListFilterInputTypeOfSupportTicketFilterInput>;
  transmissionModel?: InputMaybe<StringOperationFilterInput>;
  transmissionSerialNumber?: InputMaybe<StringOperationFilterInput>;
}

declare interface ProjectSortInput {
  billable?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  dueDate?: InputMaybe<SortEnumType>;
  engineModel?: InputMaybe<SortEnumType>;
  engineSerialNumber?: InputMaybe<SortEnumType>;
  finished?: InputMaybe<SortEnumType>;
  hINNumber?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  invoice?: InputMaybe<SortEnumType>;
  model?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  subject?: InputMaybe<SubjectSortInput>;
  subjectId?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
  transmissionModel?: InputMaybe<SortEnumType>;
  transmissionSerialNumber?: InputMaybe<SortEnumType>;
}

declare interface QueryResultColumn {
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
}

declare interface QueryResultRow {
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
}

declare interface QueryResultSet {
  columns?: Maybe<Array<Maybe<QueryResultColumn>>>;
  rows?: Maybe<Array<Maybe<QueryResultRow>>>;
}

declare interface QueryTableResult {
  query?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<QueryResultSet>>>;
}

declare interface SaveEInvoicePdfArtifactInput {
  byteLength: Scalars['Int'];
  contentBase64?: InputMaybe<Scalars['String']>;
  dispatchId: Scalars['UUID'];
  documentUid?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  originApplicationUserId?: InputMaybe<Scalars['String']>;
  originCompanySettingsId: Scalars['Int'];
  sha256?: InputMaybe<Scalars['String']>;
}

declare interface SaveWebListPreferenceInput {
  customerAcSubject?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateRange?: InputMaybe<DateFilterType>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  departmentAcSubject?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  keyFrom?: InputMaybe<Scalars['String']>;
  keyTo?: InputMaybe<Scalars['String']>;
  onlyMine?: InputMaybe<Scalars['Boolean']>;
  touchOnly: Scalars['Boolean'];
}

declare interface SaveWebPreferencesInput {
  language?: InputMaybe<Scalars['String']>;
  sidebarCollapsed: Scalars['Boolean'];
  sidebarMode: WebSidebarMode;
  theme?: InputMaybe<WebThemePreference>;
}

declare interface SavedFile {
  cID?: Maybe<Scalars['String']>;
  codeMagicArtifact: Scalars['Boolean'];
  companyDocument?: Maybe<Company>;
  companyDocumentId?: Maybe<Scalars['Int']>;
  companyRunbookNote?: Maybe<CompanyRunbookNote>;
  companyRunbookNoteId?: Maybe<Scalars['Int']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contentDisposition?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  fTP: Scalars['Boolean'];
  id: Scalars['Int'];
  isProblemSubmission: Scalars['Boolean'];
  local: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  onixPantheonDMS: Scalars['Boolean'];
  path?: Maybe<Scalars['String']>;
  public: Scalars['Boolean'];
  savedFileContent?: Maybe<SavedFileContent>;
  savedFileContentId?: Maybe<Scalars['UUID']>;
  serverPath?: Maybe<Scalars['String']>;
  supportAiThreadItem?: Maybe<SupportAiThreadItem>;
  supportAiThreadItemId?: Maybe<Scalars['Long']>;
  supportAiThreadMessage?: Maybe<SupportAiThreadMessage>;
  supportAiThreadMessageId?: Maybe<Scalars['Int']>;
  supportTicketMessage?: Maybe<SupportTicketMessage>;
  supportTicketMessageId?: Maybe<Scalars['Int']>;
  supportTicketTimeLog?: Maybe<SupportTicketTimeLog>;
  supportTicketTimeLogId?: Maybe<Scalars['Int']>;
  travelWarrantItem?: Maybe<TravelWarrantItem>;
  travelWarrantItemId?: Maybe<Scalars['Int']>;
  uniqueClientId?: Maybe<Scalars['String']>;
  uploadedByUserId?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<ApplicationUser>>>;
  wikiEntry?: Maybe<WikiEntry>;
  wikiEntryId?: Maybe<Scalars['Int']>;
  workOrder?: Maybe<MarservisWorkOrder>;
  workOrderId?: Maybe<Scalars['String']>;
  workOrderItemWork?: Maybe<MarservisWorkOrderItemWork>;
  workOrderItemWorkId?: Maybe<Scalars['Int']>;
}

declare interface SavedFileContent {
  content?: Maybe<Array<Scalars['Byte']>>;
  id: Scalars['UUID'];
}

declare interface SavedFileContentFilterInput {
  and?: InputMaybe<Array<SavedFileContentFilterInput>>;
  content?: InputMaybe<ListComparableByteOperationFilterInput>;
  id?: InputMaybe<ComparableGuidOperationFilterInput>;
  or?: InputMaybe<Array<SavedFileContentFilterInput>>;
}

declare interface SavedFileContentSortInput {
  id?: InputMaybe<SortEnumType>;
}

declare interface SavedFileDtoInput {
  additionalDirectorySegments?: InputMaybe<Scalars['String']>;
  contentDisposition?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Array<Scalars['Byte']>>;
  description?: InputMaybe<Scalars['String']>;
  isProblemSubmission?: InputMaybe<Scalars['Boolean']>;
  keepOriginalExtension?: InputMaybe<Scalars['Boolean']>;
  maxDim: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  nameOverride?: InputMaybe<Scalars['String']>;
  prependOriginalFileName?: InputMaybe<Scalars['Boolean']>;
  publicImage: Scalars['Boolean'];
  savedFileProperty?: InputMaybe<Scalars['String']>;
  savedFilePropertyValue?: InputMaybe<Scalars['String']>;
  skipProblemSubmissionForwarding?: InputMaybe<Scalars['Boolean']>;
  uniqueClientId?: InputMaybe<Scalars['String']>;
}

declare interface SavedFileFilterInput {
  and?: InputMaybe<Array<SavedFileFilterInput>>;
  cID?: InputMaybe<StringOperationFilterInput>;
  codeMagicArtifact?: InputMaybe<BooleanOperationFilterInput>;
  companyDocument?: InputMaybe<CompanyFilterInput>;
  companyDocumentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companyRunbookNote?: InputMaybe<CompanyRunbookNoteFilterInput>;
  companyRunbookNoteId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contentDisposition?: InputMaybe<StringOperationFilterInput>;
  contentType?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  fTP?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isProblemSubmission?: InputMaybe<BooleanOperationFilterInput>;
  local?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  onixPantheonDMS?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<SavedFileFilterInput>>;
  path?: InputMaybe<StringOperationFilterInput>;
  public?: InputMaybe<BooleanOperationFilterInput>;
  savedFileContent?: InputMaybe<SavedFileContentFilterInput>;
  savedFileContentId?: InputMaybe<ComparableNullableOfGuidOperationFilterInput>;
  serverPath?: InputMaybe<StringOperationFilterInput>;
  supportAiThreadItem?: InputMaybe<SupportAiThreadItemFilterInput>;
  supportAiThreadItemId?: InputMaybe<ComparableNullableOfInt64OperationFilterInput>;
  supportAiThreadMessage?: InputMaybe<SupportAiThreadMessageFilterInput>;
  supportAiThreadMessageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportTicketMessage?: InputMaybe<SupportTicketMessageFilterInput>;
  supportTicketMessageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportTicketTimeLog?: InputMaybe<SupportTicketTimeLogFilterInput>;
  supportTicketTimeLogId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  travelWarrantItem?: InputMaybe<TravelWarrantItemFilterInput>;
  travelWarrantItemId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  uniqueClientId?: InputMaybe<StringOperationFilterInput>;
  uploadedByUserId?: InputMaybe<StringOperationFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  wikiEntry?: InputMaybe<WikiEntryFilterInput>;
  wikiEntryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  workOrder?: InputMaybe<MarservisWorkOrderFilterInput>;
  workOrderId?: InputMaybe<StringOperationFilterInput>;
  workOrderItemWork?: InputMaybe<MarservisWorkOrderItemWorkFilterInput>;
  workOrderItemWorkId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
}

declare interface SavedFileSortInput {
  cID?: InputMaybe<SortEnumType>;
  codeMagicArtifact?: InputMaybe<SortEnumType>;
  companyDocument?: InputMaybe<CompanySortInput>;
  companyDocumentId?: InputMaybe<SortEnumType>;
  companyRunbookNote?: InputMaybe<CompanyRunbookNoteSortInput>;
  companyRunbookNoteId?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  contentDisposition?: InputMaybe<SortEnumType>;
  contentType?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  fTP?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isProblemSubmission?: InputMaybe<SortEnumType>;
  local?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  onixPantheonDMS?: InputMaybe<SortEnumType>;
  path?: InputMaybe<SortEnumType>;
  public?: InputMaybe<SortEnumType>;
  savedFileContent?: InputMaybe<SavedFileContentSortInput>;
  savedFileContentId?: InputMaybe<SortEnumType>;
  serverPath?: InputMaybe<SortEnumType>;
  supportAiThreadItem?: InputMaybe<SupportAiThreadItemSortInput>;
  supportAiThreadItemId?: InputMaybe<SortEnumType>;
  supportAiThreadMessage?: InputMaybe<SupportAiThreadMessageSortInput>;
  supportAiThreadMessageId?: InputMaybe<SortEnumType>;
  supportTicketMessage?: InputMaybe<SupportTicketMessageSortInput>;
  supportTicketMessageId?: InputMaybe<SortEnumType>;
  supportTicketTimeLog?: InputMaybe<SupportTicketTimeLogSortInput>;
  supportTicketTimeLogId?: InputMaybe<SortEnumType>;
  travelWarrantItem?: InputMaybe<TravelWarrantItemSortInput>;
  travelWarrantItemId?: InputMaybe<SortEnumType>;
  uniqueClientId?: InputMaybe<SortEnumType>;
  uploadedByUserId?: InputMaybe<SortEnumType>;
  wikiEntry?: InputMaybe<WikiEntrySortInput>;
  wikiEntryId?: InputMaybe<SortEnumType>;
  workOrder?: InputMaybe<MarservisWorkOrderSortInput>;
  workOrderId?: InputMaybe<SortEnumType>;
  workOrderItemWork?: InputMaybe<MarservisWorkOrderItemWorkSortInput>;
  workOrderItemWorkId?: InputMaybe<SortEnumType>;
}

/** A connection to a list of items. */
declare interface SavedFilesPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<SavedFilesPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<SavedFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface SavedFilesPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SavedFile>;
}

declare interface SingleQueryResult {
  column?: Maybe<QueryResultColumn>;
  value?: Maybe<Scalars['String']>;
}

declare interface SoftPos7PayTokenState {
  expiresAtUtc: Scalars['DateTime'];
  idToken?: Maybe<Scalars['String']>;
}

declare type SortEnumType =
  | 'ASC'
  | 'DESC';

declare interface StringOperationFilterInput {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
}

declare interface Subject {
  address?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contactName?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  longName?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  pantheonId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
  vATID?: Maybe<Scalars['String']>;
  vATIDPrefix?: Maybe<Scalars['String']>;
}

declare interface SubjectFilterInput {
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<SubjectFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contactName?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<CountryFilterInput>;
  countryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  longName?: InputMaybe<StringOperationFilterInput>;
  mail?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SubjectFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  phone?: InputMaybe<StringOperationFilterInput>;
  shortName?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  vATID?: InputMaybe<StringOperationFilterInput>;
  vATIDPrefix?: InputMaybe<StringOperationFilterInput>;
}

declare interface SubjectSortInput {
  address?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  contactName?: InputMaybe<SortEnumType>;
  country?: InputMaybe<CountrySortInput>;
  countryId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  longName?: InputMaybe<SortEnumType>;
  mail?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  shortName?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
  vATID?: InputMaybe<SortEnumType>;
  vATIDPrefix?: InputMaybe<SortEnumType>;
}

declare interface Subjektski {
  datumspre?: Maybe<Scalars['DateTime']>;
  datumzap?: Maybe<Scalars['DateTime']>;
  naziv?: Maybe<Scalars['String']>;
  naziv2?: Maybe<Scalars['String']>;
  skis?: Maybe<Scalars['String']>;
  userspre?: Maybe<Scalars['Int']>;
  userzap?: Maybe<Scalars['Int']>;
}

declare interface SubjektskiFilterInput {
  and?: InputMaybe<Array<SubjektskiFilterInput>>;
  datumspre?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  datumzap?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  naziv?: InputMaybe<StringOperationFilterInput>;
  naziv2?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SubjektskiFilterInput>>;
  skis?: InputMaybe<StringOperationFilterInput>;
  userspre?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userzap?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
}

declare interface SubjektskiSortInput {
  datumspre?: InputMaybe<SortEnumType>;
  datumzap?: InputMaybe<SortEnumType>;
  naziv?: InputMaybe<SortEnumType>;
  naziv2?: InputMaybe<SortEnumType>;
  skis?: InputMaybe<SortEnumType>;
  userspre?: InputMaybe<SortEnumType>;
  userzap?: InputMaybe<SortEnumType>;
}

declare interface SubmittingLurInvoiceCustomerInput {
  acSubject?: InputMaybe<Scalars['String']>;
}

declare interface SubmittingLurInvoiceItemInput {
  acIdent?: InputMaybe<Scalars['String']>;
  acNote?: InputMaybe<Scalars['String']>;
  anPrice: Scalars['Float'];
  anRebate: Scalars['Float'];
  boatLength: Scalars['Float'];
  numberOfDays: Scalars['Int'];
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
}

declare interface SubmittingLurInvoiceViewModelInput {
  berth?: InputMaybe<Scalars['String']>;
  boatLength?: InputMaybe<Scalars['Decimal']>;
  boatName?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<SubmittingLurInvoiceCustomerInput>;
  date: Scalars['DateTime'];
  department?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  moveItems?: InputMaybe<Array<InputMaybe<SubmittingLurInvoiceItemInput>>>;
  note?: InputMaybe<Scalars['String']>;
  payMethod?: InputMaybe<Scalars['String']>;
  printTime?: InputMaybe<Scalars['DateTime']>;
  uID?: InputMaybe<Scalars['String']>;
}

declare interface SubmittingMoveCustomerInput {
  acSubject?: InputMaybe<Scalars['String']>;
}

declare interface SubmittingMoveItemInput {
  acIdent?: InputMaybe<Scalars['String']>;
  acNote?: InputMaybe<Scalars['String']>;
  anPackQuantity: Scalars['Float'];
  anPrice: Scalars['Float'];
  anRebate: Scalars['Float'];
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
}

declare interface SubmittingMoveViewModelInput {
  customer?: InputMaybe<SubmittingMoveCustomerInput>;
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  existingAcKey?: InputMaybe<Scalars['String']>;
  moveItems?: InputMaybe<Array<InputMaybe<SubmittingMoveItemInput>>>;
  note?: InputMaybe<Scalars['String']>;
  printTime?: InputMaybe<Scalars['DateTime']>;
}

declare interface SubmittingOrderCustomerInput {
  acSubject?: InputMaybe<Scalars['String']>;
}

declare interface SubmittingOrderItemInput {
  acIdent?: InputMaybe<Scalars['String']>;
  acNote?: InputMaybe<Scalars['String']>;
  anPrice: Scalars['Float'];
  anRebate: Scalars['Float'];
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
}

declare interface SubmittingOrderViewModelInput {
  customer?: InputMaybe<SubmittingOrderCustomerInput>;
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  orderItems?: InputMaybe<Array<InputMaybe<SubmittingOrderItemInput>>>;
}

declare interface SubmittingWoexCustomerInput {
  acSubject?: InputMaybe<Scalars['String']>;
}

declare interface SubmittingWoexItemInput {
  acIdent?: InputMaybe<Scalars['String']>;
  acNote?: InputMaybe<Scalars['String']>;
  anPackQuantity: Scalars['Float'];
  anPrice: Scalars['Float'];
  anRebate: Scalars['Float'];
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
}

declare interface SubmittingWoexViewModelInput {
  customer?: InputMaybe<SubmittingWoexCustomerInput>;
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  existingAcKey?: InputMaybe<Scalars['String']>;
  moveItems?: InputMaybe<Array<InputMaybe<SubmittingWoexItemInput>>>;
  note?: InputMaybe<Scalars['String']>;
  printTime?: InputMaybe<Scalars['DateTime']>;
}

declare interface SubmittingWorkOrderEndViewModelInput {
  acDoc1?: InputMaybe<Scalars['String']>;
  acDoc1Date?: InputMaybe<Scalars['DateTime']>;
  acDoc2?: InputMaybe<Scalars['String']>;
  acDoc2Date?: InputMaybe<Scalars['DateTime']>;
  acFieldSF?: InputMaybe<Scalars['String']>;
  acKey?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  endingMileage: Scalars['Decimal'];
  location?: InputMaybe<LocationStructureInput>;
  note?: InputMaybe<Scalars['String']>;
  signatory?: InputMaybe<Scalars['String']>;
  signature?: InputMaybe<Array<Scalars['Byte']>>;
  startingMileage: Scalars['Decimal'];
}

declare interface SubmittingWorkOrderMaterialViewModelInput {
  acIdent?: InputMaybe<Scalars['String']>;
  acKey?: InputMaybe<Scalars['String']>;
  acName?: InputMaybe<Scalars['String']>;
  acSerialNo?: InputMaybe<Scalars['String']>;
  anNo?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Decimal'];
}

declare interface SubmittingWorkOrderTHeCostDrvInput {
  acClassif?: InputMaybe<Scalars['String']>;
  acConsignee?: InputMaybe<Scalars['String']>;
  acCostDrv?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acFieldSa?: InputMaybe<Scalars['String']>;
  acName?: InputMaybe<Scalars['String']>;
  acStatus?: InputMaybe<Scalars['String']>;
  anFieldNa?: InputMaybe<Scalars['Decimal']>;
}

declare interface SubmittingWorkOrderTHeSetSubjInput {
  acActive?: InputMaybe<Scalars['String']>;
  acAddress?: InputMaybe<Scalars['String']>;
  acBuyer?: InputMaybe<Scalars['String']>;
  acCountry?: InputMaybe<Scalars['String']>;
  acName2?: InputMaybe<Scalars['String']>;
  acPayer?: InputMaybe<Scalars['String']>;
  acPhone?: InputMaybe<Scalars['String']>;
  acPin?: InputMaybe<Scalars['String']>;
  acPost?: InputMaybe<Scalars['String']>;
  acSubject?: InputMaybe<Scalars['String']>;
  acVatCodePrefix?: InputMaybe<Scalars['String']>;
  acWarehouse?: InputMaybe<Scalars['String']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  anRebate: Scalars['Decimal'];
}

declare interface SubmittingWorkOrderViewModelInput {
  acDoc1?: InputMaybe<Scalars['String']>;
  acDoc1Date?: InputMaybe<Scalars['DateTime']>;
  acDoc2?: InputMaybe<Scalars['String']>;
  acDoc2Date?: InputMaybe<Scalars['DateTime']>;
  acFieldSF?: InputMaybe<Scalars['String']>;
  buyer?: InputMaybe<SubmittingWorkOrderTHeSetSubjInput>;
  buyerPayer?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  costBearer?: InputMaybe<SubmittingWorkOrderTHeCostDrvInput>;
  documentType?: InputMaybe<Scalars['String']>;
  endingMileage: Scalars['Decimal'];
  location?: InputMaybe<LocationStructureInput>;
  note?: InputMaybe<Scalars['String']>;
  otherAcWorkers?: InputMaybe<Array<Scalars['String']>>;
  signatory?: InputMaybe<Scalars['String']>;
  startingMileage: Scalars['Decimal'];
  uID?: InputMaybe<Scalars['String']>;
  zeroAcKey?: InputMaybe<Scalars['String']>;
}

declare interface SubmittingWorkOrderWorkSpecViewModelInput {
  acKey?: InputMaybe<Scalars['String']>;
  anNo?: InputMaybe<Scalars['Int']>;
  from: Scalars['DateTime'];
  ident?: InputMaybe<Scalars['String']>;
  kilometers: Scalars['Float'];
  location?: InputMaybe<LocationStructureInput>;
  note?: InputMaybe<Scalars['String']>;
  to: Scalars['DateTime'];
  worker?: InputMaybe<Scalars['String']>;
}

declare interface SupportAiThreadItem {
  attachments: Array<SavedFile>;
  body?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  completedOn?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  kind: SupportAiThreadItemKind;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  parentItemId?: Maybe<Scalars['Long']>;
  payloadJson?: Maybe<Scalars['String']>;
  phase?: Maybe<SupportAiThreadItemPhase>;
  providerItemId?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['Int']>;
  revision: Scalars['Int'];
  role?: Maybe<SupportAiThreadItemRole>;
  runId?: Maybe<Scalars['Int']>;
  sequence: Scalars['Long'];
  sourceKey?: Maybe<Scalars['String']>;
  startedOn?: Maybe<Scalars['DateTime']>;
  status: SupportAiThreadItemStatus;
  summary?: Maybe<Scalars['String']>;
  threadId: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  toolCallId?: Maybe<Scalars['Int']>;
}

declare interface SupportAiThreadItemFilterInput {
  and?: InputMaybe<Array<SupportAiThreadItemFilterInput>>;
  attachments?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  body?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  completedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  errorCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt64OperationFilterInput>;
  kind?: InputMaybe<SupportAiThreadItemKindOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SupportAiThreadItemFilterInput>>;
  parentItemId?: InputMaybe<ComparableNullableOfInt64OperationFilterInput>;
  payloadJson?: InputMaybe<StringOperationFilterInput>;
  phase?: InputMaybe<NullableOfSupportAiThreadItemPhaseOperationFilterInput>;
  providerItemId?: InputMaybe<StringOperationFilterInput>;
  questionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  revision?: InputMaybe<ComparableInt32OperationFilterInput>;
  role?: InputMaybe<NullableOfSupportAiThreadItemRoleOperationFilterInput>;
  runId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sequence?: InputMaybe<ComparableInt64OperationFilterInput>;
  sourceKey?: InputMaybe<StringOperationFilterInput>;
  startedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  status?: InputMaybe<SupportAiThreadItemStatusOperationFilterInput>;
  summary?: InputMaybe<StringOperationFilterInput>;
  threadId?: InputMaybe<ComparableInt32OperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  toolCallId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
}

declare type SupportAiThreadItemKind =
  | 'APPROVAL_DECISION'
  | 'APPROVAL_REQUEST'
  | 'ARTIFACT'
  | 'ASSISTANT_MESSAGE'
  | 'QUESTION'
  | 'REASONING_SUMMARY'
  | 'SYSTEM_NOTICE'
  | 'TOOL_CALL'
  | 'USER_MESSAGE';

declare interface SupportAiThreadItemKindOperationFilterInput {
  eq?: InputMaybe<SupportAiThreadItemKind>;
  in?: InputMaybe<Array<SupportAiThreadItemKind>>;
  neq?: InputMaybe<SupportAiThreadItemKind>;
  nin?: InputMaybe<Array<SupportAiThreadItemKind>>;
}

declare type SupportAiThreadItemPhase =
  | 'COMMENTARY'
  | 'FINAL_ANSWER';

declare type SupportAiThreadItemRole =
  | 'ASSISTANT'
  | 'SYSTEM'
  | 'USER';

declare interface SupportAiThreadItemSortInput {
  body?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  completedOn?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  errorCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kind?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  parentItemId?: InputMaybe<SortEnumType>;
  payloadJson?: InputMaybe<SortEnumType>;
  phase?: InputMaybe<SortEnumType>;
  providerItemId?: InputMaybe<SortEnumType>;
  questionId?: InputMaybe<SortEnumType>;
  revision?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  runId?: InputMaybe<SortEnumType>;
  sequence?: InputMaybe<SortEnumType>;
  sourceKey?: InputMaybe<SortEnumType>;
  startedOn?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  summary?: InputMaybe<SortEnumType>;
  threadId?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  toolCallId?: InputMaybe<SortEnumType>;
}

declare type SupportAiThreadItemStatus =
  | 'BLOCKED'
  | 'CANCELLED'
  | 'COMPLETED'
  | 'DECLINED'
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'PENDING';

declare interface SupportAiThreadItemStatusOperationFilterInput {
  eq?: InputMaybe<SupportAiThreadItemStatus>;
  in?: InputMaybe<Array<SupportAiThreadItemStatus>>;
  neq?: InputMaybe<SupportAiThreadItemStatus>;
  nin?: InputMaybe<Array<SupportAiThreadItemStatus>>;
}

declare interface SupportAiThreadMessage {
  attachments: Array<SavedFile>;
  authorKind: SupportAiVisibleMessageAuthorKind;
  body: Scalars['String'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  firstUsedByRunId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  kind: SupportAiVisibleMessageKind;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  payloadJson?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['Int']>;
  runId?: Maybe<Scalars['Int']>;
  secondaryBody?: Maybe<Scalars['String']>;
  sourceKey?: Maybe<Scalars['String']>;
  threadId: Scalars['Int'];
}

declare interface SupportAiThreadMessageFilterInput {
  and?: InputMaybe<Array<SupportAiThreadMessageFilterInput>>;
  attachments?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  authorKind?: InputMaybe<SupportAiVisibleMessageAuthorKindOperationFilterInput>;
  body?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  firstUsedByRunId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  kind?: InputMaybe<SupportAiVisibleMessageKindOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SupportAiThreadMessageFilterInput>>;
  payloadJson?: InputMaybe<StringOperationFilterInput>;
  questionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  runId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  secondaryBody?: InputMaybe<StringOperationFilterInput>;
  sourceKey?: InputMaybe<StringOperationFilterInput>;
  threadId?: InputMaybe<ComparableInt32OperationFilterInput>;
}

declare interface SupportAiThreadMessageSortInput {
  authorKind?: InputMaybe<SortEnumType>;
  body?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  firstUsedByRunId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kind?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  payloadJson?: InputMaybe<SortEnumType>;
  questionId?: InputMaybe<SortEnumType>;
  runId?: InputMaybe<SortEnumType>;
  secondaryBody?: InputMaybe<SortEnumType>;
  sourceKey?: InputMaybe<SortEnumType>;
  threadId?: InputMaybe<SortEnumType>;
}

declare type SupportAiVisibleMessageAuthorKind =
  | 'AI'
  | 'SYSTEM'
  | 'USER';

declare interface SupportAiVisibleMessageAuthorKindOperationFilterInput {
  eq?: InputMaybe<SupportAiVisibleMessageAuthorKind>;
  in?: InputMaybe<Array<SupportAiVisibleMessageAuthorKind>>;
  neq?: InputMaybe<SupportAiVisibleMessageAuthorKind>;
  nin?: InputMaybe<Array<SupportAiVisibleMessageAuthorKind>>;
}

declare type SupportAiVisibleMessageKind =
  | 'CONCLUSION'
  | 'DATABASE_GRANT_REQUEST'
  | 'ERROR'
  | 'QUESTION'
  | 'REPLY'
  | 'RESUME'
  | 'STATUS'
  | 'USER_COMMENT';

declare interface SupportAiVisibleMessageKindOperationFilterInput {
  eq?: InputMaybe<SupportAiVisibleMessageKind>;
  in?: InputMaybe<Array<SupportAiVisibleMessageKind>>;
  neq?: InputMaybe<SupportAiVisibleMessageKind>;
  nin?: InputMaybe<Array<SupportAiVisibleMessageKind>>;
}

declare interface SupportGroup {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  members?: Maybe<Array<Maybe<SupportGroupMember>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  receivesProblemSubmissions: Scalars['Boolean'];
  supportTickets?: Maybe<Array<Maybe<SupportTicket>>>;
}

declare interface SupportGroupFilterInput {
  and?: InputMaybe<Array<SupportGroupFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  members?: InputMaybe<ListFilterInputTypeOfSupportGroupMemberFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SupportGroupFilterInput>>;
  receivesProblemSubmissions?: InputMaybe<BooleanOperationFilterInput>;
  supportTickets?: InputMaybe<ListFilterInputTypeOfSupportTicketFilterInput>;
}

declare interface SupportGroupMember {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  supportGroup?: Maybe<SupportGroup>;
  supportGroupId: Scalars['Int'];
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
}

declare interface SupportGroupMemberFilterInput {
  and?: InputMaybe<Array<SupportGroupMemberFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SupportGroupMemberFilterInput>>;
  supportGroup?: InputMaybe<SupportGroupFilterInput>;
  supportGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
}

declare interface SupportGroupSortInput {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  receivesProblemSubmissions?: InputMaybe<SortEnumType>;
}

declare interface SupportOpenAiExecution {
  context: SupportOpenAiExecutionContextEnum;
  forUser?: Maybe<ApplicationUser>;
  forUserId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  message?: Maybe<SupportTicketMessage>;
  messageId?: Maybe<Scalars['Int']>;
  openAIMessage: Scalars['String'];
  openAIRequest: Scalars['String'];
  openAIResponse: Scalars['String'];
  ticket?: Maybe<SupportTicket>;
  ticketId?: Maybe<Scalars['Int']>;
}

declare type SupportOpenAiExecutionContextEnum =
  | 'DETERMINE_RECOMMENDED_USER_FOR_TICKET';

declare interface SupportOpenAiExecutionContextEnumOperationFilterInput {
  eq?: InputMaybe<SupportOpenAiExecutionContextEnum>;
  in?: InputMaybe<Array<SupportOpenAiExecutionContextEnum>>;
  neq?: InputMaybe<SupportOpenAiExecutionContextEnum>;
  nin?: InputMaybe<Array<SupportOpenAiExecutionContextEnum>>;
}

declare interface SupportOpenAiExecutionFilterInput {
  and?: InputMaybe<Array<SupportOpenAiExecutionFilterInput>>;
  context?: InputMaybe<SupportOpenAiExecutionContextEnumOperationFilterInput>;
  forUser?: InputMaybe<ApplicationUserFilterInput>;
  forUserId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  message?: InputMaybe<SupportTicketMessageFilterInput>;
  messageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  openAIMessage?: InputMaybe<StringOperationFilterInput>;
  openAIRequest?: InputMaybe<StringOperationFilterInput>;
  openAIResponse?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SupportOpenAiExecutionFilterInput>>;
  ticket?: InputMaybe<SupportTicketFilterInput>;
  ticketId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
}

declare type SupportPriorityEnum =
  | 'HIGH'
  | 'LOW'
  | 'MEDIUM'
  | 'URGENT';

declare interface SupportPriorityEnumOperationFilterInput {
  eq?: InputMaybe<SupportPriorityEnum>;
  in?: InputMaybe<Array<SupportPriorityEnum>>;
  neq?: InputMaybe<SupportPriorityEnum>;
  nin?: InputMaybe<Array<SupportPriorityEnum>>;
}

declare type SupportSourceEnum =
  | 'EMAIL'
  | 'ONIX_PHONE'
  | 'PHONE'
  | 'PORTAL'
  | 'SYSTEM';

declare interface SupportSourceEnumOperationFilterInput {
  eq?: InputMaybe<SupportSourceEnum>;
  in?: InputMaybe<Array<SupportSourceEnum>>;
  neq?: InputMaybe<SupportSourceEnum>;
  nin?: InputMaybe<Array<SupportSourceEnum>>;
}

declare type SupportStatusEnum =
  | 'CLOSED'
  | 'FOR_REVIEW'
  | 'IN_PROGRESS'
  | 'I_BACKUP'
  | 'MAINTENANCE'
  | 'OPEN'
  | 'PANTHEON_UPGRADE'
  | 'PENDING'
  | 'RESOLVED'
  | 'SPAM'
  | 'WAITING_FOR_OFFER';

declare interface SupportStatusEnumOperationFilterInput {
  eq?: InputMaybe<SupportStatusEnum>;
  in?: InputMaybe<Array<SupportStatusEnum>>;
  neq?: InputMaybe<SupportStatusEnum>;
  nin?: InputMaybe<Array<SupportStatusEnum>>;
}

declare interface SupportTicket {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contactCompanyCompany?: Maybe<Company>;
  contactCompanyCompanyId?: Maybe<Scalars['Int']>;
  contactCompanyContact?: Maybe<Contact>;
  contactCompanyContactId?: Maybe<Scalars['Int']>;
  contactEmail?: Maybe<ContactEmail>;
  contactEmailId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  dateDue?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  messagesDeleted: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  offerNumber?: Maybe<Scalars['String']>;
  offerTypeDefault: Scalars['Boolean'];
  originalSender?: Maybe<Scalars['String']>;
  pantheonVersion?: Maybe<PantheonVersion>;
  pantheonVersionId?: Maybe<Scalars['Int']>;
  priority: SupportPriorityEnum;
  problemSubmissionSourceKey?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['Int']>;
  reportedByApplicationUser?: Maybe<ApplicationUser>;
  reportedByApplicationUserId?: Maybe<Scalars['String']>;
  showProjectFeatures: Scalars['Boolean'];
  source: SupportSourceEnum;
  status: SupportStatusEnum;
  supportGroup?: Maybe<SupportGroup>;
  supportGroupId?: Maybe<Scalars['Int']>;
  supportOpenAIExecutions?: Maybe<Array<Maybe<SupportOpenAiExecution>>>;
  supportTicketMessages?: Maybe<Array<Maybe<SupportTicketMessage>>>;
  supportTicketTimeLogs?: Maybe<Array<Maybe<SupportTicketTimeLog>>>;
  supportTicketTodos?: Maybe<Array<Maybe<SupportTicketTodo>>>;
  teamViewerSessions?: Maybe<Array<Maybe<TeamViewerSession>>>;
  temporaryOwner?: Maybe<ApplicationUser>;
  temporaryOwnerId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
  wakaTimeWorklogs?: Maybe<Array<Maybe<WakaTimeWorklog>>>;
}

declare interface SupportTicketFilterInput {
  and?: InputMaybe<Array<SupportTicketFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contactCompanyCompany?: InputMaybe<CompanyFilterInput>;
  contactCompanyCompanyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contactCompanyContact?: InputMaybe<ContactFilterInput>;
  contactCompanyContactId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contactEmail?: InputMaybe<ContactEmailFilterInput>;
  contactEmailId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  dateDue?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  messagesDeleted?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  offerNumber?: InputMaybe<StringOperationFilterInput>;
  offerTypeDefault?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<SupportTicketFilterInput>>;
  originalSender?: InputMaybe<StringOperationFilterInput>;
  pantheonVersion?: InputMaybe<PantheonVersionFilterInput>;
  pantheonVersionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  priority?: InputMaybe<SupportPriorityEnumOperationFilterInput>;
  problemSubmissionSourceKey?: InputMaybe<StringOperationFilterInput>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  reportedByApplicationUser?: InputMaybe<ApplicationUserFilterInput>;
  reportedByApplicationUserId?: InputMaybe<StringOperationFilterInput>;
  showProjectFeatures?: InputMaybe<BooleanOperationFilterInput>;
  source?: InputMaybe<SupportSourceEnumOperationFilterInput>;
  status?: InputMaybe<SupportStatusEnumOperationFilterInput>;
  supportGroup?: InputMaybe<SupportGroupFilterInput>;
  supportGroupId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportOpenAIExecutions?: InputMaybe<ListFilterInputTypeOfSupportOpenAiExecutionFilterInput>;
  supportTicketMessages?: InputMaybe<ListFilterInputTypeOfSupportTicketMessageFilterInput>;
  supportTicketTimeLogs?: InputMaybe<ListFilterInputTypeOfSupportTicketTimeLogFilterInput>;
  supportTicketTodos?: InputMaybe<ListFilterInputTypeOfSupportTicketTodoFilterInput>;
  teamViewerSessions?: InputMaybe<ListFilterInputTypeOfTeamViewerSessionFilterInput>;
  temporaryOwner?: InputMaybe<ApplicationUserFilterInput>;
  temporaryOwnerId?: InputMaybe<StringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  wakaTimeWorklogs?: InputMaybe<ListFilterInputTypeOfWakaTimeWorklogFilterInput>;
}

declare interface SupportTicketMessage {
  attachments?: Maybe<Array<Maybe<SavedFile>>>;
  cCEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  codexTaskId?: Maybe<Scalars['String']>;
  codexTaskLastSeenOn?: Maybe<Scalars['DateTime']>;
  codexTaskWorkedOn?: Maybe<Scalars['DateTime']>;
  collapsed: Scalars['Boolean'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  customerHasSeen?: Maybe<Scalars['Boolean']>;
  customerHasSeenAt?: Maybe<Scalars['DateTime']>;
  globalMessageId?: Maybe<Scalars['String']>;
  globalMessageReplyId?: Maybe<Scalars['String']>;
  helpBookId?: Maybe<Scalars['Int']>;
  helpId?: Maybe<Scalars['Int']>;
  helpLink?: Maybe<Scalars['String']>;
  helpTitle?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  inbound: Scalars['Boolean'];
  internalCommunicationTo?: Maybe<SupportTicketMessage>;
  internalCommunicationToId?: Maybe<Scalars['Int']>;
  internalCommunications?: Maybe<Array<Maybe<SupportTicketMessage>>>;
  isQueryExecution: Scalars['Boolean'];
  isTask: Scalars['Boolean'];
  isTaskDone: Scalars['Boolean'];
  messageId: Scalars['Long'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  notifyEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  notifyUsers?: Maybe<Array<Maybe<ApplicationUser>>>;
  originalCCs?: Maybe<Scalars['String']>;
  originalReceiver?: Maybe<Scalars['String']>;
  originalReceiverName?: Maybe<Scalars['String']>;
  originalSender?: Maybe<Scalars['String']>;
  originalSenderName?: Maybe<Scalars['String']>;
  originalSubject?: Maybe<Scalars['String']>;
  outbound: Scalars['Boolean'];
  private: Scalars['Boolean'];
  remoteContentSavedFileId?: Maybe<Scalars['Int']>;
  responsibleAgent?: Maybe<ApplicationUser>;
  responsibleAgentId?: Maybe<Scalars['String']>;
  scheduledSendOn?: Maybe<Scalars['DateTime']>;
  sentAs?: Maybe<ApplicationUser>;
  sentAsId?: Maybe<Scalars['String']>;
  sentBy?: Maybe<ApplicationUser>;
  sentById?: Maybe<Scalars['String']>;
  supportAiRunId?: Maybe<Scalars['Int']>;
  supportAiThreadId?: Maybe<Scalars['Int']>;
  supportOpenAIExecutions?: Maybe<Array<Maybe<SupportOpenAiExecution>>>;
  taskDue?: Maybe<Scalars['DateTime']>;
  taskStart?: Maybe<Scalars['DateTime']>;
  textContent?: Maybe<Scalars['String']>;
  ticket?: Maybe<SupportTicket>;
  ticketId?: Maybe<Scalars['Int']>;
  unreadUserSupportTicketMessage?: Maybe<Array<Maybe<UnreadUserSupportTicketMessage>>>;
}

declare interface SupportTicketMessageFilterInput {
  and?: InputMaybe<Array<SupportTicketMessageFilterInput>>;
  attachments?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  cCEmails?: InputMaybe<ListStringOperationFilterInput>;
  codexTaskId?: InputMaybe<StringOperationFilterInput>;
  codexTaskLastSeenOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  codexTaskWorkedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  collapsed?: InputMaybe<BooleanOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  content?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  customerHasSeen?: InputMaybe<BooleanOperationFilterInput>;
  customerHasSeenAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  globalMessageId?: InputMaybe<StringOperationFilterInput>;
  globalMessageReplyId?: InputMaybe<StringOperationFilterInput>;
  helpBookId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  helpId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  helpLink?: InputMaybe<StringOperationFilterInput>;
  helpTitle?: InputMaybe<StringOperationFilterInput>;
  htmlContent?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  inbound?: InputMaybe<BooleanOperationFilterInput>;
  internalCommunicationTo?: InputMaybe<SupportTicketMessageFilterInput>;
  internalCommunicationToId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  internalCommunications?: InputMaybe<ListFilterInputTypeOfSupportTicketMessageFilterInput>;
  isQueryExecution?: InputMaybe<BooleanOperationFilterInput>;
  isTask?: InputMaybe<BooleanOperationFilterInput>;
  isTaskDone?: InputMaybe<BooleanOperationFilterInput>;
  messageId?: InputMaybe<ComparableInt64OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  notifyEmails?: InputMaybe<ListStringOperationFilterInput>;
  notifyUsers?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  or?: InputMaybe<Array<SupportTicketMessageFilterInput>>;
  originalCCs?: InputMaybe<StringOperationFilterInput>;
  originalReceiver?: InputMaybe<StringOperationFilterInput>;
  originalReceiverName?: InputMaybe<StringOperationFilterInput>;
  originalSender?: InputMaybe<StringOperationFilterInput>;
  originalSenderName?: InputMaybe<StringOperationFilterInput>;
  originalSubject?: InputMaybe<StringOperationFilterInput>;
  outbound?: InputMaybe<BooleanOperationFilterInput>;
  private?: InputMaybe<BooleanOperationFilterInput>;
  remoteContentSavedFileId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  responsibleAgent?: InputMaybe<ApplicationUserFilterInput>;
  responsibleAgentId?: InputMaybe<StringOperationFilterInput>;
  scheduledSendOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  sentAs?: InputMaybe<ApplicationUserFilterInput>;
  sentAsId?: InputMaybe<StringOperationFilterInput>;
  sentBy?: InputMaybe<ApplicationUserFilterInput>;
  sentById?: InputMaybe<StringOperationFilterInput>;
  supportAiRunId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportAiThreadId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportOpenAIExecutions?: InputMaybe<ListFilterInputTypeOfSupportOpenAiExecutionFilterInput>;
  taskDue?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  taskStart?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  textContent?: InputMaybe<StringOperationFilterInput>;
  ticket?: InputMaybe<SupportTicketFilterInput>;
  ticketId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  unreadUserSupportTicketMessage?: InputMaybe<ListFilterInputTypeOfUnreadUserSupportTicketMessageFilterInput>;
}

declare interface SupportTicketMessageSortInput {
  codexTaskId?: InputMaybe<SortEnumType>;
  codexTaskLastSeenOn?: InputMaybe<SortEnumType>;
  codexTaskWorkedOn?: InputMaybe<SortEnumType>;
  collapsed?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  content?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  customerHasSeen?: InputMaybe<SortEnumType>;
  customerHasSeenAt?: InputMaybe<SortEnumType>;
  globalMessageId?: InputMaybe<SortEnumType>;
  globalMessageReplyId?: InputMaybe<SortEnumType>;
  helpBookId?: InputMaybe<SortEnumType>;
  helpId?: InputMaybe<SortEnumType>;
  helpLink?: InputMaybe<SortEnumType>;
  helpTitle?: InputMaybe<SortEnumType>;
  htmlContent?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inbound?: InputMaybe<SortEnumType>;
  internalCommunicationTo?: InputMaybe<SupportTicketMessageSortInput>;
  internalCommunicationToId?: InputMaybe<SortEnumType>;
  isQueryExecution?: InputMaybe<SortEnumType>;
  isTask?: InputMaybe<SortEnumType>;
  isTaskDone?: InputMaybe<SortEnumType>;
  messageId?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  originalCCs?: InputMaybe<SortEnumType>;
  originalReceiver?: InputMaybe<SortEnumType>;
  originalReceiverName?: InputMaybe<SortEnumType>;
  originalSender?: InputMaybe<SortEnumType>;
  originalSenderName?: InputMaybe<SortEnumType>;
  originalSubject?: InputMaybe<SortEnumType>;
  outbound?: InputMaybe<SortEnumType>;
  private?: InputMaybe<SortEnumType>;
  remoteContentSavedFileId?: InputMaybe<SortEnumType>;
  responsibleAgent?: InputMaybe<ApplicationUserSortInput>;
  responsibleAgentId?: InputMaybe<SortEnumType>;
  scheduledSendOn?: InputMaybe<SortEnumType>;
  sentAs?: InputMaybe<ApplicationUserSortInput>;
  sentAsId?: InputMaybe<SortEnumType>;
  sentBy?: InputMaybe<ApplicationUserSortInput>;
  sentById?: InputMaybe<SortEnumType>;
  supportAiRunId?: InputMaybe<SortEnumType>;
  supportAiThreadId?: InputMaybe<SortEnumType>;
  taskDue?: InputMaybe<SortEnumType>;
  taskStart?: InputMaybe<SortEnumType>;
  textContent?: InputMaybe<SortEnumType>;
  ticket?: InputMaybe<SupportTicketSortInput>;
  ticketId?: InputMaybe<SortEnumType>;
}

declare interface SupportTicketSortInput {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  contactCompanyCompany?: InputMaybe<CompanySortInput>;
  contactCompanyCompanyId?: InputMaybe<SortEnumType>;
  contactCompanyContact?: InputMaybe<ContactSortInput>;
  contactCompanyContactId?: InputMaybe<SortEnumType>;
  contactEmail?: InputMaybe<ContactEmailSortInput>;
  contactEmailId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  dateDue?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  messagesDeleted?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  offerNumber?: InputMaybe<SortEnumType>;
  offerTypeDefault?: InputMaybe<SortEnumType>;
  originalSender?: InputMaybe<SortEnumType>;
  pantheonVersion?: InputMaybe<PantheonVersionSortInput>;
  pantheonVersionId?: InputMaybe<SortEnumType>;
  priority?: InputMaybe<SortEnumType>;
  problemSubmissionSourceKey?: InputMaybe<SortEnumType>;
  project?: InputMaybe<ProjectSortInput>;
  projectId?: InputMaybe<SortEnumType>;
  reportedByApplicationUser?: InputMaybe<ApplicationUserSortInput>;
  reportedByApplicationUserId?: InputMaybe<SortEnumType>;
  showProjectFeatures?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  supportGroup?: InputMaybe<SupportGroupSortInput>;
  supportGroupId?: InputMaybe<SortEnumType>;
  temporaryOwner?: InputMaybe<ApplicationUserSortInput>;
  temporaryOwnerId?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
}

declare interface SupportTicketTimeLog {
  agent?: Maybe<ApplicationUser>;
  agentId?: Maybe<Scalars['String']>;
  billable: Scalars['Boolean'];
  billableTime: Scalars['TimeSpan'];
  codexCumulativeDurationMs?: Maybe<Scalars['Long']>;
  codexSnapshotAtUtc?: Maybe<Scalars['DateTime']>;
  codexTaskId?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  exportedOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  invoice: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  projectPhase?: Maybe<Scalars['String']>;
  technicalNote?: Maybe<Scalars['String']>;
  ticket?: Maybe<SupportTicket>;
  ticketId?: Maybe<Scalars['Int']>;
  time: Scalars['TimeSpan'];
  type?: Maybe<Scalars['String']>;
  workOutsideWorkingHours: Scalars['Boolean'];
}

declare interface SupportTicketTimeLogFilterInput {
  agent?: InputMaybe<ApplicationUserFilterInput>;
  agentId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<SupportTicketTimeLogFilterInput>>;
  billable?: InputMaybe<BooleanOperationFilterInput>;
  billableTime?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  codexCumulativeDurationMs?: InputMaybe<ComparableNullableOfInt64OperationFilterInput>;
  codexSnapshotAtUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  codexTaskId?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  exportedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  invoice?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SupportTicketTimeLogFilterInput>>;
  projectPhase?: InputMaybe<StringOperationFilterInput>;
  technicalNote?: InputMaybe<StringOperationFilterInput>;
  ticket?: InputMaybe<SupportTicketFilterInput>;
  ticketId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  time?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  workOutsideWorkingHours?: InputMaybe<BooleanOperationFilterInput>;
}

declare interface SupportTicketTimeLogSortInput {
  agent?: InputMaybe<ApplicationUserSortInput>;
  agentId?: InputMaybe<SortEnumType>;
  billable?: InputMaybe<SortEnumType>;
  billableTime?: InputMaybe<SortEnumType>;
  codexCumulativeDurationMs?: InputMaybe<SortEnumType>;
  codexSnapshotAtUtc?: InputMaybe<SortEnumType>;
  codexTaskId?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  exportedOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  invoice?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  projectPhase?: InputMaybe<SortEnumType>;
  technicalNote?: InputMaybe<SortEnumType>;
  ticket?: InputMaybe<SupportTicketSortInput>;
  ticketId?: InputMaybe<SortEnumType>;
  time?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  workOutsideWorkingHours?: InputMaybe<SortEnumType>;
}

declare interface SupportTicketTodo {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  dateTime: Scalars['DateTime'];
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  notified: Scalars['Boolean'];
  ticket?: Maybe<SupportTicket>;
  ticketId: Scalars['Int'];
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
}

declare interface SupportTicketTodoFilterInput {
  and?: InputMaybe<Array<SupportTicketTodoFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  dateTime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  notified?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<SupportTicketTodoFilterInput>>;
  ticket?: InputMaybe<SupportTicketFilterInput>;
  ticketId?: InputMaybe<ComparableInt32OperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
}

declare interface Synchronization {
  added: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deleted: Scalars['Int'];
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  resource?: Maybe<Scalars['String']>;
  time: Scalars['DateTime'];
  updated: Scalars['Int'];
}

declare interface SynchronizationFilterInput {
  added?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<SynchronizationFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deleted?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SynchronizationFilterInput>>;
  resource?: InputMaybe<StringOperationFilterInput>;
  time?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  updated?: InputMaybe<ComparableInt32OperationFilterInput>;
}

declare interface TDeSetAccount {
  acAcct?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acPermitPost?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anPlanId: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface TDeSetAccountFilterInput {
  acAcct?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acPermitPost?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anPlanId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TDeSetAccountFilterInput>>;
  or?: InputMaybe<Array<TDeSetAccountFilterInput>>;
}

/** A connection to a list of items. */
declare interface TDeSetAccountPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<TDeSetAccountPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TDeSetAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface TDeSetAccountPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TDeSetAccount>;
}

declare interface TDeSetAccountSortInput {
  acAcct?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acPermitPost?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anPlanId?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeAcctTransItem {
  acAcct?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acLinkDoc?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  adDateDoc: Scalars['DateTime'];
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anCredit: Scalars['Decimal'];
  anDebit: Scalars['Decimal'];
  anNo: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
  anValCredit: Scalars['Decimal'];
  anValDebit: Scalars['Decimal'];
}

/** A connection to a list of items. */
declare interface THeAcctTransItemConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeAcctTransItemEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeAcctTransItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeAcctTransItemEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeAcctTransItem>;
}

declare interface THeAcctTransItemFilterInput {
  acAcct?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acLinkDoc?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  adDateDoc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anCredit?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDebit?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValCredit?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anValDebit?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<THeAcctTransItemFilterInput>>;
  or?: InputMaybe<Array<THeAcctTransItemFilterInput>>;
}

declare interface THeAcctTransItemSortInput {
  acAcct?: InputMaybe<SortEnumType>;
  acCurrency?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acLinkDoc?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  adDateDoc?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anCredit?: InputMaybe<SortEnumType>;
  anDebit?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anValCredit?: InputMaybe<SortEnumType>;
  anValDebit?: InputMaybe<SortEnumType>;
}

declare interface THeCashReg {
  acCurrency?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acLocked?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClerk?: Maybe<Scalars['Int']>;
  anDocNo?: Maybe<Scalars['Int']>;
  anDocYear: Scalars['Int'];
  anPaid: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anRefund: Scalars['Decimal'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Decimal'];
  tHeCashRegItems?: Maybe<Array<Maybe<THeCashRegItem>>>;
}

declare interface THeCashRegFilterInput {
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDoc1?: InputMaybe<StringOperationFilterInput>;
  acDoc2?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acLocked?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc1?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc2?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anDocNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anDocYear?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPaid?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anRefund?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<THeCashRegFilterInput>>;
  or?: InputMaybe<Array<THeCashRegFilterInput>>;
  tHeCashRegItems?: InputMaybe<ListFilterInputTypeOfTHeCashRegItemFilterInput>;
}

declare interface THeCashRegItem {
  acAcct?: Maybe<Scalars['String']>;
  acCostDrv?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeCashReg>;
  acLinkDoc?: Maybe<Scalars['String']>;
  acLnkKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPayMethodNavigation?: Maybe<THeSetPayMet>;
  acTrvlType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anAmount: Scalars['Decimal'];
  anEventTypeId?: Maybe<Scalars['Int']>;
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THeCashRegItemFilterInput {
  acAcct?: InputMaybe<StringOperationFilterInput>;
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeCashRegFilterInput>;
  acLinkDoc?: InputMaybe<StringOperationFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetFilterInput>;
  acTrvlType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anAmount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anEventTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeCashRegItemFilterInput>>;
  or?: InputMaybe<Array<THeCashRegItemFilterInput>>;
}

declare interface THeCashRegItemSortInput {
  acAcct?: InputMaybe<SortEnumType>;
  acCostDrv?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyNavigation?: InputMaybe<THeCashRegSortInput>;
  acLinkDoc?: InputMaybe<SortEnumType>;
  acLnkKey?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acPayMethod?: InputMaybe<SortEnumType>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetSortInput>;
  acTrvlType?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anAmount?: InputMaybe<SortEnumType>;
  anEventTypeId?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

/** A connection to a list of items. */
declare interface THeCashRegPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeCashRegPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeCashReg>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeCashRegPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeCashReg>;
}

declare interface THeCashRegSortInput {
  acCurrency?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acDoc1?: InputMaybe<SortEnumType>;
  acDoc2?: InputMaybe<SortEnumType>;
  acDocType?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acLocked?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acPayMethod?: InputMaybe<SortEnumType>;
  acStatus?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adDateDoc1?: InputMaybe<SortEnumType>;
  adDateDoc2?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anDocNo?: InputMaybe<SortEnumType>;
  anDocYear?: InputMaybe<SortEnumType>;
  anPaid?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anRefund?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anValue?: InputMaybe<SortEnumType>;
}

declare interface THeCostDrv {
  acClassif?: Maybe<Scalars['String']>;
  acConsignee?: Maybe<Scalars['String']>;
  acConsigneeNavigation?: Maybe<THeSetSubj>;
  acCostDrv?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDeptNavigation?: Maybe<THeSetSubj>;
  acFieldSa?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anFieldNa?: Maybe<Scalars['Decimal']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeMove?: Maybe<Array<Maybe<THeMove>>>;
  tHfPlans?: Maybe<Array<Maybe<THfPlan>>>;
  tHfWoexes?: Maybe<Array<Maybe<THfWoex>>>;
}

declare interface THeCostDrvFilterInput {
  acClassif?: InputMaybe<StringOperationFilterInput>;
  acConsignee?: InputMaybe<StringOperationFilterInput>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDeptNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeCostDrvFilterInput>>;
  or?: InputMaybe<Array<THeCostDrvFilterInput>>;
  tHeMove?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHfPlans?: InputMaybe<ListFilterInputTypeOfTHfPlanFilterInput>;
  tHfWoexes?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
}

/** A connection to a list of items. */
declare interface THeCostDrvPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeCostDrvPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeCostDrv>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeCostDrvPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeCostDrv>;
}

declare interface THeCostDrvSortInput {
  acClassif?: InputMaybe<SortEnumType>;
  acConsignee?: InputMaybe<SortEnumType>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjSortInput>;
  acCostDrv?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acDeptNavigation?: InputMaybe<THeSetSubjSortInput>;
  acFieldSa?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acStatus?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anFieldNa?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeFa {
  acActive?: Maybe<Scalars['String']>;
  acCarRegNo?: Maybe<Scalars['String']>;
  acCompanyCar?: Maybe<Scalars['String']>;
  acInventNum?: Maybe<Scalars['String']>;
  acIsRented?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acSuppCarRegNo?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acVtsid?: Maybe<Scalars['String']>;
  adDateOfAcq?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQty: Scalars['Decimal'];
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THeFaFilterInput {
  acActive?: InputMaybe<StringOperationFilterInput>;
  acCarRegNo?: InputMaybe<StringOperationFilterInput>;
  acCompanyCar?: InputMaybe<StringOperationFilterInput>;
  acInventNum?: InputMaybe<StringOperationFilterInput>;
  acIsRented?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acSuppCarRegNo?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acVtsid?: InputMaybe<StringOperationFilterInput>;
  adDateOfAcq?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeFaFilterInput>>;
  or?: InputMaybe<Array<THeFaFilterInput>>;
}

/** A connection to a list of items. */
declare interface THeFaPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeFaPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeFa>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeFaPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeFa>;
}

declare interface THeFaSortInput {
  acActive?: InputMaybe<SortEnumType>;
  acCarRegNo?: InputMaybe<SortEnumType>;
  acCompanyCar?: InputMaybe<SortEnumType>;
  acInventNum?: InputMaybe<SortEnumType>;
  acIsRented?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acSuppCarRegNo?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acVtsid?: InputMaybe<SortEnumType>;
  adDateOfAcq?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQty?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeLinkMoveItemMoveItem {
  a?: Maybe<THeMoveItem>;
  aNavigation?: Maybe<THeMoveItem>;
  acKey?: Maybe<Scalars['String']>;
  acLnkKey?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acTypeA?: Maybe<Scalars['String']>;
  acTypeB?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anLnkNo: Scalars['Int'];
  anMoveItemChildQid: Scalars['Int'];
  anMoveItemParentQid: Scalars['Int'];
  anNo: Scalars['Int'];
  anQty: Scalars['Float'];
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THeLinkMoveItemMoveItemFilterInput {
  a?: InputMaybe<THeMoveItemFilterInput>;
  aNavigation?: InputMaybe<THeMoveItemFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acTypeA?: InputMaybe<StringOperationFilterInput>;
  acTypeB?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anLnkNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anMoveItemChildQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anMoveItemParentQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeLinkMoveItemMoveItemFilterInput>>;
  or?: InputMaybe<Array<THeLinkMoveItemMoveItemFilterInput>>;
}

declare interface THeLinkMoveItemOrderItem {
  a?: Maybe<THeMoveItem>;
  aNavigation?: Maybe<THeOrderItem>;
  acKey?: Maybe<Scalars['String']>;
  acLnkKey?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acTypeA?: Maybe<Scalars['String']>;
  acTypeB?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anLnkNo: Scalars['Int'];
  anMoveItemQid: Scalars['Int'];
  anNo: Scalars['Int'];
  anOrderItemQid: Scalars['Int'];
  anQty: Scalars['Decimal'];
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THeLinkMoveItemOrderItemFilterInput {
  a?: InputMaybe<THeMoveItemFilterInput>;
  aNavigation?: InputMaybe<THeOrderItemFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acTypeA?: InputMaybe<StringOperationFilterInput>;
  acTypeB?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anLnkNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anMoveItemQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anOrderItemQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeLinkMoveItemOrderItemFilterInput>>;
  or?: InputMaybe<Array<THeLinkMoveItemOrderItemFilterInput>>;
}

declare interface THeLinkMoveMove {
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeMove>;
  acLnkKey?: Maybe<Scalars['String']>;
  acLnkKeyNavigation?: Maybe<THeMove>;
  acType?: Maybe<Scalars['String']>;
  acTypeA?: Maybe<Scalars['String']>;
  acTypeB?: Maybe<Scalars['String']>;
  acValue?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anFieldNa: Scalars['Float'];
  anFieldNb: Scalars['Float'];
  anLnkNo: Scalars['Int'];
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserId?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THeLinkMoveMoveFilterInput {
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeMoveFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acLnkKeyNavigation?: InputMaybe<THeMoveFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acTypeA?: InputMaybe<StringOperationFilterInput>;
  acTypeB?: InputMaybe<StringOperationFilterInput>;
  acValue?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anLnkNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeLinkMoveMoveFilterInput>>;
  or?: InputMaybe<Array<THeLinkMoveMoveFilterInput>>;
}

declare interface THeMove {
  acContactPrsn?: Maybe<Scalars['String']>;
  acContactPrsn3?: Maybe<Scalars['String']>;
  acCostDrvOut?: Maybe<Scalars['String']>;
  acCostDrvOutNavigation?: Maybe<THeCostDrv>;
  acCurrency?: Maybe<Scalars['String']>;
  acDelivery?: Maybe<Scalars['String']>;
  acDeliveryNavigation?: Maybe<THeSetDelMet>;
  acDept?: Maybe<Scalars['String']>;
  acDeptNavigation?: Maybe<THeSetSubj>;
  acDeptOut?: Maybe<Scalars['String']>;
  acDeptOutNavigation?: Maybe<THeSetSubj>;
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acFieldSA?: Maybe<Scalars['String']>;
  acFieldSF?: Maybe<Scalars['String']>;
  acFieldSJ?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFiscStatus?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerNavigation?: Maybe<THeSetSubj>;
  acKey?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acNote2?: Maybe<Scalars['String']>;
  acParity?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPayMethodNavigation?: Maybe<THeSetPayMet>;
  acPosted?: Maybe<Scalars['String']>;
  acPrsn3?: Maybe<Scalars['String']>;
  acPrsn3Navigation?: Maybe<THeSetSubj>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverNavigation?: Maybe<THeSetSubj>;
  acVerifiedPrices?: Maybe<Scalars['String']>;
  acVerifyStatus?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  adDateDue?: Maybe<Scalars['DateTime']>;
  adDateTimePrint?: Maybe<Scalars['DateTime']>;
  adFieldDA?: Maybe<Scalars['DateTime']>;
  adFieldDb?: Maybe<Scalars['DateTime']>;
  adFieldDc?: Maybe<Scalars['DateTime']>;
  adFieldDd?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClerk?: Maybe<Scalars['Int']>;
  anClerkNavigation?: Maybe<THeSetSubjContact>;
  anDiscount: Scalars['Decimal'];
  anFieldNA?: Maybe<Scalars['Decimal']>;
  anFieldNB?: Maybe<Scalars['Decimal']>;
  anFieldNc?: Maybe<Scalars['Decimal']>;
  anFieldNd?: Maybe<Scalars['Decimal']>;
  anFieldNe?: Maybe<Scalars['Decimal']>;
  anFieldNf?: Maybe<Scalars['Decimal']>;
  anFieldNg?: Maybe<Scalars['Decimal']>;
  anFieldNh?: Maybe<Scalars['Decimal']>;
  anFieldNi?: Maybe<Scalars['Decimal']>;
  anFieldNj?: Maybe<Scalars['Decimal']>;
  anForPay: Scalars['Decimal'];
  anNoteClerk?: Maybe<Scalars['Int']>;
  anNoteClerkNavigation?: Maybe<THeSetSubjContact>;
  anQid: Scalars['Int'];
  anRebate: Scalars['Decimal'];
  anSigner1?: Maybe<Scalars['Int']>;
  anSigner2?: Maybe<Scalars['Int']>;
  anSigner3?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Decimal'];
  anVat: Scalars['Decimal'];
  eInvoiceStatus?: Maybe<EInvoiceDocumentStatusDto>;
  tHeLinkMoveMoveAcKeyNavigation?: Maybe<Array<Maybe<THeLinkMoveMove>>>;
  tHeLinkMoveMoveAcLnkKeyNavigation?: Maybe<Array<Maybe<THeLinkMoveMove>>>;
  tHeMoveFiscalisation?: Maybe<THeMoveFiscalisation>;
  tHeMoveItem?: Maybe<Array<Maybe<THeMoveItem>>>;
  tHeMoveItemExciseOuts?: Maybe<Array<Maybe<THeMoveItemExciseOut>>>;
  tHeMoveItemExcises?: Maybe<Array<Maybe<THeMoveItemExcise>>>;
  tHeMovePaymentRecords?: Maybe<Array<Maybe<THeMovePaymentRecord>>>;
  tHeMoveRmaworkSpecs?: Maybe<Array<Maybe<TrimTHeMoveRmaworkSpec>>>;
}

declare interface THeMoveDailyIncomeDto {
  anForPay: Scalars['Decimal'];
  payMethodName?: Maybe<Scalars['String']>;
}

declare interface THeMoveDailyIncomeSummaryDto {
  fromDate?: Maybe<Scalars['DateTime']>;
  fromDoc?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<THeMoveDailyIncomeDto>>>;
  toDate?: Maybe<Scalars['DateTime']>;
  toDoc?: Maybe<Scalars['Int']>;
}

declare interface THeMoveFilterInput {
  acContactPrsn?: InputMaybe<StringOperationFilterInput>;
  acContactPrsn3?: InputMaybe<StringOperationFilterInput>;
  acCostDrvOut?: InputMaybe<StringOperationFilterInput>;
  acCostDrvOutNavigation?: InputMaybe<THeCostDrvFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDelivery?: InputMaybe<StringOperationFilterInput>;
  acDeliveryNavigation?: InputMaybe<THeSetDelMetFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDeptNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acDeptOut?: InputMaybe<StringOperationFilterInput>;
  acDeptOutNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acDoc1?: InputMaybe<StringOperationFilterInput>;
  acDoc2?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acFieldSA?: InputMaybe<StringOperationFilterInput>;
  acFieldSF?: InputMaybe<StringOperationFilterInput>;
  acFieldSJ?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFiscStatus?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acNote2?: InputMaybe<StringOperationFilterInput>;
  acParity?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetFilterInput>;
  acPosted?: InputMaybe<StringOperationFilterInput>;
  acPrsn3?: InputMaybe<StringOperationFilterInput>;
  acPrsn3Navigation?: InputMaybe<THeSetSubjFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acVerifiedPrices?: InputMaybe<StringOperationFilterInput>;
  acVerifyStatus?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc1?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc2?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateTimePrint?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDA?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDb?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactFilterInput>;
  anDiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNA?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNB?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNd?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNe?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNf?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNh?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNi?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNj?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anForPay?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anNoteClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anNoteClerkNavigation?: InputMaybe<THeSetSubjContactFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anSigner1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<THeMoveFilterInput>>;
  or?: InputMaybe<Array<THeMoveFilterInput>>;
  tHeLinkMoveMoveAcKeyNavigation?: InputMaybe<ListFilterInputTypeOfTHeLinkMoveMoveFilterInput>;
  tHeLinkMoveMoveAcLnkKeyNavigation?: InputMaybe<ListFilterInputTypeOfTHeLinkMoveMoveFilterInput>;
  tHeMoveFiscalisation?: InputMaybe<THeMoveFiscalisationFilterInput>;
  tHeMoveItem?: InputMaybe<ListFilterInputTypeOfTHeMoveItemFilterInput>;
  tHeMoveItemExciseOuts?: InputMaybe<ListFilterInputTypeOfTHeMoveItemExciseOutFilterInput>;
  tHeMoveItemExcises?: InputMaybe<ListFilterInputTypeOfTHeMoveItemExciseFilterInput>;
  tHeMovePaymentRecords?: InputMaybe<ListFilterInputTypeOfTHeMovePaymentRecordFilterInput>;
  tHeMoveRmaworkSpecs?: InputMaybe<ListFilterInputTypeOfTrimTHeMoveRmaworkSpecFilterInput>;
}

declare interface THeMoveFiscalisation {
  acBarcode?: Maybe<Scalars['String']>;
  acCustomTemplate?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acError?: Maybe<Scalars['String']>;
  acFiscalDevice?: Maybe<Scalars['String']>;
  acJir?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeMove>;
  acWorkPlace?: Maybe<Scalars['String']>;
  acYearInv?: Maybe<Scalars['String']>;
  acZik?: Maybe<Scalars['String']>;
  adFiscalDate?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anFiscVersion: Scalars['Int'];
  anFiscalDevice: Scalars['Int'];
  anFiscalNumber: Scalars['Int'];
  anQid?: Maybe<Scalars['Int']>;
  anQidTemplate?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THeMoveFiscalisationFilterInput {
  acBarcode?: InputMaybe<StringOperationFilterInput>;
  acCustomTemplate?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acError?: InputMaybe<StringOperationFilterInput>;
  acFiscalDevice?: InputMaybe<StringOperationFilterInput>;
  acJir?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeMoveFilterInput>;
  acWorkPlace?: InputMaybe<StringOperationFilterInput>;
  acYearInv?: InputMaybe<StringOperationFilterInput>;
  acZik?: InputMaybe<StringOperationFilterInput>;
  adFiscalDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anFiscVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  anFiscalDevice?: InputMaybe<ComparableInt32OperationFilterInput>;
  anFiscalNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQidTemplate?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeMoveFiscalisationFilterInput>>;
  or?: InputMaybe<Array<THeMoveFiscalisationFilterInput>>;
}

declare interface THeMoveFiscalisationSortInput {
  acBarcode?: InputMaybe<SortEnumType>;
  acCustomTemplate?: InputMaybe<SortEnumType>;
  acDocType?: InputMaybe<SortEnumType>;
  acError?: InputMaybe<SortEnumType>;
  acFiscalDevice?: InputMaybe<SortEnumType>;
  acJir?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyNavigation?: InputMaybe<THeMoveSortInput>;
  acWorkPlace?: InputMaybe<SortEnumType>;
  acYearInv?: InputMaybe<SortEnumType>;
  acZik?: InputMaybe<SortEnumType>;
  adFiscalDate?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anFiscVersion?: InputMaybe<SortEnumType>;
  anFiscalDevice?: InputMaybe<SortEnumType>;
  anFiscalNumber?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQidTemplate?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeMoveItem {
  acCostDrv?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeMove>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acUM2?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  acVatcode?: Maybe<Scalars['String']>;
  acVatcodeNavigation?: Maybe<THeSetTax>;
  acVatcodeTr?: Maybe<Scalars['String']>;
  acVatcodeTrNavigation?: Maybe<THeSetTax>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDimWeight: Scalars['Float'];
  anExcise: Scalars['Float'];
  anExciseInc?: Maybe<Scalars['Float']>;
  anExciseIncP?: Maybe<Scalars['Float']>;
  anExciseNotInc?: Maybe<Scalars['Float']>;
  anExciseNotIncP?: Maybe<Scalars['Float']>;
  anExciseP: Scalars['Float'];
  anInRtprice: Scalars['Float'];
  anNo: Scalars['Int'];
  anPackQty: Scalars['Decimal'];
  anPrice: Scalars['Float'];
  anPriceCurrency: Scalars['Float'];
  anPvdiscount: Scalars['Decimal'];
  anPvexcise: Scalars['Decimal'];
  anPvforPay: Scalars['Decimal'];
  anPvocbeatShare: Scalars['Decimal'];
  anPvocbeatShareWoExc: Scalars['Decimal'];
  anPvocdirectCost: Scalars['Decimal'];
  anPvocdiscount: Scalars['Decimal'];
  anPvocduty: Scalars['Decimal'];
  anPvocexcise: Scalars['Decimal'];
  anPvocfixPriceDiff: Scalars['Decimal'];
  anPvocforPay: Scalars['Decimal'];
  anPvocforPayWoExc: Scalars['Decimal'];
  anPvocincVat: Scalars['Decimal'];
  anPvocincVatwoExc: Scalars['Decimal'];
  anPvocnonBeatShare: Scalars['Decimal'];
  anPvocnonBeatShareWoExc: Scalars['Decimal'];
  anPvocstockValue: Scalars['Decimal'];
  anPvocsuppExcise: Scalars['Decimal'];
  anPvocsuppExciseIncSv: Scalars['Decimal'];
  anPvocsuppExciseIncVb: Scalars['Decimal'];
  anPvocsuppExciseIncVbincSuppForPay?: Maybe<Scalars['Decimal']>;
  anPvocsuppExciseNonIncVb: Scalars['Decimal'];
  anPvocsuppExciseNonIncVbincSuppForPay?: Maybe<Scalars['Decimal']>;
  anPvoctransport: Scalars['Decimal'];
  anPvocvalue: Scalars['Decimal'];
  anPvocvat: Scalars['Decimal'];
  anPvocvatbase: Scalars['Decimal'];
  anPvocvatbaseWoExc: Scalars['Decimal'];
  anPvvalue?: Maybe<Scalars['Decimal']>;
  anPvvat: Scalars['Decimal'];
  anPvvatbase?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anQty: Scalars['Decimal'];
  anRebate: Scalars['Float'];
  anRebate1: Scalars['Float'];
  anRebate2: Scalars['Float'];
  anRebate3: Scalars['Float'];
  anRetailPrice: Scalars['Decimal'];
  anRtprice: Scalars['Float'];
  anUserIns?: Maybe<Scalars['Int']>;
  anVat: Scalars['Float'];
  anWarrenty: Scalars['Int'];
  tHeLinkMoveItemMoveItemANavigations?: Maybe<Array<Maybe<THeLinkMoveItemMoveItem>>>;
  tHeLinkMoveItemMoveItemAs?: Maybe<Array<Maybe<THeLinkMoveItemMoveItem>>>;
  tHeLinkMoveItemOrderItem?: Maybe<Array<Maybe<THeLinkMoveItemOrderItem>>>;
  tHeMoveItemExciseOut?: Maybe<THeMoveItemExciseOut>;
  tHeMoveItemSerialNo?: Maybe<Array<Maybe<THeMoveItemSerialNo>>>;
}

declare interface THeMoveItemExcise {
  acBaseType?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acInCalcRvc?: Maybe<Scalars['String']>;
  acIncBase?: Maybe<Scalars['String']>;
  acIncStockValue?: Maybe<Scalars['String']>;
  acIncSuppForPay?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeMove>;
  acSetOfTax?: Maybe<Scalars['String']>;
  acTransportCalcType?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anNo: Scalars['Int'];
  anNoCost: Scalars['Int'];
  anPvocvalue: Scalars['Decimal'];
  anPvvalue: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anQty?: Maybe<Scalars['Decimal']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Float'];
  anValuePercent: Scalars['Float'];
}

declare interface THeMoveItemExciseFilterInput {
  acBaseType?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acInCalcRvc?: InputMaybe<StringOperationFilterInput>;
  acIncBase?: InputMaybe<StringOperationFilterInput>;
  acIncStockValue?: InputMaybe<StringOperationFilterInput>;
  acIncSuppForPay?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeMoveFilterInput>;
  acSetOfTax?: InputMaybe<StringOperationFilterInput>;
  acTransportCalcType?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNoCost?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPvocvalue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvvalue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anValuePercent?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THeMoveItemExciseFilterInput>>;
  or?: InputMaybe<Array<THeMoveItemExciseFilterInput>>;
}

declare interface THeMoveItemExciseOut {
  acBaseType?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acInCalcRvc?: Maybe<Scalars['String']>;
  acIncBase?: Maybe<Scalars['String']>;
  acIncStockValue?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeMove>;
  acSetOfTax?: Maybe<Scalars['String']>;
  acSetOfTaxNavigation?: Maybe<THeSetDuty>;
  acTransportCalcType?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anNo: Scalars['Int'];
  anNoCost: Scalars['Int'];
  anPvocvalue: Scalars['Decimal'];
  anPvvalue: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anQty?: Maybe<Scalars['Decimal']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Float'];
  anValuePercent: Scalars['Float'];
  tHeMoveItemNavigation?: Maybe<THeMoveItem>;
}

declare interface THeMoveItemExciseOutFilterInput {
  acBaseType?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acInCalcRvc?: InputMaybe<StringOperationFilterInput>;
  acIncBase?: InputMaybe<StringOperationFilterInput>;
  acIncStockValue?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeMoveFilterInput>;
  acSetOfTax?: InputMaybe<StringOperationFilterInput>;
  acSetOfTaxNavigation?: InputMaybe<THeSetDutyFilterInput>;
  acTransportCalcType?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNoCost?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPvocvalue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvvalue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anValuePercent?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THeMoveItemExciseOutFilterInput>>;
  or?: InputMaybe<Array<THeMoveItemExciseOutFilterInput>>;
  tHeMoveItemNavigation?: InputMaybe<THeMoveItemFilterInput>;
}

declare interface THeMoveItemExciseOutSortInput {
  acBaseType?: InputMaybe<SortEnumType>;
  acCurrency?: InputMaybe<SortEnumType>;
  acInCalcRvc?: InputMaybe<SortEnumType>;
  acIncBase?: InputMaybe<SortEnumType>;
  acIncStockValue?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyNavigation?: InputMaybe<THeMoveSortInput>;
  acSetOfTax?: InputMaybe<SortEnumType>;
  acSetOfTaxNavigation?: InputMaybe<THeSetDutySortInput>;
  acTransportCalcType?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anNoCost?: InputMaybe<SortEnumType>;
  anPvocvalue?: InputMaybe<SortEnumType>;
  anPvvalue?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQty?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anValue?: InputMaybe<SortEnumType>;
  anValuePercent?: InputMaybe<SortEnumType>;
  tHeMoveItemNavigation?: InputMaybe<THeMoveItemSortInput>;
}

declare interface THeMoveItemFilterInput {
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeMoveFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acUM2?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  acVatcode?: InputMaybe<StringOperationFilterInput>;
  acVatcodeNavigation?: InputMaybe<THeSetTaxFilterInput>;
  acVatcodeTr?: InputMaybe<StringOperationFilterInput>;
  acVatcodeTrNavigation?: InputMaybe<THeSetTaxFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDimWeight?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExcise?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExciseInc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseIncP?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseNotInc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseNotIncP?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseP?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anInRtprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPackQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPriceCurrency?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPvdiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvexcise?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvforPay?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocbeatShare?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocbeatShareWoExc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocdirectCost?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocdiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocduty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocexcise?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocfixPriceDiff?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocforPay?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocforPayWoExc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocincVat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocincVatwoExc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocnonBeatShare?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocnonBeatShareWoExc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocstockValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocsuppExcise?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocsuppExciseIncSv?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocsuppExciseIncVb?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocsuppExciseIncVbincSuppForPay?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvocsuppExciseNonIncVb?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocsuppExciseNonIncVbincSuppForPay?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvoctransport?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocvalue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocvat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocvatbase?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocvatbaseWoExc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvvalue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvvat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvvatbase?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRebate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRebate1?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRebate2?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRebate3?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRetailPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRtprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anVat?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anWarrenty?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeMoveItemFilterInput>>;
  or?: InputMaybe<Array<THeMoveItemFilterInput>>;
  tHeLinkMoveItemMoveItemANavigations?: InputMaybe<ListFilterInputTypeOfTHeLinkMoveItemMoveItemFilterInput>;
  tHeLinkMoveItemMoveItemAs?: InputMaybe<ListFilterInputTypeOfTHeLinkMoveItemMoveItemFilterInput>;
  tHeLinkMoveItemOrderItem?: InputMaybe<ListFilterInputTypeOfTHeLinkMoveItemOrderItemFilterInput>;
  tHeMoveItemExciseOut?: InputMaybe<THeMoveItemExciseOutFilterInput>;
  tHeMoveItemSerialNo?: InputMaybe<ListFilterInputTypeOfTHeMoveItemSerialNoFilterInput>;
}

declare interface THeMoveItemSerialNo {
  a?: Maybe<THeMoveItem>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acKey?: Maybe<Scalars['String']>;
  acPackage?: Maybe<Scalars['String']>;
  acSerialNo?: Maybe<Scalars['String']>;
  acSnwotype?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adDateDue: Scalars['DateTime'];
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anNo: Scalars['Int'];
  anPackQty?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anQty: Scalars['Decimal'];
  anStockPrice?: Maybe<Scalars['Float']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THeMoveItemSerialNoFilterInput {
  a?: InputMaybe<THeMoveItemFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acPackage?: InputMaybe<StringOperationFilterInput>;
  acSerialNo?: InputMaybe<StringOperationFilterInput>;
  acSnwotype?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPackQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anStockPrice?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeMoveItemSerialNoFilterInput>>;
  or?: InputMaybe<Array<THeMoveItemSerialNoFilterInput>>;
}

declare interface THeMoveItemSortInput {
  acCostDrv?: InputMaybe<SortEnumType>;
  acIdent?: InputMaybe<SortEnumType>;
  acIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyNavigation?: InputMaybe<THeMoveSortInput>;
  acName?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acUM2?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  acVatcode?: InputMaybe<SortEnumType>;
  acVatcodeNavigation?: InputMaybe<THeSetTaxSortInput>;
  acVatcodeTr?: InputMaybe<SortEnumType>;
  acVatcodeTrNavigation?: InputMaybe<THeSetTaxSortInput>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anDimWeight?: InputMaybe<SortEnumType>;
  anExcise?: InputMaybe<SortEnumType>;
  anExciseInc?: InputMaybe<SortEnumType>;
  anExciseIncP?: InputMaybe<SortEnumType>;
  anExciseNotInc?: InputMaybe<SortEnumType>;
  anExciseNotIncP?: InputMaybe<SortEnumType>;
  anExciseP?: InputMaybe<SortEnumType>;
  anInRtprice?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anPackQty?: InputMaybe<SortEnumType>;
  anPrice?: InputMaybe<SortEnumType>;
  anPriceCurrency?: InputMaybe<SortEnumType>;
  anPvdiscount?: InputMaybe<SortEnumType>;
  anPvexcise?: InputMaybe<SortEnumType>;
  anPvforPay?: InputMaybe<SortEnumType>;
  anPvocbeatShare?: InputMaybe<SortEnumType>;
  anPvocbeatShareWoExc?: InputMaybe<SortEnumType>;
  anPvocdirectCost?: InputMaybe<SortEnumType>;
  anPvocdiscount?: InputMaybe<SortEnumType>;
  anPvocduty?: InputMaybe<SortEnumType>;
  anPvocexcise?: InputMaybe<SortEnumType>;
  anPvocfixPriceDiff?: InputMaybe<SortEnumType>;
  anPvocforPay?: InputMaybe<SortEnumType>;
  anPvocforPayWoExc?: InputMaybe<SortEnumType>;
  anPvocincVat?: InputMaybe<SortEnumType>;
  anPvocincVatwoExc?: InputMaybe<SortEnumType>;
  anPvocnonBeatShare?: InputMaybe<SortEnumType>;
  anPvocnonBeatShareWoExc?: InputMaybe<SortEnumType>;
  anPvocstockValue?: InputMaybe<SortEnumType>;
  anPvocsuppExcise?: InputMaybe<SortEnumType>;
  anPvocsuppExciseIncSv?: InputMaybe<SortEnumType>;
  anPvocsuppExciseIncVb?: InputMaybe<SortEnumType>;
  anPvocsuppExciseIncVbincSuppForPay?: InputMaybe<SortEnumType>;
  anPvocsuppExciseNonIncVb?: InputMaybe<SortEnumType>;
  anPvocsuppExciseNonIncVbincSuppForPay?: InputMaybe<SortEnumType>;
  anPvoctransport?: InputMaybe<SortEnumType>;
  anPvocvalue?: InputMaybe<SortEnumType>;
  anPvocvat?: InputMaybe<SortEnumType>;
  anPvocvatbase?: InputMaybe<SortEnumType>;
  anPvocvatbaseWoExc?: InputMaybe<SortEnumType>;
  anPvvalue?: InputMaybe<SortEnumType>;
  anPvvat?: InputMaybe<SortEnumType>;
  anPvvatbase?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQty?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anRebate1?: InputMaybe<SortEnumType>;
  anRebate2?: InputMaybe<SortEnumType>;
  anRebate3?: InputMaybe<SortEnumType>;
  anRetailPrice?: InputMaybe<SortEnumType>;
  anRtprice?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anVat?: InputMaybe<SortEnumType>;
  anWarrenty?: InputMaybe<SortEnumType>;
  tHeMoveItemExciseOut?: InputMaybe<THeMoveItemExciseOutSortInput>;
}

/** A connection to a list of items. */
declare interface THeMovePagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeMovePagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeMove>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeMovePagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeMove>;
}

/** A connection to a list of items. */
declare interface THeMovePagedParametrizedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeMovePagedParametrizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeMove>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** A connection to a list of items. */
declare interface THeMovePagedParametrizedDtoConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeMovePagedParametrizedDtoEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeMove>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeMovePagedParametrizedDtoEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeMove>;
}

declare interface THeMovePagedParametrizedDtoInput {
  acDelivery?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acDeptOut?: InputMaybe<Scalars['String']>;
  acDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acIssuer?: InputMaybe<Scalars['String']>;
  acKeys?: InputMaybe<Array<Scalars['String']>>;
  acPrsn3?: InputMaybe<Scalars['String']>;
  acReceiver?: InputMaybe<Scalars['String']>;
  acVerifiedPrices?: InputMaybe<Scalars['String']>;
  acVerifyStatus?: InputMaybe<Scalars['String']>;
  acWorker?: InputMaybe<Scalars['String']>;
  adFieldDAIsNotNull?: InputMaybe<Scalars['Boolean']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  anUserIns?: InputMaybe<Scalars['Int']>;
  filterByCurrentUserIdIsAnSigner1?: InputMaybe<Scalars['Boolean']>;
  filterMovesByThisAcIssuer?: InputMaybe<Scalars['String']>;
  filterMovesByThisAcReceiver?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  fromAcKey?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: InputMaybe<Scalars['Boolean']>;
  showOnlyWOWhereCurrentUserSpecExists?: InputMaybe<Scalars['Boolean']>;
  sortDescending?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<THeMovePagedSortField>;
  to?: InputMaybe<Scalars['DateTime']>;
  toAcKey?: InputMaybe<Scalars['String']>;
}

/** An edge in a connection. */
declare interface THeMovePagedParametrizedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeMove>;
}

declare type THeMovePagedSortField =
  | 'AC_CONTACT_PRSN'
  | 'AC_CONTACT_PRSN3'
  | 'AC_DELIVERY'
  | 'AC_DEPT'
  | 'AC_DEPT_OUT'
  | 'AC_DOC1'
  | 'AC_DOC2'
  | 'AC_DOC_TYPE'
  | 'AC_ISSUER'
  | 'AC_KEY'
  | 'AC_NOTE'
  | 'AC_PRSN3'
  | 'AC_RECEIVER'
  | 'AC_VERIFY_STATUS'
  | 'AD_DATE'
  | 'AD_DATE_DOC1'
  | 'AD_DATE_DOC2'
  | 'AN_CLERK';

declare interface THeMovePaymentRecord {
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  paymentResponse?: Maybe<Scalars['String']>;
  tHeMove?: Maybe<THeMove>;
  tHeMoveAcKey?: Maybe<Scalars['String']>;
}

declare interface THeMovePaymentRecordFilterInput {
  and?: InputMaybe<Array<THeMovePaymentRecordFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<THeMovePaymentRecordFilterInput>>;
  paymentResponse?: InputMaybe<StringOperationFilterInput>;
  tHeMove?: InputMaybe<THeMoveFilterInput>;
  tHeMoveAcKey?: InputMaybe<StringOperationFilterInput>;
}

declare interface THeMoveSortInput {
  acContactPrsn?: InputMaybe<SortEnumType>;
  acContactPrsn3?: InputMaybe<SortEnumType>;
  acCostDrvOut?: InputMaybe<SortEnumType>;
  acCostDrvOutNavigation?: InputMaybe<THeCostDrvSortInput>;
  acCurrency?: InputMaybe<SortEnumType>;
  acDelivery?: InputMaybe<SortEnumType>;
  acDeliveryNavigation?: InputMaybe<THeSetDelMetSortInput>;
  acDept?: InputMaybe<SortEnumType>;
  acDeptNavigation?: InputMaybe<THeSetSubjSortInput>;
  acDeptOut?: InputMaybe<SortEnumType>;
  acDeptOutNavigation?: InputMaybe<THeSetSubjSortInput>;
  acDoc1?: InputMaybe<SortEnumType>;
  acDoc2?: InputMaybe<SortEnumType>;
  acDocType?: InputMaybe<SortEnumType>;
  acFieldSA?: InputMaybe<SortEnumType>;
  acFieldSF?: InputMaybe<SortEnumType>;
  acFieldSJ?: InputMaybe<SortEnumType>;
  acFieldSb?: InputMaybe<SortEnumType>;
  acFieldSc?: InputMaybe<SortEnumType>;
  acFieldSd?: InputMaybe<SortEnumType>;
  acFieldSe?: InputMaybe<SortEnumType>;
  acFieldSg?: InputMaybe<SortEnumType>;
  acFieldSh?: InputMaybe<SortEnumType>;
  acFieldSi?: InputMaybe<SortEnumType>;
  acFiscStatus?: InputMaybe<SortEnumType>;
  acIssuer?: InputMaybe<SortEnumType>;
  acIssuerNavigation?: InputMaybe<THeSetSubjSortInput>;
  acKey?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acNote2?: InputMaybe<SortEnumType>;
  acParity?: InputMaybe<SortEnumType>;
  acPayMethod?: InputMaybe<SortEnumType>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetSortInput>;
  acPosted?: InputMaybe<SortEnumType>;
  acPrsn3?: InputMaybe<SortEnumType>;
  acPrsn3Navigation?: InputMaybe<THeSetSubjSortInput>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverNavigation?: InputMaybe<THeSetSubjSortInput>;
  acVerifiedPrices?: InputMaybe<SortEnumType>;
  acVerifyStatus?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adDateDoc1?: InputMaybe<SortEnumType>;
  adDateDoc2?: InputMaybe<SortEnumType>;
  adDateDue?: InputMaybe<SortEnumType>;
  adDateTimePrint?: InputMaybe<SortEnumType>;
  adFieldDA?: InputMaybe<SortEnumType>;
  adFieldDb?: InputMaybe<SortEnumType>;
  adFieldDc?: InputMaybe<SortEnumType>;
  adFieldDd?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactSortInput>;
  anDiscount?: InputMaybe<SortEnumType>;
  anFieldNA?: InputMaybe<SortEnumType>;
  anFieldNB?: InputMaybe<SortEnumType>;
  anFieldNc?: InputMaybe<SortEnumType>;
  anFieldNd?: InputMaybe<SortEnumType>;
  anFieldNe?: InputMaybe<SortEnumType>;
  anFieldNf?: InputMaybe<SortEnumType>;
  anFieldNg?: InputMaybe<SortEnumType>;
  anFieldNh?: InputMaybe<SortEnumType>;
  anFieldNi?: InputMaybe<SortEnumType>;
  anFieldNj?: InputMaybe<SortEnumType>;
  anForPay?: InputMaybe<SortEnumType>;
  anNoteClerk?: InputMaybe<SortEnumType>;
  anNoteClerkNavigation?: InputMaybe<THeSetSubjContactSortInput>;
  anQid?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anSigner1?: InputMaybe<SortEnumType>;
  anSigner2?: InputMaybe<SortEnumType>;
  anSigner3?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anValue?: InputMaybe<SortEnumType>;
  anVat?: InputMaybe<SortEnumType>;
  tHeMoveFiscalisation?: InputMaybe<THeMoveFiscalisationSortInput>;
}

declare interface THeOrder {
  acConsignee?: Maybe<Scalars['String']>;
  acConsigneeNavigation?: Maybe<THeSetSubj>;
  acContactPrsn?: Maybe<Scalars['String']>;
  acContactPrsn3?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acDelivery?: Maybe<Scalars['String']>;
  acDeliveryNavigation?: Maybe<THeSetDelMet>;
  acDept?: Maybe<Scalars['String']>;
  acDeptNavigation?: Maybe<THeSetSubj>;
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSf?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFieldSj?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acParity?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPayMethodNavigation?: Maybe<THeSetPayMet>;
  acPriceRate?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverNavigation?: Maybe<THeSetSubj>;
  acStatus?: Maybe<Scalars['String']>;
  acStatusNavigation?: Maybe<TPaSetDocTypeStat>;
  acWarehouse?: Maybe<Scalars['String']>;
  acWayOfSale?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  adDateValid?: Maybe<Scalars['DateTime']>;
  adDeliveryDate?: Maybe<Scalars['DateTime']>;
  adDeliveryDeadline?: Maybe<Scalars['DateTime']>;
  adFieldDa?: Maybe<Scalars['DateTime']>;
  adFieldDb?: Maybe<Scalars['DateTime']>;
  adFieldDc?: Maybe<Scalars['DateTime']>;
  adFieldDd?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClerk?: Maybe<Scalars['Int']>;
  anClerkNavigation?: Maybe<THeSetSubjContact>;
  anDaysForPayment: Scalars['Int'];
  anDaysForValid: Scalars['Int'];
  anDeliveryDays: Scalars['Int'];
  anDiscount: Scalars['Decimal'];
  anFieldNa?: Maybe<Scalars['Decimal']>;
  anFieldNb?: Maybe<Scalars['Decimal']>;
  anFieldNc?: Maybe<Scalars['Decimal']>;
  anFieldNd?: Maybe<Scalars['Decimal']>;
  anFieldNe?: Maybe<Scalars['Decimal']>;
  anFieldNf?: Maybe<Scalars['Decimal']>;
  anFieldNg?: Maybe<Scalars['Decimal']>;
  anFieldNh?: Maybe<Scalars['Decimal']>;
  anFieldNi?: Maybe<Scalars['Decimal']>;
  anFieldNj?: Maybe<Scalars['Decimal']>;
  anForPay: Scalars['Decimal'];
  anNoteClerk?: Maybe<Scalars['Int']>;
  anNoteClerkNavigation?: Maybe<THeSetSubjContact>;
  anRoundItem: Scalars['Decimal'];
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Decimal'];
  anVat: Scalars['Decimal'];
  tHeOrderItem?: Maybe<Array<Maybe<THeOrderItem>>>;
  warehouse?: Maybe<THeSetSubj>;
}


declare interface THeOrderTHeOrderItemArgs {
  order?: InputMaybe<Array<THeOrderItemSortInput>>;
}

declare interface THeOrderFilterInput {
  acConsignee?: InputMaybe<StringOperationFilterInput>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acContactPrsn?: InputMaybe<StringOperationFilterInput>;
  acContactPrsn3?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDelivery?: InputMaybe<StringOperationFilterInput>;
  acDeliveryNavigation?: InputMaybe<THeSetDelMetFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDeptNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acDoc1?: InputMaybe<StringOperationFilterInput>;
  acDoc2?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSf?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFieldSj?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acParity?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetFilterInput>;
  acPriceRate?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acStatusNavigation?: InputMaybe<TPaSetDocTypeStatFilterInput>;
  acWarehouse?: InputMaybe<StringOperationFilterInput>;
  acWayOfSale?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc1?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc2?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateValid?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDeliveryDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDeliveryDeadline?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDa?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDb?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactFilterInput>;
  anDaysForPayment?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDaysForValid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDeliveryDays?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNd?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNe?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNf?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNh?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNi?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNj?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anForPay?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anNoteClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anNoteClerkNavigation?: InputMaybe<THeSetSubjContactFilterInput>;
  anRoundItem?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<THeOrderFilterInput>>;
  or?: InputMaybe<Array<THeOrderFilterInput>>;
  tHeOrderItem?: InputMaybe<ListFilterInputTypeOfTHeOrderItemFilterInput>;
}

declare interface THeOrderItem {
  acCostDrv?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeOrder>;
  acLnkKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acOrigin?: Maybe<Scalars['String']>;
  acPriority?: Maybe<Scalars['String']>;
  acUM2?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  acUmconverted?: Maybe<Scalars['String']>;
  acVatcode?: Maybe<Scalars['String']>;
  adDeliveryDate?: Maybe<Scalars['DateTime']>;
  adDeliveryDeadline?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDimVolume: Scalars['Float'];
  anDimWeight: Scalars['Float'];
  anDimWeightBrutto: Scalars['Float'];
  anExcise: Scalars['Float'];
  anExciseInc?: Maybe<Scalars['Float']>;
  anExciseIncP?: Maybe<Scalars['Float']>;
  anExciseNotInc?: Maybe<Scalars['Float']>;
  anExciseNotIncP?: Maybe<Scalars['Float']>;
  anExciseP: Scalars['Float'];
  anLastprice?: Maybe<Scalars['Float']>;
  anLnkNo: Scalars['Int'];
  anNo: Scalars['Int'];
  anPackQty: Scalars['Decimal'];
  anPrice: Scalars['Float'];
  anPriceCurrency?: Maybe<Scalars['Decimal']>;
  anPvdiscount?: Maybe<Scalars['Decimal']>;
  anPvexcise?: Maybe<Scalars['Decimal']>;
  anPvforPay?: Maybe<Scalars['Decimal']>;
  anPvocdiscount?: Maybe<Scalars['Decimal']>;
  anPvocexcise?: Maybe<Scalars['Decimal']>;
  anPvocforPay?: Maybe<Scalars['Decimal']>;
  anPvocvalue?: Maybe<Scalars['Decimal']>;
  anPvocvat?: Maybe<Scalars['Decimal']>;
  anPvocvatbase?: Maybe<Scalars['Decimal']>;
  anPvvalue?: Maybe<Scalars['Decimal']>;
  anPvvat?: Maybe<Scalars['Decimal']>;
  anPvvatbase?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anQty: Scalars['Decimal'];
  anQtyConverted?: Maybe<Scalars['Decimal']>;
  anQtyDispDoc: Scalars['Decimal'];
  anRebate: Scalars['Float'];
  anRebate1: Scalars['Float'];
  anRebate2: Scalars['Float'];
  anRebate3: Scalars['Float'];
  anReserved: Scalars['Decimal'];
  anRetailPrice: Scalars['Decimal'];
  anRtprice?: Maybe<Scalars['Decimal']>;
  anSalePrice: Scalars['Decimal'];
  anUmdecPlaces?: Maybe<Scalars['Decimal']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anVariant: Scalars['Byte'];
  anVat: Scalars['Float'];
  tHeLinkMoveItemOrderItem?: Maybe<Array<Maybe<THeLinkMoveItemOrderItem>>>;
}

declare interface THeOrderItemFilterInput {
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeOrderFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acOrigin?: InputMaybe<StringOperationFilterInput>;
  acPriority?: InputMaybe<StringOperationFilterInput>;
  acUM2?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  acUmconverted?: InputMaybe<StringOperationFilterInput>;
  acVatcode?: InputMaybe<StringOperationFilterInput>;
  adDeliveryDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDeliveryDeadline?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDimVolume?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anDimWeight?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anDimWeightBrutto?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExcise?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExciseInc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseIncP?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseNotInc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseNotIncP?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseP?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anLastprice?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anLnkNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPackQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPriceCurrency?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvdiscount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvexcise?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvforPay?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvocdiscount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvocexcise?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvocforPay?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvocvalue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvocvat?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvocvatbase?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvvalue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvvat?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvvatbase?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQtyConverted?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQtyDispDoc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRebate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRebate1?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRebate2?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRebate3?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anReserved?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRetailPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRtprice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anSalePrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUmdecPlaces?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anVariant?: InputMaybe<ComparableByteOperationFilterInput>;
  anVat?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THeOrderItemFilterInput>>;
  or?: InputMaybe<Array<THeOrderItemFilterInput>>;
  tHeLinkMoveItemOrderItem?: InputMaybe<ListFilterInputTypeOfTHeLinkMoveItemOrderItemFilterInput>;
}

declare interface THeOrderItemSortInput {
  acCostDrv?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acIdent?: InputMaybe<SortEnumType>;
  acIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyNavigation?: InputMaybe<THeOrderSortInput>;
  acLnkKey?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acOrigin?: InputMaybe<SortEnumType>;
  acPriority?: InputMaybe<SortEnumType>;
  acUM2?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  acUmconverted?: InputMaybe<SortEnumType>;
  acVatcode?: InputMaybe<SortEnumType>;
  adDeliveryDate?: InputMaybe<SortEnumType>;
  adDeliveryDeadline?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anDimVolume?: InputMaybe<SortEnumType>;
  anDimWeight?: InputMaybe<SortEnumType>;
  anDimWeightBrutto?: InputMaybe<SortEnumType>;
  anExcise?: InputMaybe<SortEnumType>;
  anExciseInc?: InputMaybe<SortEnumType>;
  anExciseIncP?: InputMaybe<SortEnumType>;
  anExciseNotInc?: InputMaybe<SortEnumType>;
  anExciseNotIncP?: InputMaybe<SortEnumType>;
  anExciseP?: InputMaybe<SortEnumType>;
  anLastprice?: InputMaybe<SortEnumType>;
  anLnkNo?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anPackQty?: InputMaybe<SortEnumType>;
  anPrice?: InputMaybe<SortEnumType>;
  anPriceCurrency?: InputMaybe<SortEnumType>;
  anPvdiscount?: InputMaybe<SortEnumType>;
  anPvexcise?: InputMaybe<SortEnumType>;
  anPvforPay?: InputMaybe<SortEnumType>;
  anPvocdiscount?: InputMaybe<SortEnumType>;
  anPvocexcise?: InputMaybe<SortEnumType>;
  anPvocforPay?: InputMaybe<SortEnumType>;
  anPvocvalue?: InputMaybe<SortEnumType>;
  anPvocvat?: InputMaybe<SortEnumType>;
  anPvocvatbase?: InputMaybe<SortEnumType>;
  anPvvalue?: InputMaybe<SortEnumType>;
  anPvvat?: InputMaybe<SortEnumType>;
  anPvvatbase?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQty?: InputMaybe<SortEnumType>;
  anQtyConverted?: InputMaybe<SortEnumType>;
  anQtyDispDoc?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anRebate1?: InputMaybe<SortEnumType>;
  anRebate2?: InputMaybe<SortEnumType>;
  anRebate3?: InputMaybe<SortEnumType>;
  anReserved?: InputMaybe<SortEnumType>;
  anRetailPrice?: InputMaybe<SortEnumType>;
  anRtprice?: InputMaybe<SortEnumType>;
  anSalePrice?: InputMaybe<SortEnumType>;
  anUmdecPlaces?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anVariant?: InputMaybe<SortEnumType>;
  anVat?: InputMaybe<SortEnumType>;
}

/** A connection to a list of items. */
declare interface THeOrderPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeOrderPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeOrderPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeOrder>;
}

/** A connection to a list of items. */
declare interface THeOrderPagedParametrizedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeOrderPagedParametrizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** A connection to a list of items. */
declare interface THeOrderPagedParametrizedDtoConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeOrderPagedParametrizedDtoEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeOrderPagedParametrizedDtoEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeOrder>;
}

declare interface THeOrderPagedParametrizedDtoInput {
  acConsignee?: InputMaybe<Scalars['String']>;
  acDelivery?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acReceiver?: InputMaybe<Scalars['String']>;
  acStatus?: InputMaybe<Scalars['String']>;
  acStatusIn?: InputMaybe<Array<Scalars['String']>>;
  acStatusNotIn?: InputMaybe<Array<Scalars['String']>>;
  anClerk?: InputMaybe<Scalars['Int']>;
  filterOrdersByThisAcWarehouse?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  fromAcKey?: InputMaybe<Scalars['String']>;
  scannedModifierChar?: InputMaybe<Scalars['String']>;
  showAnClerkAndAnNoteClerkIsOROperation?: InputMaybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnClerkIs?: InputMaybe<Scalars['Int']>;
  showOnlyDocumentsWhereAnNoteClerkIs?: InputMaybe<Scalars['Int']>;
  sortDescending?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<THeOrderPagedSortField>;
  to?: InputMaybe<Scalars['DateTime']>;
  toAcKey?: InputMaybe<Scalars['String']>;
  useDeliveryDeadline?: InputMaybe<Scalars['Boolean']>;
}

/** An edge in a connection. */
declare interface THeOrderPagedParametrizedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeOrder>;
}

declare type THeOrderPagedSortField =
  | 'AC_CONSIGNEE'
  | 'AC_CONTACT_PRSN'
  | 'AC_CONTACT_PRSN3'
  | 'AC_DELIVERY'
  | 'AC_DEPT'
  | 'AC_DOC1'
  | 'AC_DOC2'
  | 'AC_DOC_TYPE'
  | 'AC_KEY'
  | 'AC_NOTE'
  | 'AC_STATUS'
  | 'AD_DATE'
  | 'AD_DATE_DOC1'
  | 'AD_DATE_DOC2'
  | 'AD_DATE_VALID'
  | 'AD_DELIVERY_DEADLINE'
  | 'AN_CLERK'
  | 'AN_DELIVERY_DAYS';

declare interface THeOrderSortInput {
  acConsignee?: InputMaybe<SortEnumType>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjSortInput>;
  acContactPrsn?: InputMaybe<SortEnumType>;
  acContactPrsn3?: InputMaybe<SortEnumType>;
  acCurrency?: InputMaybe<SortEnumType>;
  acDelivery?: InputMaybe<SortEnumType>;
  acDeliveryNavigation?: InputMaybe<THeSetDelMetSortInput>;
  acDept?: InputMaybe<SortEnumType>;
  acDeptNavigation?: InputMaybe<THeSetSubjSortInput>;
  acDoc1?: InputMaybe<SortEnumType>;
  acDoc2?: InputMaybe<SortEnumType>;
  acDocType?: InputMaybe<SortEnumType>;
  acFieldSa?: InputMaybe<SortEnumType>;
  acFieldSb?: InputMaybe<SortEnumType>;
  acFieldSc?: InputMaybe<SortEnumType>;
  acFieldSd?: InputMaybe<SortEnumType>;
  acFieldSe?: InputMaybe<SortEnumType>;
  acFieldSf?: InputMaybe<SortEnumType>;
  acFieldSg?: InputMaybe<SortEnumType>;
  acFieldSh?: InputMaybe<SortEnumType>;
  acFieldSi?: InputMaybe<SortEnumType>;
  acFieldSj?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acParity?: InputMaybe<SortEnumType>;
  acPayMethod?: InputMaybe<SortEnumType>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetSortInput>;
  acPriceRate?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverNavigation?: InputMaybe<THeSetSubjSortInput>;
  acStatus?: InputMaybe<SortEnumType>;
  acStatusNavigation?: InputMaybe<TPaSetDocTypeStatSortInput>;
  acWarehouse?: InputMaybe<SortEnumType>;
  acWayOfSale?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adDateDoc1?: InputMaybe<SortEnumType>;
  adDateDoc2?: InputMaybe<SortEnumType>;
  adDateValid?: InputMaybe<SortEnumType>;
  adDeliveryDate?: InputMaybe<SortEnumType>;
  adDeliveryDeadline?: InputMaybe<SortEnumType>;
  adFieldDa?: InputMaybe<SortEnumType>;
  adFieldDb?: InputMaybe<SortEnumType>;
  adFieldDc?: InputMaybe<SortEnumType>;
  adFieldDd?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactSortInput>;
  anDaysForPayment?: InputMaybe<SortEnumType>;
  anDaysForValid?: InputMaybe<SortEnumType>;
  anDeliveryDays?: InputMaybe<SortEnumType>;
  anDiscount?: InputMaybe<SortEnumType>;
  anFieldNa?: InputMaybe<SortEnumType>;
  anFieldNb?: InputMaybe<SortEnumType>;
  anFieldNc?: InputMaybe<SortEnumType>;
  anFieldNd?: InputMaybe<SortEnumType>;
  anFieldNe?: InputMaybe<SortEnumType>;
  anFieldNf?: InputMaybe<SortEnumType>;
  anFieldNg?: InputMaybe<SortEnumType>;
  anFieldNh?: InputMaybe<SortEnumType>;
  anFieldNi?: InputMaybe<SortEnumType>;
  anFieldNj?: InputMaybe<SortEnumType>;
  anForPay?: InputMaybe<SortEnumType>;
  anNoteClerk?: InputMaybe<SortEnumType>;
  anNoteClerkNavigation?: InputMaybe<THeSetSubjContactSortInput>;
  anRoundItem?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anValue?: InputMaybe<SortEnumType>;
  anVat?: InputMaybe<SortEnumType>;
}

declare interface THeSetCustTariff {
  acAcctEdchaInvoInCr?: Maybe<Scalars['String']>;
  acAcctEdchaInvoOutCr?: Maybe<Scalars['String']>;
  acAffilDept?: Maybe<Scalars['String']>;
  acCustTariff?: Maybe<Scalars['String']>;
  acDescr?: Maybe<Scalars['String']>;
  acDisabled?: Maybe<Scalars['String']>;
  acEeequipment?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acPreloman?: Maybe<Scalars['String']>;
  acSetOfTax?: Maybe<Scalars['String']>;
  acSetOfTaxNavigation?: Maybe<THeSetDuty>;
  acSuperiorCustTariff?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anExcisePercent: Scalars['Decimal'];
  anExciseValue: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anRate: Scalars['Decimal'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeSetCustTariffSaleExes?: Maybe<Array<Maybe<THeSetCustTariffSaleEx>>>;
  tHeSetItems?: Maybe<Array<Maybe<THeSetItem>>>;
}


declare interface THeSetCustTariffTHeSetCustTariffSaleExesArgs {
  order?: InputMaybe<Array<THeSetCustTariffSaleExSortInput>>;
  where?: InputMaybe<THeSetCustTariffSaleExFilterInput>;
}

declare interface THeSetCustTariffFilterInput {
  acAcctEdchaInvoInCr?: InputMaybe<StringOperationFilterInput>;
  acAcctEdchaInvoOutCr?: InputMaybe<StringOperationFilterInput>;
  acAffilDept?: InputMaybe<StringOperationFilterInput>;
  acCustTariff?: InputMaybe<StringOperationFilterInput>;
  acDescr?: InputMaybe<StringOperationFilterInput>;
  acDisabled?: InputMaybe<StringOperationFilterInput>;
  acEeequipment?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acPreloman?: InputMaybe<StringOperationFilterInput>;
  acSetOfTax?: InputMaybe<StringOperationFilterInput>;
  acSetOfTaxNavigation?: InputMaybe<THeSetDutyFilterInput>;
  acSuperiorCustTariff?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anExcisePercent?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anExciseValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anRate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetCustTariffFilterInput>>;
  or?: InputMaybe<Array<THeSetCustTariffFilterInput>>;
  tHeSetCustTariffSaleExes?: InputMaybe<ListFilterInputTypeOfTHeSetCustTariffSaleExFilterInput>;
  tHeSetItems?: InputMaybe<ListFilterInputTypeOfTHeSetItemFilterInput>;
}

declare interface THeSetCustTariffSaleEx {
  acAcctEdchaInvoInCr?: Maybe<Scalars['String']>;
  acAcctEdchaInvoOutCr?: Maybe<Scalars['String']>;
  acBaseType?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acCustTariff?: Maybe<Scalars['String']>;
  acCustTariffNavigation?: Maybe<THeSetCustTariff>;
  acSetOfTax?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  adDate: Scalars['DateTime'];
  adDateTo?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anExcisePercent: Scalars['Decimal'];
  anExciseValue: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anQty: Scalars['Decimal'];
  anRate?: Maybe<Scalars['Decimal']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THeSetCustTariffSaleExFilterInput {
  acAcctEdchaInvoInCr?: InputMaybe<StringOperationFilterInput>;
  acAcctEdchaInvoOutCr?: InputMaybe<StringOperationFilterInput>;
  acBaseType?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acCustTariff?: InputMaybe<StringOperationFilterInput>;
  acCustTariffNavigation?: InputMaybe<THeSetCustTariffFilterInput>;
  acSetOfTax?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adDateTo?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anExcisePercent?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anExciseValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetCustTariffSaleExFilterInput>>;
  or?: InputMaybe<Array<THeSetCustTariffSaleExFilterInput>>;
}

declare interface THeSetCustTariffSaleExSortInput {
  acAcctEdchaInvoInCr?: InputMaybe<SortEnumType>;
  acAcctEdchaInvoOutCr?: InputMaybe<SortEnumType>;
  acBaseType?: InputMaybe<SortEnumType>;
  acCurrency?: InputMaybe<SortEnumType>;
  acCustTariff?: InputMaybe<SortEnumType>;
  acCustTariffNavigation?: InputMaybe<THeSetCustTariffSortInput>;
  acSetOfTax?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adDateTo?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anExcisePercent?: InputMaybe<SortEnumType>;
  anExciseValue?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQty?: InputMaybe<SortEnumType>;
  anRate?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeSetCustTariffSortInput {
  acAcctEdchaInvoInCr?: InputMaybe<SortEnumType>;
  acAcctEdchaInvoOutCr?: InputMaybe<SortEnumType>;
  acAffilDept?: InputMaybe<SortEnumType>;
  acCustTariff?: InputMaybe<SortEnumType>;
  acDescr?: InputMaybe<SortEnumType>;
  acDisabled?: InputMaybe<SortEnumType>;
  acEeequipment?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acPreloman?: InputMaybe<SortEnumType>;
  acSetOfTax?: InputMaybe<SortEnumType>;
  acSetOfTaxNavigation?: InputMaybe<THeSetDutySortInput>;
  acSuperiorCustTariff?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anExcisePercent?: InputMaybe<SortEnumType>;
  anExciseValue?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anRate?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeSetDelMet {
  acActive?: Maybe<Scalars['String']>;
  acAtactive?: Maybe<Scalars['String']>;
  acDelivery?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acTransport?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeMove?: Maybe<Array<Maybe<THeMove>>>;
  tHeOrder?: Maybe<Array<Maybe<THeOrder>>>;
}

declare interface THeSetDelMetFilterInput {
  acActive?: InputMaybe<StringOperationFilterInput>;
  acAtactive?: InputMaybe<StringOperationFilterInput>;
  acDelivery?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acTransport?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetDelMetFilterInput>>;
  or?: InputMaybe<Array<THeSetDelMetFilterInput>>;
  tHeMove?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeOrder?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
}

declare interface THeSetDelMetSortInput {
  acActive?: InputMaybe<SortEnumType>;
  acAtactive?: InputMaybe<SortEnumType>;
  acDelivery?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acTransport?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeSetDocText {
  acActive?: Maybe<Scalars['String']>;
  acDesc?: Maybe<Scalars['String']>;
  acEdocument?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acStatement?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeSetTaxes?: Maybe<Array<Maybe<THeSetTax>>>;
}

declare interface THeSetDocTextFilterInput {
  acActive?: InputMaybe<StringOperationFilterInput>;
  acDesc?: InputMaybe<StringOperationFilterInput>;
  acEdocument?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acStatement?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetDocTextFilterInput>>;
  or?: InputMaybe<Array<THeSetDocTextFilterInput>>;
  tHeSetTaxes?: InputMaybe<ListFilterInputTypeOfTHeSetTaxFilterInput>;
}

declare interface THeSetDocTextSortInput {
  acActive?: InputMaybe<SortEnumType>;
  acDesc?: InputMaybe<SortEnumType>;
  acEdocument?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acStatement?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeSetDuty {
  acDutyType?: Maybe<Scalars['String']>;
  acHrdeposit?: Maybe<Scalars['String']>;
  acHrspendTax?: Maybe<Scalars['String']>;
  acHrsubType?: Maybe<Scalars['String']>;
  acInCalcRvc?: Maybe<Scalars['String']>;
  acIncBase?: Maybe<Scalars['String']>;
  acIncStockValue?: Maybe<Scalars['String']>;
  acIncSuppForPay?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acSetOfTax?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeMoveItemExciseOuts?: Maybe<Array<Maybe<THeMoveItemExciseOut>>>;
  tHeSetCustTariffs?: Maybe<Array<Maybe<THeSetCustTariff>>>;
  tHeSetItemExcise?: Maybe<Array<Maybe<THeSetItemExcise>>>;
}

declare interface THeSetDutyFilterInput {
  acDutyType?: InputMaybe<StringOperationFilterInput>;
  acHrdeposit?: InputMaybe<StringOperationFilterInput>;
  acHrspendTax?: InputMaybe<StringOperationFilterInput>;
  acHrsubType?: InputMaybe<StringOperationFilterInput>;
  acInCalcRvc?: InputMaybe<StringOperationFilterInput>;
  acIncBase?: InputMaybe<StringOperationFilterInput>;
  acIncStockValue?: InputMaybe<StringOperationFilterInput>;
  acIncSuppForPay?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acSetOfTax?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetDutyFilterInput>>;
  or?: InputMaybe<Array<THeSetDutyFilterInput>>;
  tHeMoveItemExciseOuts?: InputMaybe<ListFilterInputTypeOfTHeMoveItemExciseOutFilterInput>;
  tHeSetCustTariffs?: InputMaybe<ListFilterInputTypeOfTHeSetCustTariffFilterInput>;
  tHeSetItemExcise?: InputMaybe<ListFilterInputTypeOfTHeSetItemExciseFilterInput>;
}

declare interface THeSetDutySortInput {
  acDutyType?: InputMaybe<SortEnumType>;
  acHrdeposit?: InputMaybe<SortEnumType>;
  acHrspendTax?: InputMaybe<SortEnumType>;
  acHrsubType?: InputMaybe<SortEnumType>;
  acInCalcRvc?: InputMaybe<SortEnumType>;
  acIncBase?: InputMaybe<SortEnumType>;
  acIncStockValue?: InputMaybe<SortEnumType>;
  acIncSuppForPay?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acSetOfTax?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeSetItem {
  abIcon?: Maybe<Array<Scalars['Byte']>>;
  acAcct?: Maybe<Scalars['String']>;
  acAcctBuyVasale?: Maybe<Scalars['String']>;
  acAcctIncome?: Maybe<Scalars['String']>;
  acAcctNotTaxDeduct?: Maybe<Scalars['String']>;
  acActive?: Maybe<Scalars['String']>;
  acBackPacking?: Maybe<Scalars['String']>;
  acBst?: Maybe<Scalars['String']>;
  acBullId?: Maybe<Scalars['String']>;
  acClassProdByAct?: Maybe<Scalars['String']>;
  acClassif?: Maybe<Scalars['String']>;
  acClassif2?: Maybe<Scalars['String']>;
  acClassifNavigation?: Maybe<THeSetItemCateg>;
  acCode?: Maybe<Scalars['String']>;
  acColumn?: Maybe<Scalars['String']>;
  acColumnNavigation?: Maybe<THeSetItemSnt>;
  acCostDrv?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acCustTariff?: Maybe<Scalars['String']>;
  acCustTariffNavigation?: Maybe<THeSetCustTariff>;
  acDateDue?: Maybe<Scalars['String']>;
  acDeclarForOrigin?: Maybe<Scalars['String']>;
  acDeclarForOriginType?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDescr?: Maybe<Scalars['String']>;
  acDocTypeIssue?: Maybe<Scalars['String']>;
  acDocTypeOrdSupp?: Maybe<Scalars['String']>;
  acDocTypeProd?: Maybe<Scalars['String']>;
  acDroe?: Maybe<Scalars['String']>;
  acDroesubject?: Maybe<Scalars['String']>;
  acEnableChgPrSt?: Maybe<Scalars['String']>;
  acEnvrmntCost?: Maybe<Scalars['String']>;
  acEvidence?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSf?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFieldSj?: Maybe<Scalars['String']>;
  acFieldsA?: Maybe<Scalars['String']>;
  acFormula?: Maybe<Scalars['String']>;
  acFormulaRt?: Maybe<Scalars['String']>;
  acHttppath?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acInFlowOutFlow?: Maybe<Scalars['String']>;
  acIsReturnPack?: Maybe<Scalars['String']>;
  acMakeCalc?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acOrderTransInMf?: Maybe<Scalars['String']>;
  acOrigin?: Maybe<Scalars['String']>;
  acPackSlopak?: Maybe<Scalars['String']>;
  acPackSlopaktype?: Maybe<Scalars['String']>;
  acPackagingType?: Maybe<Scalars['String']>;
  acPacking?: Maybe<Scalars['String']>;
  acPicture?: Maybe<Array<Scalars['Byte']>>;
  acPosprinterId?: Maybe<Scalars['String']>;
  acPrstPrice?: Maybe<Scalars['String']>;
  acPrstUmtime?: Maybe<Scalars['String']>;
  acPurchCurr?: Maybe<Scalars['String']>;
  acQtyInCode?: Maybe<Scalars['String']>;
  acQtyNotToKol?: Maybe<Scalars['String']>;
  acReportDeclar?: Maybe<Scalars['String']>;
  acSerialNo?: Maybe<Scalars['String']>;
  acSerialnoDueType?: Maybe<Scalars['String']>;
  acSetOfItem?: Maybe<Scalars['String']>;
  acSetOfItemNavigation?: Maybe<THeSetItemType>;
  acShowAtena?: Maybe<Scalars['String']>;
  acStandardize?: Maybe<Scalars['String']>;
  acSupplier?: Maybe<Scalars['String']>;
  acTechProcedure?: Maybe<Scalars['String']>;
  acTransferredWs?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  acUm2?: Maybe<Scalars['String']>;
  acUm2Navigation?: Maybe<THeSetUm>;
  acUm3?: Maybe<Scalars['String']>;
  acUmNavigation?: Maybe<THeSetUm>;
  acUmdim1?: Maybe<Scalars['String']>;
  acUmdim2?: Maybe<Scalars['String']>;
  acUmmarkLabel?: Maybe<Scalars['String']>;
  acUmseries?: Maybe<Scalars['String']>;
  acUsedTyre?: Maybe<Scalars['String']>;
  acVatCodeNavigation?: Maybe<THeSetTax>;
  acVatcode?: Maybe<Scalars['String']>;
  acVatcodeLow?: Maybe<Scalars['String']>;
  acVatcodeReceive?: Maybe<Scalars['String']>;
  acVehiclePart?: Maybe<Scalars['String']>;
  acWastePack?: Maybe<Scalars['String']>;
  acWeighableItem?: Maybe<Scalars['String']>;
  acWstEeequip?: Maybe<Scalars['String']>;
  adDiscountBegin?: Maybe<Scalars['DateTime']>;
  adDiscountEnd?: Maybe<Scalars['DateTime']>;
  adFieldDa?: Maybe<Scalars['DateTime']>;
  adFieldDb?: Maybe<Scalars['DateTime']>;
  adFieldDc?: Maybe<Scalars['DateTime']>;
  adFieldDd?: Maybe<Scalars['DateTime']>;
  adPrStCheckTime?: Maybe<Scalars['DateTime']>;
  adPrStInsertTime?: Maybe<Scalars['DateTime']>;
  adPrStUpdateTime?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anAllowedInvShort: Scalars['Decimal'];
  anAllowedWastage?: Maybe<Scalars['Decimal']>;
  anBeatShare: Scalars['Float'];
  anBuyPrice: Scalars['Float'];
  anBuyRebate2?: Maybe<Scalars['Float']>;
  anBuyRebate3?: Maybe<Scalars['Float']>;
  anColorCode?: Maybe<Scalars['Int']>;
  anDeliveryDeadline: Scalars['Int'];
  anDimDepth: Scalars['Decimal'];
  anDimHeight: Scalars['Decimal'];
  anDimWeight: Scalars['Decimal'];
  anDimWeightBrutto: Scalars['Decimal'];
  anDimWidth: Scalars['Decimal'];
  anDirectCost: Scalars['Float'];
  anDiscount: Scalars['Decimal'];
  anDiscountPrice: Scalars['Decimal'];
  anDiscountPriceRt: Scalars['Decimal'];
  anDuty: Scalars['Float'];
  anExcise: Scalars['Float'];
  anExciseP: Scalars['Float'];
  anFieldNa: Scalars['Decimal'];
  anFieldNb: Scalars['Decimal'];
  anFieldNc: Scalars['Decimal'];
  anFieldNd: Scalars['Decimal'];
  anFieldNe: Scalars['Decimal'];
  anFieldNf: Scalars['Decimal'];
  anFieldNg: Scalars['Decimal'];
  anFieldNh: Scalars['Decimal'];
  anFieldNi: Scalars['Decimal'];
  anFieldNj: Scalars['Decimal'];
  anFixPriceDiff: Scalars['Float'];
  anIncTax: Scalars['Float'];
  anMaxRebate: Scalars['Decimal'];
  anMaxStock: Scalars['Decimal'];
  anMinMargin: Scalars['Decimal'];
  anMinStock: Scalars['Decimal'];
  anMonthDue?: Maybe<Scalars['Int']>;
  anOptStock: Scalars['Decimal'];
  anOrderMinQty: Scalars['Decimal'];
  anOrderOptQty: Scalars['Decimal'];
  anPackWasteWeight?: Maybe<Scalars['Decimal']>;
  anPackWeight?: Maybe<Scalars['Decimal']>;
  anPlucode?: Maybe<Scalars['Int']>;
  anPlucode2?: Maybe<Scalars['Long']>;
  anPosQtyStep?: Maybe<Scalars['Decimal']>;
  anPosqty: Scalars['Decimal'];
  anPrStCheckUserId?: Maybe<Scalars['Int']>;
  anPrStDailyQty: Scalars['Decimal'];
  anPrStInsertUserId?: Maybe<Scalars['Int']>;
  anPrStOptimalQty: Scalars['Decimal'];
  anPrStPrice: Scalars['Float'];
  anPrStPriceP: Scalars['Float'];
  anPrStUpdateUserId?: Maybe<Scalars['Int']>;
  anPrStVariantValid: Scalars['Byte'];
  anPrice: Scalars['Float'];
  anPriceSupp: Scalars['Float'];
  anProdPrice?: Maybe<Scalars['Float']>;
  anPrstTime?: Maybe<Scalars['Float']>;
  anPurExciseA: Scalars['Float'];
  anPurExciseE: Scalars['Float'];
  anPurExciseT: Scalars['Float'];
  anQid: Scalars['Int'];
  anQtyInCodeDecPlace: Scalars['Int'];
  anQtyMarkLabel?: Maybe<Scalars['Decimal']>;
  anQtySeries: Scalars['Decimal'];
  anRebate: Scalars['Float'];
  anRtPrice: Scalars['Float'];
  anRtprice: Scalars['Float'];
  anRtpriceP: Scalars['Float'];
  anSalePrice: Scalars['Decimal'];
  anSaleRebate2?: Maybe<Scalars['Float']>;
  anSaleRebate3?: Maybe<Scalars['Float']>;
  anSubClassif: Scalars['Float'];
  anTransport: Scalars['Float'];
  anUmtoDeclarReport: Scalars['Decimal'];
  anUmtoUm2: Scalars['Decimal'];
  anUmtoUm3: Scalars['Decimal'];
  anUnionDeadline: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anVat: Scalars['Decimal'];
  anVatreceive: Scalars['Decimal'];
  anWarrenty: Scalars['Int'];
  anWasteQty: Scalars['Decimal'];
  anWsprice: Scalars['Float'];
  anWsprice2: Scalars['Float'];
  anWsprice2P: Scalars['Float'];
  anWspriceP: Scalars['Float'];
  pHE_SearchContrctPrice?: Maybe<PHe_SearchContrctPriceDto>;
  tHeMoveItem?: Maybe<Array<Maybe<THeMoveItem>>>;
  tHeMoveItemSerialNo?: Maybe<Array<Maybe<THeMoveItemSerialNo>>>;
  tHeOrderItem?: Maybe<Array<Maybe<THeOrderItem>>>;
  tHeSetItemExcises?: Maybe<Array<Maybe<THeSetItemExcise>>>;
  tHeSetItemExtItemSubj?: Maybe<Array<Maybe<THeSetItemExtItemSubj>>>;
  tHeSetItemPriceForWrh?: Maybe<Array<Maybe<THeSetItemPriceForWrh>>>;
  tHeSetSubjPriceItem?: Maybe<Array<Maybe<THeSetSubjPriceItem>>>;
  tHeStock?: Maybe<Array<Maybe<THeStock>>>;
  tHeStockSerialNos?: Maybe<Array<Maybe<THeStockSerialNo>>>;
  tHfWoexAcIdentNavigations?: Maybe<Array<Maybe<THfWoex>>>;
  tHfWoexAcLnkPrStIdentParentNavigations?: Maybe<Array<Maybe<THfWoex>>>;
  tHfWoexAcScrapIdentNavigations?: Maybe<Array<Maybe<THfWoex>>>;
  tHfWoexItemAcIdentNavigations?: Maybe<Array<Maybe<THfWoexItem>>>;
  tHfWoexItemAcScrapIdentNavigations?: Maybe<Array<Maybe<THfWoexItem>>>;
  tHfWoexItemSerialNos?: Maybe<Array<Maybe<THfWoexItemSerialNo>>>;
}


declare interface THeSetItemAcClassifNavigationArgs {
  where?: InputMaybe<THeSetItemCategFilterInput>;
}


declare interface THeSetItemPHe_SearchContrctPriceArgs {
  classif2: Scalars['Boolean'];
  date: Scalars['DateTime'];
  priceList?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
}


declare interface THeSetItemTHeMoveItemArgs {
  order?: InputMaybe<Array<THeMoveItemSortInput>>;
  where?: InputMaybe<THeMoveItemFilterInput>;
}


declare interface THeSetItemTHeOrderItemArgs {
  order?: InputMaybe<Array<THeOrderItemSortInput>>;
  where?: InputMaybe<THeOrderItemFilterInput>;
}


declare interface THeSetItemTHeSetItemExtItemSubjArgs {
  where?: InputMaybe<THeSetItemExtItemSubjFilterInput>;
}


declare interface THeSetItemTHeSetItemPriceForWrhArgs {
  where?: InputMaybe<THeSetItemPriceForWrhFilterInput>;
}


declare interface THeSetItemTHeSetSubjPriceItemArgs {
  order?: InputMaybe<Array<THeSetSubjPriceItemSortInput>>;
  where?: InputMaybe<THeSetSubjPriceItemFilterInput>;
}


declare interface THeSetItemTHeStockArgs {
  where?: InputMaybe<THeStockFilterInput>;
}


declare interface THeSetItemTHeStockSerialNosArgs {
  where?: InputMaybe<THeStockSerialNoFilterInput>;
}

declare interface THeSetItemCateg {
  abIcon?: Maybe<Array<Scalars['Byte']>>;
  acAcct?: Maybe<Scalars['String']>;
  acAcctIncome?: Maybe<Scalars['String']>;
  acActive?: Maybe<Scalars['String']>;
  acAtdescPos?: Maybe<Scalars['String']>;
  acAtorder?: Maybe<Scalars['String']>;
  acClassFillMethod?: Maybe<Scalars['String']>;
  acClassif?: Maybe<Scalars['String']>;
  acColumn?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acCustTariff?: Maybe<Scalars['String']>;
  acDescr?: Maybe<Scalars['String']>;
  acDroe?: Maybe<Scalars['String']>;
  acDroesubject?: Maybe<Scalars['String']>;
  acEnvrmntCost?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSf?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFieldSj?: Maybe<Scalars['String']>;
  acFormula?: Maybe<Scalars['String']>;
  acMakeCalc?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acPackSlopak?: Maybe<Scalars['String']>;
  acPackSlopaktype?: Maybe<Scalars['String']>;
  acPacking?: Maybe<Scalars['String']>;
  acPicture?: Maybe<Array<Scalars['Byte']>>;
  acPosprinterId?: Maybe<Scalars['String']>;
  acPrStC1?: Maybe<Scalars['String']>;
  acPrStC2?: Maybe<Scalars['String']>;
  acPrStC3?: Maybe<Scalars['String']>;
  acPrStC4?: Maybe<Scalars['String']>;
  acPrStC8?: Maybe<Scalars['String']>;
  acPrStMatQtyFormula?: Maybe<Scalars['String']>;
  acPrStMatScrapIdent?: Maybe<Scalars['String']>;
  acPrStMatUm?: Maybe<Scalars['String']>;
  acPrStOprDelayType?: Maybe<Scalars['String']>;
  acPrStOprEtadditive?: Maybe<Scalars['String']>;
  acPrStOprIncomeGrp?: Maybe<Scalars['String']>;
  acPrStOprOperationType?: Maybe<Scalars['String']>;
  acPrStOprQtyFormula?: Maybe<Scalars['String']>;
  acPrStOprResursId?: Maybe<Scalars['String']>;
  acPrStOprRuleId?: Maybe<Scalars['String']>;
  acPrStOprUm?: Maybe<Scalars['String']>;
  acPrStOprUm3?: Maybe<Scalars['String']>;
  acPrStOprUmtime?: Maybe<Scalars['String']>;
  acPriceCalcMethod?: Maybe<Scalars['String']>;
  acPurchCurr?: Maybe<Scalars['String']>;
  acQtyNotToKol?: Maybe<Scalars['String']>;
  acRbuyRebate2?: Maybe<Scalars['String']>;
  acRbuyRebate3?: Maybe<Scalars['String']>;
  acRduty?: Maybe<Scalars['String']>;
  acRnepstr?: Maybe<Scalars['String']>;
  acRprStPrice?: Maybe<Scalars['String']>;
  acRprStPriceP?: Maybe<Scalars['String']>;
  acRrebate?: Maybe<Scalars['String']>;
  acRrtprice?: Maybe<Scalars['String']>;
  acRrtpriceP?: Maybe<Scalars['String']>;
  acRsaleRebate2?: Maybe<Scalars['String']>;
  acRsaleRebate3?: Maybe<Scalars['String']>;
  acRtransport?: Maybe<Scalars['String']>;
  acRvrdavek?: Maybe<Scalars['String']>;
  acRwsprice?: Maybe<Scalars['String']>;
  acRwsprice2?: Maybe<Scalars['String']>;
  acRwsprice2P?: Maybe<Scalars['String']>;
  acRwspriceP?: Maybe<Scalars['String']>;
  acSerialNo?: Maybe<Scalars['String']>;
  acSetOfItem?: Maybe<Scalars['String']>;
  acShowAtena?: Maybe<Scalars['String']>;
  acShowAtenaDesc?: Maybe<Scalars['String']>;
  acSuprClassif?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  acUm2?: Maybe<Scalars['String']>;
  acUmdim1?: Maybe<Scalars['String']>;
  acUmdim2?: Maybe<Scalars['String']>;
  acUmmarkLabel?: Maybe<Scalars['String']>;
  acVatcode?: Maybe<Scalars['String']>;
  acVatcodeLow?: Maybe<Scalars['String']>;
  acWayBillDescr?: Maybe<Scalars['String']>;
  adDiscountBegin?: Maybe<Scalars['DateTime']>;
  adDiscountEnd?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anAllowedInvShort: Scalars['Decimal'];
  anBeatShare: Scalars['Float'];
  anBuyRebate2?: Maybe<Scalars['Decimal']>;
  anBuyRebate3?: Maybe<Scalars['Decimal']>;
  anColorCode?: Maybe<Scalars['Int']>;
  anDeliveryDeadline: Scalars['Int'];
  anDimDepth: Scalars['Decimal'];
  anDimHeight: Scalars['Decimal'];
  anDimWeight: Scalars['Decimal'];
  anDimWeightBrutto: Scalars['Decimal'];
  anDimWidth: Scalars['Decimal'];
  anDirectCost: Scalars['Decimal'];
  anDiscount: Scalars['Decimal'];
  anDuty: Scalars['Decimal'];
  anFieldNa: Scalars['Decimal'];
  anFieldNb: Scalars['Decimal'];
  anFieldNc: Scalars['Decimal'];
  anFieldNd: Scalars['Decimal'];
  anFieldNe: Scalars['Decimal'];
  anFieldNf: Scalars['Decimal'];
  anFieldNg: Scalars['Decimal'];
  anFieldNh: Scalars['Decimal'];
  anFieldNi: Scalars['Decimal'];
  anFieldNj: Scalars['Decimal'];
  anIncTax: Scalars['Decimal'];
  anMaxRebate: Scalars['Decimal'];
  anMaxRebatePos: Scalars['Decimal'];
  anMaxstock: Scalars['Decimal'];
  anMinMargin: Scalars['Decimal'];
  anMinMarginCateg: Scalars['Decimal'];
  anMinstock: Scalars['Decimal'];
  anOptStock: Scalars['Decimal'];
  anPosqty: Scalars['Decimal'];
  anPrStC5?: Maybe<Scalars['Float']>;
  anPrStC6?: Maybe<Scalars['Float']>;
  anPrStC7?: Maybe<Scalars['Float']>;
  anPrStMatBatch?: Maybe<Scalars['Float']>;
  anPrStMatQty1?: Maybe<Scalars['Float']>;
  anPrStMatQtyBase?: Maybe<Scalars['Int']>;
  anPrStMatScrapPrc?: Maybe<Scalars['Float']>;
  anPrStMatScrapQty?: Maybe<Scalars['Float']>;
  anPrStMatVariantSubLvl?: Maybe<Scalars['Byte']>;
  anPrStMatWastePrc?: Maybe<Scalars['Float']>;
  anPrStMatWasteQty?: Maybe<Scalars['Float']>;
  anPrStOprBatch?: Maybe<Scalars['Float']>;
  anPrStOprNoOfWrk?: Maybe<Scalars['Float']>;
  anPrStOprOptimalQty?: Maybe<Scalars['Float']>;
  anPrStOprQty1?: Maybe<Scalars['Float']>;
  anPrStOprQty2?: Maybe<Scalars['Float']>;
  anPrStOprQty3?: Maybe<Scalars['Float']>;
  anPrStOprQtyBase?: Maybe<Scalars['Int']>;
  anPrStOprQtyBase3?: Maybe<Scalars['Int']>;
  anPrStPrice: Scalars['Float'];
  anPrStPriceP: Scalars['Decimal'];
  anPurExciseA: Scalars['Float'];
  anPurExciseE: Scalars['Float'];
  anPurExciseT: Scalars['Float'];
  anQid: Scalars['Int'];
  anQtyMarkLabel?: Maybe<Scalars['Decimal']>;
  anRebate: Scalars['Decimal'];
  anRtprice: Scalars['Float'];
  anRtpriceP: Scalars['Decimal'];
  anSaleRebate2?: Maybe<Scalars['Decimal']>;
  anSaleRebate3?: Maybe<Scalars['Decimal']>;
  anSequence: Scalars['Int'];
  anTransport: Scalars['Decimal'];
  anUmtoUm2?: Maybe<Scalars['Float']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anWarrenty: Scalars['Int'];
  anWsprice: Scalars['Float'];
  anWsprice2: Scalars['Float'];
  anWsprice2P: Scalars['Decimal'];
  anWspriceP: Scalars['Decimal'];
  tHeSetItemAcClassifNavigations?: Maybe<Array<Maybe<THeSetItem>>>;
  tHeSetSubjPriceCategs?: Maybe<Array<Maybe<THeSetSubjPriceCateg>>>;
}


declare interface THeSetItemCategTHeSetItemAcClassifNavigationsArgs {
  where?: InputMaybe<THeSetItemFilterInput>;
}


declare interface THeSetItemCategTHeSetSubjPriceCategsArgs {
  where?: InputMaybe<THeSetSubjPriceCategFilterInput>;
}

declare interface THeSetItemCategFilterInput {
  abIcon?: InputMaybe<ListComparableByteOperationFilterInput>;
  acAcct?: InputMaybe<StringOperationFilterInput>;
  acAcctIncome?: InputMaybe<StringOperationFilterInput>;
  acActive?: InputMaybe<StringOperationFilterInput>;
  acAtdescPos?: InputMaybe<StringOperationFilterInput>;
  acAtorder?: InputMaybe<StringOperationFilterInput>;
  acClassFillMethod?: InputMaybe<StringOperationFilterInput>;
  acClassif?: InputMaybe<StringOperationFilterInput>;
  acColumn?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acCustTariff?: InputMaybe<StringOperationFilterInput>;
  acDescr?: InputMaybe<StringOperationFilterInput>;
  acDroe?: InputMaybe<StringOperationFilterInput>;
  acDroesubject?: InputMaybe<StringOperationFilterInput>;
  acEnvrmntCost?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSf?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFieldSj?: InputMaybe<StringOperationFilterInput>;
  acFormula?: InputMaybe<StringOperationFilterInput>;
  acMakeCalc?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acPackSlopak?: InputMaybe<StringOperationFilterInput>;
  acPackSlopaktype?: InputMaybe<StringOperationFilterInput>;
  acPacking?: InputMaybe<StringOperationFilterInput>;
  acPicture?: InputMaybe<ListComparableByteOperationFilterInput>;
  acPosprinterId?: InputMaybe<StringOperationFilterInput>;
  acPrStC1?: InputMaybe<StringOperationFilterInput>;
  acPrStC2?: InputMaybe<StringOperationFilterInput>;
  acPrStC3?: InputMaybe<StringOperationFilterInput>;
  acPrStC4?: InputMaybe<StringOperationFilterInput>;
  acPrStC8?: InputMaybe<StringOperationFilterInput>;
  acPrStMatQtyFormula?: InputMaybe<StringOperationFilterInput>;
  acPrStMatScrapIdent?: InputMaybe<StringOperationFilterInput>;
  acPrStMatUm?: InputMaybe<StringOperationFilterInput>;
  acPrStOprDelayType?: InputMaybe<StringOperationFilterInput>;
  acPrStOprEtadditive?: InputMaybe<StringOperationFilterInput>;
  acPrStOprIncomeGrp?: InputMaybe<StringOperationFilterInput>;
  acPrStOprOperationType?: InputMaybe<StringOperationFilterInput>;
  acPrStOprQtyFormula?: InputMaybe<StringOperationFilterInput>;
  acPrStOprResursId?: InputMaybe<StringOperationFilterInput>;
  acPrStOprRuleId?: InputMaybe<StringOperationFilterInput>;
  acPrStOprUm?: InputMaybe<StringOperationFilterInput>;
  acPrStOprUm3?: InputMaybe<StringOperationFilterInput>;
  acPrStOprUmtime?: InputMaybe<StringOperationFilterInput>;
  acPriceCalcMethod?: InputMaybe<StringOperationFilterInput>;
  acPurchCurr?: InputMaybe<StringOperationFilterInput>;
  acQtyNotToKol?: InputMaybe<StringOperationFilterInput>;
  acRbuyRebate2?: InputMaybe<StringOperationFilterInput>;
  acRbuyRebate3?: InputMaybe<StringOperationFilterInput>;
  acRduty?: InputMaybe<StringOperationFilterInput>;
  acRnepstr?: InputMaybe<StringOperationFilterInput>;
  acRprStPrice?: InputMaybe<StringOperationFilterInput>;
  acRprStPriceP?: InputMaybe<StringOperationFilterInput>;
  acRrebate?: InputMaybe<StringOperationFilterInput>;
  acRrtprice?: InputMaybe<StringOperationFilterInput>;
  acRrtpriceP?: InputMaybe<StringOperationFilterInput>;
  acRsaleRebate2?: InputMaybe<StringOperationFilterInput>;
  acRsaleRebate3?: InputMaybe<StringOperationFilterInput>;
  acRtransport?: InputMaybe<StringOperationFilterInput>;
  acRvrdavek?: InputMaybe<StringOperationFilterInput>;
  acRwsprice?: InputMaybe<StringOperationFilterInput>;
  acRwsprice2?: InputMaybe<StringOperationFilterInput>;
  acRwsprice2P?: InputMaybe<StringOperationFilterInput>;
  acRwspriceP?: InputMaybe<StringOperationFilterInput>;
  acSerialNo?: InputMaybe<StringOperationFilterInput>;
  acSetOfItem?: InputMaybe<StringOperationFilterInput>;
  acShowAtena?: InputMaybe<StringOperationFilterInput>;
  acShowAtenaDesc?: InputMaybe<StringOperationFilterInput>;
  acSuprClassif?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  acUm2?: InputMaybe<StringOperationFilterInput>;
  acUmdim1?: InputMaybe<StringOperationFilterInput>;
  acUmdim2?: InputMaybe<StringOperationFilterInput>;
  acUmmarkLabel?: InputMaybe<StringOperationFilterInput>;
  acVatcode?: InputMaybe<StringOperationFilterInput>;
  acVatcodeLow?: InputMaybe<StringOperationFilterInput>;
  acWayBillDescr?: InputMaybe<StringOperationFilterInput>;
  adDiscountBegin?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDiscountEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anAllowedInvShort?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anBeatShare?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anBuyRebate2?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anBuyRebate3?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anColorCode?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anDeliveryDeadline?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDimDepth?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimHeight?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimWeight?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimWeightBrutto?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimWidth?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDirectCost?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDuty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNd?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNe?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNf?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNg?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNh?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNi?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNj?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anIncTax?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMaxRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMaxRebatePos?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMaxstock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMinMargin?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMinMarginCateg?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMinstock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anOptStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPosqty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPrStC5?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStC6?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStC7?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStMatBatch?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStMatQty1?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStMatQtyBase?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPrStMatScrapPrc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStMatScrapQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStMatVariantSubLvl?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  anPrStMatWastePrc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStMatWasteQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStOprBatch?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStOprNoOfWrk?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStOprOptimalQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStOprQty1?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStOprQty2?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStOprQty3?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStOprQtyBase?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPrStOprQtyBase3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPrStPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPrStPriceP?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPurExciseA?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPurExciseE?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPurExciseT?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQtyMarkLabel?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRtprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRtpriceP?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anSaleRebate2?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anSaleRebate3?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anSequence?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTransport?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUmtoUm2?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWarrenty?: InputMaybe<ComparableInt32OperationFilterInput>;
  anWsprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anWsprice2?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anWsprice2P?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anWspriceP?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemCategFilterInput>>;
  or?: InputMaybe<Array<THeSetItemCategFilterInput>>;
  tHeSetItemAcClassifNavigations?: InputMaybe<ListFilterInputTypeOfTHeSetItemFilterInput>;
  tHeSetSubjPriceCategs?: InputMaybe<ListFilterInputTypeOfTHeSetSubjPriceCategFilterInput>;
}

/** A connection to a list of items. */
declare interface THeSetItemCategPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetItemCategPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetItemCateg>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeSetItemCategPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetItemCateg>;
}

/** A connection to a list of items. */
declare interface THeSetItemCategPagedParametrizedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetItemCategPagedParametrizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetItemCateg>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeSetItemCategPagedParametrizedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetItemCateg>;
}

declare interface THeSetItemCategSortInput {
  acAcct?: InputMaybe<SortEnumType>;
  acAcctIncome?: InputMaybe<SortEnumType>;
  acActive?: InputMaybe<SortEnumType>;
  acAtdescPos?: InputMaybe<SortEnumType>;
  acAtorder?: InputMaybe<SortEnumType>;
  acClassFillMethod?: InputMaybe<SortEnumType>;
  acClassif?: InputMaybe<SortEnumType>;
  acColumn?: InputMaybe<SortEnumType>;
  acCurrency?: InputMaybe<SortEnumType>;
  acCustTariff?: InputMaybe<SortEnumType>;
  acDescr?: InputMaybe<SortEnumType>;
  acDroe?: InputMaybe<SortEnumType>;
  acDroesubject?: InputMaybe<SortEnumType>;
  acEnvrmntCost?: InputMaybe<SortEnumType>;
  acFieldSa?: InputMaybe<SortEnumType>;
  acFieldSb?: InputMaybe<SortEnumType>;
  acFieldSc?: InputMaybe<SortEnumType>;
  acFieldSd?: InputMaybe<SortEnumType>;
  acFieldSe?: InputMaybe<SortEnumType>;
  acFieldSf?: InputMaybe<SortEnumType>;
  acFieldSg?: InputMaybe<SortEnumType>;
  acFieldSh?: InputMaybe<SortEnumType>;
  acFieldSi?: InputMaybe<SortEnumType>;
  acFieldSj?: InputMaybe<SortEnumType>;
  acFormula?: InputMaybe<SortEnumType>;
  acMakeCalc?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acPackSlopak?: InputMaybe<SortEnumType>;
  acPackSlopaktype?: InputMaybe<SortEnumType>;
  acPacking?: InputMaybe<SortEnumType>;
  acPosprinterId?: InputMaybe<SortEnumType>;
  acPrStC1?: InputMaybe<SortEnumType>;
  acPrStC2?: InputMaybe<SortEnumType>;
  acPrStC3?: InputMaybe<SortEnumType>;
  acPrStC4?: InputMaybe<SortEnumType>;
  acPrStC8?: InputMaybe<SortEnumType>;
  acPrStMatQtyFormula?: InputMaybe<SortEnumType>;
  acPrStMatScrapIdent?: InputMaybe<SortEnumType>;
  acPrStMatUm?: InputMaybe<SortEnumType>;
  acPrStOprDelayType?: InputMaybe<SortEnumType>;
  acPrStOprEtadditive?: InputMaybe<SortEnumType>;
  acPrStOprIncomeGrp?: InputMaybe<SortEnumType>;
  acPrStOprOperationType?: InputMaybe<SortEnumType>;
  acPrStOprQtyFormula?: InputMaybe<SortEnumType>;
  acPrStOprResursId?: InputMaybe<SortEnumType>;
  acPrStOprRuleId?: InputMaybe<SortEnumType>;
  acPrStOprUm?: InputMaybe<SortEnumType>;
  acPrStOprUm3?: InputMaybe<SortEnumType>;
  acPrStOprUmtime?: InputMaybe<SortEnumType>;
  acPriceCalcMethod?: InputMaybe<SortEnumType>;
  acPurchCurr?: InputMaybe<SortEnumType>;
  acQtyNotToKol?: InputMaybe<SortEnumType>;
  acRbuyRebate2?: InputMaybe<SortEnumType>;
  acRbuyRebate3?: InputMaybe<SortEnumType>;
  acRduty?: InputMaybe<SortEnumType>;
  acRnepstr?: InputMaybe<SortEnumType>;
  acRprStPrice?: InputMaybe<SortEnumType>;
  acRprStPriceP?: InputMaybe<SortEnumType>;
  acRrebate?: InputMaybe<SortEnumType>;
  acRrtprice?: InputMaybe<SortEnumType>;
  acRrtpriceP?: InputMaybe<SortEnumType>;
  acRsaleRebate2?: InputMaybe<SortEnumType>;
  acRsaleRebate3?: InputMaybe<SortEnumType>;
  acRtransport?: InputMaybe<SortEnumType>;
  acRvrdavek?: InputMaybe<SortEnumType>;
  acRwsprice?: InputMaybe<SortEnumType>;
  acRwsprice2?: InputMaybe<SortEnumType>;
  acRwsprice2P?: InputMaybe<SortEnumType>;
  acRwspriceP?: InputMaybe<SortEnumType>;
  acSerialNo?: InputMaybe<SortEnumType>;
  acSetOfItem?: InputMaybe<SortEnumType>;
  acShowAtena?: InputMaybe<SortEnumType>;
  acShowAtenaDesc?: InputMaybe<SortEnumType>;
  acSuprClassif?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  acUm2?: InputMaybe<SortEnumType>;
  acUmdim1?: InputMaybe<SortEnumType>;
  acUmdim2?: InputMaybe<SortEnumType>;
  acUmmarkLabel?: InputMaybe<SortEnumType>;
  acVatcode?: InputMaybe<SortEnumType>;
  acVatcodeLow?: InputMaybe<SortEnumType>;
  acWayBillDescr?: InputMaybe<SortEnumType>;
  adDiscountBegin?: InputMaybe<SortEnumType>;
  adDiscountEnd?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anAllowedInvShort?: InputMaybe<SortEnumType>;
  anBeatShare?: InputMaybe<SortEnumType>;
  anBuyRebate2?: InputMaybe<SortEnumType>;
  anBuyRebate3?: InputMaybe<SortEnumType>;
  anColorCode?: InputMaybe<SortEnumType>;
  anDeliveryDeadline?: InputMaybe<SortEnumType>;
  anDimDepth?: InputMaybe<SortEnumType>;
  anDimHeight?: InputMaybe<SortEnumType>;
  anDimWeight?: InputMaybe<SortEnumType>;
  anDimWeightBrutto?: InputMaybe<SortEnumType>;
  anDimWidth?: InputMaybe<SortEnumType>;
  anDirectCost?: InputMaybe<SortEnumType>;
  anDiscount?: InputMaybe<SortEnumType>;
  anDuty?: InputMaybe<SortEnumType>;
  anFieldNa?: InputMaybe<SortEnumType>;
  anFieldNb?: InputMaybe<SortEnumType>;
  anFieldNc?: InputMaybe<SortEnumType>;
  anFieldNd?: InputMaybe<SortEnumType>;
  anFieldNe?: InputMaybe<SortEnumType>;
  anFieldNf?: InputMaybe<SortEnumType>;
  anFieldNg?: InputMaybe<SortEnumType>;
  anFieldNh?: InputMaybe<SortEnumType>;
  anFieldNi?: InputMaybe<SortEnumType>;
  anFieldNj?: InputMaybe<SortEnumType>;
  anIncTax?: InputMaybe<SortEnumType>;
  anMaxRebate?: InputMaybe<SortEnumType>;
  anMaxRebatePos?: InputMaybe<SortEnumType>;
  anMaxstock?: InputMaybe<SortEnumType>;
  anMinMargin?: InputMaybe<SortEnumType>;
  anMinMarginCateg?: InputMaybe<SortEnumType>;
  anMinstock?: InputMaybe<SortEnumType>;
  anOptStock?: InputMaybe<SortEnumType>;
  anPosqty?: InputMaybe<SortEnumType>;
  anPrStC5?: InputMaybe<SortEnumType>;
  anPrStC6?: InputMaybe<SortEnumType>;
  anPrStC7?: InputMaybe<SortEnumType>;
  anPrStMatBatch?: InputMaybe<SortEnumType>;
  anPrStMatQty1?: InputMaybe<SortEnumType>;
  anPrStMatQtyBase?: InputMaybe<SortEnumType>;
  anPrStMatScrapPrc?: InputMaybe<SortEnumType>;
  anPrStMatScrapQty?: InputMaybe<SortEnumType>;
  anPrStMatVariantSubLvl?: InputMaybe<SortEnumType>;
  anPrStMatWastePrc?: InputMaybe<SortEnumType>;
  anPrStMatWasteQty?: InputMaybe<SortEnumType>;
  anPrStOprBatch?: InputMaybe<SortEnumType>;
  anPrStOprNoOfWrk?: InputMaybe<SortEnumType>;
  anPrStOprOptimalQty?: InputMaybe<SortEnumType>;
  anPrStOprQty1?: InputMaybe<SortEnumType>;
  anPrStOprQty2?: InputMaybe<SortEnumType>;
  anPrStOprQty3?: InputMaybe<SortEnumType>;
  anPrStOprQtyBase?: InputMaybe<SortEnumType>;
  anPrStOprQtyBase3?: InputMaybe<SortEnumType>;
  anPrStPrice?: InputMaybe<SortEnumType>;
  anPrStPriceP?: InputMaybe<SortEnumType>;
  anPurExciseA?: InputMaybe<SortEnumType>;
  anPurExciseE?: InputMaybe<SortEnumType>;
  anPurExciseT?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQtyMarkLabel?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anRtprice?: InputMaybe<SortEnumType>;
  anRtpriceP?: InputMaybe<SortEnumType>;
  anSaleRebate2?: InputMaybe<SortEnumType>;
  anSaleRebate3?: InputMaybe<SortEnumType>;
  anSequence?: InputMaybe<SortEnumType>;
  anTransport?: InputMaybe<SortEnumType>;
  anUmtoUm2?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anWarrenty?: InputMaybe<SortEnumType>;
  anWsprice?: InputMaybe<SortEnumType>;
  anWsprice2?: InputMaybe<SortEnumType>;
  anWsprice2P?: InputMaybe<SortEnumType>;
  anWspriceP?: InputMaybe<SortEnumType>;
}

declare interface THeSetItemExcise {
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acSetOfTax?: Maybe<Scalars['String']>;
  acSetOfTaxNavigation?: Maybe<THeSetDuty>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Float'];
  anValuePercent: Scalars['Float'];
}

declare interface THeSetItemExciseFilterInput {
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acSetOfTax?: InputMaybe<StringOperationFilterInput>;
  acSetOfTaxNavigation?: InputMaybe<THeSetDutyFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anValuePercent?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemExciseFilterInput>>;
  or?: InputMaybe<Array<THeSetItemExciseFilterInput>>;
}

declare interface THeSetItemExtItemSubj {
  acCode?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acName?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
  packageQuantity?: Maybe<Scalars['Decimal']>;
}

declare interface THeSetItemExtItemSubjFilterInput {
  acCode?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemExtItemSubjFilterInput>>;
  or?: InputMaybe<Array<THeSetItemExtItemSubjFilterInput>>;
  packageQuantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
}

declare interface THeSetItemFilterInput {
  abIcon?: InputMaybe<ListComparableByteOperationFilterInput>;
  acAcct?: InputMaybe<StringOperationFilterInput>;
  acAcctBuyVasale?: InputMaybe<StringOperationFilterInput>;
  acAcctIncome?: InputMaybe<StringOperationFilterInput>;
  acAcctNotTaxDeduct?: InputMaybe<StringOperationFilterInput>;
  acActive?: InputMaybe<StringOperationFilterInput>;
  acBackPacking?: InputMaybe<StringOperationFilterInput>;
  acBst?: InputMaybe<StringOperationFilterInput>;
  acBullId?: InputMaybe<StringOperationFilterInput>;
  acClassProdByAct?: InputMaybe<StringOperationFilterInput>;
  acClassif?: InputMaybe<StringOperationFilterInput>;
  acClassif2?: InputMaybe<StringOperationFilterInput>;
  acClassifNavigation?: InputMaybe<THeSetItemCategFilterInput>;
  acCode?: InputMaybe<StringOperationFilterInput>;
  acColumn?: InputMaybe<StringOperationFilterInput>;
  acColumnNavigation?: InputMaybe<THeSetItemSntFilterInput>;
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acCustTariff?: InputMaybe<StringOperationFilterInput>;
  acCustTariffNavigation?: InputMaybe<THeSetCustTariffFilterInput>;
  acDateDue?: InputMaybe<StringOperationFilterInput>;
  acDeclarForOrigin?: InputMaybe<StringOperationFilterInput>;
  acDeclarForOriginType?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDescr?: InputMaybe<StringOperationFilterInput>;
  acDocTypeIssue?: InputMaybe<StringOperationFilterInput>;
  acDocTypeOrdSupp?: InputMaybe<StringOperationFilterInput>;
  acDocTypeProd?: InputMaybe<StringOperationFilterInput>;
  acDroe?: InputMaybe<StringOperationFilterInput>;
  acDroesubject?: InputMaybe<StringOperationFilterInput>;
  acEnableChgPrSt?: InputMaybe<StringOperationFilterInput>;
  acEnvrmntCost?: InputMaybe<StringOperationFilterInput>;
  acEvidence?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSf?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFieldSj?: InputMaybe<StringOperationFilterInput>;
  acFieldsA?: InputMaybe<StringOperationFilterInput>;
  acFormula?: InputMaybe<StringOperationFilterInput>;
  acFormulaRt?: InputMaybe<StringOperationFilterInput>;
  acHttppath?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acInFlowOutFlow?: InputMaybe<StringOperationFilterInput>;
  acIsReturnPack?: InputMaybe<StringOperationFilterInput>;
  acMakeCalc?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acOrderTransInMf?: InputMaybe<StringOperationFilterInput>;
  acOrigin?: InputMaybe<StringOperationFilterInput>;
  acPackSlopak?: InputMaybe<StringOperationFilterInput>;
  acPackSlopaktype?: InputMaybe<StringOperationFilterInput>;
  acPackagingType?: InputMaybe<StringOperationFilterInput>;
  acPacking?: InputMaybe<StringOperationFilterInput>;
  acPicture?: InputMaybe<ListComparableByteOperationFilterInput>;
  acPosprinterId?: InputMaybe<StringOperationFilterInput>;
  acPrstPrice?: InputMaybe<StringOperationFilterInput>;
  acPrstUmtime?: InputMaybe<StringOperationFilterInput>;
  acPurchCurr?: InputMaybe<StringOperationFilterInput>;
  acQtyInCode?: InputMaybe<StringOperationFilterInput>;
  acQtyNotToKol?: InputMaybe<StringOperationFilterInput>;
  acReportDeclar?: InputMaybe<StringOperationFilterInput>;
  acSerialNo?: InputMaybe<StringOperationFilterInput>;
  acSerialnoDueType?: InputMaybe<StringOperationFilterInput>;
  acSetOfItem?: InputMaybe<StringOperationFilterInput>;
  acSetOfItemNavigation?: InputMaybe<THeSetItemTypeFilterInput>;
  acShowAtena?: InputMaybe<StringOperationFilterInput>;
  acStandardize?: InputMaybe<StringOperationFilterInput>;
  acSupplier?: InputMaybe<StringOperationFilterInput>;
  acTechProcedure?: InputMaybe<StringOperationFilterInput>;
  acTransferredWs?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  acUm2?: InputMaybe<StringOperationFilterInput>;
  acUm2Navigation?: InputMaybe<THeSetUmFilterInput>;
  acUm3?: InputMaybe<StringOperationFilterInput>;
  acUmNavigation?: InputMaybe<THeSetUmFilterInput>;
  acUmdim1?: InputMaybe<StringOperationFilterInput>;
  acUmdim2?: InputMaybe<StringOperationFilterInput>;
  acUmmarkLabel?: InputMaybe<StringOperationFilterInput>;
  acUmseries?: InputMaybe<StringOperationFilterInput>;
  acUsedTyre?: InputMaybe<StringOperationFilterInput>;
  acVatCodeNavigation?: InputMaybe<THeSetTaxFilterInput>;
  acVatcode?: InputMaybe<StringOperationFilterInput>;
  acVatcodeLow?: InputMaybe<StringOperationFilterInput>;
  acVatcodeReceive?: InputMaybe<StringOperationFilterInput>;
  acVehiclePart?: InputMaybe<StringOperationFilterInput>;
  acWastePack?: InputMaybe<StringOperationFilterInput>;
  acWeighableItem?: InputMaybe<StringOperationFilterInput>;
  acWstEeequip?: InputMaybe<StringOperationFilterInput>;
  adDiscountBegin?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDiscountEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDa?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDb?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adPrStCheckTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adPrStInsertTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adPrStUpdateTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anAllowedInvShort?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anAllowedWastage?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anBeatShare?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anBuyPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anBuyRebate2?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anBuyRebate3?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anColorCode?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anDeliveryDeadline?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDimDepth?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimHeight?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimWeight?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimWeightBrutto?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimWidth?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDirectCost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anDiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDiscountPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDiscountPriceRt?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDuty?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExcise?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExciseP?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNd?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNe?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNf?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNg?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNh?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNi?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNj?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFixPriceDiff?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anIncTax?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anMaxRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMaxStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMinMargin?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMinStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMonthDue?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anOptStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anOrderMinQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anOrderOptQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPackWasteWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPackWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPlucode?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPlucode2?: InputMaybe<ComparableNullableOfInt64OperationFilterInput>;
  anPosQtyStep?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPosqty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPrStCheckUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPrStDailyQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPrStInsertUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPrStOptimalQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPrStPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPrStPriceP?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPrStUpdateUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPrStVariantValid?: InputMaybe<ComparableByteOperationFilterInput>;
  anPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPriceSupp?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anProdPrice?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrstTime?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPurExciseA?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPurExciseE?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPurExciseT?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQtyInCodeDecPlace?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQtyMarkLabel?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQtySeries?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRebate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRtPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRtprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRtpriceP?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anSalePrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anSaleRebate2?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anSaleRebate3?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anSubClassif?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anTransport?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anUmtoDeclarReport?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUmtoUm2?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUmtoUm3?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUnionDeadline?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anVat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVatreceive?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anWarrenty?: InputMaybe<ComparableInt32OperationFilterInput>;
  anWasteQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anWsprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anWsprice2?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anWsprice2P?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anWspriceP?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemFilterInput>>;
  or?: InputMaybe<Array<THeSetItemFilterInput>>;
  tHeMoveItem?: InputMaybe<ListFilterInputTypeOfTHeMoveItemFilterInput>;
  tHeMoveItemSerialNo?: InputMaybe<ListFilterInputTypeOfTHeMoveItemSerialNoFilterInput>;
  tHeOrderItem?: InputMaybe<ListFilterInputTypeOfTHeOrderItemFilterInput>;
  tHeSetItemExcises?: InputMaybe<ListFilterInputTypeOfTHeSetItemExciseFilterInput>;
  tHeSetItemExtItemSubj?: InputMaybe<ListFilterInputTypeOfTHeSetItemExtItemSubjFilterInput>;
  tHeSetItemPriceForWrh?: InputMaybe<ListFilterInputTypeOfTHeSetItemPriceForWrhFilterInput>;
  tHeSetSubjPriceItem?: InputMaybe<ListFilterInputTypeOfTHeSetSubjPriceItemFilterInput>;
  tHeStock?: InputMaybe<ListFilterInputTypeOfTHeStockFilterInput>;
  tHeStockSerialNos?: InputMaybe<ListFilterInputTypeOfTHeStockSerialNoFilterInput>;
  tHfWoexAcIdentNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
  tHfWoexAcLnkPrStIdentParentNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
  tHfWoexAcScrapIdentNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
  tHfWoexItemAcIdentNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexItemFilterInput>;
  tHfWoexItemAcScrapIdentNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexItemFilterInput>;
  tHfWoexItemSerialNos?: InputMaybe<ListFilterInputTypeOfTHfWoexItemSerialNoFilterInput>;
}

/** A connection to a list of items. */
declare interface THeSetItemPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetItemPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

declare interface THeSetItemPagedDtoInput {
  acClassif?: InputMaybe<Scalars['String']>;
  acFieldsA?: InputMaybe<Scalars['String']>;
  acSetOfItem?: InputMaybe<Scalars['String']>;
  acSubject?: InputMaybe<Scalars['String']>;
  acWarehouse?: InputMaybe<Scalars['String']>;
  alwaysShowTheseAcSetOfItem?: InputMaybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<Scalars['String']>;
  customContractPriceFilter?: InputMaybe<Scalars['Boolean']>;
  docTypeId?: InputMaybe<Scalars['Int']>;
  ignoreWarehouse?: InputMaybe<Scalars['Boolean']>;
  minStock?: InputMaybe<Scalars['Decimal']>;
  onlyWithCustomerContractPrices?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  showOnlyInStock?: InputMaybe<Scalars['Boolean']>;
  sortDescending?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<THeSetItemPagedSortField>;
}

/** An edge in a connection. */
declare interface THeSetItemPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetItem>;
}

/** A connection to a list of items. */
declare interface THeSetItemPagedParametrizedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetItemPagedParametrizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** A connection to a list of items. */
declare interface THeSetItemPagedParametrizedDtoConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetItemPagedParametrizedDtoEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeSetItemPagedParametrizedDtoEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetItem>;
}

/** An edge in a connection. */
declare interface THeSetItemPagedParametrizedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetItem>;
}

/** A connection to a list of items. */
declare interface THeSetItemPagedParametrizedV2Connection {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetItemPagedParametrizedV2Edge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeSetItemPagedParametrizedV2Edge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetItem>;
}

declare type THeSetItemPagedSortField =
  | 'AC_CLASSIF'
  | 'AC_CLASSIF2'
  | 'AC_DEPT'
  | 'AC_IDENT'
  | 'AC_NAME'
  | 'AC_NOTE'
  | 'AC_SET_OF_ITEM'
  | 'AC_SUPPLIER';

declare interface THeSetItemPriceForWrh {
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acWarehouse?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anBuyPrice?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anRtprice: Scalars['Float'];
  anSalePrice: Scalars['Decimal'];
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THeSetItemPriceForWrhFilterInput {
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acWarehouse?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anBuyPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anRtprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anSalePrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemPriceForWrhFilterInput>>;
  or?: InputMaybe<Array<THeSetItemPriceForWrhFilterInput>>;
}

declare interface THeSetItemSnt {
  acColumn?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeSetItemSntitems?: Maybe<Array<Maybe<THeSetItemSntitem>>>;
  tHeSetItemSntserialNos?: Maybe<Array<Maybe<THeSetItemSntserialNo>>>;
  tHeSetItems?: Maybe<Array<Maybe<THeSetItem>>>;
}

declare interface THeSetItemSntFilterInput {
  acColumn?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemSntFilterInput>>;
  or?: InputMaybe<Array<THeSetItemSntFilterInput>>;
  tHeSetItemSntitems?: InputMaybe<ListFilterInputTypeOfTHeSetItemSntitemFilterInput>;
  tHeSetItemSntserialNos?: InputMaybe<ListFilterInputTypeOfTHeSetItemSntserialNoFilterInput>;
  tHeSetItems?: InputMaybe<ListFilterInputTypeOfTHeSetItemFilterInput>;
}

declare interface THeSetItemSntSortInput {
  acColumn?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeSetItemSntitem {
  acColumn?: Maybe<Scalars['String']>;
  acColumnNavigation?: Maybe<THeSetItemSnt>;
  acSerialNo?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anSeqNo?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THeSetItemSntitemFilterInput {
  acColumn?: InputMaybe<StringOperationFilterInput>;
  acColumnNavigation?: InputMaybe<THeSetItemSntFilterInput>;
  acSerialNo?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anSeqNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemSntitemFilterInput>>;
  or?: InputMaybe<Array<THeSetItemSntitemFilterInput>>;
}

declare interface THeSetItemSntserialNo {
  acColumn?: Maybe<Scalars['String']>;
  acColumnNavigation?: Maybe<THeSetItemSnt>;
  acHandling?: Maybe<Scalars['String']>;
  acInternal?: Maybe<Scalars['String']>;
  acMessage?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acRequireEnter?: Maybe<Scalars['String']>;
  acSignForEmpty?: Maybe<Scalars['String']>;
  acSqlcontrol?: Maybe<Scalars['String']>;
  acSqlselect?: Maybe<Scalars['String']>;
  acSqlselectDefault?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anLen: Scalars['Int'];
  anNameLength: Scalars['Int'];
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  gS1FieldFormat?: Maybe<Scalars['String']>;
  gS1FieldMask?: Maybe<Scalars['String']>;
  gS1FieldType?: Maybe<Scalars['String']>;
  gS1Mapping?: Maybe<Scalars['String']>;
}

declare interface THeSetItemSntserialNoFilterInput {
  acColumn?: InputMaybe<StringOperationFilterInput>;
  acColumnNavigation?: InputMaybe<THeSetItemSntFilterInput>;
  acHandling?: InputMaybe<StringOperationFilterInput>;
  acInternal?: InputMaybe<StringOperationFilterInput>;
  acMessage?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acRequireEnter?: InputMaybe<StringOperationFilterInput>;
  acSignForEmpty?: InputMaybe<StringOperationFilterInput>;
  acSqlcontrol?: InputMaybe<StringOperationFilterInput>;
  acSqlselect?: InputMaybe<StringOperationFilterInput>;
  acSqlselectDefault?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anLen?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNameLength?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemSntserialNoFilterInput>>;
  gS1FieldFormat?: InputMaybe<StringOperationFilterInput>;
  gS1FieldMask?: InputMaybe<StringOperationFilterInput>;
  gS1FieldType?: InputMaybe<StringOperationFilterInput>;
  gS1Mapping?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<THeSetItemSntserialNoFilterInput>>;
}

declare interface THeSetItemSortInput {
  acAcct?: InputMaybe<SortEnumType>;
  acAcctBuyVasale?: InputMaybe<SortEnumType>;
  acAcctIncome?: InputMaybe<SortEnumType>;
  acAcctNotTaxDeduct?: InputMaybe<SortEnumType>;
  acActive?: InputMaybe<SortEnumType>;
  acBackPacking?: InputMaybe<SortEnumType>;
  acBst?: InputMaybe<SortEnumType>;
  acBullId?: InputMaybe<SortEnumType>;
  acClassProdByAct?: InputMaybe<SortEnumType>;
  acClassif?: InputMaybe<SortEnumType>;
  acClassif2?: InputMaybe<SortEnumType>;
  acClassifNavigation?: InputMaybe<THeSetItemCategSortInput>;
  acCode?: InputMaybe<SortEnumType>;
  acColumn?: InputMaybe<SortEnumType>;
  acColumnNavigation?: InputMaybe<THeSetItemSntSortInput>;
  acCostDrv?: InputMaybe<SortEnumType>;
  acCurrency?: InputMaybe<SortEnumType>;
  acCustTariff?: InputMaybe<SortEnumType>;
  acCustTariffNavigation?: InputMaybe<THeSetCustTariffSortInput>;
  acDateDue?: InputMaybe<SortEnumType>;
  acDeclarForOrigin?: InputMaybe<SortEnumType>;
  acDeclarForOriginType?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acDescr?: InputMaybe<SortEnumType>;
  acDocTypeIssue?: InputMaybe<SortEnumType>;
  acDocTypeOrdSupp?: InputMaybe<SortEnumType>;
  acDocTypeProd?: InputMaybe<SortEnumType>;
  acDroe?: InputMaybe<SortEnumType>;
  acDroesubject?: InputMaybe<SortEnumType>;
  acEnableChgPrSt?: InputMaybe<SortEnumType>;
  acEnvrmntCost?: InputMaybe<SortEnumType>;
  acEvidence?: InputMaybe<SortEnumType>;
  acFieldSa?: InputMaybe<SortEnumType>;
  acFieldSb?: InputMaybe<SortEnumType>;
  acFieldSc?: InputMaybe<SortEnumType>;
  acFieldSd?: InputMaybe<SortEnumType>;
  acFieldSe?: InputMaybe<SortEnumType>;
  acFieldSf?: InputMaybe<SortEnumType>;
  acFieldSg?: InputMaybe<SortEnumType>;
  acFieldSh?: InputMaybe<SortEnumType>;
  acFieldSi?: InputMaybe<SortEnumType>;
  acFieldSj?: InputMaybe<SortEnumType>;
  acFieldsA?: InputMaybe<SortEnumType>;
  acFormula?: InputMaybe<SortEnumType>;
  acFormulaRt?: InputMaybe<SortEnumType>;
  acHttppath?: InputMaybe<SortEnumType>;
  acIdent?: InputMaybe<SortEnumType>;
  acInFlowOutFlow?: InputMaybe<SortEnumType>;
  acIsReturnPack?: InputMaybe<SortEnumType>;
  acMakeCalc?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acOrderTransInMf?: InputMaybe<SortEnumType>;
  acOrigin?: InputMaybe<SortEnumType>;
  acPackSlopak?: InputMaybe<SortEnumType>;
  acPackSlopaktype?: InputMaybe<SortEnumType>;
  acPackagingType?: InputMaybe<SortEnumType>;
  acPacking?: InputMaybe<SortEnumType>;
  acPosprinterId?: InputMaybe<SortEnumType>;
  acPrstPrice?: InputMaybe<SortEnumType>;
  acPrstUmtime?: InputMaybe<SortEnumType>;
  acPurchCurr?: InputMaybe<SortEnumType>;
  acQtyInCode?: InputMaybe<SortEnumType>;
  acQtyNotToKol?: InputMaybe<SortEnumType>;
  acReportDeclar?: InputMaybe<SortEnumType>;
  acSerialNo?: InputMaybe<SortEnumType>;
  acSerialnoDueType?: InputMaybe<SortEnumType>;
  acSetOfItem?: InputMaybe<SortEnumType>;
  acSetOfItemNavigation?: InputMaybe<THeSetItemTypeSortInput>;
  acShowAtena?: InputMaybe<SortEnumType>;
  acStandardize?: InputMaybe<SortEnumType>;
  acSupplier?: InputMaybe<SortEnumType>;
  acTechProcedure?: InputMaybe<SortEnumType>;
  acTransferredWs?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  acUm2?: InputMaybe<SortEnumType>;
  acUm2Navigation?: InputMaybe<THeSetUmSortInput>;
  acUm3?: InputMaybe<SortEnumType>;
  acUmNavigation?: InputMaybe<THeSetUmSortInput>;
  acUmdim1?: InputMaybe<SortEnumType>;
  acUmdim2?: InputMaybe<SortEnumType>;
  acUmmarkLabel?: InputMaybe<SortEnumType>;
  acUmseries?: InputMaybe<SortEnumType>;
  acUsedTyre?: InputMaybe<SortEnumType>;
  acVatCodeNavigation?: InputMaybe<THeSetTaxSortInput>;
  acVatcode?: InputMaybe<SortEnumType>;
  acVatcodeLow?: InputMaybe<SortEnumType>;
  acVatcodeReceive?: InputMaybe<SortEnumType>;
  acVehiclePart?: InputMaybe<SortEnumType>;
  acWastePack?: InputMaybe<SortEnumType>;
  acWeighableItem?: InputMaybe<SortEnumType>;
  acWstEeequip?: InputMaybe<SortEnumType>;
  adDiscountBegin?: InputMaybe<SortEnumType>;
  adDiscountEnd?: InputMaybe<SortEnumType>;
  adFieldDa?: InputMaybe<SortEnumType>;
  adFieldDb?: InputMaybe<SortEnumType>;
  adFieldDc?: InputMaybe<SortEnumType>;
  adFieldDd?: InputMaybe<SortEnumType>;
  adPrStCheckTime?: InputMaybe<SortEnumType>;
  adPrStInsertTime?: InputMaybe<SortEnumType>;
  adPrStUpdateTime?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anAllowedInvShort?: InputMaybe<SortEnumType>;
  anAllowedWastage?: InputMaybe<SortEnumType>;
  anBeatShare?: InputMaybe<SortEnumType>;
  anBuyPrice?: InputMaybe<SortEnumType>;
  anBuyRebate2?: InputMaybe<SortEnumType>;
  anBuyRebate3?: InputMaybe<SortEnumType>;
  anColorCode?: InputMaybe<SortEnumType>;
  anDeliveryDeadline?: InputMaybe<SortEnumType>;
  anDimDepth?: InputMaybe<SortEnumType>;
  anDimHeight?: InputMaybe<SortEnumType>;
  anDimWeight?: InputMaybe<SortEnumType>;
  anDimWeightBrutto?: InputMaybe<SortEnumType>;
  anDimWidth?: InputMaybe<SortEnumType>;
  anDirectCost?: InputMaybe<SortEnumType>;
  anDiscount?: InputMaybe<SortEnumType>;
  anDiscountPrice?: InputMaybe<SortEnumType>;
  anDiscountPriceRt?: InputMaybe<SortEnumType>;
  anDuty?: InputMaybe<SortEnumType>;
  anExcise?: InputMaybe<SortEnumType>;
  anExciseP?: InputMaybe<SortEnumType>;
  anFieldNa?: InputMaybe<SortEnumType>;
  anFieldNb?: InputMaybe<SortEnumType>;
  anFieldNc?: InputMaybe<SortEnumType>;
  anFieldNd?: InputMaybe<SortEnumType>;
  anFieldNe?: InputMaybe<SortEnumType>;
  anFieldNf?: InputMaybe<SortEnumType>;
  anFieldNg?: InputMaybe<SortEnumType>;
  anFieldNh?: InputMaybe<SortEnumType>;
  anFieldNi?: InputMaybe<SortEnumType>;
  anFieldNj?: InputMaybe<SortEnumType>;
  anFixPriceDiff?: InputMaybe<SortEnumType>;
  anIncTax?: InputMaybe<SortEnumType>;
  anMaxRebate?: InputMaybe<SortEnumType>;
  anMaxStock?: InputMaybe<SortEnumType>;
  anMinMargin?: InputMaybe<SortEnumType>;
  anMinStock?: InputMaybe<SortEnumType>;
  anMonthDue?: InputMaybe<SortEnumType>;
  anOptStock?: InputMaybe<SortEnumType>;
  anOrderMinQty?: InputMaybe<SortEnumType>;
  anOrderOptQty?: InputMaybe<SortEnumType>;
  anPackWasteWeight?: InputMaybe<SortEnumType>;
  anPackWeight?: InputMaybe<SortEnumType>;
  anPlucode?: InputMaybe<SortEnumType>;
  anPlucode2?: InputMaybe<SortEnumType>;
  anPosQtyStep?: InputMaybe<SortEnumType>;
  anPosqty?: InputMaybe<SortEnumType>;
  anPrStCheckUserId?: InputMaybe<SortEnumType>;
  anPrStDailyQty?: InputMaybe<SortEnumType>;
  anPrStInsertUserId?: InputMaybe<SortEnumType>;
  anPrStOptimalQty?: InputMaybe<SortEnumType>;
  anPrStPrice?: InputMaybe<SortEnumType>;
  anPrStPriceP?: InputMaybe<SortEnumType>;
  anPrStUpdateUserId?: InputMaybe<SortEnumType>;
  anPrStVariantValid?: InputMaybe<SortEnumType>;
  anPrice?: InputMaybe<SortEnumType>;
  anPriceSupp?: InputMaybe<SortEnumType>;
  anProdPrice?: InputMaybe<SortEnumType>;
  anPrstTime?: InputMaybe<SortEnumType>;
  anPurExciseA?: InputMaybe<SortEnumType>;
  anPurExciseE?: InputMaybe<SortEnumType>;
  anPurExciseT?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQtyInCodeDecPlace?: InputMaybe<SortEnumType>;
  anQtyMarkLabel?: InputMaybe<SortEnumType>;
  anQtySeries?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anRtPrice?: InputMaybe<SortEnumType>;
  anRtprice?: InputMaybe<SortEnumType>;
  anRtpriceP?: InputMaybe<SortEnumType>;
  anSalePrice?: InputMaybe<SortEnumType>;
  anSaleRebate2?: InputMaybe<SortEnumType>;
  anSaleRebate3?: InputMaybe<SortEnumType>;
  anSubClassif?: InputMaybe<SortEnumType>;
  anTransport?: InputMaybe<SortEnumType>;
  anUmtoDeclarReport?: InputMaybe<SortEnumType>;
  anUmtoUm2?: InputMaybe<SortEnumType>;
  anUmtoUm3?: InputMaybe<SortEnumType>;
  anUnionDeadline?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anVat?: InputMaybe<SortEnumType>;
  anVatreceive?: InputMaybe<SortEnumType>;
  anWarrenty?: InputMaybe<SortEnumType>;
  anWasteQty?: InputMaybe<SortEnumType>;
  anWsprice?: InputMaybe<SortEnumType>;
  anWsprice2?: InputMaybe<SortEnumType>;
  anWsprice2P?: InputMaybe<SortEnumType>;
  anWspriceP?: InputMaybe<SortEnumType>;
}

declare interface THeSetItemType {
  acGoodsAsService?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acServiceAsGoods?: Maybe<Scalars['String']>;
  acSetOfItem?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anFarmType?: Maybe<Scalars['Int']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeSetItems?: Maybe<Array<Maybe<THeSetItem>>>;
}

declare interface THeSetItemTypeFilterInput {
  acGoodsAsService?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acServiceAsGoods?: InputMaybe<StringOperationFilterInput>;
  acSetOfItem?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anFarmType?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemTypeFilterInput>>;
  or?: InputMaybe<Array<THeSetItemTypeFilterInput>>;
  tHeSetItems?: InputMaybe<ListFilterInputTypeOfTHeSetItemFilterInput>;
}

declare interface THeSetItemTypeSortInput {
  acGoodsAsService?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acServiceAsGoods?: InputMaybe<SortEnumType>;
  acSetOfItem?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anFarmType?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeSetPayMet {
  acFiscalGroup?: Maybe<Scalars['String']>;
  acIsPosTerminal?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPaymentType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
  tHeCashRegItems?: Maybe<Array<Maybe<THeCashRegItem>>>;
  tHeMove?: Maybe<Array<Maybe<THeMove>>>;
  tHeOrder?: Maybe<Array<Maybe<THeOrder>>>;
  tHeSetSubjAcPayMethodNavigations?: Maybe<Array<Maybe<THeSetSubj>>>;
}

declare interface THeSetPayMetFilterInput {
  acFiscalGroup?: InputMaybe<StringOperationFilterInput>;
  acIsPosTerminal?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPaymentType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetPayMetFilterInput>>;
  or?: InputMaybe<Array<THeSetPayMetFilterInput>>;
  tHeCashRegItems?: InputMaybe<ListFilterInputTypeOfTHeCashRegItemFilterInput>;
  tHeMove?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeOrder?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
  tHeSetSubjAcPayMethodNavigations?: InputMaybe<ListFilterInputTypeOfTHeSetSubjFilterInput>;
}

declare interface THeSetPayMetSortInput {
  acFiscalGroup?: InputMaybe<SortEnumType>;
  acIsPosTerminal?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acPayMethod?: InputMaybe<SortEnumType>;
  acPaymentType?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeSetPostCode {
  acName?: Maybe<Scalars['String']>;
  acPost?: Maybe<Scalars['String']>;
  acRegion?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anLatitude?: Maybe<Scalars['Decimal']>;
  anLongitude?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
  tHeSetSubjAcPostNavigation?: Maybe<Array<Maybe<THeSetSubj>>>;
}

declare interface THeSetPostCodeFilterInput {
  acName?: InputMaybe<StringOperationFilterInput>;
  acPost?: InputMaybe<StringOperationFilterInput>;
  acRegion?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anLatitude?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anLongitude?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetPostCodeFilterInput>>;
  or?: InputMaybe<Array<THeSetPostCodeFilterInput>>;
  tHeSetSubjAcPostNavigation?: InputMaybe<ListFilterInputTypeOfTHeSetSubjFilterInput>;
}

/** A connection to a list of items. */
declare interface THeSetPostCodePagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetPostCodePagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetPostCode>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeSetPostCodePagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetPostCode>;
}

declare interface THeSetPostCodeSortInput {
  acName?: InputMaybe<SortEnumType>;
  acPost?: InputMaybe<SortEnumType>;
  acRegion?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anLatitude?: InputMaybe<SortEnumType>;
  anLongitude?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeSetSubj {
  acActive?: Maybe<Scalars['String']>;
  acAddress?: Maybe<Scalars['String']>;
  acBuyer?: Maybe<Scalars['String']>;
  acBuyerLimitCtrl?: Maybe<Scalars['String']>;
  acCode?: Maybe<Scalars['String']>;
  acCountry?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acDelivery?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acFax?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSf?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFieldSj?: Maybe<Scalars['String']>;
  acHttpPath?: Maybe<Scalars['String']>;
  acName2?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPayMethodNavigation?: Maybe<THeSetPayMet>;
  acPayer?: Maybe<Scalars['String']>;
  acPayerNavigation?: Maybe<THeSetSubj>;
  acPhone?: Maybe<Scalars['String']>;
  acPin?: Maybe<Scalars['String']>;
  acPost?: Maybe<Scalars['String']>;
  acPostNavigation?: Maybe<THeSetPostCode>;
  acPriceRate?: Maybe<Scalars['String']>;
  acSkis?: Maybe<Scalars['String']>;
  acSubjTypeBuyer?: Maybe<Scalars['String']>;
  acSubjTypeBuyerNavigation?: Maybe<THeSetSubjType>;
  acSubjTypeSupp?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acSupplier?: Maybe<Scalars['String']>;
  acVatCodePrefix?: Maybe<Scalars['String']>;
  acWarehouse?: Maybe<Scalars['String']>;
  acWayOfSale?: Maybe<Scalars['String']>;
  adFieldDa?: Maybe<Scalars['DateTime']>;
  adFieldDb?: Maybe<Scalars['DateTime']>;
  adFieldDc?: Maybe<Scalars['DateTime']>;
  adFieldDd?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClerk?: Maybe<Scalars['Int']>;
  anClerkNavigation?: Maybe<THeSetSubjContact>;
  anDaysForPayment: Scalars['Int'];
  anFieldNa: Scalars['Decimal'];
  anFieldNb: Scalars['Decimal'];
  anFieldNc: Scalars['Decimal'];
  anFieldNd: Scalars['Decimal'];
  anFieldNe: Scalars['Decimal'];
  anFieldNf: Scalars['Decimal'];
  anFieldNg: Scalars['Decimal'];
  anFieldNh: Scalars['Decimal'];
  anFieldNi: Scalars['Decimal'];
  anFieldNj: Scalars['Decimal'];
  anLatitude?: Maybe<Scalars['Decimal']>;
  anLimit?: Maybe<Scalars['Decimal']>;
  anLongitude?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anRebate: Scalars['Decimal'];
  anUserIns?: Maybe<Scalars['Int']>;
  inverseAcPayerNavigation?: Maybe<Array<Maybe<THeSetSubj>>>;
  tHeCostDrvAcConsigneeNavigation?: Maybe<Array<Maybe<THeCostDrv>>>;
  tHeCostDrvAcDeptNavigation?: Maybe<Array<Maybe<THeCostDrv>>>;
  tHeMoveAcDeptNavigation?: Maybe<Array<Maybe<THeMove>>>;
  tHeMoveAcDeptOutNavigations?: Maybe<Array<Maybe<THeMove>>>;
  tHeMoveAcIssuerNavigation?: Maybe<Array<Maybe<THeMove>>>;
  tHeMoveAcPrsn3Navigation?: Maybe<Array<Maybe<THeMove>>>;
  tHeMoveAcReceiverNavigation?: Maybe<Array<Maybe<THeMove>>>;
  tHeOrderAcConsigneeNavigation?: Maybe<Array<Maybe<THeOrder>>>;
  tHeOrderAcDeptNavigation?: Maybe<Array<Maybe<THeOrder>>>;
  tHeOrderAcReceiverNavigation?: Maybe<Array<Maybe<THeOrder>>>;
  tHeSetSubjContactAcSubjectNavigations?: Maybe<Array<Maybe<THeSetSubjContact>>>;
  tHeSetSubjPriceCategs?: Maybe<Array<Maybe<THeSetSubjPriceCateg>>>;
  tHeSetSubjPriceItem?: Maybe<Array<Maybe<THeSetSubjPriceItem>>>;
  tHeStockRes?: Maybe<Array<Maybe<THeStock>>>;
  tHeSubjTypes?: Maybe<Array<Maybe<THeSubjType>>>;
  tHfPlanAcConsigneeNavigations?: Maybe<Array<Maybe<THfPlan>>>;
  tHfPlanAcDeptNavigations?: Maybe<Array<Maybe<THfPlan>>>;
  tHfPlanAcReceiverNavigations?: Maybe<Array<Maybe<THfPlan>>>;
  tHfWoexAcConsigneeNavigations?: Maybe<Array<Maybe<THfWoex>>>;
  tHfWoexAcDeptNavigations?: Maybe<Array<Maybe<THfWoex>>>;
  tHfWoexAcReceiverNavigations?: Maybe<Array<Maybe<THfWoex>>>;
  tHfWoexItems?: Maybe<Array<Maybe<THfWoexItem>>>;
  tHrPrsnAcWorkerNavigation?: Maybe<THrPrsn>;
}


declare interface THeSetSubjAnClerkNavigationArgs {
  where?: InputMaybe<THeSetSubjContactFilterInput>;
}


declare interface THeSetSubjTHeSetSubjContactAcSubjectNavigationsArgs {
  where?: InputMaybe<THeSetSubjContactFilterInput>;
}


declare interface THeSetSubjTHeSetSubjPriceCategsArgs {
  where?: InputMaybe<THeSetSubjPriceCategFilterInput>;
}

declare interface THeSetSubjContact {
  acActive?: Maybe<Scalars['String']>;
  acAdditPersonMark?: Maybe<Scalars['String']>;
  acAgencySignedBy?: Maybe<Scalars['String']>;
  acAppl?: Maybe<Scalars['String']>;
  acAtcalendar?: Maybe<Scalars['String']>;
  acAtcash?: Maybe<Scalars['String']>;
  acAtinvoice?: Maybe<Scalars['String']>;
  acAtorder?: Maybe<Scalars['String']>;
  acAtstock?: Maybe<Scalars['String']>;
  acBankBranch?: Maybe<Scalars['String']>;
  acCerPub?: Maybe<Scalars['String']>;
  acCerTime?: Maybe<Scalars['String']>;
  acCode?: Maybe<Scalars['String']>;
  acDefLang?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acForeigner?: Maybe<Scalars['String']>;
  acFunction?: Maybe<Scalars['String']>;
  acLangId?: Maybe<Scalars['String']>;
  acLicDataBase?: Maybe<Scalars['String']>;
  acMiddle?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acPassword?: Maybe<Scalars['String']>;
  acPersonal?: Maybe<Scalars['String']>;
  acPhoto?: Maybe<Array<Scalars['Byte']>>;
  acPin?: Maybe<Scalars['String']>;
  acPost?: Maybe<Scalars['String']>;
  acPrefix?: Maybe<Scalars['String']>;
  acProfile?: Maybe<Scalars['String']>;
  acRegNo?: Maybe<Scalars['String']>;
  acSignature?: Maybe<Array<Scalars['Byte']>>;
  acSubject?: Maybe<Scalars['String']>;
  acSubjectNavigation?: Maybe<THeSetSubj>;
  acSurname?: Maybe<Scalars['String']>;
  acUserId?: Maybe<Scalars['String']>;
  acWebUserId?: Maybe<Scalars['String']>;
  acWorkerContact?: Maybe<Scalars['String']>;
  adBday?: Maybe<Scalars['DateTime']>;
  adGdprconfirm?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anMaxRebate?: Maybe<Scalars['Float']>;
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserGroup?: Maybe<Scalars['Int']>;
  anUserId: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
  tHeMoveAnClerkNavigation?: Maybe<Array<Maybe<THeMove>>>;
  tHeMoveAnNoteClerkNavigation?: Maybe<Array<Maybe<THeMove>>>;
  tHeOrderAnClerkNavigation?: Maybe<Array<Maybe<THeOrder>>>;
  tHeOrderAnNoteClerkNavigation?: Maybe<Array<Maybe<THeOrder>>>;
  tHeSetSubjAnClerkNavigation?: Maybe<Array<Maybe<THeSetSubj>>>;
  tHeSetSubjContactAddresses?: Maybe<Array<Maybe<THeSetSubjContactAddress>>>;
  tHfPlans?: Maybe<Array<Maybe<THfPlan>>>;
  tMnDocumentChatLogs?: Maybe<Array<Maybe<TMnDocumentChatLog>>>;
}


declare interface THeSetSubjContactTHeSetSubjContactAddressesArgs {
  where?: InputMaybe<THeSetSubjContactAddressFilterInput>;
}

declare interface THeSetSubjContactAddress {
  acNote?: Maybe<Scalars['String']>;
  acPhone?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acSubjectAnNoNavigation?: Maybe<THeSetSubjContact>;
  acType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anSubNo: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THeSetSubjContactAddressFilterInput {
  acNote?: InputMaybe<StringOperationFilterInput>;
  acPhone?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acSubjectAnNoNavigation?: InputMaybe<THeSetSubjContactFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anSubNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetSubjContactAddressFilterInput>>;
  or?: InputMaybe<Array<THeSetSubjContactAddressFilterInput>>;
}

declare interface THeSetSubjContactAddressSortInput {
  acNote?: InputMaybe<SortEnumType>;
  acPhone?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acSubjectAnNoNavigation?: InputMaybe<THeSetSubjContactSortInput>;
  acType?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anSubNo?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeSetSubjContactFilterInput {
  acActive?: InputMaybe<StringOperationFilterInput>;
  acAdditPersonMark?: InputMaybe<StringOperationFilterInput>;
  acAgencySignedBy?: InputMaybe<StringOperationFilterInput>;
  acAppl?: InputMaybe<StringOperationFilterInput>;
  acAtcalendar?: InputMaybe<StringOperationFilterInput>;
  acAtcash?: InputMaybe<StringOperationFilterInput>;
  acAtinvoice?: InputMaybe<StringOperationFilterInput>;
  acAtorder?: InputMaybe<StringOperationFilterInput>;
  acAtstock?: InputMaybe<StringOperationFilterInput>;
  acBankBranch?: InputMaybe<StringOperationFilterInput>;
  acCerPub?: InputMaybe<StringOperationFilterInput>;
  acCerTime?: InputMaybe<StringOperationFilterInput>;
  acCode?: InputMaybe<StringOperationFilterInput>;
  acDefLang?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acForeigner?: InputMaybe<StringOperationFilterInput>;
  acFunction?: InputMaybe<StringOperationFilterInput>;
  acLangId?: InputMaybe<StringOperationFilterInput>;
  acLicDataBase?: InputMaybe<StringOperationFilterInput>;
  acMiddle?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acPassword?: InputMaybe<StringOperationFilterInput>;
  acPersonal?: InputMaybe<StringOperationFilterInput>;
  acPhoto?: InputMaybe<ListComparableByteOperationFilterInput>;
  acPin?: InputMaybe<StringOperationFilterInput>;
  acPost?: InputMaybe<StringOperationFilterInput>;
  acPrefix?: InputMaybe<StringOperationFilterInput>;
  acProfile?: InputMaybe<StringOperationFilterInput>;
  acRegNo?: InputMaybe<StringOperationFilterInput>;
  acSignature?: InputMaybe<ListComparableByteOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acSubjectNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acSurname?: InputMaybe<StringOperationFilterInput>;
  acUserId?: InputMaybe<StringOperationFilterInput>;
  acWebUserId?: InputMaybe<StringOperationFilterInput>;
  acWorkerContact?: InputMaybe<StringOperationFilterInput>;
  adBday?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adGdprconfirm?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anMaxRebate?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserGroup?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetSubjContactFilterInput>>;
  or?: InputMaybe<Array<THeSetSubjContactFilterInput>>;
  tHeMoveAnClerkNavigation?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeMoveAnNoteClerkNavigation?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeOrderAnClerkNavigation?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
  tHeOrderAnNoteClerkNavigation?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
  tHeSetSubjAnClerkNavigation?: InputMaybe<ListFilterInputTypeOfTHeSetSubjFilterInput>;
  tHeSetSubjContactAddresses?: InputMaybe<ListFilterInputTypeOfTHeSetSubjContactAddressFilterInput>;
  tHfPlans?: InputMaybe<ListFilterInputTypeOfTHfPlanFilterInput>;
  tMnDocumentChatLogs?: InputMaybe<ListFilterInputTypeOfTMnDocumentChatLogFilterInput>;
}

/** A connection to a list of items. */
declare interface THeSetSubjContactPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetSubjContactPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetSubjContact>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeSetSubjContactPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetSubjContact>;
}

declare interface THeSetSubjContactSortInput {
  acActive?: InputMaybe<SortEnumType>;
  acAdditPersonMark?: InputMaybe<SortEnumType>;
  acAgencySignedBy?: InputMaybe<SortEnumType>;
  acAppl?: InputMaybe<SortEnumType>;
  acAtcalendar?: InputMaybe<SortEnumType>;
  acAtcash?: InputMaybe<SortEnumType>;
  acAtinvoice?: InputMaybe<SortEnumType>;
  acAtorder?: InputMaybe<SortEnumType>;
  acAtstock?: InputMaybe<SortEnumType>;
  acBankBranch?: InputMaybe<SortEnumType>;
  acCerPub?: InputMaybe<SortEnumType>;
  acCerTime?: InputMaybe<SortEnumType>;
  acCode?: InputMaybe<SortEnumType>;
  acDefLang?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acForeigner?: InputMaybe<SortEnumType>;
  acFunction?: InputMaybe<SortEnumType>;
  acLangId?: InputMaybe<SortEnumType>;
  acLicDataBase?: InputMaybe<SortEnumType>;
  acMiddle?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acPassword?: InputMaybe<SortEnumType>;
  acPersonal?: InputMaybe<SortEnumType>;
  acPin?: InputMaybe<SortEnumType>;
  acPost?: InputMaybe<SortEnumType>;
  acPrefix?: InputMaybe<SortEnumType>;
  acProfile?: InputMaybe<SortEnumType>;
  acRegNo?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acSubjectNavigation?: InputMaybe<THeSetSubjSortInput>;
  acSurname?: InputMaybe<SortEnumType>;
  acUserId?: InputMaybe<SortEnumType>;
  acWebUserId?: InputMaybe<SortEnumType>;
  acWorkerContact?: InputMaybe<SortEnumType>;
  adBday?: InputMaybe<SortEnumType>;
  adGdprconfirm?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anMaxRebate?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserGroup?: InputMaybe<SortEnumType>;
  anUserId?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeSetSubjFilterInput {
  acActive?: InputMaybe<StringOperationFilterInput>;
  acAddress?: InputMaybe<StringOperationFilterInput>;
  acBuyer?: InputMaybe<StringOperationFilterInput>;
  acBuyerLimitCtrl?: InputMaybe<StringOperationFilterInput>;
  acCode?: InputMaybe<StringOperationFilterInput>;
  acCountry?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDelivery?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acFax?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSf?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFieldSj?: InputMaybe<StringOperationFilterInput>;
  acHttpPath?: InputMaybe<StringOperationFilterInput>;
  acName2?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetFilterInput>;
  acPayer?: InputMaybe<StringOperationFilterInput>;
  acPayerNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acPhone?: InputMaybe<StringOperationFilterInput>;
  acPin?: InputMaybe<StringOperationFilterInput>;
  acPost?: InputMaybe<StringOperationFilterInput>;
  acPostNavigation?: InputMaybe<THeSetPostCodeFilterInput>;
  acPriceRate?: InputMaybe<StringOperationFilterInput>;
  acSkis?: InputMaybe<StringOperationFilterInput>;
  acSubjTypeBuyer?: InputMaybe<StringOperationFilterInput>;
  acSubjTypeBuyerNavigation?: InputMaybe<THeSetSubjTypeFilterInput>;
  acSubjTypeSupp?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acSupplier?: InputMaybe<StringOperationFilterInput>;
  acVatCodePrefix?: InputMaybe<StringOperationFilterInput>;
  acWarehouse?: InputMaybe<StringOperationFilterInput>;
  acWayOfSale?: InputMaybe<StringOperationFilterInput>;
  adFieldDa?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDb?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactFilterInput>;
  anDaysForPayment?: InputMaybe<ComparableInt32OperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNd?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNe?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNf?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNg?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNh?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNi?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNj?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anLatitude?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anLimit?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anLongitude?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetSubjFilterInput>>;
  inverseAcPayerNavigation?: InputMaybe<ListFilterInputTypeOfTHeSetSubjFilterInput>;
  or?: InputMaybe<Array<THeSetSubjFilterInput>>;
  tHeCostDrvAcConsigneeNavigation?: InputMaybe<ListFilterInputTypeOfTHeCostDrvFilterInput>;
  tHeCostDrvAcDeptNavigation?: InputMaybe<ListFilterInputTypeOfTHeCostDrvFilterInput>;
  tHeMoveAcDeptNavigation?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeMoveAcDeptOutNavigations?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeMoveAcIssuerNavigation?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeMoveAcPrsn3Navigation?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeMoveAcReceiverNavigation?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeOrderAcConsigneeNavigation?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
  tHeOrderAcDeptNavigation?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
  tHeOrderAcReceiverNavigation?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
  tHeSetSubjContactAcSubjectNavigations?: InputMaybe<ListFilterInputTypeOfTHeSetSubjContactFilterInput>;
  tHeSetSubjPriceCategs?: InputMaybe<ListFilterInputTypeOfTHeSetSubjPriceCategFilterInput>;
  tHeSetSubjPriceItem?: InputMaybe<ListFilterInputTypeOfTHeSetSubjPriceItemFilterInput>;
  tHeStockRes?: InputMaybe<ListFilterInputTypeOfTHeStockFilterInput>;
  tHeSubjTypes?: InputMaybe<ListFilterInputTypeOfTHeSubjTypeFilterInput>;
  tHfPlanAcConsigneeNavigations?: InputMaybe<ListFilterInputTypeOfTHfPlanFilterInput>;
  tHfPlanAcDeptNavigations?: InputMaybe<ListFilterInputTypeOfTHfPlanFilterInput>;
  tHfPlanAcReceiverNavigations?: InputMaybe<ListFilterInputTypeOfTHfPlanFilterInput>;
  tHfWoexAcConsigneeNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
  tHfWoexAcDeptNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
  tHfWoexAcReceiverNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
  tHfWoexItems?: InputMaybe<ListFilterInputTypeOfTHfWoexItemFilterInput>;
  tHrPrsnAcWorkerNavigation?: InputMaybe<THrPrsnFilterInput>;
}

/** A connection to a list of items. */
declare interface THeSetSubjPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetSubjPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetSubj>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeSetSubjPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetSubj>;
}

/** A connection to a list of items. */
declare interface THeSetSubjPagedParametrizedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetSubjPagedParametrizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetSubj>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** A connection to a list of items. */
declare interface THeSetSubjPagedParametrizedDtoConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetSubjPagedParametrizedDtoEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetSubj>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeSetSubjPagedParametrizedDtoEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetSubj>;
}

declare interface THeSetSubjPagedParametrizedDtoInput {
  acBuyer?: InputMaybe<Scalars['String']>;
  acConsigneeInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acDept?: InputMaybe<Scalars['String']>;
  acDeptInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acDeptOutInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acFieldSa?: InputMaybe<Scalars['String']>;
  acIssuerInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acPayer?: InputMaybe<Scalars['String']>;
  acPrsn3InDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acReceiverInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acSubject?: InputMaybe<Scalars['String']>;
  acSupplier?: InputMaybe<Scalars['String']>;
  acWarehouse?: InputMaybe<Scalars['String']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  anClerks?: InputMaybe<Array<Scalars['Int']>>;
  byAcSkis?: InputMaybe<Scalars['String']>;
  byPrefix?: InputMaybe<Scalars['String']>;
}

/** An edge in a connection. */
declare interface THeSetSubjPagedParametrizedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetSubj>;
}

declare interface THeSetSubjPriceCateg {
  acClassif?: Maybe<Scalars['String']>;
  acClassifNavigation?: Maybe<THeSetItemCateg>;
  acCurrency?: Maybe<Scalars['String']>;
  acFormula?: Maybe<Scalars['String']>;
  acInvoInOut?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acSetOf?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acSubjectNavigation?: Maybe<THeSetSubj>;
  acType?: Maybe<Scalars['String']>;
  adDateEnd?: Maybe<Scalars['DateTime']>;
  adDateStart: Scalars['DateTime'];
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDeliveryDeadline: Scalars['Int'];
  anPaymentDeadline: Scalars['Int'];
  anPrice: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anRebate: Scalars['Decimal'];
  anRebate2: Scalars['Decimal'];
  anRebate3: Scalars['Decimal'];
  anSalePrice?: Maybe<Scalars['Decimal']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THeSetSubjPriceCategFilterInput {
  acClassif?: InputMaybe<StringOperationFilterInput>;
  acClassifNavigation?: InputMaybe<THeSetItemCategFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acFormula?: InputMaybe<StringOperationFilterInput>;
  acInvoInOut?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acSetOf?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acSubjectNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adDateEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateStart?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDeliveryDeadline?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPaymentDeadline?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRebate2?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRebate3?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anSalePrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetSubjPriceCategFilterInput>>;
  or?: InputMaybe<Array<THeSetSubjPriceCategFilterInput>>;
}

declare interface THeSetSubjPriceItem {
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acInvoInOut?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acSubjectNavigation?: Maybe<THeSetSubj>;
  adDateEnd?: Maybe<Scalars['DateTime']>;
  adDateStart: Scalars['DateTime'];
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anPrice: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anRebate: Scalars['Decimal'];
  anSalePrice?: Maybe<Scalars['Decimal']>;
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THeSetSubjPriceItemFilterInput {
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acInvoInOut?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acSubjectNavigation?: InputMaybe<THeSetSubjFilterInput>;
  adDateEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateStart?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anSalePrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetSubjPriceItemFilterInput>>;
  or?: InputMaybe<Array<THeSetSubjPriceItemFilterInput>>;
}

declare interface THeSetSubjPriceItemSortInput {
  acIdent?: InputMaybe<SortEnumType>;
  acIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acInvoInOut?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acSubjectNavigation?: InputMaybe<THeSetSubjSortInput>;
  adDateEnd?: InputMaybe<SortEnumType>;
  adDateStart?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anPrice?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anSalePrice?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeSetSubjSortInput {
  acActive?: InputMaybe<SortEnumType>;
  acAddress?: InputMaybe<SortEnumType>;
  acBuyer?: InputMaybe<SortEnumType>;
  acBuyerLimitCtrl?: InputMaybe<SortEnumType>;
  acCode?: InputMaybe<SortEnumType>;
  acCountry?: InputMaybe<SortEnumType>;
  acCurrency?: InputMaybe<SortEnumType>;
  acDelivery?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acFax?: InputMaybe<SortEnumType>;
  acFieldSa?: InputMaybe<SortEnumType>;
  acFieldSb?: InputMaybe<SortEnumType>;
  acFieldSc?: InputMaybe<SortEnumType>;
  acFieldSd?: InputMaybe<SortEnumType>;
  acFieldSe?: InputMaybe<SortEnumType>;
  acFieldSf?: InputMaybe<SortEnumType>;
  acFieldSg?: InputMaybe<SortEnumType>;
  acFieldSh?: InputMaybe<SortEnumType>;
  acFieldSi?: InputMaybe<SortEnumType>;
  acFieldSj?: InputMaybe<SortEnumType>;
  acHttpPath?: InputMaybe<SortEnumType>;
  acName2?: InputMaybe<SortEnumType>;
  acPayMethod?: InputMaybe<SortEnumType>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetSortInput>;
  acPayer?: InputMaybe<SortEnumType>;
  acPayerNavigation?: InputMaybe<THeSetSubjSortInput>;
  acPhone?: InputMaybe<SortEnumType>;
  acPin?: InputMaybe<SortEnumType>;
  acPost?: InputMaybe<SortEnumType>;
  acPostNavigation?: InputMaybe<THeSetPostCodeSortInput>;
  acPriceRate?: InputMaybe<SortEnumType>;
  acSkis?: InputMaybe<SortEnumType>;
  acSubjTypeBuyer?: InputMaybe<SortEnumType>;
  acSubjTypeBuyerNavigation?: InputMaybe<THeSetSubjTypeSortInput>;
  acSubjTypeSupp?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acSupplier?: InputMaybe<SortEnumType>;
  acVatCodePrefix?: InputMaybe<SortEnumType>;
  acWarehouse?: InputMaybe<SortEnumType>;
  acWayOfSale?: InputMaybe<SortEnumType>;
  adFieldDa?: InputMaybe<SortEnumType>;
  adFieldDb?: InputMaybe<SortEnumType>;
  adFieldDc?: InputMaybe<SortEnumType>;
  adFieldDd?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactSortInput>;
  anDaysForPayment?: InputMaybe<SortEnumType>;
  anFieldNa?: InputMaybe<SortEnumType>;
  anFieldNb?: InputMaybe<SortEnumType>;
  anFieldNc?: InputMaybe<SortEnumType>;
  anFieldNd?: InputMaybe<SortEnumType>;
  anFieldNe?: InputMaybe<SortEnumType>;
  anFieldNf?: InputMaybe<SortEnumType>;
  anFieldNg?: InputMaybe<SortEnumType>;
  anFieldNh?: InputMaybe<SortEnumType>;
  anFieldNi?: InputMaybe<SortEnumType>;
  anFieldNj?: InputMaybe<SortEnumType>;
  anLatitude?: InputMaybe<SortEnumType>;
  anLimit?: InputMaybe<SortEnumType>;
  anLongitude?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  tHrPrsnAcWorkerNavigation?: InputMaybe<THrPrsnSortInput>;
}

declare interface THeSetSubjType {
  acName?: Maybe<Scalars['String']>;
  acSubjType?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  tHeSetSubjAcSubjTypeBuyerNavigations?: Maybe<Array<Maybe<THeSetSubj>>>;
}

declare interface THeSetSubjTypeFilterInput {
  acName?: InputMaybe<StringOperationFilterInput>;
  acSubjType?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<THeSetSubjTypeFilterInput>>;
  or?: InputMaybe<Array<THeSetSubjTypeFilterInput>>;
  tHeSetSubjAcSubjTypeBuyerNavigations?: InputMaybe<ListFilterInputTypeOfTHeSetSubjFilterInput>;
}

declare interface THeSetSubjTypeSortInput {
  acName?: InputMaybe<SortEnumType>;
  acSubjType?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
}

declare interface THeSetTax {
  acAcctCr?: Maybe<Scalars['String']>;
  acAcctInclVatcr?: Maybe<Scalars['String']>;
  acAcctInclVatdb?: Maybe<Scalars['String']>;
  acActive?: Maybe<Scalars['String']>;
  acAnnulment?: Maybe<Scalars['String']>;
  acAsls?: Maybe<Scalars['String']>;
  acBadDebt?: Maybe<Scalars['String']>;
  acBanato?: Maybe<Scalars['String']>;
  acBefReg?: Maybe<Scalars['String']>;
  acDebitCreditNote?: Maybe<Scalars['String']>;
  acDeductibility?: Maybe<Scalars['String']>;
  acDistSaleEu?: Maybe<Scalars['String']>;
  acDistingVat?: Maybe<Scalars['String']>;
  acElectronicServ?: Maybe<Scalars['String']>;
  acExemptions?: Maybe<Scalars['String']>;
  acFa?: Maybe<Scalars['String']>;
  acFaownUsage?: Maybe<Scalars['String']>;
  acField37?: Maybe<Scalars['String']>;
  acFiscalCode?: Maybe<Scalars['String']>;
  acFoodDonation?: Maybe<Scalars['String']>;
  acFreed?: Maybe<Scalars['String']>;
  acHideRecapitulation?: Maybe<Scalars['String']>;
  acInitialStock?: Maybe<Scalars['String']>;
  acInternationalShipping?: Maybe<Scalars['String']>;
  acIntlTrans?: Maybe<Scalars['String']>;
  acInvestive?: Maybe<Scalars['String']>;
  acIpafond?: Maybe<Scalars['String']>;
  acIsService?: Maybe<Scalars['String']>;
  acIsVatcalc?: Maybe<Scalars['String']>;
  acIsVatcount?: Maybe<Scalars['String']>;
  acLegalTransactions?: Maybe<Scalars['String']>;
  acLicenses?: Maybe<Scalars['String']>;
  acLumpCompen?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNewTransportMeans?: Maybe<Scalars['String']>;
  acNonChargable?: Maybe<Scalars['String']>;
  acOtherPayFreed?: Maybe<Scalars['String']>;
  acOtherPreliminary?: Maybe<Scalars['String']>;
  acOtherServices?: Maybe<Scalars['String']>;
  acOverallAssets?: Maybe<Scalars['String']>;
  acPartialTax?: Maybe<Scalars['String']>;
  acPrintPosOnDocs?: Maybe<Scalars['String']>;
  acPublicInterest?: Maybe<Scalars['String']>;
  acRealEstate?: Maybe<Scalars['String']>;
  acScrap?: Maybe<Scalars['String']>;
  acSerExpDisp?: Maybe<Scalars['String']>;
  acShipping?: Maybe<Scalars['String']>;
  acShowVatdeducInreceive?: Maybe<Scalars['String']>;
  acSpecSchema?: Maybe<Scalars['String']>;
  acStatement?: Maybe<Scalars['String']>;
  acStatementNavigation?: Maybe<THeSetDocText>;
  acSyntheticsGoods?: Maybe<Scalars['String']>;
  acTaxDebt?: Maybe<Scalars['String']>;
  acTourismAgency?: Maybe<Scalars['String']>;
  acTypeOfVatRate?: Maybe<Scalars['String']>;
  acUnauthVat?: Maybe<Scalars['String']>;
  acUsedGoods?: Maybe<Scalars['String']>;
  acUsedMotorVehicle?: Maybe<Scalars['String']>;
  acVatadjustments?: Maybe<Scalars['String']>;
  acVatafterDeduction?: Maybe<Scalars['String']>;
  acVatcalcReceiver?: Maybe<Scalars['String']>;
  acVatcode?: Maybe<Scalars['String']>;
  acVateu?: Maybe<Scalars['String']>;
  acVatnoCode?: Maybe<Scalars['String']>;
  acVatnotAdmit?: Maybe<Scalars['String']>;
  acVatpost?: Maybe<Scalars['String']>;
  acVatrefund?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anVat: Scalars['Decimal'];
  anVatpdv?: Maybe<Scalars['Decimal']>;
  tHeMoveItemAcVatcodeNavigations?: Maybe<Array<Maybe<THeMoveItem>>>;
  tHeMoveItemAcVatcodeTrNavigations?: Maybe<Array<Maybe<THeMoveItem>>>;
  tHeSetItemAcVatcodeNavigations?: Maybe<Array<Maybe<THeSetItem>>>;
}

declare interface THeSetTaxFilterInput {
  acAcctCr?: InputMaybe<StringOperationFilterInput>;
  acAcctInclVatcr?: InputMaybe<StringOperationFilterInput>;
  acAcctInclVatdb?: InputMaybe<StringOperationFilterInput>;
  acActive?: InputMaybe<StringOperationFilterInput>;
  acAnnulment?: InputMaybe<StringOperationFilterInput>;
  acAsls?: InputMaybe<StringOperationFilterInput>;
  acBadDebt?: InputMaybe<StringOperationFilterInput>;
  acBanato?: InputMaybe<StringOperationFilterInput>;
  acBefReg?: InputMaybe<StringOperationFilterInput>;
  acDebitCreditNote?: InputMaybe<StringOperationFilterInput>;
  acDeductibility?: InputMaybe<StringOperationFilterInput>;
  acDistSaleEu?: InputMaybe<StringOperationFilterInput>;
  acDistingVat?: InputMaybe<StringOperationFilterInput>;
  acElectronicServ?: InputMaybe<StringOperationFilterInput>;
  acExemptions?: InputMaybe<StringOperationFilterInput>;
  acFa?: InputMaybe<StringOperationFilterInput>;
  acFaownUsage?: InputMaybe<StringOperationFilterInput>;
  acField37?: InputMaybe<StringOperationFilterInput>;
  acFiscalCode?: InputMaybe<StringOperationFilterInput>;
  acFoodDonation?: InputMaybe<StringOperationFilterInput>;
  acFreed?: InputMaybe<StringOperationFilterInput>;
  acHideRecapitulation?: InputMaybe<StringOperationFilterInput>;
  acInitialStock?: InputMaybe<StringOperationFilterInput>;
  acInternationalShipping?: InputMaybe<StringOperationFilterInput>;
  acIntlTrans?: InputMaybe<StringOperationFilterInput>;
  acInvestive?: InputMaybe<StringOperationFilterInput>;
  acIpafond?: InputMaybe<StringOperationFilterInput>;
  acIsService?: InputMaybe<StringOperationFilterInput>;
  acIsVatcalc?: InputMaybe<StringOperationFilterInput>;
  acIsVatcount?: InputMaybe<StringOperationFilterInput>;
  acLegalTransactions?: InputMaybe<StringOperationFilterInput>;
  acLicenses?: InputMaybe<StringOperationFilterInput>;
  acLumpCompen?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acNewTransportMeans?: InputMaybe<StringOperationFilterInput>;
  acNonChargable?: InputMaybe<StringOperationFilterInput>;
  acOtherPayFreed?: InputMaybe<StringOperationFilterInput>;
  acOtherPreliminary?: InputMaybe<StringOperationFilterInput>;
  acOtherServices?: InputMaybe<StringOperationFilterInput>;
  acOverallAssets?: InputMaybe<StringOperationFilterInput>;
  acPartialTax?: InputMaybe<StringOperationFilterInput>;
  acPrintPosOnDocs?: InputMaybe<StringOperationFilterInput>;
  acPublicInterest?: InputMaybe<StringOperationFilterInput>;
  acRealEstate?: InputMaybe<StringOperationFilterInput>;
  acScrap?: InputMaybe<StringOperationFilterInput>;
  acSerExpDisp?: InputMaybe<StringOperationFilterInput>;
  acShipping?: InputMaybe<StringOperationFilterInput>;
  acShowVatdeducInreceive?: InputMaybe<StringOperationFilterInput>;
  acSpecSchema?: InputMaybe<StringOperationFilterInput>;
  acStatement?: InputMaybe<StringOperationFilterInput>;
  acStatementNavigation?: InputMaybe<THeSetDocTextFilterInput>;
  acSyntheticsGoods?: InputMaybe<StringOperationFilterInput>;
  acTaxDebt?: InputMaybe<StringOperationFilterInput>;
  acTourismAgency?: InputMaybe<StringOperationFilterInput>;
  acTypeOfVatRate?: InputMaybe<StringOperationFilterInput>;
  acUnauthVat?: InputMaybe<StringOperationFilterInput>;
  acUsedGoods?: InputMaybe<StringOperationFilterInput>;
  acUsedMotorVehicle?: InputMaybe<StringOperationFilterInput>;
  acVatadjustments?: InputMaybe<StringOperationFilterInput>;
  acVatafterDeduction?: InputMaybe<StringOperationFilterInput>;
  acVatcalcReceiver?: InputMaybe<StringOperationFilterInput>;
  acVatcode?: InputMaybe<StringOperationFilterInput>;
  acVateu?: InputMaybe<StringOperationFilterInput>;
  acVatnoCode?: InputMaybe<StringOperationFilterInput>;
  acVatnotAdmit?: InputMaybe<StringOperationFilterInput>;
  acVatpost?: InputMaybe<StringOperationFilterInput>;
  acVatrefund?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anVat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVatpdv?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  and?: InputMaybe<Array<THeSetTaxFilterInput>>;
  or?: InputMaybe<Array<THeSetTaxFilterInput>>;
  tHeMoveItemAcVatcodeNavigations?: InputMaybe<ListFilterInputTypeOfTHeMoveItemFilterInput>;
  tHeMoveItemAcVatcodeTrNavigations?: InputMaybe<ListFilterInputTypeOfTHeMoveItemFilterInput>;
  tHeSetItemAcVatcodeNavigations?: InputMaybe<ListFilterInputTypeOfTHeSetItemFilterInput>;
}

declare interface THeSetTaxSortInput {
  acAcctCr?: InputMaybe<SortEnumType>;
  acAcctInclVatcr?: InputMaybe<SortEnumType>;
  acAcctInclVatdb?: InputMaybe<SortEnumType>;
  acActive?: InputMaybe<SortEnumType>;
  acAnnulment?: InputMaybe<SortEnumType>;
  acAsls?: InputMaybe<SortEnumType>;
  acBadDebt?: InputMaybe<SortEnumType>;
  acBanato?: InputMaybe<SortEnumType>;
  acBefReg?: InputMaybe<SortEnumType>;
  acDebitCreditNote?: InputMaybe<SortEnumType>;
  acDeductibility?: InputMaybe<SortEnumType>;
  acDistSaleEu?: InputMaybe<SortEnumType>;
  acDistingVat?: InputMaybe<SortEnumType>;
  acElectronicServ?: InputMaybe<SortEnumType>;
  acExemptions?: InputMaybe<SortEnumType>;
  acFa?: InputMaybe<SortEnumType>;
  acFaownUsage?: InputMaybe<SortEnumType>;
  acField37?: InputMaybe<SortEnumType>;
  acFiscalCode?: InputMaybe<SortEnumType>;
  acFoodDonation?: InputMaybe<SortEnumType>;
  acFreed?: InputMaybe<SortEnumType>;
  acHideRecapitulation?: InputMaybe<SortEnumType>;
  acInitialStock?: InputMaybe<SortEnumType>;
  acInternationalShipping?: InputMaybe<SortEnumType>;
  acIntlTrans?: InputMaybe<SortEnumType>;
  acInvestive?: InputMaybe<SortEnumType>;
  acIpafond?: InputMaybe<SortEnumType>;
  acIsService?: InputMaybe<SortEnumType>;
  acIsVatcalc?: InputMaybe<SortEnumType>;
  acIsVatcount?: InputMaybe<SortEnumType>;
  acLegalTransactions?: InputMaybe<SortEnumType>;
  acLicenses?: InputMaybe<SortEnumType>;
  acLumpCompen?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acNewTransportMeans?: InputMaybe<SortEnumType>;
  acNonChargable?: InputMaybe<SortEnumType>;
  acOtherPayFreed?: InputMaybe<SortEnumType>;
  acOtherPreliminary?: InputMaybe<SortEnumType>;
  acOtherServices?: InputMaybe<SortEnumType>;
  acOverallAssets?: InputMaybe<SortEnumType>;
  acPartialTax?: InputMaybe<SortEnumType>;
  acPrintPosOnDocs?: InputMaybe<SortEnumType>;
  acPublicInterest?: InputMaybe<SortEnumType>;
  acRealEstate?: InputMaybe<SortEnumType>;
  acScrap?: InputMaybe<SortEnumType>;
  acSerExpDisp?: InputMaybe<SortEnumType>;
  acShipping?: InputMaybe<SortEnumType>;
  acShowVatdeducInreceive?: InputMaybe<SortEnumType>;
  acSpecSchema?: InputMaybe<SortEnumType>;
  acStatement?: InputMaybe<SortEnumType>;
  acStatementNavigation?: InputMaybe<THeSetDocTextSortInput>;
  acSyntheticsGoods?: InputMaybe<SortEnumType>;
  acTaxDebt?: InputMaybe<SortEnumType>;
  acTourismAgency?: InputMaybe<SortEnumType>;
  acTypeOfVatRate?: InputMaybe<SortEnumType>;
  acUnauthVat?: InputMaybe<SortEnumType>;
  acUsedGoods?: InputMaybe<SortEnumType>;
  acUsedMotorVehicle?: InputMaybe<SortEnumType>;
  acVatadjustments?: InputMaybe<SortEnumType>;
  acVatafterDeduction?: InputMaybe<SortEnumType>;
  acVatcalcReceiver?: InputMaybe<SortEnumType>;
  acVatcode?: InputMaybe<SortEnumType>;
  acVateu?: InputMaybe<SortEnumType>;
  acVatnoCode?: InputMaybe<SortEnumType>;
  acVatnotAdmit?: InputMaybe<SortEnumType>;
  acVatpost?: InputMaybe<SortEnumType>;
  acVatrefund?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anVat?: InputMaybe<SortEnumType>;
  anVatpdv?: InputMaybe<SortEnumType>;
}

declare interface THeSetUm {
  acFiscalCode?: Maybe<Scalars['String']>;
  acInterUm?: Maybe<Scalars['String']>;
  acInterUm2?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acStdUm?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  acUmoriginal?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDecPlaces: Scalars['Decimal'];
  anMinValue?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeSetItemAcUm2Navigations?: Maybe<Array<Maybe<THeSetItem>>>;
  tHeSetItemAcUmNavigations?: Maybe<Array<Maybe<THeSetItem>>>;
  tHfWoexItemAcUm3Navigations?: Maybe<Array<Maybe<THfWoexItem>>>;
  tHfWoexItemAcUmNavigations?: Maybe<Array<Maybe<THfWoexItem>>>;
  tHfWoexes?: Maybe<Array<Maybe<THfWoex>>>;
}

declare interface THeSetUmFilterInput {
  acFiscalCode?: InputMaybe<StringOperationFilterInput>;
  acInterUm?: InputMaybe<StringOperationFilterInput>;
  acInterUm2?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acStdUm?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  acUmoriginal?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDecPlaces?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMinValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetUmFilterInput>>;
  or?: InputMaybe<Array<THeSetUmFilterInput>>;
  tHeSetItemAcUm2Navigations?: InputMaybe<ListFilterInputTypeOfTHeSetItemFilterInput>;
  tHeSetItemAcUmNavigations?: InputMaybe<ListFilterInputTypeOfTHeSetItemFilterInput>;
  tHfWoexItemAcUm3Navigations?: InputMaybe<ListFilterInputTypeOfTHfWoexItemFilterInput>;
  tHfWoexItemAcUmNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexItemFilterInput>;
  tHfWoexes?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
}

declare interface THeSetUmSortInput {
  acFiscalCode?: InputMaybe<SortEnumType>;
  acInterUm?: InputMaybe<SortEnumType>;
  acInterUm2?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acStdUm?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  acUmoriginal?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anDecPlaces?: InputMaybe<SortEnumType>;
  anMinValue?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THeStock {
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acWarehouse?: Maybe<Scalars['String']>;
  acWarehouseNavigation?: Maybe<THeSetSubj>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anLastPrice: Scalars['Float'];
  anMaxStock: Scalars['Decimal'];
  anMinStock: Scalars['Decimal'];
  anOptStock: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anReserved: Scalars['Decimal'];
  anStock: Scalars['Decimal'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Float'];
}

declare interface THeStockFilterInput {
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acWarehouse?: InputMaybe<StringOperationFilterInput>;
  acWarehouseNavigation?: InputMaybe<THeSetSubjFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anLastPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anMaxStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMinStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anOptStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anReserved?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THeStockFilterInput>>;
  or?: InputMaybe<Array<THeStockFilterInput>>;
}

/** A connection to a list of items. */
declare interface THeStockPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeStockPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeStock>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeStockPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeStock>;
}

declare interface THeStockSerialNo {
  acFree?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acSerialNo?: Maybe<Scalars['String']>;
  acWarehouse?: Maybe<Scalars['String']>;
  adDateDue: Scalars['DateTime'];
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anReserved: Scalars['Decimal'];
  anStock: Scalars['Decimal'];
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THeStockSerialNoFilterInput {
  acFree?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acSerialNo?: InputMaybe<StringOperationFilterInput>;
  acWarehouse?: InputMaybe<StringOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anReserved?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeStockSerialNoFilterInput>>;
  or?: InputMaybe<Array<THeStockSerialNoFilterInput>>;
}

declare interface THeStockSerialNoSortInput {
  acFree?: InputMaybe<SortEnumType>;
  acIdent?: InputMaybe<SortEnumType>;
  acIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acSerialNo?: InputMaybe<SortEnumType>;
  acWarehouse?: InputMaybe<SortEnumType>;
  adDateDue?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anReserved?: InputMaybe<SortEnumType>;
  anStock?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

/** A connection to a list of items. */
declare interface THeStockSerialNosPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeStockSerialNosPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeStockSerialNo>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeStockSerialNosPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeStockSerialNo>;
}

/** A connection to a list of items. */
declare interface THeStockSerialNosPagedParametrizedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THeStockSerialNosPagedParametrizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeStockSerialNo>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THeStockSerialNosPagedParametrizedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeStockSerialNo>;
}

declare interface THeStockSortInput {
  acIdent?: InputMaybe<SortEnumType>;
  acIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acWarehouse?: InputMaybe<SortEnumType>;
  acWarehouseNavigation?: InputMaybe<THeSetSubjSortInput>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anLastPrice?: InputMaybe<SortEnumType>;
  anMaxStock?: InputMaybe<SortEnumType>;
  anMinStock?: InputMaybe<SortEnumType>;
  anOptStock?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anReserved?: InputMaybe<SortEnumType>;
  anStock?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anValue?: InputMaybe<SortEnumType>;
}

declare interface THeSubjType {
  acSubjType?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQId: Scalars['Int'];
  anSortNo?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  subjTypeNavigation?: Maybe<THeSetSubjType>;
  subject?: Maybe<THeSetSubj>;
}

declare interface THeSubjTypeFilterInput {
  acSubjType?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anSortNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSubjTypeFilterInput>>;
  or?: InputMaybe<Array<THeSubjTypeFilterInput>>;
  subjTypeNavigation?: InputMaybe<THeSetSubjTypeFilterInput>;
  subject?: InputMaybe<THeSetSubjFilterInput>;
}

declare interface THfPlan {
  acConsignee?: Maybe<Scalars['String']>;
  acConsigneeNavigation?: Maybe<THeSetSubj>;
  acCostDrv?: Maybe<Scalars['String']>;
  acCostDrvNavigation?: Maybe<THeCostDrv>;
  acDept?: Maybe<Scalars['String']>;
  acDeptNavigation?: Maybe<THeSetSubj>;
  acDescr?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acDocTypeNavigation?: Maybe<TPaSetDocType>;
  acKey?: Maybe<Scalars['String']>;
  acKeyView?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acParentPlan?: Maybe<Scalars['String']>;
  acParentPlanNavigation?: Maybe<THfPlan>;
  acPlannedBom?: Maybe<Scalars['String']>;
  acPlannedCap?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverNavigation?: Maybe<THeSetSubj>;
  acScheduled?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adPlannedBomtime?: Maybe<Scalars['DateTime']>;
  adPlannedCapTime?: Maybe<Scalars['DateTime']>;
  adSchedEndTime?: Maybe<Scalars['DateTime']>;
  adSchedStartTime?: Maybe<Scalars['DateTime']>;
  adScheduledTime?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClerk: Scalars['Int'];
  anClerkNavigation?: Maybe<THeSetSubjContact>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  inverseAcParentPlanNavigation?: Maybe<Array<Maybe<THfPlan>>>;
  tHfWoexes?: Maybe<Array<Maybe<THfWoex>>>;
}

declare interface THfPlanFilterInput {
  acConsignee?: InputMaybe<StringOperationFilterInput>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acCostDrvNavigation?: InputMaybe<THeCostDrvFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDeptNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acDescr?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyView?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acParentPlan?: InputMaybe<StringOperationFilterInput>;
  acParentPlanNavigation?: InputMaybe<THfPlanFilterInput>;
  acPlannedBom?: InputMaybe<StringOperationFilterInput>;
  acPlannedCap?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acScheduled?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adPlannedBomtime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adPlannedCapTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSchedEndTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSchedStartTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adScheduledTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClerk?: InputMaybe<ComparableInt32OperationFilterInput>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THfPlanFilterInput>>;
  inverseAcParentPlanNavigation?: InputMaybe<ListFilterInputTypeOfTHfPlanFilterInput>;
  or?: InputMaybe<Array<THfPlanFilterInput>>;
  tHfWoexes?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
}

declare interface THfPlanSortInput {
  acConsignee?: InputMaybe<SortEnumType>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjSortInput>;
  acCostDrv?: InputMaybe<SortEnumType>;
  acCostDrvNavigation?: InputMaybe<THeCostDrvSortInput>;
  acDept?: InputMaybe<SortEnumType>;
  acDeptNavigation?: InputMaybe<THeSetSubjSortInput>;
  acDescr?: InputMaybe<SortEnumType>;
  acDocType?: InputMaybe<SortEnumType>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeSortInput>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyView?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acParentPlan?: InputMaybe<SortEnumType>;
  acParentPlanNavigation?: InputMaybe<THfPlanSortInput>;
  acPlannedBom?: InputMaybe<SortEnumType>;
  acPlannedCap?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverNavigation?: InputMaybe<THeSetSubjSortInput>;
  acScheduled?: InputMaybe<SortEnumType>;
  acStatus?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adPlannedBomtime?: InputMaybe<SortEnumType>;
  adPlannedCapTime?: InputMaybe<SortEnumType>;
  adSchedEndTime?: InputMaybe<SortEnumType>;
  adSchedStartTime?: InputMaybe<SortEnumType>;
  adScheduledTime?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactSortInput>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THfWoex {
  acBuyOrdId?: Maybe<Scalars['String']>;
  acConsignee?: Maybe<Scalars['String']>;
  acConsigneeNavigation?: Maybe<THeSetSubj>;
  acCostDrv?: Maybe<Scalars['String']>;
  acCostDrvNavigation?: Maybe<THeCostDrv>;
  acCreateFrom?: Maybe<Scalars['String']>;
  acCropType?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDeptNavigation?: Maybe<THeSetSubj>;
  acDocType?: Maybe<Scalars['String']>;
  acDocTypeNavigation?: Maybe<TPaSetDocType>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acKey?: Maybe<Scalars['String']>;
  acKeyView?: Maybe<Scalars['String']>;
  acLnkKey?: Maybe<Scalars['String']>;
  acLnkPrStIdentParent?: Maybe<Scalars['String']>;
  acLnkPrStIdentParentNavigation?: Maybe<THeSetItem>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acParentWo?: Maybe<Scalars['String']>;
  acPlan?: Maybe<THfPlan>;
  acPlanId?: Maybe<Scalars['String']>;
  acProdVariant?: Maybe<Scalars['String']>;
  acReceiveFinished?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverNavigation?: Maybe<THeSetSubj>;
  acReversal?: Maybe<Scalars['String']>;
  acScrapIdent?: Maybe<Scalars['String']>;
  acScrapIdentNavigation?: Maybe<THeSetItem>;
  acStatus?: Maybe<Scalars['String']>;
  acStatusMf?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  acUmNavigation?: Maybe<THeSetUm>;
  adDate?: Maybe<Scalars['DateTime']>;
  adLnkDate?: Maybe<Scalars['DateTime']>;
  adSchedEndTime?: Maybe<Scalars['DateTime']>;
  adSchedStartTime?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  adWofinishDate?: Maybe<Scalars['DateTime']>;
  anFieldNa?: Maybe<Scalars['Decimal']>;
  anLnkNo?: Maybe<Scalars['Int']>;
  anLnkPrStNo?: Maybe<Scalars['Int']>;
  anLnkPrStNoParent?: Maybe<Scalars['Int']>;
  anLnkPrStSubNo?: Maybe<Scalars['Int']>;
  anNo?: Maybe<Scalars['Int']>;
  anParentWoqty?: Maybe<Scalars['Decimal']>;
  anPlanQty?: Maybe<Scalars['Decimal']>;
  anPlanScrapQty?: Maybe<Scalars['Decimal']>;
  anPlanWasteQty?: Maybe<Scalars['Decimal']>;
  anPriority: Scalars['Byte'];
  anProducedQty?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anQidCa?: Maybe<Scalars['Int']>;
  anQtySeries?: Maybe<Scalars['Decimal']>;
  anRepairQty?: Maybe<Scalars['Float']>;
  anScrapQty?: Maybe<Scalars['Decimal']>;
  anSntransfer?: Maybe<Scalars['Byte']>;
  anThroTime?: Maybe<Scalars['Float']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anWasteQty?: Maybe<Scalars['Decimal']>;
  anWorkTime?: Maybe<Scalars['Float']>;
  tHfWoexItems?: Maybe<Array<Maybe<THfWoexItem>>>;
}

declare interface THfWoexFilterInput {
  acBuyOrdId?: InputMaybe<StringOperationFilterInput>;
  acConsignee?: InputMaybe<StringOperationFilterInput>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acCostDrvNavigation?: InputMaybe<THeCostDrvFilterInput>;
  acCreateFrom?: InputMaybe<StringOperationFilterInput>;
  acCropType?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDeptNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyView?: InputMaybe<StringOperationFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acLnkPrStIdentParent?: InputMaybe<StringOperationFilterInput>;
  acLnkPrStIdentParentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acParentWo?: InputMaybe<StringOperationFilterInput>;
  acPlan?: InputMaybe<THfPlanFilterInput>;
  acPlanId?: InputMaybe<StringOperationFilterInput>;
  acProdVariant?: InputMaybe<StringOperationFilterInput>;
  acReceiveFinished?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acReversal?: InputMaybe<StringOperationFilterInput>;
  acScrapIdent?: InputMaybe<StringOperationFilterInput>;
  acScrapIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acStatusMf?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  acUmNavigation?: InputMaybe<THeSetUmFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adLnkDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSchedEndTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSchedStartTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adWofinishDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anLnkNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anLnkPrStNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anLnkPrStNoParent?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anLnkPrStSubNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anParentWoqty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPlanQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPlanScrapQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPlanWasteQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPriority?: InputMaybe<ComparableByteOperationFilterInput>;
  anProducedQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQidCa?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQtySeries?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anRepairQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anScrapQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anSntransfer?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  anThroTime?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWasteQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anWorkTime?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THfWoexFilterInput>>;
  or?: InputMaybe<Array<THfWoexFilterInput>>;
  tHfWoexItems?: InputMaybe<ListFilterInputTypeOfTHfWoexItemFilterInput>;
}

declare interface THfWoexItem {
  acAgriculturalReason?: Maybe<Scalars['String']>;
  acAutoPrepType?: Maybe<Scalars['String']>;
  acDelayType?: Maybe<Scalars['String']>;
  acDescr?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFixedResource?: Maybe<Scalars['String']>;
  acFixedTime?: Maybe<Scalars['String']>;
  acGroupResursId?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acIssueFinished?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerNavigation?: Maybe<THeSetSubj>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THfWoex>;
  acKeyView?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acOperationType?: Maybe<Scalars['String']>;
  acOrigin?: Maybe<Scalars['String']>;
  acPhenologicalPhase?: Maybe<Scalars['String']>;
  acQtyFormula?: Maybe<Scalars['String']>;
  acRuleId?: Maybe<Scalars['String']>;
  acScrapIdent?: Maybe<Scalars['String']>;
  acScrapIdentNavigation?: Maybe<THeSetItem>;
  acTaskState?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  acUm3?: Maybe<Scalars['String']>;
  acUm3Navigation?: Maybe<THeSetUm>;
  acUmNavigation?: Maybe<THeSetUm>;
  acUmtime?: Maybe<Scalars['String']>;
  adEarliestStartTime?: Maybe<Scalars['DateTime']>;
  adLatestEndTime?: Maybe<Scalars['DateTime']>;
  adSchedEndTime?: Maybe<Scalars['DateTime']>;
  adSchedStartTime?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anActive?: Maybe<Scalars['Byte']>;
  anBatch?: Maybe<Scalars['Float']>;
  anDelayQty?: Maybe<Scalars['Float']>;
  anFieldNa?: Maybe<Scalars['Float']>;
  anFieldNax?: Maybe<Scalars['Float']>;
  anFieldNb?: Maybe<Scalars['Float']>;
  anFieldNc?: Maybe<Scalars['Float']>;
  anFixedScrapQty: Scalars['Float'];
  anFixedWasteQty: Scalars['Float'];
  anNo: Scalars['Int'];
  anPlanQty: Scalars['Float'];
  anPlanScrapQty?: Maybe<Scalars['Float']>;
  anPlanWasteQty?: Maybe<Scalars['Float']>;
  anPrcValue?: Maybe<Scalars['Float']>;
  anPrice?: Maybe<Scalars['Float']>;
  anQid: Scalars['Int'];
  anQidFertType?: Maybe<Scalars['Int']>;
  anQty?: Maybe<Scalars['Float']>;
  anQty1?: Maybe<Scalars['Float']>;
  anQty3?: Maybe<Scalars['Float']>;
  anQtyBase?: Maybe<Scalars['Int']>;
  anQtyBase3?: Maybe<Scalars['Int']>;
  anQtySe?: Maybe<Scalars['Float']>;
  anRebate?: Maybe<Scalars['Float']>;
  anScrapPrc?: Maybe<Scalars['Float']>;
  anScrapQty?: Maybe<Scalars['Float']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anVariant: Scalars['Byte'];
  anVariantSubLvl?: Maybe<Scalars['Byte']>;
  anWastePrc?: Maybe<Scalars['Float']>;
  anWasteQty?: Maybe<Scalars['Float']>;
  anWasteQtySe?: Maybe<Scalars['Float']>;
  tHfWoexItemSerialNos?: Maybe<Array<Maybe<THfWoexItemSerialNo>>>;
}

declare interface THfWoexItemFilterInput {
  acAgriculturalReason?: InputMaybe<StringOperationFilterInput>;
  acAutoPrepType?: InputMaybe<StringOperationFilterInput>;
  acDelayType?: InputMaybe<StringOperationFilterInput>;
  acDescr?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFixedResource?: InputMaybe<StringOperationFilterInput>;
  acFixedTime?: InputMaybe<StringOperationFilterInput>;
  acGroupResursId?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acIssueFinished?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THfWoexFilterInput>;
  acKeyView?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acOperationType?: InputMaybe<StringOperationFilterInput>;
  acOrigin?: InputMaybe<StringOperationFilterInput>;
  acPhenologicalPhase?: InputMaybe<StringOperationFilterInput>;
  acQtyFormula?: InputMaybe<StringOperationFilterInput>;
  acRuleId?: InputMaybe<StringOperationFilterInput>;
  acScrapIdent?: InputMaybe<StringOperationFilterInput>;
  acScrapIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acTaskState?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  acUm3?: InputMaybe<StringOperationFilterInput>;
  acUm3Navigation?: InputMaybe<THeSetUmFilterInput>;
  acUmNavigation?: InputMaybe<THeSetUmFilterInput>;
  acUmtime?: InputMaybe<StringOperationFilterInput>;
  adEarliestStartTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adLatestEndTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSchedEndTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSchedStartTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anActive?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  anBatch?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anDelayQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anFieldNax?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anFixedScrapQty?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anFixedWasteQty?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPlanQty?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPlanScrapQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPlanWasteQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrcValue?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrice?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQidFertType?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anQty1?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anQty3?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anQtyBase?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQtyBase3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQtySe?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anRebate?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anScrapPrc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anScrapQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anVariant?: InputMaybe<ComparableByteOperationFilterInput>;
  anVariantSubLvl?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  anWastePrc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anWasteQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anWasteQtySe?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THfWoexItemFilterInput>>;
  or?: InputMaybe<Array<THfWoexItemFilterInput>>;
  tHfWoexItemSerialNos?: InputMaybe<ListFilterInputTypeOfTHfWoexItemSerialNoFilterInput>;
}

declare interface THfWoexItemSerialNo {
  a?: Maybe<THfWoexItem>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acKey?: Maybe<Scalars['String']>;
  acPackage?: Maybe<Scalars['String']>;
  acSerialNo?: Maybe<Scalars['String']>;
  acSnwotype?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adDateDue: Scalars['DateTime'];
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anMultiIssueId: Scalars['Int'];
  anNo: Scalars['Int'];
  anPackQty?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anQty: Scalars['Decimal'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THfWoexItemSerialNoFilterInput {
  a?: InputMaybe<THfWoexItemFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acPackage?: InputMaybe<StringOperationFilterInput>;
  acSerialNo?: InputMaybe<StringOperationFilterInput>;
  acSnwotype?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anMultiIssueId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPackQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THfWoexItemSerialNoFilterInput>>;
  or?: InputMaybe<Array<THfWoexItemSerialNoFilterInput>>;
}

declare interface THfWoexItemSortInput {
  acAgriculturalReason?: InputMaybe<SortEnumType>;
  acAutoPrepType?: InputMaybe<SortEnumType>;
  acDelayType?: InputMaybe<SortEnumType>;
  acDescr?: InputMaybe<SortEnumType>;
  acFieldSa?: InputMaybe<SortEnumType>;
  acFieldSb?: InputMaybe<SortEnumType>;
  acFieldSc?: InputMaybe<SortEnumType>;
  acFieldSd?: InputMaybe<SortEnumType>;
  acFieldSe?: InputMaybe<SortEnumType>;
  acFixedResource?: InputMaybe<SortEnumType>;
  acFixedTime?: InputMaybe<SortEnumType>;
  acGroupResursId?: InputMaybe<SortEnumType>;
  acIdent?: InputMaybe<SortEnumType>;
  acIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acIssueFinished?: InputMaybe<SortEnumType>;
  acIssuer?: InputMaybe<SortEnumType>;
  acIssuerNavigation?: InputMaybe<THeSetSubjSortInput>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyNavigation?: InputMaybe<THfWoexSortInput>;
  acKeyView?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acOperationType?: InputMaybe<SortEnumType>;
  acOrigin?: InputMaybe<SortEnumType>;
  acPhenologicalPhase?: InputMaybe<SortEnumType>;
  acQtyFormula?: InputMaybe<SortEnumType>;
  acRuleId?: InputMaybe<SortEnumType>;
  acScrapIdent?: InputMaybe<SortEnumType>;
  acScrapIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acTaskState?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  acUm3?: InputMaybe<SortEnumType>;
  acUm3Navigation?: InputMaybe<THeSetUmSortInput>;
  acUmNavigation?: InputMaybe<THeSetUmSortInput>;
  acUmtime?: InputMaybe<SortEnumType>;
  adEarliestStartTime?: InputMaybe<SortEnumType>;
  adLatestEndTime?: InputMaybe<SortEnumType>;
  adSchedEndTime?: InputMaybe<SortEnumType>;
  adSchedStartTime?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anActive?: InputMaybe<SortEnumType>;
  anBatch?: InputMaybe<SortEnumType>;
  anDelayQty?: InputMaybe<SortEnumType>;
  anFieldNa?: InputMaybe<SortEnumType>;
  anFieldNax?: InputMaybe<SortEnumType>;
  anFieldNb?: InputMaybe<SortEnumType>;
  anFieldNc?: InputMaybe<SortEnumType>;
  anFixedScrapQty?: InputMaybe<SortEnumType>;
  anFixedWasteQty?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anPlanQty?: InputMaybe<SortEnumType>;
  anPlanScrapQty?: InputMaybe<SortEnumType>;
  anPlanWasteQty?: InputMaybe<SortEnumType>;
  anPrcValue?: InputMaybe<SortEnumType>;
  anPrice?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQidFertType?: InputMaybe<SortEnumType>;
  anQty?: InputMaybe<SortEnumType>;
  anQty1?: InputMaybe<SortEnumType>;
  anQty3?: InputMaybe<SortEnumType>;
  anQtyBase?: InputMaybe<SortEnumType>;
  anQtyBase3?: InputMaybe<SortEnumType>;
  anQtySe?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anScrapPrc?: InputMaybe<SortEnumType>;
  anScrapQty?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anVariant?: InputMaybe<SortEnumType>;
  anVariantSubLvl?: InputMaybe<SortEnumType>;
  anWastePrc?: InputMaybe<SortEnumType>;
  anWasteQty?: InputMaybe<SortEnumType>;
  anWasteQtySe?: InputMaybe<SortEnumType>;
}

/** A connection to a list of items. */
declare interface THfWoexPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THfWoexPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THfWoex>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THfWoexPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THfWoex>;
}

/** A connection to a list of items. */
declare interface THfWoexPagedParametrizedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THfWoexPagedParametrizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THfWoex>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THfWoexPagedParametrizedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THfWoex>;
}

declare type THfWoexPagedSortField =
  | 'AC_CONSIGNEE'
  | 'AC_DEPT'
  | 'AC_DOC_TYPE'
  | 'AC_IDENT'
  | 'AC_KEY'
  | 'AC_NOTE'
  | 'AC_RECEIVER'
  | 'AC_SCRAP_IDENT'
  | 'AC_STATUS'
  | 'AD_DATE'
  | 'AD_SCHED_END_TIME'
  | 'AD_SCHED_START_TIME'
  | 'AD_WOFINISH_DATE'
  | 'AN_PRIORITY';

declare interface THfWoexSortInput {
  acBuyOrdId?: InputMaybe<SortEnumType>;
  acConsignee?: InputMaybe<SortEnumType>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjSortInput>;
  acCostDrv?: InputMaybe<SortEnumType>;
  acCostDrvNavigation?: InputMaybe<THeCostDrvSortInput>;
  acCreateFrom?: InputMaybe<SortEnumType>;
  acCropType?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acDeptNavigation?: InputMaybe<THeSetSubjSortInput>;
  acDocType?: InputMaybe<SortEnumType>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeSortInput>;
  acIdent?: InputMaybe<SortEnumType>;
  acIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyView?: InputMaybe<SortEnumType>;
  acLnkKey?: InputMaybe<SortEnumType>;
  acLnkPrStIdentParent?: InputMaybe<SortEnumType>;
  acLnkPrStIdentParentNavigation?: InputMaybe<THeSetItemSortInput>;
  acName?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acParentWo?: InputMaybe<SortEnumType>;
  acPlan?: InputMaybe<THfPlanSortInput>;
  acPlanId?: InputMaybe<SortEnumType>;
  acProdVariant?: InputMaybe<SortEnumType>;
  acReceiveFinished?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverNavigation?: InputMaybe<THeSetSubjSortInput>;
  acReversal?: InputMaybe<SortEnumType>;
  acScrapIdent?: InputMaybe<SortEnumType>;
  acScrapIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acStatus?: InputMaybe<SortEnumType>;
  acStatusMf?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  acUmNavigation?: InputMaybe<THeSetUmSortInput>;
  adDate?: InputMaybe<SortEnumType>;
  adLnkDate?: InputMaybe<SortEnumType>;
  adSchedEndTime?: InputMaybe<SortEnumType>;
  adSchedStartTime?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  adWofinishDate?: InputMaybe<SortEnumType>;
  anFieldNa?: InputMaybe<SortEnumType>;
  anLnkNo?: InputMaybe<SortEnumType>;
  anLnkPrStNo?: InputMaybe<SortEnumType>;
  anLnkPrStNoParent?: InputMaybe<SortEnumType>;
  anLnkPrStSubNo?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anParentWoqty?: InputMaybe<SortEnumType>;
  anPlanQty?: InputMaybe<SortEnumType>;
  anPlanScrapQty?: InputMaybe<SortEnumType>;
  anPlanWasteQty?: InputMaybe<SortEnumType>;
  anPriority?: InputMaybe<SortEnumType>;
  anProducedQty?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQidCa?: InputMaybe<SortEnumType>;
  anQtySeries?: InputMaybe<SortEnumType>;
  anRepairQty?: InputMaybe<SortEnumType>;
  anScrapQty?: InputMaybe<SortEnumType>;
  anSntransfer?: InputMaybe<SortEnumType>;
  anThroTime?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anWasteQty?: InputMaybe<SortEnumType>;
  anWorkTime?: InputMaybe<SortEnumType>;
}

declare interface THrLinkTrvlTrvl {
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THrTrvl>;
  acLnkKey?: Maybe<Scalars['String']>;
  acLnkKeyNavigation?: Maybe<THrTrvl>;
  acType?: Maybe<Scalars['String']>;
  acTypeA?: Maybe<Scalars['String']>;
  acTypeB?: Maybe<Scalars['String']>;
  acValue?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anFieldNa: Scalars['Float'];
  anFieldNb: Scalars['Float'];
  anLnkNo: Scalars['Int'];
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserId?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THrLinkTrvlTrvlFilterInput {
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THrTrvlFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acLnkKeyNavigation?: InputMaybe<THrTrvlFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acTypeA?: InputMaybe<StringOperationFilterInput>;
  acTypeB?: InputMaybe<StringOperationFilterInput>;
  acValue?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anLnkNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THrLinkTrvlTrvlFilterInput>>;
  or?: InputMaybe<Array<THrLinkTrvlTrvlFilterInput>>;
}

declare interface THrPrsn {
  acActive?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acRegNo?: Maybe<Scalars['String']>;
  acSurname?: Maybe<Scalars['String']>;
  acWorker?: Maybe<Scalars['String']>;
  acWorkerNavigation?: Maybe<THeSetSubj>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHrPrsnStatuses?: Maybe<Array<Maybe<THrPrsnStatus>>>;
  tHrTrvls?: Maybe<Array<Maybe<THrTrvl>>>;
}

declare interface THrPrsnFilterInput {
  acActive?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acRegNo?: InputMaybe<StringOperationFilterInput>;
  acSurname?: InputMaybe<StringOperationFilterInput>;
  acWorker?: InputMaybe<StringOperationFilterInput>;
  acWorkerNavigation?: InputMaybe<THeSetSubjFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THrPrsnFilterInput>>;
  or?: InputMaybe<Array<THrPrsnFilterInput>>;
  tHrPrsnStatuses?: InputMaybe<ListFilterInputTypeOfTHrPrsnStatusFilterInput>;
  tHrTrvls?: InputMaybe<ListFilterInputTypeOfTHrTrvlFilterInput>;
}

/** A connection to a list of items. */
declare interface THrPrsnPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<THrPrsnPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THrPrsn>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface THrPrsnPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THrPrsn>;
}

declare interface THrPrsnSortInput {
  acActive?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acRegNo?: InputMaybe<SortEnumType>;
  acSurname?: InputMaybe<SortEnumType>;
  acWorker?: InputMaybe<SortEnumType>;
  acWorkerNavigation?: InputMaybe<THeSetSubjSortInput>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface THrPrsnStatus {
  acStatus?: Maybe<Scalars['String']>;
  acWorker?: Maybe<Scalars['String']>;
  acWorkerNavigation?: Maybe<THrPrsn>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface THrPrsnStatusFilterInput {
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acWorker?: InputMaybe<StringOperationFilterInput>;
  acWorkerNavigation?: InputMaybe<THrPrsnFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THrPrsnStatusFilterInput>>;
  or?: InputMaybe<Array<THrPrsnStatusFilterInput>>;
}

declare interface THrTrvl {
  acApproved?: Maybe<Scalars['String']>;
  acBnkAcctType?: Maybe<Scalars['String']>;
  acCarRegNo?: Maybe<Scalars['String']>;
  acCode1?: Maybe<Scalars['String']>;
  acCode2?: Maybe<Scalars['String']>;
  acCode3?: Maybe<Scalars['String']>;
  acCompanyCar?: Maybe<Scalars['String']>;
  acConfrm?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSf?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFieldSj?: Maybe<Scalars['String']>;
  acForeignDoc?: Maybe<Scalars['String']>;
  acInsertedFrom?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyView?: Maybe<Scalars['String']>;
  acLinkDoc?: Maybe<Scalars['String']>;
  acPayer?: Maybe<Scalars['String']>;
  acPlaceFinish?: Maybe<Scalars['String']>;
  acPlaceStart?: Maybe<Scalars['String']>;
  acPosted?: Maybe<Scalars['String']>;
  acPrivatCar?: Maybe<Scalars['String']>;
  acRefNo1?: Maybe<Scalars['String']>;
  acRefNo2?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  acSumHours?: Maybe<Scalars['String']>;
  acUpnRfcode?: Maybe<Scalars['String']>;
  acUpnRfcodeA?: Maybe<Scalars['String']>;
  acVerifyStatus?: Maybe<Scalars['String']>;
  acVersion?: Maybe<Scalars['String']>;
  acViacle?: Maybe<Scalars['String']>;
  acViacleType?: Maybe<Scalars['String']>;
  acWorker?: Maybe<Scalars['String']>;
  acWorkerNavigation?: Maybe<THrPrsn>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateCalc?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anApprovedBy: Scalars['Int'];
  anBnkAcctNo?: Maybe<Scalars['Int']>;
  anBnkAcctNoComp?: Maybe<Scalars['Int']>;
  anIrisShow?: Maybe<Scalars['Int']>;
  anQid: Scalars['Int'];
  anTrvl01?: Maybe<Scalars['Decimal']>;
  anTrvl02?: Maybe<Scalars['Decimal']>;
  anTrvl03?: Maybe<Scalars['Decimal']>;
  anTrvl04?: Maybe<Scalars['Decimal']>;
  anTrvl05?: Maybe<Scalars['Decimal']>;
  anTrvl06?: Maybe<Scalars['Decimal']>;
  anTrvl07?: Maybe<Scalars['Decimal']>;
  anTrvl08?: Maybe<Scalars['Decimal']>;
  anTrvl09?: Maybe<Scalars['Decimal']>;
  anTrvl10?: Maybe<Scalars['Decimal']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anjobId?: Maybe<Scalars['Int']>;
  tHrLinkTrvlTrvlAcKeyNavigations?: Maybe<Array<Maybe<THrLinkTrvlTrvl>>>;
  tHrLinkTrvlTrvlAcLnkKeyNavigations?: Maybe<Array<Maybe<THrLinkTrvlTrvl>>>;
  tHrTrvlItems?: Maybe<Array<Maybe<THrTrvlItem>>>;
}

declare interface THrTrvlFilterInput {
  acApproved?: InputMaybe<StringOperationFilterInput>;
  acBnkAcctType?: InputMaybe<StringOperationFilterInput>;
  acCarRegNo?: InputMaybe<StringOperationFilterInput>;
  acCode1?: InputMaybe<StringOperationFilterInput>;
  acCode2?: InputMaybe<StringOperationFilterInput>;
  acCode3?: InputMaybe<StringOperationFilterInput>;
  acCompanyCar?: InputMaybe<StringOperationFilterInput>;
  acConfrm?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSf?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFieldSj?: InputMaybe<StringOperationFilterInput>;
  acForeignDoc?: InputMaybe<StringOperationFilterInput>;
  acInsertedFrom?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyView?: InputMaybe<StringOperationFilterInput>;
  acLinkDoc?: InputMaybe<StringOperationFilterInput>;
  acPayer?: InputMaybe<StringOperationFilterInput>;
  acPlaceFinish?: InputMaybe<StringOperationFilterInput>;
  acPlaceStart?: InputMaybe<StringOperationFilterInput>;
  acPosted?: InputMaybe<StringOperationFilterInput>;
  acPrivatCar?: InputMaybe<StringOperationFilterInput>;
  acRefNo1?: InputMaybe<StringOperationFilterInput>;
  acRefNo2?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acSumHours?: InputMaybe<StringOperationFilterInput>;
  acUpnRfcode?: InputMaybe<StringOperationFilterInput>;
  acUpnRfcodeA?: InputMaybe<StringOperationFilterInput>;
  acVerifyStatus?: InputMaybe<StringOperationFilterInput>;
  acVersion?: InputMaybe<StringOperationFilterInput>;
  acViacle?: InputMaybe<StringOperationFilterInput>;
  acViacleType?: InputMaybe<StringOperationFilterInput>;
  acWorker?: InputMaybe<StringOperationFilterInput>;
  acWorkerNavigation?: InputMaybe<THrPrsnFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateCalc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anApprovedBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  anBnkAcctNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anBnkAcctNoComp?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anIrisShow?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTrvl01?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl02?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl03?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl04?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl05?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl06?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl07?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl08?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl09?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl10?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THrTrvlFilterInput>>;
  anjobId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<THrTrvlFilterInput>>;
  tHrLinkTrvlTrvlAcKeyNavigations?: InputMaybe<ListFilterInputTypeOfTHrLinkTrvlTrvlFilterInput>;
  tHrLinkTrvlTrvlAcLnkKeyNavigations?: InputMaybe<ListFilterInputTypeOfTHrLinkTrvlTrvlFilterInput>;
  tHrTrvlItems?: InputMaybe<ListFilterInputTypeOfTHrTrvlItemFilterInput>;
}

declare interface THrTrvlItem {
  acBreakfast?: Maybe<Scalars['String']>;
  acCarRegNo?: Maybe<Scalars['String']>;
  acCity?: Maybe<Scalars['String']>;
  acCostDrv?: Maybe<Scalars['String']>;
  acCountry?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acCurrencyKm?: Maybe<Scalars['String']>;
  acDailyAllow?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDinner?: Maybe<Scalars['String']>;
  acGeoJson?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THrTrvl>;
  acLocoDriving?: Maybe<Scalars['String']>;
  acLunch?: Maybe<Scalars['String']>;
  acNotInCurrency?: Maybe<Scalars['String']>;
  acNotInCurrencyKm?: Maybe<Scalars['String']>;
  acOrder?: Maybe<Scalars['String']>;
  acPost?: Maybe<Scalars['String']>;
  acRetNote?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acSuppCarRegNo?: Maybe<Scalars['String']>;
  acSuppViacle?: Maybe<Scalars['String']>;
  acViacle?: Maybe<Scalars['String']>;
  adDateHourFrom?: Maybe<Scalars['DateTime']>;
  adDateHourTo?: Maybe<Scalars['DateTime']>;
  anDayAllowNo?: Maybe<Scalars['Float']>;
  anFxrate?: Maybe<Scalars['Decimal']>;
  anFxrateKm?: Maybe<Scalars['Decimal']>;
  anKm?: Maybe<Scalars['Int']>;
  anKmcounterAfter?: Maybe<Scalars['Int']>;
  anKmcounterBefore?: Maybe<Scalars['Int']>;
  anLimitPriceKm?: Maybe<Scalars['Int']>;
  anNo: Scalars['Int'];
  anPrice500Km?: Maybe<Scalars['Decimal']>;
  anPriceDailyAllow?: Maybe<Scalars['Float']>;
  anPriceFieldBonus?: Maybe<Scalars['Float']>;
  anPriceKm?: Maybe<Scalars['Decimal']>;
  anQid?: Maybe<Scalars['Int']>;
  tHrTrvlItemExps?: Maybe<Array<Maybe<THrTrvlItemExpWithAttachment>>>;
}

declare interface THrTrvlItemExpWithAttachment {
  a?: Maybe<THrTrvlItem>;
  acAcctDb?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acDoc1?: Maybe<Scalars['String']>;
  acIrek?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acLinkDoc?: Maybe<Scalars['String']>;
  acNotForPayment?: Maybe<Scalars['String']>;
  acNotInCurrency?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  adDateCost?: Maybe<Scalars['DateTime']>;
  anCostNo: Scalars['Int'];
  anFxrate?: Maybe<Scalars['Decimal']>;
  anNo: Scalars['Int'];
  anPriceCurrency?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anType?: Maybe<Scalars['Int']>;
}

declare interface THrTrvlItemExpWithAttachmentFilterInput {
  a?: InputMaybe<THrTrvlItemFilterInput>;
  acAcctDb?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDoc1?: InputMaybe<StringOperationFilterInput>;
  acIrek?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acLinkDoc?: InputMaybe<StringOperationFilterInput>;
  acNotForPayment?: InputMaybe<StringOperationFilterInput>;
  acNotInCurrency?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  adDateCost?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anCostNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anFxrate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPriceCurrency?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anType?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THrTrvlItemExpWithAttachmentFilterInput>>;
  or?: InputMaybe<Array<THrTrvlItemExpWithAttachmentFilterInput>>;
}

declare interface THrTrvlItemFilterInput {
  acBreakfast?: InputMaybe<StringOperationFilterInput>;
  acCarRegNo?: InputMaybe<StringOperationFilterInput>;
  acCity?: InputMaybe<StringOperationFilterInput>;
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acCountry?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acCurrencyKm?: InputMaybe<StringOperationFilterInput>;
  acDailyAllow?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDinner?: InputMaybe<StringOperationFilterInput>;
  acGeoJson?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THrTrvlFilterInput>;
  acLocoDriving?: InputMaybe<StringOperationFilterInput>;
  acLunch?: InputMaybe<StringOperationFilterInput>;
  acNotInCurrency?: InputMaybe<StringOperationFilterInput>;
  acNotInCurrencyKm?: InputMaybe<StringOperationFilterInput>;
  acOrder?: InputMaybe<StringOperationFilterInput>;
  acPost?: InputMaybe<StringOperationFilterInput>;
  acRetNote?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acSuppCarRegNo?: InputMaybe<StringOperationFilterInput>;
  acSuppViacle?: InputMaybe<StringOperationFilterInput>;
  acViacle?: InputMaybe<StringOperationFilterInput>;
  adDateHourFrom?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateHourTo?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDayAllowNo?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anFxrate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFxrateKm?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anKm?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anKmcounterAfter?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anKmcounterBefore?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anLimitPriceKm?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPrice500Km?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPriceDailyAllow?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPriceFieldBonus?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPriceKm?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THrTrvlItemFilterInput>>;
  or?: InputMaybe<Array<THrTrvlItemFilterInput>>;
  tHrTrvlItemExps?: InputMaybe<ListFilterInputTypeOfTHrTrvlItemExpWithAttachmentFilterInput>;
}

declare interface TMnDocument {
  acDeleted?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acDocTypeNavigation?: Maybe<TPaSetDocType>;
  acGuid: Scalars['UUID'];
  acKey?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acTitle?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateDue?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClassifIcationQ?: Maybe<TMnSetClassification>;
  anClassifIcationQid: Scalars['Int'];
  anClerk?: Maybe<Scalars['Int']>;
  anMailBoxQ?: Maybe<TMnMailbox>;
  anMailBoxQid?: Maybe<Scalars['Int']>;
  anQid: Scalars['Int'];
  anStorageQ?: Maybe<TMnStorage>;
  anStorageQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tMnDocumentChatLogs?: Maybe<Array<Maybe<TMnDocumentChatLog>>>;
  tMnDocumentMetaData?: Maybe<Array<Maybe<TMnDocumentMetaDatum>>>;
  tMnFiles?: Maybe<Array<Maybe<TMnFile>>>;
  tMnLinkDocumentsWfs?: Maybe<Array<Maybe<TMnLinkDocumentsWf>>>;
}


declare interface TMnDocumentTMnDocumentMetaDataArgs {
  where?: InputMaybe<TMnDocumentMetaDatumFilterInput>;
}


declare interface TMnDocumentTMnFilesArgs {
  where?: InputMaybe<TMnFileFilterInput>;
}


declare interface TMnDocumentTMnLinkDocumentsWfsArgs {
  where?: InputMaybe<TMnLinkDocumentsWfFilterInput>;
}

declare interface TMnDocumentChatLog {
  acMessage?: Maybe<Scalars['String']>;
  adDateCreated: Scalars['DateTime'];
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDocumentQ?: Maybe<TMnDocument>;
  anDocumentQid: Scalars['Int'];
  anQid: Scalars['Int'];
  anUser?: Maybe<THeSetSubjContact>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserId: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface TMnDocumentChatLogFilterInput {
  acMessage?: InputMaybe<StringOperationFilterInput>;
  adDateCreated?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDocumentQ?: InputMaybe<TMnDocumentFilterInput>;
  anDocumentQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUser?: InputMaybe<THeSetSubjContactFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnDocumentChatLogFilterInput>>;
  or?: InputMaybe<Array<TMnDocumentChatLogFilterInput>>;
}

declare interface TMnDocumentChatLogSortInput {
  acMessage?: InputMaybe<SortEnumType>;
  adDateCreated?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anDocumentQ?: InputMaybe<TMnDocumentSortInput>;
  anDocumentQid?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUser?: InputMaybe<THeSetSubjContactSortInput>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserId?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

/** A connection to a list of items. */
declare interface TMnDocumentChatLogsConnection {
  /** A list of edges. */
  edges?: Maybe<Array<TMnDocumentChatLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TMnDocumentChatLog>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface TMnDocumentChatLogsEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TMnDocumentChatLog>;
}

declare interface TMnDocumentFilterInput {
  acDeleted?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeFilterInput>;
  acGuid?: InputMaybe<ComparableGuidOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acTitle?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClassifIcationQ?: InputMaybe<TMnSetClassificationFilterInput>;
  anClassifIcationQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anMailBoxQ?: InputMaybe<TMnMailboxFilterInput>;
  anMailBoxQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anStorageQ?: InputMaybe<TMnStorageFilterInput>;
  anStorageQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnDocumentFilterInput>>;
  or?: InputMaybe<Array<TMnDocumentFilterInput>>;
  tMnDocumentChatLogs?: InputMaybe<ListFilterInputTypeOfTMnDocumentChatLogFilterInput>;
  tMnDocumentMetaData?: InputMaybe<ListFilterInputTypeOfTMnDocumentMetaDatumFilterInput>;
  tMnFiles?: InputMaybe<ListFilterInputTypeOfTMnFileFilterInput>;
  tMnLinkDocumentsWfs?: InputMaybe<ListFilterInputTypeOfTMnLinkDocumentsWfFilterInput>;
}

declare interface TMnDocumentMetaDatum {
  acValue?: Maybe<Scalars['String']>;
  acValue2?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClassificationMetaQ?: Maybe<TMnSetClassificationMetaDatum>;
  anClassificationMetaQid: Scalars['Int'];
  anDocumentQ?: Maybe<TMnDocument>;
  anDocumentQid: Scalars['Int'];
  anQid: Scalars['Int'];
  anTaskInst?: Maybe<TPaWorkflowTaskInstance>;
  anTaskInstId?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserId: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface TMnDocumentMetaDatumFilterInput {
  acValue?: InputMaybe<StringOperationFilterInput>;
  acValue2?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClassificationMetaQ?: InputMaybe<TMnSetClassificationMetaDatumFilterInput>;
  anClassificationMetaQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDocumentQ?: InputMaybe<TMnDocumentFilterInput>;
  anDocumentQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTaskInst?: InputMaybe<TPaWorkflowTaskInstanceFilterInput>;
  anTaskInstId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnDocumentMetaDatumFilterInput>>;
  or?: InputMaybe<Array<TMnDocumentMetaDatumFilterInput>>;
}

declare interface TMnDocumentMetaDatumSortInput {
  acValue?: InputMaybe<SortEnumType>;
  acValue2?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClassificationMetaQ?: InputMaybe<TMnSetClassificationMetaDatumSortInput>;
  anClassificationMetaQid?: InputMaybe<SortEnumType>;
  anDocumentQ?: InputMaybe<TMnDocumentSortInput>;
  anDocumentQid?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anTaskInst?: InputMaybe<TPaWorkflowTaskInstanceSortInput>;
  anTaskInstId?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserId?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface TMnDocumentSortInput {
  acDeleted?: InputMaybe<SortEnumType>;
  acDocType?: InputMaybe<SortEnumType>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeSortInput>;
  acGuid?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acStatus?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acTitle?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adDateDue?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClassifIcationQ?: InputMaybe<TMnSetClassificationSortInput>;
  anClassifIcationQid?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anMailBoxQ?: InputMaybe<TMnMailboxSortInput>;
  anMailBoxQid?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anStorageQ?: InputMaybe<TMnStorageSortInput>;
  anStorageQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface TMnDocumentWithStatus {
  document?: Maybe<TMnDocument>;
  status?: Maybe<TPaSetDocTypeStat>;
}

declare interface TMnDocumentWithStatusFilterInput {
  and?: InputMaybe<Array<TMnDocumentWithStatusFilterInput>>;
  document?: InputMaybe<TMnDocumentFilterInput>;
  or?: InputMaybe<Array<TMnDocumentWithStatusFilterInput>>;
  status?: InputMaybe<TPaSetDocTypeStatFilterInput>;
}

declare interface TMnDocumentWithStatusSortInput {
  document?: InputMaybe<TMnDocumentSortInput>;
  status?: InputMaybe<TPaSetDocTypeStatSortInput>;
}

/** A connection to a list of items. */
declare interface TMnDocumentsConnection {
  /** A list of edges. */
  edges?: Maybe<Array<TMnDocumentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TMnDocument>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface TMnDocumentsEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TMnDocument>;
}

/** A connection to a list of items. */
declare interface TMnDocumentsWithStatusConnection {
  /** A list of edges. */
  edges?: Maybe<Array<TMnDocumentsWithStatusEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TMnDocumentWithStatus>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface TMnDocumentsWithStatusEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TMnDocumentWithStatus>;
}

declare interface TMnFile {
  acFileGuid: Scalars['UUID'];
  acFileName?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDocumentQ?: Maybe<TMnDocument>;
  anDocumentQid: Scalars['Int'];
  anFileSize?: Maybe<Scalars['Int']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tMnFileLocal?: Maybe<TMnFileLocal>;
}

declare interface TMnFileFilterInput {
  acFileGuid?: InputMaybe<ComparableGuidOperationFilterInput>;
  acFileName?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDocumentQ?: InputMaybe<TMnDocumentFilterInput>;
  anDocumentQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anFileSize?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnFileFilterInput>>;
  or?: InputMaybe<Array<TMnFileFilterInput>>;
  tMnFileLocal?: InputMaybe<TMnFileLocalFilterInput>;
}

declare interface TMnFileLocal {
  externalFileIdentifier?: Maybe<Scalars['String']>;
  onixFileContent?: Maybe<Array<Scalars['Byte']>>;
  onixFileIdentifier: Scalars['UUID'];
  tMnFile?: Maybe<TMnFile>;
  tMnFileId?: Maybe<Scalars['Int']>;
}

declare interface TMnFileLocalFilterInput {
  and?: InputMaybe<Array<TMnFileLocalFilterInput>>;
  externalFileIdentifier?: InputMaybe<StringOperationFilterInput>;
  onixFileContent?: InputMaybe<ListComparableByteOperationFilterInput>;
  onixFileIdentifier?: InputMaybe<ComparableGuidOperationFilterInput>;
  or?: InputMaybe<Array<TMnFileLocalFilterInput>>;
  tMnFile?: InputMaybe<TMnFileFilterInput>;
  tMnFileId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
}

declare interface TMnFileLocalSortInput {
  externalFileIdentifier?: InputMaybe<SortEnumType>;
  onixFileIdentifier?: InputMaybe<SortEnumType>;
  tMnFile?: InputMaybe<TMnFileSortInput>;
  tMnFileId?: InputMaybe<SortEnumType>;
}

declare interface TMnFileSortInput {
  acFileGuid?: InputMaybe<SortEnumType>;
  acFileName?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anDocumentQ?: InputMaybe<TMnDocumentSortInput>;
  anDocumentQid?: InputMaybe<SortEnumType>;
  anFileSize?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  tMnFileLocal?: InputMaybe<TMnFileLocalSortInput>;
}

/** A connection to a list of items. */
declare interface TMnFilesConnection {
  /** A list of edges. */
  edges?: Maybe<Array<TMnFilesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TMnFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface TMnFilesEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TMnFile>;
}

declare interface TMnLinkDocumentsWf {
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDocumentQ?: Maybe<TMnDocument>;
  anDocumentQid: Scalars['Int'];
  anQid: Scalars['Int'];
  anTaskInst?: Maybe<TPaWorkflowTaskInstance>;
  anTaskInstId: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anWorkInstId?: Maybe<Scalars['Int']>;
}

declare interface TMnLinkDocumentsWfFilterInput {
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDocumentQ?: InputMaybe<TMnDocumentFilterInput>;
  anDocumentQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTaskInst?: InputMaybe<TPaWorkflowTaskInstanceFilterInput>;
  anTaskInstId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWorkInstId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnLinkDocumentsWfFilterInput>>;
  or?: InputMaybe<Array<TMnLinkDocumentsWfFilterInput>>;
}

declare interface TMnMailbox {
  acDocTypeIssue?: Maybe<Scalars['String']>;
  acDocTypeOrder?: Maybe<Scalars['String']>;
  acGuid: Scalars['UUID'];
  acIcon?: Maybe<Scalars['String']>;
  acIdentify?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClassificationQ?: Maybe<TMnSetClassification>;
  anClassificationQid?: Maybe<Scalars['Int']>;
  anDirection?: Maybe<Scalars['Int']>;
  anLoginsQid?: Maybe<Scalars['Int']>;
  anQid: Scalars['Int'];
  anTransferId?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tMnDocuments?: Maybe<Array<Maybe<TMnDocument>>>;
}

declare interface TMnMailboxFilterInput {
  acDocTypeIssue?: InputMaybe<StringOperationFilterInput>;
  acDocTypeOrder?: InputMaybe<StringOperationFilterInput>;
  acGuid?: InputMaybe<ComparableGuidOperationFilterInput>;
  acIcon?: InputMaybe<StringOperationFilterInput>;
  acIdentify?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClassificationQ?: InputMaybe<TMnSetClassificationFilterInput>;
  anClassificationQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anDirection?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anLoginsQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTransferId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnMailboxFilterInput>>;
  or?: InputMaybe<Array<TMnMailboxFilterInput>>;
  tMnDocuments?: InputMaybe<ListFilterInputTypeOfTMnDocumentFilterInput>;
}

declare interface TMnMailboxSortInput {
  acDocTypeIssue?: InputMaybe<SortEnumType>;
  acDocTypeOrder?: InputMaybe<SortEnumType>;
  acGuid?: InputMaybe<SortEnumType>;
  acIcon?: InputMaybe<SortEnumType>;
  acIdentify?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClassificationQ?: InputMaybe<TMnSetClassificationSortInput>;
  anClassificationQid?: InputMaybe<SortEnumType>;
  anDirection?: InputMaybe<SortEnumType>;
  anLoginsQid?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anTransferId?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface TMnSetClassification {
  acDocKind?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acTypeDesc?: Maybe<Scalars['String']>;
  acValidType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anCbid?: Maybe<Scalars['Int']>;
  anCbtopId?: Maybe<Scalars['Int']>;
  anClerk?: Maybe<Scalars['Int']>;
  anEscalation: Scalars['Int'];
  anQid: Scalars['Int'];
  anStorageQ?: Maybe<TMnStorage>;
  anStorageQid: Scalars['Int'];
  anTop?: Maybe<TMnSetClassification>;
  anTopId?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValidValue?: Maybe<Scalars['Int']>;
  anWorkflowElapsedId?: Maybe<Scalars['Int']>;
  anWorkflowId?: Maybe<Scalars['Int']>;
  inverseAnTop?: Maybe<Array<Maybe<TMnSetClassification>>>;
  tMnDocuments?: Maybe<Array<Maybe<TMnDocument>>>;
  tMnMailboxes?: Maybe<Array<Maybe<TMnMailbox>>>;
  tMnSetClassificationMetaData?: Maybe<Array<Maybe<TMnSetClassificationMetaDatum>>>;
}


declare interface TMnSetClassificationInverseAnTopArgs {
  where?: InputMaybe<TMnSetClassificationFilterInput>;
}


declare interface TMnSetClassificationTMnDocumentsArgs {
  where?: InputMaybe<TMnDocumentFilterInput>;
}


declare interface TMnSetClassificationTMnSetClassificationMetaDataArgs {
  where?: InputMaybe<TMnSetClassificationMetaDatumFilterInput>;
}

declare interface TMnSetClassificationFilterInput {
  acDocKind?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acTypeDesc?: InputMaybe<StringOperationFilterInput>;
  acValidType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anCbid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anCbtopId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anEscalation?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anStorageQ?: InputMaybe<TMnStorageFilterInput>;
  anStorageQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTop?: InputMaybe<TMnSetClassificationFilterInput>;
  anTopId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValidValue?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWorkflowElapsedId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWorkflowId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnSetClassificationFilterInput>>;
  inverseAnTop?: InputMaybe<ListFilterInputTypeOfTMnSetClassificationFilterInput>;
  or?: InputMaybe<Array<TMnSetClassificationFilterInput>>;
  tMnDocuments?: InputMaybe<ListFilterInputTypeOfTMnDocumentFilterInput>;
  tMnMailboxes?: InputMaybe<ListFilterInputTypeOfTMnMailboxFilterInput>;
  tMnSetClassificationMetaData?: InputMaybe<ListFilterInputTypeOfTMnSetClassificationMetaDatumFilterInput>;
}

declare interface TMnSetClassificationMetaDatum {
  acDefaultValue?: Maybe<Scalars['String']>;
  acDisplayName?: Maybe<Scalars['String']>;
  acDocumentFieldSync?: Maybe<Scalars['String']>;
  acHint?: Maybe<Scalars['String']>;
  acMandatory?: Maybe<Scalars['String']>;
  acSetter?: Maybe<Scalars['String']>;
  acSetterDataType?: Maybe<Scalars['String']>;
  acVarName?: Maybe<Scalars['String']>;
  acVisible?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClassificationQ?: Maybe<TMnSetClassification>;
  anClassificationQid: Scalars['Int'];
  anQid: Scalars['Int'];
  anSequence?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tMnDocumentMetaData?: Maybe<Array<Maybe<TMnDocumentMetaDatum>>>;
}

declare interface TMnSetClassificationMetaDatumFilterInput {
  acDefaultValue?: InputMaybe<StringOperationFilterInput>;
  acDisplayName?: InputMaybe<StringOperationFilterInput>;
  acDocumentFieldSync?: InputMaybe<StringOperationFilterInput>;
  acHint?: InputMaybe<StringOperationFilterInput>;
  acMandatory?: InputMaybe<StringOperationFilterInput>;
  acSetter?: InputMaybe<StringOperationFilterInput>;
  acSetterDataType?: InputMaybe<StringOperationFilterInput>;
  acVarName?: InputMaybe<StringOperationFilterInput>;
  acVisible?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClassificationQ?: InputMaybe<TMnSetClassificationFilterInput>;
  anClassificationQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anSequence?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnSetClassificationMetaDatumFilterInput>>;
  or?: InputMaybe<Array<TMnSetClassificationMetaDatumFilterInput>>;
  tMnDocumentMetaData?: InputMaybe<ListFilterInputTypeOfTMnDocumentMetaDatumFilterInput>;
}

declare interface TMnSetClassificationMetaDatumSortInput {
  acDefaultValue?: InputMaybe<SortEnumType>;
  acDisplayName?: InputMaybe<SortEnumType>;
  acDocumentFieldSync?: InputMaybe<SortEnumType>;
  acHint?: InputMaybe<SortEnumType>;
  acMandatory?: InputMaybe<SortEnumType>;
  acSetter?: InputMaybe<SortEnumType>;
  acSetterDataType?: InputMaybe<SortEnumType>;
  acVarName?: InputMaybe<SortEnumType>;
  acVisible?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClassificationQ?: InputMaybe<TMnSetClassificationSortInput>;
  anClassificationQid?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anSequence?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface TMnSetClassificationSortInput {
  acDocKind?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acTypeDesc?: InputMaybe<SortEnumType>;
  acValidType?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anCbid?: InputMaybe<SortEnumType>;
  anCbtopId?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anEscalation?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anStorageQ?: InputMaybe<TMnStorageSortInput>;
  anStorageQid?: InputMaybe<SortEnumType>;
  anTop?: InputMaybe<TMnSetClassificationSortInput>;
  anTopId?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anValidValue?: InputMaybe<SortEnumType>;
  anWorkflowElapsedId?: InputMaybe<SortEnumType>;
  anWorkflowId?: InputMaybe<SortEnumType>;
}

declare interface TMnStorage {
  acDescription?: Maybe<Scalars['String']>;
  acGuid: Scalars['UUID'];
  acIdentify?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acUrl?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anLoginsQid?: Maybe<Scalars['Int']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tMnDocuments?: Maybe<Array<Maybe<TMnDocument>>>;
  tMnSetClassifications?: Maybe<Array<Maybe<TMnSetClassification>>>;
}

declare interface TMnStorageFilterInput {
  acDescription?: InputMaybe<StringOperationFilterInput>;
  acGuid?: InputMaybe<ComparableGuidOperationFilterInput>;
  acIdentify?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acUrl?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anLoginsQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnStorageFilterInput>>;
  or?: InputMaybe<Array<TMnStorageFilterInput>>;
  tMnDocuments?: InputMaybe<ListFilterInputTypeOfTMnDocumentFilterInput>;
  tMnSetClassifications?: InputMaybe<ListFilterInputTypeOfTMnSetClassificationFilterInput>;
}

declare interface TMnStorageSortInput {
  acDescription?: InputMaybe<SortEnumType>;
  acGuid?: InputMaybe<SortEnumType>;
  acIdentify?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acUrl?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anLoginsQid?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface TPaSetDocType {
  acDocType?: Maybe<Scalars['String']>;
  acFiscalDevice?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerName?: Maybe<Scalars['String']>;
  acLinkDocName1?: Maybe<Scalars['String']>;
  acLinkDocName2?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acName3?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverName?: Maybe<Scalars['String']>;
  acRmashowWorkSpec?: Maybe<Scalars['String']>;
  acSetOf?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acWorkPlace?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anUserIns?: Maybe<Scalars['Int']>;
  documentType: DocumentTypeEnum;
  tHfPlans?: Maybe<Array<Maybe<THfPlan>>>;
  tHfWoexes?: Maybe<Array<Maybe<THfWoex>>>;
  tMnDocuments?: Maybe<Array<Maybe<TMnDocument>>>;
  tPaSetDocTypeStats?: Maybe<Array<Maybe<TPaSetDocTypeStat>>>;
}


declare interface TPaSetDocTypeTMnDocumentsArgs {
  where?: InputMaybe<TMnDocumentFilterInput>;
}


declare interface TPaSetDocTypeTPaSetDocTypeStatsArgs {
  where?: InputMaybe<TPaSetDocTypeStatFilterInput>;
}

declare interface TPaSetDocTypeFilterInput {
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acFiscalDevice?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerName?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName1?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName2?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acName3?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverName?: InputMaybe<StringOperationFilterInput>;
  acRmashowWorkSpec?: InputMaybe<StringOperationFilterInput>;
  acSetOf?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acWorkPlace?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TPaSetDocTypeFilterInput>>;
  documentType?: InputMaybe<DocumentTypeEnumOperationFilterInput>;
  or?: InputMaybe<Array<TPaSetDocTypeFilterInput>>;
  tHfPlans?: InputMaybe<ListFilterInputTypeOfTHfPlanFilterInput>;
  tHfWoexes?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
  tMnDocuments?: InputMaybe<ListFilterInputTypeOfTMnDocumentFilterInput>;
  tPaSetDocTypeStats?: InputMaybe<ListFilterInputTypeOfTPaSetDocTypeStatFilterInput>;
}

declare interface TPaSetDocTypeSortInput {
  acDocType?: InputMaybe<SortEnumType>;
  acFiscalDevice?: InputMaybe<SortEnumType>;
  acIssuer?: InputMaybe<SortEnumType>;
  acIssuerName?: InputMaybe<SortEnumType>;
  acLinkDocName1?: InputMaybe<SortEnumType>;
  acLinkDocName2?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acName3?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverName?: InputMaybe<SortEnumType>;
  acRmashowWorkSpec?: InputMaybe<SortEnumType>;
  acSetOf?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acWorkPlace?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  documentType?: InputMaybe<SortEnumType>;
}

declare interface TPaSetDocTypeStat {
  acDocType?: Maybe<Scalars['String']>;
  acDocTypeNavigation?: Maybe<TPaSetDocType>;
  acFinished?: Maybe<Scalars['String']>;
  acFreeStock?: Maybe<Scalars['String']>;
  acIsIssueAllowdOpenBills?: Maybe<Scalars['String']>;
  acLimitControl?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeOrders?: Maybe<Array<Maybe<THeOrder>>>;
}

declare interface TPaSetDocTypeStatFilterInput {
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeFilterInput>;
  acFinished?: InputMaybe<StringOperationFilterInput>;
  acFreeStock?: InputMaybe<StringOperationFilterInput>;
  acIsIssueAllowdOpenBills?: InputMaybe<StringOperationFilterInput>;
  acLimitControl?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TPaSetDocTypeStatFilterInput>>;
  or?: InputMaybe<Array<TPaSetDocTypeStatFilterInput>>;
  tHeOrders?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
}

declare interface TPaSetDocTypeStatSortInput {
  acDocType?: InputMaybe<SortEnumType>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeSortInput>;
  acFinished?: InputMaybe<SortEnumType>;
  acFreeStock?: InputMaybe<SortEnumType>;
  acIsIssueAllowdOpenBills?: InputMaybe<SortEnumType>;
  acLimitControl?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acStatus?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface TPaSysParam {
  acCompanyImage?: Maybe<Array<Scalars['Byte']>>;
  acCompanyPrtTextA?: Maybe<Scalars['String']>;
  acCompanyPrtTextB?: Maybe<Scalars['String']>;
  acCustomLogoImage?: Maybe<Array<Scalars['Byte']>>;
  acFiscalServer?: Maybe<Scalars['String']>;
  acOurCompany?: Maybe<Scalars['String']>;
  acPrimCurrency?: Maybe<Scalars['String']>;
  acQtyInCodeCont?: Maybe<Scalars['String']>;
  acVatcodeWithoutTaxInc?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDocKeyLenDocType?: Maybe<Scalars['Byte']>;
  anDocKeyLenNumber?: Maybe<Scalars['Byte']>;
  anGenerSubjNoFieldLen: Scalars['Int'];
  anGenerSubjNoLen: Scalars['Int'];
  anQtyInCodeLen: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface TPaSysParamFilterInput {
  acCompanyImage?: InputMaybe<ListComparableByteOperationFilterInput>;
  acCompanyPrtTextA?: InputMaybe<StringOperationFilterInput>;
  acCompanyPrtTextB?: InputMaybe<StringOperationFilterInput>;
  acCustomLogoImage?: InputMaybe<ListComparableByteOperationFilterInput>;
  acFiscalServer?: InputMaybe<StringOperationFilterInput>;
  acOurCompany?: InputMaybe<StringOperationFilterInput>;
  acPrimCurrency?: InputMaybe<StringOperationFilterInput>;
  acQtyInCodeCont?: InputMaybe<StringOperationFilterInput>;
  acVatcodeWithoutTaxInc?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDocKeyLenDocType?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  anDocKeyLenNumber?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  anGenerSubjNoFieldLen?: InputMaybe<ComparableInt32OperationFilterInput>;
  anGenerSubjNoLen?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQtyInCodeLen?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TPaSysParamFilterInput>>;
  or?: InputMaybe<Array<TPaSysParamFilterInput>>;
}

declare interface TPaSysParamSortInput {
  acCompanyPrtTextA?: InputMaybe<SortEnumType>;
  acCompanyPrtTextB?: InputMaybe<SortEnumType>;
  acFiscalServer?: InputMaybe<SortEnumType>;
  acOurCompany?: InputMaybe<SortEnumType>;
  acPrimCurrency?: InputMaybe<SortEnumType>;
  acQtyInCodeCont?: InputMaybe<SortEnumType>;
  acVatcodeWithoutTaxInc?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anDocKeyLenDocType?: InputMaybe<SortEnumType>;
  anDocKeyLenNumber?: InputMaybe<SortEnumType>;
  anGenerSubjNoFieldLen?: InputMaybe<SortEnumType>;
  anGenerSubjNoLen?: InputMaybe<SortEnumType>;
  anQtyInCodeLen?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface TPaUser {
  acActive?: Maybe<Scalars['String']>;
  acAgencySignedBy?: Maybe<Scalars['String']>;
  acCerPub?: Maybe<Scalars['String']>;
  acCerTime?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acLangId?: Maybe<Scalars['String']>;
  acProfile?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acTitle?: Maybe<Scalars['String']>;
  acUserId?: Maybe<Scalars['String']>;
  acWeb?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserId: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface TPaUserFilterInput {
  acActive?: InputMaybe<StringOperationFilterInput>;
  acAgencySignedBy?: InputMaybe<StringOperationFilterInput>;
  acCerPub?: InputMaybe<StringOperationFilterInput>;
  acCerTime?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acLangId?: InputMaybe<StringOperationFilterInput>;
  acProfile?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acTitle?: InputMaybe<StringOperationFilterInput>;
  acUserId?: InputMaybe<StringOperationFilterInput>;
  acWeb?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TPaUserFilterInput>>;
  or?: InputMaybe<Array<TPaUserFilterInput>>;
}

/** A connection to a list of items. */
declare interface TPaUserPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<TPaUserPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TPaUser>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface TPaUserPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TPaUser>;
}

declare interface TPaUserSortInput {
  acActive?: InputMaybe<SortEnumType>;
  acAgencySignedBy?: InputMaybe<SortEnumType>;
  acCerPub?: InputMaybe<SortEnumType>;
  acCerTime?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acLangId?: InputMaybe<SortEnumType>;
  acProfile?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acTitle?: InputMaybe<SortEnumType>;
  acUserId?: InputMaybe<SortEnumType>;
  acWeb?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserId?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface TPaWorkflowTaskInstance {
  acComments?: Maybe<Scalars['String']>;
  acCompleted?: Maybe<Scalars['String']>;
  acDescription?: Maybe<Scalars['String']>;
  acModifiedUserId?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acTask?: Maybe<Scalars['String']>;
  acTitle?: Maybe<Scalars['String']>;
  adCreatedOn?: Maybe<Scalars['DateTime']>;
  adModifiedOn?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anId: Scalars['Int'];
  anTaskVersion?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserId?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anWorkflowDefinitionKey?: Maybe<Scalars['Int']>;
  anWorkflowInstanceKey?: Maybe<Scalars['Int']>;
  tMnDocumentMetaData?: Maybe<Array<Maybe<TMnDocumentMetaDatum>>>;
  tMnLinkDocumentsWfs?: Maybe<Array<Maybe<TMnLinkDocumentsWf>>>;
}


declare interface TPaWorkflowTaskInstanceTMnDocumentMetaDataArgs {
  where?: InputMaybe<TMnDocumentMetaDatumFilterInput>;
}


declare interface TPaWorkflowTaskInstanceTMnLinkDocumentsWfsArgs {
  where?: InputMaybe<TMnLinkDocumentsWfFilterInput>;
}

declare interface TPaWorkflowTaskInstanceFilterInput {
  acComments?: InputMaybe<StringOperationFilterInput>;
  acCompleted?: InputMaybe<StringOperationFilterInput>;
  acDescription?: InputMaybe<StringOperationFilterInput>;
  acModifiedUserId?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acTask?: InputMaybe<StringOperationFilterInput>;
  acTitle?: InputMaybe<StringOperationFilterInput>;
  adCreatedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adModifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTaskVersion?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWorkflowDefinitionKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWorkflowInstanceKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TPaWorkflowTaskInstanceFilterInput>>;
  or?: InputMaybe<Array<TPaWorkflowTaskInstanceFilterInput>>;
  tMnDocumentMetaData?: InputMaybe<ListFilterInputTypeOfTMnDocumentMetaDatumFilterInput>;
  tMnLinkDocumentsWfs?: InputMaybe<ListFilterInputTypeOfTMnLinkDocumentsWfFilterInput>;
}

declare interface TPaWorkflowTaskInstanceSortInput {
  acComments?: InputMaybe<SortEnumType>;
  acCompleted?: InputMaybe<SortEnumType>;
  acDescription?: InputMaybe<SortEnumType>;
  acModifiedUserId?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acTask?: InputMaybe<SortEnumType>;
  acTitle?: InputMaybe<SortEnumType>;
  adCreatedOn?: InputMaybe<SortEnumType>;
  adModifiedOn?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anId?: InputMaybe<SortEnumType>;
  anTaskVersion?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserId?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anWorkflowDefinitionKey?: InputMaybe<SortEnumType>;
  anWorkflowInstanceKey?: InputMaybe<SortEnumType>;
}

declare interface TeamViewerSession {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contactId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  dismissed: Scalars['Boolean'];
  duration: Scalars['TimeSpan'];
  endDate: Scalars['DateTime'];
  groupId?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  supportTicket?: Maybe<SupportTicket>;
  supportTicketId?: Maybe<Scalars['Int']>;
  supportTicketTimeLog?: Maybe<SupportTicketTimeLog>;
  supportTicketTimeLogId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
}

declare interface TeamViewerSessionFilterInput {
  and?: InputMaybe<Array<TeamViewerSessionFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  billingState?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contactId?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  deviceId?: InputMaybe<StringOperationFilterInput>;
  deviceName?: InputMaybe<StringOperationFilterInput>;
  dismissed?: InputMaybe<BooleanOperationFilterInput>;
  duration?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  endDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  groupId?: InputMaybe<StringOperationFilterInput>;
  groupName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TeamViewerSessionFilterInput>>;
  startDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  supportTicket?: InputMaybe<SupportTicketFilterInput>;
  supportTicketId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportTicketTimeLog?: InputMaybe<SupportTicketTimeLogFilterInput>;
  supportTicketTimeLogId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  username?: InputMaybe<StringOperationFilterInput>;
}

declare interface TravelKilometers {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  kilometers?: Maybe<Scalars['Int']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  pantheonId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Decimal']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
}

declare interface TravelKilometersFilterInput {
  and?: InputMaybe<Array<TravelKilometersFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  date?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  kilometers?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<TravelKilometersFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  price?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
}

declare interface TravelWarrant {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  coDrivers?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  country?: Maybe<Country>;
  countryAllowance: Scalars['Float'];
  countryAllowanceConversion: Scalars['Float'];
  countryAllowanceCurrency?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  documentNumber: Scalars['Int'];
  downPayment?: Maybe<Scalars['Float']>;
  downPaymentConversion?: Maybe<Scalars['Float']>;
  downPaymentCurrency?: Maybe<Currency>;
  downPaymentCurrencyId?: Maybe<Scalars['Int']>;
  driver?: Maybe<Scalars['String']>;
  expenseBearer?: Maybe<ExpenseBearer>;
  expenseBearerAllowance: Scalars['Float'];
  expenseBearerAllowanceConversion: Scalars['Float'];
  expenseBearerCurrency?: Maybe<Scalars['String']>;
  expenseBearerId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  kilometersTraveled: Scalars['Float'];
  lastClosedAt?: Maybe<Scalars['DateTime']>;
  lastOpenedAt?: Maybe<Scalars['DateTime']>;
  lastSentToFinalizeAt?: Maybe<Scalars['DateTime']>;
  lastSentToPantheonAt?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  officialVehicle?: Maybe<OfficialVehicle>;
  officialVehicleId?: Maybe<Scalars['Int']>;
  onixPantheonDMSId?: Maybe<Scalars['Int']>;
  pantheonId?: Maybe<Scalars['String']>;
  pantheonStatus?: Maybe<Scalars['String']>;
  perDiems: Scalars['Float'];
  personalVehicle?: Maybe<PersonalVehicle>;
  personalVehicleId?: Maybe<Scalars['Int']>;
  place?: Maybe<Scalars['String']>;
  placeOfDeparture?: Maybe<Scalars['String']>;
  returnNote?: Maybe<Scalars['String']>;
  status: TravelWarrantStatus;
  syncErrorStack?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
  travelEndDateTime?: Maybe<Scalars['DateTime']>;
  travelEndMeter?: Maybe<Scalars['Float']>;
  travelHours: Scalars['Float'];
  travelKilometersConversion: Scalars['Float'];
  travelStartDateTime?: Maybe<Scalars['DateTime']>;
  travelStartMeter?: Maybe<Scalars['Float']>;
  travelWarrantItems?: Maybe<Array<Maybe<TravelWarrantItem>>>;
  vehicle?: Maybe<Scalars['String']>;
}

declare interface TravelWarrantCostType {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  docType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeactivated: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  pantheonId?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
  type: Scalars['Int'];
}

declare interface TravelWarrantCostTypeFilterInput {
  and?: InputMaybe<Array<TravelWarrantCostTypeFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  docType?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeactivated?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TravelWarrantCostTypeFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  type?: InputMaybe<ComparableInt32OperationFilterInput>;
}

declare interface TravelWarrantCostTypeSortInput {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  docType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeactivated?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
}

declare interface TravelWarrantFilterInput {
  and?: InputMaybe<Array<TravelWarrantFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  coDrivers?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  country?: InputMaybe<CountryFilterInput>;
  countryAllowance?: InputMaybe<ComparableDoubleOperationFilterInput>;
  countryAllowanceConversion?: InputMaybe<ComparableDoubleOperationFilterInput>;
  countryAllowanceCurrency?: InputMaybe<StringOperationFilterInput>;
  countryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  documentNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  downPayment?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  downPaymentConversion?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  downPaymentCurrency?: InputMaybe<CurrencyFilterInput>;
  downPaymentCurrencyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  driver?: InputMaybe<StringOperationFilterInput>;
  expenseBearer?: InputMaybe<ExpenseBearerFilterInput>;
  expenseBearerAllowance?: InputMaybe<ComparableDoubleOperationFilterInput>;
  expenseBearerAllowanceConversion?: InputMaybe<ComparableDoubleOperationFilterInput>;
  expenseBearerCurrency?: InputMaybe<StringOperationFilterInput>;
  expenseBearerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  kilometersTraveled?: InputMaybe<ComparableDoubleOperationFilterInput>;
  lastClosedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastOpenedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastSentToFinalizeAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastSentToPantheonAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  officialVehicle?: InputMaybe<OfficialVehicleFilterInput>;
  officialVehicleId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  onixPantheonDMSId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<TravelWarrantFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  pantheonStatus?: InputMaybe<StringOperationFilterInput>;
  perDiems?: InputMaybe<ComparableDoubleOperationFilterInput>;
  personalVehicle?: InputMaybe<PersonalVehicleFilterInput>;
  personalVehicleId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  place?: InputMaybe<StringOperationFilterInput>;
  placeOfDeparture?: InputMaybe<StringOperationFilterInput>;
  returnNote?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<TravelWarrantStatusOperationFilterInput>;
  syncErrorStack?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  travelEndDateTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  travelEndMeter?: InputMaybe<ComparableNullableOfSingleOperationFilterInput>;
  travelHours?: InputMaybe<ComparableDoubleOperationFilterInput>;
  travelKilometersConversion?: InputMaybe<ComparableDoubleOperationFilterInput>;
  travelStartDateTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  travelStartMeter?: InputMaybe<ComparableNullableOfSingleOperationFilterInput>;
  travelWarrantItems?: InputMaybe<ListFilterInputTypeOfTravelWarrantItemFilterInput>;
  vehicle?: InputMaybe<StringOperationFilterInput>;
}

declare interface TravelWarrantItem {
  anCostNo?: Maybe<Scalars['Int']>;
  anNo?: Maybe<Scalars['Int']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  conversion: Scalars['Float'];
  costType?: Maybe<TravelWarrantCostType>;
  costTypeId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  currencyId: Scalars['Int'];
  date: Scalars['DateTime'];
  files?: Maybe<Array<Maybe<SavedFile>>>;
  forPeriod?: Maybe<Scalars['DateTime']>;
  hasBackingInvoice: Scalars['Boolean'];
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  notForPayment: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  travelWarrant?: Maybe<TravelWarrant>;
  travelWarrantId?: Maybe<Scalars['String']>;
  value: Scalars['Decimal'];
}

declare interface TravelWarrantItemFilterInput {
  anCostNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TravelWarrantItemFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  conversion?: InputMaybe<ComparableDoubleOperationFilterInput>;
  costType?: InputMaybe<TravelWarrantCostTypeFilterInput>;
  costTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  currency?: InputMaybe<CurrencyFilterInput>;
  currencyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  files?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  forPeriod?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  hasBackingInvoice?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  notForPayment?: InputMaybe<BooleanOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TravelWarrantItemFilterInput>>;
  travelWarrant?: InputMaybe<TravelWarrantFilterInput>;
  travelWarrantId?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<ComparableDecimalOperationFilterInput>;
}

declare interface TravelWarrantItemSortInput {
  anCostNo?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  conversion?: InputMaybe<SortEnumType>;
  costType?: InputMaybe<TravelWarrantCostTypeSortInput>;
  costTypeId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<CurrencySortInput>;
  currencyId?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  forPeriod?: InputMaybe<SortEnumType>;
  hasBackingInvoice?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  notForPayment?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  travelWarrant?: InputMaybe<TravelWarrantSortInput>;
  travelWarrantId?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
}

declare interface TravelWarrantSortInput {
  applicationUser?: InputMaybe<ApplicationUserSortInput>;
  applicationUserId?: InputMaybe<SortEnumType>;
  coDrivers?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  country?: InputMaybe<CountrySortInput>;
  countryAllowance?: InputMaybe<SortEnumType>;
  countryAllowanceConversion?: InputMaybe<SortEnumType>;
  countryAllowanceCurrency?: InputMaybe<SortEnumType>;
  countryId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  documentNumber?: InputMaybe<SortEnumType>;
  downPayment?: InputMaybe<SortEnumType>;
  downPaymentConversion?: InputMaybe<SortEnumType>;
  downPaymentCurrency?: InputMaybe<CurrencySortInput>;
  downPaymentCurrencyId?: InputMaybe<SortEnumType>;
  driver?: InputMaybe<SortEnumType>;
  expenseBearer?: InputMaybe<ExpenseBearerSortInput>;
  expenseBearerAllowance?: InputMaybe<SortEnumType>;
  expenseBearerAllowanceConversion?: InputMaybe<SortEnumType>;
  expenseBearerCurrency?: InputMaybe<SortEnumType>;
  expenseBearerId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kilometersTraveled?: InputMaybe<SortEnumType>;
  lastClosedAt?: InputMaybe<SortEnumType>;
  lastOpenedAt?: InputMaybe<SortEnumType>;
  lastSentToFinalizeAt?: InputMaybe<SortEnumType>;
  lastSentToPantheonAt?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  officialVehicle?: InputMaybe<OfficialVehicleSortInput>;
  officialVehicleId?: InputMaybe<SortEnumType>;
  onixPantheonDMSId?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  pantheonStatus?: InputMaybe<SortEnumType>;
  perDiems?: InputMaybe<SortEnumType>;
  personalVehicle?: InputMaybe<PersonalVehicleSortInput>;
  personalVehicleId?: InputMaybe<SortEnumType>;
  place?: InputMaybe<SortEnumType>;
  placeOfDeparture?: InputMaybe<SortEnumType>;
  returnNote?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  syncErrorStack?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
  travelEndDateTime?: InputMaybe<SortEnumType>;
  travelEndMeter?: InputMaybe<SortEnumType>;
  travelHours?: InputMaybe<SortEnumType>;
  travelKilometersConversion?: InputMaybe<SortEnumType>;
  travelStartDateTime?: InputMaybe<SortEnumType>;
  travelStartMeter?: InputMaybe<SortEnumType>;
  vehicle?: InputMaybe<SortEnumType>;
}

declare type TravelWarrantStatus =
  | 'CLOSED'
  | 'OPEN'
  | 'SENT_TO_FINALIZE'
  | 'SENT_TO_PANTHEON';

declare interface TravelWarrantStatusOperationFilterInput {
  eq?: InputMaybe<TravelWarrantStatus>;
  in?: InputMaybe<Array<TravelWarrantStatus>>;
  neq?: InputMaybe<TravelWarrantStatus>;
  nin?: InputMaybe<Array<TravelWarrantStatus>>;
}

declare interface TrimTHeMoveRmaworkSpec {
  _AcNote2?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeMove>;
  acNote?: Maybe<Scalars['String']>;
  acWorker?: Maybe<Scalars['String']>;
  adTravelEnd?: Maybe<Scalars['DateTime']>;
  adTravelStart?: Maybe<Scalars['DateTime']>;
  adWorkEnd?: Maybe<Scalars['DateTime']>;
  adWorkStart?: Maybe<Scalars['DateTime']>;
  anMileage?: Maybe<Scalars['Decimal']>;
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anWork?: Maybe<Scalars['Decimal']>;
}

declare interface TrimTHeMoveRmaworkSpecFilterInput {
  _AcNote2?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeMoveFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acWorker?: InputMaybe<StringOperationFilterInput>;
  adTravelEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTravelStart?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adWorkEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adWorkStart?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anMileage?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWork?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  and?: InputMaybe<Array<TrimTHeMoveRmaworkSpecFilterInput>>;
  or?: InputMaybe<Array<TrimTHeMoveRmaworkSpecFilterInput>>;
}

declare interface TrimWorkOrderImageQuery {
  _AcPicture?: Maybe<Array<Scalars['Byte']>>;
  acLnkKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  anKey?: Maybe<Scalars['Long']>;
}

declare interface TrimWorkOrderImageQueryInput {
  _AcPicture?: InputMaybe<Array<Scalars['Byte']>>;
  acLnkKey?: InputMaybe<Scalars['String']>;
  acName?: InputMaybe<Scalars['String']>;
  anKey?: InputMaybe<Scalars['Long']>;
}

declare interface TrimWorkOrderMaterialQuery {
  acIdent?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acSerialNo?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  anNo: Scalars['Int'];
  anQty: Scalars['Decimal'];
}

declare interface TrimWorkOrderQuery {
  acContactPrsn?: Maybe<Scalars['String']>;
  acContactPrsn3?: Maybe<Scalars['String']>;
  acContactPrsn3Email?: Maybe<Scalars['String']>;
  acContactPrsnEmail?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acFieldSA?: Maybe<Scalars['String']>;
  acFieldSF?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acPrsn3?: Maybe<Scalars['String']>;
  acVerifyStatus?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  adFieldDA?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClerk?: Maybe<Scalars['Int']>;
  anClerkAcName?: Maybe<Scalars['String']>;
  anClerkAcSurname?: Maybe<Scalars['String']>;
  anFieldNA?: Maybe<Scalars['Decimal']>;
  anFieldNB?: Maybe<Scalars['Decimal']>;
  bearerAddress?: Maybe<Scalars['String']>;
  bearerName?: Maybe<Scalars['String']>;
  bearerPIN?: Maybe<Scalars['String']>;
  bearerPost?: Maybe<Scalars['String']>;
  bearerPostName?: Maybe<Scalars['String']>;
  customerAddress?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerPIN?: Maybe<Scalars['String']>;
  customerPost?: Maybe<Scalars['String']>;
  customerPostName?: Maybe<Scalars['String']>;
  receiverAddress?: Maybe<Scalars['String']>;
  receiverName?: Maybe<Scalars['String']>;
  receiverPIN?: Maybe<Scalars['String']>;
  receiverPost?: Maybe<Scalars['String']>;
  receiverPostName?: Maybe<Scalars['String']>;
  signature?: Maybe<Array<Scalars['Byte']>>;
  workOrderTotal?: Maybe<Scalars['Decimal']>;
}

declare interface TrimWorkOrderReceptionQuery {
  _OxInventoryNumber?: Maybe<Scalars['String']>;
  acDescr?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acSerialNo?: Maybe<Scalars['String']>;
  acSetOfItem?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  anNo?: Maybe<Scalars['Int']>;
  anQty: Scalars['Decimal'];
}

declare interface TrimWorkOrderReceptionQueryInput {
  _OxInventoryNumber?: InputMaybe<Scalars['String']>;
  acDescr?: InputMaybe<Scalars['String']>;
  acIdent?: InputMaybe<Scalars['String']>;
  acKey?: InputMaybe<Scalars['String']>;
  acName?: InputMaybe<Scalars['String']>;
  acNote?: InputMaybe<Scalars['String']>;
  acSerialNo?: InputMaybe<Scalars['String']>;
  acSetOfItem?: InputMaybe<Scalars['String']>;
  acUm?: InputMaybe<Scalars['String']>;
  anNo?: InputMaybe<Scalars['Int']>;
  anQty: Scalars['Decimal'];
}

declare interface TrimWorkOrderReclamationQuery {
  _OxInventoryNumber?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  anNo: Scalars['Int'];
  anQty: Scalars['Decimal'];
}

declare interface TrimWorkOrderServiceQuery {
  acIdent?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  anNo: Scalars['Int'];
  anQty: Scalars['Decimal'];
}

declare interface TrimWorkOrderSpecQuery {
  _AcNote2?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acWorker?: Maybe<Scalars['String']>;
  adWorkEnd?: Maybe<Scalars['DateTime']>;
  adWorkStart?: Maybe<Scalars['DateTime']>;
  anMileage?: Maybe<Scalars['Decimal']>;
  anNo: Scalars['Int'];
  anWork?: Maybe<Scalars['Decimal']>;
}

declare interface TrimWorkOrderTHeDocs {
  _AcPicture?: Maybe<Array<Scalars['Byte']>>;
  acAppl?: Maybe<Scalars['String']>;
  acForeignIdentifier?: Maybe<Scalars['String']>;
  acLnkKey?: Maybe<Scalars['String']>;
  acLnkKeyOrd?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acPerKey?: Maybe<Scalars['String']>;
  acPhoneUID?: Maybe<Scalars['String']>;
  acTypeDocu?: Maybe<Scalars['String']>;
  acUrl?: Maybe<Scalars['String']>;
  adDateValid?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anKey: Scalars['Long'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
}

declare interface TrimWorkOrderTHeDocsFilterInput {
  _AcPicture?: InputMaybe<ListComparableByteOperationFilterInput>;
  acAppl?: InputMaybe<StringOperationFilterInput>;
  acForeignIdentifier?: InputMaybe<StringOperationFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acLnkKeyOrd?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acPerKey?: InputMaybe<StringOperationFilterInput>;
  acPhoneUID?: InputMaybe<StringOperationFilterInput>;
  acTypeDocu?: InputMaybe<StringOperationFilterInput>;
  acUrl?: InputMaybe<StringOperationFilterInput>;
  adDateValid?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anKey?: InputMaybe<ComparableInt64OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TrimWorkOrderTHeDocsFilterInput>>;
  or?: InputMaybe<Array<TrimWorkOrderTHeDocsFilterInput>>;
}

declare interface TrimWorkOrderTHeDocsSortInput {
  acAppl?: InputMaybe<SortEnumType>;
  acForeignIdentifier?: InputMaybe<SortEnumType>;
  acLnkKey?: InputMaybe<SortEnumType>;
  acLnkKeyOrd?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acPerKey?: InputMaybe<SortEnumType>;
  acPhoneUID?: InputMaybe<SortEnumType>;
  acTypeDocu?: InputMaybe<SortEnumType>;
  acUrl?: InputMaybe<SortEnumType>;
  adDateValid?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anKey?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
}

declare interface UnreadUserSupportTicketMessage {
  message?: Maybe<SupportTicketMessage>;
  messageId: Scalars['Int'];
  type: NotificationType;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
}

declare interface UnreadUserSupportTicketMessageFilterInput {
  and?: InputMaybe<Array<UnreadUserSupportTicketMessageFilterInput>>;
  message?: InputMaybe<SupportTicketMessageFilterInput>;
  messageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<UnreadUserSupportTicketMessageFilterInput>>;
  type?: InputMaybe<NotificationTypeOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
}

declare interface UpdateOxDmsxmlitemDtoInput {
  acCostBearer?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acIdent?: InputMaybe<Scalars['String']>;
  anDocumentQId: Scalars['Int'];
  anId: Scalars['Int'];
}

declare interface UpdateSubjectDtoInput {
  acAddress?: InputMaybe<Scalars['String']>;
  acBuyer?: InputMaybe<Scalars['String']>;
  acEmail?: InputMaybe<Scalars['String']>;
  acFax?: InputMaybe<Scalars['String']>;
  acHttpPath?: InputMaybe<Scalars['String']>;
  acName2?: InputMaybe<Scalars['String']>;
  acPayMethod?: InputMaybe<Scalars['String']>;
  acPayer?: InputMaybe<Scalars['String']>;
  acPhone?: InputMaybe<Scalars['String']>;
  acPin?: InputMaybe<Scalars['String']>;
  acPost?: InputMaybe<Scalars['String']>;
  acSkis?: InputMaybe<Scalars['String']>;
  acSubject: Scalars['String'];
  acSupplier?: InputMaybe<Scalars['String']>;
  acWayOfSale?: InputMaybe<Scalars['String']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  anDaysForPayment?: InputMaybe<Scalars['Int']>;
  docId?: InputMaybe<Scalars['Int']>;
}

declare interface UpdateTHeSetSubjContactAddressDtoInput {
  acNote?: InputMaybe<Scalars['String']>;
  acPhone?: InputMaybe<Scalars['String']>;
  acType?: InputMaybe<Scalars['String']>;
}

declare interface UpdateTHeSetSubjContactDtoInput {
  acActive?: InputMaybe<Scalars['String']>;
  acFunction?: InputMaybe<Scalars['String']>;
  acName?: InputMaybe<Scalars['String']>;
  acSubject?: InputMaybe<Scalars['String']>;
  acSurname?: InputMaybe<Scalars['String']>;
}

declare interface UpdateTMnDocumentDtoInput {
  acStatus?: InputMaybe<Scalars['String']>;
  anClassifIcationQid?: InputMaybe<Scalars['Int']>;
  anMailBoxQid?: InputMaybe<Scalars['Int']>;
  anStorageQid?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>;
  note?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
}

declare interface UpdateTMnFileDtoInput {
  fileContent?: InputMaybe<Array<Scalars['Byte']>>;
  fileName?: InputMaybe<Scalars['String']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  tMnDocumentId: Scalars['Int'];
}

declare interface UpdateWorkOrderDtoInput {
  acContactPrsn?: InputMaybe<Scalars['String']>;
  acContactPrsn3?: InputMaybe<Scalars['String']>;
  acDoc1?: InputMaybe<Scalars['String']>;
  acDoc1Date?: InputMaybe<Scalars['DateTime']>;
  acDoc2?: InputMaybe<Scalars['String']>;
  acDoc2Date?: InputMaybe<Scalars['DateTime']>;
  acFieldSF?: InputMaybe<Scalars['String']>;
  acKey?: InputMaybe<Scalars['String']>;
  acNote?: InputMaybe<Scalars['String']>;
  anFieldNA?: InputMaybe<Scalars['Decimal']>;
  anFieldNB?: InputMaybe<Scalars['Decimal']>;
  documentType?: InputMaybe<Scalars['Int']>;
  otherAcWorkers?: InputMaybe<Array<Scalars['String']>>;
  receiver?: InputMaybe<Scalars['String']>;
  uID?: InputMaybe<Scalars['String']>;
}

declare interface UserArbitrarySetting {
  alsoIncludeThisPantheonUserOfflineCodebooks?: Maybe<Scalars['Int']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
}

declare interface UserArbitrarySettingFilterInput {
  alsoIncludeThisPantheonUserOfflineCodebooks?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<UserArbitrarySettingFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<UserArbitrarySettingFilterInput>>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
}

declare interface UserArbitrarySettingSortInput {
  alsoIncludeThisPantheonUserOfflineCodebooks?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
}

declare interface VHeMove {
  acAcctClaimLiab?: Maybe<Scalars['String']>;
  acCode1?: Maybe<Scalars['String']>;
  acCode2?: Maybe<Scalars['String']>;
  acCode3?: Maybe<Scalars['String']>;
  acContactPrsn?: Maybe<Scalars['String']>;
  acContactPrsn3?: Maybe<Scalars['String']>;
  acContractNo?: Maybe<Scalars['String']>;
  acCostDrvOut?: Maybe<Scalars['String']>;
  acCreatFromWo?: Maybe<Scalars['String']>;
  acCreatePayOrd?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acDelivery?: Maybe<Scalars['String']>;
  acDeliveryUnderArt163a?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDeptOut?: Maybe<Scalars['String']>;
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acDocTypePayOrd?: Maybe<Scalars['String']>;
  acDocTypePayOrdFgn?: Maybe<Scalars['String']>;
  acDocTypeStatusName?: Maybe<Scalars['String']>;
  acDutyTran?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSf?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFieldSj?: Maybe<Scalars['String']>;
  acFiscSalesBookDocNo?: Maybe<Scalars['String']>;
  acFiscSalesBookSerNo?: Maybe<Scalars['String']>;
  acFiscSalesBookSetNo?: Maybe<Scalars['String']>;
  acFiscStatus?: Maybe<Scalars['String']>;
  acFiskPrintNo?: Maybe<Scalars['String']>;
  acFiskPrintNoS?: Maybe<Scalars['String']>;
  acForm?: Maybe<Scalars['String']>;
  acInternalNote?: Maybe<Scalars['String']>;
  acInvoiceForm?: Maybe<Scalars['String']>;
  acIsocountry?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerName2?: Maybe<Scalars['String']>;
  acIssuerStock?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyView?: Maybe<Scalars['String']>;
  acLimitDuty?: Maybe<Scalars['String']>;
  acLoyaltyCard?: Maybe<Scalars['String']>;
  acNaturalPerson3?: Maybe<Scalars['String']>;
  acNaturalPersonI?: Maybe<Scalars['String']>;
  acNaturalPersonR?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acNote2?: Maybe<Scalars['String']>;
  acNote3?: Maybe<Scalars['String']>;
  acNoteClerkName?: Maybe<Scalars['String']>;
  acPackNum?: Maybe<Scalars['String']>;
  acParity?: Maybe<Scalars['String']>;
  acParityPost?: Maybe<Scalars['String']>;
  acParityType?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPayPurpose1?: Maybe<Scalars['String']>;
  acPayPurpose2?: Maybe<Scalars['String']>;
  acPayPurpose3?: Maybe<Scalars['String']>;
  acPosted?: Maybe<Scalars['String']>;
  acPriceRate?: Maybe<Scalars['String']>;
  acProc?: Maybe<Scalars['String']>;
  acPrsn3?: Maybe<Scalars['String']>;
  acPrsn3Name2?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverName2?: Maybe<Scalars['String']>;
  acReceiverStock?: Maybe<Scalars['String']>;
  acRefNo1?: Maybe<Scalars['String']>;
  acRefNo2?: Maybe<Scalars['String']>;
  acRefNo3?: Maybe<Scalars['String']>;
  acRefNo4?: Maybe<Scalars['String']>;
  acRetailSale?: Maybe<Scalars['String']>;
  acRoundVatonDoc?: Maybe<Scalars['String']>;
  acStatement?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  acTransPaperForm?: Maybe<Scalars['String']>;
  acTransportCalcType?: Maybe<Scalars['String']>;
  acTriangTrans?: Maybe<Scalars['String']>;
  acUjpdocId?: Maybe<Scalars['String']>;
  acUpncode?: Maybe<Scalars['String']>;
  acUpncontrolNum?: Maybe<Scalars['String']>;
  acUpnreference?: Maybe<Scalars['String']>;
  acUserChgName?: Maybe<Scalars['String']>;
  acVatattType?: Maybe<Scalars['String']>;
  acVerifiedPrices?: Maybe<Scalars['String']>;
  acVerifyStatus?: Maybe<Scalars['String']>;
  acWayOfSale?: Maybe<Scalars['String']>;
  acWayOfSale3?: Maybe<Scalars['String']>;
  acWayOfSaleI?: Maybe<Scalars['String']>;
  acWayOfSaleR?: Maybe<Scalars['String']>;
  acXmldocType?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateBeforeVat?: Maybe<Scalars['DateTime']>;
  adDateDdvpay?: Maybe<Scalars['DateTime']>;
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  adDateDue?: Maybe<Scalars['DateTime']>;
  adDateInv?: Maybe<Scalars['DateTime']>;
  adDateVat?: Maybe<Scalars['DateTime']>;
  adFieldDa?: Maybe<Scalars['DateTime']>;
  adFieldDb?: Maybe<Scalars['DateTime']>;
  adFieldDc?: Maybe<Scalars['DateTime']>;
  adFieldDd?: Maybe<Scalars['DateTime']>;
  adSigned1?: Maybe<Scalars['DateTime']>;
  adSigned2?: Maybe<Scalars['DateTime']>;
  adSigned3?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  adVatattDate?: Maybe<Scalars['DateTime']>;
  anBnkAcctNo: Scalars['Int'];
  anClerk?: Maybe<Scalars['Int']>;
  anCurrValue: Scalars['Decimal'];
  anDaysForPayment: Scalars['Int'];
  anDirectCost: Scalars['Float'];
  anDiscount: Scalars['Decimal'];
  anDuty: Scalars['Decimal'];
  anFgnBankNo?: Maybe<Scalars['Int']>;
  anFieldNa?: Maybe<Scalars['Decimal']>;
  anFieldNb?: Maybe<Scalars['Decimal']>;
  anFieldNc?: Maybe<Scalars['Decimal']>;
  anFieldNd?: Maybe<Scalars['Decimal']>;
  anFieldNe?: Maybe<Scalars['Decimal']>;
  anFieldNf?: Maybe<Scalars['Decimal']>;
  anFieldNg?: Maybe<Scalars['Decimal']>;
  anFieldNh?: Maybe<Scalars['Decimal']>;
  anFieldNi?: Maybe<Scalars['Decimal']>;
  anFieldNj?: Maybe<Scalars['Decimal']>;
  anForPay: Scalars['Decimal'];
  anFxrate: Scalars['Decimal'];
  anIncTax: Scalars['Decimal'];
  anLicensesBase?: Maybe<Scalars['Decimal']>;
  anLicensesVat?: Maybe<Scalars['Decimal']>;
  anNoteClerk?: Maybe<Scalars['Int']>;
  anOurBankAcctNo?: Maybe<Scalars['Int']>;
  anOurBankAcctNoFgn?: Maybe<Scalars['Int']>;
  anPermissionSelect: Scalars['Boolean'];
  anQidGdprlogS0?: Maybe<Scalars['Int']>;
  anQidGdprlogS1?: Maybe<Scalars['Int']>;
  anQidGdprlogS2?: Maybe<Scalars['Int']>;
  anRebate: Scalars['Decimal'];
  anReverseChargeCoefficient?: Maybe<Scalars['Float']>;
  anRoundItem: Scalars['Decimal'];
  anRoundItemFc: Scalars['Decimal'];
  anRoundPrice: Scalars['Decimal'];
  anRoundValue: Scalars['Decimal'];
  anRoundValueOc: Scalars['Decimal'];
  anSeqWhNoIn?: Maybe<Scalars['Int']>;
  anSeqWhNoOut?: Maybe<Scalars['Int']>;
  anSigner1?: Maybe<Scalars['Int']>;
  anSigner2?: Maybe<Scalars['Int']>;
  anSigner3?: Maybe<Scalars['Int']>;
  anState: Scalars['Int'];
  anTransport: Scalars['Decimal'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Decimal'];
  anVat: Scalars['Decimal'];
  anVatbase: Scalars['Decimal'];
  anVatin: Scalars['Decimal'];
}

declare interface VHeMoveFilterInput {
  acAcctClaimLiab?: InputMaybe<StringOperationFilterInput>;
  acCode1?: InputMaybe<StringOperationFilterInput>;
  acCode2?: InputMaybe<StringOperationFilterInput>;
  acCode3?: InputMaybe<StringOperationFilterInput>;
  acContactPrsn?: InputMaybe<StringOperationFilterInput>;
  acContactPrsn3?: InputMaybe<StringOperationFilterInput>;
  acContractNo?: InputMaybe<StringOperationFilterInput>;
  acCostDrvOut?: InputMaybe<StringOperationFilterInput>;
  acCreatFromWo?: InputMaybe<StringOperationFilterInput>;
  acCreatePayOrd?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDelivery?: InputMaybe<StringOperationFilterInput>;
  acDeliveryUnderArt163a?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDeptOut?: InputMaybe<StringOperationFilterInput>;
  acDoc1?: InputMaybe<StringOperationFilterInput>;
  acDoc2?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acDocTypePayOrd?: InputMaybe<StringOperationFilterInput>;
  acDocTypePayOrdFgn?: InputMaybe<StringOperationFilterInput>;
  acDocTypeStatusName?: InputMaybe<StringOperationFilterInput>;
  acDutyTran?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSf?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFieldSj?: InputMaybe<StringOperationFilterInput>;
  acFiscSalesBookDocNo?: InputMaybe<StringOperationFilterInput>;
  acFiscSalesBookSerNo?: InputMaybe<StringOperationFilterInput>;
  acFiscSalesBookSetNo?: InputMaybe<StringOperationFilterInput>;
  acFiscStatus?: InputMaybe<StringOperationFilterInput>;
  acFiskPrintNo?: InputMaybe<StringOperationFilterInput>;
  acFiskPrintNoS?: InputMaybe<StringOperationFilterInput>;
  acForm?: InputMaybe<StringOperationFilterInput>;
  acInternalNote?: InputMaybe<StringOperationFilterInput>;
  acInvoiceForm?: InputMaybe<StringOperationFilterInput>;
  acIsocountry?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerName2?: InputMaybe<StringOperationFilterInput>;
  acIssuerStock?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyView?: InputMaybe<StringOperationFilterInput>;
  acLimitDuty?: InputMaybe<StringOperationFilterInput>;
  acLoyaltyCard?: InputMaybe<StringOperationFilterInput>;
  acNaturalPerson3?: InputMaybe<StringOperationFilterInput>;
  acNaturalPersonI?: InputMaybe<StringOperationFilterInput>;
  acNaturalPersonR?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acNote2?: InputMaybe<StringOperationFilterInput>;
  acNote3?: InputMaybe<StringOperationFilterInput>;
  acNoteClerkName?: InputMaybe<StringOperationFilterInput>;
  acPackNum?: InputMaybe<StringOperationFilterInput>;
  acParity?: InputMaybe<StringOperationFilterInput>;
  acParityPost?: InputMaybe<StringOperationFilterInput>;
  acParityType?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPayPurpose1?: InputMaybe<StringOperationFilterInput>;
  acPayPurpose2?: InputMaybe<StringOperationFilterInput>;
  acPayPurpose3?: InputMaybe<StringOperationFilterInput>;
  acPosted?: InputMaybe<StringOperationFilterInput>;
  acPriceRate?: InputMaybe<StringOperationFilterInput>;
  acProc?: InputMaybe<StringOperationFilterInput>;
  acPrsn3?: InputMaybe<StringOperationFilterInput>;
  acPrsn3Name2?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverName2?: InputMaybe<StringOperationFilterInput>;
  acReceiverStock?: InputMaybe<StringOperationFilterInput>;
  acRefNo1?: InputMaybe<StringOperationFilterInput>;
  acRefNo2?: InputMaybe<StringOperationFilterInput>;
  acRefNo3?: InputMaybe<StringOperationFilterInput>;
  acRefNo4?: InputMaybe<StringOperationFilterInput>;
  acRetailSale?: InputMaybe<StringOperationFilterInput>;
  acRoundVatonDoc?: InputMaybe<StringOperationFilterInput>;
  acStatement?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acTransPaperForm?: InputMaybe<StringOperationFilterInput>;
  acTransportCalcType?: InputMaybe<StringOperationFilterInput>;
  acTriangTrans?: InputMaybe<StringOperationFilterInput>;
  acUjpdocId?: InputMaybe<StringOperationFilterInput>;
  acUpncode?: InputMaybe<StringOperationFilterInput>;
  acUpncontrolNum?: InputMaybe<StringOperationFilterInput>;
  acUpnreference?: InputMaybe<StringOperationFilterInput>;
  acUserChgName?: InputMaybe<StringOperationFilterInput>;
  acVatattType?: InputMaybe<StringOperationFilterInput>;
  acVerifiedPrices?: InputMaybe<StringOperationFilterInput>;
  acVerifyStatus?: InputMaybe<StringOperationFilterInput>;
  acWayOfSale?: InputMaybe<StringOperationFilterInput>;
  acWayOfSale3?: InputMaybe<StringOperationFilterInput>;
  acWayOfSaleI?: InputMaybe<StringOperationFilterInput>;
  acWayOfSaleR?: InputMaybe<StringOperationFilterInput>;
  acXmldocType?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateBeforeVat?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDdvpay?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc1?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc2?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateInv?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateVat?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDa?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDb?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSigned1?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSigned2?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSigned3?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adVatattDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anBnkAcctNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anCurrValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDaysForPayment?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDirectCost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anDiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDuty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFgnBankNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNd?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNe?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNf?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNh?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNi?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNj?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anForPay?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFxrate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anIncTax?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anLicensesBase?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anLicensesVat?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anNoteClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anOurBankAcctNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anOurBankAcctNoFgn?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPermissionSelect?: InputMaybe<BooleanOperationFilterInput>;
  anQidGdprlogS0?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQidGdprlogS1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQidGdprlogS2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anReverseChargeCoefficient?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anRoundItem?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundItemFc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundValueOc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anSeqWhNoIn?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSeqWhNoOut?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anState?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTransport?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVatbase?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVatin?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<VHeMoveFilterInput>>;
  or?: InputMaybe<Array<VHeMoveFilterInput>>;
}

declare interface VHeMoveFiscalisation {
  acError?: Maybe<Scalars['String']>;
  acHrfiskalNumber?: Maybe<Scalars['String']>;
  acJir?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acSifiskalNumber?: Maybe<Scalars['String']>;
  acYearInv?: Maybe<Scalars['String']>;
  acZik?: Maybe<Scalars['String']>;
  adFiscalDate?: Maybe<Scalars['DateTime']>;
}

declare interface VHeMoveFiscalisationFilterInput {
  acError?: InputMaybe<StringOperationFilterInput>;
  acHrfiskalNumber?: InputMaybe<StringOperationFilterInput>;
  acJir?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acSifiskalNumber?: InputMaybe<StringOperationFilterInput>;
  acYearInv?: InputMaybe<StringOperationFilterInput>;
  acZik?: InputMaybe<StringOperationFilterInput>;
  adFiscalDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  and?: InputMaybe<Array<VHeMoveFiscalisationFilterInput>>;
  or?: InputMaybe<Array<VHeMoveFiscalisationFilterInput>>;
}

declare interface VHeMoveOut {
  acAcctClaimLiab?: Maybe<Scalars['String']>;
  acCode1?: Maybe<Scalars['String']>;
  acCode2?: Maybe<Scalars['String']>;
  acCode3?: Maybe<Scalars['String']>;
  acContactPrsn?: Maybe<Scalars['String']>;
  acContactPrsn3?: Maybe<Scalars['String']>;
  acContractNo?: Maybe<Scalars['String']>;
  acCostDrvOut?: Maybe<Scalars['String']>;
  acCreatFromWo?: Maybe<Scalars['String']>;
  acCreatePayOrd?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acDelivery?: Maybe<Scalars['String']>;
  acDeliveryUnderArt163a?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDeptOut?: Maybe<Scalars['String']>;
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acDocTypeStatusName?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSf?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFieldSj?: Maybe<Scalars['String']>;
  acFiscSalesBookDocNo?: Maybe<Scalars['String']>;
  acFiscSalesBookSerNo?: Maybe<Scalars['String']>;
  acFiscSalesBookSetNo?: Maybe<Scalars['String']>;
  acFiscStatus?: Maybe<Scalars['String']>;
  acFiscalNumber?: Maybe<Scalars['String']>;
  acFiskPrintNo?: Maybe<Scalars['String']>;
  acFiskPrintNoS?: Maybe<Scalars['String']>;
  acForm?: Maybe<Scalars['String']>;
  acIdbcstate?: Maybe<Scalars['String']>;
  acInternalNote?: Maybe<Scalars['String']>;
  acInvoiceForm?: Maybe<Scalars['String']>;
  acIsocountry?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerName2?: Maybe<Scalars['String']>;
  acIssuerStock?: Maybe<Scalars['String']>;
  acJir?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyView?: Maybe<Scalars['String']>;
  acLimitDuty?: Maybe<Scalars['String']>;
  acLoyaltyCard?: Maybe<Scalars['String']>;
  acNaturalPerson3?: Maybe<Scalars['String']>;
  acNaturalPersonI?: Maybe<Scalars['String']>;
  acNaturalPersonR?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acNote2?: Maybe<Scalars['String']>;
  acNote3?: Maybe<Scalars['String']>;
  acNoteClerkName?: Maybe<Scalars['String']>;
  acPackNum?: Maybe<Scalars['String']>;
  acParity?: Maybe<Scalars['String']>;
  acParityPost?: Maybe<Scalars['String']>;
  acParityType?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPayPurpose1?: Maybe<Scalars['String']>;
  acPayPurpose2?: Maybe<Scalars['String']>;
  acPayPurpose3?: Maybe<Scalars['String']>;
  acPosted?: Maybe<Scalars['String']>;
  acPriceRate?: Maybe<Scalars['String']>;
  acProc?: Maybe<Scalars['String']>;
  acPrsn3?: Maybe<Scalars['String']>;
  acPrsn3Name2?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverName2?: Maybe<Scalars['String']>;
  acReceiverStock?: Maybe<Scalars['String']>;
  acRefNo1?: Maybe<Scalars['String']>;
  acRefNo2?: Maybe<Scalars['String']>;
  acRefNo3?: Maybe<Scalars['String']>;
  acRefNo4?: Maybe<Scalars['String']>;
  acRetailSale?: Maybe<Scalars['String']>;
  acRoundVatonDoc?: Maybe<Scalars['String']>;
  acStatement?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  acTrailerRegistrationNumber?: Maybe<Scalars['String']>;
  acTransPaperForm?: Maybe<Scalars['String']>;
  acTransportCalcType?: Maybe<Scalars['String']>;
  acTransporter?: Maybe<Scalars['String']>;
  acTriangTrans?: Maybe<Scalars['String']>;
  acUjpdocId?: Maybe<Scalars['String']>;
  acUserChgName?: Maybe<Scalars['String']>;
  acVatattType?: Maybe<Scalars['String']>;
  acVehicleRegistrationNumber?: Maybe<Scalars['String']>;
  acVerifiedPrices?: Maybe<Scalars['String']>;
  acVerifyStatus?: Maybe<Scalars['String']>;
  acWayOfSale?: Maybe<Scalars['String']>;
  acWayOfSale3?: Maybe<Scalars['String']>;
  acWayOfSaleR?: Maybe<Scalars['String']>;
  acXmldocType?: Maybe<Scalars['String']>;
  acZik?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateBeforeVat?: Maybe<Scalars['DateTime']>;
  adDateDdvpay?: Maybe<Scalars['DateTime']>;
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  adDateDue?: Maybe<Scalars['DateTime']>;
  adDateInv?: Maybe<Scalars['DateTime']>;
  adDateTimePrint?: Maybe<Scalars['DateTime']>;
  adDateVat?: Maybe<Scalars['DateTime']>;
  adFieldDa?: Maybe<Scalars['DateTime']>;
  adFieldDb?: Maybe<Scalars['DateTime']>;
  adFieldDc?: Maybe<Scalars['DateTime']>;
  adFieldDd?: Maybe<Scalars['DateTime']>;
  adSigned1?: Maybe<Scalars['DateTime']>;
  adSigned2?: Maybe<Scalars['DateTime']>;
  adSigned3?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeFiscal?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  adVatattDate?: Maybe<Scalars['DateTime']>;
  anBnkAcctNo: Scalars['Int'];
  anCalcDiscPrc?: Maybe<Scalars['Float']>;
  anCalcSum?: Maybe<Scalars['Decimal']>;
  anClerk?: Maybe<Scalars['Int']>;
  anCurrValue: Scalars['Decimal'];
  anDaysForPayment: Scalars['Int'];
  anDirectCost: Scalars['Float'];
  anDiscount: Scalars['Decimal'];
  anDuty: Scalars['Decimal'];
  anFieldNa?: Maybe<Scalars['Decimal']>;
  anFieldNb?: Maybe<Scalars['Decimal']>;
  anFieldNc?: Maybe<Scalars['Decimal']>;
  anFieldNd?: Maybe<Scalars['Decimal']>;
  anFieldNe?: Maybe<Scalars['Decimal']>;
  anFieldNf?: Maybe<Scalars['Decimal']>;
  anFieldNg?: Maybe<Scalars['Decimal']>;
  anFieldNh?: Maybe<Scalars['Decimal']>;
  anFieldNi?: Maybe<Scalars['Decimal']>;
  anFieldNj?: Maybe<Scalars['Decimal']>;
  anForPay: Scalars['Decimal'];
  anFxrate: Scalars['Decimal'];
  anIncTax: Scalars['Decimal'];
  anNoteClerk?: Maybe<Scalars['Int']>;
  anOurBankAcctNo?: Maybe<Scalars['Int']>;
  anOurBankAcctNoFgn?: Maybe<Scalars['Int']>;
  anPermissionSelect: Scalars['Boolean'];
  anQidGdprlogS0?: Maybe<Scalars['Int']>;
  anQidGdprlogS1?: Maybe<Scalars['Int']>;
  anQidGdprlogS2?: Maybe<Scalars['Int']>;
  anRebate: Scalars['Decimal'];
  anReverseChargeCoefficient?: Maybe<Scalars['Float']>;
  anRoundItem: Scalars['Decimal'];
  anRoundItemFc: Scalars['Decimal'];
  anRoundPrice: Scalars['Decimal'];
  anRoundValue: Scalars['Decimal'];
  anRoundValueOc: Scalars['Decimal'];
  anSeqWhNoIn?: Maybe<Scalars['Int']>;
  anSeqWhNoOut?: Maybe<Scalars['Int']>;
  anSigner1?: Maybe<Scalars['Int']>;
  anSigner2?: Maybe<Scalars['Int']>;
  anSigner3?: Maybe<Scalars['Int']>;
  anState: Scalars['Int'];
  anTransport: Scalars['Decimal'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Decimal'];
  anVat: Scalars['Decimal'];
  anVatbase: Scalars['Decimal'];
  anVatin: Scalars['Decimal'];
}

declare interface VHeMoveOutFilterInput {
  acAcctClaimLiab?: InputMaybe<StringOperationFilterInput>;
  acCode1?: InputMaybe<StringOperationFilterInput>;
  acCode2?: InputMaybe<StringOperationFilterInput>;
  acCode3?: InputMaybe<StringOperationFilterInput>;
  acContactPrsn?: InputMaybe<StringOperationFilterInput>;
  acContactPrsn3?: InputMaybe<StringOperationFilterInput>;
  acContractNo?: InputMaybe<StringOperationFilterInput>;
  acCostDrvOut?: InputMaybe<StringOperationFilterInput>;
  acCreatFromWo?: InputMaybe<StringOperationFilterInput>;
  acCreatePayOrd?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDelivery?: InputMaybe<StringOperationFilterInput>;
  acDeliveryUnderArt163a?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDeptOut?: InputMaybe<StringOperationFilterInput>;
  acDoc1?: InputMaybe<StringOperationFilterInput>;
  acDoc2?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acDocTypeStatusName?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSf?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFieldSj?: InputMaybe<StringOperationFilterInput>;
  acFiscSalesBookDocNo?: InputMaybe<StringOperationFilterInput>;
  acFiscSalesBookSerNo?: InputMaybe<StringOperationFilterInput>;
  acFiscSalesBookSetNo?: InputMaybe<StringOperationFilterInput>;
  acFiscStatus?: InputMaybe<StringOperationFilterInput>;
  acFiscalNumber?: InputMaybe<StringOperationFilterInput>;
  acFiskPrintNo?: InputMaybe<StringOperationFilterInput>;
  acFiskPrintNoS?: InputMaybe<StringOperationFilterInput>;
  acForm?: InputMaybe<StringOperationFilterInput>;
  acIdbcstate?: InputMaybe<StringOperationFilterInput>;
  acInternalNote?: InputMaybe<StringOperationFilterInput>;
  acInvoiceForm?: InputMaybe<StringOperationFilterInput>;
  acIsocountry?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerName2?: InputMaybe<StringOperationFilterInput>;
  acIssuerStock?: InputMaybe<StringOperationFilterInput>;
  acJir?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyView?: InputMaybe<StringOperationFilterInput>;
  acLimitDuty?: InputMaybe<StringOperationFilterInput>;
  acLoyaltyCard?: InputMaybe<StringOperationFilterInput>;
  acNaturalPerson3?: InputMaybe<StringOperationFilterInput>;
  acNaturalPersonI?: InputMaybe<StringOperationFilterInput>;
  acNaturalPersonR?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acNote2?: InputMaybe<StringOperationFilterInput>;
  acNote3?: InputMaybe<StringOperationFilterInput>;
  acNoteClerkName?: InputMaybe<StringOperationFilterInput>;
  acPackNum?: InputMaybe<StringOperationFilterInput>;
  acParity?: InputMaybe<StringOperationFilterInput>;
  acParityPost?: InputMaybe<StringOperationFilterInput>;
  acParityType?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPayPurpose1?: InputMaybe<StringOperationFilterInput>;
  acPayPurpose2?: InputMaybe<StringOperationFilterInput>;
  acPayPurpose3?: InputMaybe<StringOperationFilterInput>;
  acPosted?: InputMaybe<StringOperationFilterInput>;
  acPriceRate?: InputMaybe<StringOperationFilterInput>;
  acProc?: InputMaybe<StringOperationFilterInput>;
  acPrsn3?: InputMaybe<StringOperationFilterInput>;
  acPrsn3Name2?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverName2?: InputMaybe<StringOperationFilterInput>;
  acReceiverStock?: InputMaybe<StringOperationFilterInput>;
  acRefNo1?: InputMaybe<StringOperationFilterInput>;
  acRefNo2?: InputMaybe<StringOperationFilterInput>;
  acRefNo3?: InputMaybe<StringOperationFilterInput>;
  acRefNo4?: InputMaybe<StringOperationFilterInput>;
  acRetailSale?: InputMaybe<StringOperationFilterInput>;
  acRoundVatonDoc?: InputMaybe<StringOperationFilterInput>;
  acStatement?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acTrailerRegistrationNumber?: InputMaybe<StringOperationFilterInput>;
  acTransPaperForm?: InputMaybe<StringOperationFilterInput>;
  acTransportCalcType?: InputMaybe<StringOperationFilterInput>;
  acTransporter?: InputMaybe<StringOperationFilterInput>;
  acTriangTrans?: InputMaybe<StringOperationFilterInput>;
  acUjpdocId?: InputMaybe<StringOperationFilterInput>;
  acUserChgName?: InputMaybe<StringOperationFilterInput>;
  acVatattType?: InputMaybe<StringOperationFilterInput>;
  acVehicleRegistrationNumber?: InputMaybe<StringOperationFilterInput>;
  acVerifiedPrices?: InputMaybe<StringOperationFilterInput>;
  acVerifyStatus?: InputMaybe<StringOperationFilterInput>;
  acWayOfSale?: InputMaybe<StringOperationFilterInput>;
  acWayOfSale3?: InputMaybe<StringOperationFilterInput>;
  acWayOfSaleR?: InputMaybe<StringOperationFilterInput>;
  acXmldocType?: InputMaybe<StringOperationFilterInput>;
  acZik?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateBeforeVat?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDdvpay?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc1?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc2?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateInv?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateTimePrint?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateVat?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDa?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDb?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSigned1?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSigned2?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSigned3?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeFiscal?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adVatattDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anBnkAcctNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anCalcDiscPrc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anCalcSum?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anCurrValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDaysForPayment?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDirectCost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anDiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDuty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNd?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNe?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNf?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNh?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNi?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNj?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anForPay?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFxrate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anIncTax?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anNoteClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anOurBankAcctNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anOurBankAcctNoFgn?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPermissionSelect?: InputMaybe<BooleanOperationFilterInput>;
  anQidGdprlogS0?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQidGdprlogS1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQidGdprlogS2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anReverseChargeCoefficient?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anRoundItem?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundItemFc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundValueOc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anSeqWhNoIn?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSeqWhNoOut?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anState?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTransport?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVatbase?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVatin?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<VHeMoveOutFilterInput>>;
  or?: InputMaybe<Array<VHeMoveOutFilterInput>>;
}

declare interface VopSetDept {
  acSubject?: Maybe<Scalars['String']>;
}

declare interface VopSetDeptFilterInput {
  acSubject?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<VopSetDeptFilterInput>>;
  or?: InputMaybe<Array<VopSetDeptFilterInput>>;
}

declare interface VopSetDeptSortInput {
  acSubject?: InputMaybe<SortEnumType>;
}

declare interface VopSetItem {
  acClassif?: Maybe<Scalars['String']>;
  acCustTariff?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acShowDays?: Maybe<Scalars['String']>;
  acdept?: Maybe<Scalars['String']>;
  anExcise: Scalars['Float'];
  anExciseP: Scalars['Float'];
  anExcisePercent?: Maybe<Scalars['Decimal']>;
  anExciseValue?: Maybe<Scalars['Decimal']>;
  anRtprice: Scalars['Float'];
  anSaleprice: Scalars['Decimal'];
  anVAT: Scalars['Decimal'];
  dutyAcSetOfTax?: Maybe<Scalars['String']>;
  dutyName?: Maybe<Scalars['String']>;
}

declare interface VopSetItemCateg {
  acClassif?: Maybe<Scalars['String']>;
  acdept?: Maybe<Scalars['String']>;
}

declare interface VopSetItemCategFilterInput {
  acClassif?: InputMaybe<StringOperationFilterInput>;
  acdept?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<VopSetItemCategFilterInput>>;
  or?: InputMaybe<Array<VopSetItemCategFilterInput>>;
}

declare interface VopSetItemCategSortInput {
  acClassif?: InputMaybe<SortEnumType>;
  acdept?: InputMaybe<SortEnumType>;
}

/** A connection to a list of items. */
declare interface VopSetItemCategsPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<VopSetItemCategsPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<VopSetItemCateg>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface VopSetItemCategsPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<VopSetItemCateg>;
}

declare interface VopSetItemFilterInput {
  acClassif?: InputMaybe<StringOperationFilterInput>;
  acCustTariff?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acShowDays?: InputMaybe<StringOperationFilterInput>;
  acdept?: InputMaybe<StringOperationFilterInput>;
  anExcise?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExciseP?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExcisePercent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anExciseValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anRtprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anSaleprice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVAT?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<VopSetItemFilterInput>>;
  dutyAcSetOfTax?: InputMaybe<StringOperationFilterInput>;
  dutyName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VopSetItemFilterInput>>;
}

declare interface VopSetItemSortInput {
  acClassif?: InputMaybe<SortEnumType>;
  acCustTariff?: InputMaybe<SortEnumType>;
  acIdent?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acShowDays?: InputMaybe<SortEnumType>;
  acdept?: InputMaybe<SortEnumType>;
  anExcise?: InputMaybe<SortEnumType>;
  anExciseP?: InputMaybe<SortEnumType>;
  anExcisePercent?: InputMaybe<SortEnumType>;
  anExciseValue?: InputMaybe<SortEnumType>;
  anRtprice?: InputMaybe<SortEnumType>;
  anSaleprice?: InputMaybe<SortEnumType>;
  anVAT?: InputMaybe<SortEnumType>;
  dutyAcSetOfTax?: InputMaybe<SortEnumType>;
  dutyName?: InputMaybe<SortEnumType>;
}

/** A connection to a list of items. */
declare interface VopSetItemsPagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<VopSetItemsPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<VopSetItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface VopSetItemsPagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<VopSetItem>;
}

declare interface VOpCashReg {
  acDoctype?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  ackey?: Maybe<Scalars['String']>;
  addate?: Maybe<Scalars['DateTime']>;
  anPaid: Scalars['Decimal'];
}

/** A connection to a list of items. */
declare interface VOpCashRegConnection {
  /** A list of edges. */
  edges?: Maybe<Array<VOpCashRegEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<VOpCashReg>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface VOpCashRegEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<VOpCashReg>;
}

declare interface VOpCashRegFilterInput {
  acDoctype?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  ackey?: InputMaybe<StringOperationFilterInput>;
  addate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anPaid?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<VOpCashRegFilterInput>>;
  or?: InputMaybe<Array<VOpCashRegFilterInput>>;
}

declare interface VOpCashRegSortInput {
  acDoctype?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  ackey?: InputMaybe<SortEnumType>;
  addate?: InputMaybe<SortEnumType>;
  anPaid?: InputMaybe<SortEnumType>;
}

declare interface VOpMoveBank {
  ackey?: Maybe<Scalars['String']>;
  payerAddress?: Maybe<Scalars['String']>;
  payerNameAndSurname?: Maybe<Scalars['String']>;
  payerPostNumAndPlace?: Maybe<Scalars['String']>;
  purposeText?: Maybe<Scalars['String']>;
  receiverAddress?: Maybe<Scalars['String']>;
  receiverBank?: Maybe<Scalars['String']>;
  receiverCallOnNum?: Maybe<Scalars['String']>;
  receiverName?: Maybe<Scalars['String']>;
  receiverPostNumAndPlace?: Maybe<Scalars['String']>;
  total: Scalars['Decimal'];
}

declare interface VOpSetBoatName {
  acBoatName?: Maybe<Scalars['String']>;
  acsubject?: Maybe<Scalars['String']>;
  anLenght?: Maybe<Scalars['Float']>;
}

declare interface VOpSetBoatNameFilterInput {
  acBoatName?: InputMaybe<StringOperationFilterInput>;
  acsubject?: InputMaybe<StringOperationFilterInput>;
  anLenght?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  and?: InputMaybe<Array<VOpSetBoatNameFilterInput>>;
  or?: InputMaybe<Array<VOpSetBoatNameFilterInput>>;
}

/** A connection to a list of items. */
declare interface VOpSetBoatNamePagedConnection {
  /** A list of edges. */
  edges?: Maybe<Array<VOpSetBoatNamePagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<VOpSetBoatName>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface VOpSetBoatNamePagedEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<VOpSetBoatName>;
}

declare interface VOpSetBoatNameSortInput {
  acBoatName?: InputMaybe<SortEnumType>;
  acsubject?: InputMaybe<SortEnumType>;
  anLenght?: InputMaybe<SortEnumType>;
}

declare type WakaTimeAuthorKind =
  | 'EMAIL'
  | 'NAME'
  | 'USERNAME';

declare interface WakaTimeAuthorKindOperationFilterInput {
  eq?: InputMaybe<WakaTimeAuthorKind>;
  in?: InputMaybe<Array<WakaTimeAuthorKind>>;
  neq?: InputMaybe<WakaTimeAuthorKind>;
  nin?: InputMaybe<Array<WakaTimeAuthorKind>>;
}

declare interface WakaTimeCommit {
  applicationUser: ApplicationUser;
  applicationUserId: Scalars['String'];
  authorDate?: Maybe<Scalars['DateTime']>;
  authorEmail?: Maybe<Scalars['String']>;
  authorName?: Maybe<Scalars['String']>;
  authorUsername?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
  committerDate?: Maybe<Scalars['DateTime']>;
  committerEmail?: Maybe<Scalars['String']>;
  committerName?: Maybe<Scalars['String']>;
  committerUsername?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contextOnly: Scalars['Boolean'];
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  externalProjectName: Scalars['String'];
  hash: Scalars['String'];
  htmlUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  internalProject?: Maybe<Project>;
  internalProjectId?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  repositoryFullName?: Maybe<Scalars['String']>;
  repositoryProvider?: Maybe<Scalars['String']>;
  totalSeconds: Scalars['Int'];
  wakaTimeWorklog?: Maybe<WakaTimeWorklog>;
  wakaTimeWorklogId?: Maybe<Scalars['Int']>;
}

declare interface WakaTimeCommitFilterInput {
  and?: InputMaybe<Array<WakaTimeCommitFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  authorDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  authorEmail?: InputMaybe<StringOperationFilterInput>;
  authorName?: InputMaybe<StringOperationFilterInput>;
  authorUsername?: InputMaybe<StringOperationFilterInput>;
  branch?: InputMaybe<StringOperationFilterInput>;
  committerDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  committerEmail?: InputMaybe<StringOperationFilterInput>;
  committerName?: InputMaybe<StringOperationFilterInput>;
  committerUsername?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contextOnly?: InputMaybe<BooleanOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  externalProjectName?: InputMaybe<StringOperationFilterInput>;
  hash?: InputMaybe<StringOperationFilterInput>;
  htmlUrl?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  internalProject?: InputMaybe<ProjectFilterInput>;
  internalProjectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<WakaTimeCommitFilterInput>>;
  repositoryFullName?: InputMaybe<StringOperationFilterInput>;
  repositoryProvider?: InputMaybe<StringOperationFilterInput>;
  totalSeconds?: InputMaybe<ComparableInt32OperationFilterInput>;
  wakaTimeWorklog?: InputMaybe<WakaTimeWorklogFilterInput>;
  wakaTimeWorklogId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
}

declare interface WakaTimeWorklog {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  commitCount: Scalars['Int'];
  commits?: Maybe<Array<Maybe<WakaTimeCommit>>>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  dismissed: Scalars['Boolean'];
  duration: Scalars['TimeSpan'];
  externalKey?: Maybe<Scalars['String']>;
  externalProjectName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  internalProject?: Maybe<Project>;
  internalProjectId?: Maybe<Scalars['Int']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  sourceType: WakaTimeWorklogSourceType;
  summary?: Maybe<Scalars['String']>;
  supportTicket?: Maybe<SupportTicket>;
  supportTicketId?: Maybe<Scalars['Int']>;
  supportTicketTimeLog?: Maybe<SupportTicketTimeLog>;
  supportTicketTimeLogId?: Maybe<Scalars['Int']>;
  technicalNote?: Maybe<Scalars['String']>;
}

declare interface WakaTimeWorklogFilterInput {
  and?: InputMaybe<Array<WakaTimeWorklogFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  commitCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  commits?: InputMaybe<ListFilterInputTypeOfWakaTimeCommitFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  dismissed?: InputMaybe<BooleanOperationFilterInput>;
  duration?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  externalKey?: InputMaybe<StringOperationFilterInput>;
  externalProjectName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  internalProject?: InputMaybe<ProjectFilterInput>;
  internalProjectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<WakaTimeWorklogFilterInput>>;
  sourceType?: InputMaybe<WakaTimeWorklogSourceTypeOperationFilterInput>;
  summary?: InputMaybe<StringOperationFilterInput>;
  supportTicket?: InputMaybe<SupportTicketFilterInput>;
  supportTicketId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportTicketTimeLog?: InputMaybe<SupportTicketTimeLogFilterInput>;
  supportTicketTimeLogId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  technicalNote?: InputMaybe<StringOperationFilterInput>;
}

declare type WakaTimeWorklogSourceType =
  | 'ACTIVITY'
  | 'CODEX_TASK'
  | 'COMMIT'
  | 'REMAINDER';

declare interface WakaTimeWorklogSourceTypeOperationFilterInput {
  eq?: InputMaybe<WakaTimeWorklogSourceType>;
  in?: InputMaybe<Array<WakaTimeWorklogSourceType>>;
  neq?: InputMaybe<WakaTimeWorklogSourceType>;
  nin?: InputMaybe<Array<WakaTimeWorklogSourceType>>;
}

declare type WebAppMode =
  | 'PORTAL'
  | 'STANDARD';

declare interface WebAppRoutingDto {
  autoRedirect: Scalars['Boolean'];
  hasClassicAccess: Scalars['Boolean'];
  hasTickets: Scalars['Boolean'];
  hasWebAppAccess: Scalars['Boolean'];
  mode: WebAppMode;
}

declare type WebBalanceState =
  | 'NOT_CONFIGURED'
  | 'OK'
  | 'UNAVAILABLE';

declare interface WebCustomerBalanceDto {
  due?: Maybe<Scalars['Decimal']>;
  open?: Maybe<Scalars['Decimal']>;
  state: WebBalanceState;
}

declare interface WebDailyIncomeDayDto {
  day?: Maybe<Scalars['String']>;
  total: Scalars['Decimal'];
}

declare interface WebDailyIncomeDto {
  days?: Maybe<Array<Maybe<WebDailyIncomeDayDto>>>;
  documentTypeId: Scalars['Int'];
  openByPaymentMethod?: Maybe<Array<Maybe<WebDailyIncomePaymentDto>>>;
  openFromFiscalNumber?: Maybe<Scalars['Int']>;
  openToFiscalNumber?: Maybe<Scalars['Int']>;
  openTotal: Scalars['Decimal'];
}

declare interface WebDailyIncomePaymentDto {
  amount: Scalars['Decimal'];
  paymentMethod?: Maybe<Scalars['String']>;
}

declare interface WebDmsStatusCountDto {
  acName?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  count: Scalars['Int'];
}

declare interface WebDocumentDetailDto {
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType: Scalars['String'];
  acKey: Scalars['String'];
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  canModify: Scalars['Boolean'];
  canVerify: Scalars['Boolean'];
  contact?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  customerAcSubject?: Maybe<Scalars['String']>;
  customerAddress?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerPost?: Maybe<Scalars['String']>;
  customerTaxNumber?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryDeadlineDays?: Maybe<Scalars['Int']>;
  deliveryMethodCode?: Maybe<Scalars['String']>;
  deliveryMethodName?: Maybe<Scalars['String']>;
  departmentAcSubject?: Maybe<Scalars['String']>;
  discount: Scalars['Decimal'];
  documentTypeId: Scalars['Int'];
  dueDate?: Maybe<Scalars['DateTime']>;
  eInvoiceReasonCode?: Maybe<Scalars['String']>;
  eInvoiceState?: Maybe<Scalars['String']>;
  emails: Array<WebDocumentEmailDto>;
  fields: Array<WebDocumentFieldDto>;
  fiscalError?: Maybe<Scalars['String']>;
  fiscalNumber?: Maybe<Scalars['String']>;
  fiscalPending: Scalars['Boolean'];
  fiscalized: Scalars['Boolean'];
  forPay: Scalars['Decimal'];
  jir?: Maybe<Scalars['String']>;
  lines: Array<WebDocumentLineDto>;
  note?: Maybe<Scalars['String']>;
  paymentMethodCode?: Maybe<Scalars['String']>;
  paymentMethodName?: Maybe<Scalars['String']>;
  relations: Array<WebDocumentRelationDto>;
  status?: Maybe<Scalars['String']>;
  thirdPartyAcSubject?: Maybe<Scalars['String']>;
  thirdPartyName?: Maybe<Scalars['String']>;
  value: Scalars['Decimal'];
  vat: Scalars['Decimal'];
  warehouseAcSubject?: Maybe<Scalars['String']>;
  zki?: Maybe<Scalars['String']>;
}

declare interface WebDocumentEmailDto {
  cc?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  error?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  sentAt?: Maybe<Scalars['DateTime']>;
  status: DocumentEmailDispatchStatus;
  subject?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
}

declare interface WebDocumentEmailInput {
  acKey?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Scalars['String']>;
  copyToSender: Scalars['Boolean'];
  documentTypeId: Scalars['Int'];
  message?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
}

declare interface WebDocumentFieldDto {
  arbitraryFieldId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}

declare interface WebDocumentLineDto {
  acIdent: Scalars['String'];
  anNo: Scalars['Int'];
  forPay: Scalars['Decimal'];
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  packageQuantity: Scalars['Decimal'];
  price: Scalars['Decimal'];
  quantity: Scalars['Decimal'];
  rebate: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
  unit?: Maybe<Scalars['String']>;
  unit2?: Maybe<Scalars['String']>;
  value: Scalars['Decimal'];
  vatRate: Scalars['Decimal'];
}

declare interface WebDocumentListFilterInput {
  customerAcSubject?: InputMaybe<Scalars['String']>;
  departmentAcSubject?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  fromAcKey?: InputMaybe<Scalars['String']>;
  onlyMine?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  toAcKey?: InputMaybe<Scalars['String']>;
}

declare interface WebDocumentRelationDto {
  createdAt: Scalars['DateTime'];
  relation: DocumentRelationKind;
  sourceAcKey?: Maybe<Scalars['String']>;
  targetAcKey?: Maybe<Scalars['String']>;
  thisIsSource: Scalars['Boolean'];
}

declare interface WebDocumentStatusDto {
  acKey?: Maybe<Scalars['String']>;
  eInvoiceState?: Maybe<Scalars['String']>;
  fiscalPending: Scalars['Boolean'];
  fiscalized: Scalars['Boolean'];
}

declare interface WebDraftDto {
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactEmailAuto: Scalars['Boolean'];
  contactName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customerAcSubject?: Maybe<Scalars['String']>;
  deliveryDeadlineDays?: Maybe<Scalars['Int']>;
  deliveryMethodCode?: Maybe<Scalars['String']>;
  departmentAcSubject?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentPairId?: Maybe<Scalars['Int']>;
  documentTypeId: Scalars['Int'];
  dueDate?: Maybe<Scalars['DateTime']>;
  dueDateManual: Scalars['Boolean'];
  expectedTotal?: Maybe<Scalars['Decimal']>;
  fieldValues: Array<WebDraftFieldValueDto>;
  hiddenFromOtvoreno: Scalars['Boolean'];
  id: Scalars['UUID'];
  issuedAcKey?: Maybe<Scalars['String']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  items: Array<WebDraftItemDto>;
  kind: DocumentDraftKind;
  lastError?: Maybe<Scalars['String']>;
  lastErrorCode?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  origin: DocumentDraftOrigin;
  paymentMethodCode?: Maybe<Scalars['String']>;
  sourceAcKey?: Maybe<Scalars['String']>;
  sourceRelation: DocumentRelationKind;
  status: DocumentDraftStatus;
  submissionUid: Scalars['UUID'];
  syncPackaging: Scalars['Boolean'];
  thirdPartyAcSubject?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  version: Scalars['Long'];
  warehouseAcSubject?: Maybe<Scalars['String']>;
}

declare interface WebDraftFieldValueDto {
  arbitraryFieldId: Scalars['Int'];
  boolValue?: Maybe<Scalars['Boolean']>;
  dateValue?: Maybe<Scalars['DateTime']>;
  fieldNameSnapshot?: Maybe<Scalars['String']>;
  numberValue?: Maybe<Scalars['Decimal']>;
  textValue?: Maybe<Scalars['String']>;
}

declare interface WebDraftFieldValueInput {
  arbitraryFieldId: Scalars['Int'];
  boolValue?: InputMaybe<Scalars['Boolean']>;
  dateValue?: InputMaybe<Scalars['DateTime']>;
  numberValue?: InputMaybe<Scalars['Decimal']>;
  textValue?: InputMaybe<Scalars['String']>;
}

declare interface WebDraftInput {
  acDoc1?: InputMaybe<Scalars['String']>;
  acDoc2?: InputMaybe<Scalars['String']>;
  adDateDoc1?: InputMaybe<Scalars['DateTime']>;
  adDateDoc2?: InputMaybe<Scalars['DateTime']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactEmailAuto: Scalars['Boolean'];
  contactName?: InputMaybe<Scalars['String']>;
  customerAcSubject?: InputMaybe<Scalars['String']>;
  deliveryDeadlineDays?: InputMaybe<Scalars['Int']>;
  deliveryMethodCode?: InputMaybe<Scalars['String']>;
  departmentAcSubject?: InputMaybe<Scalars['String']>;
  documentDate?: InputMaybe<Scalars['DateTime']>;
  documentTypeId: Scalars['Int'];
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateManual: Scalars['Boolean'];
  fieldValues: Array<WebDraftFieldValueInput>;
  id?: InputMaybe<Scalars['UUID']>;
  items: Array<WebDraftItemInput>;
  note?: InputMaybe<Scalars['String']>;
  paymentMethodCode?: InputMaybe<Scalars['String']>;
  previewTotal?: InputMaybe<Scalars['Decimal']>;
  syncPackaging: Scalars['Boolean'];
  thirdPartyAcSubject?: InputMaybe<Scalars['String']>;
  warehouseAcSubject?: InputMaybe<Scalars['String']>;
}

declare interface WebDraftItemDto {
  acIdent: Scalars['String'];
  id: Scalars['UUID'];
  lineNo: Scalars['Int'];
  nameSnapshot?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  packageQuantity?: Maybe<Scalars['Decimal']>;
  price: Scalars['Decimal'];
  priceIsGross: Scalars['Boolean'];
  priceSource: DocumentDraftPriceSource;
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
  unit?: Maybe<Scalars['String']>;
  unit2?: Maybe<Scalars['String']>;
  unitToUnit2?: Maybe<Scalars['Decimal']>;
}

declare interface WebDraftItemInput {
  acIdent: Scalars['String'];
  nameSnapshot?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  packageQuantity?: InputMaybe<Scalars['Decimal']>;
  price: Scalars['Decimal'];
  priceIsGross: Scalars['Boolean'];
  priceSource: DocumentDraftPriceSource;
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
  unit?: InputMaybe<Scalars['String']>;
  unit2?: InputMaybe<Scalars['String']>;
  unitToUnit2?: InputMaybe<Scalars['Decimal']>;
}

declare interface WebDraftSaveResult {
  conflict: Scalars['Boolean'];
  draft?: Maybe<WebDraftDto>;
}

declare interface WebDraftSummaryDto {
  customerAcSubject?: Maybe<Scalars['String']>;
  expectedTotal?: Maybe<Scalars['Decimal']>;
  id: Scalars['UUID'];
  lastError?: Maybe<Scalars['String']>;
  lastErrorCode?: Maybe<Scalars['String']>;
  lineCount: Scalars['Int'];
  origin: DocumentDraftOrigin;
  sourceAcKey?: Maybe<Scalars['String']>;
  sourceRelation: DocumentRelationKind;
  status: DocumentDraftStatus;
  updatedAt: Scalars['DateTime'];
}

declare interface WebEmailSettingsDto {
  canCopyToSender: Scalars['Boolean'];
  configured: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  senderEmail?: Maybe<Scalars['String']>;
}

declare interface WebFiscalRetryResult {
  error?: Maybe<Scalars['String']>;
  fiscalized: Scalars['Boolean'];
  inProgress: Scalars['Boolean'];
  jir?: Maybe<Scalars['String']>;
}

declare type WebIssueOutcome =
  | 'IN_PROGRESS'
  | 'ISSUED'
  | 'REJECTED'
  | 'TOTAL_MISMATCH';

declare interface WebIssueProblem {
  code?: Maybe<Scalars['String']>;
  fieldId?: Maybe<Scalars['Int']>;
  lineNo?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
}

declare interface WebIssueResult {
  acKey?: Maybe<Scalars['String']>;
  draft?: Maybe<WebDraftDto>;
  outcome: WebIssueOutcome;
  problems?: Maybe<Array<Maybe<WebIssueProblem>>>;
  serverTotal?: Maybe<Scalars['Decimal']>;
}

declare interface WebItemClassificationDto {
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

declare interface WebItemPrice {
  acIdent?: Maybe<Scalars['String']>;
  gross: Scalars['Decimal'];
  net: Scalars['Decimal'];
  rebateDefault: Scalars['Decimal'];
  source: WebItemPriceSource;
}

declare type WebItemPriceSource =
  | 'CONTRACT'
  | 'NONE'
  | 'PRICE_RATE'
  | 'SUBJECT_PRICE_LIST'
  | 'WAREHOUSE_PRICE';

/** A connection to a list of items. */
declare interface WebItemSearchConnection {
  /** A list of edges. */
  edges?: Maybe<Array<WebItemSearchEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface WebItemSearchEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetItem>;
}

declare interface WebItemSearchInput {
  allWarehouses?: InputMaybe<Scalars['Boolean']>;
  classification?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Scalars['String']>;
  minStock?: InputMaybe<Scalars['Decimal']>;
  onlyContractPrices?: InputMaybe<Scalars['Boolean']>;
  onlyInStock?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  warehouse?: InputMaybe<Scalars['String']>;
}

declare interface WebListPreferenceDto {
  customerAcSubject?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateRange?: Maybe<DateFilterType>;
  dateTo?: Maybe<Scalars['DateTime']>;
  departmentAcSubject?: Maybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  keyFrom?: Maybe<Scalars['String']>;
  keyTo?: Maybe<Scalars['String']>;
  lastOpenedAt?: Maybe<Scalars['DateTime']>;
  onlyMine?: Maybe<Scalars['Boolean']>;
}

/** A connection to a list of items. */
declare interface WebMoveListConnection {
  /** A list of edges. */
  edges?: Maybe<Array<WebMoveListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeMove>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface WebMoveListEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeMove>;
}

/** A connection to a list of items. */
declare interface WebOrderListConnection {
  /** A list of edges. */
  edges?: Maybe<Array<WebOrderListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface WebOrderListEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeOrder>;
}

declare interface WebPreferencesDto {
  language?: Maybe<Scalars['String']>;
  lists?: Maybe<Array<Maybe<WebListPreferenceDto>>>;
  sidebarCollapsed: Scalars['Boolean'];
  sidebarMode: WebSidebarMode;
  theme?: Maybe<WebThemePreference>;
}

declare type WebSidebarMode =
  | 'AUTO'
  | 'MANUAL';

/** A connection to a list of items. */
declare interface WebSubjectHistoryConnection {
  /** A list of edges. */
  edges?: Maybe<Array<WebSubjectHistoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeMove>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface WebSubjectHistoryEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeMove>;
}

declare type WebSubjectRole =
  | 'ALL'
  | 'BUYER'
  | 'DEPARTMENT'
  | 'SUPPLIER'
  | 'WAREHOUSE';

/** A connection to a list of items. */
declare interface WebSubjectSearchConnection {
  /** A list of edges. */
  edges?: Maybe<Array<WebSubjectSearchEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetSubj>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface WebSubjectSearchEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetSubj>;
}

declare interface WebSubjectSearchInput {
  onlyMine?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<WebSubjectRole>;
  search?: InputMaybe<Scalars['String']>;
  usedAs?: InputMaybe<WebSubjectUse>;
  usedOnThisType?: InputMaybe<Scalars['Boolean']>;
}

declare type WebSubjectUse =
  | 'DEPARTMENT'
  | 'RECEIVER'
  | 'THIRD_PARTY';

declare type WebThemePreference =
  | 'DARK'
  | 'LIGHT'
  | 'SYSTEM';

declare interface WikiEntry {
  category?: Maybe<WikiEntryCategory>;
  categoryId?: Maybe<Scalars['Int']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contentId: Scalars['Int'];
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  files?: Maybe<Array<Maybe<SavedFile>>>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Array<Maybe<WikiEntryTag>>>;
  title?: Maybe<Scalars['String']>;
}

declare interface WikiEntryCategory {
  children?: Maybe<Array<Maybe<WikiEntryCategory>>>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parent?: Maybe<WikiEntryCategory>;
  parentId?: Maybe<Scalars['Int']>;
  wikiEntries?: Maybe<Array<Maybe<WikiEntry>>>;
}

declare interface WikiEntryCategoryFilterInput {
  and?: InputMaybe<Array<WikiEntryCategoryFilterInput>>;
  children?: InputMaybe<ListFilterInputTypeOfWikiEntryCategoryFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WikiEntryCategoryFilterInput>>;
  order?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  parent?: InputMaybe<WikiEntryCategoryFilterInput>;
  parentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  wikiEntries?: InputMaybe<ListFilterInputTypeOfWikiEntryFilterInput>;
}

declare interface WikiEntryCategorySortInput {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
  parent?: InputMaybe<WikiEntryCategorySortInput>;
  parentId?: InputMaybe<SortEnumType>;
}

declare interface WikiEntryFilterInput {
  and?: InputMaybe<Array<WikiEntryFilterInput>>;
  category?: InputMaybe<WikiEntryCategoryFilterInput>;
  categoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  files?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<WikiEntryFilterInput>>;
  tags?: InputMaybe<ListFilterInputTypeOfWikiEntryTagFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
}

declare interface WikiEntrySortInput {
  category?: InputMaybe<WikiEntryCategorySortInput>;
  categoryId?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  contentId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
}

declare interface WikiEntryTag {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  wikiEntries?: Maybe<Array<Maybe<WikiEntry>>>;
}

declare interface WikiEntryTagFilterInput {
  and?: InputMaybe<Array<WikiEntryTagFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WikiEntryTagFilterInput>>;
  wikiEntries?: InputMaybe<ListFilterInputTypeOfWikiEntryFilterInput>;
}

declare interface WorkOrderStateViewModel {
  workImages?: Maybe<Array<Maybe<TrimWorkOrderImageQuery>>>;
  workMaterial?: Maybe<Array<Maybe<TrimWorkOrderMaterialQuery>>>;
  workMove?: Maybe<TrimWorkOrderQuery>;
  workReceptions?: Maybe<Array<Maybe<TrimWorkOrderReceptionQuery>>>;
  workReclamations?: Maybe<Array<Maybe<TrimWorkOrderReclamationQuery>>>;
  workServices?: Maybe<Array<Maybe<TrimWorkOrderServiceQuery>>>;
  workSpec?: Maybe<Array<Maybe<TrimWorkOrderSpecQuery>>>;
}

declare interface WorkRecord {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  costBearer?: Maybe<Scalars['String']>;
  costBearerName?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  subject?: Maybe<Scalars['String']>;
  workHours?: Maybe<Array<Maybe<WorkRecordWorkHours>>>;
  workRecordCostType?: Maybe<WorkRecordCostType>;
  workRecordCostTypeId?: Maybe<Scalars['Int']>;
  workRecordPeriod?: Maybe<WorkRecordPeriod>;
  workRecordPeriodId?: Maybe<Scalars['Int']>;
}

declare interface WorkRecordCostType {
  active: Scalars['Boolean'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  costType?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  pantheonCostGroup?: Maybe<Scalars['String']>;
  pantheonCostGroupName?: Maybe<Scalars['String']>;
  pantheonCostType?: Maybe<Scalars['String']>;
  pantheonName?: Maybe<Scalars['String']>;
}

declare interface WorkRecordCostTypeFilterInput {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<WorkRecordCostTypeFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  costType?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<WorkRecordCostTypeFilterInput>>;
  pantheonCostGroup?: InputMaybe<StringOperationFilterInput>;
  pantheonCostGroupName?: InputMaybe<StringOperationFilterInput>;
  pantheonCostType?: InputMaybe<StringOperationFilterInput>;
  pantheonName?: InputMaybe<StringOperationFilterInput>;
}

declare interface WorkRecordFilterInput {
  and?: InputMaybe<Array<WorkRecordFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  costBearer?: InputMaybe<StringOperationFilterInput>;
  costBearerName?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<WorkRecordFilterInput>>;
  subject?: InputMaybe<StringOperationFilterInput>;
  workHours?: InputMaybe<ListFilterInputTypeOfWorkRecordWorkHoursFilterInput>;
  workRecordCostType?: InputMaybe<WorkRecordCostTypeFilterInput>;
  workRecordCostTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  workRecordPeriod?: InputMaybe<WorkRecordPeriodFilterInput>;
  workRecordPeriodId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
}

declare interface WorkRecordPeriod {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  finalized: Scalars['Boolean'];
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  month: Scalars['Int'];
  readyToFinalize: Scalars['Boolean'];
  workRecords?: Maybe<Array<Maybe<WorkRecord>>>;
  year: Scalars['Int'];
}

declare interface WorkRecordPeriodFilterInput {
  and?: InputMaybe<Array<WorkRecordPeriodFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  finalized?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  month?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<WorkRecordPeriodFilterInput>>;
  readyToFinalize?: InputMaybe<BooleanOperationFilterInput>;
  workRecords?: InputMaybe<ListFilterInputTypeOfWorkRecordFilterInput>;
  year?: InputMaybe<ComparableInt32OperationFilterInput>;
}

declare interface WorkRecordPeriodSortInput {
  applicationUser?: InputMaybe<ApplicationUserSortInput>;
  applicationUserId?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  finalized?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  month?: InputMaybe<SortEnumType>;
  readyToFinalize?: InputMaybe<SortEnumType>;
  year?: InputMaybe<SortEnumType>;
}

declare interface WorkRecordWorkHours {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  day: Scalars['Byte'];
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['TimeSpan']>;
  workHours: Scalars['Byte'];
  workMinutes: Scalars['Byte'];
  workRecord?: Maybe<WorkRecord>;
  workRecordId?: Maybe<Scalars['Int']>;
}

declare interface WorkRecordWorkHoursFilterInput {
  and?: InputMaybe<Array<WorkRecordWorkHoursFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  day?: InputMaybe<ComparableByteOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WorkRecordWorkHoursFilterInput>>;
  startTime?: InputMaybe<ComparableNullableOfTimeSpanOperationFilterInput>;
  workHours?: InputMaybe<ComparableByteOperationFilterInput>;
  workMinutes?: InputMaybe<ComparableByteOperationFilterInput>;
  workRecord?: InputMaybe<WorkRecordFilterInput>;
  workRecordId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
}

/** A connection to a list of items. */
declare interface WorkflowTasksConnection {
  /** A list of edges. */
  edges?: Maybe<Array<WorkflowTasksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TPaWorkflowTaskInstance>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

/** An edge in a connection. */
declare interface WorkflowTasksEdge {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TPaWorkflowTaskInstance>;
}

declare interface PHe_SearchContrctPriceDto {
  acClassif?: Maybe<Scalars['String']>;
  acClassif2?: Maybe<Scalars['String']>;
  cIdent?: Maybe<Scalars['String']>;
  cKlasif?: Maybe<Scalars['String']>;
  cRetDobavniRok?: Maybe<Scalars['Int']>;
  cRetFormula?: Maybe<Scalars['String']>;
  cRetResult?: Maybe<Scalars['String']>;
  cRetRokPlacila?: Maybe<Scalars['Int']>;
  cRetSubjekt?: Maybe<Scalars['String']>;
  cRetTip?: Maybe<Scalars['String']>;
  cRetValuta?: Maybe<Scalars['String']>;
  cSubjekt?: Maybe<Scalars['String']>;
  cTipCenik?: Maybe<Scalars['String']>;
  cTipPartnerja?: Maybe<Scalars['String']>;
  classif2: Scalars['Boolean'];
  dDatum: Scalars['DateTime'];
  dRetDatumDO?: Maybe<Scalars['DateTime']>;
  dRetDatumOD?: Maybe<Scalars['DateTime']>;
  nRetCena?: Maybe<Scalars['Float']>;
  nRetCenaMP?: Maybe<Scalars['Float']>;
  nRetRabat?: Maybe<Scalars['Decimal']>;
  nRetRabat2?: Maybe<Scalars['Decimal']>;
  nRetRabat3?: Maybe<Scalars['Decimal']>;
  p_nRetDeliveryDeadline?: Maybe<Scalars['Int']>;
}
`);